import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: number;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Anything: any;
  CountryCode: any;
  /**
   * Follows the standard ISO8601 format.
   *         Example: 2001-07-04T12:08:56.235-07:00
   */
  DateTime: any;
  /** The Long scalar type represents a signed 64-bit numeric non-fractional value */
  Long: any;
  /** 1 = January; 12 = December */
  Month: any;
  Period: any;
  Regex: any;
  /** The Short scalar type represents a signed 16-bit numeric non-fractional value */
  Short: any;
  /** Can either be a date following the ISO8601 or just a 4 digit number */
  Year: any;
};

export enum ActiveEnum {
  ACTIVE = 'ACTIVE',
  BOTH = 'BOTH',
  INACTIVE = 'INACTIVE'
}

export type Activity = Model & {
  __typename: 'Activity';
  activityProductAffiliations: ActivityProductConnection;
  createdBy?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  endDateString: Scalars['String'];
  endTimeString: Scalars['String'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  /** All notes this activity has */
  notes: NoteConnection;
  persons: PersonConnection;
  productAffiliations: ActivityProductConnection;
  productBrands: BrandConnection;
  /** All the Product Deliveries this activity is linked to */
  productDeliveries: PersonActivityProductConnection;
  products: ProductConnection;
  project?: Maybe<Project>;
  responsibleUsers: UserConnection;
  selectedSite?: Maybe<ActivityLocation>;
  /** @deprecated use the [sites] field instead */
  siteAffiliations: Array<Site>;
  sites: SiteConnection;
  startDate: Scalars['DateTime'];
  startDateString: Scalars['String'];
  startTimeString: Scalars['String'];
  status: ActivityStatus;
  statusCode: Scalars['String'];
  statusLabel: Scalars['String'];
  type: ActivityType;
  typeCode: Scalars['String'];
  ut: Scalars['DateTime'];
};


export type ActivityactivityProductAffiliationsArgs = {
  criteria?: InputMaybe<ActivityProductCriteria>;
};


export type ActivitynotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


export type ActivitypersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type ActivityproductAffiliationsArgs = {
  criteria?: InputMaybe<ActivityProductCriteria>;
};


export type ActivityproductBrandsArgs = {
  criteria?: InputMaybe<BrandCriteria>;
};


export type ActivityproductDeliveriesArgs = {
  criteria?: InputMaybe<PersonActivityProductCriteria>;
};


export type ActivityproductsArgs = {
  criteria?: InputMaybe<ProductCriteria>;
};


export type ActivityresponsibleUsersArgs = {
  criteria?: InputMaybe<UserCriteria>;
};


export type ActivitysitesArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};

export type ActivityBrand = Model & {
  __typename: 'ActivityBrand';
  activity: Activity;
  activityId: Scalars['Int'];
  brand: Brand;
  brandId: Scalars['Int'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  /** @deprecated has been renamed to 'brand' only */
  productBrand: Brand;
  ut: Scalars['DateTime'];
};

export enum ActivityBrandCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ActivityBulkInput = {
  activityTitle?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  personData: Array<PersonProjectBulk>;
  projectType?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ActivityConnection = EntityTypeConnection & SearchableConnection & {
  __typename: 'ActivityConnection';
  hash: Scalars['String'];
  justForTesting: Scalars['Int'];
  nodes: Array<Activity>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivityCriteria = {
  activityTypeCode?: InputMaybe<Scalars['String']>;
  activityTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dateWithin?: InputMaybe<DateSpanFilter>;
  endDate?: InputMaybe<DateSpanFilter>;
  excludeByProjectId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  hasOneOfPersonRules?: InputMaybe<Array<AttachmentRuleEnum>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<ActiveEnum>;
  listId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<ActivityCriteriaOrder>>;
  personActivityId?: InputMaybe<Scalars['ID']>;
  personId?: InputMaybe<Scalars['ID']>;
  productDeliveryId?: InputMaybe<Scalars['ID']>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Scalars['ID']>;
  reportSettingFieldDayReportCode?: InputMaybe<Scalars['String']>;
  responsibleUserId?: InputMaybe<Scalars['ID']>;
  responsibleUserIds?: InputMaybe<Array<Scalars['ID']>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<DateSpanFilter>;
  status?: InputMaybe<ActivityStatusEnum>;
  statusIn?: InputMaybe<Array<ActivityStatusEnum>>;
  statusNotIn?: InputMaybe<Array<ActivityStatusEnum>>;
  superType?: InputMaybe<ActivitySuperTypeEnum>;
};

export enum ActivityCriteriaOrder {
  END_DATE_ASC = 'END_DATE_ASC',
  END_DATE_DESC = 'END_DATE_DESC',
  HCP_COUNT_ASC = 'HCP_COUNT_ASC',
  HCP_COUNT_DESC = 'HCP_COUNT_DESC',
  HEADING_ASC = 'HEADING_ASC',
  HEADING_DESC = 'HEADING_DESC',
  LOCATION_NAME_ASC = 'LOCATION_NAME_ASC',
  LOCATION_NAME_DESC = 'LOCATION_NAME_DESC',
  RESPONSIBLE_USER_ASC = 'RESPONSIBLE_USER_ASC',
  RESPONSIBLE_USER_DESC = 'RESPONSIBLE_USER_DESC',
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  STATUS_ASC = 'STATUS_ASC',
  STATUS_DESC = 'STATUS_DESC',
  STATUS_SORT_ASC = 'STATUS_SORT_ASC',
  STATUS_SORT_DESC = 'STATUS_SORT_DESC',
  TYPE_ASC = 'TYPE_ASC',
  TYPE_DESC = 'TYPE_DESC'
}

export type ActivityFieldDays = Model & {
  __typename: 'ActivityFieldDays';
  count: Scalars['Int'];
  country: Scalars['CountryCode'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  month: Scalars['Int'];
  ut: Scalars['DateTime'];
  year: Scalars['Int'];
};

export enum ActivityFieldDaysCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ActivityLocation = Model & {
  __typename: 'ActivityLocation';
  activity: Activity;
  activityId: Scalars['ID'];
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ActivityLocationConnection = {
  __typename: 'ActivityLocationConnection';
  hash: Scalars['String'];
  nodes: Array<ActivityLocation>;
  totalCount: Scalars['Int'];
};

export type ActivityLocationCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ActivityLocationCriteriaOrder>>;
  siteId?: InputMaybe<Scalars['ID']>;
};

export enum ActivityLocationCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ActivityPerson = Model & {
  __typename: 'ActivityPerson';
  activity: Activity;
  activityId: Scalars['ID'];
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  person: Person;
  personId: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ActivityPersonConnection = EntityTypeConnection & SearchableConnection & {
  __typename: 'ActivityPersonConnection';
  hash: Scalars['String'];
  justForTesting: Scalars['Int'];
  nodes: Array<ActivityPerson>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivityPersonCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  activityStatusCodes?: InputMaybe<Array<ActivityStatusEnum>>;
  activityTimeSpanFilter?: InputMaybe<DateSpanFilter>;
  activityTypeCodes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  gdprRuleEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  includedInReportCode?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ActivityPersonCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ActivityPersonCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ActivityProduct = Model & {
  __typename: 'ActivityProduct';
  activity: Activity;
  activityId: Scalars['ID'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  product: Product;
  productId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export type ActivityProductConnection = {
  __typename: 'ActivityProductConnection';
  hash: Scalars['String'];
  nodes: Array<ActivityProduct>;
  totalCount: Scalars['Int'];
};

export type ActivityProductCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ActivityProductCriteriaOrder>>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ActivityProductCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ActivityResponsibleUserCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ActivityStatus = {
  __typename: 'ActivityStatus';
  code: Scalars['String'];
  codeEnum: ActivityStatusEnum;
  ct: Scalars['DateTime'];
  descriptionKey?: Maybe<Scalars['String']>;
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ActivityStatusConnection = SearchableConnection & {
  __typename: 'ActivityStatusConnection';
  hash: Scalars['String'];
  nodes: Array<ActivityStatus>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivityStatusCriteria = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  exclude?: InputMaybe<Array<ActivityStatusEnum>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ActivityStatusCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ActivityStatusCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export enum ActivityStatusEnum {
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN'
}

export type ActivitySuperType = {
  __typename: 'ActivitySuperType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  types: ActivityTypeConnection;
  ut: Scalars['DateTime'];
};


export type ActivitySuperTypetypesArgs = {
  criteria?: InputMaybe<ActivityTypeCriteria>;
};

export type ActivitySuperTypeConnection = SearchableConnection & {
  __typename: 'ActivitySuperTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ActivitySuperType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivitySuperTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ActivitySuperTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ActivitySuperTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ActivitySuperTypeEnum {
  CALL = 'CALL',
  COMMUNICATION = 'COMMUNICATION',
  COMPENSATION = 'COMPENSATION',
  EVENTPROJECT = 'EVENTPROJECT',
  HOLIDAY = 'HOLIDAY',
  INTERNAL = 'INTERNAL',
  MATERNITY = 'MATERNITY',
  OTHER = 'OTHER',
  PHONE = 'PHONE',
  PRIVATE = 'PRIVATE',
  QUESTION = 'QUESTION',
  SICK = 'SICK',
  TRAINING = 'TRAINING'
}

export type ActivityType = {
  __typename: 'ActivityType';
  applyGdprInformedRule: Scalars['Boolean'];
  brandRule: AttachmentRuleEnum;
  code: Scalars['String'];
  color: Color;
  colorCode: Scalars['String'];
  ct: Scalars['DateTime'];
  customFields: CustomFieldConnection;
  defaultHeading?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationRule: AttachmentRuleEnum;
  participationUserRule: AttachmentRuleEnum;
  personRule: AttachmentRuleEnum;
  productRule: AttachmentRuleEnum;
  projectRule: AttachmentRuleEnum;
  responsibleUserRule: AttachmentRuleEnum;
  sort?: Maybe<Scalars['Int']>;
  standardTimeLengthMinutes: Scalars['Int'];
  superType: ActivitySuperType;
  superTypeCode: Scalars['String'];
  ut: Scalars['DateTime'];
};


export type ActivityTypecustomFieldsArgs = {
  criteria?: InputMaybe<CustomFieldCriteria>;
};

export type ActivityTypeConnection = SearchableConnection & {
  __typename: 'ActivityTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ActivityType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivityTypeCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  excludeSelectedInReportSettingByReportCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isActive?: InputMaybe<ActiveEnum>;
  ordering?: InputMaybe<Array<ActivityTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  superType?: InputMaybe<ActivitySuperTypeEnum>;
};

export enum ActivityTypeCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type ActivityTypeCustomField = Model & {
  __typename: 'ActivityTypeCustomField';
  activityTypeCode: Scalars['String'];
  ct: Scalars['DateTime'];
  customFieldCode: Scalars['String'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ActivityTypeCustomFieldConnection = SearchableConnection & {
  __typename: 'ActivityTypeCustomFieldConnection';
  hash: Scalars['String'];
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ActivityTypeCustomFieldCriteria = {
  activityTypeCode?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ActivityTypeCustomFieldCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ActivityTypeCustomFieldCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type AddWorkplaceInput = {
  contacts?: InputMaybe<Array<NewContactInput>>;
  customFieldValues?: InputMaybe<Array<SetCustomValuesInput>>;
  instantValidation?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['ID']>;
  positionCode?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['ID']>;
  siteInput?: InputMaybe<SiteInput>;
  workingSpecialtyCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type Address = Model & {
  __typename: 'Address';
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  commune?: Maybe<DataValue>;
  communeCode?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryEnum?: Maybe<Scalars['CountryCode']>;
  county?: Maybe<DataValue>;
  countyCode?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  type: AddressType;
  typeCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type AddressAffiliation = Model & {
  __typename: 'AddressAffiliation';
  address: Address;
  addressId: Scalars['ID'];
  addressTypeCode: Scalars['String'];
  affiliationEntity?: Maybe<Model>;
  ct: Scalars['DateTime'];
  entityAffiliationId: Scalars['ID'];
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type AddressAffiliationaffiliationEntityArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type AddressAffiliationConnection = SearchableConnection & {
  __typename: 'AddressAffiliationConnection';
  hash: Scalars['String'];
  nodes: Array<AddressAffiliation>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type AddressAffiliationCriteria = {
  addressId?: InputMaybe<Scalars['ID']>;
  addressIds?: InputMaybe<Array<Scalars['ID']>>;
  addressType?: InputMaybe<AddressTypeEnum>;
  addressTypeCode?: InputMaybe<Scalars['String']>;
  addressTypes?: InputMaybe<Array<AddressTypeEnum>>;
  affiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  maintainerSourceCode?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<AddressAffiliationCriteriaOrder>>;
  originSourceCode?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum AddressAffiliationCriteriaOrder {
  SORT = 'SORT'
}

export type AddressConnection = SearchableConnection & {
  __typename: 'AddressConnection';
  hash: Scalars['String'];
  nodes: Array<Address>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type AddressCriteria = {
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<AddressCriteriaOrder>>;
  postalCode?: InputMaybe<Scalars['String']>;
  requireCityNotBlank?: InputMaybe<Scalars['Boolean']>;
  requirePostalCodeNotBlank?: InputMaybe<Scalars['Boolean']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  street?: InputMaybe<Scalars['String']>;
};

export enum AddressCriteriaOrder {
  CITY = 'CITY',
  POSTAL_CODE = 'POSTAL_CODE'
}

export type AddressInput = {
  addressLine2?: InputMaybe<Scalars['String']>;
  addressTypeCode: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  communeCode?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countyCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type AddressType = {
  __typename: 'AddressType';
  affiliations: AddressAffiliationConnection;
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  descriptionKey?: Maybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  typeEnum?: Maybe<AddressTypeEnum>;
  ut: Scalars['DateTime'];
};


export type AddressTypeaffiliationsArgs = {
  criteria?: InputMaybe<AddressAffiliationCriteria>;
};

export type AddressTypeConnection = SearchableConnection & {
  __typename: 'AddressTypeConnection';
  hash: Scalars['String'];
  nodes: Array<AddressType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type AddressTypeCriteria = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<AddressTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum AddressTypeCriteriaOrder {
  SORT = 'SORT'
}

export enum AddressTypeEnum {
  HCOMAIL = 'HCOMAIL',
  HCOVISIT = 'HCOVISIT',
  HCPPRIVATE = 'HCPPRIVATE'
}

export type AdvancedSearchableGqlValueConnection = {
  __typename: 'AdvancedSearchableGqlValueConnection';
  countryCodes: Array<Scalars['String']>;
  hash: Scalars['String'];
  nodes: Array<AdvancedSearchableGqlValueWithKey>;
  search?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type AdvancedSearchableGqlValueWithKey = {
  __typename: 'AdvancedSearchableGqlValueWithKey';
  /** This is just a concatenation of the countries, search term and the service being used to search in. This is needed for the frontend to build up a proper cache which can be saved in Apollo Cache and have support for 'fetchMore' cache functionality. */
  cacheKey: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  englishHeading?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  isGlobalOnly: Scalars['Boolean'];
  isHeadingKey: Scalars['Boolean'];
  key: Scalars['String'];
};


export type AdvancedSearchableGqlValueWithKeycountArgs = {
  global?: InputMaybe<Scalars['Boolean']>;
};

export type AffiliationContactValue_EntityDataToBeTransferredType = {
  __typename: 'AffiliationContactValue_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserValue: ContactValue;
  winnerValue?: Maybe<ContactValue>;
};

export type AffiliationCountryCode_EntityDataToBeTransferredType = {
  __typename: 'AffiliationCountryCode_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  fromCode?: Maybe<Scalars['String']>;
  toCode?: Maybe<Scalars['String']>;
};

export type AffiliationCustomField_EntityDataToBeTransferredType = {
  __typename: 'AffiliationCustomField_EntityDataToBeTransferredType';
  affiliationsToMove: Array<CustomFieldToBeTransferredInfo>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  field: CustomField;
  loserExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
  winnerExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
};

export type AffiliationExternalId_EntityDataToBeTransferredType = {
  __typename: 'AffiliationExternalId_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  existingExternalId?: Maybe<ExternalId>;
  externalId: ExternalId;
};

export type AffiliationIsPrimary_EntityDataToBeTransferredType = {
  __typename: 'AffiliationIsPrimary_EntityDataToBeTransferredType';
  allLinksFromWinner: Array<SitePerson>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export type AffiliationNotes_EntityDataToBeTransferredType = {
  __typename: 'AffiliationNotes_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  noteIds: Array<Scalars['ID']>;
};

export type AffiliationPositionCode_EntityDataToBeTransferredType = {
  __typename: 'AffiliationPositionCode_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserLink: SitePerson;
  loserType?: Maybe<ImfDataValue>;
  winnerLink?: Maybe<SitePerson>;
  winnerType?: Maybe<ImfDataValue>;
};

export type AffiliationTherapeuticFocus_EntityDataToBeTransferredType = {
  __typename: 'AffiliationTherapeuticFocus_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  toBeMoved: Array<DataValue>;
};

export type AffiliationWorkingSpecialities_EntityDataToBeTransferredType = {
  __typename: 'AffiliationWorkingSpecialities_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserSpecialities: Array<SitePersonWorkingSpecialty>;
  winnerSpecialities: Array<SitePersonWorkingSpecialty>;
};

export enum AntProgressStatusEnum {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  STOP = 'STOP',
  SUCCESS = 'SUCCESS'
}

export type AntTableColumn = {
  __typename: 'AntTableColumn';
  columnKey: Scalars['String'];
  sort: Scalars['Int'];
};

export type ApiSiteMatch = {
  __typename: 'ApiSiteMatch';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  ct: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  people: Array<ApiSiteMatchPerson>;
  site_type?: Maybe<Scalars['String']>;
  spc: Array<Scalars['String']>;
  status: Scalars['Boolean'];
  ut: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type ApiSiteMatchInputSearch = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<ApiSiteMatchInputSearchPersonPart>;
  type?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type ApiSiteMatchInputSearchPersonPart = {
  eduspc?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  officialId?: InputMaybe<Scalars['String']>;
  persType?: InputMaybe<Scalars['String']>;
  persTypeGb?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  wrkspc?: InputMaybe<Scalars['String']>;
};

export type ApiSiteMatchPerson = {
  __typename: 'ApiSiteMatchPerson';
  eduspc?: Maybe<Array<Scalars['String']>>;
  firstname: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastname: Scalars['String'];
  officialId?: Maybe<Scalars['String']>;
  pers_type?: Maybe<Scalars['String']>;
  pers_type_gb?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  wrkspc?: Maybe<Array<Scalars['String']>>;
};

export enum ArchiveStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum AsyncValidatorTypeEnum {
  array = 'array',
  boolean = 'boolean',
  date = 'date',
  email = 'email',
  enum = 'enum',
  float = 'float',
  hex = 'hex',
  integer = 'integer',
  method = 'method',
  number = 'number',
  regexp = 'regexp',
  string = 'string',
  url = 'url'
}

export enum AttachmentRuleEnum {
  MANY = 'MANY',
  NONE = 'NONE',
  ONE = 'ONE',
  OPTIONAL_MANY = 'OPTIONAL_MANY',
  OPTIONAL_ONE = 'OPTIONAL_ONE'
}

export type AvailableMassAssignFilter = {
  entityTypes?: InputMaybe<Array<EntityTypeEnum>>;
};

export type Brand = Model & {
  __typename: 'Brand';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type BrandConnection = SearchableConnection & {
  __typename: 'BrandConnection';
  hash: Scalars['String'];
  nodes: Array<Brand>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type BrandCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<BrandCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum BrandCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Brick = {
  __typename: 'Brick';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  territory?: Maybe<Territory>;
  territoryCode?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type BrickConnection = SearchableConnection & {
  __typename: 'BrickConnection';
  hash: Scalars['String'];
  nodes: Array<Brick>;
  /**
   * This counts all the sites which are having a brick which is assigned to the same territory.
   * This only works if the [territoryCode] is provided to the BrickCriteria or is a nested graphql query under 'Territory > bricks > siteTotalCount'.
   */
  siteTotalCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};


export type BrickConnectionsiteTotalCountArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};

export type BrickCriteria = {
  code?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dbSource?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<BrickCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  territoryCode?: InputMaybe<Scalars['String']>;
  territoryCodeOrUnassigned?: InputMaybe<Scalars['String']>;
  unassigned?: InputMaybe<Scalars['Boolean']>;
};

export enum BrickCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type BulkProjectInput = {
  bulk: Array<BulkProjectPersInput>;
  projectId: Scalars['Int'];
};

export type BulkProjectPersInput = {
  persId: Scalars['Int'];
  preferenceIds?: InputMaybe<Array<Scalars['Int']>>;
  responseId: Scalars['Int'];
  roleId: Scalars['Int'];
};

export type CardFieldKeys = {
  __typename: 'CardFieldKeys';
  drawerFields: Array<EntityGridItemCardField>;
  entityGridItemConfigurationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  fields: Array<EntityGridItemCardField>;
};

export enum CharsetEnum {
  ISO1253_7 = 'ISO1253_7',
  ISO8859_1 = 'ISO8859_1',
  UTF8 = 'UTF8',
  WINDOWS1253 = 'WINDOWS1253'
}

export type ChartColumnItemValue = {
  __typename: 'ChartColumnItemValue';
  color: Scalars['String'];
  label: Scalars['String'];
  seriesLabel: Scalars['String'];
  value: Scalars['Int'];
};

export type ChartColumnSeriesValue = {
  __typename: 'ChartColumnSeriesValue';
  entity: EntityTypeEnum;
  state: EntityUpdateStateEnum;
  value: Scalars['Int'];
};

export type ChartItemValue = {
  __typename: 'ChartItemValue';
  code?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['Int'];
};

export type ChartResultCriteria = {
  __typename: 'ChartResultCriteria';
  name: Scalars['String'];
  value?: Maybe<Scalars['Anything']>;
  values?: Maybe<Array<Maybe<Scalars['Anything']>>>;
};

export type ChartResults = {
  __typename: 'ChartResults';
  criterias: Array<ChartResultCriteria>;
  values: Array<ChartItemValue>;
};

export type ChartTimestampValue = {
  __typename: 'ChartTimestampValue';
  time: Scalars['DateTime'];
  value: Scalars['Int'];
};

export type Color = {
  __typename: 'Color';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  headingKey: Scalars['String'];
  ut: Scalars['DateTime'];
  value: Scalars['String'];
};

export enum ColorCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC'
}

export type CommuneInput = {
  code: Scalars['String'];
  country: Scalars['CountryCode'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
};

export type ConsentContactValue = Model & {
  __typename: 'ConsentContactValue';
  contactValueId: Scalars['ID'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  status: Scalars['Boolean'];
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export enum ConsentContactValueCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ConsentInstruction = {
  __typename: 'ConsentInstruction';
  apbId: Scalars['Int'];
  country: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  customer?: Maybe<PureAdvanceCustomer>;
  imfCustomer?: Maybe<InternationalCustomer>;
  isOptedOutForAll: Scalars['Boolean'];
  optedOut: Scalars['Boolean'];
  person?: Maybe<Person>;
  ut: Scalars['DateTime'];
};

export type ConsentInstructionConnection = {
  __typename: 'ConsentInstructionConnection';
  hash: Scalars['String'];
  nodes: Array<ConsentInstruction>;
  /** Returns null if user does not have the READ permission to the HCP_OPT_OUT permission */
  optedOutFromAPB?: Maybe<Scalars['Boolean']>;
  totalCount: Scalars['Int'];
};

export type ConsentInstructionCriteria = {
  apurebaseId?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  imCustomerCode?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ConsentInstructionCriteriaOrder>>;
};

export enum ConsentInstructionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ConsentType = {
  __typename: 'ConsentType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  defaultValue: Scalars['Boolean'];
  descriptionKey?: Maybe<Scalars['String']>;
  entityTypeId: Scalars['ID'];
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  /** This will return true when this type should not be manually controlled */
  isManaged: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ConsentTypeConnection = SearchableConnection & {
  __typename: 'ConsentTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ConsentType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ConsentTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ConsentTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ConsentTypeCriteriaOrder {
  SORT = 'SORT'
}

export type ConsentValue = Model & {
  __typename: 'ConsentValue';
  consentTypeCode: Scalars['String'];
  ct: Scalars['DateTime'];
  entityAffiliationId: Scalars['ID'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  type: ConsentType;
  updatedByUserId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export enum ConsentValueAuditCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ConsentValueConnection = SearchableConnection & {
  __typename: 'ConsentValueConnection';
  hash: Scalars['String'];
  nodes: Array<ConsentValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ConsentValueCriteria = {
  consentTypeCode?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityAffiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ConsentValueCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ConsentValueCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ContactCategory = {
  __typename: 'ContactCategory';
  allowMultipleValues: Scalars['Boolean'];
  code: Scalars['String'];
  contactTypeCode: Scalars['String'];
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  heading: Scalars['String'];
  isHeadingKey: Scalars['Boolean'];
  /**
   * Looks up in the ContactCategoryMapping and if there is at least one,
   * it means this category is being synchronized and managed externally.
   */
  isMapped: Scalars['Boolean'];
  mappings: ContactCategoryMappingConnection;
  sort?: Maybe<Scalars['Int']>;
  type: ContactType;
  typeEnum: ContactTypeEnum;
  ut: Scalars['DateTime'];
  values: ContactValueConnection;
};


export type ContactCategorymappingsArgs = {
  criteria?: InputMaybe<ContactCategoryMappingCriteria>;
};


export type ContactCategoryvaluesArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};

export type ContactCategoryConnection = SearchableConnection & {
  __typename: 'ContactCategoryConnection';
  hash: Scalars['String'];
  nodes: Array<ContactCategory>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
  values: ContactValueConnection;
};


export type ContactCategoryConnectionvaluesArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};

export type ContactCategoryCriteria = {
  contactType?: InputMaybe<ContactTypeEnum>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityAffiliationId_NoActionSearch?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  mapping?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ContactCategoryCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ContactCategoryCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY',
  SORT = 'SORT'
}

export type ContactCategoryMapping = Model & {
  __typename: 'ContactCategoryMapping';
  contactCategory: ContactCategory;
  contactCategoryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  mapping: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ContactCategoryMappingConnection = SearchableConnection & {
  __typename: 'ContactCategoryMappingConnection';
  hash: Scalars['String'];
  nodes: Array<ContactCategoryMapping>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ContactCategoryMappingCriteria = {
  contactCategoryCode?: InputMaybe<Scalars['String']>;
  contactCategoryCodes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  mapping?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ContactCategoryMappingCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ContactCategoryMappingCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ContactType = {
  __typename: 'ContactType';
  categories: ContactCategoryConnection;
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  enum: ContactTypeEnum;
  heading: Scalars['String'];
  ut: Scalars['DateTime'];
};


export type ContactTypecategoriesArgs = {
  criteria?: InputMaybe<ContactCategoryCriteria>;
};

export type ContactTypeConnection = SearchableConnection & {
  __typename: 'ContactTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ContactType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ContactTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ContactTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ContactTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ContactTypeEnum {
  EMAIL = 'EMAIL',
  FAX = 'FAX',
  PHONE = 'PHONE',
  WEBSITE = 'WEBSITE'
}

export type ContactValue = Model & {
  __typename: 'ContactValue';
  addedBy?: Maybe<Scalars['ID']>;
  category: ContactCategory;
  consent?: Maybe<ConsentContactValue>;
  contactCategoryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  dbSource: Scalars['String'];
  entityAffiliationId: Scalars['ID'];
  id: Scalars['ID'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  mappingSource?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export type ContactValueConnection = SearchableConnection & {
  __typename: 'ContactValueConnection';
  hash: Scalars['String'];
  nodes: Array<ContactValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum ContactValueConsentedPriorityFirstEnum {
  AFFILIATION = 'AFFILIATION',
  PERSON = 'PERSON'
}

export type ContactValueCriteria = {
  byPersonIdsAcrossSitePersonLinks?: InputMaybe<Array<Scalars['ID']>>;
  categoryCode?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityAffiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isBeingMapped?: InputMaybe<Scalars['Boolean']>;
  isConsented?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  mappingSource?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ContactValueCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  type?: InputMaybe<ContactTypeEnum>;
};

export enum ContactValueCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY',
  CATEGORY_SORTING = 'CATEGORY_SORTING',
  SITE_PERS_PRIMARY = 'SITE_PERS_PRIMARY',
  SORT = 'SORT'
}

export type ContactValueInput = {
  categoryCode: Scalars['String'];
  consentStatus?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
  valueId?: InputMaybe<Scalars['ID']>;
};

export type CreateActivityInput = {
  endDate: Scalars['DateTime'];
  heading?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<Scalars['Int']>>;
  participationUserIds?: InputMaybe<Array<Scalars['Int']>>;
  personIds?: InputMaybe<Array<Scalars['Int']>>;
  productBrandIds?: InputMaybe<Array<Scalars['Int']>>;
  productIds?: InputMaybe<Array<Scalars['Int']>>;
  projectIds?: InputMaybe<Array<Scalars['Int']>>;
  responsibleUserIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate: Scalars['DateTime'];
  status: ActivityStatusEnum;
  typeCode: Scalars['String'];
};

export type CreateContactCategoryInput = {
  allowMultipleValues: Scalars['Boolean'];
  code: Scalars['String'];
  entityType: EntityTypeEnum;
  heading: Scalars['String'];
  isHeadingKey?: InputMaybe<Scalars['Boolean']>;
  type: ContactTypeEnum;
};

export type CreateCustomFieldInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']>;
  allowUserCreate?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  isCheckableTag?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  type: CustomFieldTypeEnum;
};

export type CreateEntityField = Model & {
  __typename: 'CreateEntityField';
  countryCode?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  fieldKey: Scalars['String'];
  id: Scalars['ID'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type CreateEntityFieldConnection = SearchableConnection & {
  __typename: 'CreateEntityFieldConnection';
  hash: Scalars['String'];
  nodes: Array<CreateEntityField>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum CreateEntityFieldCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type CreateExternalIdTypeInput = {
  allowDuplicateValues: Scalars['Boolean'];
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  exceptionCountries?: InputMaybe<Array<Scalars['CountryCode']>>;
  externalIdSystemId?: InputMaybe<Scalars['Int']>;
  heading: Scalars['String'];
  isCountrySpecific: Scalars['Boolean'];
  isDuplicateRuleAcrossCountries: Scalars['Boolean'];
  isHeadingKey: Scalars['Boolean'];
};

export type CreateUserInputdata = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  reEnterPassword?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type Criteria = Model & {
  __typename: 'Criteria';
  code?: Maybe<Scalars['String']>;
  criteriaGroupCode: Scalars['String'];
  criteriaPaths: CriteriaPathConnection;
  ct: Scalars['DateTime'];
  entityId: Scalars['ID'];
  entityType: EntityTypeEnum;
  entityTypeEnum: EntityTypeEnum;
  hasGlobalSupport: Scalars['Boolean'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  inputPaths: CriteriaPathConnection;
  isActive: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type CriteriacriteriaPathsArgs = {
  criteria?: InputMaybe<CriteriaPathCriteria>;
};


export type CriteriainputPathsArgs = {
  criteria?: InputMaybe<CriteriaPathCriteria>;
};

export type CriteriaConnection = SearchableConnection & {
  __typename: 'CriteriaConnection';
  hash: Scalars['String'];
  nodes: Array<Criteria>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CriteriaCriteria = {
  code?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criteriaGroupCode?: InputMaybe<Scalars['String']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CriteriaCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CriteriaCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type CriteriaGroup = {
  __typename: 'CriteriaGroup';
  code: Scalars['String'];
  criterias: CriteriaConnection;
  ct: Scalars['DateTime'];
  entityId: Scalars['ID'];
  entityType: EntityTypeEnum;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  optionService?: Maybe<Scalars['String']>;
  options: CriteriaConnection;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type CriteriaGroupcriteriasArgs = {
  criteria?: InputMaybe<CriteriaCriteria>;
};

export type CriteriaGroupConnection = {
  __typename: 'CriteriaGroupConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaGroup>;
  totalCount: Scalars['Int'];
};

export type CriteriaGroupCriteria = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CriteriaGroupCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CriteriaGroupCriteriaOrder {
  SORT_ASC = 'SORT_ASC'
}

export type CriteriaPath = Model & {
  __typename: 'CriteriaPath';
  criteria: Criteria;
  criteriaId: Scalars['ID'];
  criteriaTypeId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  defaultOperatorType?: Maybe<OperatorType>;
  defaultOperatorTypeId?: Maybe<Scalars['ID']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGlobal: Scalars['Boolean'];
  joinType: Scalars['String'];
  mapper: Scalars['String'];
  mapperFrom: Scalars['String'];
  mapperTo?: Maybe<Scalars['String']>;
  placeholderHeading?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  type?: Maybe<CriteriaType>;
  ut: Scalars['DateTime'];
};

export type CriteriaPathConnection = SearchableConnection & {
  __typename: 'CriteriaPathConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaPath>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CriteriaPathCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criteriaId?: InputMaybe<Scalars['ID']>;
  criteriaIds?: InputMaybe<Array<Scalars['ID']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  onlyInputs?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CriteriaPathCriteriaOrdering>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CriteriaPathCriteriaOrdering {
  SORT = 'SORT'
}

export type CriteriaSimpleSaved = Model & {
  __typename: 'CriteriaSimpleSaved';
  criteriaAffiliations: CriteriaSimpleSavedCriteriaConnection;
  ct: Scalars['DateTime'];
  entityId: Scalars['ID'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  /** Calculate the totalCount for this defined simple search */
  totalCount: Scalars['Int'];
  user: User;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type CriteriaSimpleSavedcriteriaAffiliationsArgs = {
  criteria?: InputMaybe<CriteriaSimpleSavedCriteriaGqlCriteria>;
};

export type CriteriaSimpleSavedConnection = {
  __typename: 'CriteriaSimpleSavedConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaSimpleSaved>;
  totalCount: Scalars['Int'];
};

export type CriteriaSimpleSavedCriteria = Model & {
  __typename: 'CriteriaSimpleSavedCriteria';
  criteria: Criteria;
  criteriaId: Scalars['ID'];
  criteriaSimpleSaved: CriteriaSimpleSaved;
  criteriaSimpleSavedId: Scalars['ID'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  paths: CriteriaSimpleSavedPathConnection;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};


export type CriteriaSimpleSavedCriteriapathsArgs = {
  criteria?: InputMaybe<CriteriaSimpleSavedPathGqlCriteria>;
};

export type CriteriaSimpleSavedCriteriaConnection = {
  __typename: 'CriteriaSimpleSavedCriteriaConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaSimpleSavedCriteria>;
  totalCount: Scalars['Int'];
};

export type CriteriaSimpleSavedCriteriaGqlCriteria = {
  criteriaSimpleSavedId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<CriteriaSimpleSavedCriteriaGqlCriteriaOrder>>;
};

export enum CriteriaSimpleSavedCriteriaGqlCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type CriteriaSimpleSavedGqlCriteria = {
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<CriteriaSimpleSavedGqlCriteriaOrder>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum CriteriaSimpleSavedGqlCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type CriteriaSimpleSavedPath = Model & {
  __typename: 'CriteriaSimpleSavedPath';
  criteriaSimpleSavedCriteriaId: Scalars['ID'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  path: CriteriaPath;
  pathId: Scalars['ID'];
  savedCriteria: CriteriaSimpleSavedCriteria;
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export type CriteriaSimpleSavedPathConnection = {
  __typename: 'CriteriaSimpleSavedPathConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaSimpleSavedPath>;
  totalCount: Scalars['Int'];
};

export type CriteriaSimpleSavedPathGqlCriteria = {
  criteriaSimpleSavedCriteriaId?: InputMaybe<Scalars['ID']>;
  criteriaSimpleSavedCriteriaIds?: InputMaybe<Array<Scalars['ID']>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<CriteriaSimpleSavedPathGqlCriteriaOrder>>;
};

export enum CriteriaSimpleSavedPathGqlCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum CriteriaStatusEnum {
  ACTIVE = 'ACTIVE',
  ALL = 'ALL',
  DISABLED = 'DISABLED'
}

export type CriteriaType = Model & {
  __typename: 'CriteriaType';
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  supportedOperators: OperatorTypeConnection;
  type: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type CriteriaTypeConnection = SearchableConnection & {
  __typename: 'CriteriaTypeConnection';
  hash: Scalars['String'];
  nodes: Array<CriteriaType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CriteriaTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<CriteriaTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CriteriaTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum CriteriaTypeEnum {
  Date = 'Date',
  MultiGroupSelect = 'MultiGroupSelect',
  MultiSelect = 'MultiSelect',
  PrimaryMagic = 'PrimaryMagic',
  Select = 'Select',
  Switch = 'Switch',
  Text = 'Text',
  UserSwitch = 'UserSwitch'
}

export type CriteriaTypeOperator = {
  __typename: 'CriteriaTypeOperator';
  ct: Scalars['DateTime'];
  id: CriteriaTypeOperatorId;
  ut: Scalars['DateTime'];
};

export type CriteriaTypeOperatorId = {
  __typename: 'CriteriaTypeOperatorId';
  criteriaTypeId: Scalars['Int'];
  operatorTypeId: Scalars['Int'];
};

export type CurrentSandboxDeploymentStatus = {
  __typename: 'CurrentSandboxDeploymentStatus';
  activityJob: DeploymentStatus;
  app: DeploymentStatus;
  clone: DeploymentStatus;
  code: Scalars['String'];
  currentPercentage: Scalars['Int'];
  db: DeploymentStatus;
  schedule: SandboxScheduleStatus;
  totalSteps: Scalars['Int'];
};

export type CustomField = {
  __typename: 'CustomField';
  accessRules: CustomFieldRoleConnection;
  allowCountrySpecificValues?: Maybe<Scalars['Boolean']>;
  allowMultiple?: Maybe<Scalars['Boolean']>;
  allowUserCreate?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  customFieldControlSetting?: Maybe<CustomFieldControlSetting>;
  customFieldTypeCode: Scalars['String'];
  customLinkValues?: Maybe<CustomLinkValueConnection>;
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityTypeEnum: EntityTypeEnum;
  fieldGridConfigurations: CustomFieldGridConfigurationConnection;
  fieldType: CustomFieldType;
  fieldTypeEnum: CustomFieldTypeEnum;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  isCheckableTag?: Maybe<Scalars['Boolean']>;
  myAccessRules?: Maybe<CustomFieldRole>;
  options?: Maybe<CustomFieldOptionConnection>;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};


export type CustomFieldaccessRulesArgs = {
  criteria?: InputMaybe<CustomFieldRoleCriteria>;
};


export type CustomFieldcustomLinkValuesArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
  recordId?: InputMaybe<Scalars['Int']>;
};


export type CustomFieldoptionsArgs = {
  criteria?: InputMaybe<CustomFieldOptionCriteria>;
};

export type CustomFieldConnection = SearchableConnection & {
  __typename: 'CustomFieldConnection';
  hash: Scalars['String'];
  nodes: Array<CustomField>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomFieldControlSetting = Model & {
  __typename: 'CustomFieldControlSetting';
  createDcr: Scalars['Boolean'];
  ct: Scalars['DateTime'];
  customFieldCode: Scalars['String'];
  id: Scalars['ID'];
  isSynced?: Maybe<Scalars['Boolean']>;
  maintainerSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type CustomFieldControlSettingConnection = {
  __typename: 'CustomFieldControlSettingConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldControlSetting>;
  totalCount: Scalars['Int'];
};

export type CustomFieldControlSettingCriteria = {
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<CustomFieldControlSettingCriteriaOrder>>;
};

export enum CustomFieldControlSettingCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type CustomFieldCriteria = {
  activityTypeCode?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldTypeEnums?: InputMaybe<Array<CustomFieldTypeEnum>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  excludeAlreadyAddedOnEntityTabCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CustomFieldCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  searchLabel?: InputMaybe<Scalars['String']>;
};

export enum CustomFieldCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type CustomFieldGridConfiguration = Model & {
  __typename: 'CustomFieldGridConfiguration';
  addedByUser?: Maybe<User>;
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  customField: CustomField;
  customFieldCode: Scalars['String'];
  entityGridItemFieldId: Scalars['ID'];
  fieldConfig: EntityGridItemField;
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type CustomFieldGridConfigurationConnection = SearchableConnection & {
  __typename: 'CustomFieldGridConfigurationConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldGridConfiguration>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum CustomFieldGridConfigurationCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type CustomFieldOption = Model & {
  __typename: 'CustomFieldOption';
  code?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  customFieldCode: Scalars['String'];
  customValueId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  relations: CustomLinkValueConnection;
  selectedCountries: CustomFieldOptionCountryConnection;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
  value?: Maybe<CustomValue>;
};


export type CustomFieldOptionrelationsArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
};


export type CustomFieldOptionselectedCountriesArgs = {
  criteria?: InputMaybe<CustomFieldOptionCountryCriteria>;
};

export type CustomFieldOptionConnection = SearchableConnection & {
  __typename: 'CustomFieldOptionConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldOption>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomFieldOptionCountry = Model & {
  __typename: 'CustomFieldOptionCountry';
  country: Scalars['CountryCode'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  customFieldOptionId: Scalars['ID'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type CustomFieldOptionCountryConnection = SearchableConnection & {
  __typename: 'CustomFieldOptionCountryConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldOptionCountry>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomFieldOptionCountryCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldOptionId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<CustomFieldOptionCountryCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CustomFieldOptionCountryCriteriaOrder {
  COUNTRY_CODE_ASC = 'COUNTRY_CODE_ASC',
  COUNTRY_CODE_DESC = 'COUNTRY_CODE_DESC'
}

export type CustomFieldOptionCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  headingLike?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isCountrySpecific?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CustomFieldOptionCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CustomFieldOptionCriteriaOrder {
  SORTING = 'SORTING'
}

export type CustomFieldPermissionOption = {
  __typename: 'CustomFieldPermissionOption';
  allowMutation: Scalars['Boolean'];
  allowRead: Scalars['Boolean'];
  customFieldCode: Scalars['String'];
};

export type CustomFieldRole = Model & {
  __typename: 'CustomFieldRole';
  allowMutation: Scalars['Boolean'];
  allowRead: Scalars['Boolean'];
  ct: Scalars['DateTime'];
  customFieldCode: Scalars['String'];
  id: Scalars['ID'];
  role: Role;
  roleId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type CustomFieldRoleConnection = SearchableConnection & {
  __typename: 'CustomFieldRoleConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldRole>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomFieldRoleCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<CustomFieldRoleCriteriaOrder>>;
  roleId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum CustomFieldRoleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type CustomFieldSearchInput = {
  customFieldCode: Scalars['String'];
  valueId?: InputMaybe<Scalars['Int']>;
};

export type CustomFieldToBeTransferredInfo = {
  __typename: 'CustomFieldToBeTransferredInfo';
  affiliation: CustomLinkValue;
  value: CustomValue;
};

export type CustomFieldType = {
  __typename: 'CustomFieldType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  enum: CustomFieldTypeEnum;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type CustomFieldTypeConnection = {
  __typename: 'CustomFieldTypeConnection';
  hash: Scalars['String'];
  nodes: Array<CustomFieldType>;
  totalCount: Scalars['Int'];
};

export type CustomFieldTypeCriteria = {
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<CustomFieldTypeCriteriaOrder>>;
};

export enum CustomFieldTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum CustomFieldTypeEnum {
  CHECK = 'CHECK',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT',
  SWITCH = 'SWITCH',
  TAG = 'TAG',
  TEXT = 'TEXT'
}

export type CustomLinkValue = Model & {
  __typename: 'CustomLinkValue';
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  customField: CustomField;
  customFieldCode: Scalars['String'];
  customValueId: Scalars['ID'];
  entityAffiliationId: Scalars['ID'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  sort: Scalars['Int'];
  type: CustomFieldType;
  ut: Scalars['DateTime'];
  value?: Maybe<CustomValue>;
};

export type CustomLinkValueConnection = SearchableConnection & {
  __typename: 'CustomLinkValueConnection';
  hash: Scalars['String'];
  nodes: Array<CustomLinkValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomLinkValueCriteria = {
  affiliationId?: InputMaybe<Scalars['ID']>;
  affiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  optionId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<CustomLinkValueCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valueId?: InputMaybe<Scalars['ID']>;
  valueIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum CustomLinkValueCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type CustomMapping = {
  __typename: 'CustomMapping';
  columnName: Scalars['String'];
  dataType: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  isHeadingKey: Scalars['Boolean'];
  service: Scalars['String'];
  supportedCriteriaTypes: Array<CriteriaTypeEnum>;
};

export type CustomValue = Model & {
  __typename: 'CustomValue';
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  links: CustomLinkValueConnection;
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};


export type CustomValuelinksArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
};

export type CustomValueConnection = SearchableConnection & {
  __typename: 'CustomValueConnection';
  hash: Scalars['String'];
  nodes: Array<CustomValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type CustomValueCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  customFieldCodes?: InputMaybe<Array<Scalars['String']>>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  optionsFromCustomFieldCode?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<CustomValueCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  value?: InputMaybe<Scalars['String']>;
};

export enum CustomValueCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY',
  OPTION_SORTING = 'OPTION_SORTING'
}

export type Dashboard = Model & {
  __typename: 'Dashboard';
  ct: Scalars['DateTime'];
  dashboardItemConfigurations: DashboardItemConfigurationConnection;
  descriptionKey?: Maybe<Scalars['String']>;
  headingKey: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDefaultDashboard: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};


export type DashboarddashboardItemConfigurationsArgs = {
  criteria?: InputMaybe<DashboardItemConfigurationCriteria>;
};

export type DashboardConnection = {
  __typename: 'DashboardConnection';
  hash: Scalars['String'];
  nodes: Array<Dashboard>;
  totalCount: Scalars['Int'];
};

export type DashboardCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<DashboardCriteriaOrder>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum DashboardCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DashboardEntityPieSetting = Model & {
  __typename: 'DashboardEntityPieSetting';
  createdByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  customFieldCode?: Maybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  fieldCode?: Maybe<Scalars['String']>;
  fieldHeading: Scalars['String'];
  fieldHeadingKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkConfigurationId: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export type DashboardEntityPieUpdateInput = {
  dashboardItemConfigurationId: Scalars['Int'];
  entityType: EntityTypeEnum;
  fields: Array<Scalars['String']>;
};

export type DashboardItem = {
  __typename: 'DashboardItem';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  descriptionKey?: Maybe<Scalars['String']>;
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  minHeight?: Maybe<Scalars['Int']>;
  minWidth?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type DashboardItemConfiguration = Model & {
  __typename: 'DashboardItemConfiguration';
  ct: Scalars['DateTime'];
  dashboard?: Maybe<Dashboard>;
  dashboardId: Scalars['ID'];
  dashboardItem: DashboardItem;
  dashboardItemCode: Scalars['String'];
  descriptionKey?: Maybe<Scalars['String']>;
  headingKey?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  ut: Scalars['DateTime'];
  width?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type DashboardItemConfigurationConnection = {
  __typename: 'DashboardItemConfigurationConnection';
  hash: Scalars['String'];
  nodes: Array<DashboardItemConfiguration>;
  totalCount: Scalars['Int'];
};

export type DashboardItemConfigurationCriteria = {
  dashboardId?: InputMaybe<Scalars['ID']>;
  dashboardItemCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<DashboardItemConfigurationCriteriaOrder>>;
};

export enum DashboardItemConfigurationCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DashboardItemConfigurationInput = {
  dashboardId: Scalars['Int'];
  dashboardItemId?: InputMaybe<Scalars['Int']>;
  gridItems: Array<DashboardItemGrid>;
  heading?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type DashboardItemConnection = {
  __typename: 'DashboardItemConnection';
  hash: Scalars['String'];
  nodes: Array<DashboardItem>;
  totalCount: Scalars['Int'];
};

export type DashboardItemCriteria = {
  code?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DashboardItemCriteriaOrder>>;
};

export enum DashboardItemCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DashboardItemGrid = {
  h?: InputMaybe<Scalars['Int']>;
  i: Scalars['String'];
  minH?: InputMaybe<Scalars['Int']>;
  minW?: InputMaybe<Scalars['Int']>;
  moved?: InputMaybe<Scalars['Boolean']>;
  static?: InputMaybe<Scalars['Boolean']>;
  w?: InputMaybe<Scalars['Int']>;
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
};

export type DashboardPieFieldOption = {
  __typename: 'DashboardPieFieldOption';
  code: Scalars['String'];
  entityType?: Maybe<EntityTypeEnum>;
  heading: Scalars['String'];
  headingKey?: Maybe<Scalars['String']>;
};

export type DashboardPieSelectionInput = {
  deselectedCodes: Array<Scalars['String']>;
  selectedValue?: InputMaybe<Scalars['String']>;
};

export type DashboardUser = Model & {
  __typename: 'DashboardUser';
  ct: Scalars['DateTime'];
  dashboard?: Maybe<Dashboard>;
  dashboardId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  sort: Scalars['Int'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type DashboardUserConnection = {
  __typename: 'DashboardUserConnection';
  hash: Scalars['String'];
  nodes: Array<DashboardUser>;
  totalCount: Scalars['Int'];
};

export type DashboardUserCriteria = {
  dashboardId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DashboardUserCriteriaOrder>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum DashboardUserCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DataValue = IDataValue & {
  __typename: 'DataValue';
  active: Scalars['Int'];
  code: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  isGlobalOnly: Scalars['Boolean'];
  label: Scalars['String'];
  labelGb?: Maybe<Scalars['String']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  type: DataValueMappingName;
  ut: Scalars['DateTime'];
  valCode: Scalars['String'];
};

export type DataValueConnection = SearchableConnection & {
  __typename: 'DataValueConnection';
  hash: Scalars['String'];
  nodes: Array<IDataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum DataValueMappingName {
  CHAIN = 'CHAIN',
  COMMUNE = 'COMMUNE',
  COUNTY = 'COUNTY',
  EDUSPECIALTY = 'EDUSPECIALTY',
  PERSTYPE = 'PERSTYPE',
  POSITION = 'POSITION',
  SITESPECIALTY = 'SITESPECIALTY',
  SITETYPE = 'SITETYPE',
  THERAPEUTIC_FOCUS = 'THERAPEUTIC_FOCUS',
  WORK_SPECIALTY = 'WORK_SPECIALTY'
}

export type DateSpanFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type DbSource = {
  __typename: 'DbSource';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type DbSourceConnection = SearchableConnection & {
  __typename: 'DbSourceConnection';
  hash: Scalars['String'];
  nodes: Array<DbSource>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DbSourceCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<DbSourceCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DbSourceCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Dcr = Model & {
  __typename: 'Dcr';
  affiliationEntity?: Maybe<Model>;
  ct: Scalars['DateTime'];
  dcrGroupId: Scalars['ID'];
  dcrSnapshotInfo: Array<DcrSnapshotInfo>;
  entityAffiliationId?: Maybe<Scalars['ID']>;
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId: Scalars['ID'];
  group: DcrGroup;
  id: Scalars['ID'];
  isDcrHandled: Scalars['Boolean'];
  lines: DcrLineConnection;
  requestType: DcrRequestType;
  requestTypeCode: Scalars['String'];
  requestTypeEnum: DcrRequestTypeEnum;
  responsibleUser: User;
  responsibleUserId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type DcraffiliationEntityArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};


export type DcrlinesArgs = {
  criteria?: InputMaybe<DcrLineCriteria>;
};

export type DcrComment = Model & {
  __typename: 'DcrComment';
  byUserId?: Maybe<Scalars['ID']>;
  comment?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  dcrGroupId: Scalars['ID'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export enum DcrCommentCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DcrConnection = SearchableConnection & {
  __typename: 'DcrConnection';
  hash: Scalars['String'];
  nodes: Array<Dcr>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DcrCreateResponse = {
  __typename: 'DcrCreateResponse';
  applyDirectly: Scalars['Boolean'];
  dcr: Dcr;
  group: DcrGroup;
};

export type DcrCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dcrTypes?: InputMaybe<Array<DcrRequestTypeEnum>>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityAffiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  excludeDcrTypes?: InputMaybe<Array<DcrRequestTypeEnum>>;
  fetchSize?: InputMaybe<FetchSize>;
  groupId?: InputMaybe<Scalars['ID']>;
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  ordering?: InputMaybe<Array<DcrCriteriaOrder>>;
  responseTypes?: InputMaybe<Array<DcrResponseTypeEnum>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DcrCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DcrGroup = Model & {
  __typename: 'DcrGroup';
  GroupComment?: Maybe<DcrComment>;
  areYouDcrOwner: Scalars['Boolean'];
  countryCode: Scalars['String'];
  countryEnum: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  currentResponseCode?: Maybe<Scalars['String']>;
  dcrs: DcrConnection;
  heading?: Maybe<DcrGroupHeading>;
  id: Scalars['ID'];
  isDcrGroupKeptAsLocalRecord: Scalars['Boolean'];
  responseStatus: DcrGroupResponse;
  responses: DcrGroupResponseConnection;
  responsibleUser: User;
  responsibleUserId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type DcrGroupdcrsArgs = {
  criteria?: InputMaybe<DcrCriteria>;
};


export type DcrGroupresponsesArgs = {
  criteria?: InputMaybe<DcrGroupResponseCriteria>;
};

export type DcrGroupConnection = SearchableConnection & {
  __typename: 'DcrGroupConnection';
  hash: Scalars['String'];
  nodes: Array<DcrGroup>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DcrGroupContainsRecordDcr = {
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
};

export type DcrGroupCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  hasRecord?: InputMaybe<DcrGroupContainsRecordDcr>;
  isActive?: InputMaybe<ActiveEnum>;
  ordering?: InputMaybe<Array<DcrGroupCriteriaOrder>>;
  responseType?: InputMaybe<DcrResponseTypeEnum>;
  searchInput?: InputMaybe<SaveSearchInput>;
  ut?: InputMaybe<DateSpanFilter>;
};

export enum DcrGroupCriteriaOrder {
  CT_ASC = 'CT_ASC',
  CT_DESC = 'CT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  RESPONSE_STATUS_SORT_ASC = 'RESPONSE_STATUS_SORT_ASC',
  RESPONSE_STATUS_SORT_DESC = 'RESPONSE_STATUS_SORT_DESC',
  RESPONSIBLE_USER_ASC = 'RESPONSIBLE_USER_ASC',
  RESPONSIBLE_USER_DESC = 'RESPONSIBLE_USER_DESC'
}

export type DcrGroupHeading = DcrGroupHeadingCreatePerson | DcrGroupHeadingCreateSite | DcrGroupHeadingDeletePerson | DcrGroupHeadingDeleteSite | DcrGroupHeadingDeleteWorkplace | DcrGroupHeadingNewPersonWithWorkplace | DcrGroupHeadingNewWorkplace | DcrGroupHeadingUnknownDcrType | DcrGroupHeadingUpdatePerson | DcrGroupHeadingUpdateSite | DcrGroupHeadingUpdateWorkplace;

export type DcrGroupHeadingCreatePerson = {
  __typename: 'DcrGroupHeadingCreatePerson';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingCreateSite = {
  __typename: 'DcrGroupHeadingCreateSite';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  site: Site;
  siteId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingDeletePerson = {
  __typename: 'DcrGroupHeadingDeletePerson';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingDeleteSite = {
  __typename: 'DcrGroupHeadingDeleteSite';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  site: Site;
  siteId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingDeleteWorkplace = {
  __typename: 'DcrGroupHeadingDeleteWorkplace';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['ID']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
  sitePersId: Scalars['ID'];
  sitePerson?: Maybe<SitePerson>;
  sort: Scalars['Int'];
};

export type DcrGroupHeadingNewPersonWithWorkplace = {
  __typename: 'DcrGroupHeadingNewPersonWithWorkplace';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
  sitePersId?: Maybe<Scalars['ID']>;
  sitePerson?: Maybe<SitePerson>;
  sort: Scalars['Int'];
};

export type DcrGroupHeadingNewWorkplace = {
  __typename: 'DcrGroupHeadingNewWorkplace';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
  sitePersId?: Maybe<Scalars['ID']>;
  sitePerson?: Maybe<SitePerson>;
  sort: Scalars['Int'];
};

export type DcrGroupHeadingUnknownDcrType = {
  __typename: 'DcrGroupHeadingUnknownDcrType';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingUpdatePerson = {
  __typename: 'DcrGroupHeadingUpdatePerson';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingUpdateSite = {
  __typename: 'DcrGroupHeadingUpdateSite';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  site: Site;
  siteId: Scalars['ID'];
  sort: Scalars['Int'];
};

export type DcrGroupHeadingUpdateWorkplace = {
  __typename: 'DcrGroupHeadingUpdateWorkplace';
  code: Scalars['String'];
  dcrGroupId: Scalars['ID'];
  headingKey: Scalars['String'];
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['ID']>;
  site?: Maybe<Site>;
  siteId?: Maybe<Scalars['ID']>;
  sitePersId: Scalars['ID'];
  sitePerson?: Maybe<SitePerson>;
  sort: Scalars['Int'];
};

export type DcrGroupResponse = Model & {
  __typename: 'DcrGroupResponse';
  byUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  dcrGroupId: Scalars['ID'];
  dcrNoteTemplate?: Maybe<DcrNoteTemplate>;
  id: Scalars['ID'];
  noteTemplateId?: Maybe<Scalars['Int']>;
  responseComment?: Maybe<Scalars['String']>;
  responseTypeCode: Scalars['String'];
  responseTypeEnum: DcrResponseTypeEnum;
  user?: Maybe<User>;
  ut: Scalars['DateTime'];
};

export type DcrGroupResponseConnection = SearchableConnection & {
  __typename: 'DcrGroupResponseConnection';
  hash: Scalars['String'];
  nodes: Array<DcrGroupResponse>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DcrGroupResponseCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  groupId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<DcrGroupResponseCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DcrGroupResponseCriteriaOrder {
  CT = 'CT',
  PrioritySort = 'PrioritySort'
}

export type DcrLine = Model & {
  __typename: 'DcrLine';
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  dcr: Dcr;
  dcrId: Scalars['ID'];
  dcrNewValue?: Maybe<Scalars['String']>;
  dcrOldValue?: Maybe<Scalars['String']>;
  fieldCode: Scalars['String'];
  fieldEnum?: Maybe<FieldEnum>;
  fieldLabel?: Maybe<Scalars['String']>;
  fieldLabelKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  newValue?: Maybe<Scalars['String']>;
  newValueMapped?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  oldValueMapped?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type DcrLineConnection = SearchableConnection & {
  __typename: 'DcrLineConnection';
  hasActiveLines: Scalars['Boolean'];
  hash: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  nodes: Array<DcrLine>;
  oldValue?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DcrLineCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dcrId?: InputMaybe<Scalars['ID']>;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  excludeResponseTypes?: InputMaybe<Array<DcrResponseTypeEnum>>;
  fetchSize?: InputMaybe<FetchSize>;
  field?: InputMaybe<FieldEnum>;
  fields?: InputMaybe<Array<DcrLineCriteriaField>>;
  ordering?: InputMaybe<Array<DcrLineCriteriaOrder>>;
  responseTypes?: InputMaybe<Array<DcrResponseTypeEnum>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export type DcrLineCriteriaField = {
  field?: InputMaybe<FieldEnum>;
  stringField?: InputMaybe<Scalars['String']>;
};

export enum DcrLineCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DcrNoteTemplate = Model & {
  __typename: 'DcrNoteTemplate';
  addedBy?: Maybe<Scalars['Int']>;
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  key: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  status: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export enum DcrNoteTemplateCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DcrRequestType = {
  __typename: 'DcrRequestType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type DcrRequestTypeConnection = {
  __typename: 'DcrRequestTypeConnection';
  hash: Scalars['String'];
  nodes: Array<DcrRequestType>;
  totalCount: Scalars['Int'];
};

export enum DcrRequestTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum DcrRequestTypeEnum {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  INFO = 'INFO',
  UPDATE = 'UPDATE'
}

export type DcrResponseType = {
  __typename: 'DcrResponseType';
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type DcrResponseTypeConnection = SearchableConnection & {
  __typename: 'DcrResponseTypeConnection';
  hash: Scalars['String'];
  nodes: Array<DcrResponseType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum DcrResponseTypeCriteriaOrder {
  STANDARD_SORT = 'STANDARD_SORT'
}

export enum DcrResponseTypeEnum {
  ACCEPT = 'ACCEPT',
  PENDING_REJECT = 'PENDING_REJECT',
  QUEUE = 'QUEUE',
  REJECT = 'REJECT',
  UNHANDLED = 'UNHANDLED'
}

export type DcrSnapshotInfo = Model & {
  __typename: 'DcrSnapshotInfo';
  affiliationEntity?: Maybe<Model>;
  ct: Scalars['DateTime'];
  dcrId: Scalars['ID'];
  entityAffiliationId: Scalars['ID'];
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type DcrSnapshotInfoaffiliationEntityArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type DcrSnapshotInfoConnection = SearchableConnection & {
  __typename: 'DcrSnapshotInfoConnection';
  hash: Scalars['String'];
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DcrSnapshotInfoCriteria = {
  affiliation?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dcrId?: InputMaybe<Scalars['ID']>;
  entityId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DcrSnapshotInfoCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DcrSnapshotInfoCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DefaultCriteria = Model & {
  __typename: 'DefaultCriteria';
  criteria: Criteria;
  criteriaId: Scalars['ID'];
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type DefaultCriteriaConnection = SearchableConnection & {
  __typename: 'DefaultCriteriaConnection';
  hash: Scalars['String'];
  nodes: Array<DefaultCriteria>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DefaultCriteriaCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DefaultCriteriaCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DefaultCriteriaCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type DefaultDashboard = Model & {
  __typename: 'DefaultDashboard';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  dashboard?: Maybe<Dashboard>;
  dashboardId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  roleId?: Maybe<Scalars['ID']>;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type DefaultDashboardConnection = {
  __typename: 'DefaultDashboardConnection';
  hash: Scalars['String'];
  nodes: Array<DefaultDashboard>;
  totalCount: Scalars['Int'];
};

export type DefaultDashboardCriteria = {
  dashboardId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DefaultDashboardCriteriaOrder>>;
};

export enum DefaultDashboardCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DefaultTableColumn = Model & {
  __typename: 'DefaultTableColumn';
  columnKey: Scalars['String'];
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  roleId?: Maybe<Scalars['ID']>;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type DefaultTableColumnConnection = SearchableConnection & {
  __typename: 'DefaultTableColumnConnection';
  hash: Scalars['String'];
  nodes: Array<DefaultTableColumn>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type DefaultTableColumnCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DefaultTableColumnCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum DefaultTableColumnCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export enum DeleteReasonDcrEnum {
  DESCEASED = 'DESCEASED',
  HCOISCLOSEDDOWN = 'HCOISCLOSEDDOWN',
  HCOISONPOPULATED = 'HCOISONPOPULATED',
  NOWORKHERE = 'NOWORKHERE',
  OPTOUT = 'OPTOUT',
  OTHER = 'OTHER',
  RETIRED = 'RETIRED',
  TEMPNOWORKHERE = 'TEMPNOWORKHERE',
  WORKINGABROUD = 'WORKINGABROUD'
}

export enum DelimiterEnum {
  COMMA = 'COMMA',
  SEMI_COLUMN = 'SEMI_COLUMN'
}

export type DeploymentStatus = {
  __typename: 'DeploymentStatus';
  currentStatus: AntProgressStatusEnum;
  message?: Maybe<Scalars['String']>;
};

export type DisabledDefaultDashboard = Model & {
  __typename: 'DisabledDefaultDashboard';
  ct: Scalars['DateTime'];
  dashboard?: Maybe<Dashboard>;
  defaultDashboardId: Scalars['Int'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  userId: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type DisabledDefaultDashboardConnection = {
  __typename: 'DisabledDefaultDashboardConnection';
  hash: Scalars['String'];
  nodes: Array<DisabledDefaultDashboard>;
  totalCount: Scalars['Int'];
};

export type DisabledDefaultDashboardCriteria = {
  dashboardId?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<DisabledDefaultDashboardCriteriaOrder>>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum DisabledDefaultDashboardCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DockerContainerResponse = {
  __typename: 'DockerContainerResponse';
  Id: Scalars['String'];
  Names: Array<Scalars['String']>;
};

export type DockerEndpointPort = {
  __typename: 'DockerEndpointPort';
  Protocol: Scalars['String'];
  PublishedPort?: Maybe<Scalars['Int']>;
  TargetPort: Scalars['Int'];
};

export type DockerService = {
  __typename: 'DockerService';
  CreatedAt: Scalars['String'];
  Endpoint: DockerServiceEndpoint;
  ID: Scalars['String'];
  Spec: DockerServiceSpec;
  UpdatedAt: Scalars['String'];
  Version: DockerVersion;
  imageVersion: Scalars['String'];
  jiraIssues?: Maybe<JiraIssueConnection>;
};

export type DockerServiceEndpoint = {
  __typename: 'DockerServiceEndpoint';
  Ports: Array<DockerEndpointPort>;
  Spec: DockerServiceEndpointSpec;
  VirtualIPs: Array<DockerServiceEndpointVirtualIP>;
};

export type DockerServiceEndpointSpec = {
  __typename: 'DockerServiceEndpointSpec';
  Mode?: Maybe<Scalars['String']>;
  Ports: Array<DockerEndpointPort>;
};

export type DockerServiceEndpointVirtualIP = {
  __typename: 'DockerServiceEndpointVirtualIP';
  Addr: Scalars['String'];
  NetworkID: Scalars['String'];
};

export type DockerServiceSearchInput = {
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DockerServiceSpec = {
  __typename: 'DockerServiceSpec';
  EndpointSpec: DockerServiceSpecEndpointSpec;
  Mode: DockerServiceSpecMode;
  Name: Scalars['String'];
  RollbackConfig?: Maybe<DockerServiceSpecRollbackConfig>;
  TaskTemplate: DockerServiceSpecTaskTemplate;
  UpdateConfig?: Maybe<DockerServiceSpecUpdateConfig>;
};

export type DockerServiceSpecEndpointSpec = {
  __typename: 'DockerServiceSpecEndpointSpec';
  Mode: Scalars['String'];
  Ports: Array<DockerEndpointPort>;
};

export type DockerServiceSpecMode = {
  __typename: 'DockerServiceSpecMode';
  Replicated?: Maybe<DockerServiceSpecModeReplicated>;
};

export type DockerServiceSpecModeReplicated = {
  __typename: 'DockerServiceSpecModeReplicated';
  Replicas: Scalars['Int'];
};

export type DockerServiceSpecRollbackConfig = {
  __typename: 'DockerServiceSpecRollbackConfig';
  Delay: Scalars['Long'];
  FailureAction: Scalars['String'];
  MaxFailureRatio: Scalars['Float'];
  Monitor: Scalars['Long'];
  Parallelism: Scalars['Int'];
};

export type DockerServiceSpecTaskTemplate = {
  __typename: 'DockerServiceSpecTaskTemplate';
  ContainerSpec: DockerServiceSpecTaskTemplateContainerSpec;
  ForceUpdate: Scalars['Int'];
  RestartPolicy?: Maybe<DockerServiceSpecTaskTemplateRestartPolicy>;
};

export type DockerServiceSpecTaskTemplateContainerSpec = {
  __typename: 'DockerServiceSpecTaskTemplateContainerSpec';
  Image: Scalars['String'];
};

export type DockerServiceSpecTaskTemplateRestartPolicy = {
  __typename: 'DockerServiceSpecTaskTemplateRestartPolicy';
  Condition: Scalars['String'];
  MaxAttempts: Scalars['Int'];
};

export type DockerServiceSpecUpdateConfig = {
  __typename: 'DockerServiceSpecUpdateConfig';
  Delay?: Maybe<Scalars['Long']>;
  FailureAction: Scalars['String'];
  MaxFailureRatio: Scalars['Float'];
  Monitor?: Maybe<Scalars['Long']>;
  Parallelism: Scalars['Int'];
};

export type DockerVersion = {
  __typename: 'DockerVersion';
  Index: Scalars['Int'];
};

export type DynamicCriteriaInput = {
  criteriaId: Scalars['ID'];
  value?: InputMaybe<DynamicCriteriaValueInput>;
};

export type DynamicCriteriaList = Model & {
  __typename: 'DynamicCriteriaList';
  criteria: Criteria;
  criteriaId: Scalars['ID'];
  ct: Scalars['DateTime'];
  dclId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  list: List;
  listId: Scalars['ID'];
  ut: Scalars['DateTime'];
  values: DynamicCriteriaListValueConnection;
};

export type DynamicCriteriaListConnection = {
  __typename: 'DynamicCriteriaListConnection';
  hash: Scalars['String'];
  nodes: Array<DynamicCriteriaList>;
  totalCount: Scalars['Int'];
};

export type DynamicCriteriaListCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  listId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<DynamicCriteriaListCriteriaOrder>>;
};

export enum DynamicCriteriaListCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DynamicCriteriaListValue = Model & {
  __typename: 'DynamicCriteriaListValue';
  ct: Scalars['DateTime'];
  dclId: Scalars['ID'];
  id: Scalars['ID'];
  operatorType?: Maybe<OperatorType>;
  operatorTypeId?: Maybe<Scalars['ID']>;
  path: CriteriaPath;
  pathId: Scalars['ID'];
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export type DynamicCriteriaListValueConnection = {
  __typename: 'DynamicCriteriaListValueConnection';
  hash: Scalars['String'];
  nodes: Array<DynamicCriteriaListValue>;
  totalCount: Scalars['Int'];
};

export enum DynamicCriteriaListValueCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type DynamicCriteriaValueInput = {
  operatorType?: InputMaybe<OperatorTypeEnum>;
  pathId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<DynamicCriteriaValueInput>>;
};

export type DynamicRulesInput = {
  listId: Scalars['ID'];
  rules: Array<DynamicCriteriaInput>;
};

export type Entity = Model & {
  __typename: 'Entity';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  heading: Scalars['String'];
  id: Scalars['ID'];
  mapping: TableMapper;
  ut: Scalars['DateTime'];
};

export type EntityCardFields = {
  __typename: 'EntityCardFields';
  entityGridItemConfigurationId: Scalars['ID'];
  link: CardFieldKeys;
  person: CardFieldKeys;
  site: CardFieldKeys;
};

export type EntityConnection = SearchableConnection & {
  __typename: 'EntityConnection';
  hash: Scalars['String'];
  nodes: Array<Entity>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityControlSetting = Model & {
  __typename: 'EntityControlSetting';
  createDcr: Scalars['Boolean'];
  ct: Scalars['DateTime'];
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export enum EntityControlSettingCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type EntityCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityId?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  name?: InputMaybe<Scalars['String']>;
  onlyDcrTypes?: InputMaybe<Scalars['Boolean']>;
  onlyEntityMergeTypes?: InputMaybe<Scalars['Boolean']>;
  onlyListTypes?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  types?: InputMaybe<Array<EntityTypeEnum>>;
};

export enum EntityCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum EntityDataToBeTransferredDataTypeEnum {
  AFFILIATION = 'AFFILIATION',
  DIRECT = 'DIRECT'
}

export type EntityDataToBeTransferredType = AffiliationContactValue_EntityDataToBeTransferredType | AffiliationCountryCode_EntityDataToBeTransferredType | AffiliationCustomField_EntityDataToBeTransferredType | AffiliationExternalId_EntityDataToBeTransferredType | AffiliationIsPrimary_EntityDataToBeTransferredType | AffiliationNotes_EntityDataToBeTransferredType | AffiliationPositionCode_EntityDataToBeTransferredType | AffiliationTherapeuticFocus_EntityDataToBeTransferredType | AffiliationWorkingSpecialities_EntityDataToBeTransferredType | PersonActivity_EntityDataToBeTransferredType | PersonAddress_EntityDataToBeTransferredType | PersonBirth_EntityDataToBeTransferredType | PersonConsent_EntityDataToBeTransferredType | PersonContactValue_EntityDataToBeTransferredType | PersonCountry_EntityDataToBeTransferredType | PersonCustomField_EntityDataToBeTransferredType | PersonEducations_EntityDataToBeTransferredType | PersonExamYear_EntityDataToBeTransferredType | PersonExternalId_EntityDataToBeTransferredType | PersonFirstName_EntityDataToBeTransferredType | PersonGdpr_EntityDataToBeTransferredType | PersonGender_EntityDataToBeTransferredType | PersonIsActive_EntityDataToBeTransferredType | PersonLastName_EntityDataToBeTransferredType | PersonLink_EntityDataToBeTransferredType | PersonLists_EntityDataToBeTransferredType | PersonMailToPrivate_EntityDataToBeTransferredType | PersonNotes_EntityDataToBeTransferredType | PersonProductSegmentation_EntityDataToBeTransferredType | PersonProjects_EntityDataToBeTransferredType | PersonResponsibleArea_EntityDataToBeTransferredType | PersonSegmentation_EntityDataToBeTransferredType | PersonTags_EntityDataToBeTransferredType | PersonTherapeuticFocus_EntityDataToBeTransferredType | PersonTitle_EntityDataToBeTransferredType | PersonType_EntityDataToBeTransferredType | SiteActivity_EntityDataToBeTransferredType | SiteAddress_EntityDataToBeTransferredType | SiteContactValue_EntityDataToBeTransferredType | SiteCountry_EntityDataToBeTransferredType | SiteCustomField_EntityDataToBeTransferredType | SiteExternalId_EntityDataToBeTransferredType | SiteIsUnplaced_EntityDataToBeTransferredType | SiteLinks_EntityDataToBeTransferredType | SiteLists_EntityDataToBeTransferredType | SiteMailingNamePrefix_EntityDataToBeTransferredType | SiteName_EntityDataToBeTransferredType | SiteNotes_EntityDataToBeTransferredType | SiteParent_EntityDataToBeTransferredType | SiteSegmentation_EntityDataToBeTransferredType | SiteTags_EntityDataToBeTransferredType | SiteType_EntityDataToBeTransferredType | SiteWebpage_EntityDataToBeTransferredType;

export type EntityGridCardFieldTypeConnection = SearchableConnection & {
  __typename: 'EntityGridCardFieldTypeConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemCardFieldType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemCardField = Model & {
  __typename: 'EntityGridItemCardField';
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  entityGridItemCardFieldType: EntityGridItemCardFieldTypeEnum;
  entityGridItemCardFieldTypeCode: Scalars['String'];
  entityGridItemConfigurationId: Scalars['ID'];
  fieldKey: Scalars['String'];
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isHeadingKey: Scalars['Boolean'];
  sort: Scalars['Int'];
  type: EntityGridItemCardFieldType;
  ut: Scalars['DateTime'];
};

export type EntityGridItemCardFieldConnection = SearchableConnection & {
  __typename: 'EntityGridItemCardFieldConnection';
  cardFieldKeys: EntityCardFields;
  hash: Scalars['String'];
  nodes: Array<EntityGridItemCardField>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemCardFieldCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityGridItemCardFieldType?: InputMaybe<EntityGridItemCardFieldTypeEnum>;
  entityGridItemConfigurationId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<EntityGridItemCardFieldCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityGridItemCardFieldCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type EntityGridItemCardFieldInput = {
  fieldKey: Scalars['String'];
  heading?: InputMaybe<Scalars['String']>;
  isHeadingKey: Scalars['Boolean'];
};

export type EntityGridItemCardFieldType = {
  __typename: 'EntityGridItemCardFieldType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  entityTypeId: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type EntityGridItemCardFieldTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<EntityGridItemCardFieldTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityGridItemCardFieldTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum EntityGridItemCardFieldTypeEnum {
  HCO_MAIN = 'HCO_MAIN',
  HCO_META = 'HCO_META',
  HCP_MAIN = 'HCP_MAIN',
  HCP_META = 'HCP_META',
  LINK_MAIN = 'LINK_MAIN',
  LINK_META = 'LINK_META'
}

export type EntityGridItemConfiguration = Model & {
  __typename: 'EntityGridItemConfiguration';
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entityTabCode: Scalars['String'];
  fields: EntityGridItemFieldConnection;
  heading?: Maybe<Scalars['String']>;
  height: Scalars['Int'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  tab: EntityTab;
  type: EntityGridItemType;
  typeCode: Scalars['String'];
  typeEnum: EntityGridItemTypeEnum;
  updatedByUserId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
  width?: Maybe<Scalars['Int']>;
  x: Scalars['Int'];
  y: Scalars['Int'];
};


export type EntityGridItemConfigurationfieldsArgs = {
  criteria?: InputMaybe<EntityGridItemFieldCriteria>;
};

export type EntityGridItemConfigurationConnection = SearchableConnection & {
  __typename: 'EntityGridItemConfigurationConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemConfiguration>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemConfigurationCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityGridItemConfigurationCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  tabCode?: InputMaybe<Scalars['String']>;
};

export enum EntityGridItemConfigurationCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type EntityGridItemField = Model & {
  __typename: 'EntityGridItemField';
  addedByUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  /** This returns null when type is not 'CustomField' */
  customFieldConfiguration?: Maybe<CustomFieldGridConfiguration>;
  entityGridItemConfigurationId: Scalars['ID'];
  gridItemFieldTypeCode: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  itemConfiguration: EntityGridItemConfiguration;
  sort?: Maybe<Scalars['Int']>;
  type: EntityGridItemFieldType;
  ut: Scalars['DateTime'];
};

export type EntityGridItemFieldConnection = SearchableConnection & {
  __typename: 'EntityGridItemFieldConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemField>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemFieldCriteria = {
  configurationId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  fieldTypes?: InputMaybe<Array<EntityGridItemFieldTypeEnum>>;
  inTabCode?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityGridItemFieldOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sort?: InputMaybe<Scalars['Int']>;
};

export enum EntityGridItemFieldOrder {
  SORTING = 'SORTING'
}

export type EntityGridItemFieldType = {
  __typename: 'EntityGridItemFieldType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entityTypeId: Scalars['Int'];
  enum: EntityGridItemFieldTypeEnum;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  isInTab: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type EntityGridItemFieldTypeisInTabArgs = {
  tabCode: Scalars['String'];
};

export type EntityGridItemFieldTypeConnection = SearchableConnection & {
  __typename: 'EntityGridItemFieldTypeConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemFieldType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemFieldTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityGridItemFieldTypeOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityGridItemFieldTypeEnum {
  HCO_CUSTOM_FIELD = 'HCO_CUSTOM_FIELD',
  HCO_EXTERNAL_IDS = 'HCO_EXTERNAL_IDS',
  HCO_SEGMENTATION = 'HCO_SEGMENTATION',
  HCO_TAGS = 'HCO_TAGS',
  HCP_CONSENT = 'HCP_CONSENT',
  HCP_CUSTOM_FIELD = 'HCP_CUSTOM_FIELD',
  HCP_EXTERNAL_IDS = 'HCP_EXTERNAL_IDS',
  HCP_RES_AREAS = 'HCP_RES_AREAS',
  HCP_SEGMENTATION = 'HCP_SEGMENTATION',
  HCP_TAGS = 'HCP_TAGS',
  LINK_CUSTOM_FIELD = 'LINK_CUSTOM_FIELD'
}

export enum EntityGridItemFieldTypeOrder {
  SORTING = 'SORTING'
}

export type EntityGridItemRelationField = Model & {
  __typename: 'EntityGridItemRelationField';
  ct: Scalars['DateTime'];
  entityGridItemConfigurationId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  relationTabKey: Scalars['String'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type EntityGridItemRelationFieldConnection = SearchableConnection & {
  __typename: 'EntityGridItemRelationFieldConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemRelationField>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemRelationFieldCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityGridItemConfigurationId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  fieldKey?: InputMaybe<Scalars['String']>;
  fieldKeys?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityGridItemRelationFieldCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityGridItemRelationFieldCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type EntityGridItemType = {
  __typename: 'EntityGridItemType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  descriptionKey?: Maybe<Scalars['String']>;
  enum: EntityGridItemTypeEnum;
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  minHeight: Scalars['Int'];
  minWidth?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type EntityGridItemTypeConnection = SearchableConnection & {
  __typename: 'EntityGridItemTypeConnection';
  hash: Scalars['String'];
  nodes: Array<EntityGridItemType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityGridItemTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityGridItemTypeOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityGridItemTypeEnum {
  CARDS = 'CARDS',
  FIELDS = 'FIELDS',
  RELATIONS = 'RELATIONS'
}

export enum EntityGridItemTypeOrder {
  SORTING = 'SORTING'
}

export type EntityMerge = Model & {
  __typename: 'EntityMerge';
  byUser?: Maybe<User>;
  byUserId?: Maybe<Scalars['ID']>;
  ct: Scalars['DateTime'];
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId: Scalars['ID'];
  from?: Maybe<Model>;
  id: Scalars['ID'];
  into?: Maybe<Model>;
  intoEntityAffiliationId: Scalars['ID'];
  mergeOverview: VirtualEntityMergeInfo;
  status: EntityMergeStatusEnum;
  statusCode: Scalars['String'];
  ut: Scalars['DateTime'];
};


export type EntityMergefromArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};


export type EntityMergeintoArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type EntityMergeConnection = SearchableConnection & {
  __typename: 'EntityMergeConnection';
  hash: Scalars['String'];
  nodes: Array<EntityMerge>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityMergeCriteria = {
  affiliationId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  fromOrIntoIds?: InputMaybe<Array<Scalars['ID']>>;
  intoAffiliationId?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Array<EntityMergeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  status?: InputMaybe<EntityMergeStatusEnum>;
};

export enum EntityMergeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type EntityMergeStatus = {
  __typename: 'EntityMergeStatus';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  headingKey: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type EntityMergeStatusConnection = SearchableConnection & {
  __typename: 'EntityMergeStatusConnection';
  hash: Scalars['String'];
  nodes: Array<EntityMergeStatus>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum EntityMergeStatusCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum EntityMergeStatusEnum {
  HANDLED = 'HANDLED',
  UNHANDLED = 'UNHANDLED'
}

export type EntityTab = {
  __typename: 'EntityTab';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  descriptionKey?: Maybe<Scalars['String']>;
  entityTypeId: Scalars['Int'];
  gridItems: EntityGridItemConfigurationConnection;
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type EntityTabgridItemsArgs = {
  criteria?: InputMaybe<EntityGridItemConfigurationCriteria>;
};

export type EntityTabConnection = SearchableConnection & {
  __typename: 'EntityTabConnection';
  hash: Scalars['String'];
  nodes: Array<EntityTab>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityTabCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<EntityTabOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityTabOrder {
  SORTING = 'SORTING'
}

export type EntityTypeConnection = {
  justForTesting: Scalars['Int'];
};

export enum EntityTypeEnum {
  ACTIVITY = 'ACTIVITY',
  ACTIVITY_BRAND = 'ACTIVITY_BRAND',
  ACTIVITY_PRODUCT = 'ACTIVITY_PRODUCT',
  ACTIVITY_STATUS = 'ACTIVITY_STATUS',
  ACTIVITY_TYPE = 'ACTIVITY_TYPE',
  ADDRESS = 'ADDRESS',
  ADDRESS_TYPE = 'ADDRESS_TYPE',
  AFFILIATION = 'AFFILIATION',
  AFFILIATION_FROM_PERSON = 'AFFILIATION_FROM_PERSON',
  AFFILIATION_FROM_SITE = 'AFFILIATION_FROM_SITE',
  BRAND = 'BRAND',
  BRICK = 'BRICK',
  CHAIN = 'CHAIN',
  CHERRY_PICK_OVERVIEW_CUSTOMER = 'CHERRY_PICK_OVERVIEW_CUSTOMER',
  CONSENT_INSTRUCTION = 'CONSENT_INSTRUCTION',
  CONTACT_CATEGORY = 'CONTACT_CATEGORY',
  CONTACT_VALUE = 'CONTACT_VALUE',
  CRITERIA = 'CRITERIA',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
  CUSTOM_LINK_VALUE = 'CUSTOM_LINK_VALUE',
  CUSTOM_VALUE = 'CUSTOM_VALUE',
  DCR = 'DCR',
  DCR_GROUP = 'DCR_GROUP',
  EDUCATION = 'EDUCATION',
  ENTITY_MERGE = 'ENTITY_MERGE',
  EXTERNAL_ID = 'EXTERNAL_ID',
  EXTERNAL_ID_TYPE = 'EXTERNAL_ID_TYPE',
  FILTER_CODE = 'FILTER_CODE',
  IMPORT_PROCESS_LINE = 'IMPORT_PROCESS_LINE',
  IMPORT_PROJECT = 'IMPORT_PROJECT',
  LANGUAGE = 'LANGUAGE',
  LIST = 'LIST',
  PERSON = 'PERSON',
  PERSON_ACTIVITY_AFFILIATION = 'PERSON_ACTIVITY_AFFILIATION',
  PERSON_EDUCATION = 'PERSON_EDUCATION',
  PERSON_FILTER_CODE = 'PERSON_FILTER_CODE',
  PERSON_PRODUCT_SEGMENTATION = 'PERSON_PRODUCT_SEGMENTATION',
  PERSON_PROJECT_AFFILIATION = 'PERSON_PROJECT_AFFILIATION',
  PERSON_TYPE = 'PERSON_TYPE',
  PERS_SELECTION_ROW = 'PERS_SELECTION_ROW',
  POSITION = 'POSITION',
  PREFERENCE = 'PREFERENCE',
  PRODUCT = 'PRODUCT',
  PROJECT = 'PROJECT',
  PROJECT_RESPONSE = 'PROJECT_RESPONSE',
  PROJECT_ROLE = 'PROJECT_ROLE',
  PROJECT_STATUS = 'PROJECT_STATUS',
  PROJECT_TYPE = 'PROJECT_TYPE',
  PURE_ADVANCE_CUSTOMER = 'PURE_ADVANCE_CUSTOMER',
  ROLE = 'ROLE',
  SEGMENTATION_CODE = 'SEGMENTATION_CODE',
  SELECTION = 'SELECTION',
  SELECTION_ROW = 'SELECTION_ROW',
  SELECTION_ROW_RESULT = 'SELECTION_ROW_RESULT',
  SITE = 'SITE',
  SITE_PERSON_WORK_SPECIALTY = 'SITE_PERSON_WORK_SPECIALTY',
  SITE_SECTOR_TYPE = 'SITE_SECTOR_TYPE',
  SITE_SELECTION_ROW = 'SITE_SELECTION_ROW',
  SITE_SPECIALTY = 'SITE_SPECIALTY',
  SITE_TYPE = 'SITE_TYPE',
  USER = 'USER',
  WORK_SPECIALTY = 'WORK_SPECIALTY'
}

export enum EntityUpdateStateEnum {
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
  VALIDATED = 'VALIDATED'
}

export type EntityValidationLog = Model & {
  __typename: 'EntityValidationLog';
  affiliationEntity?: Maybe<Model>;
  ct: Scalars['DateTime'];
  entityAffiliationId: Scalars['ID'];
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  user?: Maybe<User>;
  ut: Scalars['DateTime'];
  validatedByUser?: Maybe<Scalars['ID']>;
  validatedTime: Scalars['DateTime'];
};


export type EntityValidationLogaffiliationEntityArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type EntityValidationLogConnection = SearchableConnection & {
  __typename: 'EntityValidationLogConnection';
  hash: Scalars['String'];
  nodes: Array<EntityValidationLog>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type EntityValidationLogCriteria = {
  affiliationId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<EntityValidationLogCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum EntityValidationLogCriteriaOrder {
  VALIDATED_ASC = 'VALIDATED_ASC',
  VALIDATED_DESC = 'VALIDATED_DESC'
}

export type ExternalCherryPickCustomerOverview = {
  __typename: 'ExternalCherryPickCustomerOverview';
  amount: Scalars['Int'];
  amountAvailable: Scalars['Int'];
  amountUsed: Scalars['Int'];
  country: Scalars['CountryCode'];
  customerCode: Scalars['String'];
};

export type ExternalCherryPickHcpOverview = {
  __typename: 'ExternalCherryPickHcpOverview';
  apurebaseId: Scalars['Int'];
  cherryPickedForCustomerCodes: Array<ExternalCherryPickHcpOverviewCustomer>;
  internationalId: Scalars['String'];
};

export type ExternalCherryPickHcpOverviewCustomer = {
  __typename: 'ExternalCherryPickHcpOverviewCustomer';
  bySystem?: Maybe<Scalars['String']>;
  bySystemUserId?: Maybe<Scalars['String']>;
  byUser?: Maybe<User>;
  customer?: Maybe<PureAdvanceCustomer>;
  customerCode: Scalars['String'];
  timestamp: Scalars['DateTime'];
};

export type ExternalId = Model & {
  __typename: 'ExternalId';
  affiliationId: Scalars['ID'];
  ct: Scalars['DateTime'];
  entityAffiliation?: Maybe<Model>;
  externalId: Scalars['String'];
  externalIdTypeId: Scalars['ID'];
  id: Scalars['ID'];
  type: ExternalIdType;
  ut: Scalars['DateTime'];
};

export type ExternalIdConnection = SearchableConnection & {
  __typename: 'ExternalIdConnection';
  hash: Scalars['String'];
  nodes: Array<ExternalId>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ExternalIdCriteria = {
  affiliationId?: InputMaybe<Scalars['ID']>;
  affiliationIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  exactExternalId?: InputMaybe<Scalars['String']>;
  exactExternalIds?: InputMaybe<Array<Scalars['String']>>;
  externalId?: InputMaybe<Scalars['String']>;
  externalIdTypeCode?: InputMaybe<Scalars['String']>;
  externalIdTypeId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ExternalIdCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ExternalIdCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ExternalIdMutationInput = {
  externalId: Scalars['String'];
  externalIdTypeCode?: InputMaybe<Scalars['String']>;
  externalIdTypeId?: InputMaybe<Scalars['ID']>;
  internalId: Scalars['ID'];
};

export type ExternalIdSystem = Model & {
  __typename: 'ExternalIdSystem';
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isHeadingKey: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type ExternalIdSystemConnection = SearchableConnection & {
  __typename: 'ExternalIdSystemConnection';
  hash: Scalars['String'];
  nodes: Array<ExternalIdSystem>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ExternalIdSystemCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ExternalIdSystemCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ExternalIdSystemCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ExternalIdType = Model & {
  __typename: 'ExternalIdType';
  allowDuplicateValues: Scalars['Boolean'];
  code: Scalars['String'];
  controlSetting?: Maybe<EntityControlSetting>;
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  exceptionCountries?: Maybe<ExternalIdTypeCountryExceptionRuleConnection>;
  externalIdSystemId?: Maybe<Scalars['ID']>;
  externalIds: ExternalIdConnection;
  externalSystem?: Maybe<ExternalIdSystem>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDuplicateRuleAcrossCountries: Scalars['Boolean'];
  isHeadingKey: Scalars['Boolean'];
  maintainerSourceCode: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  originSourceCode: Scalars['String'];
  roleRules: ExternalIdTypeRoleConnection;
  rules: ExternalIdTypeRules;
  ut: Scalars['DateTime'];
};


export type ExternalIdTypeexternalIdsArgs = {
  criteria?: InputMaybe<ExternalIdCriteria>;
};


export type ExternalIdTyperoleRulesArgs = {
  criteria?: InputMaybe<ExternalIdTypeRoleCriteria>;
};

export type ExternalIdTypeConnection = SearchableConnection & {
  __typename: 'ExternalIdTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ExternalIdType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ExternalIdTypeCountryExceptionRule = Model & {
  __typename: 'ExternalIdTypeCountryExceptionRule';
  country: Scalars['CountryCode'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  typeId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ExternalIdTypeCountryExceptionRuleConnection = SearchableConnection & {
  __typename: 'ExternalIdTypeCountryExceptionRuleConnection';
  hash: Scalars['String'];
  nodes: Array<ExternalIdTypeCountryExceptionRule>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum ExternalIdTypeCountryExceptionRuleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ExternalIdTypeCriteria = {
  code?: InputMaybe<Scalars['String']>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  externalIdSystemId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ExternalIdTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export enum ExternalIdTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ExternalIdTypeEnum {
  CUSTOM_FIELD_CRITERIA = 'CUSTOM_FIELD_CRITERIA',
  OFFICIAL_ID = 'OFFICIAL_ID'
}

export type ExternalIdTypeRole = Model & {
  __typename: 'ExternalIdTypeRole';
  allowMutation: Scalars['Boolean'];
  allowRead: Scalars['Boolean'];
  ct: Scalars['DateTime'];
  externalIdTypeCode: Scalars['String'];
  id: Scalars['ID'];
  role: Role;
  roleId: Scalars['ID'];
  type: ExternalIdType;
  ut: Scalars['DateTime'];
};

export type ExternalIdTypeRoleConnection = SearchableConnection & {
  __typename: 'ExternalIdTypeRoleConnection';
  hash: Scalars['String'];
  nodes: Array<ExternalIdTypeRole>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ExternalIdTypeRoleCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ExternalIdTypeRoleCriteriaOrder>>;
  roleId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  typeCode?: InputMaybe<Scalars['String']>;
};

export enum ExternalIdTypeRoleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ExternalIdTypeRules = {
  __typename: 'ExternalIdTypeRules';
  allowMutation: Scalars['Boolean'];
  allowRead: Scalars['Boolean'];
  key: Scalars['ID'];
};

export type ExternalPostcodeResponse = {
  __typename: 'ExternalPostcodeResponse';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyCode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type FetchSize = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Field = {
  __typename: 'Field';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  entityId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<EntityTypeEnum>;
  field?: Maybe<Scalars['String']>;
  fisk?: Maybe<Scalars['Boolean']>;
  heading: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type FieldConnection = {
  __typename: 'FieldConnection';
  hash: Scalars['String'];
  nodes: Array<Field>;
  totalCount: Scalars['Int'];
};

export type FieldCriteria = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<FieldCriteriaOrder>>;
};

export enum FieldCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum FieldEnum {
  ACTIVITY_END = 'ACTIVITY_END',
  ACTIVITY_ID = 'ACTIVITY_ID',
  ACTIVITY_START = 'ACTIVITY_START',
  ACTIVITY_STATUS_HEADING = 'ACTIVITY_STATUS_HEADING',
  ACTIVITY_SUPER_TYPE = 'ACTIVITY_SUPER_TYPE',
  ACTIVITY_TITLE = 'ACTIVITY_TITLE',
  ACTIVITY_TYPE = 'ACTIVITY_TYPE',
  ACTIVITY_TYPE_HEADING = 'ACTIVITY_TYPE_HEADING',
  ADDRESS_HCO_CITY = 'ADDRESS_HCO_CITY',
  ADDRESS_HCO_COMMUNE = 'ADDRESS_HCO_COMMUNE',
  ADDRESS_HCO_COUNTRY = 'ADDRESS_HCO_COUNTRY',
  ADDRESS_HCO_COUNTY = 'ADDRESS_HCO_COUNTY',
  ADDRESS_HCO_LATITUDE = 'ADDRESS_HCO_LATITUDE',
  ADDRESS_HCO_LONGITUDE = 'ADDRESS_HCO_LONGITUDE',
  ADDRESS_HCO_STREET = 'ADDRESS_HCO_STREET',
  ADDRESS_HCO_ZIP = 'ADDRESS_HCO_ZIP',
  ADDRESS_HCP_CITY = 'ADDRESS_HCP_CITY',
  ADDRESS_HCP_COMMUNE = 'ADDRESS_HCP_COMMUNE',
  ADDRESS_HCP_COUNTRY = 'ADDRESS_HCP_COUNTRY',
  ADDRESS_HCP_COUNTY = 'ADDRESS_HCP_COUNTY',
  ADDRESS_HCP_LATITUDE = 'ADDRESS_HCP_LATITUDE',
  ADDRESS_HCP_LONGITUDE = 'ADDRESS_HCP_LONGITUDE',
  ADDRESS_HCP_STREET = 'ADDRESS_HCP_STREET',
  ADDRESS_HCP_ZIP = 'ADDRESS_HCP_ZIP',
  ATTENDING = 'ATTENDING',
  BRAND_NAME = 'BRAND_NAME',
  BRICK_NAME = 'BRICK_NAME',
  CONFERENCE_MANAGER_HCP_ID = 'CONFERENCE_MANAGER_HCP_ID',
  CONTACT_HCO_EMAIL_VALUE = 'CONTACT_HCO_EMAIL_VALUE',
  CONTACT_HCO_FAX_VALUE = 'CONTACT_HCO_FAX_VALUE',
  CONTACT_HCO_PHONE_VALUE = 'CONTACT_HCO_PHONE_VALUE',
  CONTACT_HCP_EMAIL_VALUE = 'CONTACT_HCP_EMAIL_VALUE',
  CONTACT_HCP_FAX_VALUE = 'CONTACT_HCP_FAX_VALUE',
  CONTACT_HCP_PHONE_VALUE = 'CONTACT_HCP_PHONE_VALUE',
  CUSTOM_IMPORT_ALTERNATIVE_EMAIL = 'CUSTOM_IMPORT_ALTERNATIVE_EMAIL',
  CUSTOM_IMPORT_CONSENT = 'CUSTOM_IMPORT_CONSENT',
  CUSTOM_IMPORT_LINK = 'CUSTOM_IMPORT_LINK',
  CUSTOM_IMPORT_PERSON = 'CUSTOM_IMPORT_PERSON',
  CUSTOM_IMPORT_PRIMARY = 'CUSTOM_IMPORT_PRIMARY',
  CUSTOM_IMPORT_PRIMARY_EMAIL = 'CUSTOM_IMPORT_PRIMARY_EMAIL',
  CUSTOM_LINK_VALUE_VALUE_ID = 'CUSTOM_LINK_VALUE_VALUE_ID',
  EDU_CODE = 'EDU_CODE',
  EDU_LABEL = 'EDU_LABEL',
  EXTERNAL_ACTIVITY_ID = 'EXTERNAL_ACTIVITY_ID',
  EXTERNAL_HCP_ID = 'EXTERNAL_HCP_ID',
  EXTERNAL_PROJECT_ID = 'EXTERNAL_PROJECT_ID',
  EXTERNAL_USER_ID = 'EXTERNAL_USER_ID',
  FILTER_CODE_HEADING = 'FILTER_CODE_HEADING',
  HCO_APUREBASE_ID = 'HCO_APUREBASE_ID',
  HCO_CHAIN = 'HCO_CHAIN',
  HCO_COUNTRY = 'HCO_COUNTRY',
  HCO_ID = 'HCO_ID',
  HCO_LAT = 'HCO_LAT',
  HCO_LON = 'HCO_LON',
  HCO_MAIL_CITY = 'HCO_MAIL_CITY',
  HCO_MAIL_COMMUNE = 'HCO_MAIL_COMMUNE',
  HCO_MAIL_STREET = 'HCO_MAIL_STREET',
  HCO_MAIL_ZIP = 'HCO_MAIL_ZIP',
  HCO_NAME = 'HCO_NAME',
  HCO_NUMBER_OF_BEDS = 'HCO_NUMBER_OF_BEDS',
  HCO_NUMBER_OF_CHAIRS = 'HCO_NUMBER_OF_CHAIRS',
  HCO_PARENT_ID = 'HCO_PARENT_ID',
  HCO_SECTOR_TYPE = 'HCO_SECTOR_TYPE',
  HCO_SPECIALTY = 'HCO_SPECIALTY',
  HCO_TYPE_CODE = 'HCO_TYPE_CODE',
  HCO_VISIT_CITY = 'HCO_VISIT_CITY',
  HCO_VISIT_COMMUNE = 'HCO_VISIT_COMMUNE',
  HCO_VISIT_STREET = 'HCO_VISIT_STREET',
  HCO_VISIT_ZIP = 'HCO_VISIT_ZIP',
  HCO_WEBPAGE = 'HCO_WEBPAGE',
  HCP_APUREBASE_ID = 'HCP_APUREBASE_ID',
  HCP_BIRTH_YEAR = 'HCP_BIRTH_YEAR',
  HCP_COUNTRY_CODE = 'HCP_COUNTRY_CODE',
  HCP_EXAMYEAR = 'HCP_EXAMYEAR',
  HCP_FIRSTNAME = 'HCP_FIRSTNAME',
  HCP_FULLNAME = 'HCP_FULLNAME',
  HCP_GENDER = 'HCP_GENDER',
  HCP_ID = 'HCP_ID',
  HCP_LASTNAME = 'HCP_LASTNAME',
  HCP_MAIL_TO_PRIVATE = 'HCP_MAIL_TO_PRIVATE',
  HCP_MIDDLENAME = 'HCP_MIDDLENAME',
  HCP_OFFICIAL_ID = 'HCP_OFFICIAL_ID',
  HCP_OFFICIAL_ID_CT = 'HCP_OFFICIAL_ID_CT',
  HCP_SPECIALTY = 'HCP_SPECIALTY',
  HCP_STATUS = 'HCP_STATUS',
  HCP_TITLE = 'HCP_TITLE',
  HCP_TYPE_CODE = 'HCP_TYPE_CODE',
  HCP_WORKING_SPECIALTY = 'HCP_WORKING_SPECIALTY',
  HCP_WORK_EMAIL = 'HCP_WORK_EMAIL',
  HCP_WORK_FAX = 'HCP_WORK_FAX',
  HCP_WORK_PHONE = 'HCP_WORK_PHONE',
  HCP_WORK_POS_CODE = 'HCP_WORK_POS_CODE',
  LANGUAGE = 'LANGUAGE',
  LINK_APUREBASE_ID = 'LINK_APUREBASE_ID',
  LINK_IS_PRIMARY = 'LINK_IS_PRIMARY',
  PERSTYPE_LABEL = 'PERSTYPE_LABEL',
  PERSTYPE_LABEL_GB = 'PERSTYPE_LABEL_GB',
  PERS_EDU_CT = 'PERS_EDU_CT',
  POSITION_LABEL = 'POSITION_LABEL',
  PREFERENCE_HEADING = 'PREFERENCE_HEADING',
  PRODUCT_HEADING = 'PRODUCT_HEADING',
  PROJECT_END = 'PROJECT_END',
  PROJECT_HEADING = 'PROJECT_HEADING',
  PROJECT_LOCATION = 'PROJECT_LOCATION',
  PROJECT_RESPONSE_HEADING = 'PROJECT_RESPONSE_HEADING',
  PROJECT_ROLE_HEADING = 'PROJECT_ROLE_HEADING',
  PROJECT_START = 'PROJECT_START',
  PROJECT_STATUS_HEADING = 'PROJECT_STATUS_HEADING',
  PROJECT_TYPE_HEADING = 'PROJECT_TYPE_HEADING',
  SEGMENTATION_CODE = 'SEGMENTATION_CODE',
  SELAS_ACTIVITY_ID = 'SELAS_ACTIVITY_ID',
  SELAS_ACTIVITY_TYPE = 'SELAS_ACTIVITY_TYPE',
  SELAS_EVENT_ID = 'SELAS_EVENT_ID',
  SELAS_HCP_ID = 'SELAS_HCP_ID',
  SELAS_USER_ID = 'SELAS_USER_ID',
  SITETYPE_LABEL = 'SITETYPE_LABEL',
  SITETYPE_LABEL_GB = 'SITETYPE_LABEL_GB',
  SMS_HCP_ID = 'SMS_HCP_ID',
  UNKNOWN = 'UNKNOWN',
  WP_DELIVERY = 'WP_DELIVERY',
  WP_INTEREST = 'WP_INTEREST',
  WP_MAGAZINE = 'WP_MAGAZINE',
  WP_NEWSLETTER = 'WP_NEWSLETTER',
  WP_OCCUPATION = 'WP_OCCUPATION',
  WP_ROLE = 'WP_ROLE',
  WP_SPC = 'WP_SPC'
}

export type FilterCode = Model & {
  __typename: 'FilterCode';
  ct: Scalars['DateTime'];
  filterCodeTypeId: Scalars['ID'];
  /** All persons with specific filter codes */
  filterType?: Maybe<FilterCodeType>;
  /** All persons with specific filter codes */
  getPersonsByFilterCode: PersonConnection;
  header: Scalars['String'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  status: Scalars['Int'];
  ut: Scalars['DateTime'];
};


export type FilterCodegetPersonsByFilterCodeArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};

export type FilterCodeConnection = SearchableConnection & {
  __typename: 'FilterCodeConnection';
  containsType: Scalars['Boolean'];
  hash: Scalars['String'];
  nodes: Array<FilterCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};


export type FilterCodeConnectioncontainsTypeArgs = {
  code: Scalars['String'];
};

export type FilterCodeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  filterCodeId?: InputMaybe<Scalars['ID']>;
  filterTypeCode?: InputMaybe<Scalars['String']>;
  filterTypeId?: InputMaybe<Scalars['ID']>;
  header?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<FilterCodeCriteriaOrder>>;
  persId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
};

export enum FilterCodeCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY'
}

export type FilterCodeType = Model & {
  __typename: 'FilterCodeType';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  /** All filter codes by this type */
  filterCodes: FilterCodeConnection;
  /**
   * All filter codes by type id
   * @deprecated Please use the filterCodes property instead
   */
  getFilterCodesByTypeId: FilterCodeConnection;
  heading: Scalars['String'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  status: Scalars['Int'];
  ut: Scalars['DateTime'];
};


export type FilterCodeTypefilterCodesArgs = {
  criteria?: InputMaybe<FilterCodeCriteria>;
};


export type FilterCodeTypegetFilterCodesByTypeIdArgs = {
  criteria?: InputMaybe<FilterCodeCriteria>;
};

export type FilterCodeTypeConnection = SearchableConnection & {
  __typename: 'FilterCodeTypeConnection';
  hash: Scalars['String'];
  nodes: Array<FilterCodeType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type FilterCodeTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  filterCodeTypeOrFilterCodeLabel?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<FilterCodeTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum FilterCodeTypeCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY'
}

export type FormInputRule = {
  __typename: 'FormInputRule';
  enum?: Maybe<Array<Scalars['String']>>;
  len?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  messageKey?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Int']>;
  pattern?: Maybe<Scalars['Regex']>;
  required: Scalars['Boolean'];
  type?: Maybe<AsyncValidatorTypeEnum>;
  whitespace?: Maybe<Scalars['Boolean']>;
};

export type FormValidationErrorResponse = {
  __typename: 'FormValidationErrorResponse';
  errorMessage?: Maybe<Scalars['String']>;
  isOk: Scalars['Boolean'];
};

export enum GenderEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}

export type GitlabCommit = {
  __typename: 'GitlabCommit';
  author_email: Scalars['String'];
  author_name: Scalars['String'];
  created_at: Scalars['String'];
  id: Scalars['String'];
  message: Scalars['String'];
  short_id: Scalars['String'];
  title: Scalars['String'];
};

export type GitlabJob = {
  __typename: 'GitlabJob';
  allow_failure?: Maybe<Scalars['Boolean']>;
  artifactsExpireAt?: Maybe<Scalars['DateTime']>;
  artifacts_expire_at?: Maybe<Scalars['String']>;
  commit?: Maybe<GitlabCommit>;
  createdAt?: Maybe<Scalars['DateTime']>;
  created_at?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  pipeline?: Maybe<GitlabPipeline>;
  ref?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  started_at?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tag_list?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<GitlabUser>;
  web_url?: Maybe<Scalars['String']>;
};

export type GitlabPipeline = {
  __typename: 'GitlabPipeline';
  before_sha?: Maybe<Scalars['String']>;
  committed_at?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  finished_at?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  jobs: Array<GitlabJob>;
  project_id?: Maybe<Scalars['Long']>;
  ref?: Maybe<Scalars['String']>;
  sha: Scalars['String'];
  started_at?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  user?: Maybe<GitlabUser>;
  web_url?: Maybe<Scalars['String']>;
};

export type GitlabSchedule = {
  __typename: 'GitlabSchedule';
  active: Scalars['Boolean'];
  created_at: Scalars['String'];
  cron: Scalars['String'];
  cron_timezone: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  last_pipeline?: Maybe<GitlabPipeline>;
  next_run_at: Scalars['String'];
  owner: GitlabUser;
  ref: Scalars['String'];
  updated_at: Scalars['String'];
  variables: Array<GitlabScheduleVariable>;
};

export type GitlabScheduleVariable = {
  __typename: 'GitlabScheduleVariable';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  variable_type: Scalars['String'];
};

export type GitlabUser = {
  __typename: 'GitlabUser';
  avatar_url: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  state: Scalars['String'];
  username: Scalars['String'];
  web_url: Scalars['String'];
};

export type GridInput = {
  gridItems: Array<DashboardItemGrid>;
};

export enum GroupByDateRanges {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type IDataValue = {
  code: Scalars['String'];
  countryCode: Scalars['String'];
  isGlobalOnly: Scalars['Boolean'];
  label: Scalars['String'];
  labelGb?: Maybe<Scalars['String']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
};

export type ImfDataValue = IDataValue & {
  __typename: 'ImfDataValue';
  active: Scalars['Int'];
  code: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  displayLabel: Scalars['String'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isGlobalOnly: Scalars['Boolean'];
  label: Scalars['String'];
  labelGb?: Maybe<Scalars['String']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  type: DataValueMappingName;
  ut: Scalars['DateTime'];
  valCode: Scalars['String'];
};

export type ImfModel = {
  apurebaseId?: Maybe<Scalars['Int']>;
  countryCode: Scalars['String'];
  countryEnum: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  isLocal: Scalars['Boolean'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ImportFile = Model & {
  __typename: 'ImportFile';
  charset: CharsetEnum;
  charsetCode: Scalars['String'];
  ct: Scalars['DateTime'];
  delimiter: DelimiterEnum;
  delimiterCode: Scalars['String'];
  id: Scalars['ID'];
  isFirstHeader: Scalars['Boolean'];
  lines: ImportLineConnection;
  name: Scalars['String'];
  projectId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type ImportFilelinesArgs = {
  criteria?: InputMaybe<ImportLineCriteria>;
};

export type ImportFileConnection = {
  __typename: 'ImportFileConnection';
  hash: Scalars['String'];
  nodes: Array<ImportFile>;
  totalCount: Scalars['Int'];
};

export type ImportFileCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ImportFileCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum ImportFileCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportLine = Model & {
  __typename: 'ImportLine';
  ct: Scalars['DateTime'];
  data: Scalars['String'];
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  lineIndex: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ImportLineConnection = {
  __typename: 'ImportLineConnection';
  nodes: Array<ImportLine>;
  totalCount: Scalars['Int'];
};

export type ImportLineCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  fileId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ImportLineCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum ImportLineCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportManualEventMatchStage = ImportManualStageType & {
  __typename: 'ImportManualEventMatchStage';
  lineId: Scalars['ID'];
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type ImportManualPersonStage = ImportManualStageType & {
  __typename: 'ImportManualPersonStage';
  candidates: Array<MatchCandidate>;
  candidatesFor: Array<MatchCandidateValue>;
  externalIdTypeCode: Scalars['String'];
  externalIdValue: Scalars['String'];
  fuzzySearchAvailable: Scalars['Boolean'];
  lineId: Scalars['ID'];
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type ImportManualStageType = {
  lineId: Scalars['ID'];
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type ImportProcessField = Model & {
  __typename: 'ImportProcessField';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  lineId: Scalars['ID'];
  projectId: Scalars['ID'];
  templateProcessFieldId: Scalars['ID'];
  ut: Scalars['DateTime'];
  value: Scalars['String'];
};

export type ImportProcessFieldConnection = {
  __typename: 'ImportProcessFieldConnection';
  hash: Scalars['String'];
  nodes: Array<ImportProcessField>;
  totalCount: Scalars['Int'];
};

export type ImportProcessFieldCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  lineId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ImportProcessFieldCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  templateProcessId?: InputMaybe<Scalars['ID']>;
};

export enum ImportProcessFieldCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportProcessLine = Model & {
  __typename: 'ImportProcessLine';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  line: ImportLine;
  lineId: Scalars['ID'];
  processFields: ImportProcessFieldConnection;
  projectId: Scalars['ID'];
  status: ImportProcessStatusEnum;
  statusCode: Scalars['Int'];
  templateProcessId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type ImportProcessLineprocessFieldsArgs = {
  criteria?: InputMaybe<ImportProcessFieldCriteria>;
};

export type ImportProcessLineConnection = {
  __typename: 'ImportProcessLineConnection';
  hash: Scalars['String'];
  nodes: Array<ImportProcessLine>;
  totalCount: Scalars['Int'];
};

export type ImportProcessLineCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  lineId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ImportProcessLineCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  templateProcessId?: InputMaybe<Scalars['ID']>;
};

export enum ImportProcessLineCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportProcessLineEffect = Model & {
  __typename: 'ImportProcessLineEffect';
  actionCode: Scalars['Int'];
  actionType: ProcessLineEffectActionEnum;
  affiliationEntity?: Maybe<Model>;
  ct: Scalars['DateTime'];
  entityAffiliationId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<EntityTypeEnum>;
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  processLineId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type ImportProcessLineEffectaffiliationEntityArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type ImportProcessLineEffectConnection = {
  __typename: 'ImportProcessLineEffectConnection';
  hash: Scalars['String'];
  nodes: Array<ImportProcessLineEffect>;
  totalCount: Scalars['Int'];
};

export type ImportProcessLineEffectCriteria = {
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ImportProcessLineEffectCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum ImportProcessLineEffectCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ImportProcessStatusEnum {
  FAIL = 'FAIL',
  MANUAL = 'MANUAL',
  NOT_STARTED = 'NOT_STARTED',
  PROCESSED = 'PROCESSED',
  RUNNING = 'RUNNING',
  STARTED = 'STARTED',
  STOPPED = 'STOPPED',
  WAITING = 'WAITING'
}

export type ImportProcessorData = Model & {
  __typename: 'ImportProcessorData';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  key: Scalars['String'];
  processorId: Scalars['ID'];
  projectId: Scalars['ID'];
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export enum ImportProcessorDataCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportProject = Model & {
  __typename: 'ImportProject';
  countryCode?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  currentPhase?: Maybe<ImportTemplateProcess>;
  effects: ImportProcessLineEffectConnection;
  files: ImportFileConnection;
  heading: Scalars['String'];
  id: Scalars['ID'];
  isHeadingKey: Scalars['Boolean'];
  linePreview: ImportProjectLinesPreview;
  manual?: Maybe<ImportManualStageType>;
  meta: ImportProjectMeta;
  note?: Maybe<Scalars['String']>;
  phaseId?: Maybe<Scalars['ID']>;
  processLines: ImportProcessLineConnection;
  responsibleUserId: Scalars['ID'];
  status: Scalars['Int'];
  statusCode?: Maybe<ImportProcessStatusEnum>;
  statusNote?: Maybe<Scalars['String']>;
  template: ImportTemplate;
  templateId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type ImportProjecteffectsArgs = {
  criteria?: InputMaybe<ImportProcessLineEffectCriteria>;
};


export type ImportProjectfilesArgs = {
  criteria?: InputMaybe<ImportFileCriteria>;
};


export type ImportProjectlinePreviewArgs = {
  linesCount?: InputMaybe<Scalars['Int']>;
};


export type ImportProjectprocessLinesArgs = {
  criteria?: InputMaybe<ImportProcessLineCriteria>;
};

export type ImportProjectColumnPreview = {
  __typename: 'ImportProjectColumnPreview';
  code: Scalars['String'];
  label: Scalars['String'];
  note?: Maybe<Scalars['String']>;
};

export type ImportProjectConnection = SearchableConnection & {
  __typename: 'ImportProjectConnection';
  hash: Scalars['String'];
  nodes: Array<ImportProject>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ImportProjectCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ordering?: InputMaybe<Array<ImportProjectCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ImportProjectCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ImportProjectLinePreview = {
  __typename: 'ImportProjectLinePreview';
  key: Scalars['ID'];
  values: Array<ImportProjectValuePreview>;
};

export type ImportProjectLinesPreview = {
  __typename: 'ImportProjectLinesPreview';
  charset: CharsetEnum;
  columns: Array<Maybe<ImportProjectColumnPreview>>;
  delimiter: DelimiterEnum;
  firstLineHeader: Scalars['Boolean'];
  projectId: Scalars['ID'];
  values: Array<ImportProjectLinePreview>;
};

export type ImportProjectMeta = {
  __typename: 'ImportProjectMeta';
  currentStepIndex: Scalars['Int'];
  finishedLineCount: Scalars['Int'];
  lineCount: Scalars['Int'];
  missingLineCount: Scalars['Int'];
  percentage: Scalars['Float'];
  projectId: Scalars['ID'];
  steps: Array<Scalars['String']>;
};

export type ImportProjectValuePreview = {
  __typename: 'ImportProjectValuePreview';
  code?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  value: Scalars['String'];
};

export type ImportSaveProcessInput = {
  actionCode: ProcessLineEffectActionEnum;
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  lineId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type ImportSkipProcessInput = {
  entityAffiliationId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  lineId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type ImportTemplate = Model & {
  __typename: 'ImportTemplate';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  processes: ImportTemplateProcessConnection;
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type ImportTemplateprocessesArgs = {
  criteria?: InputMaybe<ImportTemplateProcessCriteria>;
};

export type ImportTemplateConnection = {
  __typename: 'ImportTemplateConnection';
  hash: Scalars['String'];
  nodes: Array<ImportTemplate>;
  totalCount: Scalars['Int'];
};

export type ImportTemplateCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ImportTemplateCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['Int']>;
};

export enum ImportTemplateCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type ImportTemplateProcess = Model & {
  __typename: 'ImportTemplateProcess';
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  fields: ImportTemplateProcessFieldConnection;
  heading: Scalars['String'];
  id: Scalars['ID'];
  isHeadingKey: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  processorDataKey?: Maybe<Scalars['String']>;
  processorId: Scalars['ID'];
  requiresCustomFieldsImportMapping: Scalars['Boolean'];
  sort: Scalars['Int'];
  templateId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ImportTemplateProcessConnection = {
  __typename: 'ImportTemplateProcessConnection';
  hash: Scalars['String'];
  nodes: Array<ImportTemplateProcess>;
  totalCount: Scalars['Int'];
};

export type ImportTemplateProcessCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ImportTemplateProcessCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
};

export enum ImportTemplateProcessCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type ImportTemplateProcessField = Model & {
  __typename: 'ImportTemplateProcessField';
  ct: Scalars['DateTime'];
  field: Field;
  fieldCode: Scalars['String'];
  id: Scalars['ID'];
  lineDataIndex: Scalars['Int'];
  templateProcessId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ImportTemplateProcessFieldConnection = {
  __typename: 'ImportTemplateProcessFieldConnection';
  hash: Scalars['String'];
  nodes: Array<ImportTemplateProcessField>;
  totalCount: Scalars['Int'];
};

export enum ImportTemplateProcessFieldCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type InstanceSetting = {
  __typename: 'InstanceSetting';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  enum: InstanceSettingEnum;
  ut: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export enum InstanceSettingCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum InstanceSettingEnum {
  DESCRIPTION = 'DESCRIPTION',
  DOMAIN_PATH = 'DOMAIN_PATH',
  DOWNLOAD_FILES_VIA_BOX = 'DOWNLOAD_FILES_VIA_BOX',
  IMG_PATH = 'IMG_PATH',
  MASS_ASSIGN_HCO = 'MASS_ASSIGN_HCO',
  MASS_ASSIGN_HCP = 'MASS_ASSIGN_HCP',
  NAME = 'NAME',
  NEW_HCO_VIEW_ENABLED = 'NEW_HCO_VIEW_ENABLED',
  NEW_HCP_VIEW_ENABLED = 'NEW_HCP_VIEW_ENABLED',
  PAGE_TITLE = 'PAGE_TITLE',
  PERSON_SEGMENTATION = 'PERSON_SEGMENTATION',
  PRODUCT_SEGMENTATION = 'PRODUCT_SEGMENTATION',
  PRODUCT_SEGMENTATION_MULTIPLE = 'PRODUCT_SEGMENTATION_MULTIPLE',
  SITE_SEGMENTATION = 'SITE_SEGMENTATION',
  TAB_TEXT = 'TAB_TEXT'
}

export type InternationalCustomer = {
  __typename: 'InternationalCustomer';
  _callName?: Maybe<Scalars['String']>;
  _name?: Maybe<Scalars['String']>;
  cherryPickOverview?: Maybe<ExternalCherryPickCustomerOverview>;
  code: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type InternationalCustomerConnection = SearchableConnection & {
  __typename: 'InternationalCustomerConnection';
  hash: Scalars['String'];
  nodes: Array<InternationalCustomer>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type InternationalCustomerCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  excludeWhenPersonApbIdIsCherryPicked?: InputMaybe<Scalars['Int']>;
  excludeWhenSiteApbIdIsCherryPicked?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  hasPersonCherryPickSupport?: InputMaybe<Scalars['Boolean']>;
  hasSiteCherryPickSupport?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<ActiveEnum>;
  ordering?: InputMaybe<Array<InternationalCustomerCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum InternationalCustomerCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum IsMappingJoinBasicEnum {
  ADVANCED = 'ADVANCED',
  BASIC = 'BASIC',
  BOTH = 'BOTH'
}

export type JiraIssue = {
  __typename: 'JiraIssue';
  expand: Scalars['String'];
  fields: JiraIssueFields;
  id: Scalars['String'];
  key: Scalars['String'];
  self: Scalars['String'];
};

export type JiraIssueConnection = {
  __typename: 'JiraIssueConnection';
  expand?: Maybe<Scalars['String']>;
  issues: Array<JiraIssue>;
  maxResults: Scalars['Int'];
  startAt: Scalars['Int'];
  total: Scalars['Int'];
};

export type JiraIssueDescription = {
  __typename: 'JiraIssueDescription';
  content: Array<JiraIssueDescriptionContent>;
  type: Scalars['String'];
  version: Scalars['Int'];
};

export type JiraIssueDescriptionContent = {
  __typename: 'JiraIssueDescriptionContent';
  attrs?: Maybe<JiraIssueDescriptionContentAttributes>;
  content?: Maybe<Array<JiraIssueDescriptionContentValue>>;
  type: Scalars['String'];
};

export type JiraIssueDescriptionContentAttributes = {
  __typename: 'JiraIssueDescriptionContentAttributes';
  layout?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type JiraIssueDescriptionContentValue = {
  __typename: 'JiraIssueDescriptionContentValue';
  attrs?: Maybe<JiraIssueDescriptionContentValueAttributes>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type JiraIssueDescriptionContentValueAttributes = {
  __typename: 'JiraIssueDescriptionContentValueAttributes';
  collection?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  occurrenceKey?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type JiraIssueFields = {
  __typename: 'JiraIssueFields';
  description?: Maybe<JiraIssueDescription>;
  issuetype?: Maybe<JiraIssueType>;
  summary?: Maybe<Scalars['String']>;
};

export type JiraIssueType = {
  __typename: 'JiraIssueType';
  avatarId: Scalars['Int'];
  description: Scalars['String'];
  entityId: Scalars['String'];
  iconUrl: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  self: Scalars['String'];
  subtask: Scalars['Boolean'];
};

export type JiraRelease = {
  __typename: 'JiraRelease';
  archived: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  overdue?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['Int'];
  releaseDate?: Maybe<Scalars['String']>;
  released: Scalars['Boolean'];
  self: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  userReleaseDate?: Maybe<Scalars['String']>;
  userStartDate?: Maybe<Scalars['String']>;
};

export type JiraReleaseConnection = {
  __typename: 'JiraReleaseConnection';
  isLast: Scalars['Boolean'];
  maxResults: Scalars['Int'];
  self: Scalars['String'];
  startAt: Scalars['Int'];
  total: Scalars['Int'];
  values: Array<JiraRelease>;
};

export type JiraReleaseCriteria = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JiraReleaseSortRule>>;
  status?: InputMaybe<Array<JiraReleaseStatusEnum>>;
};

export enum JiraReleaseSortEnum {
  Description = 'Description',
  Name = 'Name',
  ReleaseDate = 'ReleaseDate',
  Sequence = 'Sequence',
  StartDate = 'StartDate'
}

export type JiraReleaseSortRule = {
  direction: OrderDirection;
  rule: JiraReleaseSortEnum;
};

export enum JiraReleaseStatusEnum {
  archived = 'archived',
  released = 'released',
  unreleased = 'unreleased'
}

export enum JoinType {
  Inner = 'Inner',
  Left = 'Left',
  Right = 'Right'
}

export type JwtToken = {
  __typename: 'JwtToken';
  expireDate: Scalars['String'];
  token: Scalars['String'];
};

export type LanguageConnection = SearchableConnection & {
  __typename: 'LanguageConnection';
  hash: Scalars['String'];
  nodes: Array<ValueLanguage>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type LanguageCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  onlyCoreCodes?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<LanguageCriteriaOrder>>;
  personIds?: InputMaybe<Array<Scalars['Int']>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum LanguageCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type LinkMatchCandidateData = {
  __typename: 'LinkMatchCandidateData';
  apurebaseId: Scalars['Int'];
  role: Scalars['String'];
  specialty: Scalars['String'];
};

export type List = Model & {
  __typename: 'List';
  affiliations: EntityTypeConnection;
  amountAffiliated: Scalars['Int'];
  availableCriteriaGroups: CriteriaGroupConnection;
  /** Returns a list of all available formats for entityType that this list has */
  availableFormats: ListFormatConnection;
  countries: ListCountryConnection;
  createdUser?: Maybe<User>;
  createdUserId?: Maybe<Scalars['ID']>;
  /** Returns a collection of rules for this dynamic list. If this isn't a dynamic list it'll return null */
  criterias?: Maybe<DynamicCriteriaListConnection>;
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  editAccess: Scalars['Boolean'];
  entityType?: Maybe<Entity>;
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isFavoriteList: Scalars['Boolean'];
  isPinned: Scalars['Boolean'];
  isShared: Scalars['Boolean'];
  listType: ListType;
  listTypeId: Scalars['ID'];
  /** @deprecated Please use the new affiliations property */
  persons: PersonConnection;
  /** @deprecated Please use the new affiliations property */
  sites: SiteConnection;
  /** Returns the sort number for the current logged in user for this list */
  sort?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  typeEnum: ListTypeEnum;
  ut: Scalars['DateTime'];
};


export type ListaffiliationsArgs = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<Scalars['String']>>;
};


export type ListavailableCriteriaGroupsArgs = {
  criteria?: InputMaybe<CriteriaGroupCriteria>;
};


export type ListavailableFormatsArgs = {
  criteria?: InputMaybe<ListFormatCriteria>;
};


export type ListcountriesArgs = {
  criteria?: InputMaybe<ListCountryCriteria>;
};


export type ListpersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type ListsitesArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};

export type ListConnection = SearchableConnection & {
  __typename: 'ListConnection';
  hash: Scalars['String'];
  nodes: Array<List>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ListCountry = Model & {
  __typename: 'ListCountry';
  addedByUser?: Maybe<User>;
  addedByUserId?: Maybe<Scalars['ID']>;
  country: ValueCountry;
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  list: List;
  listId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ListCountryConnection = SearchableConnection & {
  __typename: 'ListCountryConnection';
  hash: Scalars['String'];
  nodes: Array<ListCountry>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ListCountryCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  listId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ListCountryCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ListCountryCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ListCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  excludedIds?: InputMaybe<Array<Scalars['ID']>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isActive?: InputMaybe<ActiveEnum>;
  isFavoriteByUserId?: InputMaybe<Scalars['ID']>;
  isFavoriteByUserIdOrPinned?: InputMaybe<Scalars['ID']>;
  isShared?: InputMaybe<Scalars['Boolean']>;
  isSharedOrByUserId?: InputMaybe<Scalars['ID']>;
  listType?: InputMaybe<ListTypeEnum>;
  listTypeId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<ListCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum ListCriteriaOrder {
  CREATED_BY_USER_ASC = 'CREATED_BY_USER_ASC',
  CREATED_BY_USER_DESC = 'CREATED_BY_USER_DESC',
  CT_ASC = 'CT_ASC',
  CT_DESC = 'CT_DESC',
  ENTITY_TYPE_ASC = 'ENTITY_TYPE_ASC',
  ENTITY_TYPE_DESC = 'ENTITY_TYPE_DESC',
  ENTITY_TYPE_ID_ASC = 'ENTITY_TYPE_ID_ASC',
  ENTITY_TYPE_ID_DESC = 'ENTITY_TYPE_ID_DESC',
  HEADING_ASC = 'HEADING_ASC',
  HEADING_DESC = 'HEADING_DESC',
  LIST_TYPE_ASC = 'LIST_TYPE_ASC',
  LIST_TYPE_DESC = 'LIST_TYPE_DESC',
  PINNED_SORTING_ASC = 'PINNED_SORTING_ASC',
  PINNED_SORTING_DESC = 'PINNED_SORTING_DESC',
  USER_FAVORITE_SORTING_ASC = 'USER_FAVORITE_SORTING_ASC',
  USER_FAVORITE_SORTING_DESC = 'USER_FAVORITE_SORTING_DESC'
}

export type ListFormat = Model & {
  __typename: 'ListFormat';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  entityTypeId: Scalars['ID'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ListFormatConnection = {
  __typename: 'ListFormatConnection';
  hash: Scalars['String'];
  nodes: Array<ListFormat>;
  totalCount: Scalars['Int'];
};

export type ListFormatCriteria = {
  active?: InputMaybe<Scalars['Boolean']>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ListFormatCriteriaOrder>>;
};

export enum ListFormatCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ListFormatField = Model & {
  __typename: 'ListFormatField';
  ct: Scalars['DateTime'];
  header: Scalars['String'];
  id: Scalars['ID'];
  listFormatId: Scalars['ID'];
  path: Scalars['String'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ListFormatFieldConnection = {
  __typename: 'ListFormatFieldConnection';
  hash: Scalars['String'];
  nodes: Array<ListFormatField>;
  totalCount: Scalars['Int'];
};

export type ListFormatFieldCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  listFormatId?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Array<ListFormatFieldCriteriaOrder>>;
};

export enum ListFormatFieldCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ListInput = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  description?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  isActive: Scalars['Boolean'];
  isShared: Scalars['Boolean'];
  title: Scalars['String'];
  type: ListTypeEnum;
};

export type ListPin = Model & {
  __typename: 'ListPin';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  list: List;
  listId: Scalars['ID'];
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ListPinConnection = {
  __typename: 'ListPinConnection';
  hash: Scalars['String'];
  nodes: Array<ListPin>;
  totalCount: Scalars['Int'];
};

export enum ListPinCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ListStatusEnum {
  Active = 'Active',
  Disabled = 'Disabled'
}

export type ListType = Model & {
  __typename: 'ListType';
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  status: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ListTypeConnection = SearchableConnection & {
  __typename: 'ListTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ListType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ListTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  listFormatId?: InputMaybe<Scalars['Int']>;
  listId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ListTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ListTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ListTypeEnum {
  DYN = 'DYN',
  STAT = 'STAT'
}

export type ListUserFav = Model & {
  __typename: 'ListUserFav';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  list: List;
  listId: Scalars['ID'];
  sort: Scalars['Int'];
  status: Scalars['Int'];
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ListUserFavConnection = {
  __typename: 'ListUserFavConnection';
  hash: Scalars['String'];
  nodes: Array<ListUserFav>;
  totalCount: Scalars['Int'];
};

export enum ListUserFavCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Localization = {
  __typename: 'Localization';
  ct: Scalars['DateTime'];
  id: LocalizationId;
  resource: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type LocalizationConnection = {
  __typename: 'LocalizationConnection';
  hash: Scalars['String'];
  nodes: Array<Localization>;
  totalCount: Scalars['Int'];
};

export type LocalizationCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  languageCode?: InputMaybe<Scalars['String']>;
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<LocalizationCriteriaOrder>>;
  search?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum LocalizationCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type LocalizationId = {
  __typename: 'LocalizationId';
  code: Scalars['String'];
  languageCode: Scalars['String'];
};

export type ManualExternalUserIdMapping = ImportManualStageType & {
  __typename: 'ManualExternalUserIdMapping';
  externalIdTypeCode: Scalars['String'];
  externalIds: Array<Scalars['String']>;
  lineId: Scalars['ID'];
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type MappingJoinSupport = {
  __typename: 'MappingJoinSupport';
  code: Scalars['String'];
  dataValue: Scalars['Boolean'];
  entityType: EntityTypeEnum;
  hasGlobalSupport: Scalars['Boolean'];
  headingKey: Scalars['String'];
  isHeadingKey: Scalars['Boolean'];
  mapper: TableMapper;
  mode: IsMappingJoinBasicEnum;
  paths: Array<VirtualColumnPath>;
  /** This is a simplified way for the frontend to get the service to use for this specific join. */
  service?: Maybe<Scalars['String']>;
  supportedCriteriaTypes: Array<Scalars['String']>;
};

export enum MarketAccessCountryCriteriaOrder {
  COUNTRY_CODE_ASC = 'COUNTRY_CODE_ASC',
  COUNTRY_CODE_DESC = 'COUNTRY_CODE_DESC'
}

export type MarketAccessSite = Model & {
  __typename: 'MarketAccessSite';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  marketAccessCountryCode: Scalars['String'];
  marketAccessSiteValueCode: Scalars['String'];
  marketAccessValue?: Maybe<ValueSiteMarketAccess>;
  originSourceCode: Scalars['String'];
  siteId: Scalars['ID'];
  status: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type MarketAccessSiteConnection = SearchableConnection & {
  __typename: 'MarketAccessSiteConnection';
  hash: Scalars['String'];
  nodes: Array<MarketAccessSite>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type MarketAccessSiteCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<MarketAccessSiteCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  siteIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum MarketAccessSiteCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type MarketAccessSitePerson = Model & {
  __typename: 'MarketAccessSitePerson';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  marketAccessCountryCode: Scalars['String'];
  marketAccessSitePersonValueCode: Scalars['String'];
  marketAccessValue?: Maybe<ValueSitePersonMarketAccess>;
  originSourceCode: Scalars['String'];
  sitePersonId: Scalars['ID'];
  status: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type MarketAccessSitePersonConnection = SearchableConnection & {
  __typename: 'MarketAccessSitePersonConnection';
  hash: Scalars['String'];
  nodes: Array<MarketAccessSitePerson>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type MarketAccessSitePersonCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<MarketAccessSitePersonCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
  sitePersonIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum MarketAccessSitePersonCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum MassAssignFieldAction {
  AddNewValue = 'AddNewValue',
  AddSelectedToCurrentState = 'AddSelectedToCurrentState',
  AppendTextToField = 'AppendTextToField',
  BlankOutField = 'BlankOutField',
  PrependTextToField = 'PrependTextToField',
  RemoveSelectedFromCurrentState = 'RemoveSelectedFromCurrentState',
  ReplaceTextInField = 'ReplaceTextInField',
  SetValueToSelected = 'SetValueToSelected'
}

export type MassAssignFieldInfo = {
  __typename: 'MassAssignFieldInfo';
  accessRules?: Maybe<CustomFieldPermissionOption>;
  actionName: Scalars['String'];
  entityTypes: Array<EntityTypeEnum>;
  fieldType: MassAssignFieldTypeEnum;
  heading: Scalars['String'];
  isHeadingKey: Scalars['Boolean'];
};

export type MassAssignFieldInput = {
  action: MassAssignFieldAction;
  entityType: EntityTypeEnum;
  values: Array<Scalars['String']>;
};

export type MassAssignFieldOption = {
  __typename: 'MassAssignFieldOption';
  heading: Scalars['String'];
  isHeadingKey: Scalars['Boolean'];
  key: Scalars['String'];
};

export enum MassAssignFieldTypeEnum {
  Date = 'Date',
  EntitySearch = 'EntitySearch',
  Select = 'Select',
  SingleSelect = 'SingleSelect',
  Switch = 'Switch',
  Tag = 'Tag',
  Text = 'Text'
}

export type MassFieldAssignPreviewInfo = {
  __typename: 'MassFieldAssignPreviewInfo';
  addCount?: Maybe<Scalars['Int']>;
  addLabel?: Maybe<Scalars['String']>;
  blankOutLabel?: Maybe<Scalars['String']>;
  blankOutSize?: Maybe<Scalars['Int']>;
  skipCount?: Maybe<Scalars['Int']>;
  skipLabel?: Maybe<Scalars['String']>;
  tbd: Scalars['String'];
  updatedCount?: Maybe<Scalars['Int']>;
  updatedLabel?: Maybe<Scalars['String']>;
};

export type MatchCandidate = {
  __typename: 'MatchCandidate';
  apurebaseId: Scalars['String'];
  fields: Array<MatchCandidateValue>;
  /** Returns true if this record is in the local database */
  inLocal: Scalars['Boolean'];
  inLocalDb: Scalars['Boolean'];
  link: LinkMatchCandidateData;
  person: PersonMatchCandidateData;
  score: Scalars['Int'];
  site: SiteMatchCandidateData;
};

export type MatchCandidateValue = {
  __typename: 'MatchCandidateValue';
  fieldName: Scalars['String'];
  fieldNameKey: Scalars['String'];
  value: Scalars['String'];
};

export type MatchCriteria = {
  limit?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Int']>;
};

export type MenuGroup = {
  __typename: 'MenuGroup';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  enum: MenuGroupEnum;
  headingKey: Scalars['String'];
  isActive: Scalars['Boolean'];
  menuItems: MenuItemConnection;
  sort: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type MenuGroupConnection = SearchableConnection & {
  __typename: 'MenuGroupConnection';
  hash: Scalars['String'];
  nodes: Array<MenuGroup>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type MenuGroupCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  id?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Array<MenuGroupCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum MenuGroupCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum MenuGroupEnum {
  ADMIN = 'ADMIN',
  FUNC = 'FUNC',
  MENU = 'MENU'
}

export type MenuItem = {
  __typename: 'MenuItem';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  headingKey: Scalars['String'];
  iconKey?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  menuGroup: MenuGroup;
  menuGroupCode: Scalars['String'];
  sort: Scalars['Int'];
  tooltipKey?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type MenuItemConnection = SearchableConnection & {
  __typename: 'MenuItemConnection';
  hash: Scalars['String'];
  nodes: Array<MenuItem>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type MenuItemCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  group?: InputMaybe<MenuGroupEnum>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<MenuItemCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum MenuItemCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type Model = {
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export enum ModuleEnumType {
  BRICK = 'BRICK',
  CONTROL_INSTANCES = 'CONTROL_INSTANCES',
  GDPR = 'GDPR',
  IMPORT = 'IMPORT',
  LIST = 'LIST',
  MDM = 'MDM',
  OWN_RECORDS = 'OWN_RECORDS',
  PRODSAMPLES = 'PRODSAMPLES',
  PROJECT = 'PROJECT',
  REPORT = 'REPORT',
  SEGMENTATION = 'SEGMENTATION'
}

/** Mutation object */
export type Mutation = {
  __typename: 'Mutation';
  RemoveDashboard: Dashboard;
  addActivitiesToProject: Project;
  addActivityToProject: Project;
  addActivityTypeToReport: ReportSettingsActivityType;
  addDashboardItem: DashboardItemConfiguration;
  addDynamicRulesToList: Array<DynamicCriteriaList>;
  addExternalIdTypeRole: ExternalIdTypeRole;
  addPersonsToActivity: Activity;
  addPersonsToProjects: Project;
  addProductBrandToActivity: Activity;
  addProductSegmentation: PersonProductSegmentation;
  addProductToActivity: Activity;
  addProductToProject: ProjectProduct;
  addReportSettingFieldDay: ReportSettingFieldDay;
  addRoleToCustomField: CustomFieldRole;
  /** Adds a single site to a list */
  addSiteToStaticList: List;
  /** Adds a single site to a list */
  addSitesToList: List;
  addSitesToStaticList: List;
  addToStaticList: List;
  assignFieldToGroup: EntityGridItemField;
  bulkCreatePersProject: Project;
  bulkPersProject: Project;
  cherryPick: Array<ImfModel>;
  completeActivity: Activity;
  completeProject: Project;
  createActivity: Activity;
  createActivityDelivery: PersonActivityProduct;
  createCommune: DataValue;
  createConsentOnContactValue: Scalars['Boolean'];
  createContactCategory: ContactCategory;
  createContactValue: ContactValue;
  createCustomField: CustomField;
  createDeleteDcr: DcrCreateResponse;
  createEntityGridItemConfiguration: EntityGridItemConfiguration;
  createExternalIdType: ExternalIdType;
  /** Create a new list */
  createList: List;
  createMergeRequest: EntityMerge;
  createNewDashboard: Dashboard;
  createNewProject: Project;
  createNewSalesCycle: SalesCycleSetup;
  createNote: Note;
  createPerson: PersonCreated;
  createProduct: Product;
  createProjectNotes?: Maybe<Project>;
  createSite: SiteCreated;
  createSitePerson: SitePersonCreated;
  createStaticList: List;
  createTerritory: Territory;
  createUser: User;
  deactivateEntityGridItemConfiguration: Scalars['Boolean'];
  /** Deactivates list */
  deactivateList: List;
  deactivateProject?: Maybe<Project>;
  defaultSearch: SearchNode;
  deleteActivitiesFromProject: Project;
  deleteActivity: Activity;
  deleteActivityFromProject: Project;
  deleteNote: Scalars['Boolean'];
  deleteSavedSearchCriteria: Scalars['Boolean'];
  deleteSearch: Scalars['Boolean'];
  deployNewSandbox: PureAdvanceCustomerSandbox;
  destroySandbox: PureAdvanceCustomerSandbox;
  /** Generates a excel file and provides a link to download the excel file */
  downloadList: Resource;
  executeMassAssign: Scalars['Boolean'];
  generateGdprInformation: Resource;
  generateReport: Resource;
  impersonateUser: JwtToken;
  inactivateHcpAndActivityAffiliations: Person;
  inactivateTerritory: Territory;
  insertEntityValidationLog: EntityValidationLog;
  insertMassEntityValidationLog: Scalars['Boolean'];
  linkEntityGridFieldToCustomField: CustomFieldGridConfiguration;
  manageGroupDcrMutation: DcrGroup;
  /** This will inactivate the current link and transfer all data over to the new link */
  newLinkFromExisting?: Maybe<SitePerson>;
  performAutomaticMerges: Array<VirtualEntityMergeInfo>;
  performMerge: VirtualEntityMergeInfo;
  preferEnglishLov: UserPreferEnglishLov;
  removeActivityDeliveries: Array<PersonActivityProduct>;
  removeActivityDelivery: PersonActivityProduct;
  removeActivityTypeFromReport: ReportSettingsActivityType;
  removeCustomLinkValues: Scalars['Boolean'];
  removeDashboardItem: DashboardItemConfiguration;
  removeDynamicRulesFromList: Scalars['Int'];
  removeEntityGridItem: Scalars['Boolean'];
  removeExternalId: ExternalId;
  removeExternalIdTypeRole: Scalars['Boolean'];
  removeFromStaticList: List;
  removeHcpSiteRelation: Scalars['Boolean'];
  removePersonsFromActivity: Activity;
  removePersonsFromProject: Project;
  removeProductBrandFromActivity: Activity;
  removeProductFromProject: ProjectProduct;
  removeProductSegmentation: Scalars['Boolean'];
  removeProductToActivity: Activity;
  removeReportSettingFieldDay: Scalars['Boolean'];
  removeResponsibleArea: Scalars['Boolean'];
  removeRoleFromCustomField: Scalars['Boolean'];
  removeSegmentationCode: Scalars['Boolean'];
  removeSite: Scalars['Boolean'];
  removeSiteSegmentation: Site;
  replacePersonInActivity: Activity;
  resetSandboxDb: PureAdvanceCustomerSandbox;
  runDataLoader: Scalars['Boolean'];
  runDcrSynchronization: Scalars['Boolean'];
  saveImportLineProcess: ImportProcessLine;
  /** This saves custom data to a specific imported project that can be shared between lines and/or different processes */
  saveImportProcessorData: ImportProcessorData;
  saveNewSimpleCriteria: CriteriaSimpleSaved;
  saveSearch: Search;
  setBricksForTerritory: Territory;
  setConsentInstruction: ConsentInstruction;
  setConsentInstructions: Array<ConsentInstruction>;
  setConsentValue: VirtualConsentValue;
  setContactPrimaryState: Scalars['Boolean'];
  setCountriesForCustomFieldOption: CustomFieldOption;
  setCreateFieldForEntity: Array<CreateEntityField>;
  setCustomFieldsToActivityType: ActivityType;
  setCustomLinkValues: Array<CustomLinkValue>;
  setDynamicRulesToList: Array<DynamicCriteriaList>;
  setExternalId?: Maybe<ExternalId>;
  setExternalIdTypeRoleRules: ExternalIdTypeRole;
  /** This marks the provided [linkId] as non-primary. */
  setNonPrimaryLink: Array<SitePerson>;
  setPersonActiveStatus: Person;
  /** @deprecated We should have a more generic way of handling Addresses! */
  setPersonSingleAddress: AddressAffiliation;
  setPrimaryLink: Array<SitePerson>;
  setPureAdvanceCustomerInstanceSetting: PureAdvanceCustomer;
  setReportSettingDailyCallTarget: ReportSettingDailyCallTarget;
  setReportSettingIsHalfDay: Scalars['Boolean'];
  setSiteActiveStatus: Site;
  setSiteIsUnplaced: Site;
  setSitePersonActiveStatus: SitePerson;
  setSiteResponsibleUser?: Maybe<SiteResponsible>;
  setTerritories: Array<Brick>;
  setTerritory: Brick;
  skipImportLineProcess: ImportProcessLine;
  startImportProject: ImportProject;
  synchronizeApureBaseId: ImfModel;
  synchronizePostalCodes: Scalars['Boolean'];
  /** Toggles favorite lists pr user */
  toggleFavoriteList?: Maybe<ListUserFav>;
  toggleSearchShared: Search;
  updateActivity: Activity;
  updateActivityFieldDaysInMonth: ActivityFieldDays;
  updateActivityLocation: Activity;
  updateActivityResponsibleUsers: Activity;
  updateActivityType: ActivityType;
  updateAddress: Address;
  updateCommune: DataValue;
  updateContactCategory: ContactCategory;
  updateCustomField: CustomField;
  /** This is a special logic for updating/setting the custom link values. Should only be used for 'checkableTag' setting */
  updateCustomFieldCheckableTag: CustomField;
  updateCustomFieldRoleRules: CustomFieldRole;
  updateCustomValue: CustomValue;
  updateDashboardEntityPieSettings: Scalars['Boolean'];
  updateDashboardItems: Dashboard;
  updateDefaultCriterias: Array<DefaultCriteria>;
  updateDefaultTableColumns: DefaultTableColumnConnection;
  /** Runs through the criterias defined for this list and updates the list */
  updateDynamicList: List;
  updateEntityGrid: Scalars['Boolean'];
  updateEntityGridItemCardFields: EntityGridItemCardFieldConnection;
  updateEntityGridItemConfiguration: EntityGridItemConfiguration;
  updateEntityGridItemFieldSorting: Array<EntityGridItemField>;
  updateEntityGridItemRelationFieldSwitchStatus: EntityGridItemRelationField;
  updateEntityGridItemRelationFieldUpdateSorting: Array<EntityGridItemRelationField>;
  updateFavSort?: Maybe<Scalars['Boolean']>;
  updateFavoriteList?: Maybe<ListUserFav>;
  updateImportedFileSettings: ImportFile;
  updateInstanceSetting: InstanceSetting;
  /** Update fields on a list */
  updateList: List;
  updateListCountries?: Maybe<List>;
  updateMailToPrivate: Person;
  updateMenuItemGroup: MenuItem;
  updateMenuItemStatus: MenuItem;
  updateMenuItemsSorting: Array<MenuItem>;
  updateNote: Note;
  updateNumberOfPatients: SitePerson;
  /** When no addressAffiliationId is provided it will go ahead and directly create it instead of updating an existing one */
  updateOrCreateAddress: AddressAffiliation;
  updatePersonCountry: Person;
  updatePersonDateOfBirth: Person;
  updatePersonEducations: Array<PersonEducation>;
  updatePersonExamYear: Person;
  updatePersonFilterCode: Array<PersonFilterCode>;
  updatePersonFirstAndLastName: Person;
  updatePersonFirstName: Person;
  updatePersonLanguage: Array<PersonLanguage>;
  updatePersonLastName: Person;
  updatePersonMiddleName: Person;
  updatePersonSex: Person;
  updatePersonTherapeuticFocuses: Array<PersonTherapeuticFocus>;
  updatePersonTitle: Person;
  updatePersonType: Person;
  updatePinList?: Maybe<ListPin>;
  updatePosition: SitePerson;
  updateProduct: Product;
  updateProjectDate: Project;
  updateProjectLocation: Project;
  updateProjectNotes?: Maybe<Project>;
  updateProjectResUsers: Project;
  updateProjectStatus: Project;
  updateProjectTitle: Project;
  updateProjectType: Project;
  updatePureAdvanceCustomerModule: PureAdvanceCustomer;
  updateReportSettingFieldDay: ReportSettingFieldDay;
  updateRolePermission: VirtualRolePermission;
  updateSaleCycle: SalesCycleSetup;
  updateSimpleCriteria: CriteriaSimpleSaved;
  updateSiteChain: Array<Maybe<SiteChain>>;
  updateSiteFilterCode: Array<SiteFilterCode>;
  updateSiteMailingNamePrefix: Site;
  updateSiteName: Site;
  updateSiteName2: Site;
  updateSiteNumberOfBeds: Site;
  updateSiteNumberOfChairs: Site;
  updateSiteParentId: Site;
  updateSitePersonTherapeuticFocuses: Array<SitePersonTherapeuticFocus>;
  updateSitePersonWorkingSpecialties: Array<SitePersonWorkingSpecialty>;
  updateSiteSectorType: Site;
  updateSiteSpecialties: Array<SiteSpecialty>;
  updateSiteTypeCode: Site;
  updateSiteWebpage: Site;
  updateTerritoryHeading: Territory;
  updateTerritoryResponsibleUser: Territory;
  updateTherapeuticFocusLabel: DataValue;
  updateUser: User;
  updateUserResponsibility: Person;
  updateUserTableColumns: Array<UserTableColumn>;
  upsertContactValues: Array<ContactValue>;
  upsertPersonSegmentationCode: PersonSegmentationCode;
  upsertProject: Project;
  upsertResponsibleArea: ResponsibleArea;
  upsertSiteSegmentationCode: SiteSegmentationCode;
};


/** Mutation object */
export type MutationRemoveDashboardArgs = {
  dashboardId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddActivitiesToProjectArgs = {
  activivityIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddActivityToProjectArgs = {
  activivityId: Scalars['Int'];
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddActivityTypeToReportArgs = {
  activityTypeCode: Scalars['String'];
  country: Scalars['CountryCode'];
  reportCode: Scalars['String'];
};


/** Mutation object */
export type MutationaddDashboardItemArgs = {
  dashboardId: Scalars['Int'];
  dashboardItemCode: Scalars['String'];
};


/** Mutation object */
export type MutationaddDynamicRulesToListArgs = {
  input: DynamicRulesInput;
};


/** Mutation object */
export type MutationaddExternalIdTypeRoleArgs = {
  externalIdTypeCode: Scalars['String'];
  roleId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddPersonsToActivityArgs = {
  activityId: Scalars['Int'];
  personId?: InputMaybe<Scalars['Int']>;
  selection?: InputMaybe<SelectionCriteriaInput>;
};


/** Mutation object */
export type MutationaddPersonsToProjectsArgs = {
  personIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddProductBrandToActivityArgs = {
  activityId: Scalars['Int'];
  productBrandId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddProductSegmentationArgs = {
  personId: Scalars['Int'];
  productId: Scalars['Int'];
  segmentationCodeId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddProductToActivityArgs = {
  activityId: Scalars['ID'];
  productId: Scalars['ID'];
};


/** Mutation object */
export type MutationaddProductToProjectArgs = {
  productId: Scalars['Int'];
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddReportSettingFieldDayArgs = {
  activityTypeCode: Scalars['String'];
  amountForOne: Scalars['Int'];
  reportCode: Scalars['String'];
};


/** Mutation object */
export type MutationaddRoleToCustomFieldArgs = {
  customFieldCode: Scalars['String'];
  roleId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddSiteToStaticListArgs = {
  id: Scalars['Int'];
  siteIdList: Scalars['Int'];
};


/** Mutation object */
export type MutationaddSitesToListArgs = {
  id: Scalars['Int'];
  siteIds: Array<Scalars['Int']>;
};


/** Mutation object */
export type MutationaddSitesToStaticListArgs = {
  id: Array<Scalars['Int']>;
  listId: Scalars['Int'];
};


/** Mutation object */
export type MutationaddToStaticListArgs = {
  listId: Scalars['Int'];
  selection: SelectionCriteriaInput;
};


/** Mutation object */
export type MutationassignFieldToGroupArgs = {
  fieldType: EntityGridItemFieldTypeEnum;
  groupId: Scalars['Int'];
};


/** Mutation object */
export type MutationbulkCreatePersProjectArgs = {
  persProjInput: PersonProjectInput;
};


/** Mutation object */
export type MutationbulkPersProjectArgs = {
  input: BulkProjectInput;
};


/** Mutation object */
export type MutationcherryPickArgs = {
  apurebaseIds: Array<Scalars['Int']>;
  customerCode?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationcompleteActivityArgs = {
  activityId: Scalars['Int'];
};


/** Mutation object */
export type MutationcompleteProjectArgs = {
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationcreateActivityArgs = {
  input: CreateActivityInput;
};


/** Mutation object */
export type MutationcreateActivityDeliveryArgs = {
  input: PersonActivityProductInput;
};


/** Mutation object */
export type MutationcreateCommuneArgs = {
  input: CommuneInput;
};


/** Mutation object */
export type MutationcreateConsentOnContactValueArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationcreateContactCategoryArgs = {
  input: CreateContactCategoryInput;
};


/** Mutation object */
export type MutationcreateContactValueArgs = {
  categoryCode: Scalars['String'];
  entityAffiliationId: Scalars['Int'];
  sort?: InputMaybe<Scalars['Int']>;
  value: Scalars['String'];
};


/** Mutation object */
export type MutationcreateCustomFieldArgs = {
  input: CreateCustomFieldInput;
};


/** Mutation object */
export type MutationcreateDeleteDcrArgs = {
  id: Scalars['Int'];
  notes?: InputMaybe<Scalars['String']>;
  type: EntityTypeEnum;
};


/** Mutation object */
export type MutationcreateEntityGridItemConfigurationArgs = {
  description?: InputMaybe<Scalars['String']>;
  entityTabCode: Scalars['String'];
  heading?: InputMaybe<Scalars['String']>;
  itemType: EntityGridItemTypeEnum;
};


/** Mutation object */
export type MutationcreateExternalIdTypeArgs = {
  input: CreateExternalIdTypeInput;
};


/** Mutation object */
export type MutationcreateListArgs = {
  input: ListInput;
};


/** Mutation object */
export type MutationcreateMergeRequestArgs = {
  entityType: EntityTypeEnum;
  loserId: Scalars['ID'];
  winnerId: Scalars['ID'];
};


/** Mutation object */
export type MutationcreateNewDashboardArgs = {
  title: Scalars['String'];
};


/** Mutation object */
export type MutationcreateNewProjectArgs = {
  end: Scalars['DateTime'];
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  start: Scalars['DateTime'];
  title: Scalars['String'];
  typeId: Scalars['Int'];
};


/** Mutation object */
export type MutationcreateNewSalesCycleArgs = {
  country: Scalars['CountryCode'];
  cycleAmount: Scalars['Int'];
  cycleStartMonth: Scalars['Month'];
  segmentationValues: Array<SegmentationSaleCycleInput>;
  year: Scalars['Int'];
};


/** Mutation object */
export type MutationcreateNoteArgs = {
  entityAffiliationId: Scalars['Int'];
  entityType: EntityTypeEnum;
  private: Scalars['Boolean'];
  text: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationcreatePersonArgs = {
  input: PersonInput;
};


/** Mutation object */
export type MutationcreateProductArgs = {
  product: ProductInput;
};


/** Mutation object */
export type MutationcreateProjectNotesArgs = {
  id: Scalars['Int'];
  note: Scalars['String'];
  title: Scalars['String'];
};


/** Mutation object */
export type MutationcreateSiteArgs = {
  input: SiteInput;
};


/** Mutation object */
export type MutationcreateSitePersonArgs = {
  input: AddWorkplaceInput;
};


/** Mutation object */
export type MutationcreateStaticListArgs = {
  description?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  isShared?: InputMaybe<Scalars['Boolean']>;
  selection: SelectionCriteriaInput;
  title: Scalars['String'];
};


/** Mutation object */
export type MutationcreateTerritoryArgs = {
  code: Scalars['String'];
  country: Scalars['CountryCode'];
  heading: Scalars['String'];
};


/** Mutation object */
export type MutationcreateUserArgs = {
  input: CreateUserInputdata;
};


/** Mutation object */
export type MutationdeactivateEntityGridItemConfigurationArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationdeactivateListArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationdeactivateProjectArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationdefaultSearchArgs = {
  searchId: Scalars['ID'];
};


/** Mutation object */
export type MutationdeleteActivitiesFromProjectArgs = {
  activivityIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationdeleteActivityArgs = {
  activityId: Scalars['Int'];
};


/** Mutation object */
export type MutationdeleteActivityFromProjectArgs = {
  activivityId: Scalars['Int'];
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationdeleteNoteArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationdeleteSavedSearchCriteriaArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationdeleteSearchArgs = {
  searchId: Scalars['ID'];
};


/** Mutation object */
export type MutationdeployNewSandboxArgs = {
  heading: Scalars['String'];
};


/** Mutation object */
export type MutationdestroySandboxArgs = {
  sandboxId: Scalars['Int'];
};


/** Mutation object */
export type MutationdownloadListArgs = {
  listFormatId: Scalars['Int'];
  listId: Scalars['Int'];
};


/** Mutation object */
export type MutationexecuteMassAssignArgs = {
  actionName: Scalars['String'];
  input: MassAssignFieldInput;
  selection: SelectionCriteriaInput;
};


/** Mutation object */
export type MutationgenerateGdprInformationArgs = {
  hcpId: Scalars['Int'];
};


/** Mutation object */
export type MutationgenerateReportArgs = {
  input: ReportInput;
};


/** Mutation object */
export type MutationimpersonateUserArgs = {
  userId: Scalars['Int'];
};


/** Mutation object */
export type MutationinactivateHcpAndActivityAffiliationsArgs = {
  persId: Scalars['Int'];
  removeAffiliations: Scalars['Boolean'];
};


/** Mutation object */
export type MutationinactivateTerritoryArgs = {
  territoryCode: Scalars['String'];
};


/** Mutation object */
export type MutationinsertEntityValidationLogArgs = {
  affiliationId: Scalars['Int'];
  entityType: EntityTypeEnum;
  validationDate?: InputMaybe<Scalars['DateTime']>;
};


/** Mutation object */
export type MutationinsertMassEntityValidationLogArgs = {
  entityType: EntityTypeEnum;
  ids: Array<Scalars['Int']>;
  validationDate?: InputMaybe<Scalars['DateTime']>;
};


/** Mutation object */
export type MutationlinkEntityGridFieldToCustomFieldArgs = {
  customFieldCode: Scalars['String'];
  fieldId: Scalars['Int'];
};


/** Mutation object */
export type MutationmanageGroupDcrMutationArgs = {
  groupId: Scalars['Int'];
  isMdmEnabled: Scalars['Boolean'];
  maintainRecord: Scalars['Boolean'];
};


/** Mutation object */
export type MutationnewLinkFromExistingArgs = {
  linkId: Scalars['ID'];
  siteId: Scalars['ID'];
};


/** Mutation object */
export type MutationperformAutomaticMergesArgs = {
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationperformMergeArgs = {
  mergeRequestId: Scalars['ID'];
};


/** Mutation object */
export type MutationremoveActivityDeliveriesArgs = {
  deliveryIds: Array<Scalars['Int']>;
};


/** Mutation object */
export type MutationremoveActivityDeliveryArgs = {
  deliveryId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveActivityTypeFromReportArgs = {
  activityTypeCode: Scalars['String'];
  country: Scalars['CountryCode'];
  reportCode: Scalars['String'];
};


/** Mutation object */
export type MutationremoveCustomLinkValuesArgs = {
  customLinkValueIds: Array<Scalars['ID']>;
};


/** Mutation object */
export type MutationremoveDashboardItemArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveEntityGridItemArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveExternalIdArgs = {
  externalIdId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveExternalIdTypeRoleArgs = {
  externalIdTypeRoleId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveFromStaticListArgs = {
  id: Scalars['Int'];
  listId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveHcpSiteRelationArgs = {
  comment?: InputMaybe<Scalars['String']>;
  linkIds: Array<Scalars['Int']>;
  reason: DeleteReasonDcrEnum;
};


/** Mutation object */
export type MutationremovePersonsFromActivityArgs = {
  activityId: Scalars['Int'];
  personSelection: SelectionCriteriaInput;
};


/** Mutation object */
export type MutationremovePersonsFromProjectArgs = {
  personIds: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveProductBrandFromActivityArgs = {
  activityId: Scalars['Int'];
  productBrandId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveProductFromProjectArgs = {
  productId: Scalars['Int'];
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveProductSegmentationArgs = {
  personId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveProductToActivityArgs = {
  activityId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveReportSettingFieldDayArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveResponsibleAreaArgs = {
  areaId: Scalars['Int'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveRoleFromCustomFieldArgs = {
  fieldRoleId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveSegmentationCodeArgs = {
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveSiteArgs = {
  comment: Scalars['String'];
  reason: DeleteReasonDcrEnum;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationremoveSiteSegmentationArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationreplacePersonInActivityArgs = {
  activityId: Scalars['Int'];
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationresetSandboxDbArgs = {
  sandboxId: Scalars['Int'];
};


/** Mutation object */
export type MutationrunDataLoaderArgs = {
  customerCode: Scalars['String'];
};


/** Mutation object */
export type MutationrunDcrSynchronizationArgs = {
  customerCode: Scalars['String'];
};


/** Mutation object */
export type MutationsaveImportLineProcessArgs = {
  input: ImportSaveProcessInput;
};


/** Mutation object */
export type MutationsaveImportProcessorDataArgs = {
  key: Scalars['String'];
  processorId: Scalars['Int'];
  projectId: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationsaveNewSimpleCriteriaArgs = {
  criterias: Array<DynamicCriteriaInput>;
  entityType: EntityTypeEnum;
  name: Scalars['String'];
};


/** Mutation object */
export type MutationsaveSearchArgs = {
  heading: Scalars['String'];
  isShared?: InputMaybe<Scalars['Boolean']>;
  searchInput: SaveSearchInput;
  type: EntityTypeEnum;
};


/** Mutation object */
export type MutationsetBricksForTerritoryArgs = {
  brickCodes: Array<Scalars['String']>;
  territoryCode: Scalars['String'];
};


/** Mutation object */
export type MutationsetConsentInstructionArgs = {
  imfCustomerCode: Scalars['String'];
  optedOut: Scalars['Boolean'];
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetConsentInstructionsArgs = {
  imfCustomerCodes: Array<Scalars['String']>;
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetConsentValueArgs = {
  entityAffiliationId: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  typeCode: Scalars['String'];
};


/** Mutation object */
export type MutationsetContactPrimaryStateArgs = {
  contactValueId: Scalars['Int'];
  entityType: EntityTypeEnum;
  isPrimary: Scalars['Boolean'];
};


/** Mutation object */
export type MutationsetCountriesForCustomFieldOptionArgs = {
  countries: Array<Scalars['CountryCode']>;
  customFieldOptionId: Scalars['ID'];
};


/** Mutation object */
export type MutationsetCreateFieldForEntityArgs = {
  country?: InputMaybe<Scalars['CountryCode']>;
  entityType: EntityTypeEnum;
  fieldKeys: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationsetCustomFieldsToActivityTypeArgs = {
  activityTypeCode: Scalars['String'];
  customFieldCodes: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationsetCustomLinkValuesArgs = {
  customFieldCode: Scalars['String'];
  customValues: Array<UpdateSelectCustomFieldValueForRecord>;
  recordId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetDynamicRulesToListArgs = {
  input: DynamicRulesInput;
};


/** Mutation object */
export type MutationsetExternalIdArgs = {
  input: ExternalIdMutationInput;
};


/** Mutation object */
export type MutationsetExternalIdTypeRoleRulesArgs = {
  allowMutation: Scalars['Boolean'];
  allowRead: Scalars['Boolean'];
  externalIdTypeRoleId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetNonPrimaryLinkArgs = {
  linkId: Scalars['ID'];
  personId: Scalars['ID'];
};


/** Mutation object */
export type MutationsetPersonActiveStatusArgs = {
  isActive: Scalars['Boolean'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetPersonSingleAddressArgs = {
  addressInput: AddressInput;
  addressTypeCode: Scalars['String'];
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetPrimaryLinkArgs = {
  linkId: Scalars['ID'];
  personId: Scalars['ID'];
};


/** Mutation object */
export type MutationsetPureAdvanceCustomerInstanceSettingArgs = {
  customerCode: Scalars['String'];
  setting: InstanceSettingEnum;
  value?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationsetReportSettingDailyCallTargetArgs = {
  amount: Scalars['Int'];
  country: Scalars['CountryCode'];
  reportCode: Scalars['String'];
};


/** Mutation object */
export type MutationsetReportSettingIsHalfDayArgs = {
  isHalfDay: Scalars['Boolean'];
  reportCode: Scalars['String'];
};


/** Mutation object */
export type MutationsetSiteActiveStatusArgs = {
  isActive: Scalars['Boolean'];
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationsetSiteIsUnplacedArgs = {
  isUnplaced: Scalars['Boolean'];
  siteId: Scalars['ID'];
};


/** Mutation object */
export type MutationsetSitePersonActiveStatusArgs = {
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
};


/** Mutation object */
export type MutationsetSiteResponsibleUserArgs = {
  siteId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** Mutation object */
export type MutationsetTerritoriesArgs = {
  brickCodes: Array<Scalars['String']>;
  territoryCode?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationsetTerritoryArgs = {
  brickCode: Scalars['String'];
  territoryCode?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationskipImportLineProcessArgs = {
  input: ImportSkipProcessInput;
};


/** Mutation object */
export type MutationstartImportProjectArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationsynchronizeApureBaseIdArgs = {
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationsynchronizePostalCodesArgs = {
  countries: Array<Scalars['CountryCode']>;
};


/** Mutation object */
export type MutationtoggleFavoriteListArgs = {
  listId: Scalars['Int'];
};


/** Mutation object */
export type MutationtoggleSearchSharedArgs = {
  searchId: Scalars['ID'];
};


/** Mutation object */
export type MutationupdateActivityArgs = {
  input: UpdateActivityInput;
};


/** Mutation object */
export type MutationupdateActivityFieldDaysInMonthArgs = {
  count: Scalars['Int'];
  country: Scalars['CountryCode'];
  month: Scalars['Month'];
  year: Scalars['Year'];
};


/** Mutation object */
export type MutationupdateActivityLocationArgs = {
  input: UpdateActivityInput;
};


/** Mutation object */
export type MutationupdateActivityResponsibleUsersArgs = {
  activityId: Scalars['Int'];
  responsibleUserIds: Array<Scalars['Int']>;
};


/** Mutation object */
export type MutationupdateActivityTypeArgs = {
  input: UpdateActivityTypeInput;
  typeCode: Scalars['String'];
};


/** Mutation object */
export type MutationupdateAddressArgs = {
  addressAffiliationId: Scalars['Int'];
  input: AddressInput;
};


/** Mutation object */
export type MutationupdateCommuneArgs = {
  input: CommuneInput;
};


/** Mutation object */
export type MutationupdateContactCategoryArgs = {
  input: UpdateContactCategoryInput;
};


/** Mutation object */
export type MutationupdateCustomFieldArgs = {
  input: UpdateCustomFieldInput;
};


/** Mutation object */
export type MutationupdateCustomFieldCheckableTagArgs = {
  affiliationId: Scalars['Int'];
  customFieldCode: Scalars['String'];
  status: Scalars['Boolean'];
  valueId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateCustomFieldRoleRulesArgs = {
  allowMutation?: InputMaybe<Scalars['Boolean']>;
  allowRead?: InputMaybe<Scalars['Boolean']>;
  fieldRoleId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateCustomValueArgs = {
  newValue: Scalars['String'];
  valueId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateDashboardEntityPieSettingsArgs = {
  input: DashboardEntityPieUpdateInput;
};


/** Mutation object */
export type MutationupdateDashboardItemsArgs = {
  input: DashboardItemConfigurationInput;
};


/** Mutation object */
export type MutationupdateDefaultCriteriasArgs = {
  criteriaIds: Array<Scalars['Int']>;
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationupdateDefaultTableColumnsArgs = {
  columnKeys: Array<Scalars['String']>;
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationupdateDynamicListArgs = {
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateEntityGridArgs = {
  input: GridInput;
};


/** Mutation object */
export type MutationupdateEntityGridItemCardFieldsArgs = {
  entityGridItemCardFieldType: EntityGridItemCardFieldTypeEnum;
  entityGridItemConfigurationId: Scalars['Int'];
  fields: Array<EntityGridItemCardFieldInput>;
};


/** Mutation object */
export type MutationupdateEntityGridItemConfigurationArgs = {
  description?: InputMaybe<Scalars['String']>;
  heading: Scalars['String'];
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateEntityGridItemFieldSortingArgs = {
  fieldIds: Array<Scalars['Int']>;
  gridItemConfigurationId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateEntityGridItemRelationFieldSwitchStatusArgs = {
  enabled: Scalars['Boolean'];
  entityGridItemConfigurationId: Scalars['Int'];
  fieldKey: Scalars['String'];
};


/** Mutation object */
export type MutationupdateEntityGridItemRelationFieldUpdateSortingArgs = {
  entityGridItemConfigurationId: Scalars['Int'];
  fieldKeys: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateFavSortArgs = {
  input: Array<UserFavInput>;
};


/** Mutation object */
export type MutationupdateFavoriteListArgs = {
  enabled: Scalars['Boolean'];
  listId: Scalars['Int'];
  sort?: InputMaybe<Scalars['Int']>;
};


/** Mutation object */
export type MutationupdateImportedFileSettingsArgs = {
  charset?: InputMaybe<CharsetEnum>;
  delimiter?: InputMaybe<DelimiterEnum>;
  importProjectId: Scalars['ID'];
};


/** Mutation object */
export type MutationupdateInstanceSettingArgs = {
  newValue?: InputMaybe<Scalars['String']>;
  type: InstanceSettingEnum;
};


/** Mutation object */
export type MutationupdateListArgs = {
  input: UpdateListInput;
};


/** Mutation object */
export type MutationupdateListCountriesArgs = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  listId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateMailToPrivateArgs = {
  mailToPrivate: Scalars['Boolean'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateMenuItemGroupArgs = {
  menuGroup: MenuGroupEnum;
  menuItemCode: Scalars['String'];
};


/** Mutation object */
export type MutationupdateMenuItemStatusArgs = {
  isActive: Scalars['Boolean'];
  menuItemCode: Scalars['String'];
};


/** Mutation object */
export type MutationupdateMenuItemsSortingArgs = {
  menuGroup: MenuGroupEnum;
  menuItemCodes: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateNoteArgs = {
  id: Scalars['Int'];
  private: Scalars['Boolean'];
  text: Scalars['String'];
  title: Scalars['String'];
};


/** Mutation object */
export type MutationupdateNumberOfPatientsArgs = {
  id: Scalars['Int'];
  numberOfPatients?: InputMaybe<Scalars['Int']>;
};


/** Mutation object */
export type MutationupdateOrCreateAddressArgs = {
  addressAffiliationId?: InputMaybe<Scalars['Int']>;
  addressInput: AddressInput;
  entityAffiliationId: Scalars['Int'];
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationupdatePersonCountryArgs = {
  country: Scalars['CountryCode'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonDateOfBirthArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonEducationsArgs = {
  educations: Array<Scalars['String']>;
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonExamYearArgs = {
  date?: InputMaybe<Scalars['Year']>;
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonFilterCodeArgs = {
  filterCodeIds: Array<Scalars['Int']>;
  personId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonFirstAndLastNameArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonFirstNameArgs = {
  firstName: Scalars['String'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonLanguageArgs = {
  languageCodes: Array<Scalars['String']>;
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonLastNameArgs = {
  lastName: Scalars['String'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonMiddleNameArgs = {
  middleName: Scalars['String'];
  persId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePersonSexArgs = {
  persId: Scalars['Int'];
  sex?: InputMaybe<GenderEnum>;
};


/** Mutation object */
export type MutationupdatePersonTherapeuticFocusesArgs = {
  personId: Scalars['ID'];
  therapeuticFocusCodes: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdatePersonTitleArgs = {
  persId: Scalars['Int'];
  title: Scalars['String'];
};


/** Mutation object */
export type MutationupdatePersonTypeArgs = {
  persId: Scalars['Int'];
  typeCode?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationupdatePinListArgs = {
  enabled: Scalars['Boolean'];
  listId: Scalars['Int'];
  sort?: InputMaybe<Scalars['Int']>;
};


/** Mutation object */
export type MutationupdatePositionArgs = {
  id: Scalars['Int'];
  positionCode?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateProductArgs = {
  product: ProductInput;
};


/** Mutation object */
export type MutationupdateProjectDateArgs = {
  end: Scalars['DateTime'];
  id: Scalars['Int'];
  start: Scalars['DateTime'];
};


/** Mutation object */
export type MutationupdateProjectLocationArgs = {
  location: Scalars['String'];
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateProjectNotesArgs = {
  id: Scalars['Int'];
  note: Scalars['String'];
};


/** Mutation object */
export type MutationupdateProjectResUsersArgs = {
  ids: Array<Scalars['Int']>;
  projectId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateProjectStatusArgs = {
  projectId: Scalars['Int'];
  status: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateProjectTitleArgs = {
  projectId: Scalars['Int'];
  title: Scalars['String'];
};


/** Mutation object */
export type MutationupdateProjectTypeArgs = {
  projectId: Scalars['Int'];
  type: Scalars['Int'];
};


/** Mutation object */
export type MutationupdatePureAdvanceCustomerModuleArgs = {
  customerCode: Scalars['String'];
  enabled: Scalars['Boolean'];
  module: ModuleEnumType;
};


/** Mutation object */
export type MutationupdateReportSettingFieldDayArgs = {
  amountForOne: Scalars['Int'];
  id: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateRolePermissionArgs = {
  allow: Scalars['Boolean'];
  level: PermissionLevel;
  permission: PermissionEnum;
  roleId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSaleCycleArgs = {
  country: Scalars['CountryCode'];
  cycleAmount: Scalars['Int'];
  cycleStartMonth: Scalars['Month'];
  id: Scalars['Int'];
  segmentationValues: Array<SegmentationSaleCycleInput>;
  year: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSimpleCriteriaArgs = {
  criterias: Array<DynamicCriteriaInput>;
  id: Scalars['Int'];
  name: Scalars['String'];
};


/** Mutation object */
export type MutationupdateSiteChainArgs = {
  chainCode?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSiteFilterCodeArgs = {
  filterCodeIds: Array<Scalars['Int']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSiteMailingNamePrefixArgs = {
  mailingNamePrefix?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSiteNameArgs = {
  siteId: Scalars['Int'];
  title: Scalars['String'];
};


/** Mutation object */
export type MutationupdateSiteName2Args = {
  siteId: Scalars['Int'];
  siteName2: Scalars['String'];
};


/** Mutation object */
export type MutationupdateSiteNumberOfBedsArgs = {
  numberOfBeds?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSiteNumberOfChairsArgs = {
  numberOfChairs?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSiteParentIdArgs = {
  parentId?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateSitePersonTherapeuticFocusesArgs = {
  sitePersonId: Scalars['Int'];
  therapeuticFocusCodes: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateSitePersonWorkingSpecialtiesArgs = {
  linkId: Scalars['Int'];
  workingSpecialtyCodes: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateSiteSectorTypeArgs = {
  siteId: Scalars['Int'];
  siteSectorType?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateSiteSpecialtiesArgs = {
  siteId: Scalars['Int'];
  specialties: Array<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateSiteTypeCodeArgs = {
  siteId: Scalars['Int'];
  typeCode?: InputMaybe<Scalars['String']>;
};


/** Mutation object */
export type MutationupdateSiteWebpageArgs = {
  siteId: Scalars['Int'];
  webpage: Scalars['String'];
};


/** Mutation object */
export type MutationupdateTerritoryHeadingArgs = {
  heading: Scalars['String'];
  territoryCode: Scalars['String'];
};


/** Mutation object */
export type MutationupdateTerritoryResponsibleUserArgs = {
  responsibleUserId?: InputMaybe<Scalars['Int']>;
  territoryCode: Scalars['String'];
};


/** Mutation object */
export type MutationupdateTherapeuticFocusLabelArgs = {
  code: Scalars['String'];
  label: Scalars['String'];
};


/** Mutation object */
export type MutationupdateUserArgs = {
  input: UpdateUserInput;
};


/** Mutation object */
export type MutationupdateUserResponsibilityArgs = {
  areaId: Scalars['Int'];
  persId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** Mutation object */
export type MutationupdateUserTableColumnsArgs = {
  columnKeys: Array<Scalars['String']>;
  entityType: EntityTypeEnum;
};


/** Mutation object */
export type MutationupsertContactValuesArgs = {
  entityAffiliationId: Scalars['Int'];
  entityType: EntityTypeEnum;
  type: ContactTypeEnum;
  values: Array<ContactValueInput>;
};


/** Mutation object */
export type MutationupsertPersonSegmentationCodeArgs = {
  id: Scalars['Int'];
  segmentationId: Scalars['Int'];
};


/** Mutation object */
export type MutationupsertProjectArgs = {
  project: ProjectInput;
};


/** Mutation object */
export type MutationupsertResponsibleAreaArgs = {
  areaId: Scalars['Int'];
  persId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** Mutation object */
export type MutationupsertSiteSegmentationCodeArgs = {
  segmentationCodeId: Scalars['Int'];
  siteId: Scalars['Int'];
};

export type NewContactInput = {
  categoryCode: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type Note = Model & {
  __typename: 'Note';
  affiliationId: Scalars['ID'];
  ct: Scalars['DateTime'];
  entityId: Scalars['ID'];
  id: Scalars['ID'];
  private: Scalars['Boolean'];
  status: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export type NoteConnection = {
  __typename: 'NoteConnection';
  hash: Scalars['String'];
  nodes: Array<Note>;
  totalCount: Scalars['Int'];
};

export type NoteCriteria = {
  affiliationId?: InputMaybe<Scalars['ID']>;
  entityId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<NoteCriteriaOrder>>;
  text?: InputMaybe<Scalars['String']>;
  userIdOrIsShared?: InputMaybe<Scalars['ID']>;
};

export enum NoteCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type OperatorType = Model & {
  __typename: 'OperatorType';
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type OperatorTypeConnection = SearchableConnection & {
  __typename: 'OperatorTypeConnection';
  hash: Scalars['String'];
  nodes: Array<OperatorType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type OperatorTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criteriaTypeId?: InputMaybe<Scalars['ID']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  ordering?: InputMaybe<Array<OperatorTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum OperatorTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum OperatorTypeEnum {
  ByMe = 'ByMe',
  CrossMagic = 'CrossMagic',
  Date = 'Date',
  EqualOrNullWhenFalse = 'EqualOrNullWhenFalse',
  EqualOrNullWhenTrue = 'EqualOrNullWhenTrue',
  Equals = 'Equals',
  EqualsOnJoin = 'EqualsOnJoin',
  EqualsRaw = 'EqualsRaw',
  GreaterOrEqualTo = 'GreaterOrEqualTo',
  GreaterThan = 'GreaterThan',
  In = 'In',
  InOnJoin = 'InOnJoin',
  LessOrEqualTo = 'LessOrEqualTo',
  LessThan = 'LessThan',
  Like = 'Like',
  NotEquals = 'NotEquals',
  NotIn = 'NotIn',
  NotLike = 'NotLike'
}

export enum OrderDirection {
  ASC = 'ASC',
  ASCENDING = 'ASCENDING',
  DESC = 'DESC',
  DESCENDING = 'DESCENDING'
}

export enum PermissionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum PermissionEnum {
  ADDRESS_TYPE = 'ADDRESS_TYPE',
  ADVANCED_SEARCH = 'ADVANCED_SEARCH',
  Activity = 'Activity',
  ActivityType = 'ActivityType',
  BRICK = 'BRICK',
  CHERRY_PICK_OTHER_INSTANCE = 'CHERRY_PICK_OTHER_INSTANCE',
  CONTACT_CATEGORY = 'CONTACT_CATEGORY',
  DASHBOARD_DEFAULT = 'DASHBOARD_DEFAULT',
  DATA_MANAGEMENT = 'DATA_MANAGEMENT',
  DCR = 'DCR',
  Dashboard = 'Dashboard',
  DefaultTableColumn = 'DefaultTableColumn',
  HCP_GDPR = 'HCP_GDPR',
  HCP_OPT_OUT = 'HCP_OPT_OUT',
  HCP_PROD_SEGMENTATION = 'HCP_PROD_SEGMENTATION',
  HCP_SEGMENTATION = 'HCP_SEGMENTATION',
  INSTANCE_DEPLOY = 'INSTANCE_DEPLOY',
  LIST = 'LIST',
  LIST_PIN = 'LIST_PIN',
  LOV_MANAGEMENT = 'LOV_MANAGEMENT',
  Link = 'Link',
  MANAGE_LAYOUT = 'MANAGE_LAYOUT',
  MERGE_RECORD = 'MERGE_RECORD',
  OWN_RECORDS = 'OWN_RECORDS',
  OtherCalendar = 'OtherCalendar',
  PROJECT = 'PROJECT',
  Person = 'Person',
  RolePermission = 'RolePermission',
  SANDBOX = 'SANDBOX',
  SEARCH_INACTIVE = 'SEARCH_INACTIVE',
  SEARCH_UNPLACED = 'SEARCH_UNPLACED',
  SELECTION = 'SELECTION',
  Site = 'Site',
  TERRITORY = 'TERRITORY',
  UserControl = 'UserControl',
  VALIDATE_RECORD = 'VALIDATE_RECORD'
}

export enum PermissionLevel {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export type PersProjPreference = Model & {
  __typename: 'PersProjPreference';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  persProjId: Scalars['ID'];
  preference: Preference;
  preferenceId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PersProjPreferenceConnection = {
  __typename: 'PersProjPreferenceConnection';
  hash: Scalars['String'];
  nodes: Array<PersProjPreference>;
  totalCount: Scalars['Int'];
};

export type PersProjPreferenceCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<PersProjPreferenceCriteriaOrder>>;
  persId?: InputMaybe<Scalars['ID']>;
  persProjId?: InputMaybe<Scalars['ID']>;
  persProjIds?: InputMaybe<Array<Scalars['ID']>>;
  preference?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['ID']>;
};

export enum PersProjPreferenceCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersProjectConnection = {
  __typename: 'PersProjectConnection';
  hash: Scalars['String'];
  nodes: Array<PersonProject>;
  totalCount: Scalars['Int'];
};

export type PersProjectRoleConnection = SearchableConnection & {
  __typename: 'PersProjectRoleConnection';
  defaultOption: ValueModel;
  hash: Scalars['String'];
  nodes: Array<ValueModel>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersProjectRoleCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<PersProjectRoleCriteriaOrder>>;
  persId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum PersProjectRoleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Person = ImfModel & Model & {
  __typename: 'Person';
  /** All activities this person is linked to */
  activities: ActivityConnection;
  additionalEmails: Scalars['String'];
  affiliations: SitePersonConnection;
  apurebaseId?: Maybe<Scalars['Int']>;
  birth?: Maybe<Scalars['DateTime']>;
  combinedSalutation?: Maybe<Scalars['String']>;
  consentInstructions?: Maybe<ConsentInstructionConnection>;
  consentedEmail?: Maybe<ContactValue>;
  consents: ConsentValueConnection;
  /** All contact types and it's values related this this person */
  contactInformation: Array<VirtualContactTypeWithValue>;
  contacts: ContactValueConnection;
  controlSetting?: Maybe<EntityControlSetting>;
  country: ValueCountry;
  countryCode: Scalars['String'];
  countryEnum: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  customFieldValue: Array<Maybe<Scalars['String']>>;
  customFields: CustomLinkValueConnection;
  /** Returns the amount of days since the user registered an activity for a specific HCP */
  daysSinceLastActivity?: Maybe<Scalars['Int']>;
  dcrGroups: DcrGroupConnection;
  /** All educations this person has */
  educations: ValueEducationConnection;
  examYear?: Maybe<Scalars['Int']>;
  examYearAsDate?: Maybe<Scalars['DateTime']>;
  externalIdValue?: Maybe<Scalars['String']>;
  externalIds: ExternalIdConnection;
  /** All the filter codes this person is related to */
  filterCodes: FilterCodeConnection;
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  /**
   * The person full name in one field
   * @deprecated Please only use 'fullName'
   */
  fullname: Scalars['String'];
  /** Provides a full length english name of the gender. (Only: 'Female' or 'Male') */
  gender?: Maybe<Scalars['String']>;
  genderEnum?: Maybe<GenderEnum>;
  /** All products this person is linked to */
  getProductsByPersonId: ProductConnection;
  hasConsentedEmail: Scalars['Boolean'];
  id: Scalars['ID'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  isCherryPicked?: Maybe<Scalars['Boolean']>;
  isConsentTypeEnabled: Scalars['Boolean'];
  isGdprInformed: Scalars['Boolean'];
  isLocal: Scalars['Boolean'];
  /** This is a shorthand for the full graphql query of [languages.nodes.language.heading] */
  languageValues: Array<Scalars['String']>;
  languages: PersonLanguageConnection;
  lastName: Scalars['String'];
  linksContactInformation: Array<VirtualContactTypeWithValue>;
  /** All lists this person is associated with */
  lists: ListConnection;
  mailToPrivate: Scalars['Boolean'];
  mainAddress?: Maybe<Address>;
  mainContact?: Maybe<ContactValue>;
  maintainerSource: DbSource;
  maintainerSourceCode: Scalars['String'];
  mergeRequests: EntityMergeConnection;
  middleName?: Maybe<Scalars['String']>;
  /** All notes this person has */
  notes: NoteConnection;
  originSource: DbSource;
  originSourceCode: Scalars['String'];
  pendingDcrLines?: Maybe<Array<DcrLine>>;
  /** All the projects this person is related to */
  persProjects: PersProjectConnection;
  persType?: Maybe<ImfDataValue>;
  persTypeCode?: Maybe<Scalars['String']>;
  personDcr?: Maybe<Array<Dcr>>;
  /** Returns all of the validation logs submitted to this record */
  personValidationLogs?: Maybe<Array<EntityValidationLog>>;
  /** All positions this person has */
  positions: ValuePositionConnection;
  primaryEmail?: Maybe<ContactValue>;
  primaryOrFirstAffiliation?: Maybe<SitePerson>;
  primaryOrFirstSite?: Maybe<Site>;
  primarySite?: Maybe<Site>;
  /** The primary affiliation for the person */
  primarySitePerson?: Maybe<SitePerson>;
  privateAddresses?: Maybe<Address>;
  /** All the Product Deliveries this product is linked to */
  productDeliveries: PersonActivityProductConnection;
  /** View all assigned products with segmentation codes */
  productSegmentations: PersonProductSegmentationConnection;
  /** All products that are related to a person */
  products: ProductConnection;
  /** All the projects this person is related to */
  projects: ProjectConnection;
  salutation?: Maybe<Scalars['String']>;
  segmentation?: Maybe<SegmentationCode>;
  /** @deprecated Please use 'segmentation' instead of 'segmentationCode'! */
  segmentationCode?: Maybe<SegmentationCode>;
  selectionRows?: Maybe<PersonSelectionRowConnection>;
  /** This returns null if you don't have READ access to the Selection permission. */
  selectionRowsCustomerCount?: Maybe<Scalars['Int']>;
  sex?: Maybe<Scalars['String']>;
  /** Returns custom fields of affiliated sites that has a shared customField */
  sharedCustomFields?: Maybe<Array<CustomLinkValue>>;
  /** All sites this person is linked to */
  sites: SiteConnection;
  therapeuticFocuses: ValueTherapeuticFocusConnection;
  title?: Maybe<Scalars['String']>;
  /** All the projects this person is related to */
  userResponsibilites: PersonUserConnection;
  ut: Scalars['DateTime'];
  virtualConsents: Array<VirtualConsentValue>;
  workingSpecialities: SitePersonWorkSpecialtyConnection;
  workingSpecialityLabels: Array<Scalars['String']>;
};


export type PersonactivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


export type PersonaffiliationsArgs = {
  criteria?: InputMaybe<SitePersonCriteria>;
};


export type PersonconsentInstructionsArgs = {
  criteria?: InputMaybe<ConsentInstructionCriteria>;
};


export type PersonconsentsArgs = {
  criteria?: InputMaybe<ConsentValueCriteria>;
};


export type PersoncontactInformationArgs = {
  typeCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type PersoncontactsArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};


export type PersoncountryCodeArgs = {
  asLowerCase?: InputMaybe<Scalars['Boolean']>;
};


export type PersoncustomFieldValueArgs = {
  fieldCode: Scalars['String'];
};


export type PersoncustomFieldsArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
};


export type PersondcrGroupsArgs = {
  criteria?: InputMaybe<DcrGroupCriteria>;
};


export type PersoneducationsArgs = {
  criteria?: InputMaybe<ValueEducationCriteria>;
};


export type PersonexternalIdValueArgs = {
  externalIdTypeCode: Scalars['String'];
};


export type PersonexternalIdsArgs = {
  criteria?: InputMaybe<ExternalIdCriteria>;
};


export type PersonfilterCodesArgs = {
  criteria?: InputMaybe<FilterCodeCriteria>;
};


export type PersongetProductsByPersonIdArgs = {
  criteria?: InputMaybe<ProductCriteria>;
};


export type PersonisConsentTypeEnabledArgs = {
  consentTypeCode: Scalars['String'];
};


export type PersonlanguageValuesArgs = {
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type PersonlanguagesArgs = {
  criteria?: InputMaybe<PersonLanguageCriteria>;
};


export type PersonlinksContactInformationArgs = {
  typeCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type PersonlistsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


export type PersonmainContactArgs = {
  type: ContactTypeEnum;
};


export type PersonmergeRequestsArgs = {
  criteria?: InputMaybe<EntityMergeCriteria>;
};


export type PersonnotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


export type PersonpersProjectsArgs = {
  criteria?: InputMaybe<PersonProjectCriteria>;
};


export type PersonpositionsArgs = {
  criteria?: InputMaybe<ValuePositionCriteria>;
};


export type PersonproductDeliveriesArgs = {
  criteria?: InputMaybe<PersonActivityProductCriteria>;
};


export type PersonproductSegmentationsArgs = {
  criteria?: InputMaybe<PersonProductSegmentationCriteria>;
};


export type PersonproductsArgs = {
  criteria?: InputMaybe<ProductCriteria>;
};


export type PersonprojectsArgs = {
  criteria?: InputMaybe<ProjectCriteria>;
};


export type PersonselectionRowsArgs = {
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
};


export type PersonselectionRowsCustomerCountArgs = {
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
};


export type PersonsitesArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};


export type PersontherapeuticFocusesArgs = {
  criteria?: InputMaybe<ValueTherapeuticFocusCriteria>;
};


export type PersonuserResponsibilitesArgs = {
  criteria?: InputMaybe<PersonUserCriteria>;
};


export type PersonworkingSpecialitiesArgs = {
  criteria?: InputMaybe<SitePersonWorkingSpecialtyCriteria>;
};

export type PersonActivityProduct = Model & {
  __typename: 'PersonActivityProduct';
  /**
   * All activities this person is linked to
   * @deprecated This query doesn't make any sense!
   */
  activities: ActivityConnection;
  ct: Scalars['DateTime'];
  deliveryDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  person: Person;
  personActivityId: Scalars['ID'];
  /** The product that is affiliated to the delivery */
  product: Product;
  productId: Scalars['ID'];
  responsibleUser?: Maybe<User>;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type PersonActivityProductactivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};

export type PersonActivityProductConnection = {
  __typename: 'PersonActivityProductConnection';
  hash: Scalars['String'];
  nodes: Array<PersonActivityProduct>;
  totalCount: Scalars['Int'];
};

export type PersonActivityProductCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  ordering?: InputMaybe<Array<PersonActivityProductCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  responsibleId?: InputMaybe<Scalars['ID']>;
};

export enum PersonActivityProductCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersonActivityProductInput = {
  activityId: Scalars['Int'];
  personId: Scalars['Int'];
  productId: Scalars['Int'];
  time: Scalars['DateTime'];
};

export type PersonActivity_EntityDataToBeTransferredType = {
  __typename: 'PersonActivity_EntityDataToBeTransferredType';
  activityIds: Array<Scalars['ID']>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export type PersonAddress_EntityDataToBeTransferredType = {
  __typename: 'PersonAddress_EntityDataToBeTransferredType';
  addressAffiliation: AddressAffiliation;
  code: Scalars['String'];
  conflictedWith?: Maybe<AddressAffiliation>;
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export type PersonBirth_EntityDataToBeTransferredType = {
  __typename: 'PersonBirth_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type PersonConnection = EntityTypeConnection & SearchableConnection & {
  __typename: 'PersonConnection';
  globalAdditionalCount: Scalars['Int'];
  hash: Scalars['String'];
  justForTesting: Scalars['Int'];
  nodes: Array<Person>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersonConsent_EntityDataToBeTransferredType = {
  __typename: 'PersonConsent_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  value: ConsentValue;
};

export type PersonContactValue_EntityDataToBeTransferredType = {
  __typename: 'PersonContactValue_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserValue: ContactValue;
  winnerValue?: Maybe<ContactValue>;
};

export type PersonCountry_EntityDataToBeTransferredType = {
  __typename: 'PersonCountry_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['CountryCode']>;
  to?: Maybe<Scalars['CountryCode']>;
};

export type PersonCreated = {
  __typename: 'PersonCreated';
  dcr?: Maybe<DcrGroup>;
  person?: Maybe<Person>;
  sitePerson?: Maybe<SitePersonCreated>;
};

export type PersonCriteria = {
  aPureBaseId?: InputMaybe<Scalars['Int']>;
  aPureBaseIds?: InputMaybe<Array<Scalars['Int']>>;
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  byActivityResponsibleUserId?: InputMaybe<Scalars['ID']>;
  bySelection?: InputMaybe<SelectionCriteriaInput>;
  containDcrWithApbId?: InputMaybe<Scalars['Boolean']>;
  containMergeRequest?: InputMaybe<Scalars['Boolean']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldValues?: InputMaybe<Array<CustomFieldSearchInput>>;
  dbSource?: InputMaybe<Scalars['String']>;
  dcrId?: InputMaybe<Scalars['ID']>;
  educationCodes?: InputMaybe<Array<Scalars['String']>>;
  examYear?: InputMaybe<Scalars['Int']>;
  excludeActivityId?: InputMaybe<Scalars['ID']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeSiteId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  firstName?: InputMaybe<Scalars['String']>;
  hasAPureBaseId?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  imfCreatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfUpdatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfValidatedAfter?: InputMaybe<Scalars['DateTime']>;
  includeOptedOut?: InputMaybe<Scalars['Boolean']>;
  includeUnplaced?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<ActiveEnum>;
  lastName?: InputMaybe<Scalars['String']>;
  listId?: InputMaybe<Scalars['ID']>;
  mailToPrivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  onlyCherryPicked?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<PersonCriteriaOrder>>;
  persNote?: InputMaybe<Scalars['String']>;
  personDeliveryId?: InputMaybe<Scalars['ID']>;
  personFilterCodeId?: InputMaybe<Scalars['ID']>;
  positionCodes?: InputMaybe<Array<Scalars['String']>>;
  productId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Scalars['ID']>;
  responsibleUserId?: InputMaybe<Scalars['ID']>;
  searchGlobal?: InputMaybe<Scalars['Boolean']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sex?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['ID']>;
  siteName?: InputMaybe<Scalars['String']>;
  siteSpecialtyCodes?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  typeCodes?: InputMaybe<Array<Scalars['String']>>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
  withDuplicatedApureBaseIds?: InputMaybe<Scalars['Boolean']>;
  workingSpecialities?: InputMaybe<Array<Scalars['String']>>;
};

export enum PersonCriteriaOrder {
  COUNTRY_CODE_ASC = 'COUNTRY_CODE_ASC',
  COUNTRY_CODE_DESC = 'COUNTRY_CODE_DESC',
  CT_ASC = 'CT_ASC',
  CT_DESC = 'CT_DESC',
  EXAM_YEAR_ASC = 'EXAM_YEAR_ASC',
  EXAM_YEAR_DESC = 'EXAM_YEAR_DESC',
  FIRSTNAME_ASC = 'FIRSTNAME_ASC',
  FIRSTNAME_DESC = 'FIRSTNAME_DESC',
  GENDER_ASC = 'GENDER_ASC',
  GENDER_DESC = 'GENDER_DESC',
  IMF_CT_ASC = 'IMF_CT_ASC',
  IMF_CT_DESC = 'IMF_CT_DESC',
  IMF_UT_ASC = 'IMF_UT_ASC',
  IMF_UT_DESC = 'IMF_UT_DESC',
  IMF_VT_ASC = 'IMF_VT_ASC',
  IMF_VT_DESC = 'IMF_VT_DESC',
  LASTNAME_ASC = 'LASTNAME_ASC',
  LASTNAME_DESC = 'LASTNAME_DESC',
  LINK_THERAPEUTIC_FOCUS_ASC = 'LINK_THERAPEUTIC_FOCUS_ASC',
  LINK_THERAPEUTIC_FOCUS_DESC = 'LINK_THERAPEUTIC_FOCUS_DESC',
  MAILTOPRIVATE_ASC = 'MAILTOPRIVATE_ASC',
  MAILTOPRIVATE_DESC = 'MAILTOPRIVATE_DESC',
  MIDDLENAME_ASC = 'MIDDLENAME_ASC',
  MIDDLENAME_DESC = 'MIDDLENAME_DESC',
  ORIGIN_SOURCE_APB = 'ORIGIN_SOURCE_APB',
  PERSON_THERAPEUTIC_FOCUS_ASC = 'PERSON_THERAPEUTIC_FOCUS_ASC',
  PERSON_THERAPEUTIC_FOCUS_DESC = 'PERSON_THERAPEUTIC_FOCUS_DESC',
  PERSON_TYPE_ASC = 'PERSON_TYPE_ASC',
  PERSON_TYPE_DESC = 'PERSON_TYPE_DESC',
  PRIMARY_SITE_NAME_ASC = 'PRIMARY_SITE_NAME_ASC',
  PRIMARY_SITE_NAME_DESC = 'PRIMARY_SITE_NAME_DESC',
  PRIMARY_SITE_TYPE_ASC = 'PRIMARY_SITE_TYPE_ASC',
  PRIMARY_SITE_TYPE_DESC = 'PRIMARY_SITE_TYPE_DESC',
  PRIMARY_SITE_VISIT_CITY_ASC = 'PRIMARY_SITE_VISIT_CITY_ASC',
  PRIMARY_SITE_VISIT_CITY_DESC = 'PRIMARY_SITE_VISIT_CITY_DESC',
  PRIMARY_WORKPLACE_WORKING_SPECIALTY_ASC = 'PRIMARY_WORKPLACE_WORKING_SPECIALTY_ASC',
  PRIMARY_WORKPLACE_WORKING_SPECIALTY_DESC = 'PRIMARY_WORKPLACE_WORKING_SPECIALTY_DESC',
  SEGMENTATION_ASC = 'SEGMENTATION_ASC',
  SEGMENTATION_DESC = 'SEGMENTATION_DESC',
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DESC = 'TITLE_DESC',
  UT_ASC = 'UT_ASC',
  UT_DESC = 'UT_DESC',
  WORKING_SPECIALTY_ASC = 'WORKING_SPECIALTY_ASC',
  WORKING_SPECIALTY_DESC = 'WORKING_SPECIALTY_DESC'
}

export type PersonCustomField_EntityDataToBeTransferredType = {
  __typename: 'PersonCustomField_EntityDataToBeTransferredType';
  affiliationsToMove: Array<CustomFieldToBeTransferredInfo>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  field: CustomField;
  loserExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
  winnerExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
};

export type PersonEducation = Model & {
  __typename: 'PersonEducation';
  ct: Scalars['DateTime'];
  education: ImfDataValue;
  educationCode: Scalars['String'];
  id: Scalars['ID'];
  imfCt: Scalars['DateTime'];
  imfUt: Scalars['DateTime'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PersonEducations_EntityDataToBeTransferredType = {
  __typename: 'PersonEducations_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  educationCodesAlreadyExisting: Array<PersonEducation>;
  educationCodesToBeMoved: Array<PersonEducation>;
  entityType: EntityTypeEnum;
};

export type PersonExamYear_EntityDataToBeTransferredType = {
  __typename: 'PersonExamYear_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['Int']>;
  to?: Maybe<Scalars['Int']>;
};

export type PersonExternalIdInput = {
  externalIdTypeCode: Scalars['String'];
  externalIdValue?: InputMaybe<Scalars['String']>;
};

export type PersonExternalId_EntityDataToBeTransferredType = {
  __typename: 'PersonExternalId_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  existingExternalId?: Maybe<ExternalId>;
  externalId: ExternalId;
};

export type PersonFilterCode = Model & {
  __typename: 'PersonFilterCode';
  ct: Scalars['DateTime'];
  filterCode: FilterCode;
  filterCodeId: Scalars['ID'];
  id: Scalars['ID'];
  person: Person;
  personId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PersonFilterCodeConnection = SearchableConnection & {
  __typename: 'PersonFilterCodeConnection';
  hash: Scalars['String'];
  nodes: Array<PersonFilterCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum PersonFilterCodeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersonFirstName_EntityDataToBeTransferredType = {
  __typename: 'PersonFirstName_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['String'];
  to: Scalars['String'];
};

export type PersonGdpr_EntityDataToBeTransferredType = {
  __typename: 'PersonGdpr_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  newGdprValue: Scalars['Boolean'];
};

export type PersonGender_EntityDataToBeTransferredType = {
  __typename: 'PersonGender_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<GenderEnum>;
  to?: Maybe<GenderEnum>;
};

export type PersonInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  birth?: InputMaybe<Scalars['DateTime']>;
  contacts?: InputMaybe<Array<NewContactInput>>;
  countryCode: Scalars['String'];
  customFieldValues?: InputMaybe<Array<SetCustomValuesInput>>;
  educationCodes?: InputMaybe<Array<Scalars['String']>>;
  examYear?: InputMaybe<Scalars['Year']>;
  externalIds?: InputMaybe<Array<PersonExternalIdInput>>;
  firstName: Scalars['String'];
  instantValidation?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  persTypeCode?: InputMaybe<Array<Scalars['String']>>;
  sex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  workplace?: InputMaybe<AddWorkplaceInput>;
};

export type PersonIsActive_EntityDataToBeTransferredType = {
  __typename: 'PersonIsActive_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  willBeActivated?: Maybe<Person>;
  willBeInactivated?: Maybe<Person>;
};

export type PersonLanguage = Model & {
  __typename: 'PersonLanguage';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  language: ValueLanguage;
  languageCode: Scalars['String'];
  personId: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type PersonLanguageConnection = SearchableConnection & {
  __typename: 'PersonLanguageConnection';
  hash: Scalars['String'];
  nodes: Array<PersonLanguage>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersonLanguageCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<PersonLanguageCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum PersonLanguageCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type PersonLastName_EntityDataToBeTransferredType = {
  __typename: 'PersonLastName_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['String'];
  to: Scalars['String'];
};

export type PersonLink_EntityDataToBeTransferredType = {
  __typename: 'PersonLink_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: SitePerson;
  into?: Maybe<SitePerson>;
  linkEffects?: Maybe<Array<VirtualEntityMergeFieldInfo>>;
  primaryConflict: Scalars['Boolean'];
};

export type PersonLists_EntityDataToBeTransferredType = {
  __typename: 'PersonLists_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  listIds: Array<Scalars['ID']>;
};

export type PersonMailToPrivate_EntityDataToBeTransferredType = {
  __typename: 'PersonMailToPrivate_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['Boolean'];
  to: Scalars['Boolean'];
};

export type PersonMatchCandidateData = {
  __typename: 'PersonMatchCandidateData';
  apurebaseId: Scalars['Int'];
  countryCode: Scalars['String'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  personType: Scalars['String'];
  title: Scalars['String'];
};

export type PersonMatchInput = {
  apurebaseId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  officialId?: InputMaybe<Scalars['String']>;
  personType?: InputMaybe<Scalars['String']>;
  personTypeGb?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type PersonNotes_EntityDataToBeTransferredType = {
  __typename: 'PersonNotes_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  noteIds: Array<Scalars['ID']>;
};

export type PersonProductSegmentation = Model & {
  __typename: 'PersonProductSegmentation';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  person: Person;
  personId: Scalars['ID'];
  product: Product;
  productId: Scalars['ID'];
  segmentationCode: SegmentationCode;
  segmentationId: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type PersonProductSegmentationConnection = SearchableConnection & {
  __typename: 'PersonProductSegmentationConnection';
  hash: Scalars['String'];
  nodes: Array<PersonProductSegmentation>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersonProductSegmentationCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<PersonProductSegmentationCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  productId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  segmentationCodeId?: InputMaybe<Scalars['ID']>;
};

export enum PersonProductSegmentationCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type PersonProductSegmentation_EntityDataToBeTransferredType = {
  __typename: 'PersonProductSegmentation_EntityDataToBeTransferredType';
  code: Scalars['String'];
  conflictFrom?: Maybe<PersonProductSegmentation>;
  conflictTo?: Maybe<PersonProductSegmentation>;
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  toBeTransferred?: Maybe<PersonProductSegmentation>;
};

export type PersonProject = Model & {
  __typename: 'PersonProject';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  person: Person;
  personId: Scalars['ID'];
  /** @deprecated Please use [personPreferences] instead! */
  personPreference: Array<PersProjPreference>;
  personPreferences: PersProjPreferenceConnection;
  personProjectResponse: ValueModel;
  personProjectRole: ValueModel;
  project: Project;
  projectId: Scalars['ID'];
  ut: Scalars['DateTime'];
  valProjectResponseId: Scalars['ID'];
  valProjectRoleId: Scalars['ID'];
};

export type PersonProjectBulk = {
  personId?: InputMaybe<Scalars['Int']>;
  responsId?: InputMaybe<Scalars['Int']>;
  roleId?: InputMaybe<Scalars['Int']>;
};

export type PersonProjectCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<PersonProjectCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum PersonProjectCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersonProjectInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  personData: Array<PersonProjectBulk>;
  projectTitle?: InputMaybe<Scalars['String']>;
  projectType?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type PersonProjects_EntityDataToBeTransferredType = {
  __typename: 'PersonProjects_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export type PersonResponsibleArea_EntityDataToBeTransferredType = {
  __typename: 'PersonResponsibleArea_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  fromUser: User;
  fromUserId: Scalars['ID'];
  responsibleArea: ResponsibleArea;
  responsibleAreaId: Scalars['ID'];
  toUser?: Maybe<User>;
  toUserId?: Maybe<Scalars['ID']>;
};

export type PersonSegmentationCode = Model & {
  __typename: 'PersonSegmentationCode';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  person: Person;
  personId: Scalars['ID'];
  segmentationCode: SegmentationCode;
  segmentationCodeId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PersonSegmentationCodeConnection = SearchableConnection & {
  __typename: 'PersonSegmentationCodeConnection';
  hash: Scalars['String'];
  nodes: Array<PersonSegmentationCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum PersonSegmentationCodeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersonSegmentation_EntityDataToBeTransferredType = {
  __typename: 'PersonSegmentation_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loser: SegmentationCode;
  winner?: Maybe<SegmentationCode>;
};

export type PersonSelectionRow = {
  __typename: 'PersonSelectionRow';
  ct: Scalars['DateTime'];
  id: Scalars['Long'];
  person?: Maybe<Person>;
  personApurebaseId: Scalars['Int'];
  selectionRow?: Maybe<SelectionRow>;
};

export type PersonSelectionRowConnection = {
  __typename: 'PersonSelectionRowConnection';
  hash: Scalars['String'];
  nodes: Array<PersonSelectionRow>;
  totalCount: Scalars['Int'];
};

export type PersonSelectionRowCriteria = {
  aPureBaseId?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  imfCustomerCodes?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<PersonSelectionRowCriteriaOrder>>;
  selectionIsActive?: InputMaybe<Scalars['Boolean']>;
  selectionRowId?: InputMaybe<Scalars['ID']>;
  selectionType?: InputMaybe<SlicerSelectionType>;
};

export enum PersonSelectionRowCriteriaOrder {
  CUSTOMER_NAME_ASC = 'CUSTOMER_NAME_ASC',
  CUSTOMER_NAME_DESC = 'CUSTOMER_NAME_DESC',
  ROW_ID_ASC = 'ROW_ID_ASC',
  ROW_ID_DESC = 'ROW_ID_DESC',
  SELECTION_DESCRIPTION_ASC = 'SELECTION_DESCRIPTION_ASC',
  SELECTION_DESCRIPTION_DESC = 'SELECTION_DESCRIPTION_DESC',
  SELECTION_GROUP_DESCRIPTION_ASC = 'SELECTION_GROUP_DESCRIPTION_ASC',
  SELECTION_GROUP_DESCRIPTION_DESC = 'SELECTION_GROUP_DESCRIPTION_DESC',
  SELECTION_TYPE_ASC = 'SELECTION_TYPE_ASC',
  SELECTION_TYPE_DESC = 'SELECTION_TYPE_DESC'
}

export type PersonTags_EntityDataToBeTransferredType = {
  __typename: 'PersonTags_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserCodes: Array<PersonFilterCode>;
  winnerCodes: Array<PersonFilterCode>;
};

export type PersonTherapeuticFocus = Model & {
  __typename: 'PersonTherapeuticFocus';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  person: Person;
  personId: Scalars['ID'];
  therapeuticFocus: DataValue;
  therapeuticFocusCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type PersonTherapeuticFocusConnection = SearchableConnection & {
  __typename: 'PersonTherapeuticFocusConnection';
  hash: Scalars['String'];
  nodes: Array<PersonTherapeuticFocus>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersonTherapeuticFocusCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<PersonTherapeuticFocusCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum PersonTherapeuticFocusCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PersonTherapeuticFocus_EntityDataToBeTransferredType = {
  __typename: 'PersonTherapeuticFocus_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  toBeMoved: Array<DataValue>;
};

export type PersonTitle_EntityDataToBeTransferredType = {
  __typename: 'PersonTitle_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type PersonType_EntityDataToBeTransferredType = {
  __typename: 'PersonType_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserType?: Maybe<ImfDataValue>;
  winnerType?: Maybe<ImfDataValue>;
};

export type PersonUser = Model & {
  __typename: 'PersonUser';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  person: Person;
  personId: Scalars['ID'];
  responsibleArea: ResponsibleArea;
  responsibleAreaId: Scalars['ID'];
  user: User;
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PersonUserConnection = SearchableConnection & {
  __typename: 'PersonUserConnection';
  hash: Scalars['String'];
  nodes: Array<PersonUser>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PersonUserCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<PersonUserCriteriaOrder>>;
  persId?: InputMaybe<Scalars['ID']>;
  responsibleAreaId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum PersonUserCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PositionGroup = {
  __typename: 'PositionGroup';
  code?: Maybe<Scalars['String']>;
  count: Scalars['Int'];
  heading?: Maybe<Scalars['String']>;
  siteId: Scalars['ID'];
};

export type Preference = Model & {
  __typename: 'Preference';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type PreferenceConnection = {
  __typename: 'PreferenceConnection';
  defaultOption: Preference;
  hash: Scalars['String'];
  nodes: Array<Preference>;
  totalCount: Scalars['Int'];
};

export type PreferenceCriteria = {
  code?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<PreferenceCriteriaOrder>>;
  personId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

export enum PreferenceCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ProcessLineEffectActionEnum {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  SKIP = 'SKIP',
  UNCHANGED = 'UNCHANGED',
  UPDATE = 'UPDATE'
}

export type Product = Model & {
  __typename: 'Product';
  brandId?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  /** All persons this product is linked to */
  getPersons: PersonConnection;
  heading: Scalars['String'];
  id: Scalars['ID'];
  /** All the Product Deliveries this product is linked to */
  productDeliveries: PersonActivityProductConnection;
  strength?: Maybe<Scalars['Float']>;
  strengthUnitType?: Maybe<UnitType>;
  strengthUnitTypeId?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};


export type ProductgetPersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type ProductproductDeliveriesArgs = {
  criteria?: InputMaybe<PersonActivityProductCriteria>;
};

export type ProductConnection = SearchableConnection & {
  __typename: 'ProductConnection';
  hash: Scalars['String'];
  nodes: Array<Product>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ProductCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityStatus?: InputMaybe<ActivityStatusEnum>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  excludeActivityId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  inActivitiesWithinTimespan?: InputMaybe<DateSpanFilter>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ProductCriteriaOrder>>;
  persId?: InputMaybe<Scalars['ID']>;
  productDeliveryId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  segmentationCodeIdByPers?: InputMaybe<Scalars['ID']>;
  siteId?: InputMaybe<Scalars['String']>;
};

export enum ProductCriteriaOrder {
  ALPHABETICALLY_ASC = 'ALPHABETICALLY_ASC',
  ALPHABETICALLY_DESC = 'ALPHABETICALLY_DESC'
}

export type ProductInput = {
  brandId?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  strength: Scalars['Float'];
  strengthUnitTypeId: Scalars['Int'];
};

export type Project = Model & {
  __typename: 'Project';
  activities: ActivityConnection;
  affiliatedActivities: ProjectActivityConnection;
  ct: Scalars['DateTime'];
  editAccess: Scalars['Boolean'];
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  /** All notes this project has */
  notes: NoteConnection;
  /** All persons this project is linked to */
  persProjectsByProjectId: PersProjectConnection;
  /** Get all persons by project id */
  persons: PersonConnection;
  /** All Products this project is linked to */
  productsAffiliations: ProjectProductConnection;
  projectStatus: ProjectStatus;
  projectStatusId: Scalars['ID'];
  projectType: ProjectType;
  projectTypeId: Scalars['ID'];
  responsibleUsers: UserConnection;
  startDate: Scalars['DateTime'];
  title: Scalars['String'];
  ut: Scalars['DateTime'];
};


export type ProjectactivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


export type ProjectaffiliatedActivitiesArgs = {
  criteria?: InputMaybe<ProjectActivityCriteria>;
};


export type ProjectnotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


export type ProjectpersProjectsByProjectIdArgs = {
  criteria?: InputMaybe<PersonProjectCriteria>;
};


export type ProjectpersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type ProjectproductsAffiliationsArgs = {
  criteria?: InputMaybe<ProjectProductCriteria>;
};


export type ProjectresponsibleUsersArgs = {
  criteria?: InputMaybe<UserCriteria>;
};

export type ProjectActivity = Model & {
  __typename: 'ProjectActivity';
  activity: Activity;
  activityId: Scalars['ID'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  project: Project;
  projectId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ProjectActivityConnection = SearchableConnection & {
  __typename: 'ProjectActivityConnection';
  hash: Scalars['String'];
  nodes: Array<ProjectActivity>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ProjectActivityCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ProjectActivityCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ProjectActivityCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectConnection = SearchableConnection & {
  __typename: 'ProjectConnection';
  hash: Scalars['String'];
  nodes: Array<Project>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ProjectCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ProjectCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectStatusId?: InputMaybe<Scalars['ID']>;
  projectTypeId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  title?: InputMaybe<Scalars['String']>;
  titles?: InputMaybe<Array<Scalars['String']>>;
};

export enum ProjectCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  projectStatusId?: InputMaybe<Scalars['Int']>;
  projectTypeId?: InputMaybe<Scalars['Int']>;
  responsibleUserIds?: InputMaybe<Array<Scalars['Int']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProjectProduct = Model & {
  __typename: 'ProjectProduct';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  product: Product;
  productId: Scalars['ID'];
  project: Project;
  projectId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ProjectProductConnection = {
  __typename: 'ProjectProductConnection';
  hash: Scalars['String'];
  nodes: Array<ProjectProduct>;
  totalCount: Scalars['Int'];
};

export type ProjectProductCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ProjectProductCriteriaOrder>>;
  productId?: InputMaybe<Scalars['ID']>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ProjectProductCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectResponseValueConnection = {
  __typename: 'ProjectResponseValueConnection';
  defaultOption: ValueModel;
  hash: Scalars['String'];
  nodes: Array<ValueModel>;
  totalCount: Scalars['Int'];
};

export type ProjectResponseValueCriteria = {
  code?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ProjectResponseValueCriteriaOrder>>;
  persId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['Int']>;
};

export enum ProjectResponseValueCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectStatus = Model & {
  __typename: 'ProjectStatus';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  status: Scalars['Int'];
  ut: Scalars['DateTime'];
};

export type ProjectStatusConnection = SearchableConnection & {
  __typename: 'ProjectStatusConnection';
  hash: Scalars['String'];
  nodes: Array<ProjectStatus>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ProjectStatusCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ProjectStatusCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['Int']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ProjectStatusCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectType = Model & {
  __typename: 'ProjectType';
  code: Scalars['String'];
  color?: Maybe<Color>;
  colorCode?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};

export type ProjectTypeConnection = SearchableConnection & {
  __typename: 'ProjectTypeConnection';
  /** @deprecated Do not use this! doesn't make sense. */
  defaultOption: ProjectType;
  hash: Scalars['String'];
  nodes: Array<ProjectType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ProjectTypeCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ProjectTypeCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['Int']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ProjectTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ProjectUser = Model & {
  __typename: 'ProjectUser';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  projectId: Scalars['ID'];
  user: User;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ProjectUserConnection = {
  __typename: 'ProjectUserConnection';
  hash: Scalars['String'];
  nodes: Array<ProjectUser>;
  totalCount: Scalars['Int'];
};

export type ProjectUserCriteria = {
  code?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ProjectUserCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum ProjectUserCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PureAdvanceCustomer = {
  __typename: 'PureAdvanceCustomer';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  dataSyncSchedule?: Maybe<GitlabSchedule>;
  dcrSyncSchedule?: Maybe<GitlabSchedule>;
  dockerService?: Maybe<DockerService>;
  heading?: Maybe<Scalars['String']>;
  maxSandboxes: Scalars['Int'];
  modules: PureAdvanceCustomerModuleConnection;
  sandboxes: PureAdvanceCustomerSandboxConnection;
  scheduleDataSyncId?: Maybe<Scalars['Long']>;
  scheduleDcrSyncId?: Maybe<Scalars['Long']>;
  selectionCustomers: SelectionImfCustomerConnection;
  systemSetting?: Maybe<Scalars['String']>;
  ut: Scalars['DateTime'];
};


export type PureAdvanceCustomermodulesArgs = {
  criteria?: InputMaybe<PureAdvanceCustomerModuleCriteria>;
};


export type PureAdvanceCustomerselectionCustomersArgs = {
  criteria?: InputMaybe<SelectionImfCustomerCriteria>;
};


export type PureAdvanceCustomersystemSettingArgs = {
  setting: InstanceSettingEnum;
};

export type PureAdvanceCustomerConnection = SearchableConnection & {
  __typename: 'PureAdvanceCustomerConnection';
  hash: Scalars['String'];
  nodes: Array<PureAdvanceCustomer>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PureAdvanceCustomerCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<ActiveEnum>;
  ordering?: InputMaybe<Array<PureAdvanceCustomerCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum PureAdvanceCustomerCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PureAdvanceCustomerModule = {
  __typename: 'PureAdvanceCustomerModule';
  id: PureAdvanceCustomerModuleId;
  module: PureAdvanceModule;
};

export type PureAdvanceCustomerModuleConnection = {
  __typename: 'PureAdvanceCustomerModuleConnection';
  hash: Scalars['String'];
  nodes: Array<PureAdvanceCustomerModule>;
  totalCount: Scalars['Int'];
};

export type PureAdvanceCustomerModuleCriteria = {
  customerCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  module?: InputMaybe<ModuleEnumType>;
  ordering?: InputMaybe<Array<PureAdvanceCustomerModuleCriteriaOrder>>;
};

export enum PureAdvanceCustomerModuleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PureAdvanceCustomerModuleId = {
  __typename: 'PureAdvanceCustomerModuleId';
  customerCode: Scalars['String'];
  moduleId: Scalars['ID'];
};

export type PureAdvanceCustomerSandbox = Model & {
  __typename: 'PureAdvanceCustomerSandbox';
  createdByUserId: Scalars['ID'];
  ct: Scalars['DateTime'];
  customerCode: Scalars['String'];
  deploymentStatus: CurrentSandboxDeploymentStatus;
  gitlabPipelineId: Scalars['Long'];
  gitlabScheduleId?: Maybe<Scalars['Long']>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lastPipeline: GitlabPipeline;
  sandboxGitRepoId: Scalars['ID'];
  schedule?: Maybe<GitlabSchedule>;
  serverCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type PureAdvanceCustomerSandboxConnection = {
  __typename: 'PureAdvanceCustomerSandboxConnection';
  hash: Scalars['String'];
  nodes: Array<PureAdvanceCustomerSandbox>;
  totalCount: Scalars['Int'];
};

export type PureAdvanceCustomerSandboxCriteria = {
  customerCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<PureAdvanceCustomerSandboxCriteriaOrder>>;
  pipelineId?: InputMaybe<Scalars['Long']>;
  scheduleId?: InputMaybe<Scalars['Long']>;
};

export enum PureAdvanceCustomerSandboxCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PureAdvanceCustomerSelection = Model & {
  __typename: 'PureAdvanceCustomerSelection';
  ct: Scalars['DateTime'];
  customerCode: Scalars['String'];
  id: Scalars['ID'];
  imfCustomerCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type PureAdvanceCustomerSelectionConnection = SearchableConnection & {
  __typename: 'PureAdvanceCustomerSelectionConnection';
  hash: Scalars['String'];
  nodes: Array<PureAdvanceCustomerSelection>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum PureAdvanceCustomerSelectionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type PureAdvanceModule = Model & {
  __typename: 'PureAdvanceModule';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  enum: ModuleEnumType;
  id: Scalars['ID'];
  name: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type PureAdvanceModuleConnection = SearchableConnection & {
  __typename: 'PureAdvanceModuleConnection';
  hash: Scalars['String'];
  nodes: Array<PureAdvanceModule>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type PureAdvanceModuleCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customerCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<PureAdvanceModuleCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum PureAdvanceModuleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

/** Query object */
export type Query = {
  __typename: 'Query';
  activities: ActivityConnection;
  activity?: Maybe<Activity>;
  activityFieldDaysInYear: Array<ActivityFieldDays>;
  activityLocations: ActivityLocationConnection;
  activityPerson?: Maybe<ActivityPerson>;
  activityPersons: ActivityPersonConnection;
  activityProducts: ActivityProductConnection;
  activityStatuses: ActivityStatusConnection;
  activitySuperType?: Maybe<ActivitySuperType>;
  activitySuperTypes: ActivitySuperTypeConnection;
  activityType?: Maybe<ActivityType>;
  activityTypeCustomField?: Maybe<ActivityTypeCustomField>;
  activityTypeCustomFields: ActivityTypeCustomFieldConnection;
  activityTypes: ActivityTypeConnection;
  address?: Maybe<Address>;
  addressType?: Maybe<AddressType>;
  addressTypes: AddressTypeConnection;
  addresses: AddressConnection;
  allSearches: SearchConnection;
  allSiteMarketAccess: MarketAccessSiteConnection;
  allSitePersonMarketAccess: MarketAccessSitePersonConnection;
  availableMassAssignFields: Array<MassAssignFieldInfo>;
  brand?: Maybe<Brand>;
  brands: BrandConnection;
  brick?: Maybe<Brick>;
  bricks: BrickConnection;
  /**
   * This returns true if the user has access to the create the requested entityType,
   * checking against the user permission and entity control permission
   */
  canICreate: Scalars['Boolean'];
  canIGenerateApureBaseId: Scalars['Boolean'];
  cardFieldKeys: EntityCardFields;
  charsets: Array<CharsetEnum>;
  cherryPickOverview: ExternalCherryPickCustomerOverview;
  cherryPickOverviews: Array<ExternalCherryPickCustomerOverview>;
  commune?: Maybe<DataValue>;
  communeByCodeAndCountry?: Maybe<DataValue>;
  communes: ValueCommuneConnection;
  consentInstructions: ConsentInstructionConnection;
  consentTypes: ConsentTypeConnection;
  contactCategories: ContactCategoryConnection;
  contactCategory?: Maybe<ContactCategory>;
  contactCategoryMappings: ContactCategoryMappingConnection;
  contactType?: Maybe<ContactType>;
  contactTypes: ContactTypeConnection;
  contactValues: ContactValueConnection;
  counties: ValueCountyConnection;
  countries: ValueCountryConnection;
  country?: Maybe<ValueCountry>;
  county?: Maybe<DataValue>;
  criteria?: Maybe<Criteria>;
  criteriaByCode?: Maybe<Criteria>;
  criteriaGroup?: Maybe<CriteriaGroup>;
  criteriaGroups: CriteriaGroupConnection;
  criteriaTypes: CriteriaTypeConnection;
  criterias: CriteriaConnection;
  customField?: Maybe<CustomField>;
  customFieldControlSetting?: Maybe<CustomFieldControlSetting>;
  customFieldControlSettings: CustomFieldControlSettingConnection;
  customFieldOptionCountries: CustomFieldOptionCountryConnection;
  customFieldOptionCountry?: Maybe<CustomFieldOptionCountry>;
  customFieldOptions: CustomFieldOptionConnection;
  customFieldRoles: CustomFieldRoleConnection;
  /** Returns the customFieldType by id */
  customFieldType?: Maybe<CustomFieldType>;
  /** Returns all customFieldTypes */
  customFieldTypes: CustomFieldTypeConnection;
  customFields: CustomFieldConnection;
  customFieldsWithOptionsSupport: Array<CustomField>;
  customLinkValues: CustomLinkValueConnection;
  customValues: CustomValueConnection;
  /** Returns the dashboard by id */
  dashboard?: Maybe<Dashboard>;
  dashboardEntityPieData?: Maybe<ChartResults>;
  dashboardEntityPieSettings: Array<DashboardEntityPieSetting>;
  dashboardEntityPieSupportedFields: Array<DashboardPieFieldOption>;
  /** Returns the dashboardItem by code */
  dashboardItem?: Maybe<DashboardItem>;
  /** Returns the dashboardItemConfiguration by id */
  dashboardItemConfiguration?: Maybe<DashboardItemConfiguration>;
  /** Returns all notes */
  dashboardItemConfigurations: DashboardItemConfigurationConnection;
  /** Returns all notes */
  dashboardItems: DashboardItemConnection;
  dashboardMasterDataOverview: Array<ChartColumnSeriesValue>;
  dashboardRecordsImportedDataPoints: Array<ChartTimestampValue>;
  /** Returns the dashboardUser by id */
  dashboardUser?: Maybe<DashboardUser>;
  /** Returns all notes */
  dashboardUsers: DashboardUserConnection;
  dashboards: DashboardConnection;
  dbSource?: Maybe<DbSource>;
  dbSources: DbSourceConnection;
  dcr?: Maybe<Dcr>;
  dcrGroup?: Maybe<DcrGroup>;
  dcrGroups: DcrGroupConnection;
  dcrSnapshot?: Maybe<DcrSnapshotInfo>;
  dcrSnapshots: DcrSnapshotInfoConnection;
  dcrs: DcrConnection;
  defaultCriteria?: Maybe<DefaultCriteria>;
  defaultCriterias: DefaultCriteriaConnection;
  /** Returns the DefaultDashboard by id */
  defaultDashboard?: Maybe<DefaultDashboard>;
  /** Returns all defaultDashboard */
  defaultDashboards: DefaultDashboardConnection;
  defaultSearch: SearchNode;
  defaultTableColumns: DefaultTableColumnConnection;
  delimiters: Array<DelimiterEnum>;
  /** Returns the DisabledDefaultDashboard by id */
  disabledDefaultDashboard?: Maybe<DisabledDefaultDashboard>;
  /** Returns all defaultDashboard */
  disabledDefaultDashboards: DisabledDefaultDashboardConnection;
  dockerContainers: Array<DockerContainerResponse>;
  dockerSwarmServices: Array<DockerService>;
  dropdownSuggestions: AdvancedSearchableGqlValueConnection;
  dynamicCriteriaList?: Maybe<DynamicCriteriaList>;
  dynamicCriteriaLists: DynamicCriteriaListConnection;
  education?: Maybe<ImfDataValue>;
  educations: ValueEducationConnection;
  elasticMatch: Array<MatchCandidate>;
  elasticSiteMatch: Array<SiteMatchCandidate>;
  entityControlSetting?: Maybe<EntityControlSetting>;
  entityGridItemCardField?: Maybe<EntityGridItemCardField>;
  entityGridItemCardFieldType?: Maybe<EntityGridItemCardFieldType>;
  entityGridItemCardFieldTypes: EntityGridCardFieldTypeConnection;
  entityGridItemCardFields: EntityGridItemCardFieldConnection;
  entityGridItemConfiguration?: Maybe<EntityGridItemConfiguration>;
  entityGridItemConfigurations: EntityGridItemConfigurationConnection;
  entityGridItemFieldType?: Maybe<EntityGridItemFieldType>;
  entityGridItemFieldTypes: EntityGridItemFieldTypeConnection;
  entityGridItemRelationField?: Maybe<EntityGridItemRelationField>;
  entityGridItemRelationFields: EntityGridItemRelationFieldConnection;
  entityGridItemType?: Maybe<EntityGridItemType>;
  entityGridItemTypes: EntityGridItemTypeConnection;
  entityMerge?: Maybe<EntityMerge>;
  entityMerges: EntityMergeConnection;
  entityTab?: Maybe<EntityTab>;
  entityTabGridConfigurationField?: Maybe<EntityGridItemField>;
  entityTabGridConfigurationFields: EntityGridItemFieldConnection;
  entityTabs: EntityTabConnection;
  entityTypes: Array<Entity>;
  entityValidationLogs: EntityValidationLogConnection;
  entityValidationLogsByValues: Array<EntityValidationLog>;
  externalId?: Maybe<ExternalId>;
  externalIdSystem?: Maybe<ExternalIdSystem>;
  externalIdSystems: ExternalIdSystemConnection;
  externalIdType?: Maybe<ExternalIdType>;
  externalIdTypeRole?: Maybe<ExternalIdTypeRole>;
  externalIdTypeRoles: ExternalIdTypeRoleConnection;
  externalIdTypes: ExternalIdTypeConnection;
  externalIds: ExternalIdConnection;
  fields: FieldConnection;
  filterCode?: Maybe<FilterCode>;
  filterCodeType?: Maybe<FilterCodeType>;
  filterCodeTypes: FilterCodeTypeConnection;
  filterCodes: FilterCodeConnection;
  findDcrLine: DcrLineConnection;
  /**
   * Returns the list by list id
   * @deprecated Please use the [Query.list] field instead!
   */
  gdprList?: Maybe<List>;
  getAffiliationByEntity?: Maybe<ImfModel>;
  getCreateEntityFields: Array<CreateEntityField>;
  getDcrCounts: Array<ChartColumnItemValue>;
  getProductById?: Maybe<Product>;
  /** all active static lists */
  getStaticLists: ListConnection;
  /** all active static site lists */
  getStaticSiteLists: ListConnection;
  gitlabPipeline?: Maybe<GitlabPipeline>;
  gitlabSchedule?: Maybe<GitlabSchedule>;
  gitlabSchedules: Array<GitlabSchedule>;
  hasAccessToModule: Scalars['Boolean'];
  hasPermission: Scalars['Boolean'];
  hasPermissions: Array<VirtualPermissionInfo>;
  imgPath?: Maybe<Scalars['String']>;
  importProcessLineEffect?: Maybe<ImportProcessLineEffect>;
  importProcessLineEffects: ImportProcessLineEffectConnection;
  importProject?: Maybe<ImportProject>;
  importProjects: ImportProjectConnection;
  importTemplates: ImportTemplateConnection;
  instance: PureAdvanceCustomer;
  instanceCode: Scalars['String'];
  instanceName?: Maybe<Scalars['String']>;
  instanceSetting?: Maybe<InstanceSetting>;
  instanceSettingValue?: Maybe<Scalars['String']>;
  instancesRecordCherryPickOverview: Array<ExternalCherryPickHcpOverview>;
  internationalCustomer?: Maybe<InternationalCustomer>;
  internationalCustomers: InternationalCustomerConnection;
  jiraIssues?: Maybe<JiraIssueConnection>;
  languages: LanguageConnection;
  /** Returns the list by list id */
  list?: Maybe<List>;
  listFormatFields: ListFormatFieldConnection;
  listFormats: ListFormatConnection;
  listTypes: ListTypeConnection;
  lists: ListConnection;
  localizations: LocalizationConnection;
  massAssignFieldOptions: Array<MassAssignFieldOption>;
  menuGroup?: Maybe<MenuGroup>;
  /** Returns all group menu options */
  menuGroups: MenuGroupConnection;
  menuItem?: Maybe<MenuItem>;
  /** Returns all menu options */
  menuItems: MenuItemConnection;
  /** Returns the Note by id */
  note?: Maybe<Note>;
  /** Returns all notes */
  notes: NoteConnection;
  operatorTypes: OperatorTypeConnection;
  person?: Maybe<Person>;
  /** @deprecated Please use activityPersons instead */
  personActivities: ActivityPersonConnection;
  /** @deprecated Please use activityPerson instead */
  personActivity?: Maybe<ActivityPerson>;
  personProject?: Maybe<PersonProject>;
  personProjectByPersonId: Array<PersonProject>;
  personProjectLinks: PersProjectConnection;
  personProjectPreference?: Maybe<PersProjPreference>;
  personProjectPreferences: PersProjPreferenceConnection;
  personProjectRole?: Maybe<ValueModel>;
  personProjectRoles: PersProjectRoleConnection;
  personProjects: PersProjectConnection;
  personSelectionRow?: Maybe<PersonSelectionRow>;
  personSelectionRows: PersonSelectionRowConnection;
  /** This returns null if you don't have READ access to the Selection permission. */
  personSelectionRowsCustomerCount?: Maybe<Scalars['Int']>;
  personTherapeuticFocus?: Maybe<PersonTherapeuticFocus>;
  personTherapeuticFocuses: PersonTherapeuticFocusConnection;
  personType?: Maybe<ImfDataValue>;
  personTypes: ValuePersonTypeConnection;
  personUserResponsibilites?: Maybe<PersonUser>;
  persons: PersonConnection;
  personsById: Array<Person>;
  personsUserResponsibilites: PersonUserConnection;
  position?: Maybe<ImfDataValue>;
  positions: ValuePositionConnection;
  postalCode?: Maybe<ValuePostalCode>;
  postalCodes: ValuePostalCodeConnection;
  postcode?: Maybe<ExternalPostcodeResponse>;
  preference?: Maybe<Preference>;
  preferences: PreferenceConnection;
  previewMassAssign: MassFieldAssignPreviewInfo;
  productDeliveries: PersonActivityProductConnection;
  products: ProductConnection;
  project?: Maybe<Project>;
  projectActivityAffiliation: ProjectActivityConnection;
  projectProductBrand?: Maybe<ProjectProduct>;
  projectProducts: PersProjectConnection;
  projectResponse?: Maybe<ValueModel>;
  projectResponses: ProjectResponseValueConnection;
  projectStatus?: Maybe<ProjectStatus>;
  projectStatutes: ProjectStatusConnection;
  projectType?: Maybe<ProjectType>;
  projectTypes: ProjectTypeConnection;
  projectUser?: Maybe<ProjectUser>;
  projectUsers: ProjectUserConnection;
  projects: ProjectConnection;
  pureAdvanceCustomer?: Maybe<PureAdvanceCustomer>;
  pureAdvanceCustomers: PureAdvanceCustomerConnection;
  pureAdvanceModules: PureAdvanceModuleConnection;
  pureAdvanceSandboxEnvironments: PureAdvanceCustomerSandboxConnection;
  releases: JiraReleaseConnection;
  /** Returns the Report by code */
  report?: Maybe<Report>;
  reportSettingDailyCallTarget: Array<ReportSettingDailyCallTarget>;
  reportSettingFieldDays: ReportSettingFieldDayConnection;
  reportSettingIsHalfDay: Scalars['Boolean'];
  reportSettingsActivityTypes: ReportSettingsActivityTypeConnection;
  /** Returns all reports */
  reports: ReportConnection;
  responsibleArea?: Maybe<ResponsibleArea>;
  responsibleAreas: ResponsibleAreaConnection;
  role?: Maybe<Role>;
  roles: RoleConnection;
  salesCycle?: Maybe<SalesCycle>;
  salesCycleSegmentation?: Maybe<SalesCycleSegmentationTarget>;
  salesCycleSegmentations: SalesCycleSegmentationTargetConnection;
  salesCycleSetup?: Maybe<SalesCycleSetup>;
  salesCycleSetups: SalesCycleSetupConnection;
  salesCycles: Array<SalesCycle>;
  savedCriterias: CriteriaSimpleSavedConnection;
  segmentationCode?: Maybe<SegmentationCode>;
  segmentationCodes: SegmentationCodeConnection;
  selection?: Maybe<Selection>;
  selectionGroup?: Maybe<SelectionGroup>;
  selectionGroups: SelectionGroupConnection;
  selectionImfCustomer?: Maybe<SelectionImfCustomer>;
  selectionImfCustomers: SelectionImfCustomerConnection;
  selectionRow?: Maybe<SelectionRow>;
  selectionRowResult?: Maybe<SelectionRowResult>;
  selectionRowResults: SelectionRowResultConnection;
  selectionRows: SelectionRowConnection;
  selectionToIds: Array<Scalars['ID']>;
  selections: SelectionConnection;
  singleSearch: SearchNode;
  site?: Maybe<Site>;
  siteFilterCode?: Maybe<SiteFilterCode>;
  siteFilterCodes: SiteFilterCodeConnection;
  siteMarketAccess?: Maybe<MarketAccessSite>;
  sitePersonAffiliation?: Maybe<SitePerson>;
  sitePersonAffiliations: SitePersonConnection;
  sitePersonMarketAccess?: Maybe<MarketAccessSitePerson>;
  siteSectorType?: Maybe<ValueSiteSectorType>;
  siteSectorTypes: ValueSiteSectorTypeConnection;
  siteSelectionRow?: Maybe<SiteSelectionRow>;
  siteSelectionRows: SiteSelectionRowConnection;
  /** This return null if you don't have READ access to the Selection permission */
  siteSelectionRowsCustomerCount?: Maybe<Scalars['Int']>;
  siteSpecialties: ValueSiteSpecialtyConnection;
  siteType?: Maybe<ImfDataValue>;
  siteTypes: ValueSiteTypeConnection;
  sites: SiteConnection;
  sitesById: Array<Site>;
  standardTitleForCountry: Array<Maybe<StandardTitle>>;
  standardTitles: StandardTitleConnection;
  /** @deprecated Please use dropdownSuggestions after moved to new AdvancedSearch. */
  suggestions: SearchableGqlValueConnection;
  suggestionsByPostalCode: VirtualPostalCodeSuggestion;
  tableMapper: TableMapper;
  /** Returns the Team by id */
  team?: Maybe<Team>;
  /** Returns all teams */
  teams: TeamConnection;
  territories: TerritoryConnection;
  territory?: Maybe<Territory>;
  therapeuticFocuses: ValueTherapeuticFocusConnection;
  user?: Maybe<User>;
  userTableColumns: UserTableColumnConnection;
  users: UserConnection;
  validateExternalId: FormValidationErrorResponse;
  valueChain?: Maybe<ImfDataValue>;
  valueChains: ValueChainConnection;
  viewer?: Maybe<Viewer>;
  virtualMergeOverview: VirtualEntityMerge;
  workingSpecialties: ValueWorkingSpecialtyConnection;
};


/** Query object */
export type QueryactivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


/** Query object */
export type QueryactivityArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryactivityFieldDaysInYearArgs = {
  country: Scalars['CountryCode'];
  year: Scalars['Year'];
};


/** Query object */
export type QueryactivityLocationsArgs = {
  criteria?: InputMaybe<ActivityLocationCriteria>;
};


/** Query object */
export type QueryactivityPersonArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryactivityPersonsArgs = {
  criteria?: InputMaybe<ActivityPersonCriteria>;
};


/** Query object */
export type QueryactivityProductsArgs = {
  criteria?: InputMaybe<ActivityProductCriteria>;
};


/** Query object */
export type QueryactivityStatusesArgs = {
  criteria?: InputMaybe<ActivityStatusCriteria>;
};


/** Query object */
export type QueryactivitySuperTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryactivitySuperTypesArgs = {
  criteria?: InputMaybe<ActivitySuperTypeCriteria>;
};


/** Query object */
export type QueryactivityTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryactivityTypeCustomFieldArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QueryactivityTypeCustomFieldsArgs = {
  criteria?: InputMaybe<ActivityTypeCustomFieldCriteria>;
};


/** Query object */
export type QueryactivityTypesArgs = {
  criteria?: InputMaybe<ActivityTypeCriteria>;
};


/** Query object */
export type QueryaddressArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryaddressTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryaddressTypesArgs = {
  criteria?: InputMaybe<AddressTypeCriteria>;
};


/** Query object */
export type QueryaddressesArgs = {
  criteria?: InputMaybe<AddressCriteria>;
};


/** Query object */
export type QueryallSearchesArgs = {
  criteria?: InputMaybe<SearchCriteria>;
};


/** Query object */
export type QueryallSiteMarketAccessArgs = {
  criteria?: InputMaybe<MarketAccessSiteCriteria>;
};


/** Query object */
export type QueryallSitePersonMarketAccessArgs = {
  criteria?: InputMaybe<MarketAccessSitePersonCriteria>;
};


/** Query object */
export type QueryavailableMassAssignFieldsArgs = {
  filter?: InputMaybe<AvailableMassAssignFilter>;
};


/** Query object */
export type QuerybrandArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerybrandsArgs = {
  criteria?: InputMaybe<BrandCriteria>;
};


/** Query object */
export type QuerybrickArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerybricksArgs = {
  criteria?: InputMaybe<BrickCriteria>;
};


/** Query object */
export type QuerycanICreateArgs = {
  entityType: EntityTypeEnum;
};


/** Query object */
export type QuerycardFieldKeysArgs = {
  entityGridItemConfigurationId: Scalars['Int'];
};


/** Query object */
export type QuerycherryPickOverviewArgs = {
  country: Scalars['CountryCode'];
};


/** Query object */
export type QuerycommuneArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycommuneByCodeAndCountryArgs = {
  code: Scalars['String'];
  country: Scalars['CountryCode'];
};


/** Query object */
export type QuerycommunesArgs = {
  criteria?: InputMaybe<ValueCommuneCriteria>;
};


/** Query object */
export type QueryconsentInstructionsArgs = {
  criteria?: InputMaybe<ConsentInstructionCriteria>;
};


/** Query object */
export type QueryconsentTypesArgs = {
  criteria?: InputMaybe<ConsentTypeCriteria>;
};


/** Query object */
export type QuerycontactCategoriesArgs = {
  criteria?: InputMaybe<ContactCategoryCriteria>;
};


/** Query object */
export type QuerycontactCategoryArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycontactCategoryMappingsArgs = {
  criteria?: InputMaybe<ContactCategoryMappingCriteria>;
};


/** Query object */
export type QuerycontactTypeArgs = {
  type: ContactTypeEnum;
};


/** Query object */
export type QuerycontactTypesArgs = {
  criteria?: InputMaybe<ContactTypeCriteria>;
};


/** Query object */
export type QuerycontactValuesArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};


/** Query object */
export type QuerycountiesArgs = {
  criteria?: InputMaybe<ValueCountyCriteria>;
};


/** Query object */
export type QuerycountriesArgs = {
  criteria?: InputMaybe<ValueCountryCriteria>;
};


/** Query object */
export type QuerycountryArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycountyArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycriteriaArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerycriteriaByCodeArgs = {
  code: Scalars['String'];
  entityType: EntityTypeEnum;
};


/** Query object */
export type QuerycriteriaGroupArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycriteriaGroupsArgs = {
  criteria?: InputMaybe<CriteriaGroupCriteria>;
};


/** Query object */
export type QuerycriteriaTypesArgs = {
  criteria?: InputMaybe<CriteriaTypeCriteria>;
};


/** Query object */
export type QuerycriteriasArgs = {
  criteria?: InputMaybe<CriteriaCriteria>;
};


/** Query object */
export type QuerycustomFieldArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycustomFieldControlSettingArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerycustomFieldControlSettingsArgs = {
  criteria?: InputMaybe<CustomFieldControlSettingCriteria>;
};


/** Query object */
export type QuerycustomFieldOptionCountriesArgs = {
  criteria?: InputMaybe<CustomFieldOptionCountryCriteria>;
};


/** Query object */
export type QuerycustomFieldOptionCountryArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QuerycustomFieldOptionsArgs = {
  criteria?: InputMaybe<CustomFieldOptionCriteria>;
};


/** Query object */
export type QuerycustomFieldRolesArgs = {
  criteria?: InputMaybe<CustomFieldRoleCriteria>;
};


/** Query object */
export type QuerycustomFieldTypeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QuerycustomFieldTypesArgs = {
  criteria?: InputMaybe<CustomFieldTypeCriteria>;
};


/** Query object */
export type QuerycustomFieldsArgs = {
  criteria?: InputMaybe<CustomFieldCriteria>;
};


/** Query object */
export type QuerycustomFieldsWithOptionsSupportArgs = {
  entityType: EntityTypeEnum;
};


/** Query object */
export type QuerycustomLinkValuesArgs = {
  entityType: EntityTypeEnum;
  recordId: Scalars['Int'];
};


/** Query object */
export type QuerycustomValuesArgs = {
  criteria?: InputMaybe<CustomValueCriteria>;
};


/** Query object */
export type QuerydashboardArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Query object */
export type QuerydashboardEntityPieDataArgs = {
  dashboardItemConfigurationId: Scalars['Int'];
  selection?: InputMaybe<Array<DashboardPieSelectionInput>>;
};


/** Query object */
export type QuerydashboardEntityPieSettingsArgs = {
  dashboardItemConfigurationId: Scalars['Int'];
};


/** Query object */
export type QuerydashboardEntityPieSupportedFieldsArgs = {
  entityType: EntityTypeEnum;
};


/** Query object */
export type QuerydashboardItemArgs = {
  id: Scalars['String'];
};


/** Query object */
export type QuerydashboardItemConfigurationArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Query object */
export type QuerydashboardItemConfigurationsArgs = {
  criteria?: InputMaybe<DashboardItemConfigurationCriteria>;
};


/** Query object */
export type QuerydashboardItemsArgs = {
  criteria?: InputMaybe<DashboardItemCriteria>;
};


/** Query object */
export type QuerydashboardMasterDataOverviewArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
};


/** Query object */
export type QuerydashboardRecordsImportedDataPointsArgs = {
  grouping: GroupByDateRanges;
};


/** Query object */
export type QuerydashboardUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Query object */
export type QuerydashboardUsersArgs = {
  criteria?: InputMaybe<DashboardUserCriteria>;
};


/** Query object */
export type QuerydashboardsArgs = {
  criteria?: InputMaybe<DashboardCriteria>;
};


/** Query object */
export type QuerydbSourceArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerydbSourcesArgs = {
  criteria?: InputMaybe<DbSourceCriteria>;
};


/** Query object */
export type QuerydcrArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydcrGroupArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydcrGroupsArgs = {
  criteria?: InputMaybe<DcrGroupCriteria>;
};


/** Query object */
export type QuerydcrSnapshotArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydcrSnapshotsArgs = {
  criteria?: InputMaybe<DcrSnapshotInfoCriteria>;
};


/** Query object */
export type QuerydcrsArgs = {
  criteria?: InputMaybe<DcrCriteria>;
};


/** Query object */
export type QuerydefaultCriteriaArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydefaultCriteriasArgs = {
  criteria?: InputMaybe<DefaultCriteriaCriteria>;
};


/** Query object */
export type QuerydefaultDashboardArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Query object */
export type QuerydefaultDashboardsArgs = {
  criteria?: InputMaybe<DefaultDashboardCriteria>;
};


/** Query object */
export type QuerydefaultTableColumnsArgs = {
  criteria?: InputMaybe<DefaultTableColumnCriteria>;
};


/** Query object */
export type QuerydisabledDefaultDashboardArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydisabledDefaultDashboardsArgs = {
  criteria?: InputMaybe<DisabledDefaultDashboardCriteria>;
};


/** Query object */
export type QuerydockerSwarmServicesArgs = {
  search: DockerServiceSearchInput;
};


/** Query object */
export type QuerydropdownSuggestionsArgs = {
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  fetchSize?: InputMaybe<FetchSize>;
  fromEntityType: EntityTypeEnum;
  includeInactive: Scalars['Boolean'];
  includeOptedOut: Scalars['Boolean'];
  includeUnplaced: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  service: Scalars['String'];
};


/** Query object */
export type QuerydynamicCriteriaListArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerydynamicCriteriaListsArgs = {
  criteria?: InputMaybe<DynamicCriteriaListCriteria>;
};


/** Query object */
export type QueryeducationArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QueryeducationsArgs = {
  criteria?: InputMaybe<ValueEducationCriteria>;
};


/** Query object */
export type QueryelasticMatchArgs = {
  criteria?: InputMaybe<MatchCriteria>;
  link?: InputMaybe<SitePersonMatchInput>;
  person?: InputMaybe<PersonMatchInput>;
  site?: InputMaybe<SiteMatchInput>;
};


/** Query object */
export type QueryelasticSiteMatchArgs = {
  criteria?: InputMaybe<MatchCriteria>;
  search: ApiSiteMatchInputSearch;
};


/** Query object */
export type QueryentityControlSettingArgs = {
  entityType: EntityTypeEnum;
};


/** Query object */
export type QueryentityGridItemCardFieldArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryentityGridItemCardFieldTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryentityGridItemCardFieldTypesArgs = {
  criteria?: InputMaybe<EntityGridItemCardFieldTypeCriteria>;
};


/** Query object */
export type QueryentityGridItemCardFieldsArgs = {
  criteria?: InputMaybe<EntityGridItemCardFieldCriteria>;
};


/** Query object */
export type QueryentityGridItemConfigurationArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryentityGridItemConfigurationsArgs = {
  criteria?: InputMaybe<EntityGridItemConfigurationCriteria>;
};


/** Query object */
export type QueryentityGridItemFieldTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryentityGridItemFieldTypesArgs = {
  criteria?: InputMaybe<EntityGridItemFieldTypeCriteria>;
};


/** Query object */
export type QueryentityGridItemRelationFieldArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryentityGridItemRelationFieldsArgs = {
  criteria?: InputMaybe<EntityGridItemRelationFieldCriteria>;
};


/** Query object */
export type QueryentityGridItemTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryentityGridItemTypesArgs = {
  criteria?: InputMaybe<EntityGridItemTypeCriteria>;
};


/** Query object */
export type QueryentityMergeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryentityMergesArgs = {
  criteria?: InputMaybe<EntityMergeCriteria>;
};


/** Query object */
export type QueryentityTabArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryentityTabGridConfigurationFieldArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryentityTabGridConfigurationFieldsArgs = {
  criteria?: InputMaybe<EntityGridItemFieldCriteria>;
};


/** Query object */
export type QueryentityTabsArgs = {
  criteria?: InputMaybe<EntityTabCriteria>;
};


/** Query object */
export type QueryentityTypesArgs = {
  criteria?: InputMaybe<EntityCriteria>;
};


/** Query object */
export type QueryentityValidationLogsArgs = {
  criteria?: InputMaybe<EntityValidationLogCriteria>;
};


/** Query object */
export type QueryentityValidationLogsByValuesArgs = {
  entity: EntityTypeEnum;
  id: Scalars['Int'];
};


/** Query object */
export type QueryexternalIdArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QueryexternalIdSystemArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryexternalIdSystemsArgs = {
  criteria?: InputMaybe<ExternalIdSystemCriteria>;
};


/** Query object */
export type QueryexternalIdTypeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryexternalIdTypeRoleArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryexternalIdTypeRolesArgs = {
  criteria?: InputMaybe<ExternalIdTypeRoleCriteria>;
};


/** Query object */
export type QueryexternalIdTypesArgs = {
  criteria?: InputMaybe<ExternalIdTypeCriteria>;
};


/** Query object */
export type QueryexternalIdsArgs = {
  criteria?: InputMaybe<ExternalIdCriteria>;
};


/** Query object */
export type QueryfieldsArgs = {
  criteria?: InputMaybe<FieldCriteria>;
};


/** Query object */
export type QueryfilterCodeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryfilterCodeTypeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryfilterCodeTypesArgs = {
  criteria?: InputMaybe<FilterCodeTypeCriteria>;
};


/** Query object */
export type QueryfilterCodesArgs = {
  criteria?: InputMaybe<FilterCodeCriteria>;
};


/** Query object */
export type QueryfindDcrLineArgs = {
  entityAffiliationId: Scalars['Int'];
  entityType: EntityTypeEnum;
  fields: Array<DcrLineCriteriaField>;
};


/** Query object */
export type QuerygdprListArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerygetAffiliationByEntityArgs = {
  entityType: EntityTypeEnum;
  id: Scalars['Int'];
};


/** Query object */
export type QuerygetCreateEntityFieldsArgs = {
  country: Scalars['CountryCode'];
  entityType: EntityTypeEnum;
};


/** Query object */
export type QuerygetProductByIdArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerygetStaticListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


/** Query object */
export type QuerygetStaticSiteListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


/** Query object */
export type QuerygitlabPipelineArgs = {
  id: Scalars['Long'];
};


/** Query object */
export type QuerygitlabScheduleArgs = {
  id: Scalars['Long'];
};


/** Query object */
export type QueryhasAccessToModuleArgs = {
  module: ModuleEnumType;
};


/** Query object */
export type QueryhasPermissionArgs = {
  level: PermissionLevel;
  permission: PermissionEnum;
};


/** Query object */
export type QueryhasPermissionsArgs = {
  permissions: Array<PermissionEnum>;
};


/** Query object */
export type QueryimportProcessLineEffectArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryimportProcessLineEffectsArgs = {
  criteria?: InputMaybe<ImportProcessLineEffectCriteria>;
};


/** Query object */
export type QueryimportProjectArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryimportProjectsArgs = {
  criteria?: InputMaybe<ImportProjectCriteria>;
};


/** Query object */
export type QueryimportTemplatesArgs = {
  criteria?: InputMaybe<ImportTemplateCriteria>;
};


/** Query object */
export type QueryinstanceSettingArgs = {
  type: InstanceSettingEnum;
};


/** Query object */
export type QueryinstanceSettingValueArgs = {
  type: InstanceSettingEnum;
};


/** Query object */
export type QueryinstancesRecordCherryPickOverviewArgs = {
  entityApbId: Scalars['Int'];
  entityType: EntityTypeEnum;
};


/** Query object */
export type QueryinternationalCustomerArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryinternationalCustomersArgs = {
  criteria?: InputMaybe<InternationalCustomerCriteria>;
};


/** Query object */
export type QueryjiraIssuesArgs = {
  version: Scalars['String'];
};


/** Query object */
export type QuerylanguagesArgs = {
  criteria?: InputMaybe<LanguageCriteria>;
};


/** Query object */
export type QuerylistArgs = {
  id: Scalars['Int'];
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};


/** Query object */
export type QuerylistFormatFieldsArgs = {
  criteria?: InputMaybe<ListFormatFieldCriteria>;
};


/** Query object */
export type QuerylistFormatsArgs = {
  criteria?: InputMaybe<ListFormatCriteria>;
};


/** Query object */
export type QuerylistTypesArgs = {
  criteria?: InputMaybe<ListTypeCriteria>;
};


/** Query object */
export type QuerylistsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


/** Query object */
export type QuerylocalizationsArgs = {
  criteria?: InputMaybe<LocalizationCriteria>;
};


/** Query object */
export type QuerymassAssignFieldOptionsArgs = {
  actionName: Scalars['String'];
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  search: Scalars['String'];
};


/** Query object */
export type QuerymenuGroupArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerymenuGroupsArgs = {
  criteria?: InputMaybe<MenuGroupCriteria>;
};


/** Query object */
export type QuerymenuItemArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerymenuItemsArgs = {
  criteria?: InputMaybe<MenuItemCriteria>;
};


/** Query object */
export type QuerynoteArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


/** Query object */
export type QuerynotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


/** Query object */
export type QueryoperatorTypesArgs = {
  criteria?: InputMaybe<OperatorTypeCriteria>;
};


/** Query object */
export type QuerypersonArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonActivitiesArgs = {
  criteria?: InputMaybe<ActivityPersonCriteria>;
};


/** Query object */
export type QuerypersonActivityArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonProjectArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonProjectByPersonIdArgs = {
  persId: Scalars['Int'];
};


/** Query object */
export type QuerypersonProjectLinksArgs = {
  criteria?: InputMaybe<PersonProjectCriteria>;
};


/** Query object */
export type QuerypersonProjectPreferenceArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonProjectPreferencesArgs = {
  criteria?: InputMaybe<PersProjPreferenceCriteria>;
};


/** Query object */
export type QuerypersonProjectRoleArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonProjectRolesArgs = {
  criteria?: InputMaybe<PersProjectRoleCriteria>;
};


/** Query object */
export type QuerypersonProjectsArgs = {
  criteria?: InputMaybe<PersonProjectCriteria>;
};


/** Query object */
export type QuerypersonSelectionRowArgs = {
  id: Scalars['Long'];
};


/** Query object */
export type QuerypersonSelectionRowsArgs = {
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
};


/** Query object */
export type QuerypersonSelectionRowsCustomerCountArgs = {
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
};


/** Query object */
export type QuerypersonTherapeuticFocusArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QuerypersonTherapeuticFocusesArgs = {
  criteria?: InputMaybe<PersonTherapeuticFocusCriteria>;
};


/** Query object */
export type QuerypersonTypeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QuerypersonTypesArgs = {
  criteria?: InputMaybe<ValuePersonTypeCriteria>;
};


/** Query object */
export type QuerypersonUserResponsibilitesArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


/** Query object */
export type QuerypersonsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


/** Query object */
export type QuerypersonsUserResponsibilitesArgs = {
  criteria?: InputMaybe<PersonUserCriteria>;
};


/** Query object */
export type QuerypositionArgs = {
  id: Scalars['String'];
};


/** Query object */
export type QuerypositionsArgs = {
  criteria?: InputMaybe<ValuePositionCriteria>;
};


/** Query object */
export type QuerypostalCodeArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerypostalCodesArgs = {
  criteria?: InputMaybe<ValuePostalCodeCriteria>;
};


/** Query object */
export type QuerypostcodeArgs = {
  country: Scalars['CountryCode'];
  postcode: Scalars['String'];
};


/** Query object */
export type QuerypreferenceArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerypreferencesArgs = {
  criteria?: InputMaybe<PreferenceCriteria>;
};


/** Query object */
export type QuerypreviewMassAssignArgs = {
  actionName: Scalars['String'];
  input: MassAssignFieldInput;
  selection: SelectionCriteriaInput;
};


/** Query object */
export type QueryproductDeliveriesArgs = {
  criteria?: InputMaybe<PersonActivityProductCriteria>;
};


/** Query object */
export type QueryproductsArgs = {
  criteria?: InputMaybe<ProductCriteria>;
};


/** Query object */
export type QueryprojectArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectActivityAffiliationArgs = {
  criteria?: InputMaybe<ProjectActivityCriteria>;
};


/** Query object */
export type QueryprojectProductBrandArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectProductsArgs = {
  criteria?: InputMaybe<PersonProjectCriteria>;
};


/** Query object */
export type QueryprojectResponseArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectResponsesArgs = {
  criteria?: InputMaybe<ProjectResponseValueCriteria>;
};


/** Query object */
export type QueryprojectStatusArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectStatutesArgs = {
  criteria?: InputMaybe<ProjectStatusCriteria>;
};


/** Query object */
export type QueryprojectTypeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectTypesArgs = {
  criteria?: InputMaybe<ProjectTypeCriteria>;
};


/** Query object */
export type QueryprojectUserArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryprojectUsersArgs = {
  criteria?: InputMaybe<ProjectUserCriteria>;
};


/** Query object */
export type QueryprojectsArgs = {
  criteria?: InputMaybe<ProjectCriteria>;
};


/** Query object */
export type QuerypureAdvanceCustomerArgs = {
  customerCode: Scalars['String'];
};


/** Query object */
export type QuerypureAdvanceCustomersArgs = {
  criteria?: InputMaybe<PureAdvanceCustomerCriteria>;
};


/** Query object */
export type QuerypureAdvanceModulesArgs = {
  criteria?: InputMaybe<PureAdvanceModuleCriteria>;
};


/** Query object */
export type QuerypureAdvanceSandboxEnvironmentsArgs = {
  criteria?: InputMaybe<PureAdvanceCustomerSandboxCriteria>;
};


/** Query object */
export type QueryreleasesArgs = {
  criteria?: InputMaybe<JiraReleaseCriteria>;
};


/** Query object */
export type QueryreportArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QueryreportSettingDailyCallTargetArgs = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  reportCode: Scalars['String'];
};


/** Query object */
export type QueryreportSettingFieldDaysArgs = {
  criteria?: InputMaybe<ReportSettingFieldDayCriteria>;
};


/** Query object */
export type QueryreportSettingIsHalfDayArgs = {
  reportCode: Scalars['String'];
};


/** Query object */
export type QueryreportSettingsActivityTypesArgs = {
  criteria?: InputMaybe<ReportSettingsActivityTypeCriteria>;
};


/** Query object */
export type QueryreportsArgs = {
  criteria?: InputMaybe<ReportCriteria>;
};


/** Query object */
export type QueryresponsibleAreaArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryresponsibleAreasArgs = {
  criteria?: InputMaybe<ResponsibleAreaCriteria>;
};


/** Query object */
export type QueryroleArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryrolesArgs = {
  criteria?: InputMaybe<RoleCriteria>;
};


/** Query object */
export type QuerysalesCycleArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysalesCycleSegmentationArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysalesCycleSegmentationsArgs = {
  criteria?: InputMaybe<SalesCycleSegmentationTargetCriteria>;
};


/** Query object */
export type QuerysalesCycleSetupArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysalesCycleSetupsArgs = {
  criteria?: InputMaybe<SalesCycleSetupCriteria>;
};


/** Query object */
export type QuerysalesCyclesArgs = {
  criteria?: InputMaybe<SalesCycleCriteria>;
};


/** Query object */
export type QuerysavedCriteriasArgs = {
  criteria?: InputMaybe<CriteriaSimpleSavedGqlCriteria>;
};


/** Query object */
export type QuerysegmentationCodeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysegmentationCodesArgs = {
  criteria?: InputMaybe<SegmentationCodeCriteria>;
};


/** Query object */
export type QueryselectionArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryselectionGroupArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryselectionGroupsArgs = {
  criteria?: InputMaybe<SelectionGroupCriteria>;
};


/** Query object */
export type QueryselectionImfCustomerArgs = {
  imfCustomerCode: Scalars['String'];
};


/** Query object */
export type QueryselectionImfCustomersArgs = {
  criteria?: InputMaybe<SelectionImfCustomerCriteria>;
};


/** Query object */
export type QueryselectionRowArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryselectionRowResultArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QueryselectionRowResultsArgs = {
  criteria?: InputMaybe<SelectionRowResultCriteria>;
};


/** Query object */
export type QueryselectionRowsArgs = {
  criteria?: InputMaybe<SelectionRowCriteria>;
};


/** Query object */
export type QueryselectionToIdsArgs = {
  entityType: EntityTypeEnum;
  selection: SelectionCriteriaInput;
};


/** Query object */
export type QueryselectionsArgs = {
  criteria?: InputMaybe<SelectionCriteria>;
};


/** Query object */
export type QuerysingleSearchArgs = {
  id: Scalars['ID'];
};


/** Query object */
export type QuerysiteArgs = {
  siteId: Scalars['Int'];
};


/** Query object */
export type QuerysiteFilterCodeArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysiteFilterCodesArgs = {
  criteria?: InputMaybe<SiteFilterCodeCriteria>;
};


/** Query object */
export type QuerysiteMarketAccessArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysitePersonAffiliationArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysitePersonAffiliationsArgs = {
  criteria?: InputMaybe<SitePersonCriteria>;
};


/** Query object */
export type QuerysitePersonMarketAccessArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QuerysiteSectorTypeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QuerysiteSectorTypesArgs = {
  criteria?: InputMaybe<ValueSiteSectorTypeCriteria>;
};


/** Query object */
export type QuerysiteSelectionRowArgs = {
  id: Scalars['Long'];
};


/** Query object */
export type QuerysiteSelectionRowsArgs = {
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
};


/** Query object */
export type QuerysiteSelectionRowsCustomerCountArgs = {
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
};


/** Query object */
export type QuerysiteSpecialtiesArgs = {
  criteria?: InputMaybe<ValueSiteSpecialtyCriteria>;
};


/** Query object */
export type QuerysiteTypeArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QuerysiteTypesArgs = {
  criteria?: InputMaybe<ValueSiteTypeCriteria>;
};


/** Query object */
export type QuerysitesArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};


/** Query object */
export type QuerysitesByIdArgs = {
  ids: Array<Scalars['ID']>;
};


/** Query object */
export type QuerystandardTitleForCountryArgs = {
  countryCode: Scalars['String'];
};


/** Query object */
export type QuerystandardTitlesArgs = {
  criteria?: InputMaybe<StandardTitleCriteria>;
};


/** Query object */
export type QuerysuggestionsArgs = {
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']>>;
  criteriaPathId: Scalars['Int'];
  fetchSize?: InputMaybe<FetchSize>;
  includeInactive: Scalars['Boolean'];
  includeOptedOut: Scalars['Boolean'];
  includeUnplaced: Scalars['Boolean'];
  search?: InputMaybe<Scalars['String']>;
  service: Scalars['String'];
};


/** Query object */
export type QuerysuggestionsByPostalCodeArgs = {
  country?: InputMaybe<Scalars['CountryCode']>;
  postalCode: Scalars['String'];
};


/** Query object */
export type QuerytableMapperArgs = {
  entityType: EntityTypeEnum;
};


/** Query object */
export type QueryteamArgs = {
  id: Scalars['Int'];
};


/** Query object */
export type QueryteamsArgs = {
  criteria?: InputMaybe<TeamCriteria>;
};


/** Query object */
export type QueryterritoriesArgs = {
  criteria?: InputMaybe<TerritoryCriteria>;
};


/** Query object */
export type QueryterritoryArgs = {
  code: Scalars['String'];
};


/** Query object */
export type QuerytherapeuticFocusesArgs = {
  criteria?: InputMaybe<ValueTherapeuticFocusCriteria>;
};


/** Query object */
export type QueryuserArgs = {
  userId: Scalars['Int'];
};


/** Query object */
export type QueryuserTableColumnsArgs = {
  criteria?: InputMaybe<UserTableColumnCriteria>;
};


/** Query object */
export type QueryusersArgs = {
  criteria?: InputMaybe<UserCriteria>;
};


/** Query object */
export type QueryvalidateExternalIdArgs = {
  entityAffiliationId: Scalars['ID'];
  externalId: Scalars['String'];
  typeId: Scalars['ID'];
};


/** Query object */
export type QueryvalueChainArgs = {
  code?: InputMaybe<Scalars['String']>;
};


/** Query object */
export type QueryvalueChainsArgs = {
  criteria?: InputMaybe<ValueChainCriteria>;
};


/** Query object */
export type QueryvirtualMergeOverviewArgs = {
  entityType: EntityTypeEnum;
  fromId: Scalars['ID'];
  intoId: Scalars['ID'];
};


/** Query object */
export type QueryworkingSpecialtiesArgs = {
  criteria?: InputMaybe<ValueWorkingSpecialtyCriteria>;
};

export type Report = {
  __typename: 'Report';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  inputDefs: Array<ReportInputDef>;
  isActive: Scalars['Boolean'];
  sort?: Maybe<Scalars['Int']>;
  ut: Scalars['DateTime'];
};

export type ReportConnection = {
  __typename: 'ReportConnection';
  hash: Scalars['String'];
  nodes: Array<Report>;
  totalCount: Scalars['Int'];
};

export type ReportCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ReportCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  withActivityTypeLogic?: InputMaybe<Scalars['Boolean']>;
};

export enum ReportCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type ReportInput = {
  templateCode: Scalars['String'];
  values: Array<ReportInputValue>;
};

export type ReportInputDef = {
  __typename: 'ReportInputDef';
  key: ReportInputEnum;
  labelKey?: Maybe<Scalars['String']>;
  placeholderKey?: Maybe<Scalars['String']>;
  rules: Array<FormInputRule>;
};

export enum ReportInputEnum {
  COUNTRY_DF_ALL = 'COUNTRY_DF_ALL',
  DAY_SPAN = 'DAY_SPAN',
  HCP = 'HCP',
  MONTH = 'MONTH',
  PRODUCT = 'PRODUCT',
  PRODUCTS = 'PRODUCTS',
  SPECIFIC_KPI_REPORT = 'SPECIFIC_KPI_REPORT',
  TEXT = 'TEXT',
  USERS = 'USERS',
  USERS_DF_ALL = 'USERS_DF_ALL',
  YEAR = 'YEAR'
}

export type ReportInputValue = {
  labelKey: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReportSettingDailyCallTarget = Model & {
  __typename: 'ReportSettingDailyCallTarget';
  amount: Scalars['Int'];
  country: Scalars['CountryCode'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  reportCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export enum ReportSettingDailyCallTargetCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ReportSettingFieldDay = Model & {
  __typename: 'ReportSettingFieldDay';
  activityType: ActivityType;
  activityTypeCode: Scalars['String'];
  amountForOne: Scalars['Int'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  reportCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ReportSettingFieldDayConnection = SearchableConnection & {
  __typename: 'ReportSettingFieldDayConnection';
  hash: Scalars['String'];
  nodes: Array<ReportSettingFieldDay>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ReportSettingFieldDayCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ReportSettingFieldDayCriteriaOrder>>;
  reportCode?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ReportSettingFieldDayCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ReportSettingIsHalfDayCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ReportSettingsActivityType = Model & {
  __typename: 'ReportSettingsActivityType';
  activityType: ActivityType;
  activityTypeCode: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  includeInReport: Scalars['Boolean'];
  report: Report;
  reportCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ReportSettingsActivityTypeConnection = SearchableConnection & {
  __typename: 'ReportSettingsActivityTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ReportSettingsActivityType>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ReportSettingsActivityTypeCriteria = {
  activityTypeCode?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  country?: InputMaybe<Scalars['CountryCode']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  includedInReport?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<ReportSettingsActivityTypeCriteriaOrder>>;
  reportCode?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ReportSettingsActivityTypeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Resource = {
  __typename: 'Resource';
  filename: Scalars['String'];
  url: Scalars['String'];
};

export type ResponsibleArea = Model & {
  __typename: 'ResponsibleArea';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type ResponsibleAreaConnection = SearchableConnection & {
  __typename: 'ResponsibleAreaConnection';
  hash: Scalars['String'];
  nodes: Array<ResponsibleArea>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ResponsibleAreaCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ResponsibleAreaCriteriaOrder>>;
  persId?: InputMaybe<Scalars['Int']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ResponsibleAreaCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Role = Model & {
  __typename: 'Role';
  ct: Scalars['DateTime'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isAdminRole: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  permissions: Array<VirtualRolePermission>;
  users: UserConnection;
  ut: Scalars['DateTime'];
};


export type RoleusersArgs = {
  criteria?: InputMaybe<UserCriteria>;
};

export type RoleConnection = SearchableConnection & {
  __typename: 'RoleConnection';
  hash: Scalars['String'];
  nodes: Array<Role>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type RoleCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<RoleCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum RoleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type RolePermission = Model & {
  __typename: 'RolePermission';
  create?: Maybe<Scalars['Boolean']>;
  ct: Scalars['DateTime'];
  delete?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  permissionCode: Scalars['String'];
  read?: Maybe<Scalars['Boolean']>;
  roleId: Scalars['ID'];
  update?: Maybe<Scalars['Boolean']>;
  ut: Scalars['DateTime'];
};

export type RolePermissionConnection = {
  __typename: 'RolePermissionConnection';
  hash: Scalars['String'];
  nodes: Array<RolePermission>;
  totalCount: Scalars['Int'];
};

export enum RolePermissionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SalesCycle = Model & {
  __typename: 'SalesCycle';
  createdByUserId: Scalars['ID'];
  ct: Scalars['DateTime'];
  fromDate: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedByUserId: Scalars['ID'];
  salesCycleSetupId: Scalars['ID'];
  setup: SalesCycleSetup;
  toDate: Scalars['DateTime'];
  ut: Scalars['DateTime'];
};

export type SalesCycleConnection = SearchableConnection & {
  __typename: 'SalesCycleConnection';
  hash: Scalars['String'];
  nodes: Array<SalesCycle>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SalesCycleCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SalesCycleCriteriaOrder>>;
  salesCycleSetupId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum SalesCycleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SalesCycleSegmentationTarget = Model & {
  __typename: 'SalesCycleSegmentationTarget';
  createdBy: Scalars['ID'];
  ct: Scalars['DateTime'];
  goal: Scalars['Int'];
  id: Scalars['ID'];
  modifiedBy: Scalars['ID'];
  salesCycleSetupId: Scalars['ID'];
  segmentation: SegmentationCodeConnection;
  segmentationCode?: Maybe<SegmentationCode>;
  segmentationCodeId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type SalesCycleSegmentationTargetsegmentationArgs = {
  criteria?: InputMaybe<SegmentationCodeCriteria>;
};

export type SalesCycleSegmentationTargetConnection = SearchableConnection & {
  __typename: 'SalesCycleSegmentationTargetConnection';
  hash: Scalars['String'];
  nodes: Array<SalesCycleSegmentationTarget>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SalesCycleSegmentationTargetCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SalesCycleSegmentationTargetCriteriaOrder>>;
  salesCycleSetupId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  segmentationId?: InputMaybe<Scalars['ID']>;
};

export enum SalesCycleSegmentationTargetCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SalesCycleSetup = Model & {
  __typename: 'SalesCycleSetup';
  country: Scalars['CountryCode'];
  countryCode: Scalars['String'];
  createdByUserId: Scalars['ID'];
  ct: Scalars['DateTime'];
  cycleStartMonth: Scalars['Int'];
  cycles: SalesCycleConnection;
  id: Scalars['ID'];
  modifiedByUserId: Scalars['ID'];
  numberOfCyclesInYear: Scalars['Int'];
  startMonth: Scalars['Month'];
  targets: SalesCycleSegmentationTargetConnection;
  ut: Scalars['DateTime'];
  year: Scalars['Int'];
  yearEnum: Scalars['Year'];
};


export type SalesCycleSetupcyclesArgs = {
  criteria?: InputMaybe<SalesCycleCriteria>;
};


export type SalesCycleSetuptargetsArgs = {
  criteria?: InputMaybe<SalesCycleSegmentationTargetCriteria>;
};

export type SalesCycleSetupConnection = SearchableConnection & {
  __typename: 'SalesCycleSetupConnection';
  hash: Scalars['String'];
  nodes: Array<SalesCycleSetup>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SalesCycleSetupCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SalesCycleSetupCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export enum SalesCycleSetupCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SandboxScheduleStatus = {
  __typename: 'SandboxScheduleStatus';
  code: Scalars['String'];
  cron: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastRun?: Maybe<Scalars['DateTime']>;
  status: AntProgressStatusEnum;
};

export type SaveSearchInput = {
  search?: InputMaybe<SearchInput>;
  searchId?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Array<SearchArgInput>>;
};

export type Search = Model & {
  __typename: 'Search';
  code?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  entityTypeEnum: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  groupingCode?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isDefault: Scalars['Boolean'];
  isHeadingKey: Scalars['Boolean'];
  isShared: Scalars['Boolean'];
  sort?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export type SearchArgInput = {
  conditionCode: Scalars['String'];
  values?: InputMaybe<Array<Scalars['String']>>;
};

export enum SearchConditionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum SearchConditionEnum {
  COUNT = 'COUNT',
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
  NEST = 'NEST'
}

export type SearchConditionInput = {
  code: Scalars['String'];
  criteriaId?: InputMaybe<Scalars['ID']>;
  inputConfiguration?: InputMaybe<SearchConditionInputConfigurationInput>;
  nest?: InputMaybe<SearchInput>;
  operation?: InputMaybe<SearchConditionOperationEnum>;
  paths?: InputMaybe<Array<SearchPathInput>>;
  type: SearchConditionEnum;
  value?: InputMaybe<Array<Scalars['String']>>;
};

export type SearchConditionInputConfigurationInput = {
  allowMultiple?: InputMaybe<Scalars['Boolean']>;
  allowNoValue?: InputMaybe<Scalars['Boolean']>;
  inputHeading?: InputMaybe<Scalars['String']>;
  inputHeadingMeta?: InputMaybe<Scalars['String']>;
  inputPlaceholder?: InputMaybe<Scalars['String']>;
  inputType?: InputMaybe<CriteriaTypeEnum>;
  isInputHeadingKey?: InputMaybe<Scalars['Boolean']>;
  isInputPlaceholderKey?: InputMaybe<Scalars['Boolean']>;
  parentEntityType?: InputMaybe<EntityTypeEnum>;
  valueService?: InputMaybe<Scalars['String']>;
};

export type SearchConditionInputConfigurationNode = {
  __typename: 'SearchConditionInputConfigurationNode';
  allowMultiple?: Maybe<Scalars['Boolean']>;
  allowNoValue?: Maybe<Scalars['Boolean']>;
  inputHeading?: Maybe<Scalars['String']>;
  inputHeadingMeta?: Maybe<Scalars['String']>;
  inputPlaceholder?: Maybe<Scalars['String']>;
  inputType?: Maybe<CriteriaTypeEnum>;
  isInputHeadingKey?: Maybe<Scalars['Boolean']>;
  isInputPlaceholderKey?: Maybe<Scalars['Boolean']>;
  parentEntityType?: Maybe<EntityTypeEnum>;
  valueService?: Maybe<Scalars['String']>;
};

export type SearchConditionNode = {
  __typename: 'SearchConditionNode';
  code: Scalars['String'];
  criteriaId?: Maybe<Scalars['ID']>;
  dataType?: Maybe<Scalars['String']>;
  inputConfiguration?: Maybe<SearchConditionInputConfigurationNode>;
  nest?: Maybe<SearchNode>;
  operation?: Maybe<SearchConditionOperationEnum>;
  paths?: Maybe<Array<SearchPathNode>>;
  type: SearchConditionEnum;
  value?: Maybe<Array<Scalars['String']>>;
};

export enum SearchConditionOperationEnum {
  BETWEEN = 'BETWEEN',
  BETWEEN_RAW = 'BETWEEN_RAW',
  DATE = 'DATE',
  EQUAL = 'EQUAL',
  EQUAL_RAW = 'EQUAL_RAW',
  EXCLUDE_DATE = 'EXCLUDE_DATE',
  IN = 'IN',
  IN_RAW = 'IN_RAW',
  LESS_THAN = 'LESS_THAN',
  LIKE = 'LIKE',
  MORE_THAN = 'MORE_THAN',
  NOT_BETWEEN = 'NOT_BETWEEN',
  NOT_EQUAL = 'NOT_EQUAL',
  NOT_IN = 'NOT_IN',
  NOT_LIKE = 'NOT_LIKE',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type SearchConnection = SearchableConnection & {
  __typename: 'SearchConnection';
  hash: Scalars['String'];
  nodes: Array<Search>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SearchCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SearchCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  shared?: InputMaybe<Scalars['Boolean']>;
};

export enum SearchCriteriaCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum SearchCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum SearchGroupCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SearchGroupInput = {
  conditions: Array<SearchConditionInput>;
  nextOperation?: InputMaybe<SearchGroupOperationEnum>;
};

export type SearchGroupNode = {
  __typename: 'SearchGroupNode';
  conditions: Array<SearchConditionNode>;
  nextOperation?: Maybe<SearchGroupOperationEnum>;
};

export enum SearchGroupOperationEnum {
  EXCEPT = 'EXCEPT',
  INTERSECT = 'INTERSECT',
  UNION = 'UNION'
}

export enum SearchGroupingCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SearchInput = {
  code?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  groups: Array<SearchGroupInput>;
  heading?: InputMaybe<Scalars['String']>;
  searchId?: InputMaybe<Scalars['ID']>;
};

export enum SearchNestingConditionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SearchNode = {
  __typename: 'SearchNode';
  code?: Maybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  groups: Array<SearchGroupNode>;
  heading?: Maybe<Scalars['String']>;
  searchId?: Maybe<Scalars['ID']>;
};

export enum SearchPathCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SearchPathInput = {
  mapper: Scalars['String'];
  mapperFrom: Scalars['String'];
  mapperTo?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<OperatorTypeEnum>;
};

export type SearchPathNode = {
  __typename: 'SearchPathNode';
  mapper: Scalars['String'];
  mapperFrom: Scalars['String'];
  mapperTo?: Maybe<Scalars['String']>;
  operator?: Maybe<OperatorTypeEnum>;
};

export enum SearchUserCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SearchableConnection = {
  hash: Scalars['String'];
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SearchableGqlValue = {
  __typename: 'SearchableGqlValue';
  isGlobalOnly: Scalars['Boolean'];
  isValueHeadingKey: Scalars['Boolean'];
  key: Scalars['String'];
  parentKey?: Maybe<Scalars['String']>;
  value: Scalars['String'];
  valueGb?: Maybe<Scalars['String']>;
};

export type SearchableGqlValueConnection = {
  __typename: 'SearchableGqlValueConnection';
  countryCodes: Array<Scalars['String']>;
  hash: Scalars['String'];
  nodes: Array<SearchableGqlValueWithKey>;
  search?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
};

export type SearchableGqlValueWithKey = {
  __typename: 'SearchableGqlValueWithKey';
  /** This is just a concatenation of the countries, search term and the service being used to search in. This is needed for the frontend to build up a proper cache which can be saved in Apollo Cache and have support for 'fetchMore' cache functionality. */
  cacheKey: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  isGlobalOnly: Scalars['Boolean'];
  isValueHeadingKey: Scalars['Boolean'];
  key: Scalars['String'];
  parentKey?: Maybe<Scalars['String']>;
  value: Scalars['String'];
  valueGb?: Maybe<Scalars['String']>;
};


export type SearchableGqlValueWithKeycountArgs = {
  global?: InputMaybe<Scalars['Boolean']>;
};

export type SegmentationCode = Model & {
  __typename: 'SegmentationCode';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description: Scalars['String'];
  heading: Scalars['String'];
  id: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type SegmentationCodeConnection = SearchableConnection & {
  __typename: 'SegmentationCodeConnection';
  hash: Scalars['String'];
  nodes: Array<SegmentationCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SegmentationCodeCriteria = {
  code?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<SegmentationCodeCriteriaOrder>>;
  personID?: InputMaybe<Scalars['ID']>;
  salesCycleSegmentationTargetId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
};

export enum SegmentationCodeCriteriaOrder {
  HEADING_ASC = 'HEADING_ASC',
  HEADING_DESC = 'HEADING_DESC'
}

export type SegmentationSaleCycleInput = {
  goal: Scalars['Int'];
  segmentationId: Scalars['Int'];
};

export type SelectExternalSystemManualState = ImportManualStageType & {
  __typename: 'SelectExternalSystemManualState';
  lineId: Scalars['ID'];
  processorId: Scalars['Int'];
  projectId: Scalars['ID'];
  templateProcessId: Scalars['ID'];
};

export type Selection = Model & {
  __typename: 'Selection';
  ct: Scalars['DateTime'];
  customer: SelectionImfCustomer;
  description?: Maybe<Scalars['String']>;
  groups: SelectionGroupConnection;
  id: Scalars['ID'];
  imfCustomerCode: Scalars['String'];
  isActive: Scalars['Boolean'];
  marketAccessEnabled: Scalars['Boolean'];
  type: SlicerSelectionType;
  ut: Scalars['DateTime'];
};


export type SelectiongroupsArgs = {
  criteria?: InputMaybe<SelectionGroupCriteria>;
};

export type SelectionConnection = SearchableConnection & {
  __typename: 'SelectionConnection';
  hash: Scalars['String'];
  nodes: Array<Selection>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SelectionCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  description?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  imfCustomerCode?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<SelectionCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  selectionType?: InputMaybe<SlicerSelectionType>;
};

export type SelectionCriteriaInput = {
  count: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias: Array<DynamicCriteriaInput>;
  excluded: Array<Scalars['ID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeOptedOut?: InputMaybe<Scalars['Boolean']>;
  includeUnplaced?: InputMaybe<Scalars['Boolean']>;
  selected: Array<Scalars['ID']>;
  style: SelectionCriteriaStyle;
};

export enum SelectionCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum SelectionCriteriaStyle {
  ALL = 'ALL',
  ONLY_EVEN = 'ONLY_EVEN',
  ONLY_ODD = 'ONLY_ODD',
  STANDARD = 'STANDARD'
}

export type SelectionGroup = Model & {
  __typename: 'SelectionGroup';
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  rows: SelectionRowConnection;
  selection: Selection;
  selectionId: Scalars['ID'];
  ut: Scalars['DateTime'];
};


export type SelectionGrouprowsArgs = {
  criteria?: InputMaybe<SelectionRowCriteria>;
};

export type SelectionGroupConnection = SearchableConnection & {
  __typename: 'SelectionGroupConnection';
  hash: Scalars['String'];
  nodes: Array<SelectionGroup>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SelectionGroupCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SelectionGroupCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  selectionId?: InputMaybe<Scalars['ID']>;
};

export enum SelectionGroupCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SelectionImfCustomer = {
  __typename: 'SelectionImfCustomer';
  callName?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  includeInReports: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  kam: Scalars['String'];
  legacyCustomerCode: Scalars['String'];
  name: Scalars['String'];
  selections: SelectionConnection;
  ut: Scalars['DateTime'];
};


export type SelectionImfCustomerselectionsArgs = {
  criteria?: InputMaybe<SelectionCriteria>;
};

export type SelectionImfCustomerConnection = SearchableConnection & {
  __typename: 'SelectionImfCustomerConnection';
  hash: Scalars['String'];
  nodes: Array<SelectionImfCustomer>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SelectionImfCustomerCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customerCode?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  linkApbIdInSelection?: InputMaybe<Array<Scalars['Int']>>;
  ordering?: InputMaybe<Array<SelectionImfCustomerCriteriaOrder>>;
  personApbIdInSelection?: InputMaybe<Array<Scalars['Int']>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  selectionType?: InputMaybe<SlicerSelectionType>;
  siteApbIdInSelection?: InputMaybe<Array<Scalars['Int']>>;
};

export enum SelectionImfCustomerCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SelectionRow = Model & {
  __typename: 'SelectionRow';
  ct: Scalars['DateTime'];
  group: SelectionGroup;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  persons: PersonSelectionRowConnection;
  selectionGroupId: Scalars['ID'];
  sites: SiteSelectionRowConnection;
  ut: Scalars['DateTime'];
};


export type SelectionRowpersonsArgs = {
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
};


export type SelectionRowsitesArgs = {
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
};

export type SelectionRowConnection = SearchableConnection & {
  __typename: 'SelectionRowConnection';
  hash: Scalars['String'];
  nodes: Array<SelectionRow>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SelectionRowCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  groupId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<SelectionRowCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum SelectionRowCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SelectionRowResult = Model & {
  __typename: 'SelectionRowResult';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  selectionRow?: Maybe<SelectionRow>;
  selectionRowId: Scalars['Int'];
  sitePersonImfId: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type SelectionRowResultConnection = SearchableConnection & {
  __typename: 'SelectionRowResultConnection';
  hash: Scalars['String'];
  nodes: Array<SelectionRowResult>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SelectionRowResultCriteria = {
  aPureBaseId?: InputMaybe<Scalars['Int']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  imfCustomerCodes?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<SelectionRowResultCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  selectionType?: InputMaybe<SlicerSelectionType>;
};

export enum SelectionRowResultCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SetCustomValuesInput = {
  customFieldCode: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type Site = ImfModel & Model & {
  __typename: 'Site';
  activities: ActivityConnection;
  addressInformation: Array<VirtualAddressTypeWithValues>;
  addresses: AddressAffiliationConnection;
  affiliations: SitePersonConnection;
  apurebaseId?: Maybe<Scalars['Int']>;
  bricks: BrickConnection;
  /** Value Chain this specific site holds */
  chain?: Maybe<ImfDataValue>;
  childrenHierarchy: SiteClosureConnection;
  /** All contact types and it's values related this this site */
  contactInformation: Array<VirtualContactTypeWithValue>;
  contacts: ContactValueConnection;
  controlSetting?: Maybe<EntityControlSetting>;
  country: ValueCountry;
  countryCode: Scalars['String'];
  countryEnum: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  customFieldValue: Array<Maybe<Scalars['String']>>;
  customFields: CustomLinkValueConnection;
  dcrGroups: DcrGroupConnection;
  /**
   * It is not recommended to use this functionality, as this calculation is not always correct.
   * @deprecated Please do not ever use this, and if the current name and mailingNamePrefix isn't good enough, we should find a proper structure for it
   */
  departmentCalculatedName: SiteNameDepartmentCalculated;
  externalIdValue?: Maybe<Scalars['String']>;
  externalIds: ExternalIdConnection;
  /** All the filter codes this site is related to */
  filterCodes: FilterCodeConnection;
  id: Scalars['ID'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  isHcoCherryPicked?: Maybe<Scalars['Boolean']>;
  isLocal: Scalars['Boolean'];
  isUnplaced: Scalars['Boolean'];
  mailAddress?: Maybe<Address>;
  /** @deprecated Please use the address field object instead of this directly. */
  mailCity?: Maybe<Scalars['String']>;
  /** @deprecated Please use the address field object instead of this directly. */
  mailStreet?: Maybe<Scalars['String']>;
  /** @deprecated Please use the address field object instead of this directly. */
  mailZip?: Maybe<Scalars['String']>;
  mailingNamePrefix?: Maybe<Scalars['String']>;
  mainContact?: Maybe<ContactValue>;
  maintainerSource: DbSource;
  maintainerSourceCode: Scalars['String'];
  /** All the market access this site is related to */
  marketAccess: MarketAccessSiteConnection;
  mergeRequests: EntityMergeConnection;
  name: Scalars['String'];
  name2?: Maybe<Scalars['String']>;
  /** All notes this site has */
  notes: NoteConnection;
  numberOfBeds?: Maybe<Scalars['Int']>;
  numberOfChairs?: Maybe<Scalars['Int']>;
  originSource: DbSource;
  originSourceCode: Scalars['String'];
  /** This returns the manually set responsible user. To get the fully calculated responsible user for a site, please use the [responsibleUser] field instead. */
  overwrittenResponsibleUser?: Maybe<SiteResponsible>;
  parentHierarchy: SiteClosureConnection;
  parentId?: Maybe<Scalars['ID']>;
  parentSite?: Maybe<Site>;
  pendingDcrLines?: Maybe<Array<DcrLine>>;
  persons: PersonConnection;
  positionGroups: Array<PositionGroup>;
  responsibleUser: SiteResponsibleUserViewModel;
  selectionRows?: Maybe<SiteSelectionRowConnection>;
  /** This returns null if you don't have READ access to the Selection permission. */
  selectionRowsCustomerCount?: Maybe<Scalars['Int']>;
  sharedCustomFields?: Maybe<Array<CustomLinkValue>>;
  siteDcr?: Maybe<Array<Dcr>>;
  /** All lists this site is associated with */
  siteLists: ListConnection;
  /**
   * Always use this string to display the name of a site. If this name is wrong, it should be fixed in the backend and not via some frontend workaround.
   * @deprecated Just use [name] instead!
   */
  siteName: Scalars['String'];
  siteSectorType?: Maybe<ValueSiteSectorType>;
  siteSegmentationCode?: Maybe<SegmentationCode>;
  /** All specialties this site holds */
  siteSpecialties: ValueSiteSpecialtyConnection;
  siteTypeCode?: Maybe<Scalars['String']>;
  /** Returns all of the validation logs submitted to this record */
  siteValidationLogs?: Maybe<Array<EntityValidationLog>>;
  siteWebpage?: Maybe<Scalars['String']>;
  type?: Maybe<ImfDataValue>;
  ut: Scalars['DateTime'];
  visitAddress?: Maybe<Address>;
  /** @deprecated Please use the address field object instead of this directly. */
  visitCity?: Maybe<Scalars['String']>;
  /** @deprecated Please use the address field object instead of this directly. */
  visitStreet?: Maybe<Scalars['String']>;
  /** @deprecated Please use the address field object instead of this directly. */
  visitZip?: Maybe<Scalars['String']>;
};


export type SiteactivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


export type SiteaddressesArgs = {
  criteria?: InputMaybe<AddressAffiliationCriteria>;
};


export type SiteaffiliationsArgs = {
  criteria?: InputMaybe<SitePersonCriteria>;
};


export type SitebricksArgs = {
  criteria?: InputMaybe<BrickCriteria>;
};


export type SitecontactInformationArgs = {
  typeCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type SitecontactsArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};


export type SitecountryCodeArgs = {
  asLowerCase?: InputMaybe<Scalars['Boolean']>;
};


export type SitecustomFieldValueArgs = {
  fieldCode: Scalars['String'];
};


export type SitecustomFieldsArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
};


export type SitedcrGroupsArgs = {
  criteria?: InputMaybe<DcrGroupCriteria>;
};


export type SiteexternalIdValueArgs = {
  externalIdTypeCode: Scalars['String'];
};


export type SiteexternalIdsArgs = {
  criteria?: InputMaybe<ExternalIdCriteria>;
};


export type SitefilterCodesArgs = {
  criteria?: InputMaybe<FilterCodeCriteria>;
};


export type SitemainContactArgs = {
  type: ContactTypeEnum;
};


export type SitemarketAccessArgs = {
  criteria?: InputMaybe<MarketAccessSiteCriteria>;
};


export type SitemergeRequestsArgs = {
  criteria?: InputMaybe<EntityMergeCriteria>;
};


export type SitenotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


export type SitepersonsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type SiteselectionRowsArgs = {
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
};


export type SiteselectionRowsCustomerCountArgs = {
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
};


export type SitesiteListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


export type SitesiteSpecialtiesArgs = {
  criteria?: InputMaybe<ValueSiteSpecialtyCriteria>;
};

export type SiteActivity_EntityDataToBeTransferredType = {
  __typename: 'SiteActivity_EntityDataToBeTransferredType';
  activityIds: Array<Scalars['ID']>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export type SiteAddress_EntityDataToBeTransferredType = {
  __typename: 'SiteAddress_EntityDataToBeTransferredType';
  addressAffiliation: AddressAffiliation;
  code: Scalars['String'];
  conflictedWith?: Maybe<AddressAffiliation>;
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
};

export enum SiteBrickCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteChain = {
  __typename: 'SiteChain';
  ct: Scalars['DateTime'];
  id: SiteChainId;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export enum SiteChainCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteChainId = {
  __typename: 'SiteChainId';
  chainCode: Scalars['String'];
  siteId: Scalars['ID'];
};

export type SiteClosure = {
  __typename: 'SiteClosure';
  ancestor: Site;
  ancestorId: Scalars['ID'];
  depth: Scalars['Int'];
  descendant: Site;
  descendantId: Scalars['ID'];
};

export type SiteClosureConnection = {
  __typename: 'SiteClosureConnection';
  hash: Scalars['String'];
  nodes: Array<SiteClosure>;
  totalCount: Scalars['Int'];
};

export enum SiteClosureCriteriaOrder {
  DEPTH_ASC = 'DEPTH_ASC',
  DEPTH_DESC = 'DEPTH_DESC'
}

export type SiteConnection = EntityTypeConnection & SearchableConnection & {
  __typename: 'SiteConnection';
  globalAdditionalCount: Scalars['Int'];
  hash: Scalars['String'];
  justForTesting: Scalars['Int'];
  nodes: Array<Site>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SiteContactValue_EntityDataToBeTransferredType = {
  __typename: 'SiteContactValue_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserValue: ContactValue;
  winnerValue?: Maybe<ContactValue>;
};

export type SiteCountry_EntityDataToBeTransferredType = {
  __typename: 'SiteCountry_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['CountryCode'];
  to?: Maybe<Scalars['CountryCode']>;
};

export type SiteCreated = {
  __typename: 'SiteCreated';
  dcr?: Maybe<Dcr>;
  dcrGroup?: Maybe<DcrGroup>;
  site?: Maybe<Site>;
};

export type SiteCriteria = {
  aPureBaseId?: InputMaybe<Scalars['Int']>;
  aPureBaseIds?: InputMaybe<Array<Scalars['Int']>>;
  activityId?: InputMaybe<Scalars['ID']>;
  activityIdWithPersonRelations?: InputMaybe<Scalars['ID']>;
  byPrimaryLinkFromPersonIds?: InputMaybe<Array<Scalars['ID']>>;
  containDcrWithApbId?: InputMaybe<Scalars['Boolean']>;
  containMergeRequest?: InputMaybe<Scalars['Boolean']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  country?: InputMaybe<Scalars['CountryCode']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  customFieldValues?: InputMaybe<Array<CustomFieldSearchInput>>;
  dbSource?: InputMaybe<Scalars['String']>;
  dcrId?: InputMaybe<Scalars['ID']>;
  excludeIds?: InputMaybe<Array<Scalars['ID']>>;
  fetchSize?: InputMaybe<FetchSize>;
  hasApureBaseId?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  imfCreatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfUpdatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfValidatedAfter?: InputMaybe<Scalars['DateTime']>;
  includeUnplaced?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<ActiveEnum>;
  listId?: InputMaybe<Scalars['ID']>;
  numberOfBeds?: InputMaybe<Scalars['Int']>;
  numberOfChairs?: InputMaybe<Scalars['Int']>;
  ordering?: InputMaybe<Array<SiteCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  primaryId?: InputMaybe<Scalars['Int']>;
  responsibleUserId?: InputMaybe<Scalars['ID']>;
  searchGlobal?: InputMaybe<Scalars['Boolean']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  segmentationCode?: InputMaybe<Scalars['String']>;
  siteEmail?: InputMaybe<Scalars['String']>;
  siteFax?: InputMaybe<Scalars['String']>;
  siteName?: InputMaybe<Scalars['String']>;
  siteName2?: InputMaybe<Scalars['String']>;
  siteNote?: InputMaybe<Scalars['String']>;
  siteSectorType?: InputMaybe<Scalars['String']>;
  siteTele?: InputMaybe<Scalars['String']>;
  siteWebpage?: InputMaybe<Scalars['String']>;
  specialityCodes?: InputMaybe<Array<Scalars['String']>>;
  territoryCode?: InputMaybe<Scalars['String']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
  withDuplicatedApureBaseIds?: InputMaybe<Scalars['Boolean']>;
};

export enum SiteCriteriaOrder {
  CHAIN_ASC = 'CHAIN_ASC',
  CHAIN_DESC = 'CHAIN_DESC',
  COUNTRY_ASC = 'COUNTRY_ASC',
  COUNTRY_DESC = 'COUNTRY_DESC',
  CT_ASC = 'CT_ASC',
  CT_DESC = 'CT_DESC',
  IMF_CT_ASC = 'IMF_CT_ASC',
  IMF_CT_DESC = 'IMF_CT_DESC',
  IMF_UT_ASC = 'IMF_UT_ASC',
  IMF_UT_DESC = 'IMF_UT_DESC',
  IMF_VT_ASC = 'IMF_VT_ASC',
  IMF_VT_DESC = 'IMF_VT_DESC',
  MAIL_ADDRESS_LINE_2_ASC = 'MAIL_ADDRESS_LINE_2_ASC',
  MAIL_ADDRESS_LINE_2_DESC = 'MAIL_ADDRESS_LINE_2_DESC',
  MAIL_STREET_ASC = 'MAIL_STREET_ASC',
  MAIL_STREET_DESC = 'MAIL_STREET_DESC',
  NAME2_ASC = 'NAME2_ASC',
  NAME2_DESC = 'NAME2_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  NUMBER_OF_BEDS_ASC = 'NUMBER_OF_BEDS_ASC',
  NUMBER_OF_BEDS_DESC = 'NUMBER_OF_BEDS_DESC',
  NUMBER_OF_CHAIRS_ASC = 'NUMBER_OF_CHAIRS_ASC',
  NUMBER_OF_CHAIRS_DESC = 'NUMBER_OF_CHAIRS_DESC',
  ORIGIN_SOURCE_APB = 'ORIGIN_SOURCE_APB',
  PARENT_NAME_ASC = 'PARENT_NAME_ASC',
  PARENT_NAME_DESC = 'PARENT_NAME_DESC',
  SITE_SECTOR_TYPE_ASC = 'SITE_SECTOR_TYPE_ASC',
  SITE_SECTOR_TYPE_DESC = 'SITE_SECTOR_TYPE_DESC',
  SITE_TYPE_ASC = 'SITE_TYPE_ASC',
  SITE_TYPE_DESC = 'SITE_TYPE_DESC',
  UT_ASC = 'UT_ASC',
  UT_DESC = 'UT_DESC',
  VISIT_ADDRESS_LINE_2_ASC = 'VISIT_ADDRESS_LINE_2_ASC',
  VISIT_ADDRESS_LINE_2_DESC = 'VISIT_ADDRESS_LINE_2_DESC',
  VISIT_CITY_ASC = 'VISIT_CITY_ASC',
  VISIT_CITY_DESC = 'VISIT_CITY_DESC',
  VISIT_POSTAL_CODE_ASC = 'VISIT_POSTAL_CODE_ASC',
  VISIT_POSTAL_CODE_DESC = 'VISIT_POSTAL_CODE_DESC',
  VISIT_STREET_ASC = 'VISIT_STREET_ASC',
  VISIT_STREET_DESC = 'VISIT_STREET_DESC'
}

export type SiteCustomField_EntityDataToBeTransferredType = {
  __typename: 'SiteCustomField_EntityDataToBeTransferredType';
  affiliationsToMove: Array<CustomFieldToBeTransferredInfo>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  field: CustomField;
  loserExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
  winnerExistingAffiliations: Array<CustomFieldToBeTransferredInfo>;
};

export type SiteExternalId_EntityDataToBeTransferredType = {
  __typename: 'SiteExternalId_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  existingExternalId?: Maybe<ExternalId>;
  externalId: ExternalId;
};

export type SiteFilterCode = Model & {
  __typename: 'SiteFilterCode';
  ct: Scalars['DateTime'];
  filterCode: FilterCode;
  filterCodeId: Scalars['ID'];
  id: Scalars['ID'];
  site: Site;
  siteId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type SiteFilterCodeConnection = SearchableConnection & {
  __typename: 'SiteFilterCodeConnection';
  hash: Scalars['String'];
  nodes: Array<SiteFilterCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SiteFilterCodeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  filterCodeId?: InputMaybe<Scalars['ID']>;
  ordering?: InputMaybe<Array<SiteFilterCodeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
};

export enum SiteFilterCodeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteInput = {
  addresses?: InputMaybe<Array<AddressInput>>;
  chainCode?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<NewContactInput>>;
  country: Scalars['CountryCode'];
  customFieldValues?: InputMaybe<Array<SetCustomValuesInput>>;
  departmentName?: InputMaybe<Scalars['String']>;
  instantValidation?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  numberOfBeds?: InputMaybe<Scalars['Int']>;
  numberOfChairs?: InputMaybe<Scalars['Int']>;
  parentSiteId?: InputMaybe<Scalars['ID']>;
  siteSectorType?: InputMaybe<Scalars['String']>;
  specialtyCodes?: InputMaybe<Array<Scalars['String']>>;
  typeCode: Scalars['String'];
  webPage?: InputMaybe<Scalars['String']>;
};

export type SiteIsUnplaced_EntityDataToBeTransferredType = {
  __typename: 'SiteIsUnplaced_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['Boolean'];
  to: Scalars['Boolean'];
};

export type SiteLinkToBeMergedVirtualOverview = {
  __typename: 'SiteLinkToBeMergedVirtualOverview';
  effects: Array<VirtualEntityMergeFieldInfo>;
  loser: SitePerson;
  winner: SitePerson;
};

export type SiteLinks_EntityDataToBeTransferredType = {
  __typename: 'SiteLinks_EntityDataToBeTransferredType';
  alreadyOnWinner: Array<SitePerson>;
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  toBeMerged: Array<SiteLinkToBeMergedVirtualOverview>;
  toBeMoved: Array<SitePerson>;
};

export type SiteLists_EntityDataToBeTransferredType = {
  __typename: 'SiteLists_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  listIds: Array<Scalars['ID']>;
};

export type SiteMailingNamePrefix_EntityDataToBeTransferredType = {
  __typename: 'SiteMailingNamePrefix_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type SiteMatchCandidate = {
  __typename: 'SiteMatchCandidate';
  apurebaseId: Scalars['String'];
  inLocalDb: Scalars['Boolean'];
  result: ApiSiteMatch;
  score: Scalars['Int'];
};

export type SiteMatchCandidateData = {
  __typename: 'SiteMatchCandidateData';
  apurebaseId: Scalars['Int'];
  name: Scalars['String'];
};

export type SiteMatchInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SiteNameDepartmentCalculated = {
  __typename: 'SiteNameDepartmentCalculated';
  departmentName?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
};

export type SiteName_EntityDataToBeTransferredType = {
  __typename: 'SiteName_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from: Scalars['String'];
  to: Scalars['String'];
};

export type SiteNotes_EntityDataToBeTransferredType = {
  __typename: 'SiteNotes_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  noteIds: Array<Scalars['ID']>;
};

export type SiteParent_EntityDataToBeTransferredType = {
  __typename: 'SiteParent_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  fromParentSite?: Maybe<Site>;
  toParentSite?: Maybe<Site>;
};

export type SitePerson = ImfModel & Model & {
  __typename: 'SitePerson';
  apurebaseId?: Maybe<Scalars['Int']>;
  /** All contact types and it's values related this this link */
  contactInformation: Array<VirtualContactTypeWithValue>;
  contacts: ContactValueConnection;
  controlSetting?: Maybe<EntityControlSetting>;
  countryCode: Scalars['String'];
  countryEnum: Scalars['CountryCode'];
  ct: Scalars['DateTime'];
  customFields: CustomLinkValueConnection;
  externalIdValue?: Maybe<Scalars['String']>;
  externalIds: ExternalIdConnection;
  id: Scalars['ID'];
  imfCt?: Maybe<Scalars['DateTime']>;
  imfUt?: Maybe<Scalars['DateTime']>;
  imfVt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  isLocal: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  linkDcr?: Maybe<Array<Dcr>>;
  mainContact?: Maybe<ContactValue>;
  maintainerSource: DbSource;
  maintainerSourceCode: Scalars['String'];
  /** All the market access this link is related to */
  marketAccess: MarketAccessSitePersonConnection;
  /** All notes this affiliation has */
  notes: NoteConnection;
  numberOfPatients?: Maybe<Scalars['Int']>;
  originSource: DbSource;
  originSourceCode: Scalars['String'];
  pendingLinkDcrLines?: Maybe<Array<DcrLine>>;
  persId: Scalars['ID'];
  person: Person;
  position?: Maybe<ImfDataValue>;
  positionCode?: Maybe<Scalars['String']>;
  /** This returns null if you don't have READ access to the Selection permission. */
  selectionRowsCustomerCount?: Maybe<Scalars['Int']>;
  site: Site;
  siteId: Scalars['ID'];
  specialties: SitePersonWorkSpecialtyConnection;
  specialtyValues: ValueWorkingSpecialtyConnection;
  therapeuticFocusAffiliations: SitePersonTherapeuticFocusConnection;
  therapeuticFocuses: ValueTherapeuticFocusConnection;
  ut: Scalars['DateTime'];
  validatedByUser?: Maybe<User>;
  /** This returns 'Yes' if this is the primary link, otherwise an empty string */
  yesIfIsPrimary: Scalars['String'];
};


export type SitePersoncontactInformationArgs = {
  typeCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type SitePersoncontactsArgs = {
  criteria?: InputMaybe<ContactValueCriteria>;
};


export type SitePersoncustomFieldsArgs = {
  criteria?: InputMaybe<CustomLinkValueCriteria>;
};


export type SitePersonexternalIdValueArgs = {
  externalIdTypeCode: Scalars['String'];
};


export type SitePersonexternalIdsArgs = {
  criteria?: InputMaybe<ExternalIdCriteria>;
};


export type SitePersonmainContactArgs = {
  type: ContactTypeEnum;
};


export type SitePersonmarketAccessArgs = {
  criteria?: InputMaybe<MarketAccessSitePersonCriteria>;
};


export type SitePersonnotesArgs = {
  criteria?: InputMaybe<NoteCriteria>;
};


export type SitePersonselectionRowsCustomerCountArgs = {
  criteria?: InputMaybe<SelectionRowResultCriteria>;
};


export type SitePersonspecialtyValuesArgs = {
  criteria?: InputMaybe<ValueWorkingSpecialtyCriteria>;
};


export type SitePersontherapeuticFocusAffiliationsArgs = {
  criteria?: InputMaybe<SitePersonTherapeuticFocusCriteria>;
};


export type SitePersontherapeuticFocusesArgs = {
  criteria?: InputMaybe<ValueTherapeuticFocusCriteria>;
};

export type SitePersonConnection = EntityTypeConnection & SearchableConnection & {
  __typename: 'SitePersonConnection';
  hash: Scalars['String'];
  justForTesting: Scalars['Int'];
  nodes: Array<SitePerson>;
  primarySite?: Maybe<SitePerson>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SitePersonCreated = {
  __typename: 'SitePersonCreated';
  dcr?: Maybe<Dcr>;
  dcrGroup?: Maybe<DcrGroup>;
  site?: Maybe<SiteCreated>;
  sitePerson?: Maybe<SitePerson>;
};

export type SitePersonCriteria = {
  apurebaseId?: InputMaybe<Scalars['Int']>;
  apurebaseIds?: InputMaybe<Array<Scalars['Int']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  dbSource?: InputMaybe<Scalars['String']>;
  dcrGroupResponses?: InputMaybe<Array<DcrResponseTypeEnum>>;
  dcrId?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  imfCreatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfUpdatedAfter?: InputMaybe<Scalars['DateTime']>;
  imfValidatedAfter?: InputMaybe<Scalars['DateTime']>;
  isActive?: InputMaybe<ActiveEnum>;
  nullApurebaseId?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<SitePersonCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  primaryOnly?: InputMaybe<Scalars['Boolean']>;
  searchGlobal?: InputMaybe<Scalars['Boolean']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
};

export enum SitePersonCriteriaOrder {
  APUREBASE_ID_ASC = 'APUREBASE_ID_ASC',
  APUREBASE_ID_DESC = 'APUREBASE_ID_DESC',
  CT_ASC = 'CT_ASC',
  CT_DESC = 'CT_DESC',
  ID_ASC = 'ID_ASC',
  ID_DESC = 'ID_DESC',
  IMF_CT_ASC = 'IMF_CT_ASC',
  IMF_CT_DESC = 'IMF_CT_DESC',
  IMF_UT_ASC = 'IMF_UT_ASC',
  IMF_UT_DESC = 'IMF_UT_DESC',
  IMF_VT_ASC = 'IMF_VT_ASC',
  IMF_VT_DESC = 'IMF_VT_DESC',
  LINK_PERSON_EDUCATION_ASC = 'LINK_PERSON_EDUCATION_ASC',
  LINK_PERSON_EDUCATION_DESC = 'LINK_PERSON_EDUCATION_DESC',
  NUMBER_OF_PATIENTS_ASC = 'NUMBER_OF_PATIENTS_ASC',
  NUMBER_OF_PATIENTS_DESC = 'NUMBER_OF_PATIENTS_DESC',
  PERSON_FIRSTNAME_ASC = 'PERSON_FIRSTNAME_ASC',
  PERSON_FIRSTNAME_DESC = 'PERSON_FIRSTNAME_DESC',
  PERSON_LASTNAME_ASC = 'PERSON_LASTNAME_ASC',
  PERSON_LASTNAME_DESC = 'PERSON_LASTNAME_DESC',
  PERSON_MIDDLENAME_ASC = 'PERSON_MIDDLENAME_ASC',
  PERSON_MIDDLENAME_DESC = 'PERSON_MIDDLENAME_DESC',
  PERSON_TITLE_ASC = 'PERSON_TITLE_ASC',
  PERSON_TITLE_DESC = 'PERSON_TITLE_DESC',
  PERSON_TYPE_ASC = 'PERSON_TYPE_ASC',
  PERSON_TYPE_DESC = 'PERSON_TYPE_DESC',
  POSITION_ASC = 'POSITION_ASC',
  POSITION_DESC = 'POSITION_DESC',
  PRIMARY_FIRST = 'PRIMARY_FIRST',
  PRIMARY_LAST = 'PRIMARY_LAST',
  SITE_NAME_ASC = 'SITE_NAME_ASC',
  SITE_NAME_DESC = 'SITE_NAME_DESC',
  SITE_PARENT_NAME_ASC = 'SITE_PARENT_NAME_ASC',
  SITE_PARENT_NAME_DESC = 'SITE_PARENT_NAME_DESC',
  SITE_TYPE_ASC = 'SITE_TYPE_ASC',
  SITE_TYPE_DESC = 'SITE_TYPE_DESC',
  THERAPEUTIC_FOCUS_ASC = 'THERAPEUTIC_FOCUS_ASC',
  THERAPEUTIC_FOCUS_DESC = 'THERAPEUTIC_FOCUS_DESC',
  UT_ASC = 'UT_ASC',
  UT_DESC = 'UT_DESC',
  VALIDATED_BY_USER_FULLNAME_ASC = 'VALIDATED_BY_USER_FULLNAME_ASC',
  VALIDATED_BY_USER_FULLNAME_DESC = 'VALIDATED_BY_USER_FULLNAME_DESC',
  WORKING_SPC_ASC = 'WORKING_SPC_ASC',
  WORKING_SPC_DESC = 'WORKING_SPC_DESC'
}

export type SitePersonMatchInput = {
  role?: InputMaybe<Scalars['String']>;
  workSpeciality?: InputMaybe<Scalars['String']>;
};

export type SitePersonTherapeuticFocus = Model & {
  __typename: 'SitePersonTherapeuticFocus';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  sitePerson: SitePerson;
  sitePersonId: Scalars['ID'];
  therapeuticFocus: DataValue;
  therapeuticFocusCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type SitePersonTherapeuticFocusConnection = SearchableConnection & {
  __typename: 'SitePersonTherapeuticFocusConnection';
  hash: Scalars['String'];
  nodes: Array<SitePersonTherapeuticFocus>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SitePersonTherapeuticFocusCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SitePersonTherapeuticFocusCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
};

export enum SitePersonTherapeuticFocusCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SitePersonWorkSpecialtyConnection = SearchableConnection & {
  __typename: 'SitePersonWorkSpecialtyConnection';
  hash: Scalars['String'];
  nodes: Array<SitePersonWorkingSpecialty>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type SitePersonWorkingSpecialty = Model & {
  __typename: 'SitePersonWorkingSpecialty';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  imfCt: Scalars['DateTime'];
  imfUt: Scalars['DateTime'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  sitePersonId: Scalars['ID'];
  specialty: ImfDataValue;
  ut: Scalars['DateTime'];
  workingSpecialtyCode: Scalars['String'];
};

export type SitePersonWorkingSpecialtyCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<SitePersonWorkingSpecialtyCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
  sitePersonIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum SitePersonWorkingSpecialtyCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteResponsible = Model & {
  __typename: 'SiteResponsible';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  responsibleUserId: Scalars['ID'];
  setByUserId?: Maybe<Scalars['ID']>;
  site: Site;
  siteId: Scalars['ID'];
  user: User;
  ut: Scalars['DateTime'];
};

export type SiteResponsibleConnection = SearchableConnection & {
  __typename: 'SiteResponsibleConnection';
  hash: Scalars['String'];
  nodes: Array<SiteResponsible>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export enum SiteResponsibleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteResponsibleUserViewModel = {
  __typename: 'SiteResponsibleUserViewModel';
  brickCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  responsibleUserId?: Maybe<Scalars['ID']>;
  siteId: Scalars['ID'];
  user?: Maybe<User>;
};

export type SiteResponsibleUserViewModelConnection = {
  __typename: 'SiteResponsibleUserViewModelConnection';
  hash: Scalars['String'];
  nodes: Array<SiteResponsibleUserViewModel>;
  totalCount: Scalars['Int'];
};

export type SiteSegmentationCode = Model & {
  __typename: 'SiteSegmentationCode';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  segmentationCode: SegmentationCode;
  segmentationCodeId: Scalars['ID'];
  siteId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type SiteSegmentation_EntityDataToBeTransferredType = {
  __typename: 'SiteSegmentation_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loser: SegmentationCode;
  winner?: Maybe<SegmentationCode>;
};

export type SiteSelectionRow = {
  __typename: 'SiteSelectionRow';
  ct: Scalars['DateTime'];
  id: Scalars['Long'];
  selectionRow?: Maybe<SelectionRow>;
  site?: Maybe<Site>;
  siteApurebaseId: Scalars['Int'];
};

export type SiteSelectionRowConnection = {
  __typename: 'SiteSelectionRowConnection';
  hash: Scalars['String'];
  nodes: Array<SiteSelectionRow>;
  totalCount: Scalars['Int'];
};

export type SiteSelectionRowCriteria = {
  aPureBaseId?: InputMaybe<Scalars['Int']>;
  fetchSize?: InputMaybe<FetchSize>;
  imfCustomerCodes?: InputMaybe<Array<Scalars['String']>>;
  ordering?: InputMaybe<Array<SiteSelectionRowCriteriaOrder>>;
  selectionRowId?: InputMaybe<Scalars['ID']>;
  selectionType?: InputMaybe<SlicerSelectionType>;
};

export enum SiteSelectionRowCriteriaOrder {
  CUSTOMER_NAME_ASC = 'CUSTOMER_NAME_ASC',
  CUSTOMER_NAME_DESC = 'CUSTOMER_NAME_DESC',
  ROW_ID_ASC = 'ROW_ID_ASC',
  ROW_ID_DESC = 'ROW_ID_DESC',
  SELECTION_DESCRIPTION_ASC = 'SELECTION_DESCRIPTION_ASC',
  SELECTION_DESCRIPTION_DESC = 'SELECTION_DESCRIPTION_DESC',
  SELECTION_GROUP_DESCRIPTION_ASC = 'SELECTION_GROUP_DESCRIPTION_ASC',
  SELECTION_GROUP_DESCRIPTION_DESC = 'SELECTION_GROUP_DESCRIPTION_DESC',
  SELECTION_TYPE_ASC = 'SELECTION_TYPE_ASC',
  SELECTION_TYPE_DESC = 'SELECTION_TYPE_DESC'
}

export type SiteSpecialty = {
  __typename: 'SiteSpecialty';
  ct: Scalars['DateTime'];
  id: SiteSpecialtyId;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export enum SiteSpecialtyCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type SiteSpecialtyId = {
  __typename: 'SiteSpecialtyId';
  siteId: Scalars['ID'];
  siteSpecialtyCode: Scalars['String'];
};

export type SiteTags_EntityDataToBeTransferredType = {
  __typename: 'SiteTags_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  loserCodes: Array<SiteFilterCode>;
  winnerCodes: Array<SiteFilterCode>;
};

export type SiteType_EntityDataToBeTransferredType = {
  __typename: 'SiteType_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  fromCode?: Maybe<Scalars['String']>;
  toCode?: Maybe<Scalars['String']>;
};

export type SiteWebpage_EntityDataToBeTransferredType = {
  __typename: 'SiteWebpage_EntityDataToBeTransferredType';
  code: Scalars['String'];
  dataType: EntityDataToBeTransferredDataTypeEnum;
  entityType: EntityTypeEnum;
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export enum SlicerSelectionType {
  DYNAMIC = 'DYNAMIC',
  EXCLUDE = 'EXCLUDE',
  GLOBAL = 'GLOBAL',
  SALES_DATA = 'SALES_DATA',
  TEMPLATE = 'TEMPLATE'
}

export enum SourceEnum {
  APB = 'APB',
  LOCAL = 'LOCAL'
}

export type StandardTitle = Model & {
  __typename: 'StandardTitle';
  active: Scalars['Boolean'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  label: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type StandardTitleConnection = {
  __typename: 'StandardTitleConnection';
  hash: Scalars['String'];
  nodes: Array<StandardTitle>;
  totalCount: Scalars['Int'];
};

export type StandardTitleCriteria = {
  active?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<StandardTitleCriteriaOrder>>;
};

export enum StandardTitleCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type TableMapper = {
  __typename: 'TableMapper';
  code: Scalars['String'];
  criterias: CriteriaGroupConnection;
  entityType: EntityTypeEnum;
  joinSupport: Array<MappingJoinSupport>;
  mappingName: Scalars['String'];
  tableCols: Array<Scalars['String']>;
  tableColumns: Array<CustomMapping>;
  tableName: Scalars['String'];
};


export type TableMapperjoinSupportArgs = {
  mode?: InputMaybe<IsMappingJoinBasicEnum>;
  search?: InputMaybe<Scalars['String']>;
};

export type Team = Model & {
  __typename: 'Team';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  getResponsibleTeamUser?: Maybe<User>;
  id: Scalars['ID'];
  responsibleUser: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['String'];
  /** All the users affiliated to a Team */
  userTeamAffiliations: UserTeamConnection;
  ut: Scalars['DateTime'];
};


export type TeamuserTeamAffiliationsArgs = {
  criteria?: InputMaybe<UserTeamCriteria>;
};

export type TeamConnection = {
  __typename: 'TeamConnection';
  hash: Scalars['String'];
  nodes: Array<Team>;
  totalCount: Scalars['Int'];
};

export type TeamCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<TeamCriteriaOrder>>;
  responsibleUser?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  status?: InputMaybe<ArchiveStatusEnum>;
  title?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum TeamCriteriaOrder {
  TITLE_ASC = 'TITLE_ASC',
  TITLE_DESC = 'TITLE_DESC'
}

export type Territory = {
  __typename: 'Territory';
  bricks: BrickConnection;
  code: Scalars['String'];
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  responsibleUser?: Maybe<User>;
  responsibleUserId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};


export type TerritorybricksArgs = {
  criteria?: InputMaybe<BrickCriteria>;
};

export type TerritoryConnection = SearchableConnection & {
  __typename: 'TerritoryConnection';
  hash: Scalars['String'];
  nodes: Array<Territory>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type TerritoryCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  heading?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ordering?: InputMaybe<Array<TerritoryCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum TerritoryCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type UnitType = Model & {
  __typename: 'UnitType';
  abbreviation: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type UpdateActivityInput = {
  activityId: Scalars['Int'];
  activityTypeCode?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  heading?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<ActivityStatusEnum>;
};

export type UpdateActivityTypeInput = {
  brandRule: AttachmentRuleEnum;
  colorCode: Scalars['String'];
  defaultHeading?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationRule: AttachmentRuleEnum;
  participationUserRule: AttachmentRuleEnum;
  personRule: AttachmentRuleEnum;
  productRule: AttachmentRuleEnum;
  projectRule: AttachmentRuleEnum;
  responsibleUserRule: AttachmentRuleEnum;
  sort?: InputMaybe<Scalars['Int']>;
  standardTimeLengthMinutes: Scalars['Int'];
  superTypeCode: Scalars['String'];
};

export type UpdateContactCategoryInput = {
  allowMultipleValues: Scalars['Boolean'];
  code: Scalars['String'];
  heading: Scalars['String'];
  isHeadingKey?: InputMaybe<Scalars['Boolean']>;
  type: ContactTypeEnum;
};

export type UpdateCustomFieldInput = {
  allowCountrySpecificValues?: InputMaybe<Scalars['Boolean']>;
  allowMultiple?: InputMaybe<Scalars['Boolean']>;
  allowUserCreate?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  color?: InputMaybe<Scalars['String']>;
  entityType: EntityTypeEnum;
  heading: Scalars['String'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isCheckableTag?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<UpdateCustomFieldOptionInput>>;
  type: CustomFieldTypeEnum;
};

export type UpdateCustomFieldOptionInput = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  optionId: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateListInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isShared?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSelectCustomFieldValueForRecord = {
  newValue?: InputMaybe<Scalars['String']>;
  valueId?: InputMaybe<Scalars['ID']>;
};

export type UpdateUserInput = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['Int']>;
  userId: Scalars['ID'];
  username?: InputMaybe<Scalars['String']>;
};

export type User = Model & {
  __typename: 'User';
  TeamResponsible: TeamConnection;
  activities: ActivityConnection;
  apiEnabled: Scalars['Boolean'];
  countries: ValueCountryConnection;
  countryAffiliations: UserCountryConnection;
  ct: Scalars['DateTime'];
  deliveries: PersonActivityProductConnection;
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  /** The person full name in one field */
  fullname: Scalars['String'];
  /** Displays if the user prefers English LOV's */
  hasEnglishAsDefault: Scalars['Boolean'];
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  lastname?: Maybe<Scalars['String']>;
  md5Email: Scalars['String'];
  role: Role;
  roleId: Scalars['ID'];
  sitesResponsibleFor: SiteConnection;
  teamAffiliations: UserTeamConnection;
  teams: TeamConnection;
  /** The person full name in one field */
  testyTest: Array<PersonUser>;
  ut: Scalars['DateTime'];
};


export type UserTeamResponsibleArgs = {
  criteria?: InputMaybe<TeamCriteria>;
};


export type UseractivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


export type UsercountriesArgs = {
  criteria?: InputMaybe<ValueCountryCriteria>;
};


export type UsercountryAffiliationsArgs = {
  criteria?: InputMaybe<UserCountryCriteria>;
};


export type UserdeliveriesArgs = {
  criteria?: InputMaybe<PersonActivityProductCriteria>;
};


export type UsersitesResponsibleForArgs = {
  criteria?: InputMaybe<SiteCriteria>;
};


export type UserteamAffiliationsArgs = {
  criteria?: InputMaybe<UserTeamCriteria>;
};


export type UserteamsArgs = {
  criteria?: InputMaybe<TeamCriteria>;
};

export type UserConnection = SearchableConnection & {
  __typename: 'UserConnection';
  hash: Scalars['String'];
  nodes: Array<User>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type UserCountry = Model & {
  __typename: 'UserCountry';
  countryCode: Scalars['String'];
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  status: Scalars['Boolean'];
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type UserCountryConnection = {
  __typename: 'UserCountryConnection';
  hash: Scalars['String'];
  nodes: Array<UserCountry>;
  totalCount: Scalars['Int'];
};

export type UserCountryCriteria = {
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<UserCountryCriteriaOrder>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum UserCountryCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type UserCriteria = {
  activityId?: InputMaybe<Scalars['ID']>;
  activityIds?: InputMaybe<Array<Scalars['ID']>>;
  activityResponsibleUserInTimeSpanFilter?: InputMaybe<DateSpanFilter>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  deliveryId?: InputMaybe<Scalars['ID']>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  listId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<UserCriteriaOrder>>;
  projectId?: InputMaybe<Scalars['ID']>;
  responsibleForSitesInTerritoryCode?: InputMaybe<Scalars['String']>;
  responsibleId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export enum UserCriteriaOrder {
  TODO = 'TODO'
}

export type UserFavInput = {
  listId?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
};

export type UserPreferEnglishLov = Model & {
  __typename: 'UserPreferEnglishLov';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  status: Scalars['Boolean'];
  user: User;
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export enum UserPreferEnglishLovCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type UserTableColumn = Model & {
  __typename: 'UserTableColumn';
  columnKey: Scalars['String'];
  ct: Scalars['DateTime'];
  entityType: EntityTypeEnum;
  entityTypeId: Scalars['ID'];
  id: Scalars['ID'];
  sort: Scalars['Int'];
  userId?: Maybe<Scalars['ID']>;
  ut: Scalars['DateTime'];
};

export type UserTableColumnConnection = SearchableConnection & {
  __typename: 'UserTableColumnConnection';
  hash: Scalars['String'];
  nodes: Array<UserTableColumn>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type UserTableColumnCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  entityType?: InputMaybe<EntityTypeEnum>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<UserTableColumnCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum UserTableColumnCriteriaOrder {
  SORT_ASC = 'SORT_ASC',
  SORT_DESC = 'SORT_DESC'
}

export type UserTeam = Model & {
  __typename: 'UserTeam';
  ct: Scalars['DateTime'];
  id: Scalars['ID'];
  status: Scalars['Int'];
  teamId: Scalars['ID'];
  userId: Scalars['ID'];
  ut: Scalars['DateTime'];
};

export type UserTeamConnection = {
  __typename: 'UserTeamConnection';
  hash: Scalars['String'];
  nodes: Array<UserTeam>;
  totalCount: Scalars['Int'];
};

export type UserTeamCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<UserTeamCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  teamId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum UserTeamCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ValueChainConnection = {
  __typename: 'ValueChainConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
};

export type ValueChainCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueChainCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueChainCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueCommuneConnection = SearchableConnection & {
  __typename: 'ValueCommuneConnection';
  hash: Scalars['String'];
  nodes: Array<DataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueCommuneCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueCommuneCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueCommuneCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY'
}

export type ValueCountry = {
  __typename: 'ValueCountry';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  isGlobalOnly: Scalars['Boolean'];
  label: Scalars['String'];
  labelGb?: Maybe<Scalars['String']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ValueCountryConnection = SearchableConnection & {
  __typename: 'ValueCountryConnection';
  hash: Scalars['String'];
  nodes: Array<ValueCountry>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueCountryCriteria = {
  codes?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueCountryCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export enum ValueCountryCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY'
}

export type ValueCountyConnection = SearchableConnection & {
  __typename: 'ValueCountyConnection';
  hash: Scalars['String'];
  nodes: Array<DataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueCountyCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueCountyCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueCountyCriteriaOrder {
  ALPHABETICALLY = 'ALPHABETICALLY'
}

export type ValueEducationConnection = SearchableConnection & {
  __typename: 'ValueEducationConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueEducationCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueEducationCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueEducationCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueLanguage = {
  __typename: 'ValueLanguage';
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  isActive: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type ValueModel = Model & {
  __typename: 'ValueModel';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  id: Scalars['ID'];
  isHeadingKey: Scalars['Boolean'];
  ut: Scalars['DateTime'];
};

export type ValuePersonTypeConnection = SearchableConnection & {
  __typename: 'ValuePersonTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValuePersonTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValuePersonTypeCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValuePersonTypeCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValuePositionConnection = SearchableConnection & {
  __typename: 'ValuePositionConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValuePositionCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  country?: InputMaybe<Scalars['CountryCode']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValuePositionCriteriaOrder>>;
  persId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValuePositionCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValuePostalCode = {
  __typename: 'ValuePostalCode';
  code: Scalars['String'];
  countryCode: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  ct: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ValuePostalCodeConnection = SearchableConnection & {
  __typename: 'ValuePostalCodeConnection';
  hash: Scalars['String'];
  nodes: Array<ValuePostalCode>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValuePostalCodeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<ValuePostalCodeCriteriaOrder>>;
  postalCode?: InputMaybe<Scalars['String']>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ValuePostalCodeCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export enum ValueSexCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueSiteMarketAccess = {
  __typename: 'ValueSiteMarketAccess';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  imfCt: Scalars['DateTime'];
  imfUt: Scalars['DateTime'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
  value: Scalars['String'];
  valueGb: Scalars['String'];
};

export type ValueSitePersonMarketAccess = {
  __typename: 'ValueSitePersonMarketAccess';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  imfCt: Scalars['DateTime'];
  imfUt: Scalars['DateTime'];
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
  value: Scalars['String'];
  valueGb: Scalars['String'];
};

export type ValueSiteSectorType = {
  __typename: 'ValueSiteSectorType';
  active: Scalars['Boolean'];
  code: Scalars['String'];
  ct: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  isGlobalOnly: Scalars['Boolean'];
  label: Scalars['String'];
  labelGb?: Maybe<Scalars['String']>;
  maintainerSourceCode: Scalars['String'];
  originSourceCode: Scalars['String'];
  ut: Scalars['DateTime'];
};

export type ValueSiteSectorTypeConnection = {
  __typename: 'ValueSiteSectorTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ValueSiteSectorType>;
  totalCount: Scalars['Int'];
};

export type ValueSiteSectorTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueSiteSectorTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
};

export enum ValueSiteSectorTypeCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueSiteSpecialtyConnection = {
  __typename: 'ValueSiteSpecialtyConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
};

export type ValueSiteSpecialtyCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueSiteSpecialtyCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  siteId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueSiteSpecialtyCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueSiteTypeConnection = {
  __typename: 'ValueSiteTypeConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
};

export type ValueSiteTypeCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  country?: InputMaybe<Scalars['CountryCode']>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueSiteTypeCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueSiteTypeCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type ValueTherapeuticFocusConnection = SearchableConnection & {
  __typename: 'ValueTherapeuticFocusConnection';
  hash: Scalars['String'];
  nodes: Array<DataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueTherapeuticFocusCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueTherapeuticFocusCriteriaOrder>>;
  personId?: InputMaybe<Scalars['ID']>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueTherapeuticFocusCriteriaOrder {
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type ValueWorkingSpecialtyConnection = SearchableConnection & {
  __typename: 'ValueWorkingSpecialtyConnection';
  hash: Scalars['String'];
  nodes: Array<ImfDataValue>;
  totalCount: Scalars['Int'];
  valueNodes: Array<SearchableGqlValue>;
};

export type ValueWorkingSpecialtyCriteria = {
  countries?: InputMaybe<Array<Scalars['CountryCode']>>;
  criterias?: InputMaybe<Array<DynamicCriteriaInput>>;
  fetchSize?: InputMaybe<FetchSize>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  ordering?: InputMaybe<Array<ValueWorkingSpecialtyCriteriaOrder>>;
  searchInput?: InputMaybe<SaveSearchInput>;
  sitePersonId?: InputMaybe<Scalars['ID']>;
  valCode?: InputMaybe<Scalars['String']>;
};

export enum ValueWorkingSpecialtyCriteriaOrder {
  LABEL_ASC = 'LABEL_ASC',
  LABEL_DESC = 'LABEL_DESC'
}

export type Viewer = {
  __typename: 'Viewer';
  activities: ActivityConnection;
  adminMenuItems: MenuItemConnection;
  dashboards: DashboardConnection;
  fullname: Scalars['String'];
  functionMenuItems: MenuItemConnection;
  getAllFavoriteLists: ListConnection;
  getFavoriteLists: ListConnection;
  hasAdminAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  menuItems: MenuItemConnection;
  pinnedAndFavoriteLists: ListConnection;
  responsibleHcps: PersonConnection;
  role: Role;
  roleId: Scalars['ID'];
  savedCriterias: CriteriaSimpleSavedConnection;
  tableColumns: Array<AntTableColumn>;
  user: User;
  username: Scalars['String'];
};


export type VieweractivitiesArgs = {
  criteria?: InputMaybe<ActivityCriteria>;
};


export type ViewerdashboardsArgs = {
  criteria?: InputMaybe<DashboardCriteria>;
};


export type ViewergetAllFavoriteListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


export type ViewergetFavoriteListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


export type ViewerpinnedAndFavoriteListsArgs = {
  criteria?: InputMaybe<ListCriteria>;
};


export type ViewerresponsibleHcpsArgs = {
  criteria?: InputMaybe<PersonCriteria>;
};


export type ViewersavedCriteriasArgs = {
  criteria?: InputMaybe<CriteriaSimpleSavedGqlCriteria>;
};


export type ViewertableColumnsArgs = {
  entityType: EntityTypeEnum;
};

export type VirtualAddressTypeWithValues = {
  __typename: 'VirtualAddressTypeWithValues';
  addresses: Array<Address>;
  affiliations: Array<AddressAffiliation>;
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  type: AddressType;
};

export type VirtualColumnPath = {
  __typename: 'VirtualColumnPath';
  id?: Maybe<Scalars['String']>;
  mapper: Scalars['String'];
  mapperFrom: Scalars['String'];
  mapperTo?: Maybe<Scalars['String']>;
  operatorOnMapperTo?: Maybe<OperatorTypeEnum>;
};

export type VirtualConsentValue = {
  __typename: 'VirtualConsentValue';
  consentTypeCode: Scalars['String'];
  ct?: Maybe<Scalars['DateTime']>;
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  isEnabled: Scalars['Boolean'];
  type: ConsentType;
  updatedByUserId?: Maybe<Scalars['ID']>;
  ut?: Maybe<Scalars['DateTime']>;
};

export type VirtualContactTypeWithValue = {
  __typename: 'VirtualContactTypeWithValue';
  contactType: ContactType;
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  values: Array<ContactValue>;
};

export type VirtualEntityMerge = {
  __typename: 'VirtualEntityMerge';
  entityAffiliationId: Scalars['ID'];
  entityType: EntityTypeEnum;
  entityTypeEnum?: Maybe<EntityTypeEnum>;
  entityTypeId: Scalars['ID'];
  from?: Maybe<Model>;
  into?: Maybe<Model>;
  intoEntityAffiliationId: Scalars['ID'];
  mergeOverview: Array<VirtualEntityMergeFieldInfo>;
  status: EntityMergeStatusEnum;
};


export type VirtualEntityMergefromArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};


export type VirtualEntityMergeintoArgs = {
  nullIfMissingPermission?: InputMaybe<Scalars['Boolean']>;
};

export type VirtualEntityMergeFieldInfo = {
  __typename: 'VirtualEntityMergeFieldInfo';
  hasConflict: Scalars['Boolean'];
  ignoredByMaintainer: Scalars['Boolean'];
  type?: Maybe<EntityDataToBeTransferredType>;
};

export type VirtualEntityMergeInfo = {
  __typename: 'VirtualEntityMergeInfo';
  dataFields: Array<VirtualEntityMergeFieldInfo>;
  entityMerge: EntityMerge;
  entityMergeId: Scalars['ID'];
  entityType: EntityTypeEnum;
  fromId: Scalars['ID'];
  hasConflict: Scalars['Boolean'];
  intoId: Scalars['ID'];
};

export type VirtualPermissionInfo = {
  __typename: 'VirtualPermissionInfo';
  code: Scalars['String'];
  create: Scalars['Boolean'];
  delete: Scalars['Boolean'];
  read: Scalars['Boolean'];
  update: Scalars['Boolean'];
};

export type VirtualPostalCodeSuggestion = {
  __typename: 'VirtualPostalCodeSuggestion';
  city: Array<Scalars['String']>;
  county: Array<Scalars['String']>;
  key: Scalars['String'];
};

export type VirtualRolePermission = {
  __typename: 'VirtualRolePermission';
  create?: Maybe<Scalars['Boolean']>;
  ct: Scalars['DateTime'];
  delete?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  heading: Scalars['String'];
  module?: Maybe<ModuleEnumType>;
  permissionEnum: PermissionEnum;
  read?: Maybe<Scalars['Boolean']>;
  roleId: Scalars['ID'];
  update?: Maybe<Scalars['Boolean']>;
  ut: Scalars['DateTime'];
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "DcrGroupHeading": [
      "DcrGroupHeadingCreatePerson",
      "DcrGroupHeadingCreateSite",
      "DcrGroupHeadingDeletePerson",
      "DcrGroupHeadingDeleteSite",
      "DcrGroupHeadingDeleteWorkplace",
      "DcrGroupHeadingNewPersonWithWorkplace",
      "DcrGroupHeadingNewWorkplace",
      "DcrGroupHeadingUnknownDcrType",
      "DcrGroupHeadingUpdatePerson",
      "DcrGroupHeadingUpdateSite",
      "DcrGroupHeadingUpdateWorkplace"
    ],
    "EntityDataToBeTransferredType": [
      "AffiliationContactValue_EntityDataToBeTransferredType",
      "AffiliationCountryCode_EntityDataToBeTransferredType",
      "AffiliationCustomField_EntityDataToBeTransferredType",
      "AffiliationExternalId_EntityDataToBeTransferredType",
      "AffiliationIsPrimary_EntityDataToBeTransferredType",
      "AffiliationNotes_EntityDataToBeTransferredType",
      "AffiliationPositionCode_EntityDataToBeTransferredType",
      "AffiliationTherapeuticFocus_EntityDataToBeTransferredType",
      "AffiliationWorkingSpecialities_EntityDataToBeTransferredType",
      "PersonActivity_EntityDataToBeTransferredType",
      "PersonAddress_EntityDataToBeTransferredType",
      "PersonBirth_EntityDataToBeTransferredType",
      "PersonConsent_EntityDataToBeTransferredType",
      "PersonContactValue_EntityDataToBeTransferredType",
      "PersonCountry_EntityDataToBeTransferredType",
      "PersonCustomField_EntityDataToBeTransferredType",
      "PersonEducations_EntityDataToBeTransferredType",
      "PersonExamYear_EntityDataToBeTransferredType",
      "PersonExternalId_EntityDataToBeTransferredType",
      "PersonFirstName_EntityDataToBeTransferredType",
      "PersonGdpr_EntityDataToBeTransferredType",
      "PersonGender_EntityDataToBeTransferredType",
      "PersonIsActive_EntityDataToBeTransferredType",
      "PersonLastName_EntityDataToBeTransferredType",
      "PersonLink_EntityDataToBeTransferredType",
      "PersonLists_EntityDataToBeTransferredType",
      "PersonMailToPrivate_EntityDataToBeTransferredType",
      "PersonNotes_EntityDataToBeTransferredType",
      "PersonProductSegmentation_EntityDataToBeTransferredType",
      "PersonProjects_EntityDataToBeTransferredType",
      "PersonResponsibleArea_EntityDataToBeTransferredType",
      "PersonSegmentation_EntityDataToBeTransferredType",
      "PersonTags_EntityDataToBeTransferredType",
      "PersonTherapeuticFocus_EntityDataToBeTransferredType",
      "PersonTitle_EntityDataToBeTransferredType",
      "PersonType_EntityDataToBeTransferredType",
      "SiteActivity_EntityDataToBeTransferredType",
      "SiteAddress_EntityDataToBeTransferredType",
      "SiteContactValue_EntityDataToBeTransferredType",
      "SiteCountry_EntityDataToBeTransferredType",
      "SiteCustomField_EntityDataToBeTransferredType",
      "SiteExternalId_EntityDataToBeTransferredType",
      "SiteIsUnplaced_EntityDataToBeTransferredType",
      "SiteLinks_EntityDataToBeTransferredType",
      "SiteLists_EntityDataToBeTransferredType",
      "SiteMailingNamePrefix_EntityDataToBeTransferredType",
      "SiteName_EntityDataToBeTransferredType",
      "SiteNotes_EntityDataToBeTransferredType",
      "SiteParent_EntityDataToBeTransferredType",
      "SiteSegmentation_EntityDataToBeTransferredType",
      "SiteTags_EntityDataToBeTransferredType",
      "SiteType_EntityDataToBeTransferredType",
      "SiteWebpage_EntityDataToBeTransferredType"
    ],
    "EntityTypeConnection": [
      "ActivityConnection",
      "ActivityPersonConnection",
      "PersonConnection",
      "SiteConnection",
      "SitePersonConnection"
    ],
    "IDataValue": [
      "DataValue",
      "ImfDataValue"
    ],
    "ImfModel": [
      "Person",
      "Site",
      "SitePerson"
    ],
    "ImportManualStageType": [
      "ImportManualEventMatchStage",
      "ImportManualPersonStage",
      "ManualExternalUserIdMapping",
      "SelectExternalSystemManualState"
    ],
    "Model": [
      "Activity",
      "ActivityBrand",
      "ActivityFieldDays",
      "ActivityLocation",
      "ActivityPerson",
      "ActivityProduct",
      "ActivityTypeCustomField",
      "Address",
      "AddressAffiliation",
      "Brand",
      "ConsentContactValue",
      "ConsentValue",
      "ContactCategoryMapping",
      "ContactValue",
      "CreateEntityField",
      "Criteria",
      "CriteriaPath",
      "CriteriaSimpleSaved",
      "CriteriaSimpleSavedCriteria",
      "CriteriaSimpleSavedPath",
      "CriteriaType",
      "CustomFieldControlSetting",
      "CustomFieldGridConfiguration",
      "CustomFieldOption",
      "CustomFieldOptionCountry",
      "CustomFieldRole",
      "CustomLinkValue",
      "CustomValue",
      "Dashboard",
      "DashboardEntityPieSetting",
      "DashboardItemConfiguration",
      "DashboardUser",
      "Dcr",
      "DcrComment",
      "DcrGroup",
      "DcrGroupResponse",
      "DcrLine",
      "DcrNoteTemplate",
      "DcrSnapshotInfo",
      "DefaultCriteria",
      "DefaultDashboard",
      "DefaultTableColumn",
      "DisabledDefaultDashboard",
      "DynamicCriteriaList",
      "DynamicCriteriaListValue",
      "Entity",
      "EntityControlSetting",
      "EntityGridItemCardField",
      "EntityGridItemConfiguration",
      "EntityGridItemField",
      "EntityGridItemRelationField",
      "EntityMerge",
      "EntityValidationLog",
      "ExternalId",
      "ExternalIdSystem",
      "ExternalIdType",
      "ExternalIdTypeCountryExceptionRule",
      "ExternalIdTypeRole",
      "FilterCode",
      "FilterCodeType",
      "ImportFile",
      "ImportLine",
      "ImportProcessField",
      "ImportProcessLine",
      "ImportProcessLineEffect",
      "ImportProcessorData",
      "ImportProject",
      "ImportTemplate",
      "ImportTemplateProcess",
      "ImportTemplateProcessField",
      "List",
      "ListCountry",
      "ListFormat",
      "ListFormatField",
      "ListPin",
      "ListType",
      "ListUserFav",
      "MarketAccessSite",
      "MarketAccessSitePerson",
      "Note",
      "OperatorType",
      "PersProjPreference",
      "Person",
      "PersonActivityProduct",
      "PersonEducation",
      "PersonFilterCode",
      "PersonLanguage",
      "PersonProductSegmentation",
      "PersonProject",
      "PersonSegmentationCode",
      "PersonTherapeuticFocus",
      "PersonUser",
      "Preference",
      "Product",
      "Project",
      "ProjectActivity",
      "ProjectProduct",
      "ProjectStatus",
      "ProjectType",
      "ProjectUser",
      "PureAdvanceCustomerSandbox",
      "PureAdvanceCustomerSelection",
      "PureAdvanceModule",
      "ReportSettingDailyCallTarget",
      "ReportSettingFieldDay",
      "ReportSettingsActivityType",
      "ResponsibleArea",
      "Role",
      "RolePermission",
      "SalesCycle",
      "SalesCycleSegmentationTarget",
      "SalesCycleSetup",
      "Search",
      "SegmentationCode",
      "Selection",
      "SelectionGroup",
      "SelectionRow",
      "SelectionRowResult",
      "Site",
      "SiteFilterCode",
      "SitePerson",
      "SitePersonTherapeuticFocus",
      "SitePersonWorkingSpecialty",
      "SiteResponsible",
      "SiteSegmentationCode",
      "StandardTitle",
      "Team",
      "UnitType",
      "User",
      "UserCountry",
      "UserPreferEnglishLov",
      "UserTableColumn",
      "UserTeam",
      "ValueModel"
    ],
    "SearchableConnection": [
      "ActivityConnection",
      "ActivityPersonConnection",
      "ActivityStatusConnection",
      "ActivitySuperTypeConnection",
      "ActivityTypeConnection",
      "ActivityTypeCustomFieldConnection",
      "AddressAffiliationConnection",
      "AddressConnection",
      "AddressTypeConnection",
      "BrandConnection",
      "BrickConnection",
      "ConsentTypeConnection",
      "ConsentValueConnection",
      "ContactCategoryConnection",
      "ContactCategoryMappingConnection",
      "ContactTypeConnection",
      "ContactValueConnection",
      "CreateEntityFieldConnection",
      "CriteriaConnection",
      "CriteriaPathConnection",
      "CriteriaTypeConnection",
      "CustomFieldConnection",
      "CustomFieldGridConfigurationConnection",
      "CustomFieldOptionConnection",
      "CustomFieldOptionCountryConnection",
      "CustomFieldRoleConnection",
      "CustomLinkValueConnection",
      "CustomValueConnection",
      "DataValueConnection",
      "DbSourceConnection",
      "DcrConnection",
      "DcrGroupConnection",
      "DcrGroupResponseConnection",
      "DcrLineConnection",
      "DcrResponseTypeConnection",
      "DcrSnapshotInfoConnection",
      "DefaultCriteriaConnection",
      "DefaultTableColumnConnection",
      "EntityConnection",
      "EntityGridCardFieldTypeConnection",
      "EntityGridItemCardFieldConnection",
      "EntityGridItemConfigurationConnection",
      "EntityGridItemFieldConnection",
      "EntityGridItemFieldTypeConnection",
      "EntityGridItemRelationFieldConnection",
      "EntityGridItemTypeConnection",
      "EntityMergeConnection",
      "EntityMergeStatusConnection",
      "EntityTabConnection",
      "EntityValidationLogConnection",
      "ExternalIdConnection",
      "ExternalIdSystemConnection",
      "ExternalIdTypeConnection",
      "ExternalIdTypeCountryExceptionRuleConnection",
      "ExternalIdTypeRoleConnection",
      "FilterCodeConnection",
      "FilterCodeTypeConnection",
      "ImportProjectConnection",
      "InternationalCustomerConnection",
      "LanguageConnection",
      "ListConnection",
      "ListCountryConnection",
      "ListTypeConnection",
      "MarketAccessSiteConnection",
      "MarketAccessSitePersonConnection",
      "MenuGroupConnection",
      "MenuItemConnection",
      "OperatorTypeConnection",
      "PersProjectRoleConnection",
      "PersonConnection",
      "PersonFilterCodeConnection",
      "PersonLanguageConnection",
      "PersonProductSegmentationConnection",
      "PersonSegmentationCodeConnection",
      "PersonTherapeuticFocusConnection",
      "PersonUserConnection",
      "ProductConnection",
      "ProjectActivityConnection",
      "ProjectConnection",
      "ProjectStatusConnection",
      "ProjectTypeConnection",
      "PureAdvanceCustomerConnection",
      "PureAdvanceCustomerSelectionConnection",
      "PureAdvanceModuleConnection",
      "ReportSettingFieldDayConnection",
      "ReportSettingsActivityTypeConnection",
      "ResponsibleAreaConnection",
      "RoleConnection",
      "SalesCycleConnection",
      "SalesCycleSegmentationTargetConnection",
      "SalesCycleSetupConnection",
      "SearchConnection",
      "SegmentationCodeConnection",
      "SelectionConnection",
      "SelectionGroupConnection",
      "SelectionImfCustomerConnection",
      "SelectionRowConnection",
      "SelectionRowResultConnection",
      "SiteConnection",
      "SiteFilterCodeConnection",
      "SitePersonConnection",
      "SitePersonTherapeuticFocusConnection",
      "SitePersonWorkSpecialtyConnection",
      "SiteResponsibleConnection",
      "TerritoryConnection",
      "UserConnection",
      "UserTableColumnConnection",
      "ValueCommuneConnection",
      "ValueCountryConnection",
      "ValueCountyConnection",
      "ValueEducationConnection",
      "ValuePersonTypeConnection",
      "ValuePositionConnection",
      "ValuePostalCodeConnection",
      "ValueTherapeuticFocusConnection",
      "ValueWorkingSpecialtyConnection"
    ]
  }
};
      export default result;
    
export const activityConnectionOverviewPersonsFragmentDoc = gql`
    fragment activityConnectionOverviewPersons on Activity {
  persons(criteria: {fetchSize: {limit: $personLimit}}) {
    hash
    totalCount
    nodes {
      id
      fullName
      title
    }
  }
}
    `;
export const activityConnectionOverviewFragmentDoc = gql`
    fragment activityConnectionOverview on ActivityConnection {
  hash
  totalCount
  nodes {
    id
    heading
    status {
      code
      headingKey
      codeEnum
    }
    time: startDate
    end: endDate
    type {
      label: heading
      code
      color {
        code
        value
      }
    }
    sites {
      hash
      nodes {
        id
        name
        visitAddress {
          id
          city
          commune {
            code
            label
            type
          }
          street
          postalCode
        }
        siteTypeCode
        phone: mainContact(type: PHONE) {
          id
          value
        }
        fax: mainContact(type: FAX) {
          id
          value
        }
        email: mainContact(type: EMAIL) {
          id
          value
        }
      }
    }
    ...activityConnectionOverviewPersons
  }
}
    ${activityConnectionOverviewPersonsFragmentDoc}`;
export const contactPersonsFragmentDoc = gql`
    fragment contactPersons on PersonConnection {
  hash
  totalCount
  nodes {
    id
    fullname: fullName
    title
    segmentationCode {
      id
      code
      heading
    }
  }
}
    `;
export const ActivityPersonFragmentFragmentDoc = gql`
    fragment ActivityPersonFragment on Person {
  id
  fullName
  title
  segmentationCode {
    code
    heading
  }
}
    `;
export const ActivitySiteSiteFragmentFragmentDoc = gql`
    fragment ActivitySiteSiteFragment on Site {
  id
  name
  type {
    code
    type
    label
  }
}
    `;
export const SiteFragmentForDisplayFragmentDoc = gql`
    fragment SiteFragmentForDisplay on Site {
  id
  name
}
    `;
export const ActivityTableBuiltFragmentFragmentDoc = gql`
    fragment ActivityTableBuiltFragment on Activity {
  id
}
    `;
export const FieldFragmentFragmentDoc = gql`
    fragment FieldFragment on EntityGridItemCardField {
  id
  fieldKey
  heading
  isHeadingKey
  sort
}
    `;
export const SelectedGridItemConfigurationFragmentFragmentDoc = gql`
    fragment SelectedGridItemConfigurationFragment on EntityGridItemConfiguration {
  id
  fields {
    hash
    nodes {
      id
      gridItemFieldTypeCode
      entityGridItemConfigurationId
      sort
      type {
        code
        heading
        isActive
        enum
      }
      customFieldConfiguration {
        id
        customField {
          code
          heading
          customFieldTypeCode
          options {
            hash
            totalCount
            nodes {
              code
              value {
                id
                value
              }
            }
          }
          fieldType {
            code
            enum
          }
        }
      }
    }
  }
}
    `;
export const AdminEntityMergeRequestFragmentFragmentDoc = gql`
    fragment AdminEntityMergeRequestFragment on EntityMerge {
  id
}
    `;
export const MergeItemPersonResponsibleAreasFragmentDoc = gql`
    fragment MergeItemPersonResponsibleAreas on PersonResponsibleArea_EntityDataToBeTransferredType {
  code
  dataType
  entityType
  responsibleArea {
    id
    heading
  }
  fromUser {
    id
    fullname
    email
  }
  toUser {
    id
    fullname
    email
  }
}
    `;
export const MergeItemPersonFirstNameFragmentDoc = gql`
    fragment MergeItemPersonFirstName on PersonFirstName_EntityDataToBeTransferredType {
  code
  from
  to
}
    `;
export const MergeItemPersonLastNameFragmentDoc = gql`
    fragment MergeItemPersonLastName on PersonLastName_EntityDataToBeTransferredType {
  code
  from
  to
}
    `;
export const MergeItemPersonTitleFragmentDoc = gql`
    fragment MergeItemPersonTitle on PersonTitle_EntityDataToBeTransferredType {
  code
  fromTitle: from
  toTitle: to
}
    `;
export const MergeItemPersonGenderFragmentDoc = gql`
    fragment MergeItemPersonGender on PersonGender_EntityDataToBeTransferredType {
  code
  fromGender: from
  toGender: to
}
    `;
export const MergeItemPersonCountryFragmentDoc = gql`
    fragment MergeItemPersonCountry on PersonCountry_EntityDataToBeTransferredType {
  code
  entityType
  fromCountry: from
  toCountry: to
}
    `;
export const MergeItemPersonExamYearFragmentDoc = gql`
    fragment MergeItemPersonExamYear on PersonExamYear_EntityDataToBeTransferredType {
  code
  examYearFrom: from
  examYearTo: to
}
    `;
export const MergeItemPersonActivitiesFragmentDoc = gql`
    fragment MergeItemPersonActivities on PersonActivity_EntityDataToBeTransferredType {
  code
  entityType
  activityIds
}
    `;
export const MergeItemPersonConsentFragmentDoc = gql`
    fragment MergeItemPersonConsent on PersonConsent_EntityDataToBeTransferredType {
  code
  value {
    id
    consentTypeCode
    isEnabled
    type {
      code
      headingKey
    }
  }
}
    `;
export const MergeAddressFragmentDoc = gql`
    fragment MergeAddress on AddressAffiliation {
  id
  address {
    id
    type {
      code
      headingKey
    }
    city
    postalCode
    street
    countryCode
    countyCode
  }
}
    `;
export const MergeItemPersonAddressFragmentDoc = gql`
    fragment MergeItemPersonAddress on PersonAddress_EntityDataToBeTransferredType {
  code
  addressAffiliation {
    ...MergeAddress
  }
  conflictedWith {
    ...MergeAddress
  }
}
    ${MergeAddressFragmentDoc}`;
export const ContactValueInfoFragmentDoc = gql`
    fragment ContactValueInfo on ContactValue {
  id
  value
  consent {
    id
    status
  }
  category {
    code
    heading
    isHeadingKey
    typeEnum
  }
}
    `;
export const MergeItemPersonContactValueFragmentDoc = gql`
    fragment MergeItemPersonContactValue on PersonContactValue_EntityDataToBeTransferredType {
  code
  loserValue {
    ...ContactValueInfo
  }
  winnerValue {
    ...ContactValueInfo
  }
}
    ${ContactValueInfoFragmentDoc}`;
export const FieldDataFragmentDoc = gql`
    fragment FieldData on CustomFieldToBeTransferredInfo {
  value {
    id
    value
  }
  affiliation {
    id
  }
}
    `;
export const MergeItemPersonCustomFieldFragmentDoc = gql`
    fragment MergeItemPersonCustomField on PersonCustomField_EntityDataToBeTransferredType {
  code
  field {
    code
    heading
    fieldTypeEnum
  }
  affiliationsToMove {
    ...FieldData
  }
  loserExistingAffiliations {
    ...FieldData
  }
  winnerExistingAffiliations {
    ...FieldData
  }
}
    ${FieldDataFragmentDoc}`;
export const MergeItemPersonExternalIdFragmentDoc = gql`
    fragment MergeItemPersonExternalId on PersonExternalId_EntityDataToBeTransferredType {
  code
  externalId {
    id
    type {
      code
      heading
      isHeadingKey
    }
    externalId
  }
  existingExternalId {
    id
    externalId
  }
}
    `;
export const MergeItemPersonGdprFragmentDoc = gql`
    fragment MergeItemPersonGdpr on PersonGdpr_EntityDataToBeTransferredType {
  code
  newGdprValue
}
    `;
export const MergeItemPersonListsFragmentDoc = gql`
    fragment MergeItemPersonLists on PersonLists_EntityDataToBeTransferredType {
  code
  entityType
  listIds
}
    `;
export const MergeItemPersonNotesFragmentDoc = gql`
    fragment MergeItemPersonNotes on PersonNotes_EntityDataToBeTransferredType {
  code
  entityType
  noteIds
}
    `;
export const MergeItemPersonSegmentationFragmentDoc = gql`
    fragment MergeItemPersonSegmentation on PersonSegmentation_EntityDataToBeTransferredType {
  code
  dataType
  entityType
  loser {
    id
    heading
  }
  winner {
    id
    heading
  }
}
    `;
export const persProdSegFragmentDoc = gql`
    fragment persProdSeg on PersonProductSegmentation {
  id
  product {
    id
    heading
  }
  segmentationCode {
    id
    heading
  }
}
    `;
export const MergeItemPersonProductSegmentationFragmentDoc = gql`
    fragment MergeItemPersonProductSegmentation on PersonProductSegmentation_EntityDataToBeTransferredType {
  code
  entityType
  toBeTransferred {
    ...persProdSeg
  }
  conflictFrom {
    ...persProdSeg
  }
  conflictTo {
    ...persProdSeg
  }
}
    ${persProdSegFragmentDoc}`;
export const MergeItemPersonIsActiveFragmentDoc = gql`
    fragment MergeItemPersonIsActive on PersonIsActive_EntityDataToBeTransferredType {
  code
  entityType
  willBeActivated {
    id
    fullName
  }
  willBeInactivated {
    id
    fullName
  }
}
    `;
export const MergeItemPersonTagsFragmentDoc = gql`
    fragment MergeItemPersonTags on PersonTags_EntityDataToBeTransferredType {
  code
  entityType
  loserCodes {
    id
    filterCode {
      id
      header
    }
  }
  winnerCodes {
    id
    filterCode {
      id
      header
    }
  }
}
    `;
export const MergeItemPersonBirthFragmentDoc = gql`
    fragment MergeItemPersonBirth on PersonBirth_EntityDataToBeTransferredType {
  code
  birthFrom: from
  birthTo: to
}
    `;
export const MergeItemPersonTypeFragmentDoc = gql`
    fragment MergeItemPersonType on PersonType_EntityDataToBeTransferredType {
  code
  loserType {
    code
    type
    displayLabel
  }
  winnerType {
    code
    type
    displayLabel
  }
}
    `;
export const MergeItemPersonEducationsFragmentDoc = gql`
    fragment MergeItemPersonEducations on PersonEducations_EntityDataToBeTransferredType {
  code
  entityType
  educationCodesToBeMoved {
    id
    education {
      code
      type
      displayLabel
    }
  }
}
    `;
export const MergeItemPersonMailToPrivateFragmentDoc = gql`
    fragment MergeItemPersonMailToPrivate on PersonMailToPrivate_EntityDataToBeTransferredType {
  code
  mailToPrivateFrom: from
  mailToPrivateTo: to
}
    `;
export const MergeItemPersonTherapeuticFocusFragmentDoc = gql`
    fragment MergeItemPersonTherapeuticFocus on PersonTherapeuticFocus_EntityDataToBeTransferredType {
  code
  entityType
  toBeMoved {
    code
    type
    label
  }
}
    `;
export const MergeItemPersonLinkFragmentDoc = gql`
    fragment MergeItemPersonLink on PersonLink_EntityDataToBeTransferredType {
  code
  primaryConflict
  fromLink: from {
    id
    position {
      code
      type
      displayLabel
    }
    site {
      id
      name
    }
  }
  toLink: into {
    id
  }
}
    `;
export const MergeItemSiteNameFragmentDoc = gql`
    fragment MergeItemSiteName on SiteName_EntityDataToBeTransferredType {
  code
  fromName: from
  toName: to
}
    `;
export const MergeItemSiteActivitiesFragmentDoc = gql`
    fragment MergeItemSiteActivities on SiteActivity_EntityDataToBeTransferredType {
  code
  entityType
  activityIds
}
    `;
export const MergeItemSiteAddressFragmentDoc = gql`
    fragment MergeItemSiteAddress on SiteAddress_EntityDataToBeTransferredType {
  code
  addressAffiliation {
    ...MergeAddress
  }
  conflictedWith {
    ...MergeAddress
  }
}
    ${MergeAddressFragmentDoc}`;
export const MergeItemSiteContactValueFragmentDoc = gql`
    fragment MergeItemSiteContactValue on SiteContactValue_EntityDataToBeTransferredType {
  code
  loserValue {
    ...ContactValueInfo
  }
  winnerValue {
    ...ContactValueInfo
  }
}
    ${ContactValueInfoFragmentDoc}`;
export const MergeItemSiteCustomFieldFragmentDoc = gql`
    fragment MergeItemSiteCustomField on SiteCustomField_EntityDataToBeTransferredType {
  code
  field {
    code
    heading
    fieldTypeEnum
  }
  affiliationsToMove {
    ...FieldData
  }
  loserExistingAffiliations {
    ...FieldData
  }
  winnerExistingAffiliations {
    ...FieldData
  }
}
    ${FieldDataFragmentDoc}`;
export const MergeItemSiteExternalIdFragmentDoc = gql`
    fragment MergeItemSiteExternalId on SiteExternalId_EntityDataToBeTransferredType {
  code
  externalId {
    id
    type {
      code
      heading
      isHeadingKey
    }
    externalId
  }
  existingExternalId {
    id
    externalId
  }
}
    `;
export const MergeItemSiteListsFragmentDoc = gql`
    fragment MergeItemSiteLists on SiteLists_EntityDataToBeTransferredType {
  code
  entityType
  listIds
}
    `;
export const MergeItemSiteNotesFragmentDoc = gql`
    fragment MergeItemSiteNotes on SiteNotes_EntityDataToBeTransferredType {
  code
  entityType
  noteIds
}
    `;
export const MergeItemSiteSegmentationFragmentDoc = gql`
    fragment MergeItemSiteSegmentation on SiteSegmentation_EntityDataToBeTransferredType {
  code
  dataType
  entityType
  loser {
    id
    heading
  }
  winner {
    id
    heading
  }
}
    `;
export const MergeItemSiteTagsFragmentDoc = gql`
    fragment MergeItemSiteTags on SiteTags_EntityDataToBeTransferredType {
  code
  entityType
  loserCodes {
    id
    filterCode {
      id
      header
    }
  }
  winnerCodes {
    id
    filterCode {
      id
      header
    }
  }
}
    `;
export const MergeItemSiteCountryFragmentDoc = gql`
    fragment MergeItemSiteCountry on SiteCountry_EntityDataToBeTransferredType {
  code
  entityType
  fromSiteCountry: from
  toSiteCountry: to
}
    `;
export const MergeItemSiteIsUnplacedFragmentDoc = gql`
    fragment MergeItemSiteIsUnplaced on SiteIsUnplaced_EntityDataToBeTransferredType {
  code
  entityType
  isUnplacedFrom: from
  isUnplacedTo: to
}
    `;
export const MergeItemSiteMailingNamePrefixFragmentDoc = gql`
    fragment MergeItemSiteMailingNamePrefix on SiteMailingNamePrefix_EntityDataToBeTransferredType {
  code
  fromPrefixName: from
  toPrefixName: to
}
    `;
export const MergeItemSiteLinkFragmentDoc = gql`
    fragment MergeItemSiteLink on SitePerson {
  id
  personId: persId
  siteId
  person {
    id
    fullName
  }
  position {
    code
    type
    displayLabel
  }
}
    `;
export const MergeItemSiteLinksFragmentDoc = gql`
    fragment MergeItemSiteLinks on SiteLinks_EntityDataToBeTransferredType {
  code
  alreadyOnWinner {
    ...MergeItemSiteLink
  }
  linksToBeMoved: toBeMoved {
    ...MergeItemSiteLink
  }
  linksToBeMerged: toBeMerged {
    loser {
      ...MergeItemSiteLink
    }
    winner {
      ...MergeItemSiteLink
    }
  }
}
    ${MergeItemSiteLinkFragmentDoc}`;
export const MergeItemSiteWebpageFragmentDoc = gql`
    fragment MergeItemSiteWebpage on SiteWebpage_EntityDataToBeTransferredType {
  code
  fromWebpage: from
  toWebpage: to
}
    `;
export const MergeItemSiteParentFragmentDoc = gql`
    fragment MergeItemSiteParent on SiteParent_EntityDataToBeTransferredType {
  code
  fromParentSite {
    id
    name
  }
  toParentSite {
    id
    name
  }
}
    `;
export const MergeItemSiteTypeFragmentDoc = gql`
    fragment MergeItemSiteType on SiteType_EntityDataToBeTransferredType {
  code
  fromCode
  toCode
  entityType
  dataType
}
    `;
export const MergeItemAffiliationPositionCodeFragmentDoc = gql`
    fragment MergeItemAffiliationPositionCode on AffiliationPositionCode_EntityDataToBeTransferredType {
  code
  loserLink {
    id
    countryCode
  }
  winnerLink {
    id
  }
  loserType {
    code
    type
    displayLabel
  }
  winnerType {
    code
    type
    displayLabel
  }
}
    `;
export const MergeItemAffiliationIsPrimaryFragmentDoc = gql`
    fragment MergeItemAffiliationIsPrimary on AffiliationIsPrimary_EntityDataToBeTransferredType {
  code
  allLinksFromWinner {
    id
    isPrimary
    position {
      code
      type
      displayLabel
    }
    personId: persId
    site {
      id
      name
    }
  }
}
    `;
export const MergeItemAffiliationWorkingSpecialitiesFragmentDoc = gql`
    fragment MergeItemAffiliationWorkingSpecialities on AffiliationWorkingSpecialities_EntityDataToBeTransferredType {
  code
  entityType
  loserSpecialities {
    id
    specialty {
      code
      type
      displayLabel
    }
  }
  winnerSpecialities {
    id
    specialty {
      code
      type
      displayLabel
    }
  }
}
    `;
export const MergeItemAffiliationContactValueFragmentDoc = gql`
    fragment MergeItemAffiliationContactValue on AffiliationContactValue_EntityDataToBeTransferredType {
  code
  loserValue {
    ...ContactValueInfo
  }
  winnerValue {
    ...ContactValueInfo
  }
}
    ${ContactValueInfoFragmentDoc}`;
export const MergeItemAffiliationCustomFieldFragmentDoc = gql`
    fragment MergeItemAffiliationCustomField on AffiliationCustomField_EntityDataToBeTransferredType {
  code
  field {
    code
    heading
    fieldTypeEnum
  }
  affiliationsToMove {
    ...FieldData
  }
  loserExistingAffiliations {
    ...FieldData
  }
  winnerExistingAffiliations {
    ...FieldData
  }
}
    ${FieldDataFragmentDoc}`;
export const MergeItemAffiliationExternalIdFragmentDoc = gql`
    fragment MergeItemAffiliationExternalId on AffiliationExternalId_EntityDataToBeTransferredType {
  code
  externalId {
    id
    type {
      code
      heading
      isHeadingKey
    }
    externalId
  }
  existingExternalId {
    id
    externalId
  }
}
    `;
export const MergeItemAffiliationNotesFragmentDoc = gql`
    fragment MergeItemAffiliationNotes on AffiliationNotes_EntityDataToBeTransferredType {
  code
  entityType
  noteIds
}
    `;
export const MergeItemAffiliationCountryFragmentDoc = gql`
    fragment MergeItemAffiliationCountry on AffiliationCountryCode_EntityDataToBeTransferredType {
  code
  entityType
  fromAffiliationCountry: fromCode
  toAffiliationCountry: toCode
}
    `;
export const MergeItemAffiliationTherapeuticFocusFragmentDoc = gql`
    fragment MergeItemAffiliationTherapeuticFocus on AffiliationTherapeuticFocus_EntityDataToBeTransferredType {
  code
  entityType
  toBeMoved {
    code
    type
    label
  }
}
    `;
export const AdminEntityMergeItemFragmentFragmentDoc = gql`
    fragment AdminEntityMergeItemFragment on VirtualEntityMergeFieldInfo {
  hasConflict
  ignoredByMaintainer
  type {
    ... on PersonResponsibleArea_EntityDataToBeTransferredType {
      ...MergeItemPersonResponsibleAreas
    }
    ... on PersonFirstName_EntityDataToBeTransferredType {
      ...MergeItemPersonFirstName
    }
    ... on PersonLastName_EntityDataToBeTransferredType {
      ...MergeItemPersonLastName
    }
    ... on PersonTitle_EntityDataToBeTransferredType {
      ...MergeItemPersonTitle
    }
    ... on PersonGender_EntityDataToBeTransferredType {
      ...MergeItemPersonGender
    }
    ... on PersonCountry_EntityDataToBeTransferredType {
      ...MergeItemPersonCountry
    }
    ... on PersonExamYear_EntityDataToBeTransferredType {
      ...MergeItemPersonExamYear
    }
    ... on PersonActivity_EntityDataToBeTransferredType {
      ...MergeItemPersonActivities
    }
    ... on PersonConsent_EntityDataToBeTransferredType {
      ...MergeItemPersonConsent
    }
    ... on PersonAddress_EntityDataToBeTransferredType {
      ...MergeItemPersonAddress
    }
    ... on PersonContactValue_EntityDataToBeTransferredType {
      ...MergeItemPersonContactValue
    }
    ... on PersonCustomField_EntityDataToBeTransferredType {
      ...MergeItemPersonCustomField
    }
    ... on PersonExternalId_EntityDataToBeTransferredType {
      ...MergeItemPersonExternalId
    }
    ... on PersonGdpr_EntityDataToBeTransferredType {
      ...MergeItemPersonGdpr
    }
    ... on PersonLists_EntityDataToBeTransferredType {
      ...MergeItemPersonLists
    }
    ... on PersonNotes_EntityDataToBeTransferredType {
      ...MergeItemPersonNotes
    }
    ... on PersonSegmentation_EntityDataToBeTransferredType {
      ...MergeItemPersonSegmentation
    }
    ... on PersonProductSegmentation_EntityDataToBeTransferredType {
      ...MergeItemPersonProductSegmentation
    }
    ... on PersonIsActive_EntityDataToBeTransferredType {
      ...MergeItemPersonIsActive
    }
    ... on PersonTags_EntityDataToBeTransferredType {
      ...MergeItemPersonTags
    }
    ... on PersonBirth_EntityDataToBeTransferredType {
      ...MergeItemPersonBirth
    }
    ... on PersonType_EntityDataToBeTransferredType {
      ...MergeItemPersonType
    }
    ... on PersonEducations_EntityDataToBeTransferredType {
      ...MergeItemPersonEducations
    }
    ... on PersonMailToPrivate_EntityDataToBeTransferredType {
      ...MergeItemPersonMailToPrivate
    }
    ... on PersonTherapeuticFocus_EntityDataToBeTransferredType {
      ...MergeItemPersonTherapeuticFocus
    }
    ... on PersonLink_EntityDataToBeTransferredType {
      ...MergeItemPersonLink
    }
    ... on SiteName_EntityDataToBeTransferredType {
      ...MergeItemSiteName
    }
    ... on SiteActivity_EntityDataToBeTransferredType {
      ...MergeItemSiteActivities
    }
    ... on SiteAddress_EntityDataToBeTransferredType {
      ...MergeItemSiteAddress
    }
    ... on SiteContactValue_EntityDataToBeTransferredType {
      ...MergeItemSiteContactValue
    }
    ... on SiteCustomField_EntityDataToBeTransferredType {
      ...MergeItemSiteCustomField
    }
    ... on SiteExternalId_EntityDataToBeTransferredType {
      ...MergeItemSiteExternalId
    }
    ... on SiteLists_EntityDataToBeTransferredType {
      ...MergeItemSiteLists
    }
    ... on SiteNotes_EntityDataToBeTransferredType {
      ...MergeItemSiteNotes
    }
    ... on SiteSegmentation_EntityDataToBeTransferredType {
      ...MergeItemSiteSegmentation
    }
    ... on SiteTags_EntityDataToBeTransferredType {
      ...MergeItemSiteTags
    }
    ... on SiteCountry_EntityDataToBeTransferredType {
      ...MergeItemSiteCountry
    }
    ... on SiteIsUnplaced_EntityDataToBeTransferredType {
      ...MergeItemSiteIsUnplaced
    }
    ... on SiteMailingNamePrefix_EntityDataToBeTransferredType {
      ...MergeItemSiteMailingNamePrefix
    }
    ... on SiteLinks_EntityDataToBeTransferredType {
      ...MergeItemSiteLinks
    }
    ... on SiteWebpage_EntityDataToBeTransferredType {
      ...MergeItemSiteWebpage
    }
    ... on SiteParent_EntityDataToBeTransferredType {
      ...MergeItemSiteParent
    }
    ... on SiteType_EntityDataToBeTransferredType {
      ...MergeItemSiteType
    }
    ... on AffiliationPositionCode_EntityDataToBeTransferredType {
      ...MergeItemAffiliationPositionCode
    }
    ... on AffiliationIsPrimary_EntityDataToBeTransferredType {
      ...MergeItemAffiliationIsPrimary
    }
    ... on AffiliationWorkingSpecialities_EntityDataToBeTransferredType {
      ...MergeItemAffiliationWorkingSpecialities
    }
    ... on AffiliationContactValue_EntityDataToBeTransferredType {
      ...MergeItemAffiliationContactValue
    }
    ... on AffiliationCustomField_EntityDataToBeTransferredType {
      ...MergeItemAffiliationCustomField
    }
    ... on AffiliationExternalId_EntityDataToBeTransferredType {
      ...MergeItemAffiliationExternalId
    }
    ... on AffiliationNotes_EntityDataToBeTransferredType {
      ...MergeItemAffiliationNotes
    }
    ... on AffiliationCountryCode_EntityDataToBeTransferredType {
      ...MergeItemAffiliationCountry
    }
    ... on AffiliationTherapeuticFocus_EntityDataToBeTransferredType {
      ...MergeItemAffiliationTherapeuticFocus
    }
  }
}
    ${MergeItemPersonResponsibleAreasFragmentDoc}
${MergeItemPersonFirstNameFragmentDoc}
${MergeItemPersonLastNameFragmentDoc}
${MergeItemPersonTitleFragmentDoc}
${MergeItemPersonGenderFragmentDoc}
${MergeItemPersonCountryFragmentDoc}
${MergeItemPersonExamYearFragmentDoc}
${MergeItemPersonActivitiesFragmentDoc}
${MergeItemPersonConsentFragmentDoc}
${MergeItemPersonAddressFragmentDoc}
${MergeItemPersonContactValueFragmentDoc}
${MergeItemPersonCustomFieldFragmentDoc}
${MergeItemPersonExternalIdFragmentDoc}
${MergeItemPersonGdprFragmentDoc}
${MergeItemPersonListsFragmentDoc}
${MergeItemPersonNotesFragmentDoc}
${MergeItemPersonSegmentationFragmentDoc}
${MergeItemPersonProductSegmentationFragmentDoc}
${MergeItemPersonIsActiveFragmentDoc}
${MergeItemPersonTagsFragmentDoc}
${MergeItemPersonBirthFragmentDoc}
${MergeItemPersonTypeFragmentDoc}
${MergeItemPersonEducationsFragmentDoc}
${MergeItemPersonMailToPrivateFragmentDoc}
${MergeItemPersonTherapeuticFocusFragmentDoc}
${MergeItemPersonLinkFragmentDoc}
${MergeItemSiteNameFragmentDoc}
${MergeItemSiteActivitiesFragmentDoc}
${MergeItemSiteAddressFragmentDoc}
${MergeItemSiteContactValueFragmentDoc}
${MergeItemSiteCustomFieldFragmentDoc}
${MergeItemSiteExternalIdFragmentDoc}
${MergeItemSiteListsFragmentDoc}
${MergeItemSiteNotesFragmentDoc}
${MergeItemSiteSegmentationFragmentDoc}
${MergeItemSiteTagsFragmentDoc}
${MergeItemSiteCountryFragmentDoc}
${MergeItemSiteIsUnplacedFragmentDoc}
${MergeItemSiteMailingNamePrefixFragmentDoc}
${MergeItemSiteLinksFragmentDoc}
${MergeItemSiteWebpageFragmentDoc}
${MergeItemSiteParentFragmentDoc}
${MergeItemSiteTypeFragmentDoc}
${MergeItemAffiliationPositionCodeFragmentDoc}
${MergeItemAffiliationIsPrimaryFragmentDoc}
${MergeItemAffiliationWorkingSpecialitiesFragmentDoc}
${MergeItemAffiliationContactValueFragmentDoc}
${MergeItemAffiliationCustomFieldFragmentDoc}
${MergeItemAffiliationExternalIdFragmentDoc}
${MergeItemAffiliationNotesFragmentDoc}
${MergeItemAffiliationCountryFragmentDoc}
${MergeItemAffiliationTherapeuticFocusFragmentDoc}`;
export const MRPersonLinkPrimaryFragmentDoc = gql`
    fragment MRPersonLinkPrimary on SitePerson {
  id
  isPrimary
  person {
    id
    fullName
  }
  site {
    id
    name
  }
  position {
    code
    type
    displayLabel
  }
}
    `;
export const EntityMergeFragmentFragmentDoc = gql`
    fragment EntityMergeFragment on Model {
  id
  ... on Person {
    id
    countryCode
    fullName
  }
  ... on Site {
    id
    countryCode
    name
  }
  ... on SitePerson {
    id
    countryCode
    person {
      id
      fullName
    }
    site {
      id
      name
    }
    position {
      code
      type
      displayLabel
    }
  }
}
    `;
export const EntityFragmentFragmentDoc = gql`
    fragment EntityFragment on Model {
  ... on Person {
    id
    fullName
  }
  ... on Site {
    id
    name
  }
  ... on SitePerson {
    id
  }
}
    `;
export const InstanceDeploymentTableFragmentFragmentDoc = gql`
    fragment InstanceDeploymentTableFragment on PureAdvanceCustomer {
  code
}
    `;
export const ScheduleFragmentFragmentDoc = gql`
    fragment ScheduleFragment on GitlabSchedule {
  id
  active
  cron
  cron_timezone
  description
  next_run_at
  last_pipeline {
    id
    duration
    finished_at
    started_at
    status
    web_url
  }
}
    `;
export const ActivityTypeMutationFragmentFragmentDoc = gql`
    fragment ActivityTypeMutationFragment on ActivityType {
  code
  heading
  isActive
  description
  sort
  standardTimeLengthMinutes
  superTypeCode
  color {
    code
    headingKey
    value
  }
  brandRule
  locationRule
  participationUserRule
  personRule
  productRule
  projectRule
  responsibleUserRule
  customFields {
    hash
    nodes {
      code
      heading
    }
  }
}
    `;
export const AdminMenuItemFragmentFragmentDoc = gql`
    fragment AdminMenuItemFragment on MenuItem {
  code
  headingKey
  tooltipKey
  iconKey
  url
  isActive
  menuGroup {
    code
    enum
  }
}
    `;
export const InstanceSettingFragmentFragmentDoc = gql`
    fragment InstanceSettingFragment on InstanceSetting {
  code
  value
  enum
}
    `;
export const UserAdminTableFragmentFragmentDoc = gql`
    fragment UserAdminTableFragment on User {
  id
}
    `;
export const RoleAdminTableFragmentFragmentDoc = gql`
    fragment RoleAdminTableFragment on Role {
  id
}
    `;
export const BrickTableFragmentFragmentDoc = gql`
    fragment BrickTableFragment on Brick {
  code
  ct
  ut
  heading
}
    `;
export const DcrGroupTableFragmentFragmentDoc = gql`
    fragment DcrGroupTableFragment on DcrGroup {
  id
}
    `;
export const DcrGroupHeadingFragmentFragmentDoc = gql`
    fragment DcrGroupHeadingFragment on DcrGroup {
  heading {
    ... on DcrGroupHeadingNewWorkplace {
      code
      headingKey
      rPerson: person {
        id
        fullName
      }
      oSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingNewPersonWithWorkplace {
      code
      headingKey
      rPerson: person {
        id
        fullName
      }
      oSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingUpdateWorkplace {
      code
      headingKey
      oPerson: person {
        id
        fullName
      }
      oSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingDeleteWorkplace {
      code
      headingKey
      oPerson: person {
        id
        fullName
      }
      oSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingCreatePerson {
      code
      headingKey
      rPerson: person {
        id
        fullName
      }
    }
    ... on DcrGroupHeadingUpdatePerson {
      code
      headingKey
      rPerson: person {
        id
        fullName
      }
    }
    ... on DcrGroupHeadingDeletePerson {
      code
      headingKey
      rPerson: person {
        id
        fullName
      }
    }
    ... on DcrGroupHeadingCreateSite {
      code
      headingKey
      rSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingUpdateSite {
      code
      headingKey
      rSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingDeleteSite {
      code
      headingKey
      rSite: site {
        id
        name
      }
    }
    ... on DcrGroupHeadingUnknownDcrType {
      code
      headingKey
    }
  }
}
    `;
export const ManualPersonActionFragmentFragmentDoc = gql`
    fragment ManualPersonActionFragment on ImportManualPersonStage {
  projectId
  externalIdTypeCode
  externalIdValue
  fuzzySearchAvailable
  candidatesFor {
    fieldName
    fieldNameKey
    value
  }
  candidates {
    apurebaseId
    inLocalDb
    score
    fields {
      fieldName
      fieldNameKey
      value
    }
  }
}
    `;
export const ManualEventActionFragmentFragmentDoc = gql`
    fragment ManualEventActionFragment on ImportManualEventMatchStage {
  projectId
  __typename
}
    `;
export const ManualExternalUserMappingFragmentFragmentDoc = gql`
    fragment ManualExternalUserMappingFragment on ManualExternalUserIdMapping {
  projectId
  externalIds
  externalIdTypeCode
  __typename
}
    `;
export const SelectExternalSystemManualFragmentDoc = gql`
    fragment SelectExternalSystemManual on SelectExternalSystemManualState {
  processorId
  __typename
}
    `;
export const currentImportStateFragmentDoc = gql`
    fragment currentImportState on ImportProject {
  id
  heading
  statusCode
  statusNote
  ut
  manual {
    projectId
    lineId
    templateProcessId
    ... on ImportManualPersonStage {
      ...ManualPersonActionFragment
    }
    ... on ImportManualEventMatchStage {
      ...ManualEventActionFragment
    }
    ... on ManualExternalUserIdMapping {
      ...ManualExternalUserMappingFragment
    }
    ... on SelectExternalSystemManualState {
      ...SelectExternalSystemManual
    }
  }
  meta {
    projectId
    missingLineCount
    steps
    currentStepIndex
    percentage
  }
}
    ${ManualPersonActionFragmentFragmentDoc}
${ManualEventActionFragmentFragmentDoc}
${ManualExternalUserMappingFragmentFragmentDoc}
${SelectExternalSystemManualFragmentDoc}`;
export const LinkTableFragmentFragmentDoc = gql`
    fragment LinkTableFragment on SitePerson {
  id
  apurebaseId
  isActive
  isLocal
}
    `;
export const CriteriaInputFragmentFragmentDoc = gql`
    fragment CriteriaInputFragment on Criteria {
  id
  heading
  entityType
  code
  criteriaGroupCode
  hasGlobalSupport
  inputPaths {
    hash
    nodes {
      id
      service
      icon
      placeholderHeading
      defaultOperatorType {
        id
        heading
        type
      }
      type {
        id
        type
      }
    }
  }
}
    `;
export const ListDynamicRulesFragmentFragmentDoc = gql`
    fragment ListDynamicRulesFragment on List {
  criterias {
    hash
    nodes {
      id
      criteria {
        id
        heading
        ...CriteriaInputFragment
      }
      values {
        hash
        nodes {
          id
          value
          path {
            id
            type {
              id
              type
            }
          }
        }
      }
    }
  }
}
    ${CriteriaInputFragmentFragmentDoc}`;
export const ListTableFragmentFragmentDoc = gql`
    fragment ListTableFragment on List {
  id
}
    `;
export const PersonDetailAttributesSecondaryPositionFragmentFragmentDoc = gql`
    fragment PersonDetailAttributesSecondaryPositionFragment on SitePerson {
  id
  imfCt
  imfUt
  imfVt
  ct
  apurebaseId
  maintainerSource {
    code
    heading
  }
  originSource {
    code
    heading
  }
}
    `;
export const PersonDetailAttributesSharedCustomFieldsFragmentFragmentDoc = gql`
    fragment PersonDetailAttributesSharedCustomFieldsFragment on Person {
  id
  sharedCustomFields {
    id
    heading
    value {
      id
      value
    }
  }
}
    `;
export const PersonSitesFragmentFragmentDoc = gql`
    fragment PersonSitesFragment on SitePerson {
  id
  person {
    id
    affiliations {
      hash
      totalCount
      nodes {
        id
      }
    }
  }
}
    `;
export const PersonTableBuiltFragmentFragmentDoc = gql`
    fragment PersonTableBuiltFragment on Person {
  id
  countryCode
  isActive
  consentInstructions {
    hash
    optedOutFromAPB
  }
  isLocal
}
    `;
export const PersonSelectionRowTableBuiltFragmentFragmentDoc = gql`
    fragment PersonSelectionRowTableBuiltFragment on PersonSelectionRow {
  id
}
    `;
export const DynamicCriteriaInputFragmentDoc = gql`
    fragment DynamicCriteriaInput on Criteria {
  id
  heading
  entityType
  inputPaths {
    hash
    nodes {
      id
      service
      defaultOperatorType {
        id
        heading
        type
      }
      type {
        id
        type
      }
    }
  }
}
    `;
export const CriteriasGroupsFragmentFragmentDoc = gql`
    fragment CriteriasGroupsFragment on CriteriaGroup {
  id: code
  code
  heading
  entityId
  options {
    hash
    nodes {
      ...DynamicCriteriaInput
    }
  }
}
    ${DynamicCriteriaInputFragmentDoc}`;
export const SelectionRowResultTableBuiltFragmentFragmentDoc = gql`
    fragment SelectionRowResultTableBuiltFragment on SelectionRowResult {
  id
}
    `;
export const SitePersonForCacheFragmentDoc = gql`
    fragment SitePersonForCache on SitePerson {
  id
  site {
    id
    affiliations {
      hash
      totalCount
      nodes {
        id
      }
    }
  }
}
    `;
export const SiteSelectionRowTableBuiltFragmentFragmentDoc = gql`
    fragment SiteSelectionRowTableBuiltFragment on SiteSelectionRow {
  id
}
    `;
export const CustomFieldFragmentFragmentDoc = gql`
    fragment CustomFieldFragment on CustomField {
  code
  isActive
  allowMultiple
  color
  allowUserCreate
  isCheckableTag
  customFieldControlSetting {
    id
    createDcr
    maintainerSourceCode
    isSynced
  }
  fieldType {
    code
    enum
  }
  options(criteria: {fetchSize: {limit: null}, countries: $countries}) {
    hash
    nodes {
      id
      value {
        id
        value
      }
    }
  }
  accessRules: myAccessRules {
    id
    allowRead
    allowMutation
  }
}
    `;
export const CustomFieldValueFragmentFragmentDoc = gql`
    fragment CustomFieldValueFragment on CustomLinkValueConnection {
  hash
  nodes {
    id
    value {
      id
      value
    }
  }
}
    `;
export const DashboardItemFragmentFragmentDoc = gql`
    fragment DashboardItemFragment on DashboardItemConfiguration {
  id
  dashboardItemCode
  headingKey
  dashboardItem {
    code
    headingKey
    minHeight
    minWidth
  }
}
    `;
export const TableMapperFragmentFragmentDoc = gql`
    fragment TableMapperFragment on TableMapper {
  joinSupport {
    entityType
    id: headingKey
    headingKey
    code
    mode
    service
    dataValue
    supportedCriteriaTypes
    paths {
      id
      mapper
      mapperFrom
      mapperTo
      operatorOnMapperTo
    }
  }
}
    `;
export const TabCardConfigurationFragmentFragmentDoc = gql`
    fragment TabCardConfigurationFragment on EntityGridItemConfiguration {
  id
  heading
  typeEnum
  height
  width
  type {
    code
    headingKey
    minHeight
    minWidth
  }
}
    `;
export const DynamicTabGridFragmentFragmentDoc = gql`
    fragment DynamicTabGridFragment on EntityGridItemConfiguration {
  id
  typeEnum
  heading
  description
  x
  y
  width
  height
  ...TabCardConfigurationFragment
}
    ${TabCardConfigurationFragmentFragmentDoc}`;
export const PersonDetailSegmentationFragmentFragmentDoc = gql`
    fragment PersonDetailSegmentationFragment on PersonProductSegmentation {
  id
  segmentation: segmentationCode {
    id
    heading
  }
  product: product {
    id
    heading
    strengthUnitType {
      id
      abbreviation
      description
      name
    }
  }
}
    `;
export const NoteDrawerFragmentFragmentDoc = gql`
    fragment NoteDrawerFragment on Note {
  id
  text
  ct
  ut
  status
  private
  title
  user {
    id
    fullname
  }
}
    `;
export const HierarchyConnectionFragmentFragmentDoc = gql`
    fragment HierarchyConnectionFragment on SiteClosureConnection {
  hash
  totalCount
  nodes {
    ancestorId
    descendantId
    depth
    descendant {
      id
      name
      childrenHierarchy {
        hash
        totalCount
      }
    }
    ancestor {
      id
      name
      childrenHierarchy {
        hash
        totalCount
      }
    }
  }
}
    `;
export const SearchNodesFragmentFragmentDoc = gql`
    fragment SearchNodesFragment on SearchNode {
  id: searchId
  searchId
  heading
  code
  groups {
    conditions {
      nest {
        id: entityType
        entityType
        groups {
          conditions {
            dataType
            id: code
            code
            criteriaId
            type
            paths {
              mapper
              mapperTo
              mapperFrom
              operator
            }
            operation
            inputConfiguration {
              id: inputHeading
              valueService
              inputHeading
              inputPlaceholder
              inputHeadingMeta
              parentEntityType
              isInputPlaceholderKey
              isInputHeadingKey
              allowMultiple
              allowNoValue
              inputType
            }
            operation
            value
          }
          nextOperation
        }
      }
      dataType
      id: code
      code
      criteriaId
      type
      paths {
        mapper
        mapperTo
        mapperFrom
        operator
      }
      operation
      inputConfiguration {
        id: inputHeading
        valueService
        inputHeading
        inputPlaceholder
        inputHeadingMeta
        parentEntityType
        isInputPlaceholderKey
        isInputHeadingKey
        allowMultiple
        allowNoValue
        inputType
      }
      operation
      value
    }
    nextOperation
  }
}
    `;
export const SimpleSavedSearchFragmentFragmentDoc = gql`
    fragment SimpleSavedSearchFragment on CriteriaSimpleSaved {
  id
  heading
  totalCount
  criteriaAffiliations {
    hash
    nodes {
      id
      criteria {
        ...CriteriaInputFragment
      }
      paths {
        hash
        nodes {
          id
          pathId
          value
        }
      }
    }
  }
}
    ${CriteriaInputFragmentFragmentDoc}`;
export const MenuItemFragmentFragmentDoc = gql`
    fragment MenuItemFragment on MenuItem {
  code
  headingKey
  tooltipKey
  iconKey
  url
}
    `;
export const GridCardFieldFragmentDoc = gql`
    fragment GridCardField on EntityGridItemCardField {
  id
  fieldKey
  heading
  isHeadingKey
}
    `;
export const ViewerActivitiesCalendarDocument = gql`
    query ViewerActivitiesCalendar($responsibleUserId: ID!, $dateFrom: DateTime, $dateTo: DateTime) {
  activities(
    criteria: {responsibleUserId: $responsibleUserId, fetchSize: {limit: 100}, dateWithin: {from: $dateFrom, to: $dateTo}}
  ) {
    hash
    totalCount
    nodes {
      id
      startDate
      endDate
      heading
      status {
        code
        codeEnum
        headingKey
      }
      persons {
        hash
        nodes {
          id
          fullName
        }
      }
      sites {
        hash
        nodes {
          id
          name
          phone: mainContact(type: PHONE) {
            id
            value
          }
          visitAddress {
            id
            city
            countyCode
            street
            postalCode
          }
        }
      }
      type {
        code
        heading
        color {
          code
          value
        }
      }
    }
  }
}
    `;

/**
 * __useViewerActivitiesCalendarQuery__
 *
 * To run a query within a React component, call `useViewerActivitiesCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerActivitiesCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerActivitiesCalendarQuery({
 *   variables: {
 *      responsibleUserId: // value for 'responsibleUserId'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useViewerActivitiesCalendarQuery(baseOptions: Apollo.QueryHookOptions<ViewerActivitiesCalendarQuery, ViewerActivitiesCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewerActivitiesCalendarQuery, ViewerActivitiesCalendarQueryVariables>(ViewerActivitiesCalendarDocument, options);
      }
export function useViewerActivitiesCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewerActivitiesCalendarQuery, ViewerActivitiesCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewerActivitiesCalendarQuery, ViewerActivitiesCalendarQueryVariables>(ViewerActivitiesCalendarDocument, options);
        }
export type ViewerActivitiesCalendarQueryHookResult = ReturnType<typeof useViewerActivitiesCalendarQuery>;
export type ViewerActivitiesCalendarLazyQueryHookResult = ReturnType<typeof useViewerActivitiesCalendarLazyQuery>;
export type ViewerActivitiesCalendarQueryResult = Apollo.QueryResult<ViewerActivitiesCalendarQuery, ViewerActivitiesCalendarQueryVariables>;
export const UpdateActivityTimespanMutationDocument = gql`
    mutation UpdateActivityTimespanMutation($activityId: Int!, $startDate: DateTime!, $endDate: DateTime!) {
  updateActivity(
    input: {activityId: $activityId, startDate: $startDate, endDate: $endDate}
  ) {
    id
    startDate
    endDate
  }
}
    `;
export type UpdateActivityTimespanMutationMutationFn = Apollo.MutationFunction<UpdateActivityTimespanMutationMutation, UpdateActivityTimespanMutationMutationVariables>;

/**
 * __useUpdateActivityTimespanMutationMutation__
 *
 * To run a mutation, you first call `useUpdateActivityTimespanMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityTimespanMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityTimespanMutationMutation, { data, loading, error }] = useUpdateActivityTimespanMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUpdateActivityTimespanMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityTimespanMutationMutation, UpdateActivityTimespanMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityTimespanMutationMutation, UpdateActivityTimespanMutationMutationVariables>(UpdateActivityTimespanMutationDocument, options);
      }
export type UpdateActivityTimespanMutationMutationHookResult = ReturnType<typeof useUpdateActivityTimespanMutationMutation>;
export type UpdateActivityTimespanMutationMutationResult = Apollo.MutationResult<UpdateActivityTimespanMutationMutation>;
export type UpdateActivityTimespanMutationMutationOptions = Apollo.BaseMutationOptions<UpdateActivityTimespanMutationMutation, UpdateActivityTimespanMutationMutationVariables>;
export const usersResponsibleListDocument = gql`
    query usersResponsibleList($userId: ID!) {
  viewer {
    id
    fullname
    responsibleHcps {
      hash
      totalCount
      nodes {
        id
        ...ActivityPersonFragment
        fullName
        daysSinceLastActivity
        activitiesAffiliatedToMe: activities(criteria: {responsibleUserId: $userId}) {
          hash
          totalCount
        }
        primarySite {
          id
          name
        }
      }
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}`;

/**
 * __useusersResponsibleListQuery__
 *
 * To run a query within a React component, call `useusersResponsibleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useusersResponsibleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useusersResponsibleListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useusersResponsibleListQuery(baseOptions: Apollo.QueryHookOptions<usersResponsibleListQuery, usersResponsibleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<usersResponsibleListQuery, usersResponsibleListQueryVariables>(usersResponsibleListDocument, options);
      }
export function useusersResponsibleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<usersResponsibleListQuery, usersResponsibleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<usersResponsibleListQuery, usersResponsibleListQueryVariables>(usersResponsibleListDocument, options);
        }
export type usersResponsibleListQueryHookResult = ReturnType<typeof useusersResponsibleListQuery>;
export type usersResponsibleListLazyQueryHookResult = ReturnType<typeof useusersResponsibleListLazyQuery>;
export type usersResponsibleListQueryResult = Apollo.QueryResult<usersResponsibleListQuery, usersResponsibleListQueryVariables>;
export const AvailableUsersForCalendarDocument = gql`
    query AvailableUsersForCalendar($search: String) {
  users(criteria: {search: $search}) {
    hash
    nodes {
      id
      username: email
      fullname
      roleId
    }
  }
}
    `;

/**
 * __useAvailableUsersForCalendarQuery__
 *
 * To run a query within a React component, call `useAvailableUsersForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableUsersForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableUsersForCalendarQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAvailableUsersForCalendarQuery(baseOptions?: Apollo.QueryHookOptions<AvailableUsersForCalendarQuery, AvailableUsersForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableUsersForCalendarQuery, AvailableUsersForCalendarQueryVariables>(AvailableUsersForCalendarDocument, options);
      }
export function useAvailableUsersForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableUsersForCalendarQuery, AvailableUsersForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableUsersForCalendarQuery, AvailableUsersForCalendarQueryVariables>(AvailableUsersForCalendarDocument, options);
        }
export type AvailableUsersForCalendarQueryHookResult = ReturnType<typeof useAvailableUsersForCalendarQuery>;
export type AvailableUsersForCalendarLazyQueryHookResult = ReturnType<typeof useAvailableUsersForCalendarLazyQuery>;
export type AvailableUsersForCalendarQueryResult = Apollo.QueryResult<AvailableUsersForCalendarQuery, AvailableUsersForCalendarQueryVariables>;
export const ActivityOverviewDocument = gql`
    query ActivityOverview($limit: Int, $excludePreviousStatuses: [ActivityStatusEnum!], $responsibleUserId: Int!, $startDate: DateTime!, $endDate: DateTime!, $personLimit: Int, $pastActivityOrder: [ActivityCriteriaOrder!]!, $todayActivityOrder: [ActivityCriteriaOrder!], $futureActivityOrder: [ActivityCriteriaOrder!]) {
  user(userId: $responsibleUserId) {
    id
    firstname
    fullname
    previous: activities(
      criteria: {ordering: $pastActivityOrder, startDate: {from: null, to: $startDate}, statusNotIn: $excludePreviousStatuses, fetchSize: {limit: $limit}}
    ) {
      ...activityConnectionOverview
    }
    today: activities(
      criteria: {ordering: $todayActivityOrder, startDate: {from: $startDate, to: $endDate}, fetchSize: {limit: $limit}}
    ) {
      ...activityConnectionOverview
    }
    next: activities(
      criteria: {ordering: $futureActivityOrder, startDate: {from: $endDate, to: null}, fetchSize: {limit: $limit}}
    ) {
      ...activityConnectionOverview
    }
  }
}
    ${activityConnectionOverviewFragmentDoc}`;

/**
 * __useActivityOverviewQuery__
 *
 * To run a query within a React component, call `useActivityOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityOverviewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      excludePreviousStatuses: // value for 'excludePreviousStatuses'
 *      responsibleUserId: // value for 'responsibleUserId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      personLimit: // value for 'personLimit'
 *      pastActivityOrder: // value for 'pastActivityOrder'
 *      todayActivityOrder: // value for 'todayActivityOrder'
 *      futureActivityOrder: // value for 'futureActivityOrder'
 *   },
 * });
 */
export function useActivityOverviewQuery(baseOptions: Apollo.QueryHookOptions<ActivityOverviewQuery, ActivityOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityOverviewQuery, ActivityOverviewQueryVariables>(ActivityOverviewDocument, options);
      }
export function useActivityOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityOverviewQuery, ActivityOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityOverviewQuery, ActivityOverviewQueryVariables>(ActivityOverviewDocument, options);
        }
export type ActivityOverviewQueryHookResult = ReturnType<typeof useActivityOverviewQuery>;
export type ActivityOverviewLazyQueryHookResult = ReturnType<typeof useActivityOverviewLazyQuery>;
export type ActivityOverviewQueryResult = Apollo.QueryResult<ActivityOverviewQuery, ActivityOverviewQueryVariables>;
export const UserActivityOverViewDocument = gql`
    query UserActivityOverView {
  viewer {
    id
    user {
      id
      firstname
    }
  }
}
    `;

/**
 * __useUserActivityOverViewQuery__
 *
 * To run a query within a React component, call `useUserActivityOverViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivityOverViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivityOverViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserActivityOverViewQuery(baseOptions?: Apollo.QueryHookOptions<UserActivityOverViewQuery, UserActivityOverViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserActivityOverViewQuery, UserActivityOverViewQueryVariables>(UserActivityOverViewDocument, options);
      }
export function useUserActivityOverViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserActivityOverViewQuery, UserActivityOverViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserActivityOverViewQuery, UserActivityOverViewQueryVariables>(UserActivityOverViewDocument, options);
        }
export type UserActivityOverViewQueryHookResult = ReturnType<typeof useUserActivityOverViewQuery>;
export type UserActivityOverViewLazyQueryHookResult = ReturnType<typeof useUserActivityOverViewLazyQuery>;
export type UserActivityOverViewQueryResult = Apollo.QueryResult<UserActivityOverViewQuery, UserActivityOverViewQueryVariables>;
export const ActivityDetailsCalendarListQueryDocument = gql`
    query ActivityDetailsCalendarListQuery($activityId: Int!, $startOfDay: DateTime!, $endOfDay: DateTime!) {
  viewer {
    id
    activities(criteria: {dateWithin: {from: $startOfDay, to: $endOfDay}}) {
      hash
      nodes {
        id
        heading
        startDate
        endDate
      }
    }
  }
  activity(id: $activityId) {
    id
    startDate
  }
}
    `;

/**
 * __useActivityDetailsCalendarListQueryQuery__
 *
 * To run a query within a React component, call `useActivityDetailsCalendarListQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsCalendarListQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsCalendarListQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      startOfDay: // value for 'startOfDay'
 *      endOfDay: // value for 'endOfDay'
 *   },
 * });
 */
export function useActivityDetailsCalendarListQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsCalendarListQueryQuery, ActivityDetailsCalendarListQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsCalendarListQueryQuery, ActivityDetailsCalendarListQueryQueryVariables>(ActivityDetailsCalendarListQueryDocument, options);
      }
export function useActivityDetailsCalendarListQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsCalendarListQueryQuery, ActivityDetailsCalendarListQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsCalendarListQueryQuery, ActivityDetailsCalendarListQueryQueryVariables>(ActivityDetailsCalendarListQueryDocument, options);
        }
export type ActivityDetailsCalendarListQueryQueryHookResult = ReturnType<typeof useActivityDetailsCalendarListQueryQuery>;
export type ActivityDetailsCalendarListQueryLazyQueryHookResult = ReturnType<typeof useActivityDetailsCalendarListQueryLazyQuery>;
export type ActivityDetailsCalendarListQueryQueryResult = Apollo.QueryResult<ActivityDetailsCalendarListQueryQuery, ActivityDetailsCalendarListQueryQueryVariables>;
export const ActivityTypesQueryDocument = gql`
    query ActivityTypesQuery {
  activityTypes {
    hash
    nodes {
      code
      heading
      sort
      superTypeCode
      superType {
        code
        heading
      }
      color {
        code
        value
        headingKey
      }
      customFields {
        hash
        nodes {
          code
          heading
          fieldTypeEnum
        }
      }
      locationRule
      participationUserRule
      personRule
      projectRule
      responsibleUserRule
      productRule
      brandRule
      standardTimeLengthMinutes
    }
  }
}
    `;

/**
 * __useActivityTypesQueryQuery__
 *
 * To run a query within a React component, call `useActivityTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ActivityTypesQueryQuery, ActivityTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityTypesQueryQuery, ActivityTypesQueryQueryVariables>(ActivityTypesQueryDocument, options);
      }
export function useActivityTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityTypesQueryQuery, ActivityTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityTypesQueryQuery, ActivityTypesQueryQueryVariables>(ActivityTypesQueryDocument, options);
        }
export type ActivityTypesQueryQueryHookResult = ReturnType<typeof useActivityTypesQueryQuery>;
export type ActivityTypesQueryLazyQueryHookResult = ReturnType<typeof useActivityTypesQueryLazyQuery>;
export type ActivityTypesQueryQueryResult = Apollo.QueryResult<ActivityTypesQueryQuery, ActivityTypesQueryQueryVariables>;
export const ActivityDetailsQueryDocument = gql`
    query ActivityDetailsQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    heading
    typeCode
    startDate
  }
}
    `;

/**
 * __useActivityDetailsQueryQuery__
 *
 * To run a query within a React component, call `useActivityDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsQueryQuery, ActivityDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsQueryQuery, ActivityDetailsQueryQueryVariables>(ActivityDetailsQueryDocument, options);
      }
export function useActivityDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsQueryQuery, ActivityDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsQueryQuery, ActivityDetailsQueryQueryVariables>(ActivityDetailsQueryDocument, options);
        }
export type ActivityDetailsQueryQueryHookResult = ReturnType<typeof useActivityDetailsQueryQuery>;
export type ActivityDetailsQueryLazyQueryHookResult = ReturnType<typeof useActivityDetailsQueryLazyQuery>;
export type ActivityDetailsQueryQueryResult = Apollo.QueryResult<ActivityDetailsQueryQuery, ActivityDetailsQueryQueryVariables>;
export const ActivityDetailsCustomFieldsDocument = gql`
    query ActivityDetailsCustomFields($activityTypeCode: String!, $activityId: Int, $includeValues: Boolean!, $countries: [CountryCode!]) {
  activityType(code: $activityTypeCode) {
    code
    customFields {
      hash
      nodes {
        code
        heading
        fieldTypeEnum
        ...CustomFieldFragment
        customLinkValues(recordId: $activityId) {
          hash @include(if: $includeValues)
          ...CustomFieldValueFragment
        }
      }
    }
  }
}
    ${CustomFieldFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}`;

/**
 * __useActivityDetailsCustomFieldsQuery__
 *
 * To run a query within a React component, call `useActivityDetailsCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsCustomFieldsQuery({
 *   variables: {
 *      activityTypeCode: // value for 'activityTypeCode'
 *      activityId: // value for 'activityId'
 *      includeValues: // value for 'includeValues'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useActivityDetailsCustomFieldsQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsCustomFieldsQuery, ActivityDetailsCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsCustomFieldsQuery, ActivityDetailsCustomFieldsQueryVariables>(ActivityDetailsCustomFieldsDocument, options);
      }
export function useActivityDetailsCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsCustomFieldsQuery, ActivityDetailsCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsCustomFieldsQuery, ActivityDetailsCustomFieldsQueryVariables>(ActivityDetailsCustomFieldsDocument, options);
        }
export type ActivityDetailsCustomFieldsQueryHookResult = ReturnType<typeof useActivityDetailsCustomFieldsQuery>;
export type ActivityDetailsCustomFieldsLazyQueryHookResult = ReturnType<typeof useActivityDetailsCustomFieldsLazyQuery>;
export type ActivityDetailsCustomFieldsQueryResult = Apollo.QueryResult<ActivityDetailsCustomFieldsQuery, ActivityDetailsCustomFieldsQueryVariables>;
export const ActivityDetailDocument = gql`
    query ActivityDetail($id: Int!) {
  activity(id: $id) {
    id
    notes {
      hash
      totalCount
      nodes {
        id
        ...NoteDrawerFragment
      }
    }
  }
}
    ${NoteDrawerFragmentFragmentDoc}`;

/**
 * __useActivityDetailQuery__
 *
 * To run a query within a React component, call `useActivityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityDetailQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailQuery, ActivityDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailQuery, ActivityDetailQueryVariables>(ActivityDetailDocument, options);
      }
export function useActivityDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailQuery, ActivityDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailQuery, ActivityDetailQueryVariables>(ActivityDetailDocument, options);
        }
export type ActivityDetailQueryHookResult = ReturnType<typeof useActivityDetailQuery>;
export type ActivityDetailLazyQueryHookResult = ReturnType<typeof useActivityDetailLazyQuery>;
export type ActivityDetailQueryResult = Apollo.QueryResult<ActivityDetailQuery, ActivityDetailQueryVariables>;
export const FindHcoActivityAffiliationsDocument = gql`
    query FindHcoActivityAffiliations($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
  }
}
    `;

/**
 * __useFindHcoActivityAffiliationsQuery__
 *
 * To run a query within a React component, call `useFindHcoActivityAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHcoActivityAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHcoActivityAffiliationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useFindHcoActivityAffiliationsQuery(baseOptions: Apollo.QueryHookOptions<FindHcoActivityAffiliationsQuery, FindHcoActivityAffiliationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHcoActivityAffiliationsQuery, FindHcoActivityAffiliationsQueryVariables>(FindHcoActivityAffiliationsDocument, options);
      }
export function useFindHcoActivityAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHcoActivityAffiliationsQuery, FindHcoActivityAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHcoActivityAffiliationsQuery, FindHcoActivityAffiliationsQueryVariables>(FindHcoActivityAffiliationsDocument, options);
        }
export type FindHcoActivityAffiliationsQueryHookResult = ReturnType<typeof useFindHcoActivityAffiliationsQuery>;
export type FindHcoActivityAffiliationsLazyQueryHookResult = ReturnType<typeof useFindHcoActivityAffiliationsLazyQuery>;
export type FindHcoActivityAffiliationsQueryResult = Apollo.QueryResult<FindHcoActivityAffiliationsQuery, FindHcoActivityAffiliationsQueryVariables>;
export const AddMultiplePersonToActivityMutationDocument = gql`
    mutation AddMultiplePersonToActivityMutation($activityId: Int!, $selection: SelectionCriteriaInput!) {
  addPersonsToActivity(activityId: $activityId, selection: $selection) {
    id
    persons {
      hash
      totalCount
      nodes {
        id
        ...ActivityPersonFragment
      }
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}`;
export type AddMultiplePersonToActivityMutationMutationFn = Apollo.MutationFunction<AddMultiplePersonToActivityMutationMutation, AddMultiplePersonToActivityMutationMutationVariables>;

/**
 * __useAddMultiplePersonToActivityMutationMutation__
 *
 * To run a mutation, you first call `useAddMultiplePersonToActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultiplePersonToActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultiplePersonToActivityMutationMutation, { data, loading, error }] = useAddMultiplePersonToActivityMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useAddMultiplePersonToActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddMultiplePersonToActivityMutationMutation, AddMultiplePersonToActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMultiplePersonToActivityMutationMutation, AddMultiplePersonToActivityMutationMutationVariables>(AddMultiplePersonToActivityMutationDocument, options);
      }
export type AddMultiplePersonToActivityMutationMutationHookResult = ReturnType<typeof useAddMultiplePersonToActivityMutationMutation>;
export type AddMultiplePersonToActivityMutationMutationResult = Apollo.MutationResult<AddMultiplePersonToActivityMutationMutation>;
export type AddMultiplePersonToActivityMutationMutationOptions = Apollo.BaseMutationOptions<AddMultiplePersonToActivityMutationMutation, AddMultiplePersonToActivityMutationMutationVariables>;
export const RemoveMultiplePersonToActivityMutationDocument = gql`
    mutation RemoveMultiplePersonToActivityMutation($activityId: Int!, $personSelection: SelectionCriteriaInput!) {
  removePersonsFromActivity(
    activityId: $activityId
    personSelection: $personSelection
  ) {
    id
    persons {
      hash
      totalCount
      nodes {
        id
        ...ActivityPersonFragment
      }
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}`;
export type RemoveMultiplePersonToActivityMutationMutationFn = Apollo.MutationFunction<RemoveMultiplePersonToActivityMutationMutation, RemoveMultiplePersonToActivityMutationMutationVariables>;

/**
 * __useRemoveMultiplePersonToActivityMutationMutation__
 *
 * To run a mutation, you first call `useRemoveMultiplePersonToActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMultiplePersonToActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMultiplePersonToActivityMutationMutation, { data, loading, error }] = useRemoveMultiplePersonToActivityMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      personSelection: // value for 'personSelection'
 *   },
 * });
 */
export function useRemoveMultiplePersonToActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMultiplePersonToActivityMutationMutation, RemoveMultiplePersonToActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMultiplePersonToActivityMutationMutation, RemoveMultiplePersonToActivityMutationMutationVariables>(RemoveMultiplePersonToActivityMutationDocument, options);
      }
export type RemoveMultiplePersonToActivityMutationMutationHookResult = ReturnType<typeof useRemoveMultiplePersonToActivityMutationMutation>;
export type RemoveMultiplePersonToActivityMutationMutationResult = Apollo.MutationResult<RemoveMultiplePersonToActivityMutationMutation>;
export type RemoveMultiplePersonToActivityMutationMutationOptions = Apollo.BaseMutationOptions<RemoveMultiplePersonToActivityMutationMutation, RemoveMultiplePersonToActivityMutationMutationVariables>;
export const ReplaceSinglePersonToActivityMutationDocument = gql`
    mutation ReplaceSinglePersonToActivityMutation($activityId: Int!, $personId: Int!) {
  replacePersonInActivity(activityId: $activityId, personId: $personId) {
    id
    persons {
      hash
      totalCount
      nodes {
        id
        ...ActivityPersonFragment
      }
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}`;
export type ReplaceSinglePersonToActivityMutationMutationFn = Apollo.MutationFunction<ReplaceSinglePersonToActivityMutationMutation, ReplaceSinglePersonToActivityMutationMutationVariables>;

/**
 * __useReplaceSinglePersonToActivityMutationMutation__
 *
 * To run a mutation, you first call `useReplaceSinglePersonToActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceSinglePersonToActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceSinglePersonToActivityMutationMutation, { data, loading, error }] = useReplaceSinglePersonToActivityMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useReplaceSinglePersonToActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceSinglePersonToActivityMutationMutation, ReplaceSinglePersonToActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceSinglePersonToActivityMutationMutation, ReplaceSinglePersonToActivityMutationMutationVariables>(ReplaceSinglePersonToActivityMutationDocument, options);
      }
export type ReplaceSinglePersonToActivityMutationMutationHookResult = ReturnType<typeof useReplaceSinglePersonToActivityMutationMutation>;
export type ReplaceSinglePersonToActivityMutationMutationResult = Apollo.MutationResult<ReplaceSinglePersonToActivityMutationMutation>;
export type ReplaceSinglePersonToActivityMutationMutationOptions = Apollo.BaseMutationOptions<ReplaceSinglePersonToActivityMutationMutation, ReplaceSinglePersonToActivityMutationMutationVariables>;
export const ActivityPersonsQueryDocument = gql`
    query ActivityPersonsQuery($activityId: ID!, $limit: Int!, $offset: Int!, $ordering: [PersonCriteriaOrder!]) {
  persons(
    criteria: {activityId: $activityId, includeUnplaced: null, isActive: BOTH, ordering: $ordering, fetchSize: {limit: $limit, offset: $offset}}
  ) {
    hash
    totalCount
    nodes {
      id
      ...ActivityPersonFragment
      ...PersonTableBuiltFragment
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}
${PersonTableBuiltFragmentFragmentDoc}`;

/**
 * __useActivityPersonsQueryQuery__
 *
 * To run a query within a React component, call `useActivityPersonsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityPersonsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityPersonsQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useActivityPersonsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityPersonsQueryQuery, ActivityPersonsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityPersonsQueryQuery, ActivityPersonsQueryQueryVariables>(ActivityPersonsQueryDocument, options);
      }
export function useActivityPersonsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityPersonsQueryQuery, ActivityPersonsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityPersonsQueryQuery, ActivityPersonsQueryQueryVariables>(ActivityPersonsQueryDocument, options);
        }
export type ActivityPersonsQueryQueryHookResult = ReturnType<typeof useActivityPersonsQueryQuery>;
export type ActivityPersonsQueryLazyQueryHookResult = ReturnType<typeof useActivityPersonsQueryLazyQuery>;
export type ActivityPersonsQueryQueryResult = Apollo.QueryResult<ActivityPersonsQueryQuery, ActivityPersonsQueryQueryVariables>;
export const ActivityPersonSelectionIdsQueryDocument = gql`
    query ActivityPersonSelectionIdsQuery($selection: SelectionCriteriaInput!) {
  selectionToIds(selection: $selection, entityType: PERSON)
}
    `;

/**
 * __useActivityPersonSelectionIdsQueryQuery__
 *
 * To run a query within a React component, call `useActivityPersonSelectionIdsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityPersonSelectionIdsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityPersonSelectionIdsQueryQuery({
 *   variables: {
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useActivityPersonSelectionIdsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityPersonSelectionIdsQueryQuery, ActivityPersonSelectionIdsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityPersonSelectionIdsQueryQuery, ActivityPersonSelectionIdsQueryQueryVariables>(ActivityPersonSelectionIdsQueryDocument, options);
      }
export function useActivityPersonSelectionIdsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityPersonSelectionIdsQueryQuery, ActivityPersonSelectionIdsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityPersonSelectionIdsQueryQuery, ActivityPersonSelectionIdsQueryQueryVariables>(ActivityPersonSelectionIdsQueryDocument, options);
        }
export type ActivityPersonSelectionIdsQueryQueryHookResult = ReturnType<typeof useActivityPersonSelectionIdsQueryQuery>;
export type ActivityPersonSelectionIdsQueryLazyQueryHookResult = ReturnType<typeof useActivityPersonSelectionIdsQueryLazyQuery>;
export type ActivityPersonSelectionIdsQueryQueryResult = Apollo.QueryResult<ActivityPersonSelectionIdsQueryQuery, ActivityPersonSelectionIdsQueryQueryVariables>;
export const personActivityQueryDocument = gql`
    query personActivityQuery($ids: [ID!], $limit: Int, $offset: Int) {
  persons(
    criteria: {ids: $ids, includeUnplaced: null, isActive: BOTH, fetchSize: {limit: $limit, offset: $offset}}
  ) {
    hash
    nodes {
      id
      ...ActivityPersonFragment
      ...PersonTableBuiltFragment
    }
  }
}
    ${ActivityPersonFragmentFragmentDoc}
${PersonTableBuiltFragmentFragmentDoc}`;

/**
 * __usepersonActivityQueryQuery__
 *
 * To run a query within a React component, call `usepersonActivityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usepersonActivityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepersonActivityQueryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usepersonActivityQueryQuery(baseOptions?: Apollo.QueryHookOptions<personActivityQueryQuery, personActivityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<personActivityQueryQuery, personActivityQueryQueryVariables>(personActivityQueryDocument, options);
      }
export function usepersonActivityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<personActivityQueryQuery, personActivityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<personActivityQueryQuery, personActivityQueryQueryVariables>(personActivityQueryDocument, options);
        }
export type personActivityQueryQueryHookResult = ReturnType<typeof usepersonActivityQueryQuery>;
export type personActivityQueryLazyQueryHookResult = ReturnType<typeof usepersonActivityQueryLazyQuery>;
export type personActivityQueryQueryResult = Apollo.QueryResult<personActivityQueryQuery, personActivityQueryQueryVariables>;
export const ActivityResponsibleUsersQueryDocument = gql`
    query ActivityResponsibleUsersQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    responsibleUsers {
      hash
      nodes {
        id
        fullname
        email
      }
    }
  }
}
    `;

/**
 * __useActivityResponsibleUsersQueryQuery__
 *
 * To run a query within a React component, call `useActivityResponsibleUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityResponsibleUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityResponsibleUsersQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityResponsibleUsersQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityResponsibleUsersQueryQuery, ActivityResponsibleUsersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityResponsibleUsersQueryQuery, ActivityResponsibleUsersQueryQueryVariables>(ActivityResponsibleUsersQueryDocument, options);
      }
export function useActivityResponsibleUsersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityResponsibleUsersQueryQuery, ActivityResponsibleUsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityResponsibleUsersQueryQuery, ActivityResponsibleUsersQueryQueryVariables>(ActivityResponsibleUsersQueryDocument, options);
        }
export type ActivityResponsibleUsersQueryQueryHookResult = ReturnType<typeof useActivityResponsibleUsersQueryQuery>;
export type ActivityResponsibleUsersQueryLazyQueryHookResult = ReturnType<typeof useActivityResponsibleUsersQueryLazyQuery>;
export type ActivityResponsibleUsersQueryQueryResult = Apollo.QueryResult<ActivityResponsibleUsersQueryQuery, ActivityResponsibleUsersQueryQueryVariables>;
export const ResponsibleUsersSearchQueryDocument = gql`
    query ResponsibleUsersSearchQuery($userSearch: String) {
  users(criteria: {search: $userSearch, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      id
      fullname
      email
    }
  }
}
    `;

/**
 * __useResponsibleUsersSearchQueryQuery__
 *
 * To run a query within a React component, call `useResponsibleUsersSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponsibleUsersSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponsibleUsersSearchQueryQuery({
 *   variables: {
 *      userSearch: // value for 'userSearch'
 *   },
 * });
 */
export function useResponsibleUsersSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<ResponsibleUsersSearchQueryQuery, ResponsibleUsersSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponsibleUsersSearchQueryQuery, ResponsibleUsersSearchQueryQueryVariables>(ResponsibleUsersSearchQueryDocument, options);
      }
export function useResponsibleUsersSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponsibleUsersSearchQueryQuery, ResponsibleUsersSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponsibleUsersSearchQueryQuery, ResponsibleUsersSearchQueryQueryVariables>(ResponsibleUsersSearchQueryDocument, options);
        }
export type ResponsibleUsersSearchQueryQueryHookResult = ReturnType<typeof useResponsibleUsersSearchQueryQuery>;
export type ResponsibleUsersSearchQueryLazyQueryHookResult = ReturnType<typeof useResponsibleUsersSearchQueryLazyQuery>;
export type ResponsibleUsersSearchQueryQueryResult = Apollo.QueryResult<ResponsibleUsersSearchQueryQuery, ResponsibleUsersSearchQueryQueryVariables>;
export const UpdateActivityResponsibleUsersMutationDocument = gql`
    mutation UpdateActivityResponsibleUsersMutation($activityId: Int!, $responsibleUserIds: [Int!]!) {
  updateActivityResponsibleUsers(
    activityId: $activityId
    responsibleUserIds: $responsibleUserIds
  ) {
    id
    responsibleUsers {
      hash
      nodes {
        id
        fullname
        email
      }
    }
  }
}
    `;
export type UpdateActivityResponsibleUsersMutationMutationFn = Apollo.MutationFunction<UpdateActivityResponsibleUsersMutationMutation, UpdateActivityResponsibleUsersMutationMutationVariables>;

/**
 * __useUpdateActivityResponsibleUsersMutationMutation__
 *
 * To run a mutation, you first call `useUpdateActivityResponsibleUsersMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityResponsibleUsersMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityResponsibleUsersMutationMutation, { data, loading, error }] = useUpdateActivityResponsibleUsersMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      responsibleUserIds: // value for 'responsibleUserIds'
 *   },
 * });
 */
export function useUpdateActivityResponsibleUsersMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityResponsibleUsersMutationMutation, UpdateActivityResponsibleUsersMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityResponsibleUsersMutationMutation, UpdateActivityResponsibleUsersMutationMutationVariables>(UpdateActivityResponsibleUsersMutationDocument, options);
      }
export type UpdateActivityResponsibleUsersMutationMutationHookResult = ReturnType<typeof useUpdateActivityResponsibleUsersMutationMutation>;
export type UpdateActivityResponsibleUsersMutationMutationResult = Apollo.MutationResult<UpdateActivityResponsibleUsersMutationMutation>;
export type UpdateActivityResponsibleUsersMutationMutationOptions = Apollo.BaseMutationOptions<UpdateActivityResponsibleUsersMutationMutation, UpdateActivityResponsibleUsersMutationMutationVariables>;
export const ActivitySiteAffiliationsDocument = gql`
    query ActivitySiteAffiliations($id: Int!) {
  activity(id: $id) {
    id
    sites {
      hash
      nodes {
        ...ActivitySiteSiteFragment
      }
    }
    siteAffiliations {
      ...SiteFragmentForDisplay
    }
  }
}
    ${ActivitySiteSiteFragmentFragmentDoc}
${SiteFragmentForDisplayFragmentDoc}`;

/**
 * __useActivitySiteAffiliationsQuery__
 *
 * To run a query within a React component, call `useActivitySiteAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySiteAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySiteAffiliationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivitySiteAffiliationsQuery(baseOptions: Apollo.QueryHookOptions<ActivitySiteAffiliationsQuery, ActivitySiteAffiliationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitySiteAffiliationsQuery, ActivitySiteAffiliationsQueryVariables>(ActivitySiteAffiliationsDocument, options);
      }
export function useActivitySiteAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitySiteAffiliationsQuery, ActivitySiteAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitySiteAffiliationsQuery, ActivitySiteAffiliationsQueryVariables>(ActivitySiteAffiliationsDocument, options);
        }
export type ActivitySiteAffiliationsQueryHookResult = ReturnType<typeof useActivitySiteAffiliationsQuery>;
export type ActivitySiteAffiliationsLazyQueryHookResult = ReturnType<typeof useActivitySiteAffiliationsLazyQuery>;
export type ActivitySiteAffiliationsQueryResult = Apollo.QueryResult<ActivitySiteAffiliationsQuery, ActivitySiteAffiliationsQueryVariables>;
export const ActivitySitesSuggestionsDocument = gql`
    query ActivitySitesSuggestions($personIds: [ID!], $activityId: ID, $siteIds: [ID!]) {
  sites(criteria: {personIds: $personIds, activityId: $activityId, ids: $siteIds}) {
    hash
    nodes {
      ...SiteFragmentForDisplay
    }
  }
}
    ${SiteFragmentForDisplayFragmentDoc}`;

/**
 * __useActivitySitesSuggestionsQuery__
 *
 * To run a query within a React component, call `useActivitySitesSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitySitesSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitySitesSuggestionsQuery({
 *   variables: {
 *      personIds: // value for 'personIds'
 *      activityId: // value for 'activityId'
 *      siteIds: // value for 'siteIds'
 *   },
 * });
 */
export function useActivitySitesSuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<ActivitySitesSuggestionsQuery, ActivitySitesSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitySitesSuggestionsQuery, ActivitySitesSuggestionsQueryVariables>(ActivitySitesSuggestionsDocument, options);
      }
export function useActivitySitesSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitySitesSuggestionsQuery, ActivitySitesSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitySitesSuggestionsQuery, ActivitySitesSuggestionsQueryVariables>(ActivitySitesSuggestionsDocument, options);
        }
export type ActivitySitesSuggestionsQueryHookResult = ReturnType<typeof useActivitySitesSuggestionsQuery>;
export type ActivitySitesSuggestionsLazyQueryHookResult = ReturnType<typeof useActivitySitesSuggestionsLazyQuery>;
export type ActivitySitesSuggestionsQueryResult = Apollo.QueryResult<ActivitySitesSuggestionsQuery, ActivitySitesSuggestionsQueryVariables>;
export const UpdateActivityLocationDocument = gql`
    mutation UpdateActivityLocation($activityId: Int!, $locationId: Int!) {
  updateActivityLocation(
    input: {activityId: $activityId, locationId: $locationId}
  ) {
    id
  }
}
    `;
export type UpdateActivityLocationMutationFn = Apollo.MutationFunction<UpdateActivityLocationMutation, UpdateActivityLocationMutationVariables>;

/**
 * __useUpdateActivityLocationMutation__
 *
 * To run a mutation, you first call `useUpdateActivityLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityLocationMutation, { data, loading, error }] = useUpdateActivityLocationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUpdateActivityLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityLocationMutation, UpdateActivityLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityLocationMutation, UpdateActivityLocationMutationVariables>(UpdateActivityLocationDocument, options);
      }
export type UpdateActivityLocationMutationHookResult = ReturnType<typeof useUpdateActivityLocationMutation>;
export type UpdateActivityLocationMutationResult = Apollo.MutationResult<UpdateActivityLocationMutation>;
export type UpdateActivityLocationMutationOptions = Apollo.BaseMutationOptions<UpdateActivityLocationMutation, UpdateActivityLocationMutationVariables>;
export const ActivityDateDetailsQueryDocument = gql`
    query ActivityDateDetailsQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    heading
    typeCode
    statusCode
    startDate
    endDate
  }
}
    `;

/**
 * __useActivityDateDetailsQueryQuery__
 *
 * To run a query within a React component, call `useActivityDateDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDateDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDateDetailsQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDateDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityDateDetailsQueryQuery, ActivityDateDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDateDetailsQueryQuery, ActivityDateDetailsQueryQueryVariables>(ActivityDateDetailsQueryDocument, options);
      }
export function useActivityDateDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDateDetailsQueryQuery, ActivityDateDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDateDetailsQueryQuery, ActivityDateDetailsQueryQueryVariables>(ActivityDateDetailsQueryDocument, options);
        }
export type ActivityDateDetailsQueryQueryHookResult = ReturnType<typeof useActivityDateDetailsQueryQuery>;
export type ActivityDateDetailsQueryLazyQueryHookResult = ReturnType<typeof useActivityDateDetailsQueryLazyQuery>;
export type ActivityDateDetailsQueryQueryResult = Apollo.QueryResult<ActivityDateDetailsQueryQuery, ActivityDateDetailsQueryQueryVariables>;
export const UpdateActivityDatesDocument = gql`
    mutation UpdateActivityDates($input: UpdateActivityInput!) {
  updateActivity(input: $input) {
    id
    startDate
    endDate
  }
}
    `;
export type UpdateActivityDatesMutationFn = Apollo.MutationFunction<UpdateActivityDatesMutation, UpdateActivityDatesMutationVariables>;

/**
 * __useUpdateActivityDatesMutation__
 *
 * To run a mutation, you first call `useUpdateActivityDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityDatesMutation, { data, loading, error }] = useUpdateActivityDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityDatesMutation, UpdateActivityDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityDatesMutation, UpdateActivityDatesMutationVariables>(UpdateActivityDatesDocument, options);
      }
export type UpdateActivityDatesMutationHookResult = ReturnType<typeof useUpdateActivityDatesMutation>;
export type UpdateActivityDatesMutationResult = Apollo.MutationResult<UpdateActivityDatesMutation>;
export type UpdateActivityDatesMutationOptions = Apollo.BaseMutationOptions<UpdateActivityDatesMutation, UpdateActivityDatesMutationVariables>;
export const UpdateActivityTitleDocument = gql`
    mutation UpdateActivityTitle($activityId: Int!, $title: String!) {
  updateActivity(input: {activityId: $activityId, heading: $title}) {
    id
    heading
  }
}
    `;
export type UpdateActivityTitleMutationFn = Apollo.MutationFunction<UpdateActivityTitleMutation, UpdateActivityTitleMutationVariables>;

/**
 * __useUpdateActivityTitleMutation__
 *
 * To run a mutation, you first call `useUpdateActivityTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityTitleMutation, { data, loading, error }] = useUpdateActivityTitleMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateActivityTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityTitleMutation, UpdateActivityTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityTitleMutation, UpdateActivityTitleMutationVariables>(UpdateActivityTitleDocument, options);
      }
export type UpdateActivityTitleMutationHookResult = ReturnType<typeof useUpdateActivityTitleMutation>;
export type UpdateActivityTitleMutationResult = Apollo.MutationResult<UpdateActivityTitleMutation>;
export type UpdateActivityTitleMutationOptions = Apollo.BaseMutationOptions<UpdateActivityTitleMutation, UpdateActivityTitleMutationVariables>;
export const ActivityHeadingDetailsQueryDocument = gql`
    query ActivityHeadingDetailsQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    heading
    typeCode
    statusCode
    startDate
    endDate
  }
}
    `;

/**
 * __useActivityHeadingDetailsQueryQuery__
 *
 * To run a query within a React component, call `useActivityHeadingDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityHeadingDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityHeadingDetailsQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityHeadingDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityHeadingDetailsQueryQuery, ActivityHeadingDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityHeadingDetailsQueryQuery, ActivityHeadingDetailsQueryQueryVariables>(ActivityHeadingDetailsQueryDocument, options);
      }
export function useActivityHeadingDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityHeadingDetailsQueryQuery, ActivityHeadingDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityHeadingDetailsQueryQuery, ActivityHeadingDetailsQueryQueryVariables>(ActivityHeadingDetailsQueryDocument, options);
        }
export type ActivityHeadingDetailsQueryQueryHookResult = ReturnType<typeof useActivityHeadingDetailsQueryQuery>;
export type ActivityHeadingDetailsQueryLazyQueryHookResult = ReturnType<typeof useActivityHeadingDetailsQueryLazyQuery>;
export type ActivityHeadingDetailsQueryQueryResult = Apollo.QueryResult<ActivityHeadingDetailsQueryQuery, ActivityHeadingDetailsQueryQueryVariables>;
export const ActivityProductQueryDocument = gql`
    query ActivityProductQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    activityProductAffiliations {
      hash
      totalCount
      nodes {
        id
        product {
          id
          heading
          code
        }
      }
    }
  }
}
    `;

/**
 * __useActivityProductQueryQuery__
 *
 * To run a query within a React component, call `useActivityProductQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityProductQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityProductQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityProductQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityProductQueryQuery, ActivityProductQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityProductQueryQuery, ActivityProductQueryQueryVariables>(ActivityProductQueryDocument, options);
      }
export function useActivityProductQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityProductQueryQuery, ActivityProductQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityProductQueryQuery, ActivityProductQueryQueryVariables>(ActivityProductQueryDocument, options);
        }
export type ActivityProductQueryQueryHookResult = ReturnType<typeof useActivityProductQueryQuery>;
export type ActivityProductQueryLazyQueryHookResult = ReturnType<typeof useActivityProductQueryLazyQuery>;
export type ActivityProductQueryQueryResult = Apollo.QueryResult<ActivityProductQueryQuery, ActivityProductQueryQueryVariables>;
export const ActivityProductSuggestionQueryDocument = gql`
    query ActivityProductSuggestionQuery($activityId: ID) {
  products(criteria: {excludeActivityId: $activityId}) {
    hash
    nodes {
      id
      code
      heading
    }
  }
}
    `;

/**
 * __useActivityProductSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useActivityProductSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityProductSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityProductSuggestionQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityProductSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<ActivityProductSuggestionQueryQuery, ActivityProductSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityProductSuggestionQueryQuery, ActivityProductSuggestionQueryQueryVariables>(ActivityProductSuggestionQueryDocument, options);
      }
export function useActivityProductSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityProductSuggestionQueryQuery, ActivityProductSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityProductSuggestionQueryQuery, ActivityProductSuggestionQueryQueryVariables>(ActivityProductSuggestionQueryDocument, options);
        }
export type ActivityProductSuggestionQueryQueryHookResult = ReturnType<typeof useActivityProductSuggestionQueryQuery>;
export type ActivityProductSuggestionQueryLazyQueryHookResult = ReturnType<typeof useActivityProductSuggestionQueryLazyQuery>;
export type ActivityProductSuggestionQueryQueryResult = Apollo.QueryResult<ActivityProductSuggestionQueryQuery, ActivityProductSuggestionQueryQueryVariables>;
export const AddProductToActivityDocument = gql`
    mutation AddProductToActivity($activityId: ID!, $productId: ID!) {
  addProductToActivity(activityId: $activityId, productId: $productId) {
    id
    activityProductAffiliations {
      hash
      nodes {
        id
        product {
          id
          heading
          code
        }
      }
    }
  }
}
    `;
export type AddProductToActivityMutationFn = Apollo.MutationFunction<AddProductToActivityMutation, AddProductToActivityMutationVariables>;

/**
 * __useAddProductToActivityMutation__
 *
 * To run a mutation, you first call `useAddProductToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToActivityMutation, { data, loading, error }] = useAddProductToActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAddProductToActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToActivityMutation, AddProductToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToActivityMutation, AddProductToActivityMutationVariables>(AddProductToActivityDocument, options);
      }
export type AddProductToActivityMutationHookResult = ReturnType<typeof useAddProductToActivityMutation>;
export type AddProductToActivityMutationResult = Apollo.MutationResult<AddProductToActivityMutation>;
export type AddProductToActivityMutationOptions = Apollo.BaseMutationOptions<AddProductToActivityMutation, AddProductToActivityMutationVariables>;
export const RemoveProductToActivityDocument = gql`
    mutation RemoveProductToActivity($activityId: Int!, $productId: Int!) {
  removeProductToActivity(activityId: $activityId, productId: $productId) {
    id
    activityProductAffiliations {
      hash
      nodes {
        id
        product {
          id
          heading
          code
        }
      }
    }
  }
}
    `;
export type RemoveProductToActivityMutationFn = Apollo.MutationFunction<RemoveProductToActivityMutation, RemoveProductToActivityMutationVariables>;

/**
 * __useRemoveProductToActivityMutation__
 *
 * To run a mutation, you first call `useRemoveProductToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductToActivityMutation, { data, loading, error }] = useRemoveProductToActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveProductToActivityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductToActivityMutation, RemoveProductToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductToActivityMutation, RemoveProductToActivityMutationVariables>(RemoveProductToActivityDocument, options);
      }
export type RemoveProductToActivityMutationHookResult = ReturnType<typeof useRemoveProductToActivityMutation>;
export type RemoveProductToActivityMutationResult = Apollo.MutationResult<RemoveProductToActivityMutation>;
export type RemoveProductToActivityMutationOptions = Apollo.BaseMutationOptions<RemoveProductToActivityMutation, RemoveProductToActivityMutationVariables>;
export const CreateActivityMutationDocument = gql`
    mutation CreateActivityMutation($input: CreateActivityInput!) {
  createActivity(input: $input) {
    id
  }
}
    `;
export type CreateActivityMutationMutationFn = Apollo.MutationFunction<CreateActivityMutationMutation, CreateActivityMutationMutationVariables>;

/**
 * __useCreateActivityMutationMutation__
 *
 * To run a mutation, you first call `useCreateActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivityMutationMutation, { data, loading, error }] = useCreateActivityMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateActivityMutationMutation, CreateActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActivityMutationMutation, CreateActivityMutationMutationVariables>(CreateActivityMutationDocument, options);
      }
export type CreateActivityMutationMutationHookResult = ReturnType<typeof useCreateActivityMutationMutation>;
export type CreateActivityMutationMutationResult = Apollo.MutationResult<CreateActivityMutationMutation>;
export type CreateActivityMutationMutationOptions = Apollo.BaseMutationOptions<CreateActivityMutationMutation, CreateActivityMutationMutationVariables>;
export const ActivitiesTableConnectionQueryBuiltDocument = gql`
    query ActivitiesTableConnectionQueryBuilt($criteria: ActivityCriteria) {
  connection: activities(criteria: $criteria) {
    hash
    totalCount
    nodes {
      id
      heading
      startDate
      endDate
      responsibleUsers {
        hash
        nodes {
          id
          fullname
        }
      }
      persons {
        hash
        totalCount
        nodes {
          id
          fullName
        }
      }
      sites {
        hash
        totalCount
        nodes {
          id
          name
        }
      }
      ...ActivityTableBuiltFragment
    }
  }
}
    ${ActivityTableBuiltFragmentFragmentDoc}`;

/**
 * __useActivitiesTableConnectionQueryBuiltQuery__
 *
 * To run a query within a React component, call `useActivitiesTableConnectionQueryBuiltQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivitiesTableConnectionQueryBuiltQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivitiesTableConnectionQueryBuiltQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useActivitiesTableConnectionQueryBuiltQuery(baseOptions?: Apollo.QueryHookOptions<ActivitiesTableConnectionQueryBuiltQuery, ActivitiesTableConnectionQueryBuiltQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivitiesTableConnectionQueryBuiltQuery, ActivitiesTableConnectionQueryBuiltQueryVariables>(ActivitiesTableConnectionQueryBuiltDocument, options);
      }
export function useActivitiesTableConnectionQueryBuiltLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivitiesTableConnectionQueryBuiltQuery, ActivitiesTableConnectionQueryBuiltQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivitiesTableConnectionQueryBuiltQuery, ActivitiesTableConnectionQueryBuiltQueryVariables>(ActivitiesTableConnectionQueryBuiltDocument, options);
        }
export type ActivitiesTableConnectionQueryBuiltQueryHookResult = ReturnType<typeof useActivitiesTableConnectionQueryBuiltQuery>;
export type ActivitiesTableConnectionQueryBuiltLazyQueryHookResult = ReturnType<typeof useActivitiesTableConnectionQueryBuiltLazyQuery>;
export type ActivitiesTableConnectionQueryBuiltQueryResult = Apollo.QueryResult<ActivitiesTableConnectionQueryBuiltQuery, ActivitiesTableConnectionQueryBuiltQueryVariables>;
export const ActivityNestedHCPTableQueryDocument = gql`
    query ActivityNestedHCPTableQuery($activityId: ID!) {
  persons(criteria: {activityId: $activityId}) {
    hash
    nodes {
      ...PersonTableBuiltFragment
    }
  }
}
    ${PersonTableBuiltFragmentFragmentDoc}`;

/**
 * __useActivityNestedHCPTableQueryQuery__
 *
 * To run a query within a React component, call `useActivityNestedHCPTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityNestedHCPTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityNestedHCPTableQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityNestedHCPTableQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityNestedHCPTableQueryQuery, ActivityNestedHCPTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityNestedHCPTableQueryQuery, ActivityNestedHCPTableQueryQueryVariables>(ActivityNestedHCPTableQueryDocument, options);
      }
export function useActivityNestedHCPTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityNestedHCPTableQueryQuery, ActivityNestedHCPTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityNestedHCPTableQueryQuery, ActivityNestedHCPTableQueryQueryVariables>(ActivityNestedHCPTableQueryDocument, options);
        }
export type ActivityNestedHCPTableQueryQueryHookResult = ReturnType<typeof useActivityNestedHCPTableQueryQuery>;
export type ActivityNestedHCPTableQueryLazyQueryHookResult = ReturnType<typeof useActivityNestedHCPTableQueryLazyQuery>;
export type ActivityNestedHCPTableQueryQueryResult = Apollo.QueryResult<ActivityNestedHCPTableQueryQuery, ActivityNestedHCPTableQueryQueryVariables>;
export const ActivityCreatedByQueryDocument = gql`
    query ActivityCreatedByQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    createdBy {
      id
      fullname
      email
      md5Email
    }
  }
}
    `;

/**
 * __useActivityCreatedByQueryQuery__
 *
 * To run a query within a React component, call `useActivityCreatedByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityCreatedByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityCreatedByQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityCreatedByQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityCreatedByQueryQuery, ActivityCreatedByQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityCreatedByQueryQuery, ActivityCreatedByQueryQueryVariables>(ActivityCreatedByQueryDocument, options);
      }
export function useActivityCreatedByQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityCreatedByQueryQuery, ActivityCreatedByQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityCreatedByQueryQuery, ActivityCreatedByQueryQueryVariables>(ActivityCreatedByQueryDocument, options);
        }
export type ActivityCreatedByQueryQueryHookResult = ReturnType<typeof useActivityCreatedByQueryQuery>;
export type ActivityCreatedByQueryLazyQueryHookResult = ReturnType<typeof useActivityCreatedByQueryLazyQuery>;
export type ActivityCreatedByQueryQueryResult = Apollo.QueryResult<ActivityCreatedByQueryQuery, ActivityCreatedByQueryQueryVariables>;
export const CompleteActivityMutationDocument = gql`
    mutation CompleteActivityMutation($activityId: Int!) {
  completeActivity(activityId: $activityId) {
    id
    statusCode
    status {
      code
      headingKey
    }
  }
}
    `;
export type CompleteActivityMutationMutationFn = Apollo.MutationFunction<CompleteActivityMutationMutation, CompleteActivityMutationMutationVariables>;

/**
 * __useCompleteActivityMutationMutation__
 *
 * To run a mutation, you first call `useCompleteActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeActivityMutationMutation, { data, loading, error }] = useCompleteActivityMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useCompleteActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteActivityMutationMutation, CompleteActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteActivityMutationMutation, CompleteActivityMutationMutationVariables>(CompleteActivityMutationDocument, options);
      }
export type CompleteActivityMutationMutationHookResult = ReturnType<typeof useCompleteActivityMutationMutation>;
export type CompleteActivityMutationMutationResult = Apollo.MutationResult<CompleteActivityMutationMutation>;
export type CompleteActivityMutationMutationOptions = Apollo.BaseMutationOptions<CompleteActivityMutationMutation, CompleteActivityMutationMutationVariables>;
export const DeleteActivityMutationDocument = gql`
    mutation DeleteActivityMutation($activityId: Int!) {
  deleteActivity(activityId: $activityId) {
    id
    status {
      code
      headingKey
    }
  }
}
    `;
export type DeleteActivityMutationMutationFn = Apollo.MutationFunction<DeleteActivityMutationMutation, DeleteActivityMutationMutationVariables>;

/**
 * __useDeleteActivityMutationMutation__
 *
 * To run a mutation, you first call `useDeleteActivityMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivityMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivityMutationMutation, { data, loading, error }] = useDeleteActivityMutationMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteActivityMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActivityMutationMutation, DeleteActivityMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActivityMutationMutation, DeleteActivityMutationMutationVariables>(DeleteActivityMutationDocument, options);
      }
export type DeleteActivityMutationMutationHookResult = ReturnType<typeof useDeleteActivityMutationMutation>;
export type DeleteActivityMutationMutationResult = Apollo.MutationResult<DeleteActivityMutationMutation>;
export type DeleteActivityMutationMutationOptions = Apollo.BaseMutationOptions<DeleteActivityMutationMutation, DeleteActivityMutationMutationVariables>;
export const ActivityDetailsSectionRightQueryDocument = gql`
    query ActivityDetailsSectionRightQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    status {
      code
      codeEnum
    }
  }
}
    `;

/**
 * __useActivityDetailsSectionRightQueryQuery__
 *
 * To run a query within a React component, call `useActivityDetailsSectionRightQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDetailsSectionRightQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDetailsSectionRightQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityDetailsSectionRightQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityDetailsSectionRightQueryQuery, ActivityDetailsSectionRightQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityDetailsSectionRightQueryQuery, ActivityDetailsSectionRightQueryQueryVariables>(ActivityDetailsSectionRightQueryDocument, options);
      }
export function useActivityDetailsSectionRightQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityDetailsSectionRightQueryQuery, ActivityDetailsSectionRightQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityDetailsSectionRightQueryQuery, ActivityDetailsSectionRightQueryQueryVariables>(ActivityDetailsSectionRightQueryDocument, options);
        }
export type ActivityDetailsSectionRightQueryQueryHookResult = ReturnType<typeof useActivityDetailsSectionRightQueryQuery>;
export type ActivityDetailsSectionRightQueryLazyQueryHookResult = ReturnType<typeof useActivityDetailsSectionRightQueryLazyQuery>;
export type ActivityDetailsSectionRightQueryQueryResult = Apollo.QueryResult<ActivityDetailsSectionRightQueryQuery, ActivityDetailsSectionRightQueryQueryVariables>;
export const UpdateActivityStatusDocument = gql`
    mutation UpdateActivityStatus($activityId: Int!, $status: ActivityStatusEnum!) {
  updateActivity(input: {activityId: $activityId, status: $status}) {
    id
    status {
      code
    }
    statusCode
    statusLabel
  }
}
    `;
export type UpdateActivityStatusMutationFn = Apollo.MutationFunction<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>;

/**
 * __useUpdateActivityStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActivityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityStatusMutation, { data, loading, error }] = useUpdateActivityStatusMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateActivityStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>(UpdateActivityStatusDocument, options);
      }
export type UpdateActivityStatusMutationHookResult = ReturnType<typeof useUpdateActivityStatusMutation>;
export type UpdateActivityStatusMutationResult = Apollo.MutationResult<UpdateActivityStatusMutation>;
export type UpdateActivityStatusMutationOptions = Apollo.BaseMutationOptions<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>;
export const ActivityStatusesQueryDocument = gql`
    query ActivityStatusesQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    status {
      code
      codeEnum
      headingKey
    }
  }
  activityStatuses {
    hash
    nodes {
      code
      codeEnum
      headingKey
    }
  }
}
    `;

/**
 * __useActivityStatusesQueryQuery__
 *
 * To run a query within a React component, call `useActivityStatusesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityStatusesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityStatusesQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityStatusesQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityStatusesQueryQuery, ActivityStatusesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityStatusesQueryQuery, ActivityStatusesQueryQueryVariables>(ActivityStatusesQueryDocument, options);
      }
export function useActivityStatusesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityStatusesQueryQuery, ActivityStatusesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityStatusesQueryQuery, ActivityStatusesQueryQueryVariables>(ActivityStatusesQueryDocument, options);
        }
export type ActivityStatusesQueryQueryHookResult = ReturnType<typeof useActivityStatusesQueryQuery>;
export type ActivityStatusesQueryLazyQueryHookResult = ReturnType<typeof useActivityStatusesQueryLazyQuery>;
export type ActivityStatusesQueryQueryResult = Apollo.QueryResult<ActivityStatusesQueryQuery, ActivityStatusesQueryQueryVariables>;
export const ActivityTimeStampsQueryDocument = gql`
    query ActivityTimeStampsQuery($activityId: Int!) {
  activity(id: $activityId) {
    id
    ct
    ut
  }
}
    `;

/**
 * __useActivityTimeStampsQueryQuery__
 *
 * To run a query within a React component, call `useActivityTimeStampsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTimeStampsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTimeStampsQueryQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useActivityTimeStampsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityTimeStampsQueryQuery, ActivityTimeStampsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityTimeStampsQueryQuery, ActivityTimeStampsQueryQueryVariables>(ActivityTimeStampsQueryDocument, options);
      }
export function useActivityTimeStampsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityTimeStampsQueryQuery, ActivityTimeStampsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityTimeStampsQueryQuery, ActivityTimeStampsQueryQueryVariables>(ActivityTimeStampsQueryDocument, options);
        }
export type ActivityTimeStampsQueryQueryHookResult = ReturnType<typeof useActivityTimeStampsQueryQuery>;
export type ActivityTimeStampsQueryLazyQueryHookResult = ReturnType<typeof useActivityTimeStampsQueryLazyQuery>;
export type ActivityTimeStampsQueryQueryResult = Apollo.QueryResult<ActivityTimeStampsQueryQuery, ActivityTimeStampsQueryQueryVariables>;
export const UpdateActivityTypeDocument = gql`
    mutation UpdateActivityType($activityId: Int!, $activityTypeCode: String!) {
  updateActivity(
    input: {activityId: $activityId, activityTypeCode: $activityTypeCode}
  ) {
    id
    typeCode
    type {
      code
    }
    heading
  }
}
    `;
export type UpdateActivityTypeMutationFn = Apollo.MutationFunction<UpdateActivityTypeMutation, UpdateActivityTypeMutationVariables>;

/**
 * __useUpdateActivityTypeMutation__
 *
 * To run a mutation, you first call `useUpdateActivityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityTypeMutation, { data, loading, error }] = useUpdateActivityTypeMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityTypeCode: // value for 'activityTypeCode'
 *   },
 * });
 */
export function useUpdateActivityTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityTypeMutation, UpdateActivityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityTypeMutation, UpdateActivityTypeMutationVariables>(UpdateActivityTypeDocument, options);
      }
export type UpdateActivityTypeMutationHookResult = ReturnType<typeof useUpdateActivityTypeMutation>;
export type UpdateActivityTypeMutationResult = Apollo.MutationResult<UpdateActivityTypeMutation>;
export type UpdateActivityTypeMutationOptions = Apollo.BaseMutationOptions<UpdateActivityTypeMutation, UpdateActivityTypeMutationVariables>;
export const AdminMenuItemsQueryDocument = gql`
    query AdminMenuItemsQuery {
  viewer {
    id
    adminMenuItems {
      hash
      nodes {
        code
        headingKey
        url
      }
    }
  }
}
    `;

/**
 * __useAdminMenuItemsQueryQuery__
 *
 * To run a query within a React component, call `useAdminMenuItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMenuItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMenuItemsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMenuItemsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AdminMenuItemsQueryQuery, AdminMenuItemsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMenuItemsQueryQuery, AdminMenuItemsQueryQueryVariables>(AdminMenuItemsQueryDocument, options);
      }
export function useAdminMenuItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMenuItemsQueryQuery, AdminMenuItemsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMenuItemsQueryQuery, AdminMenuItemsQueryQueryVariables>(AdminMenuItemsQueryDocument, options);
        }
export type AdminMenuItemsQueryQueryHookResult = ReturnType<typeof useAdminMenuItemsQueryQuery>;
export type AdminMenuItemsQueryLazyQueryHookResult = ReturnType<typeof useAdminMenuItemsQueryLazyQuery>;
export type AdminMenuItemsQueryQueryResult = Apollo.QueryResult<AdminMenuItemsQueryQuery, AdminMenuItemsQueryQueryVariables>;
export const GridItemTypesQueryDocument = gql`
    query GridItemTypesQuery {
  entityGridItemTypes {
    hash
    nodes {
      code
      enum
      headingKey
      descriptionKey
      minHeight
      minWidth
    }
  }
}
    `;

/**
 * __useGridItemTypesQueryQuery__
 *
 * To run a query within a React component, call `useGridItemTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGridItemTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGridItemTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGridItemTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<GridItemTypesQueryQuery, GridItemTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GridItemTypesQueryQuery, GridItemTypesQueryQueryVariables>(GridItemTypesQueryDocument, options);
      }
export function useGridItemTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GridItemTypesQueryQuery, GridItemTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GridItemTypesQueryQuery, GridItemTypesQueryQueryVariables>(GridItemTypesQueryDocument, options);
        }
export type GridItemTypesQueryQueryHookResult = ReturnType<typeof useGridItemTypesQueryQuery>;
export type GridItemTypesQueryLazyQueryHookResult = ReturnType<typeof useGridItemTypesQueryLazyQuery>;
export type GridItemTypesQueryQueryResult = Apollo.QueryResult<GridItemTypesQueryQuery, GridItemTypesQueryQueryVariables>;
export const UpdateGridConfigurationHeadingDocument = gql`
    mutation UpdateGridConfigurationHeading($id: Int!, $heading: String!, $description: String) {
  updateEntityGridItemConfiguration(
    id: $id
    heading: $heading
    description: $description
  ) {
    id
    heading
    description
  }
}
    `;
export type UpdateGridConfigurationHeadingMutationFn = Apollo.MutationFunction<UpdateGridConfigurationHeadingMutation, UpdateGridConfigurationHeadingMutationVariables>;

/**
 * __useUpdateGridConfigurationHeadingMutation__
 *
 * To run a mutation, you first call `useUpdateGridConfigurationHeadingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridConfigurationHeadingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridConfigurationHeadingMutation, { data, loading, error }] = useUpdateGridConfigurationHeadingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      heading: // value for 'heading'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateGridConfigurationHeadingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridConfigurationHeadingMutation, UpdateGridConfigurationHeadingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridConfigurationHeadingMutation, UpdateGridConfigurationHeadingMutationVariables>(UpdateGridConfigurationHeadingDocument, options);
      }
export type UpdateGridConfigurationHeadingMutationHookResult = ReturnType<typeof useUpdateGridConfigurationHeadingMutation>;
export type UpdateGridConfigurationHeadingMutationResult = Apollo.MutationResult<UpdateGridConfigurationHeadingMutation>;
export type UpdateGridConfigurationHeadingMutationOptions = Apollo.BaseMutationOptions<UpdateGridConfigurationHeadingMutation, UpdateGridConfigurationHeadingMutationVariables>;
export const SelectedGridItemQueryDocument = gql`
    query SelectedGridItemQuery($gridItemId: Int!) {
  entityGridItemConfiguration(id: $gridItemId) {
    id
    heading
    description
    type {
      code
      enum
      headingKey
      descriptionKey
    }
    fields {
      hash
      totalCount
      nodes {
        id
      }
    }
  }
}
    `;

/**
 * __useSelectedGridItemQueryQuery__
 *
 * To run a query within a React component, call `useSelectedGridItemQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedGridItemQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedGridItemQueryQuery({
 *   variables: {
 *      gridItemId: // value for 'gridItemId'
 *   },
 * });
 */
export function useSelectedGridItemQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectedGridItemQueryQuery, SelectedGridItemQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedGridItemQueryQuery, SelectedGridItemQueryQueryVariables>(SelectedGridItemQueryDocument, options);
      }
export function useSelectedGridItemQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedGridItemQueryQuery, SelectedGridItemQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedGridItemQueryQuery, SelectedGridItemQueryQueryVariables>(SelectedGridItemQueryDocument, options);
        }
export type SelectedGridItemQueryQueryHookResult = ReturnType<typeof useSelectedGridItemQueryQuery>;
export type SelectedGridItemQueryLazyQueryHookResult = ReturnType<typeof useSelectedGridItemQueryLazyQuery>;
export type SelectedGridItemQueryQueryResult = Apollo.QueryResult<SelectedGridItemQueryQuery, SelectedGridItemQueryQueryVariables>;
export const LocalizationKeysSearchDocument = gql`
    query LocalizationKeysSearch($search: String) {
  localizations(criteria: {languageCode: "en", search: $search}) {
    nodes {
      id {
        code
        languageCode
      }
      resource
    }
  }
}
    `;

/**
 * __useLocalizationKeysSearchQuery__
 *
 * To run a query within a React component, call `useLocalizationKeysSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationKeysSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationKeysSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLocalizationKeysSearchQuery(baseOptions?: Apollo.QueryHookOptions<LocalizationKeysSearchQuery, LocalizationKeysSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalizationKeysSearchQuery, LocalizationKeysSearchQueryVariables>(LocalizationKeysSearchDocument, options);
      }
export function useLocalizationKeysSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalizationKeysSearchQuery, LocalizationKeysSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalizationKeysSearchQuery, LocalizationKeysSearchQueryVariables>(LocalizationKeysSearchDocument, options);
        }
export type LocalizationKeysSearchQueryHookResult = ReturnType<typeof useLocalizationKeysSearchQuery>;
export type LocalizationKeysSearchLazyQueryHookResult = ReturnType<typeof useLocalizationKeysSearchLazyQuery>;
export type LocalizationKeysSearchQueryResult = Apollo.QueryResult<LocalizationKeysSearchQuery, LocalizationKeysSearchQueryVariables>;
export const ConfigureGridCardsMutationDocument = gql`
    mutation ConfigureGridCardsMutation($entityGridItemConfigurationId: Int!, $entityGridItemCardFieldType: EntityGridItemCardFieldTypeEnum!, $fields: [EntityGridItemCardFieldInput!]!) {
  updateEntityGridItemCardFields(
    entityGridItemConfigurationId: $entityGridItemConfigurationId
    entityGridItemCardFieldType: $entityGridItemCardFieldType
    fields: $fields
  ) {
    hash
    nodes {
      id
    }
  }
}
    `;
export type ConfigureGridCardsMutationMutationFn = Apollo.MutationFunction<ConfigureGridCardsMutationMutation, ConfigureGridCardsMutationMutationVariables>;

/**
 * __useConfigureGridCardsMutationMutation__
 *
 * To run a mutation, you first call `useConfigureGridCardsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureGridCardsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureGridCardsMutationMutation, { data, loading, error }] = useConfigureGridCardsMutationMutation({
 *   variables: {
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *      entityGridItemCardFieldType: // value for 'entityGridItemCardFieldType'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useConfigureGridCardsMutationMutation(baseOptions?: Apollo.MutationHookOptions<ConfigureGridCardsMutationMutation, ConfigureGridCardsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfigureGridCardsMutationMutation, ConfigureGridCardsMutationMutationVariables>(ConfigureGridCardsMutationDocument, options);
      }
export type ConfigureGridCardsMutationMutationHookResult = ReturnType<typeof useConfigureGridCardsMutationMutation>;
export type ConfigureGridCardsMutationMutationResult = Apollo.MutationResult<ConfigureGridCardsMutationMutation>;
export type ConfigureGridCardsMutationMutationOptions = Apollo.BaseMutationOptions<ConfigureGridCardsMutationMutation, ConfigureGridCardsMutationMutationVariables>;
export const ConfigureGridCardsQueryDocument = gql`
    query ConfigureGridCardsQuery($itemConfigurationId: ID!, $main: EntityGridItemCardFieldTypeEnum!, $meta: EntityGridItemCardFieldTypeEnum!) {
  main: entityGridItemCardFields(
    criteria: {entityGridItemConfigurationId: $itemConfigurationId, entityGridItemCardFieldType: $main}
  ) {
    hash
    nodes {
      ...FieldFragment
    }
  }
  meta: entityGridItemCardFields(
    criteria: {entityGridItemConfigurationId: $itemConfigurationId, entityGridItemCardFieldType: $meta}
  ) {
    hash
    nodes {
      ...FieldFragment
    }
  }
}
    ${FieldFragmentFragmentDoc}`;

/**
 * __useConfigureGridCardsQueryQuery__
 *
 * To run a query within a React component, call `useConfigureGridCardsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureGridCardsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureGridCardsQueryQuery({
 *   variables: {
 *      itemConfigurationId: // value for 'itemConfigurationId'
 *      main: // value for 'main'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useConfigureGridCardsQueryQuery(baseOptions: Apollo.QueryHookOptions<ConfigureGridCardsQueryQuery, ConfigureGridCardsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigureGridCardsQueryQuery, ConfigureGridCardsQueryQueryVariables>(ConfigureGridCardsQueryDocument, options);
      }
export function useConfigureGridCardsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigureGridCardsQueryQuery, ConfigureGridCardsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigureGridCardsQueryQuery, ConfigureGridCardsQueryQueryVariables>(ConfigureGridCardsQueryDocument, options);
        }
export type ConfigureGridCardsQueryQueryHookResult = ReturnType<typeof useConfigureGridCardsQueryQuery>;
export type ConfigureGridCardsQueryLazyQueryHookResult = ReturnType<typeof useConfigureGridCardsQueryLazyQuery>;
export type ConfigureGridCardsQueryQueryResult = Apollo.QueryResult<ConfigureGridCardsQueryQuery, ConfigureGridCardsQueryQueryVariables>;
export const AddFieldToFieldsGridMutationDocument = gql`
    mutation AddFieldToFieldsGridMutation($fieldType: EntityGridItemFieldTypeEnum!, $groupId: Int!) {
  assignFieldToGroup(fieldType: $fieldType, groupId: $groupId) {
    id
    itemConfiguration {
      id
      ...SelectedGridItemConfigurationFragment
    }
  }
}
    ${SelectedGridItemConfigurationFragmentFragmentDoc}`;
export type AddFieldToFieldsGridMutationMutationFn = Apollo.MutationFunction<AddFieldToFieldsGridMutationMutation, AddFieldToFieldsGridMutationMutationVariables>;

/**
 * __useAddFieldToFieldsGridMutationMutation__
 *
 * To run a mutation, you first call `useAddFieldToFieldsGridMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFieldToFieldsGridMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFieldToFieldsGridMutationMutation, { data, loading, error }] = useAddFieldToFieldsGridMutationMutation({
 *   variables: {
 *      fieldType: // value for 'fieldType'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useAddFieldToFieldsGridMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddFieldToFieldsGridMutationMutation, AddFieldToFieldsGridMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFieldToFieldsGridMutationMutation, AddFieldToFieldsGridMutationMutationVariables>(AddFieldToFieldsGridMutationDocument, options);
      }
export type AddFieldToFieldsGridMutationMutationHookResult = ReturnType<typeof useAddFieldToFieldsGridMutationMutation>;
export type AddFieldToFieldsGridMutationMutationResult = Apollo.MutationResult<AddFieldToFieldsGridMutationMutation>;
export type AddFieldToFieldsGridMutationMutationOptions = Apollo.BaseMutationOptions<AddFieldToFieldsGridMutationMutation, AddFieldToFieldsGridMutationMutationVariables>;
export const LinkCustomFieldMutationDocument = gql`
    mutation LinkCustomFieldMutation($customFieldCode: String!, $fieldId: Int!) {
  linkEntityGridFieldToCustomField(
    customFieldCode: $customFieldCode
    fieldId: $fieldId
  ) {
    id
    fieldConfig {
      id
      itemConfiguration {
        id
        ...SelectedGridItemConfigurationFragment
      }
    }
  }
}
    ${SelectedGridItemConfigurationFragmentFragmentDoc}`;
export type LinkCustomFieldMutationMutationFn = Apollo.MutationFunction<LinkCustomFieldMutationMutation, LinkCustomFieldMutationMutationVariables>;

/**
 * __useLinkCustomFieldMutationMutation__
 *
 * To run a mutation, you first call `useLinkCustomFieldMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCustomFieldMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCustomFieldMutationMutation, { data, loading, error }] = useLinkCustomFieldMutationMutation({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *      fieldId: // value for 'fieldId'
 *   },
 * });
 */
export function useLinkCustomFieldMutationMutation(baseOptions?: Apollo.MutationHookOptions<LinkCustomFieldMutationMutation, LinkCustomFieldMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkCustomFieldMutationMutation, LinkCustomFieldMutationMutationVariables>(LinkCustomFieldMutationDocument, options);
      }
export type LinkCustomFieldMutationMutationHookResult = ReturnType<typeof useLinkCustomFieldMutationMutation>;
export type LinkCustomFieldMutationMutationResult = Apollo.MutationResult<LinkCustomFieldMutationMutation>;
export type LinkCustomFieldMutationMutationOptions = Apollo.BaseMutationOptions<LinkCustomFieldMutationMutation, LinkCustomFieldMutationMutationVariables>;
export const ListAllCustomFieldTypesQueryDocument = gql`
    query ListAllCustomFieldTypesQuery($tabCode: String!, $entityType: EntityTypeEnum!) {
  entityGridItemFieldTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      enum
      heading
      description
      isInTab(tabCode: $tabCode)
    }
  }
  customFields(
    criteria: {entityType: $entityType, excludeAlreadyAddedOnEntityTabCode: $tabCode}
  ) {
    hash
    nodes {
      code
      heading
      description
      fieldType {
        code
        enum
      }
    }
  }
}
    `;

/**
 * __useListAllCustomFieldTypesQueryQuery__
 *
 * To run a query within a React component, call `useListAllCustomFieldTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllCustomFieldTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllCustomFieldTypesQueryQuery({
 *   variables: {
 *      tabCode: // value for 'tabCode'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useListAllCustomFieldTypesQueryQuery(baseOptions: Apollo.QueryHookOptions<ListAllCustomFieldTypesQueryQuery, ListAllCustomFieldTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllCustomFieldTypesQueryQuery, ListAllCustomFieldTypesQueryQueryVariables>(ListAllCustomFieldTypesQueryDocument, options);
      }
export function useListAllCustomFieldTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllCustomFieldTypesQueryQuery, ListAllCustomFieldTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllCustomFieldTypesQueryQuery, ListAllCustomFieldTypesQueryQueryVariables>(ListAllCustomFieldTypesQueryDocument, options);
        }
export type ListAllCustomFieldTypesQueryQueryHookResult = ReturnType<typeof useListAllCustomFieldTypesQueryQuery>;
export type ListAllCustomFieldTypesQueryLazyQueryHookResult = ReturnType<typeof useListAllCustomFieldTypesQueryLazyQuery>;
export type ListAllCustomFieldTypesQueryQueryResult = Apollo.QueryResult<ListAllCustomFieldTypesQueryQuery, ListAllCustomFieldTypesQueryQueryVariables>;
export const UpdateGridItemFieldSortingDocument = gql`
    mutation UpdateGridItemFieldSorting($gridItemConfigurationId: Int!, $fieldIds: [Int!]!) {
  updateEntityGridItemFieldSorting(
    gridItemConfigurationId: $gridItemConfigurationId
    fieldIds: $fieldIds
  ) {
    id
    sort
  }
}
    `;
export type UpdateGridItemFieldSortingMutationFn = Apollo.MutationFunction<UpdateGridItemFieldSortingMutation, UpdateGridItemFieldSortingMutationVariables>;

/**
 * __useUpdateGridItemFieldSortingMutation__
 *
 * To run a mutation, you first call `useUpdateGridItemFieldSortingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridItemFieldSortingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridItemFieldSortingMutation, { data, loading, error }] = useUpdateGridItemFieldSortingMutation({
 *   variables: {
 *      gridItemConfigurationId: // value for 'gridItemConfigurationId'
 *      fieldIds: // value for 'fieldIds'
 *   },
 * });
 */
export function useUpdateGridItemFieldSortingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridItemFieldSortingMutation, UpdateGridItemFieldSortingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridItemFieldSortingMutation, UpdateGridItemFieldSortingMutationVariables>(UpdateGridItemFieldSortingDocument, options);
      }
export type UpdateGridItemFieldSortingMutationHookResult = ReturnType<typeof useUpdateGridItemFieldSortingMutation>;
export type UpdateGridItemFieldSortingMutationResult = Apollo.MutationResult<UpdateGridItemFieldSortingMutation>;
export type UpdateGridItemFieldSortingMutationOptions = Apollo.BaseMutationOptions<UpdateGridItemFieldSortingMutation, UpdateGridItemFieldSortingMutationVariables>;
export const RemoveEntityGridItemDocument = gql`
    mutation RemoveEntityGridItem($id: Int!) {
  removeEntityGridItem(id: $id)
}
    `;
export type RemoveEntityGridItemMutationFn = Apollo.MutationFunction<RemoveEntityGridItemMutation, RemoveEntityGridItemMutationVariables>;

/**
 * __useRemoveEntityGridItemMutation__
 *
 * To run a mutation, you first call `useRemoveEntityGridItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEntityGridItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEntityGridItemMutation, { data, loading, error }] = useRemoveEntityGridItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEntityGridItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEntityGridItemMutation, RemoveEntityGridItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEntityGridItemMutation, RemoveEntityGridItemMutationVariables>(RemoveEntityGridItemDocument, options);
      }
export type RemoveEntityGridItemMutationHookResult = ReturnType<typeof useRemoveEntityGridItemMutation>;
export type RemoveEntityGridItemMutationResult = Apollo.MutationResult<RemoveEntityGridItemMutation>;
export type RemoveEntityGridItemMutationOptions = Apollo.BaseMutationOptions<RemoveEntityGridItemMutation, RemoveEntityGridItemMutationVariables>;
export const SelectedFieldsGridItemQueryDocument = gql`
    query SelectedFieldsGridItemQuery($gridItemId: Int!) {
  entityGridItemConfiguration(id: $gridItemId) {
    id
    ...SelectedGridItemConfigurationFragment
  }
}
    ${SelectedGridItemConfigurationFragmentFragmentDoc}`;

/**
 * __useSelectedFieldsGridItemQueryQuery__
 *
 * To run a query within a React component, call `useSelectedFieldsGridItemQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedFieldsGridItemQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedFieldsGridItemQueryQuery({
 *   variables: {
 *      gridItemId: // value for 'gridItemId'
 *   },
 * });
 */
export function useSelectedFieldsGridItemQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectedFieldsGridItemQueryQuery, SelectedFieldsGridItemQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedFieldsGridItemQueryQuery, SelectedFieldsGridItemQueryQueryVariables>(SelectedFieldsGridItemQueryDocument, options);
      }
export function useSelectedFieldsGridItemQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedFieldsGridItemQueryQuery, SelectedFieldsGridItemQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedFieldsGridItemQueryQuery, SelectedFieldsGridItemQueryQueryVariables>(SelectedFieldsGridItemQueryDocument, options);
        }
export type SelectedFieldsGridItemQueryQueryHookResult = ReturnType<typeof useSelectedFieldsGridItemQueryQuery>;
export type SelectedFieldsGridItemQueryLazyQueryHookResult = ReturnType<typeof useSelectedFieldsGridItemQueryLazyQuery>;
export type SelectedFieldsGridItemQueryQueryResult = Apollo.QueryResult<SelectedFieldsGridItemQueryQuery, SelectedFieldsGridItemQueryQueryVariables>;
export const UpdateGridRightRelationsSortingMutationDocument = gql`
    mutation UpdateGridRightRelationsSortingMutation($itemConfigurationId: Int!, $fieldKeys: [String!]!) {
  updateEntityGridItemRelationFieldUpdateSorting(
    entityGridItemConfigurationId: $itemConfigurationId
    fieldKeys: $fieldKeys
  ) {
    id
    sort
    relationTabKey
    isActive
  }
}
    `;
export type UpdateGridRightRelationsSortingMutationMutationFn = Apollo.MutationFunction<UpdateGridRightRelationsSortingMutationMutation, UpdateGridRightRelationsSortingMutationMutationVariables>;

/**
 * __useUpdateGridRightRelationsSortingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateGridRightRelationsSortingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridRightRelationsSortingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridRightRelationsSortingMutationMutation, { data, loading, error }] = useUpdateGridRightRelationsSortingMutationMutation({
 *   variables: {
 *      itemConfigurationId: // value for 'itemConfigurationId'
 *      fieldKeys: // value for 'fieldKeys'
 *   },
 * });
 */
export function useUpdateGridRightRelationsSortingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridRightRelationsSortingMutationMutation, UpdateGridRightRelationsSortingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridRightRelationsSortingMutationMutation, UpdateGridRightRelationsSortingMutationMutationVariables>(UpdateGridRightRelationsSortingMutationDocument, options);
      }
export type UpdateGridRightRelationsSortingMutationMutationHookResult = ReturnType<typeof useUpdateGridRightRelationsSortingMutationMutation>;
export type UpdateGridRightRelationsSortingMutationMutationResult = Apollo.MutationResult<UpdateGridRightRelationsSortingMutationMutation>;
export type UpdateGridRightRelationsSortingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateGridRightRelationsSortingMutationMutation, UpdateGridRightRelationsSortingMutationMutationVariables>;
export const UpdateGridRightRelationStatusMutationDocument = gql`
    mutation UpdateGridRightRelationStatusMutation($itemConfigurationId: Int!, $fieldKey: String!, $enabled: Boolean!) {
  updateEntityGridItemRelationFieldSwitchStatus(
    entityGridItemConfigurationId: $itemConfigurationId
    fieldKey: $fieldKey
    enabled: $enabled
  ) {
    id
    sort
    relationTabKey
    isActive
  }
}
    `;
export type UpdateGridRightRelationStatusMutationMutationFn = Apollo.MutationFunction<UpdateGridRightRelationStatusMutationMutation, UpdateGridRightRelationStatusMutationMutationVariables>;

/**
 * __useUpdateGridRightRelationStatusMutationMutation__
 *
 * To run a mutation, you first call `useUpdateGridRightRelationStatusMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridRightRelationStatusMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridRightRelationStatusMutationMutation, { data, loading, error }] = useUpdateGridRightRelationStatusMutationMutation({
 *   variables: {
 *      itemConfigurationId: // value for 'itemConfigurationId'
 *      fieldKey: // value for 'fieldKey'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateGridRightRelationStatusMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridRightRelationStatusMutationMutation, UpdateGridRightRelationStatusMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridRightRelationStatusMutationMutation, UpdateGridRightRelationStatusMutationMutationVariables>(UpdateGridRightRelationStatusMutationDocument, options);
      }
export type UpdateGridRightRelationStatusMutationMutationHookResult = ReturnType<typeof useUpdateGridRightRelationStatusMutationMutation>;
export type UpdateGridRightRelationStatusMutationMutationResult = Apollo.MutationResult<UpdateGridRightRelationStatusMutationMutation>;
export type UpdateGridRightRelationStatusMutationMutationOptions = Apollo.BaseMutationOptions<UpdateGridRightRelationStatusMutationMutation, UpdateGridRightRelationStatusMutationMutationVariables>;
export const AdminGridRightRelationsConfiguratorQueryDocument = gql`
    query AdminGridRightRelationsConfiguratorQuery($itemConfigurationId: ID!) {
  entityGridItemRelationFields(
    criteria: {entityGridItemConfigurationId: $itemConfigurationId, isActive: null}
  ) {
    hash
    nodes {
      id
      sort
      relationTabKey
      isActive
    }
  }
}
    `;

/**
 * __useAdminGridRightRelationsConfiguratorQueryQuery__
 *
 * To run a query within a React component, call `useAdminGridRightRelationsConfiguratorQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGridRightRelationsConfiguratorQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGridRightRelationsConfiguratorQueryQuery({
 *   variables: {
 *      itemConfigurationId: // value for 'itemConfigurationId'
 *   },
 * });
 */
export function useAdminGridRightRelationsConfiguratorQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminGridRightRelationsConfiguratorQueryQuery, AdminGridRightRelationsConfiguratorQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGridRightRelationsConfiguratorQueryQuery, AdminGridRightRelationsConfiguratorQueryQueryVariables>(AdminGridRightRelationsConfiguratorQueryDocument, options);
      }
export function useAdminGridRightRelationsConfiguratorQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGridRightRelationsConfiguratorQueryQuery, AdminGridRightRelationsConfiguratorQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGridRightRelationsConfiguratorQueryQuery, AdminGridRightRelationsConfiguratorQueryQueryVariables>(AdminGridRightRelationsConfiguratorQueryDocument, options);
        }
export type AdminGridRightRelationsConfiguratorQueryQueryHookResult = ReturnType<typeof useAdminGridRightRelationsConfiguratorQueryQuery>;
export type AdminGridRightRelationsConfiguratorQueryLazyQueryHookResult = ReturnType<typeof useAdminGridRightRelationsConfiguratorQueryLazyQuery>;
export type AdminGridRightRelationsConfiguratorQueryQueryResult = Apollo.QueryResult<AdminGridRightRelationsConfiguratorQueryQuery, AdminGridRightRelationsConfiguratorQueryQueryVariables>;
export const CreateEntityGridItemConfigurationDocument = gql`
    mutation CreateEntityGridItemConfiguration($entityTabCode: String!, $itemType: EntityGridItemTypeEnum!, $heading: String, $description: String) {
  createEntityGridItemConfiguration(
    entityTabCode: $entityTabCode
    itemType: $itemType
    heading: $heading
    description: $description
  ) {
    id
  }
}
    `;
export type CreateEntityGridItemConfigurationMutationFn = Apollo.MutationFunction<CreateEntityGridItemConfigurationMutation, CreateEntityGridItemConfigurationMutationVariables>;

/**
 * __useCreateEntityGridItemConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateEntityGridItemConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityGridItemConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityGridItemConfigurationMutation, { data, loading, error }] = useCreateEntityGridItemConfigurationMutation({
 *   variables: {
 *      entityTabCode: // value for 'entityTabCode'
 *      itemType: // value for 'itemType'
 *      heading: // value for 'heading'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateEntityGridItemConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityGridItemConfigurationMutation, CreateEntityGridItemConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityGridItemConfigurationMutation, CreateEntityGridItemConfigurationMutationVariables>(CreateEntityGridItemConfigurationDocument, options);
      }
export type CreateEntityGridItemConfigurationMutationHookResult = ReturnType<typeof useCreateEntityGridItemConfigurationMutation>;
export type CreateEntityGridItemConfigurationMutationResult = Apollo.MutationResult<CreateEntityGridItemConfigurationMutation>;
export type CreateEntityGridItemConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateEntityGridItemConfigurationMutation, CreateEntityGridItemConfigurationMutationVariables>;
export const DeactivateItemGroupMutationDocument = gql`
    mutation DeactivateItemGroupMutation($id: Int!) {
  deactivateEntityGridItemConfiguration(id: $id)
}
    `;
export type DeactivateItemGroupMutationMutationFn = Apollo.MutationFunction<DeactivateItemGroupMutationMutation, DeactivateItemGroupMutationMutationVariables>;

/**
 * __useDeactivateItemGroupMutationMutation__
 *
 * To run a mutation, you first call `useDeactivateItemGroupMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateItemGroupMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateItemGroupMutationMutation, { data, loading, error }] = useDeactivateItemGroupMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateItemGroupMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateItemGroupMutationMutation, DeactivateItemGroupMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateItemGroupMutationMutation, DeactivateItemGroupMutationMutationVariables>(DeactivateItemGroupMutationDocument, options);
      }
export type DeactivateItemGroupMutationMutationHookResult = ReturnType<typeof useDeactivateItemGroupMutationMutation>;
export type DeactivateItemGroupMutationMutationResult = Apollo.MutationResult<DeactivateItemGroupMutationMutation>;
export type DeactivateItemGroupMutationMutationOptions = Apollo.BaseMutationOptions<DeactivateItemGroupMutationMutation, DeactivateItemGroupMutationMutationVariables>;
export const entityGridItemConfigurationQueryDocument = gql`
    query entityGridItemConfigurationQuery($id: Int!) {
  entityGridItemConfiguration(id: $id) {
    x
    y
    width
    height
    id
    typeCode
    typeEnum
    heading
    description
    type {
      code
      headingKey
      minHeight
      minWidth
    }
  }
}
    `;

/**
 * __useentityGridItemConfigurationQueryQuery__
 *
 * To run a query within a React component, call `useentityGridItemConfigurationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useentityGridItemConfigurationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useentityGridItemConfigurationQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useentityGridItemConfigurationQueryQuery(baseOptions: Apollo.QueryHookOptions<entityGridItemConfigurationQueryQuery, entityGridItemConfigurationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<entityGridItemConfigurationQueryQuery, entityGridItemConfigurationQueryQueryVariables>(entityGridItemConfigurationQueryDocument, options);
      }
export function useentityGridItemConfigurationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<entityGridItemConfigurationQueryQuery, entityGridItemConfigurationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<entityGridItemConfigurationQueryQuery, entityGridItemConfigurationQueryQueryVariables>(entityGridItemConfigurationQueryDocument, options);
        }
export type entityGridItemConfigurationQueryQueryHookResult = ReturnType<typeof useentityGridItemConfigurationQueryQuery>;
export type entityGridItemConfigurationQueryLazyQueryHookResult = ReturnType<typeof useentityGridItemConfigurationQueryLazyQuery>;
export type entityGridItemConfigurationQueryQueryResult = Apollo.QueryResult<entityGridItemConfigurationQueryQuery, entityGridItemConfigurationQueryQueryVariables>;
export const UpdateEntityGridMutationDocument = gql`
    mutation UpdateEntityGridMutation($input: GridInput!) {
  updateEntityGrid(input: $input)
}
    `;
export type UpdateEntityGridMutationMutationFn = Apollo.MutationFunction<UpdateEntityGridMutationMutation, UpdateEntityGridMutationMutationVariables>;

/**
 * __useUpdateEntityGridMutationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityGridMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityGridMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityGridMutationMutation, { data, loading, error }] = useUpdateEntityGridMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityGridMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityGridMutationMutation, UpdateEntityGridMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityGridMutationMutation, UpdateEntityGridMutationMutationVariables>(UpdateEntityGridMutationDocument, options);
      }
export type UpdateEntityGridMutationMutationHookResult = ReturnType<typeof useUpdateEntityGridMutationMutation>;
export type UpdateEntityGridMutationMutationResult = Apollo.MutationResult<UpdateEntityGridMutationMutation>;
export type UpdateEntityGridMutationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityGridMutationMutation, UpdateEntityGridMutationMutationVariables>;
export const HCPMoreDataQueryDocument = gql`
    query HCPMoreDataQuery($entityType: EntityTypeEnum!) {
  entityTabs(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      headingKey
      sort
      gridItems {
        hash
        nodes {
          x
          y
          width
          heading
          height
          id
          type {
            code
            headingKey
            minHeight
            minWidth
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHCPMoreDataQueryQuery__
 *
 * To run a query within a React component, call `useHCPMoreDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHCPMoreDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHCPMoreDataQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useHCPMoreDataQueryQuery(baseOptions: Apollo.QueryHookOptions<HCPMoreDataQueryQuery, HCPMoreDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HCPMoreDataQueryQuery, HCPMoreDataQueryQueryVariables>(HCPMoreDataQueryDocument, options);
      }
export function useHCPMoreDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HCPMoreDataQueryQuery, HCPMoreDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HCPMoreDataQueryQuery, HCPMoreDataQueryQueryVariables>(HCPMoreDataQueryDocument, options);
        }
export type HCPMoreDataQueryQueryHookResult = ReturnType<typeof useHCPMoreDataQueryQuery>;
export type HCPMoreDataQueryLazyQueryHookResult = ReturnType<typeof useHCPMoreDataQueryLazyQuery>;
export type HCPMoreDataQueryQueryResult = Apollo.QueryResult<HCPMoreDataQueryQuery, HCPMoreDataQueryQueryVariables>;
export const AdminDetailedGridCardsPreviewQueryDocument = gql`
    query AdminDetailedGridCardsPreviewQuery($entityGridItemConfigurationId: Int!) {
  cardFieldKeys(entityGridItemConfigurationId: $entityGridItemConfigurationId) {
    entityGridItemConfigurationId
    person {
      entityGridItemConfigurationId
      entityType
      drawerFields {
        ...GridCardField
      }
      fields {
        ...GridCardField
      }
    }
    site {
      entityGridItemConfigurationId
      entityType
      drawerFields {
        ...GridCardField
      }
      fields {
        ...GridCardField
      }
    }
    link {
      entityGridItemConfigurationId
      entityType
      drawerFields {
        ...GridCardField
      }
      fields {
        ...GridCardField
      }
    }
  }
}
    ${GridCardFieldFragmentDoc}`;

/**
 * __useAdminDetailedGridCardsPreviewQueryQuery__
 *
 * To run a query within a React component, call `useAdminDetailedGridCardsPreviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDetailedGridCardsPreviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDetailedGridCardsPreviewQueryQuery({
 *   variables: {
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function useAdminDetailedGridCardsPreviewQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminDetailedGridCardsPreviewQueryQuery, AdminDetailedGridCardsPreviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDetailedGridCardsPreviewQueryQuery, AdminDetailedGridCardsPreviewQueryQueryVariables>(AdminDetailedGridCardsPreviewQueryDocument, options);
      }
export function useAdminDetailedGridCardsPreviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDetailedGridCardsPreviewQueryQuery, AdminDetailedGridCardsPreviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDetailedGridCardsPreviewQueryQuery, AdminDetailedGridCardsPreviewQueryQueryVariables>(AdminDetailedGridCardsPreviewQueryDocument, options);
        }
export type AdminDetailedGridCardsPreviewQueryQueryHookResult = ReturnType<typeof useAdminDetailedGridCardsPreviewQueryQuery>;
export type AdminDetailedGridCardsPreviewQueryLazyQueryHookResult = ReturnType<typeof useAdminDetailedGridCardsPreviewQueryLazyQuery>;
export type AdminDetailedGridCardsPreviewQueryQueryResult = Apollo.QueryResult<AdminDetailedGridCardsPreviewQueryQuery, AdminDetailedGridCardsPreviewQueryQueryVariables>;
export const AdminGridRightRelationsPreviewQueryDocument = gql`
    query AdminGridRightRelationsPreviewQuery($entityGridItemConfigurationId: ID!) {
  entityGridItemRelationFields(
    criteria: {entityGridItemConfigurationId: $entityGridItemConfigurationId, isActive: null}
  ) {
    hash
    nodes {
      id
      sort
      relationTabKey
      isActive
    }
  }
}
    `;

/**
 * __useAdminGridRightRelationsPreviewQueryQuery__
 *
 * To run a query within a React component, call `useAdminGridRightRelationsPreviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGridRightRelationsPreviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGridRightRelationsPreviewQueryQuery({
 *   variables: {
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function useAdminGridRightRelationsPreviewQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminGridRightRelationsPreviewQueryQuery, AdminGridRightRelationsPreviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGridRightRelationsPreviewQueryQuery, AdminGridRightRelationsPreviewQueryQueryVariables>(AdminGridRightRelationsPreviewQueryDocument, options);
      }
export function useAdminGridRightRelationsPreviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGridRightRelationsPreviewQueryQuery, AdminGridRightRelationsPreviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGridRightRelationsPreviewQueryQuery, AdminGridRightRelationsPreviewQueryQueryVariables>(AdminGridRightRelationsPreviewQueryDocument, options);
        }
export type AdminGridRightRelationsPreviewQueryQueryHookResult = ReturnType<typeof useAdminGridRightRelationsPreviewQueryQuery>;
export type AdminGridRightRelationsPreviewQueryLazyQueryHookResult = ReturnType<typeof useAdminGridRightRelationsPreviewQueryLazyQuery>;
export type AdminGridRightRelationsPreviewQueryQueryResult = Apollo.QueryResult<AdminGridRightRelationsPreviewQueryQuery, AdminGridRightRelationsPreviewQueryQueryVariables>;
export const CustomFieldGridDisplayQueryDocument = gql`
    query CustomFieldGridDisplayQuery($entityGridItemConfigurationId: Int!) {
  entityGridItemConfiguration(id: $entityGridItemConfigurationId) {
    id
    fields {
      hash
      nodes {
        id
        gridItemFieldTypeCode
        entityGridItemConfigurationId
        sort
        type {
          code
          heading
          isActive
        }
        customFieldConfiguration {
          id
          customField {
            code
            heading
            customFieldTypeCode
            options {
              hash
              totalCount
              nodes {
                code
                value {
                  id
                  value
                }
              }
            }
            fieldType {
              code
              enum
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCustomFieldGridDisplayQueryQuery__
 *
 * To run a query within a React component, call `useCustomFieldGridDisplayQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldGridDisplayQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldGridDisplayQueryQuery({
 *   variables: {
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function useCustomFieldGridDisplayQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldGridDisplayQueryQuery, CustomFieldGridDisplayQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldGridDisplayQueryQuery, CustomFieldGridDisplayQueryQueryVariables>(CustomFieldGridDisplayQueryDocument, options);
      }
export function useCustomFieldGridDisplayQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldGridDisplayQueryQuery, CustomFieldGridDisplayQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldGridDisplayQueryQuery, CustomFieldGridDisplayQueryQueryVariables>(CustomFieldGridDisplayQueryDocument, options);
        }
export type CustomFieldGridDisplayQueryQueryHookResult = ReturnType<typeof useCustomFieldGridDisplayQueryQuery>;
export type CustomFieldGridDisplayQueryLazyQueryHookResult = ReturnType<typeof useCustomFieldGridDisplayQueryLazyQuery>;
export type CustomFieldGridDisplayQueryQueryResult = Apollo.QueryResult<CustomFieldGridDisplayQueryQuery, CustomFieldGridDisplayQueryQueryVariables>;
export const GetAvailableAddressTypesDocument = gql`
    query GetAvailableAddressTypes($entityType: EntityTypeEnum!) {
  addressTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      headingKey
    }
  }
}
    `;

/**
 * __useGetAvailableAddressTypesQuery__
 *
 * To run a query within a React component, call `useGetAvailableAddressTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableAddressTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableAddressTypesQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useGetAvailableAddressTypesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableAddressTypesQuery, GetAvailableAddressTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableAddressTypesQuery, GetAvailableAddressTypesQueryVariables>(GetAvailableAddressTypesDocument, options);
      }
export function useGetAvailableAddressTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableAddressTypesQuery, GetAvailableAddressTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableAddressTypesQuery, GetAvailableAddressTypesQueryVariables>(GetAvailableAddressTypesDocument, options);
        }
export type GetAvailableAddressTypesQueryHookResult = ReturnType<typeof useGetAvailableAddressTypesQuery>;
export type GetAvailableAddressTypesLazyQueryHookResult = ReturnType<typeof useGetAvailableAddressTypesLazyQuery>;
export type GetAvailableAddressTypesQueryResult = Apollo.QueryResult<GetAvailableAddressTypesQuery, GetAvailableAddressTypesQueryVariables>;
export const AddressTypeQueryDocument = gql`
    query AddressTypeQuery($code: String!) {
  addressType(code: $code) {
    code
    headingKey
    sort
    affiliations {
      hash
      totalCount
    }
  }
}
    `;

/**
 * __useAddressTypeQueryQuery__
 *
 * To run a query within a React component, call `useAddressTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressTypeQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAddressTypeQueryQuery(baseOptions: Apollo.QueryHookOptions<AddressTypeQueryQuery, AddressTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressTypeQueryQuery, AddressTypeQueryQueryVariables>(AddressTypeQueryDocument, options);
      }
export function useAddressTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressTypeQueryQuery, AddressTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressTypeQueryQuery, AddressTypeQueryQueryVariables>(AddressTypeQueryDocument, options);
        }
export type AddressTypeQueryQueryHookResult = ReturnType<typeof useAddressTypeQueryQuery>;
export type AddressTypeQueryLazyQueryHookResult = ReturnType<typeof useAddressTypeQueryLazyQuery>;
export type AddressTypeQueryQueryResult = Apollo.QueryResult<AddressTypeQueryQuery, AddressTypeQueryQueryVariables>;
export const UpdateDefaultCriteriasMutationDocument = gql`
    mutation UpdateDefaultCriteriasMutation($entityType: EntityTypeEnum!, $criteriaIds: [Int!]!) {
  updateDefaultCriterias(entityType: $entityType, criteriaIds: $criteriaIds) {
    id
    sort
  }
}
    `;
export type UpdateDefaultCriteriasMutationMutationFn = Apollo.MutationFunction<UpdateDefaultCriteriasMutationMutation, UpdateDefaultCriteriasMutationMutationVariables>;

/**
 * __useUpdateDefaultCriteriasMutationMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultCriteriasMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultCriteriasMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultCriteriasMutationMutation, { data, loading, error }] = useUpdateDefaultCriteriasMutationMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      criteriaIds: // value for 'criteriaIds'
 *   },
 * });
 */
export function useUpdateDefaultCriteriasMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultCriteriasMutationMutation, UpdateDefaultCriteriasMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultCriteriasMutationMutation, UpdateDefaultCriteriasMutationMutationVariables>(UpdateDefaultCriteriasMutationDocument, options);
      }
export type UpdateDefaultCriteriasMutationMutationHookResult = ReturnType<typeof useUpdateDefaultCriteriasMutationMutation>;
export type UpdateDefaultCriteriasMutationMutationResult = Apollo.MutationResult<UpdateDefaultCriteriasMutationMutation>;
export type UpdateDefaultCriteriasMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultCriteriasMutationMutation, UpdateDefaultCriteriasMutationMutationVariables>;
export const AdminCriteriaGroupsQueryDocument = gql`
    query AdminCriteriaGroupsQuery($entityType: EntityTypeEnum!) {
  criteriaGroups(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      entityId
      heading
      criterias(criteria: {fetchSize: {limit: null}}) {
        hash
        nodes {
          id
          entityId
          heading
        }
      }
    }
  }
}
    `;

/**
 * __useAdminCriteriaGroupsQueryQuery__
 *
 * To run a query within a React component, call `useAdminCriteriaGroupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCriteriaGroupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCriteriaGroupsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useAdminCriteriaGroupsQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminCriteriaGroupsQueryQuery, AdminCriteriaGroupsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCriteriaGroupsQueryQuery, AdminCriteriaGroupsQueryQueryVariables>(AdminCriteriaGroupsQueryDocument, options);
      }
export function useAdminCriteriaGroupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCriteriaGroupsQueryQuery, AdminCriteriaGroupsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCriteriaGroupsQueryQuery, AdminCriteriaGroupsQueryQueryVariables>(AdminCriteriaGroupsQueryDocument, options);
        }
export type AdminCriteriaGroupsQueryQueryHookResult = ReturnType<typeof useAdminCriteriaGroupsQueryQuery>;
export type AdminCriteriaGroupsQueryLazyQueryHookResult = ReturnType<typeof useAdminCriteriaGroupsQueryLazyQuery>;
export type AdminCriteriaGroupsQueryQueryResult = Apollo.QueryResult<AdminCriteriaGroupsQueryQuery, AdminCriteriaGroupsQueryQueryVariables>;
export const ConfigureDefaultCriteriasQueryDocument = gql`
    query ConfigureDefaultCriteriasQuery($entityType: EntityTypeEnum!) {
  defaultCriterias(criteria: {entityType: $entityType}) {
    hash
    nodes {
      id
      sort
      criteria {
        id
        entityId
        heading
      }
    }
  }
}
    `;

/**
 * __useConfigureDefaultCriteriasQueryQuery__
 *
 * To run a query within a React component, call `useConfigureDefaultCriteriasQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureDefaultCriteriasQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureDefaultCriteriasQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useConfigureDefaultCriteriasQueryQuery(baseOptions: Apollo.QueryHookOptions<ConfigureDefaultCriteriasQueryQuery, ConfigureDefaultCriteriasQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigureDefaultCriteriasQueryQuery, ConfigureDefaultCriteriasQueryQueryVariables>(ConfigureDefaultCriteriasQueryDocument, options);
      }
export function useConfigureDefaultCriteriasQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigureDefaultCriteriasQueryQuery, ConfigureDefaultCriteriasQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigureDefaultCriteriasQueryQuery, ConfigureDefaultCriteriasQueryQueryVariables>(ConfigureDefaultCriteriasQueryDocument, options);
        }
export type ConfigureDefaultCriteriasQueryQueryHookResult = ReturnType<typeof useConfigureDefaultCriteriasQueryQuery>;
export type ConfigureDefaultCriteriasQueryLazyQueryHookResult = ReturnType<typeof useConfigureDefaultCriteriasQueryLazyQuery>;
export type ConfigureDefaultCriteriasQueryQueryResult = Apollo.QueryResult<ConfigureDefaultCriteriasQueryQuery, ConfigureDefaultCriteriasQueryQueryVariables>;
export const ContactCategoriesQueryDocument = gql`
    query ContactCategoriesQuery($entityType: EntityTypeEnum!) {
  contactCategories(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      heading
      isMapped
    }
  }
}
    `;

/**
 * __useContactCategoriesQueryQuery__
 *
 * To run a query within a React component, call `useContactCategoriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategoriesQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useContactCategoriesQueryQuery(baseOptions: Apollo.QueryHookOptions<ContactCategoriesQueryQuery, ContactCategoriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategoriesQueryQuery, ContactCategoriesQueryQueryVariables>(ContactCategoriesQueryDocument, options);
      }
export function useContactCategoriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategoriesQueryQuery, ContactCategoriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategoriesQueryQuery, ContactCategoriesQueryQueryVariables>(ContactCategoriesQueryDocument, options);
        }
export type ContactCategoriesQueryQueryHookResult = ReturnType<typeof useContactCategoriesQueryQuery>;
export type ContactCategoriesQueryLazyQueryHookResult = ReturnType<typeof useContactCategoriesQueryLazyQuery>;
export type ContactCategoriesQueryQueryResult = Apollo.QueryResult<ContactCategoriesQueryQuery, ContactCategoriesQueryQueryVariables>;
export const CreateContactCategoryDocument = gql`
    mutation CreateContactCategory($input: CreateContactCategoryInput!) {
  createContactCategory(input: $input) {
    code
    heading
  }
}
    `;
export type CreateContactCategoryMutationFn = Apollo.MutationFunction<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>;

/**
 * __useCreateContactCategoryMutation__
 *
 * To run a mutation, you first call `useCreateContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactCategoryMutation, { data, loading, error }] = useCreateContactCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>(CreateContactCategoryDocument, options);
      }
export type CreateContactCategoryMutationHookResult = ReturnType<typeof useCreateContactCategoryMutation>;
export type CreateContactCategoryMutationResult = Apollo.MutationResult<CreateContactCategoryMutation>;
export type CreateContactCategoryMutationOptions = Apollo.BaseMutationOptions<CreateContactCategoryMutation, CreateContactCategoryMutationVariables>;
export const UpdateContactCategoryDocument = gql`
    mutation UpdateContactCategory($input: UpdateContactCategoryInput!) {
  updateContactCategory(input: $input) {
    code
    heading
    isHeadingKey
    allowMultipleValues
    typeEnum
    type {
      code
      enum
      heading
    }
  }
}
    `;
export type UpdateContactCategoryMutationFn = Apollo.MutationFunction<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>;

/**
 * __useUpdateContactCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateContactCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCategoryMutation, { data, loading, error }] = useUpdateContactCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>(UpdateContactCategoryDocument, options);
      }
export type UpdateContactCategoryMutationHookResult = ReturnType<typeof useUpdateContactCategoryMutation>;
export type UpdateContactCategoryMutationResult = Apollo.MutationResult<UpdateContactCategoryMutation>;
export type UpdateContactCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateContactCategoryMutation, UpdateContactCategoryMutationVariables>;
export const ContactCategorySuggestionQueryDocument = gql`
    query ContactCategorySuggestionQuery {
  contactTypes {
    hash
    nodes {
      code
      heading
    }
  }
}
    `;

/**
 * __useContactCategorySuggestionQueryQuery__
 *
 * To run a query within a React component, call `useContactCategorySuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategorySuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategorySuggestionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactCategorySuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<ContactCategorySuggestionQueryQuery, ContactCategorySuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategorySuggestionQueryQuery, ContactCategorySuggestionQueryQueryVariables>(ContactCategorySuggestionQueryDocument, options);
      }
export function useContactCategorySuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategorySuggestionQueryQuery, ContactCategorySuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategorySuggestionQueryQuery, ContactCategorySuggestionQueryQueryVariables>(ContactCategorySuggestionQueryDocument, options);
        }
export type ContactCategorySuggestionQueryQueryHookResult = ReturnType<typeof useContactCategorySuggestionQueryQuery>;
export type ContactCategorySuggestionQueryLazyQueryHookResult = ReturnType<typeof useContactCategorySuggestionQueryLazyQuery>;
export type ContactCategorySuggestionQueryQueryResult = Apollo.QueryResult<ContactCategorySuggestionQueryQuery, ContactCategorySuggestionQueryQueryVariables>;
export const ContactCategoryCodeCheckQueryDocument = gql`
    query ContactCategoryCodeCheckQuery($categoryCode: String!) {
  contactCategory(code: $categoryCode) {
    code
  }
}
    `;

/**
 * __useContactCategoryCodeCheckQueryQuery__
 *
 * To run a query within a React component, call `useContactCategoryCodeCheckQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoryCodeCheckQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategoryCodeCheckQueryQuery({
 *   variables: {
 *      categoryCode: // value for 'categoryCode'
 *   },
 * });
 */
export function useContactCategoryCodeCheckQueryQuery(baseOptions: Apollo.QueryHookOptions<ContactCategoryCodeCheckQueryQuery, ContactCategoryCodeCheckQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategoryCodeCheckQueryQuery, ContactCategoryCodeCheckQueryQueryVariables>(ContactCategoryCodeCheckQueryDocument, options);
      }
export function useContactCategoryCodeCheckQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategoryCodeCheckQueryQuery, ContactCategoryCodeCheckQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategoryCodeCheckQueryQuery, ContactCategoryCodeCheckQueryQueryVariables>(ContactCategoryCodeCheckQueryDocument, options);
        }
export type ContactCategoryCodeCheckQueryQueryHookResult = ReturnType<typeof useContactCategoryCodeCheckQueryQuery>;
export type ContactCategoryCodeCheckQueryLazyQueryHookResult = ReturnType<typeof useContactCategoryCodeCheckQueryLazyQuery>;
export type ContactCategoryCodeCheckQueryQueryResult = Apollo.QueryResult<ContactCategoryCodeCheckQueryQuery, ContactCategoryCodeCheckQueryQueryVariables>;
export const ContactCategoryModalQueryDocument = gql`
    query ContactCategoryModalQuery($categoryCode: String!) {
  contactCategory(code: $categoryCode) {
    code
    heading
    isHeadingKey
    allowMultipleValues
    mappings {
      hash
      nodes {
        id
        mapping
      }
    }
    type {
      code
      heading
      enum
    }
    values {
      hash
      totalCount
    }
  }
}
    `;

/**
 * __useContactCategoryModalQueryQuery__
 *
 * To run a query within a React component, call `useContactCategoryModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactCategoryModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactCategoryModalQueryQuery({
 *   variables: {
 *      categoryCode: // value for 'categoryCode'
 *   },
 * });
 */
export function useContactCategoryModalQueryQuery(baseOptions: Apollo.QueryHookOptions<ContactCategoryModalQueryQuery, ContactCategoryModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactCategoryModalQueryQuery, ContactCategoryModalQueryQueryVariables>(ContactCategoryModalQueryDocument, options);
      }
export function useContactCategoryModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactCategoryModalQueryQuery, ContactCategoryModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactCategoryModalQueryQuery, ContactCategoryModalQueryQueryVariables>(ContactCategoryModalQueryDocument, options);
        }
export type ContactCategoryModalQueryQueryHookResult = ReturnType<typeof useContactCategoryModalQueryQuery>;
export type ContactCategoryModalQueryLazyQueryHookResult = ReturnType<typeof useContactCategoryModalQueryLazyQuery>;
export type ContactCategoryModalQueryQueryResult = Apollo.QueryResult<ContactCategoryModalQueryQuery, ContactCategoryModalQueryQueryVariables>;
export const AdminEntityCustomFieldsQueryDocument = gql`
    query AdminEntityCustomFieldsQuery($entityType: EntityTypeEnum!) {
  customFields(criteria: {entityType: $entityType, isActive: null}) {
    hash
    nodes {
      code
      heading
      isActive
      fieldTypeEnum
      fieldGridConfigurations {
        hash
        totalCount
      }
    }
  }
}
    `;

/**
 * __useAdminEntityCustomFieldsQueryQuery__
 *
 * To run a query within a React component, call `useAdminEntityCustomFieldsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityCustomFieldsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityCustomFieldsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useAdminEntityCustomFieldsQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminEntityCustomFieldsQueryQuery, AdminEntityCustomFieldsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityCustomFieldsQueryQuery, AdminEntityCustomFieldsQueryQueryVariables>(AdminEntityCustomFieldsQueryDocument, options);
      }
export function useAdminEntityCustomFieldsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityCustomFieldsQueryQuery, AdminEntityCustomFieldsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityCustomFieldsQueryQuery, AdminEntityCustomFieldsQueryQueryVariables>(AdminEntityCustomFieldsQueryDocument, options);
        }
export type AdminEntityCustomFieldsQueryQueryHookResult = ReturnType<typeof useAdminEntityCustomFieldsQueryQuery>;
export type AdminEntityCustomFieldsQueryLazyQueryHookResult = ReturnType<typeof useAdminEntityCustomFieldsQueryLazyQuery>;
export type AdminEntityCustomFieldsQueryQueryResult = Apollo.QueryResult<AdminEntityCustomFieldsQueryQuery, AdminEntityCustomFieldsQueryQueryVariables>;
export const AdminEntityMergeRequestConnectionQueryDocument = gql`
    query AdminEntityMergeRequestConnectionQuery($criteria: EntityMergeCriteria) {
  connection: entityMerges(criteria: $criteria) {
    hash
    totalCount
    nodes {
      id
      ...AdminEntityMergeRequestFragment
    }
  }
}
    ${AdminEntityMergeRequestFragmentFragmentDoc}`;

/**
 * __useAdminEntityMergeRequestConnectionQueryQuery__
 *
 * To run a query within a React component, call `useAdminEntityMergeRequestConnectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityMergeRequestConnectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityMergeRequestConnectionQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useAdminEntityMergeRequestConnectionQueryQuery(baseOptions?: Apollo.QueryHookOptions<AdminEntityMergeRequestConnectionQueryQuery, AdminEntityMergeRequestConnectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityMergeRequestConnectionQueryQuery, AdminEntityMergeRequestConnectionQueryQueryVariables>(AdminEntityMergeRequestConnectionQueryDocument, options);
      }
export function useAdminEntityMergeRequestConnectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityMergeRequestConnectionQueryQuery, AdminEntityMergeRequestConnectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityMergeRequestConnectionQueryQuery, AdminEntityMergeRequestConnectionQueryQueryVariables>(AdminEntityMergeRequestConnectionQueryDocument, options);
        }
export type AdminEntityMergeRequestConnectionQueryQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestConnectionQueryQuery>;
export type AdminEntityMergeRequestConnectionQueryLazyQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestConnectionQueryLazyQuery>;
export type AdminEntityMergeRequestConnectionQueryQueryResult = Apollo.QueryResult<AdminEntityMergeRequestConnectionQueryQuery, AdminEntityMergeRequestConnectionQueryQueryVariables>;
export const AdminEntityMergeRequestRecordQueryDocument = gql`
    query AdminEntityMergeRequestRecordQuery($recordId: Int!) {
  record: entityMerge(id: $recordId) {
    id
    ...AdminEntityMergeRequestFragment
  }
}
    ${AdminEntityMergeRequestFragmentFragmentDoc}`;

/**
 * __useAdminEntityMergeRequestRecordQueryQuery__
 *
 * To run a query within a React component, call `useAdminEntityMergeRequestRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityMergeRequestRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityMergeRequestRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useAdminEntityMergeRequestRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminEntityMergeRequestRecordQueryQuery, AdminEntityMergeRequestRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityMergeRequestRecordQueryQuery, AdminEntityMergeRequestRecordQueryQueryVariables>(AdminEntityMergeRequestRecordQueryDocument, options);
      }
export function useAdminEntityMergeRequestRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityMergeRequestRecordQueryQuery, AdminEntityMergeRequestRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityMergeRequestRecordQueryQuery, AdminEntityMergeRequestRecordQueryQueryVariables>(AdminEntityMergeRequestRecordQueryDocument, options);
        }
export type AdminEntityMergeRequestRecordQueryQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestRecordQueryQuery>;
export type AdminEntityMergeRequestRecordQueryLazyQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestRecordQueryLazyQuery>;
export type AdminEntityMergeRequestRecordQueryQueryResult = Apollo.QueryResult<AdminEntityMergeRequestRecordQueryQuery, AdminEntityMergeRequestRecordQueryQueryVariables>;
export const AdminEntityMergeRequestBasicDocument = gql`
    query AdminEntityMergeRequestBasic($mergeRequestId: Int!) {
  entityMerge(id: $mergeRequestId) {
    id
    byUser {
      id
      fullname
    }
    entityType
    from {
      id
    }
    into {
      id
    }
  }
}
    `;

/**
 * __useAdminEntityMergeRequestBasicQuery__
 *
 * To run a query within a React component, call `useAdminEntityMergeRequestBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityMergeRequestBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityMergeRequestBasicQuery({
 *   variables: {
 *      mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function useAdminEntityMergeRequestBasicQuery(baseOptions: Apollo.QueryHookOptions<AdminEntityMergeRequestBasicQuery, AdminEntityMergeRequestBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityMergeRequestBasicQuery, AdminEntityMergeRequestBasicQueryVariables>(AdminEntityMergeRequestBasicDocument, options);
      }
export function useAdminEntityMergeRequestBasicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityMergeRequestBasicQuery, AdminEntityMergeRequestBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityMergeRequestBasicQuery, AdminEntityMergeRequestBasicQueryVariables>(AdminEntityMergeRequestBasicDocument, options);
        }
export type AdminEntityMergeRequestBasicQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestBasicQuery>;
export type AdminEntityMergeRequestBasicLazyQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestBasicLazyQuery>;
export type AdminEntityMergeRequestBasicQueryResult = Apollo.QueryResult<AdminEntityMergeRequestBasicQuery, AdminEntityMergeRequestBasicQueryVariables>;
export const MergeLinksSetPrimaryLinkDocument = gql`
    mutation MergeLinksSetPrimaryLink($personId: ID!, $primaryLinkId: ID!) {
  setPrimaryLink(personId: $personId, linkId: $primaryLinkId) {
    id
    isPrimary
  }
}
    `;
export type MergeLinksSetPrimaryLinkMutationFn = Apollo.MutationFunction<MergeLinksSetPrimaryLinkMutation, MergeLinksSetPrimaryLinkMutationVariables>;

/**
 * __useMergeLinksSetPrimaryLinkMutation__
 *
 * To run a mutation, you first call `useMergeLinksSetPrimaryLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeLinksSetPrimaryLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeLinksSetPrimaryLinkMutation, { data, loading, error }] = useMergeLinksSetPrimaryLinkMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      primaryLinkId: // value for 'primaryLinkId'
 *   },
 * });
 */
export function useMergeLinksSetPrimaryLinkMutation(baseOptions?: Apollo.MutationHookOptions<MergeLinksSetPrimaryLinkMutation, MergeLinksSetPrimaryLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeLinksSetPrimaryLinkMutation, MergeLinksSetPrimaryLinkMutationVariables>(MergeLinksSetPrimaryLinkDocument, options);
      }
export type MergeLinksSetPrimaryLinkMutationHookResult = ReturnType<typeof useMergeLinksSetPrimaryLinkMutation>;
export type MergeLinksSetPrimaryLinkMutationResult = Apollo.MutationResult<MergeLinksSetPrimaryLinkMutation>;
export type MergeLinksSetPrimaryLinkMutationOptions = Apollo.BaseMutationOptions<MergeLinksSetPrimaryLinkMutation, MergeLinksSetPrimaryLinkMutationVariables>;
export const MergeRemovePrimaryLinkDocument = gql`
    mutation MergeRemovePrimaryLink($personId: ID!, $currentPrimaryLink: ID!) {
  setNonPrimaryLink(personId: $personId, linkId: $currentPrimaryLink) {
    id
    isPrimary
  }
}
    `;
export type MergeRemovePrimaryLinkMutationFn = Apollo.MutationFunction<MergeRemovePrimaryLinkMutation, MergeRemovePrimaryLinkMutationVariables>;

/**
 * __useMergeRemovePrimaryLinkMutation__
 *
 * To run a mutation, you first call `useMergeRemovePrimaryLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeRemovePrimaryLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeRemovePrimaryLinkMutation, { data, loading, error }] = useMergeRemovePrimaryLinkMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      currentPrimaryLink: // value for 'currentPrimaryLink'
 *   },
 * });
 */
export function useMergeRemovePrimaryLinkMutation(baseOptions?: Apollo.MutationHookOptions<MergeRemovePrimaryLinkMutation, MergeRemovePrimaryLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeRemovePrimaryLinkMutation, MergeRemovePrimaryLinkMutationVariables>(MergeRemovePrimaryLinkDocument, options);
      }
export type MergeRemovePrimaryLinkMutationHookResult = ReturnType<typeof useMergeRemovePrimaryLinkMutation>;
export type MergeRemovePrimaryLinkMutationResult = Apollo.MutationResult<MergeRemovePrimaryLinkMutation>;
export type MergeRemovePrimaryLinkMutationOptions = Apollo.BaseMutationOptions<MergeRemovePrimaryLinkMutation, MergeRemovePrimaryLinkMutationVariables>;
export const MRAffiliationPositionCodeDocument = gql`
    query MRAffiliationPositionCode($countryCode: CountryCode!) {
  positions(criteria: {countries: [$countryCode], fetchSize: {limit: 10000}}) {
    hash
    nodes {
      code
      label
      type
      displayLabel
    }
  }
}
    `;

/**
 * __useMRAffiliationPositionCodeQuery__
 *
 * To run a query within a React component, call `useMRAffiliationPositionCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMRAffiliationPositionCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMRAffiliationPositionCodeQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useMRAffiliationPositionCodeQuery(baseOptions: Apollo.QueryHookOptions<MRAffiliationPositionCodeQuery, MRAffiliationPositionCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MRAffiliationPositionCodeQuery, MRAffiliationPositionCodeQueryVariables>(MRAffiliationPositionCodeDocument, options);
      }
export function useMRAffiliationPositionCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MRAffiliationPositionCodeQuery, MRAffiliationPositionCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MRAffiliationPositionCodeQuery, MRAffiliationPositionCodeQueryVariables>(MRAffiliationPositionCodeDocument, options);
        }
export type MRAffiliationPositionCodeQueryHookResult = ReturnType<typeof useMRAffiliationPositionCodeQuery>;
export type MRAffiliationPositionCodeLazyQueryHookResult = ReturnType<typeof useMRAffiliationPositionCodeLazyQuery>;
export type MRAffiliationPositionCodeQueryResult = Apollo.QueryResult<MRAffiliationPositionCodeQuery, MRAffiliationPositionCodeQueryVariables>;
export const UpdateAffiliationPositionCodeDocument = gql`
    mutation UpdateAffiliationPositionCode($linkId: Int!, $newCode: String) {
  updatePosition(id: $linkId, positionCode: $newCode) {
    id
    positionCode
    position {
      code
      type
    }
  }
}
    `;
export type UpdateAffiliationPositionCodeMutationFn = Apollo.MutationFunction<UpdateAffiliationPositionCodeMutation, UpdateAffiliationPositionCodeMutationVariables>;

/**
 * __useUpdateAffiliationPositionCodeMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliationPositionCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliationPositionCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliationPositionCodeMutation, { data, loading, error }] = useUpdateAffiliationPositionCodeMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      newCode: // value for 'newCode'
 *   },
 * });
 */
export function useUpdateAffiliationPositionCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffiliationPositionCodeMutation, UpdateAffiliationPositionCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffiliationPositionCodeMutation, UpdateAffiliationPositionCodeMutationVariables>(UpdateAffiliationPositionCodeDocument, options);
      }
export type UpdateAffiliationPositionCodeMutationHookResult = ReturnType<typeof useUpdateAffiliationPositionCodeMutation>;
export type UpdateAffiliationPositionCodeMutationResult = Apollo.MutationResult<UpdateAffiliationPositionCodeMutation>;
export type UpdateAffiliationPositionCodeMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliationPositionCodeMutation, UpdateAffiliationPositionCodeMutationVariables>;
export const MRSetWorkingSpecialitiesDocument = gql`
    mutation MRSetWorkingSpecialities($linkId: Int!, $workingSpecialtyCodes: [String!]!) {
  updateSitePersonWorkingSpecialties(
    linkId: $linkId
    workingSpecialtyCodes: $workingSpecialtyCodes
  ) {
    id
  }
}
    `;
export type MRSetWorkingSpecialitiesMutationFn = Apollo.MutationFunction<MRSetWorkingSpecialitiesMutation, MRSetWorkingSpecialitiesMutationVariables>;

/**
 * __useMRSetWorkingSpecialitiesMutation__
 *
 * To run a mutation, you first call `useMRSetWorkingSpecialitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMRSetWorkingSpecialitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mrSetWorkingSpecialitiesMutation, { data, loading, error }] = useMRSetWorkingSpecialitiesMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      workingSpecialtyCodes: // value for 'workingSpecialtyCodes'
 *   },
 * });
 */
export function useMRSetWorkingSpecialitiesMutation(baseOptions?: Apollo.MutationHookOptions<MRSetWorkingSpecialitiesMutation, MRSetWorkingSpecialitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MRSetWorkingSpecialitiesMutation, MRSetWorkingSpecialitiesMutationVariables>(MRSetWorkingSpecialitiesDocument, options);
      }
export type MRSetWorkingSpecialitiesMutationHookResult = ReturnType<typeof useMRSetWorkingSpecialitiesMutation>;
export type MRSetWorkingSpecialitiesMutationResult = Apollo.MutationResult<MRSetWorkingSpecialitiesMutation>;
export type MRSetWorkingSpecialitiesMutationOptions = Apollo.BaseMutationOptions<MRSetWorkingSpecialitiesMutation, MRSetWorkingSpecialitiesMutationVariables>;
export const MRWorkingSpecialitiesDocument = gql`
    query MRWorkingSpecialities($countryCode: CountryCode!) {
  workingSpecialties(
    criteria: {countries: [$countryCode], fetchSize: {limit: 10000}}
  ) {
    hash
    nodes {
      code
      type
      displayLabel
    }
  }
}
    `;

/**
 * __useMRWorkingSpecialitiesQuery__
 *
 * To run a query within a React component, call `useMRWorkingSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMRWorkingSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMRWorkingSpecialitiesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useMRWorkingSpecialitiesQuery(baseOptions: Apollo.QueryHookOptions<MRWorkingSpecialitiesQuery, MRWorkingSpecialitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MRWorkingSpecialitiesQuery, MRWorkingSpecialitiesQueryVariables>(MRWorkingSpecialitiesDocument, options);
      }
export function useMRWorkingSpecialitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MRWorkingSpecialitiesQuery, MRWorkingSpecialitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MRWorkingSpecialitiesQuery, MRWorkingSpecialitiesQueryVariables>(MRWorkingSpecialitiesDocument, options);
        }
export type MRWorkingSpecialitiesQueryHookResult = ReturnType<typeof useMRWorkingSpecialitiesQuery>;
export type MRWorkingSpecialitiesLazyQueryHookResult = ReturnType<typeof useMRWorkingSpecialitiesLazyQuery>;
export type MRWorkingSpecialitiesQueryResult = Apollo.QueryResult<MRWorkingSpecialitiesQuery, MRWorkingSpecialitiesQueryVariables>;
export const PersonEntityMergeActivityModalDocument = gql`
    query PersonEntityMergeActivityModal($activityIds: [ID!]!) {
  activities(criteria: {ids: $activityIds}) {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __usePersonEntityMergeActivityModalQuery__
 *
 * To run a query within a React component, call `usePersonEntityMergeActivityModalQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonEntityMergeActivityModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonEntityMergeActivityModalQuery({
 *   variables: {
 *      activityIds: // value for 'activityIds'
 *   },
 * });
 */
export function usePersonEntityMergeActivityModalQuery(baseOptions: Apollo.QueryHookOptions<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>(PersonEntityMergeActivityModalDocument, options);
      }
export function usePersonEntityMergeActivityModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>(PersonEntityMergeActivityModalDocument, options);
        }
export type PersonEntityMergeActivityModalQueryHookResult = ReturnType<typeof usePersonEntityMergeActivityModalQuery>;
export type PersonEntityMergeActivityModalLazyQueryHookResult = ReturnType<typeof usePersonEntityMergeActivityModalLazyQuery>;
export type PersonEntityMergeActivityModalQueryResult = Apollo.QueryResult<PersonEntityMergeActivityModalQuery, PersonEntityMergeActivityModalQueryVariables>;
export const UpdatePersonBirthDocument = gql`
    mutation UpdatePersonBirth($personId: Int!, $newValue: DateTime) {
  updatePersonDateOfBirth(persId: $personId, date: $newValue) {
    id
    birth
  }
}
    `;
export type UpdatePersonBirthMutationFn = Apollo.MutationFunction<UpdatePersonBirthMutation, UpdatePersonBirthMutationVariables>;

/**
 * __useUpdatePersonBirthMutation__
 *
 * To run a mutation, you first call `useUpdatePersonBirthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonBirthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonBirthMutation, { data, loading, error }] = useUpdatePersonBirthMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonBirthMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonBirthMutation, UpdatePersonBirthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonBirthMutation, UpdatePersonBirthMutationVariables>(UpdatePersonBirthDocument, options);
      }
export type UpdatePersonBirthMutationHookResult = ReturnType<typeof useUpdatePersonBirthMutation>;
export type UpdatePersonBirthMutationResult = Apollo.MutationResult<UpdatePersonBirthMutation>;
export type UpdatePersonBirthMutationOptions = Apollo.BaseMutationOptions<UpdatePersonBirthMutation, UpdatePersonBirthMutationVariables>;
export const UpdatePersonConsentDocument = gql`
    mutation UpdatePersonConsent($personId: Int!, $typeCode: String!, $isEnabled: Boolean!) {
  setConsentValue(
    entityAffiliationId: $personId
    typeCode: $typeCode
    isEnabled: $isEnabled
  ) {
    entityAffiliationId
    entityType
    consentTypeCode
    isEnabled
  }
}
    `;
export type UpdatePersonConsentMutationFn = Apollo.MutationFunction<UpdatePersonConsentMutation, UpdatePersonConsentMutationVariables>;

/**
 * __useUpdatePersonConsentMutation__
 *
 * To run a mutation, you first call `useUpdatePersonConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonConsentMutation, { data, loading, error }] = useUpdatePersonConsentMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      typeCode: // value for 'typeCode'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdatePersonConsentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonConsentMutation, UpdatePersonConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonConsentMutation, UpdatePersonConsentMutationVariables>(UpdatePersonConsentDocument, options);
      }
export type UpdatePersonConsentMutationHookResult = ReturnType<typeof useUpdatePersonConsentMutation>;
export type UpdatePersonConsentMutationResult = Apollo.MutationResult<UpdatePersonConsentMutation>;
export type UpdatePersonConsentMutationOptions = Apollo.BaseMutationOptions<UpdatePersonConsentMutation, UpdatePersonConsentMutationVariables>;
export const UpdatePersonCountryDocument = gql`
    mutation UpdatePersonCountry($personId: Int!, $newValue: CountryCode!) {
  updatePersonCountry(persId: $personId, country: $newValue) {
    id
    countryCode
    countryEnum
    country {
      code
    }
  }
}
    `;
export type UpdatePersonCountryMutationFn = Apollo.MutationFunction<UpdatePersonCountryMutation, UpdatePersonCountryMutationVariables>;

/**
 * __useUpdatePersonCountryMutation__
 *
 * To run a mutation, you first call `useUpdatePersonCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonCountryMutation, { data, loading, error }] = useUpdatePersonCountryMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonCountryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonCountryMutation, UpdatePersonCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonCountryMutation, UpdatePersonCountryMutationVariables>(UpdatePersonCountryDocument, options);
      }
export type UpdatePersonCountryMutationHookResult = ReturnType<typeof useUpdatePersonCountryMutation>;
export type UpdatePersonCountryMutationResult = Apollo.MutationResult<UpdatePersonCountryMutation>;
export type UpdatePersonCountryMutationOptions = Apollo.BaseMutationOptions<UpdatePersonCountryMutation, UpdatePersonCountryMutationVariables>;
export const UpdatePersonExamYearDocument = gql`
    mutation UpdatePersonExamYear($personId: Int!, $newValue: Year!) {
  updatePersonExamYear(persId: $personId, date: $newValue) {
    id
    examYear
  }
}
    `;
export type UpdatePersonExamYearMutationFn = Apollo.MutationFunction<UpdatePersonExamYearMutation, UpdatePersonExamYearMutationVariables>;

/**
 * __useUpdatePersonExamYearMutation__
 *
 * To run a mutation, you first call `useUpdatePersonExamYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonExamYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonExamYearMutation, { data, loading, error }] = useUpdatePersonExamYearMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonExamYearMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonExamYearMutation, UpdatePersonExamYearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonExamYearMutation, UpdatePersonExamYearMutationVariables>(UpdatePersonExamYearDocument, options);
      }
export type UpdatePersonExamYearMutationHookResult = ReturnType<typeof useUpdatePersonExamYearMutation>;
export type UpdatePersonExamYearMutationResult = Apollo.MutationResult<UpdatePersonExamYearMutation>;
export type UpdatePersonExamYearMutationOptions = Apollo.BaseMutationOptions<UpdatePersonExamYearMutation, UpdatePersonExamYearMutationVariables>;
export const MergeRequestExternalIdDocument = gql`
    mutation MergeRequestExternalId($input: ExternalIdMutationInput!, $existingExternalIdId: Int!, $removeOld: Boolean!) {
  setExternalId(input: $input) {
    id
    externalId
  }
  removeExternalId(externalIdId: $existingExternalIdId) @skip(if: $removeOld) {
    id
    externalId
  }
}
    `;
export type MergeRequestExternalIdMutationFn = Apollo.MutationFunction<MergeRequestExternalIdMutation, MergeRequestExternalIdMutationVariables>;

/**
 * __useMergeRequestExternalIdMutation__
 *
 * To run a mutation, you first call `useMergeRequestExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeRequestExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeRequestExternalIdMutation, { data, loading, error }] = useMergeRequestExternalIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *      existingExternalIdId: // value for 'existingExternalIdId'
 *      removeOld: // value for 'removeOld'
 *   },
 * });
 */
export function useMergeRequestExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<MergeRequestExternalIdMutation, MergeRequestExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeRequestExternalIdMutation, MergeRequestExternalIdMutationVariables>(MergeRequestExternalIdDocument, options);
      }
export type MergeRequestExternalIdMutationHookResult = ReturnType<typeof useMergeRequestExternalIdMutation>;
export type MergeRequestExternalIdMutationResult = Apollo.MutationResult<MergeRequestExternalIdMutation>;
export type MergeRequestExternalIdMutationOptions = Apollo.BaseMutationOptions<MergeRequestExternalIdMutation, MergeRequestExternalIdMutationVariables>;
export const UpdatePersonNameDocument = gql`
    mutation UpdatePersonName($personId: Int!, $newValue: String!) {
  updatePersonFirstName(persId: $personId, firstName: $newValue) {
    id
    firstName
  }
}
    `;
export type UpdatePersonNameMutationFn = Apollo.MutationFunction<UpdatePersonNameMutation, UpdatePersonNameMutationVariables>;

/**
 * __useUpdatePersonNameMutation__
 *
 * To run a mutation, you first call `useUpdatePersonNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonNameMutation, { data, loading, error }] = useUpdatePersonNameMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonNameMutation, UpdatePersonNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonNameMutation, UpdatePersonNameMutationVariables>(UpdatePersonNameDocument, options);
      }
export type UpdatePersonNameMutationHookResult = ReturnType<typeof useUpdatePersonNameMutation>;
export type UpdatePersonNameMutationResult = Apollo.MutationResult<UpdatePersonNameMutation>;
export type UpdatePersonNameMutationOptions = Apollo.BaseMutationOptions<UpdatePersonNameMutation, UpdatePersonNameMutationVariables>;
export const UpdatePersonLastNameDocument = gql`
    mutation UpdatePersonLastName($personId: Int!, $newValue: String!) {
  updatePersonLastName(persId: $personId, lastName: $newValue) {
    id
    lastName
  }
}
    `;
export type UpdatePersonLastNameMutationFn = Apollo.MutationFunction<UpdatePersonLastNameMutation, UpdatePersonLastNameMutationVariables>;

/**
 * __useUpdatePersonLastNameMutation__
 *
 * To run a mutation, you first call `useUpdatePersonLastNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonLastNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonLastNameMutation, { data, loading, error }] = useUpdatePersonLastNameMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonLastNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonLastNameMutation, UpdatePersonLastNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonLastNameMutation, UpdatePersonLastNameMutationVariables>(UpdatePersonLastNameDocument, options);
      }
export type UpdatePersonLastNameMutationHookResult = ReturnType<typeof useUpdatePersonLastNameMutation>;
export type UpdatePersonLastNameMutationResult = Apollo.MutationResult<UpdatePersonLastNameMutation>;
export type UpdatePersonLastNameMutationOptions = Apollo.BaseMutationOptions<UpdatePersonLastNameMutation, UpdatePersonLastNameMutationVariables>;
export const CreateNestedMergeRequestDocument = gql`
    mutation CreateNestedMergeRequest($fromLinkId: ID!, $toLinkId: ID!) {
  createMergeRequest(
    entityType: AFFILIATION
    loserId: $fromLinkId
    winnerId: $toLinkId
  ) {
    id
  }
}
    `;
export type CreateNestedMergeRequestMutationFn = Apollo.MutationFunction<CreateNestedMergeRequestMutation, CreateNestedMergeRequestMutationVariables>;

/**
 * __useCreateNestedMergeRequestMutation__
 *
 * To run a mutation, you first call `useCreateNestedMergeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNestedMergeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNestedMergeRequestMutation, { data, loading, error }] = useCreateNestedMergeRequestMutation({
 *   variables: {
 *      fromLinkId: // value for 'fromLinkId'
 *      toLinkId: // value for 'toLinkId'
 *   },
 * });
 */
export function useCreateNestedMergeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateNestedMergeRequestMutation, CreateNestedMergeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNestedMergeRequestMutation, CreateNestedMergeRequestMutationVariables>(CreateNestedMergeRequestDocument, options);
      }
export type CreateNestedMergeRequestMutationHookResult = ReturnType<typeof useCreateNestedMergeRequestMutation>;
export type CreateNestedMergeRequestMutationResult = Apollo.MutationResult<CreateNestedMergeRequestMutation>;
export type CreateNestedMergeRequestMutationOptions = Apollo.BaseMutationOptions<CreateNestedMergeRequestMutation, CreateNestedMergeRequestMutationVariables>;
export const PerformNestedMergeRequestDocument = gql`
    mutation PerformNestedMergeRequest($mergeId: ID!) {
  performMerge(mergeRequestId: $mergeId) {
    entityMergeId
    hasConflict
    fromId
    intoId
  }
}
    `;
export type PerformNestedMergeRequestMutationFn = Apollo.MutationFunction<PerformNestedMergeRequestMutation, PerformNestedMergeRequestMutationVariables>;

/**
 * __usePerformNestedMergeRequestMutation__
 *
 * To run a mutation, you first call `usePerformNestedMergeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformNestedMergeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performNestedMergeRequestMutation, { data, loading, error }] = usePerformNestedMergeRequestMutation({
 *   variables: {
 *      mergeId: // value for 'mergeId'
 *   },
 * });
 */
export function usePerformNestedMergeRequestMutation(baseOptions?: Apollo.MutationHookOptions<PerformNestedMergeRequestMutation, PerformNestedMergeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformNestedMergeRequestMutation, PerformNestedMergeRequestMutationVariables>(PerformNestedMergeRequestDocument, options);
      }
export type PerformNestedMergeRequestMutationHookResult = ReturnType<typeof usePerformNestedMergeRequestMutation>;
export type PerformNestedMergeRequestMutationResult = Apollo.MutationResult<PerformNestedMergeRequestMutation>;
export type PerformNestedMergeRequestMutationOptions = Apollo.BaseMutationOptions<PerformNestedMergeRequestMutation, PerformNestedMergeRequestMutationVariables>;
export const MRPersonLinksPrimaryResolverDocument = gql`
    query MRPersonLinksPrimaryResolver($fromPersonId: ID!, $intoPersonId: ID!) {
  from: sitePersonAffiliations(
    criteria: {personId: $fromPersonId, primaryOnly: true}
  ) {
    hash
    nodes {
      ...MRPersonLinkPrimary
    }
  }
  into: sitePersonAffiliations(
    criteria: {personId: $intoPersonId, primaryOnly: true}
  ) {
    hash
    nodes {
      ...MRPersonLinkPrimary
    }
  }
}
    ${MRPersonLinkPrimaryFragmentDoc}`;

/**
 * __useMRPersonLinksPrimaryResolverQuery__
 *
 * To run a query within a React component, call `useMRPersonLinksPrimaryResolverQuery` and pass it any options that fit your needs.
 * When your component renders, `useMRPersonLinksPrimaryResolverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMRPersonLinksPrimaryResolverQuery({
 *   variables: {
 *      fromPersonId: // value for 'fromPersonId'
 *      intoPersonId: // value for 'intoPersonId'
 *   },
 * });
 */
export function useMRPersonLinksPrimaryResolverQuery(baseOptions: Apollo.QueryHookOptions<MRPersonLinksPrimaryResolverQuery, MRPersonLinksPrimaryResolverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MRPersonLinksPrimaryResolverQuery, MRPersonLinksPrimaryResolverQueryVariables>(MRPersonLinksPrimaryResolverDocument, options);
      }
export function useMRPersonLinksPrimaryResolverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MRPersonLinksPrimaryResolverQuery, MRPersonLinksPrimaryResolverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MRPersonLinksPrimaryResolverQuery, MRPersonLinksPrimaryResolverQueryVariables>(MRPersonLinksPrimaryResolverDocument, options);
        }
export type MRPersonLinksPrimaryResolverQueryHookResult = ReturnType<typeof useMRPersonLinksPrimaryResolverQuery>;
export type MRPersonLinksPrimaryResolverLazyQueryHookResult = ReturnType<typeof useMRPersonLinksPrimaryResolverLazyQuery>;
export type MRPersonLinksPrimaryResolverQueryResult = Apollo.QueryResult<MRPersonLinksPrimaryResolverQuery, MRPersonLinksPrimaryResolverQueryVariables>;
export const DeletePersonProductSegmentationMergeDocument = gql`
    mutation DeletePersonProductSegmentationMerge($personId: Int!, $productId: Int!) {
  removeProductSegmentation(personId: $personId, productId: $productId)
}
    `;
export type DeletePersonProductSegmentationMergeMutationFn = Apollo.MutationFunction<DeletePersonProductSegmentationMergeMutation, DeletePersonProductSegmentationMergeMutationVariables>;

/**
 * __useDeletePersonProductSegmentationMergeMutation__
 *
 * To run a mutation, you first call `useDeletePersonProductSegmentationMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonProductSegmentationMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonProductSegmentationMergeMutation, { data, loading, error }] = useDeletePersonProductSegmentationMergeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useDeletePersonProductSegmentationMergeMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonProductSegmentationMergeMutation, DeletePersonProductSegmentationMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonProductSegmentationMergeMutation, DeletePersonProductSegmentationMergeMutationVariables>(DeletePersonProductSegmentationMergeDocument, options);
      }
export type DeletePersonProductSegmentationMergeMutationHookResult = ReturnType<typeof useDeletePersonProductSegmentationMergeMutation>;
export type DeletePersonProductSegmentationMergeMutationResult = Apollo.MutationResult<DeletePersonProductSegmentationMergeMutation>;
export type DeletePersonProductSegmentationMergeMutationOptions = Apollo.BaseMutationOptions<DeletePersonProductSegmentationMergeMutation, DeletePersonProductSegmentationMergeMutationVariables>;
export const AddPersonProductSegmentationMergeDocument = gql`
    mutation AddPersonProductSegmentationMerge($personId: Int!, $productId: Int!, $segmentationCodeId: Int!) {
  addProductSegmentation(
    personId: $personId
    productId: $productId
    segmentationCodeId: $segmentationCodeId
  ) {
    id
  }
}
    `;
export type AddPersonProductSegmentationMergeMutationFn = Apollo.MutationFunction<AddPersonProductSegmentationMergeMutation, AddPersonProductSegmentationMergeMutationVariables>;

/**
 * __useAddPersonProductSegmentationMergeMutation__
 *
 * To run a mutation, you first call `useAddPersonProductSegmentationMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPersonProductSegmentationMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPersonProductSegmentationMergeMutation, { data, loading, error }] = useAddPersonProductSegmentationMergeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *      segmentationCodeId: // value for 'segmentationCodeId'
 *   },
 * });
 */
export function useAddPersonProductSegmentationMergeMutation(baseOptions?: Apollo.MutationHookOptions<AddPersonProductSegmentationMergeMutation, AddPersonProductSegmentationMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPersonProductSegmentationMergeMutation, AddPersonProductSegmentationMergeMutationVariables>(AddPersonProductSegmentationMergeDocument, options);
      }
export type AddPersonProductSegmentationMergeMutationHookResult = ReturnType<typeof useAddPersonProductSegmentationMergeMutation>;
export type AddPersonProductSegmentationMergeMutationResult = Apollo.MutationResult<AddPersonProductSegmentationMergeMutation>;
export type AddPersonProductSegmentationMergeMutationOptions = Apollo.BaseMutationOptions<AddPersonProductSegmentationMergeMutation, AddPersonProductSegmentationMergeMutationVariables>;
export const PersonProductSegmentationMergeLookupDocument = gql`
    query PersonProductSegmentationMergeLookup {
  segmentationCodes {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __usePersonProductSegmentationMergeLookupQuery__
 *
 * To run a query within a React component, call `usePersonProductSegmentationMergeLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonProductSegmentationMergeLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonProductSegmentationMergeLookupQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonProductSegmentationMergeLookupQuery(baseOptions?: Apollo.QueryHookOptions<PersonProductSegmentationMergeLookupQuery, PersonProductSegmentationMergeLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonProductSegmentationMergeLookupQuery, PersonProductSegmentationMergeLookupQueryVariables>(PersonProductSegmentationMergeLookupDocument, options);
      }
export function usePersonProductSegmentationMergeLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonProductSegmentationMergeLookupQuery, PersonProductSegmentationMergeLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonProductSegmentationMergeLookupQuery, PersonProductSegmentationMergeLookupQueryVariables>(PersonProductSegmentationMergeLookupDocument, options);
        }
export type PersonProductSegmentationMergeLookupQueryHookResult = ReturnType<typeof usePersonProductSegmentationMergeLookupQuery>;
export type PersonProductSegmentationMergeLookupLazyQueryHookResult = ReturnType<typeof usePersonProductSegmentationMergeLookupLazyQuery>;
export type PersonProductSegmentationMergeLookupQueryResult = Apollo.QueryResult<PersonProductSegmentationMergeLookupQuery, PersonProductSegmentationMergeLookupQueryVariables>;
export const UpdateResponsibleUserForPersonDocument = gql`
    mutation UpdateResponsibleUserForPerson($recordId: Int!, $areaId: Int!, $userId: Int!) {
  upsertResponsibleArea(persId: $recordId, areaId: $areaId, userId: $userId) {
    id
  }
}
    `;
export type UpdateResponsibleUserForPersonMutationFn = Apollo.MutationFunction<UpdateResponsibleUserForPersonMutation, UpdateResponsibleUserForPersonMutationVariables>;

/**
 * __useUpdateResponsibleUserForPersonMutation__
 *
 * To run a mutation, you first call `useUpdateResponsibleUserForPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResponsibleUserForPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResponsibleUserForPersonMutation, { data, loading, error }] = useUpdateResponsibleUserForPersonMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      areaId: // value for 'areaId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateResponsibleUserForPersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResponsibleUserForPersonMutation, UpdateResponsibleUserForPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResponsibleUserForPersonMutation, UpdateResponsibleUserForPersonMutationVariables>(UpdateResponsibleUserForPersonDocument, options);
      }
export type UpdateResponsibleUserForPersonMutationHookResult = ReturnType<typeof useUpdateResponsibleUserForPersonMutation>;
export type UpdateResponsibleUserForPersonMutationResult = Apollo.MutationResult<UpdateResponsibleUserForPersonMutation>;
export type UpdateResponsibleUserForPersonMutationOptions = Apollo.BaseMutationOptions<UpdateResponsibleUserForPersonMutation, UpdateResponsibleUserForPersonMutationVariables>;
export const UsersListOverviewDocument = gql`
    query UsersListOverview($criteria: UserCriteria!) {
  users(criteria: $criteria) {
    hash
    nodes {
      id
      fullname
    }
  }
}
    `;

/**
 * __useUsersListOverviewQuery__
 *
 * To run a query within a React component, call `useUsersListOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersListOverviewQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useUsersListOverviewQuery(baseOptions: Apollo.QueryHookOptions<UsersListOverviewQuery, UsersListOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersListOverviewQuery, UsersListOverviewQueryVariables>(UsersListOverviewDocument, options);
      }
export function useUsersListOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersListOverviewQuery, UsersListOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersListOverviewQuery, UsersListOverviewQueryVariables>(UsersListOverviewDocument, options);
        }
export type UsersListOverviewQueryHookResult = ReturnType<typeof useUsersListOverviewQuery>;
export type UsersListOverviewLazyQueryHookResult = ReturnType<typeof useUsersListOverviewLazyQuery>;
export type UsersListOverviewQueryResult = Apollo.QueryResult<UsersListOverviewQuery, UsersListOverviewQueryVariables>;
export const MRSetSegmentationCodeDocument = gql`
    mutation MRSetSegmentationCode($personId: Int!, $segmentationCodeId: Int!) {
  upsertPersonSegmentationCode(id: $personId, segmentationId: $segmentationCodeId) {
    id
  }
}
    `;
export type MRSetSegmentationCodeMutationFn = Apollo.MutationFunction<MRSetSegmentationCodeMutation, MRSetSegmentationCodeMutationVariables>;

/**
 * __useMRSetSegmentationCodeMutation__
 *
 * To run a mutation, you first call `useMRSetSegmentationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMRSetSegmentationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mrSetSegmentationCodeMutation, { data, loading, error }] = useMRSetSegmentationCodeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      segmentationCodeId: // value for 'segmentationCodeId'
 *   },
 * });
 */
export function useMRSetSegmentationCodeMutation(baseOptions?: Apollo.MutationHookOptions<MRSetSegmentationCodeMutation, MRSetSegmentationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MRSetSegmentationCodeMutation, MRSetSegmentationCodeMutationVariables>(MRSetSegmentationCodeDocument, options);
      }
export type MRSetSegmentationCodeMutationHookResult = ReturnType<typeof useMRSetSegmentationCodeMutation>;
export type MRSetSegmentationCodeMutationResult = Apollo.MutationResult<MRSetSegmentationCodeMutation>;
export type MRSetSegmentationCodeMutationOptions = Apollo.BaseMutationOptions<MRSetSegmentationCodeMutation, MRSetSegmentationCodeMutationVariables>;
export const MergeRequestSegmentationDocument = gql`
    query MergeRequestSegmentation {
  segmentationCodes {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useMergeRequestSegmentationQuery__
 *
 * To run a query within a React component, call `useMergeRequestSegmentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeRequestSegmentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeRequestSegmentationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMergeRequestSegmentationQuery(baseOptions?: Apollo.QueryHookOptions<MergeRequestSegmentationQuery, MergeRequestSegmentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeRequestSegmentationQuery, MergeRequestSegmentationQueryVariables>(MergeRequestSegmentationDocument, options);
      }
export function useMergeRequestSegmentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeRequestSegmentationQuery, MergeRequestSegmentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeRequestSegmentationQuery, MergeRequestSegmentationQueryVariables>(MergeRequestSegmentationDocument, options);
        }
export type MergeRequestSegmentationQueryHookResult = ReturnType<typeof useMergeRequestSegmentationQuery>;
export type MergeRequestSegmentationLazyQueryHookResult = ReturnType<typeof useMergeRequestSegmentationLazyQuery>;
export type MergeRequestSegmentationQueryResult = Apollo.QueryResult<MergeRequestSegmentationQuery, MergeRequestSegmentationQueryVariables>;
export const UpdatePersonSexDocument = gql`
    mutation UpdatePersonSex($personId: Int!, $newValue: GenderEnum!) {
  updatePersonSex(persId: $personId, sex: $newValue) {
    id
    title
  }
}
    `;
export type UpdatePersonSexMutationFn = Apollo.MutationFunction<UpdatePersonSexMutation, UpdatePersonSexMutationVariables>;

/**
 * __useUpdatePersonSexMutation__
 *
 * To run a mutation, you first call `useUpdatePersonSexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonSexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonSexMutation, { data, loading, error }] = useUpdatePersonSexMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonSexMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonSexMutation, UpdatePersonSexMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonSexMutation, UpdatePersonSexMutationVariables>(UpdatePersonSexDocument, options);
      }
export type UpdatePersonSexMutationHookResult = ReturnType<typeof useUpdatePersonSexMutation>;
export type UpdatePersonSexMutationResult = Apollo.MutationResult<UpdatePersonSexMutation>;
export type UpdatePersonSexMutationOptions = Apollo.BaseMutationOptions<UpdatePersonSexMutation, UpdatePersonSexMutationVariables>;
export const MRSetTagsDocument = gql`
    mutation MRSetTags($personId: Int!, $filterCodeIds: [Int!]!) {
  updatePersonFilterCode(personId: $personId, filterCodeIds: $filterCodeIds) {
    id
    personId
  }
}
    `;
export type MRSetTagsMutationFn = Apollo.MutationFunction<MRSetTagsMutation, MRSetTagsMutationVariables>;

/**
 * __useMRSetTagsMutation__
 *
 * To run a mutation, you first call `useMRSetTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMRSetTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mrSetTagsMutation, { data, loading, error }] = useMRSetTagsMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      filterCodeIds: // value for 'filterCodeIds'
 *   },
 * });
 */
export function useMRSetTagsMutation(baseOptions?: Apollo.MutationHookOptions<MRSetTagsMutation, MRSetTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MRSetTagsMutation, MRSetTagsMutationVariables>(MRSetTagsDocument, options);
      }
export type MRSetTagsMutationHookResult = ReturnType<typeof useMRSetTagsMutation>;
export type MRSetTagsMutationResult = Apollo.MutationResult<MRSetTagsMutation>;
export type MRSetTagsMutationOptions = Apollo.BaseMutationOptions<MRSetTagsMutation, MRSetTagsMutationVariables>;
export const MRFilterCodesDocument = gql`
    query MRFilterCodes {
  filterCodes(criteria: {fetchSize: {limit: 10000}}) {
    hash
    nodes {
      id
      header
    }
  }
}
    `;

/**
 * __useMRFilterCodesQuery__
 *
 * To run a query within a React component, call `useMRFilterCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMRFilterCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMRFilterCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMRFilterCodesQuery(baseOptions?: Apollo.QueryHookOptions<MRFilterCodesQuery, MRFilterCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MRFilterCodesQuery, MRFilterCodesQueryVariables>(MRFilterCodesDocument, options);
      }
export function useMRFilterCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MRFilterCodesQuery, MRFilterCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MRFilterCodesQuery, MRFilterCodesQueryVariables>(MRFilterCodesDocument, options);
        }
export type MRFilterCodesQueryHookResult = ReturnType<typeof useMRFilterCodesQuery>;
export type MRFilterCodesLazyQueryHookResult = ReturnType<typeof useMRFilterCodesLazyQuery>;
export type MRFilterCodesQueryResult = Apollo.QueryResult<MRFilterCodesQuery, MRFilterCodesQueryVariables>;
export const UpdatePersonTitleDocument = gql`
    mutation UpdatePersonTitle($personId: Int!, $newValue: String!) {
  updatePersonTitle(persId: $personId, title: $newValue) {
    id
    title
  }
}
    `;
export type UpdatePersonTitleMutationFn = Apollo.MutationFunction<UpdatePersonTitleMutation, UpdatePersonTitleMutationVariables>;

/**
 * __useUpdatePersonTitleMutation__
 *
 * To run a mutation, you first call `useUpdatePersonTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonTitleMutation, { data, loading, error }] = useUpdatePersonTitleMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdatePersonTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonTitleMutation, UpdatePersonTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonTitleMutation, UpdatePersonTitleMutationVariables>(UpdatePersonTitleDocument, options);
      }
export type UpdatePersonTitleMutationHookResult = ReturnType<typeof useUpdatePersonTitleMutation>;
export type UpdatePersonTitleMutationResult = Apollo.MutationResult<UpdatePersonTitleMutation>;
export type UpdatePersonTitleMutationOptions = Apollo.BaseMutationOptions<UpdatePersonTitleMutation, UpdatePersonTitleMutationVariables>;
export const MRPersonTypesDocument = gql`
    query MRPersonTypes($countryCode: CountryCode!) {
  personTypes(criteria: {countries: [$countryCode], fetchSize: {limit: 10000}}) {
    hash
    nodes {
      code
      type
      displayLabel
    }
  }
}
    `;

/**
 * __useMRPersonTypesQuery__
 *
 * To run a query within a React component, call `useMRPersonTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMRPersonTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMRPersonTypesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useMRPersonTypesQuery(baseOptions: Apollo.QueryHookOptions<MRPersonTypesQuery, MRPersonTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MRPersonTypesQuery, MRPersonTypesQueryVariables>(MRPersonTypesDocument, options);
      }
export function useMRPersonTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MRPersonTypesQuery, MRPersonTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MRPersonTypesQuery, MRPersonTypesQueryVariables>(MRPersonTypesDocument, options);
        }
export type MRPersonTypesQueryHookResult = ReturnType<typeof useMRPersonTypesQuery>;
export type MRPersonTypesLazyQueryHookResult = ReturnType<typeof useMRPersonTypesLazyQuery>;
export type MRPersonTypesQueryResult = Apollo.QueryResult<MRPersonTypesQuery, MRPersonTypesQueryVariables>;
export const UpdatePersonTypeDocument = gql`
    mutation UpdatePersonType($personId: Int!, $newCode: String) {
  updatePersonType(persId: $personId, typeCode: $newCode) {
    id
    persTypeCode
    persType {
      code
      type
    }
  }
}
    `;
export type UpdatePersonTypeMutationFn = Apollo.MutationFunction<UpdatePersonTypeMutation, UpdatePersonTypeMutationVariables>;

/**
 * __useUpdatePersonTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePersonTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonTypeMutation, { data, loading, error }] = useUpdatePersonTypeMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      newCode: // value for 'newCode'
 *   },
 * });
 */
export function useUpdatePersonTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonTypeMutation, UpdatePersonTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonTypeMutation, UpdatePersonTypeMutationVariables>(UpdatePersonTypeDocument, options);
      }
export type UpdatePersonTypeMutationHookResult = ReturnType<typeof useUpdatePersonTypeMutation>;
export type UpdatePersonTypeMutationResult = Apollo.MutationResult<UpdatePersonTypeMutation>;
export type UpdatePersonTypeMutationOptions = Apollo.BaseMutationOptions<UpdatePersonTypeMutation, UpdatePersonTypeMutationVariables>;
export const MergeAddressUpdateAddressDocument = gql`
    mutation MergeAddressUpdateAddress($addressAffiliationId: Int!, $input: AddressInput!) {
  updateAddress(addressAffiliationId: $addressAffiliationId, input: $input) {
    id
  }
}
    `;
export type MergeAddressUpdateAddressMutationFn = Apollo.MutationFunction<MergeAddressUpdateAddressMutation, MergeAddressUpdateAddressMutationVariables>;

/**
 * __useMergeAddressUpdateAddressMutation__
 *
 * To run a mutation, you first call `useMergeAddressUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAddressUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAddressUpdateAddressMutation, { data, loading, error }] = useMergeAddressUpdateAddressMutation({
 *   variables: {
 *      addressAffiliationId: // value for 'addressAffiliationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeAddressUpdateAddressMutation(baseOptions?: Apollo.MutationHookOptions<MergeAddressUpdateAddressMutation, MergeAddressUpdateAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeAddressUpdateAddressMutation, MergeAddressUpdateAddressMutationVariables>(MergeAddressUpdateAddressDocument, options);
      }
export type MergeAddressUpdateAddressMutationHookResult = ReturnType<typeof useMergeAddressUpdateAddressMutation>;
export type MergeAddressUpdateAddressMutationResult = Apollo.MutationResult<MergeAddressUpdateAddressMutation>;
export type MergeAddressUpdateAddressMutationOptions = Apollo.BaseMutationOptions<MergeAddressUpdateAddressMutation, MergeAddressUpdateAddressMutationVariables>;
export const MergeContactValuesDocument = gql`
    mutation MergeContactValues($entityType: EntityTypeEnum!, $type: ContactTypeEnum!, $entityAffiliationId: Int!, $values: [ContactValueInput!]!) {
  upsertContactValues(
    entityType: $entityType
    type: $type
    entityAffiliationId: $entityAffiliationId
    values: $values
  ) {
    id
    value
  }
}
    `;
export type MergeContactValuesMutationFn = Apollo.MutationFunction<MergeContactValuesMutation, MergeContactValuesMutationVariables>;

/**
 * __useMergeContactValuesMutation__
 *
 * To run a mutation, you first call `useMergeContactValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeContactValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeContactValuesMutation, { data, loading, error }] = useMergeContactValuesMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      type: // value for 'type'
 *      entityAffiliationId: // value for 'entityAffiliationId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useMergeContactValuesMutation(baseOptions?: Apollo.MutationHookOptions<MergeContactValuesMutation, MergeContactValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeContactValuesMutation, MergeContactValuesMutationVariables>(MergeContactValuesDocument, options);
      }
export type MergeContactValuesMutationHookResult = ReturnType<typeof useMergeContactValuesMutation>;
export type MergeContactValuesMutationResult = Apollo.MutationResult<MergeContactValuesMutation>;
export type MergeContactValuesMutationOptions = Apollo.BaseMutationOptions<MergeContactValuesMutation, MergeContactValuesMutationVariables>;
export const EntityMergeListsModalDocument = gql`
    query EntityMergeListsModal($listIds: [ID!]!) {
  lists(criteria: {ids: $listIds}) {
    hash
    nodes {
      id
      title
    }
  }
}
    `;

/**
 * __useEntityMergeListsModalQuery__
 *
 * To run a query within a React component, call `useEntityMergeListsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMergeListsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMergeListsModalQuery({
 *   variables: {
 *      listIds: // value for 'listIds'
 *   },
 * });
 */
export function useEntityMergeListsModalQuery(baseOptions: Apollo.QueryHookOptions<EntityMergeListsModalQuery, EntityMergeListsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityMergeListsModalQuery, EntityMergeListsModalQueryVariables>(EntityMergeListsModalDocument, options);
      }
export function useEntityMergeListsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityMergeListsModalQuery, EntityMergeListsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityMergeListsModalQuery, EntityMergeListsModalQueryVariables>(EntityMergeListsModalDocument, options);
        }
export type EntityMergeListsModalQueryHookResult = ReturnType<typeof useEntityMergeListsModalQuery>;
export type EntityMergeListsModalLazyQueryHookResult = ReturnType<typeof useEntityMergeListsModalLazyQuery>;
export type EntityMergeListsModalQueryResult = Apollo.QueryResult<EntityMergeListsModalQuery, EntityMergeListsModalQueryVariables>;
export const SiteEntityMergeActivityModalDocument = gql`
    query SiteEntityMergeActivityModal($activityIds: [ID!]!) {
  activities(criteria: {ids: $activityIds}) {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useSiteEntityMergeActivityModalQuery__
 *
 * To run a query within a React component, call `useSiteEntityMergeActivityModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteEntityMergeActivityModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteEntityMergeActivityModalQuery({
 *   variables: {
 *      activityIds: // value for 'activityIds'
 *   },
 * });
 */
export function useSiteEntityMergeActivityModalQuery(baseOptions: Apollo.QueryHookOptions<SiteEntityMergeActivityModalQuery, SiteEntityMergeActivityModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteEntityMergeActivityModalQuery, SiteEntityMergeActivityModalQueryVariables>(SiteEntityMergeActivityModalDocument, options);
      }
export function useSiteEntityMergeActivityModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteEntityMergeActivityModalQuery, SiteEntityMergeActivityModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteEntityMergeActivityModalQuery, SiteEntityMergeActivityModalQueryVariables>(SiteEntityMergeActivityModalDocument, options);
        }
export type SiteEntityMergeActivityModalQueryHookResult = ReturnType<typeof useSiteEntityMergeActivityModalQuery>;
export type SiteEntityMergeActivityModalLazyQueryHookResult = ReturnType<typeof useSiteEntityMergeActivityModalLazyQuery>;
export type SiteEntityMergeActivityModalQueryResult = Apollo.QueryResult<SiteEntityMergeActivityModalQuery, SiteEntityMergeActivityModalQueryVariables>;
export const MRUpdateIsUnplacedDocument = gql`
    mutation MRUpdateIsUnplaced($siteId: ID!, $isUnplaced: Boolean!) {
  setSiteIsUnplaced(siteId: $siteId, isUnplaced: $isUnplaced) {
    id
    isUnplaced
  }
}
    `;
export type MRUpdateIsUnplacedMutationFn = Apollo.MutationFunction<MRUpdateIsUnplacedMutation, MRUpdateIsUnplacedMutationVariables>;

/**
 * __useMRUpdateIsUnplacedMutation__
 *
 * To run a mutation, you first call `useMRUpdateIsUnplacedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMRUpdateIsUnplacedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mrUpdateIsUnplacedMutation, { data, loading, error }] = useMRUpdateIsUnplacedMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      isUnplaced: // value for 'isUnplaced'
 *   },
 * });
 */
export function useMRUpdateIsUnplacedMutation(baseOptions?: Apollo.MutationHookOptions<MRUpdateIsUnplacedMutation, MRUpdateIsUnplacedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MRUpdateIsUnplacedMutation, MRUpdateIsUnplacedMutationVariables>(MRUpdateIsUnplacedDocument, options);
      }
export type MRUpdateIsUnplacedMutationHookResult = ReturnType<typeof useMRUpdateIsUnplacedMutation>;
export type MRUpdateIsUnplacedMutationResult = Apollo.MutationResult<MRUpdateIsUnplacedMutation>;
export type MRUpdateIsUnplacedMutationOptions = Apollo.BaseMutationOptions<MRUpdateIsUnplacedMutation, MRUpdateIsUnplacedMutationVariables>;
export const MergeMoveLinkToWinnerSiteDocument = gql`
    mutation MergeMoveLinkToWinnerSite($linkId: ID!, $siteId: ID!) {
  newLinkFromExisting(linkId: $linkId, siteId: $siteId) {
    id
  }
}
    `;
export type MergeMoveLinkToWinnerSiteMutationFn = Apollo.MutationFunction<MergeMoveLinkToWinnerSiteMutation, MergeMoveLinkToWinnerSiteMutationVariables>;

/**
 * __useMergeMoveLinkToWinnerSiteMutation__
 *
 * To run a mutation, you first call `useMergeMoveLinkToWinnerSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeMoveLinkToWinnerSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeMoveLinkToWinnerSiteMutation, { data, loading, error }] = useMergeMoveLinkToWinnerSiteMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMergeMoveLinkToWinnerSiteMutation(baseOptions?: Apollo.MutationHookOptions<MergeMoveLinkToWinnerSiteMutation, MergeMoveLinkToWinnerSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeMoveLinkToWinnerSiteMutation, MergeMoveLinkToWinnerSiteMutationVariables>(MergeMoveLinkToWinnerSiteDocument, options);
      }
export type MergeMoveLinkToWinnerSiteMutationHookResult = ReturnType<typeof useMergeMoveLinkToWinnerSiteMutation>;
export type MergeMoveLinkToWinnerSiteMutationResult = Apollo.MutationResult<MergeMoveLinkToWinnerSiteMutation>;
export type MergeMoveLinkToWinnerSiteMutationOptions = Apollo.BaseMutationOptions<MergeMoveLinkToWinnerSiteMutation, MergeMoveLinkToWinnerSiteMutationVariables>;
export const MergeInactivateLinkDocument = gql`
    mutation MergeInactivateLink($linkId: Int!) {
  setSitePersonActiveStatus(id: $linkId, isActive: false) {
    id
    isActive
  }
}
    `;
export type MergeInactivateLinkMutationFn = Apollo.MutationFunction<MergeInactivateLinkMutation, MergeInactivateLinkMutationVariables>;

/**
 * __useMergeInactivateLinkMutation__
 *
 * To run a mutation, you first call `useMergeInactivateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeInactivateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeInactivateLinkMutation, { data, loading, error }] = useMergeInactivateLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useMergeInactivateLinkMutation(baseOptions?: Apollo.MutationHookOptions<MergeInactivateLinkMutation, MergeInactivateLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeInactivateLinkMutation, MergeInactivateLinkMutationVariables>(MergeInactivateLinkDocument, options);
      }
export type MergeInactivateLinkMutationHookResult = ReturnType<typeof useMergeInactivateLinkMutation>;
export type MergeInactivateLinkMutationResult = Apollo.MutationResult<MergeInactivateLinkMutation>;
export type MergeInactivateLinkMutationOptions = Apollo.BaseMutationOptions<MergeInactivateLinkMutation, MergeInactivateLinkMutationVariables>;
export const MergeCreateSubMergeDocument = gql`
    mutation MergeCreateSubMerge($fromLinkId: ID!, $toLinkId: ID!) {
  createMergeRequest(
    entityType: AFFILIATION
    loserId: $fromLinkId
    winnerId: $toLinkId
  ) {
    id
  }
}
    `;
export type MergeCreateSubMergeMutationFn = Apollo.MutationFunction<MergeCreateSubMergeMutation, MergeCreateSubMergeMutationVariables>;

/**
 * __useMergeCreateSubMergeMutation__
 *
 * To run a mutation, you first call `useMergeCreateSubMergeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCreateSubMergeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCreateSubMergeMutation, { data, loading, error }] = useMergeCreateSubMergeMutation({
 *   variables: {
 *      fromLinkId: // value for 'fromLinkId'
 *      toLinkId: // value for 'toLinkId'
 *   },
 * });
 */
export function useMergeCreateSubMergeMutation(baseOptions?: Apollo.MutationHookOptions<MergeCreateSubMergeMutation, MergeCreateSubMergeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCreateSubMergeMutation, MergeCreateSubMergeMutationVariables>(MergeCreateSubMergeDocument, options);
      }
export type MergeCreateSubMergeMutationHookResult = ReturnType<typeof useMergeCreateSubMergeMutation>;
export type MergeCreateSubMergeMutationResult = Apollo.MutationResult<MergeCreateSubMergeMutation>;
export type MergeCreateSubMergeMutationOptions = Apollo.BaseMutationOptions<MergeCreateSubMergeMutation, MergeCreateSubMergeMutationVariables>;
export const UpdateSiteMailingNamePrefixDocument = gql`
    mutation UpdateSiteMailingNamePrefix($siteId: Int!, $newValue: String!) {
  updateSiteMailingNamePrefix(siteId: $siteId, mailingNamePrefix: $newValue) {
    id
    mailingNamePrefix
  }
}
    `;
export type UpdateSiteMailingNamePrefixMutationFn = Apollo.MutationFunction<UpdateSiteMailingNamePrefixMutation, UpdateSiteMailingNamePrefixMutationVariables>;

/**
 * __useUpdateSiteMailingNamePrefixMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMailingNamePrefixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMailingNamePrefixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMailingNamePrefixMutation, { data, loading, error }] = useUpdateSiteMailingNamePrefixMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSiteMailingNamePrefixMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMailingNamePrefixMutation, UpdateSiteMailingNamePrefixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMailingNamePrefixMutation, UpdateSiteMailingNamePrefixMutationVariables>(UpdateSiteMailingNamePrefixDocument, options);
      }
export type UpdateSiteMailingNamePrefixMutationHookResult = ReturnType<typeof useUpdateSiteMailingNamePrefixMutation>;
export type UpdateSiteMailingNamePrefixMutationResult = Apollo.MutationResult<UpdateSiteMailingNamePrefixMutation>;
export type UpdateSiteMailingNamePrefixMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMailingNamePrefixMutation, UpdateSiteMailingNamePrefixMutationVariables>;
export const UpdateSiteNameDocument = gql`
    mutation UpdateSiteName($siteId: Int!, $newValue: String!) {
  updateSiteName(siteId: $siteId, title: $newValue) {
    id
    name
  }
}
    `;
export type UpdateSiteNameMutationFn = Apollo.MutationFunction<UpdateSiteNameMutation, UpdateSiteNameMutationVariables>;

/**
 * __useUpdateSiteNameMutation__
 *
 * To run a mutation, you first call `useUpdateSiteNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteNameMutation, { data, loading, error }] = useUpdateSiteNameMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSiteNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteNameMutation, UpdateSiteNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteNameMutation, UpdateSiteNameMutationVariables>(UpdateSiteNameDocument, options);
      }
export type UpdateSiteNameMutationHookResult = ReturnType<typeof useUpdateSiteNameMutation>;
export type UpdateSiteNameMutationResult = Apollo.MutationResult<UpdateSiteNameMutation>;
export type UpdateSiteNameMutationOptions = Apollo.BaseMutationOptions<UpdateSiteNameMutation, UpdateSiteNameMutationVariables>;
export const UpdateSiteParentDocument = gql`
    mutation UpdateSiteParent($siteId: Int!, $newValue: Int!) {
  updateSiteParentId(siteId: $siteId, parentId: $newValue) {
    id
    parentId
    parentSite {
      id
      name
    }
  }
}
    `;
export type UpdateSiteParentMutationFn = Apollo.MutationFunction<UpdateSiteParentMutation, UpdateSiteParentMutationVariables>;

/**
 * __useUpdateSiteParentMutation__
 *
 * To run a mutation, you first call `useUpdateSiteParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteParentMutation, { data, loading, error }] = useUpdateSiteParentMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSiteParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteParentMutation, UpdateSiteParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteParentMutation, UpdateSiteParentMutationVariables>(UpdateSiteParentDocument, options);
      }
export type UpdateSiteParentMutationHookResult = ReturnType<typeof useUpdateSiteParentMutation>;
export type UpdateSiteParentMutationResult = Apollo.MutationResult<UpdateSiteParentMutation>;
export type UpdateSiteParentMutationOptions = Apollo.BaseMutationOptions<UpdateSiteParentMutation, UpdateSiteParentMutationVariables>;
export const MRSiteSetSegmentationCodeDocument = gql`
    mutation MRSiteSetSegmentationCode($siteId: Int!, $segmentationCodeId: Int!) {
  upsertSiteSegmentationCode(
    siteId: $siteId
    segmentationCodeId: $segmentationCodeId
  ) {
    id
  }
}
    `;
export type MRSiteSetSegmentationCodeMutationFn = Apollo.MutationFunction<MRSiteSetSegmentationCodeMutation, MRSiteSetSegmentationCodeMutationVariables>;

/**
 * __useMRSiteSetSegmentationCodeMutation__
 *
 * To run a mutation, you first call `useMRSiteSetSegmentationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMRSiteSetSegmentationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mrSiteSetSegmentationCodeMutation, { data, loading, error }] = useMRSiteSetSegmentationCodeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      segmentationCodeId: // value for 'segmentationCodeId'
 *   },
 * });
 */
export function useMRSiteSetSegmentationCodeMutation(baseOptions?: Apollo.MutationHookOptions<MRSiteSetSegmentationCodeMutation, MRSiteSetSegmentationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MRSiteSetSegmentationCodeMutation, MRSiteSetSegmentationCodeMutationVariables>(MRSiteSetSegmentationCodeDocument, options);
      }
export type MRSiteSetSegmentationCodeMutationHookResult = ReturnType<typeof useMRSiteSetSegmentationCodeMutation>;
export type MRSiteSetSegmentationCodeMutationResult = Apollo.MutationResult<MRSiteSetSegmentationCodeMutation>;
export type MRSiteSetSegmentationCodeMutationOptions = Apollo.BaseMutationOptions<MRSiteSetSegmentationCodeMutation, MRSiteSetSegmentationCodeMutationVariables>;
export const MergeSiteRequestSegmentationDocument = gql`
    query MergeSiteRequestSegmentation {
  segmentationCodes {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useMergeSiteRequestSegmentationQuery__
 *
 * To run a query within a React component, call `useMergeSiteRequestSegmentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeSiteRequestSegmentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeSiteRequestSegmentationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMergeSiteRequestSegmentationQuery(baseOptions?: Apollo.QueryHookOptions<MergeSiteRequestSegmentationQuery, MergeSiteRequestSegmentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeSiteRequestSegmentationQuery, MergeSiteRequestSegmentationQueryVariables>(MergeSiteRequestSegmentationDocument, options);
      }
export function useMergeSiteRequestSegmentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeSiteRequestSegmentationQuery, MergeSiteRequestSegmentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeSiteRequestSegmentationQuery, MergeSiteRequestSegmentationQueryVariables>(MergeSiteRequestSegmentationDocument, options);
        }
export type MergeSiteRequestSegmentationQueryHookResult = ReturnType<typeof useMergeSiteRequestSegmentationQuery>;
export type MergeSiteRequestSegmentationLazyQueryHookResult = ReturnType<typeof useMergeSiteRequestSegmentationLazyQuery>;
export type MergeSiteRequestSegmentationQueryResult = Apollo.QueryResult<MergeSiteRequestSegmentationQuery, MergeSiteRequestSegmentationQueryVariables>;
export const UpdateSiteTypeDocument = gql`
    mutation UpdateSiteType($siteId: Int!, $newValue: String!) {
  updateSiteTypeCode(siteId: $siteId, typeCode: $newValue) {
    id
    siteTypeCode
  }
}
    `;
export type UpdateSiteTypeMutationFn = Apollo.MutationFunction<UpdateSiteTypeMutation, UpdateSiteTypeMutationVariables>;

/**
 * __useUpdateSiteTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSiteTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteTypeMutation, { data, loading, error }] = useUpdateSiteTypeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSiteTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteTypeMutation, UpdateSiteTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteTypeMutation, UpdateSiteTypeMutationVariables>(UpdateSiteTypeDocument, options);
      }
export type UpdateSiteTypeMutationHookResult = ReturnType<typeof useUpdateSiteTypeMutation>;
export type UpdateSiteTypeMutationResult = Apollo.MutationResult<UpdateSiteTypeMutation>;
export type UpdateSiteTypeMutationOptions = Apollo.BaseMutationOptions<UpdateSiteTypeMutation, UpdateSiteTypeMutationVariables>;
export const UpdateSiteWebpageDocument = gql`
    mutation UpdateSiteWebpage($siteId: Int!, $newValue: String!) {
  updateSiteWebpage(siteId: $siteId, webpage: $newValue) {
    id
    siteWebpage
  }
}
    `;
export type UpdateSiteWebpageMutationFn = Apollo.MutationFunction<UpdateSiteWebpageMutation, UpdateSiteWebpageMutationVariables>;

/**
 * __useUpdateSiteWebpageMutation__
 *
 * To run a mutation, you first call `useUpdateSiteWebpageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteWebpageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteWebpageMutation, { data, loading, error }] = useUpdateSiteWebpageMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSiteWebpageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteWebpageMutation, UpdateSiteWebpageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteWebpageMutation, UpdateSiteWebpageMutationVariables>(UpdateSiteWebpageDocument, options);
      }
export type UpdateSiteWebpageMutationHookResult = ReturnType<typeof useUpdateSiteWebpageMutation>;
export type UpdateSiteWebpageMutationResult = Apollo.MutationResult<UpdateSiteWebpageMutation>;
export type UpdateSiteWebpageMutationOptions = Apollo.BaseMutationOptions<UpdateSiteWebpageMutation, UpdateSiteWebpageMutationVariables>;
export const PerformEntityMergeMutationDocument = gql`
    mutation PerformEntityMergeMutation($mergeRequestId: ID!) {
  performMerge(mergeRequestId: $mergeRequestId) {
    fromId
    intoId
    hasConflict
  }
}
    `;
export type PerformEntityMergeMutationMutationFn = Apollo.MutationFunction<PerformEntityMergeMutationMutation, PerformEntityMergeMutationMutationVariables>;

/**
 * __usePerformEntityMergeMutationMutation__
 *
 * To run a mutation, you first call `usePerformEntityMergeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformEntityMergeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performEntityMergeMutationMutation, { data, loading, error }] = usePerformEntityMergeMutationMutation({
 *   variables: {
 *      mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function usePerformEntityMergeMutationMutation(baseOptions?: Apollo.MutationHookOptions<PerformEntityMergeMutationMutation, PerformEntityMergeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformEntityMergeMutationMutation, PerformEntityMergeMutationMutationVariables>(PerformEntityMergeMutationDocument, options);
      }
export type PerformEntityMergeMutationMutationHookResult = ReturnType<typeof usePerformEntityMergeMutationMutation>;
export type PerformEntityMergeMutationMutationResult = Apollo.MutationResult<PerformEntityMergeMutationMutation>;
export type PerformEntityMergeMutationMutationOptions = Apollo.BaseMutationOptions<PerformEntityMergeMutationMutation, PerformEntityMergeMutationMutationVariables>;
export const AdminEntityMergeRequestDocument = gql`
    query AdminEntityMergeRequest($entityType: EntityTypeEnum!, $fromId: ID!, $intoId: ID!) {
  virtualMergeOverview(entityType: $entityType, fromId: $fromId, intoId: $intoId) {
    entityType
    status
    from {
      ...EntityMergeFragment
    }
    into {
      ...EntityMergeFragment
    }
    overview: mergeOverview {
      ...AdminEntityMergeItemFragment
    }
  }
}
    ${EntityMergeFragmentFragmentDoc}
${AdminEntityMergeItemFragmentFragmentDoc}`;

/**
 * __useAdminEntityMergeRequestQuery__
 *
 * To run a query within a React component, call `useAdminEntityMergeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityMergeRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityMergeRequestQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      fromId: // value for 'fromId'
 *      intoId: // value for 'intoId'
 *   },
 * });
 */
export function useAdminEntityMergeRequestQuery(baseOptions: Apollo.QueryHookOptions<AdminEntityMergeRequestQuery, AdminEntityMergeRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityMergeRequestQuery, AdminEntityMergeRequestQueryVariables>(AdminEntityMergeRequestDocument, options);
      }
export function useAdminEntityMergeRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityMergeRequestQuery, AdminEntityMergeRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityMergeRequestQuery, AdminEntityMergeRequestQueryVariables>(AdminEntityMergeRequestDocument, options);
        }
export type AdminEntityMergeRequestQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestQuery>;
export type AdminEntityMergeRequestLazyQueryHookResult = ReturnType<typeof useAdminEntityMergeRequestLazyQuery>;
export type AdminEntityMergeRequestQueryResult = Apollo.QueryResult<AdminEntityMergeRequestQuery, AdminEntityMergeRequestQueryVariables>;
export const PerformAutomaticMergesDocument = gql`
    mutation PerformAutomaticMerges($entityType: EntityTypeEnum!) {
  performAutomaticMerges(entityType: $entityType) {
    entityMergeId
  }
}
    `;
export type PerformAutomaticMergesMutationFn = Apollo.MutationFunction<PerformAutomaticMergesMutation, PerformAutomaticMergesMutationVariables>;

/**
 * __usePerformAutomaticMergesMutation__
 *
 * To run a mutation, you first call `usePerformAutomaticMergesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformAutomaticMergesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performAutomaticMergesMutation, { data, loading, error }] = usePerformAutomaticMergesMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function usePerformAutomaticMergesMutation(baseOptions?: Apollo.MutationHookOptions<PerformAutomaticMergesMutation, PerformAutomaticMergesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformAutomaticMergesMutation, PerformAutomaticMergesMutationVariables>(PerformAutomaticMergesDocument, options);
      }
export type PerformAutomaticMergesMutationHookResult = ReturnType<typeof usePerformAutomaticMergesMutation>;
export type PerformAutomaticMergesMutationResult = Apollo.MutationResult<PerformAutomaticMergesMutation>;
export type PerformAutomaticMergesMutationOptions = Apollo.BaseMutationOptions<PerformAutomaticMergesMutation, PerformAutomaticMergesMutationVariables>;
export const EntityMergeAdminOverviewQueryDocument = gql`
    query EntityMergeAdminOverviewQuery($entityType: EntityTypeEnum!) {
  handled: entityMerges(criteria: {entityType: $entityType, status: HANDLED}) {
    hash
    totalCount
  }
  unhandled: entityMerges(
    criteria: {entityType: $entityType, status: UNHANDLED, fetchSize: {limit: 5}}
  ) {
    hash
    totalCount
    nodes {
      id
      overview: mergeOverview {
        entityMergeId
        hasConflict
      }
      from {
        ...EntityFragment
      }
      into {
        ...EntityFragment
      }
    }
  }
}
    ${EntityFragmentFragmentDoc}`;

/**
 * __useEntityMergeAdminOverviewQueryQuery__
 *
 * To run a query within a React component, call `useEntityMergeAdminOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMergeAdminOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMergeAdminOverviewQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityMergeAdminOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityMergeAdminOverviewQueryQuery, EntityMergeAdminOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityMergeAdminOverviewQueryQuery, EntityMergeAdminOverviewQueryQueryVariables>(EntityMergeAdminOverviewQueryDocument, options);
      }
export function useEntityMergeAdminOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityMergeAdminOverviewQueryQuery, EntityMergeAdminOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityMergeAdminOverviewQueryQuery, EntityMergeAdminOverviewQueryQueryVariables>(EntityMergeAdminOverviewQueryDocument, options);
        }
export type EntityMergeAdminOverviewQueryQueryHookResult = ReturnType<typeof useEntityMergeAdminOverviewQueryQuery>;
export type EntityMergeAdminOverviewQueryLazyQueryHookResult = ReturnType<typeof useEntityMergeAdminOverviewQueryLazyQuery>;
export type EntityMergeAdminOverviewQueryQueryResult = Apollo.QueryResult<EntityMergeAdminOverviewQueryQuery, EntityMergeAdminOverviewQueryQueryVariables>;
export const ExternalIdAdminQueryDocument = gql`
    query ExternalIdAdminQuery($entityType: EntityTypeEnum!) {
  externalIdTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      heading
      isHeadingKey
      description
      externalIds {
        hash
        totalCount
      }
    }
  }
}
    `;

/**
 * __useExternalIdAdminQueryQuery__
 *
 * To run a query within a React component, call `useExternalIdAdminQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdAdminQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdAdminQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useExternalIdAdminQueryQuery(baseOptions: Apollo.QueryHookOptions<ExternalIdAdminQueryQuery, ExternalIdAdminQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdAdminQueryQuery, ExternalIdAdminQueryQueryVariables>(ExternalIdAdminQueryDocument, options);
      }
export function useExternalIdAdminQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdAdminQueryQuery, ExternalIdAdminQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdAdminQueryQuery, ExternalIdAdminQueryQueryVariables>(ExternalIdAdminQueryDocument, options);
        }
export type ExternalIdAdminQueryQueryHookResult = ReturnType<typeof useExternalIdAdminQueryQuery>;
export type ExternalIdAdminQueryLazyQueryHookResult = ReturnType<typeof useExternalIdAdminQueryLazyQuery>;
export type ExternalIdAdminQueryQueryResult = Apollo.QueryResult<ExternalIdAdminQueryQuery, ExternalIdAdminQueryQueryVariables>;
export const ExternalIdModalQueryDocument = gql`
    query ExternalIdModalQuery($code: String!) {
  roles {
    hash
    nodes {
      id
      heading
    }
  }
  externalIdType(code: $code) {
    code
    heading
    description
    allowDuplicateValues
    isDuplicateRuleAcrossCountries
    exceptionCountries {
      hash
      nodes {
        id
        country
        countryCode
      }
    }
    roleRules {
      hash
      nodes {
        id
        allowRead
        allowMutation
        role {
          id
          heading
          isAdminRole
        }
      }
    }
  }
}
    `;

/**
 * __useExternalIdModalQueryQuery__
 *
 * To run a query within a React component, call `useExternalIdModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdModalQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useExternalIdModalQueryQuery(baseOptions: Apollo.QueryHookOptions<ExternalIdModalQueryQuery, ExternalIdModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdModalQueryQuery, ExternalIdModalQueryQueryVariables>(ExternalIdModalQueryDocument, options);
      }
export function useExternalIdModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdModalQueryQuery, ExternalIdModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdModalQueryQuery, ExternalIdModalQueryQueryVariables>(ExternalIdModalQueryDocument, options);
        }
export type ExternalIdModalQueryQueryHookResult = ReturnType<typeof useExternalIdModalQueryQuery>;
export type ExternalIdModalQueryLazyQueryHookResult = ReturnType<typeof useExternalIdModalQueryLazyQuery>;
export type ExternalIdModalQueryQueryResult = Apollo.QueryResult<ExternalIdModalQueryQuery, ExternalIdModalQueryQueryVariables>;
export const AddExternalIdRoleDocument = gql`
    mutation AddExternalIdRole($externalIdTypeCode: String!, $roleId: Int!) {
  addExternalIdTypeRole(externalIdTypeCode: $externalIdTypeCode, roleId: $roleId) {
    id
  }
}
    `;
export type AddExternalIdRoleMutationFn = Apollo.MutationFunction<AddExternalIdRoleMutation, AddExternalIdRoleMutationVariables>;

/**
 * __useAddExternalIdRoleMutation__
 *
 * To run a mutation, you first call `useAddExternalIdRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalIdRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExternalIdRoleMutation, { data, loading, error }] = useAddExternalIdRoleMutation({
 *   variables: {
 *      externalIdTypeCode: // value for 'externalIdTypeCode'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useAddExternalIdRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddExternalIdRoleMutation, AddExternalIdRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExternalIdRoleMutation, AddExternalIdRoleMutationVariables>(AddExternalIdRoleDocument, options);
      }
export type AddExternalIdRoleMutationHookResult = ReturnType<typeof useAddExternalIdRoleMutation>;
export type AddExternalIdRoleMutationResult = Apollo.MutationResult<AddExternalIdRoleMutation>;
export type AddExternalIdRoleMutationOptions = Apollo.BaseMutationOptions<AddExternalIdRoleMutation, AddExternalIdRoleMutationVariables>;
export const RemoveExternalIdRoleDocument = gql`
    mutation RemoveExternalIdRole($externalIdTypeRoleId: Int!) {
  removeExternalIdTypeRole(externalIdTypeRoleId: $externalIdTypeRoleId)
}
    `;
export type RemoveExternalIdRoleMutationFn = Apollo.MutationFunction<RemoveExternalIdRoleMutation, RemoveExternalIdRoleMutationVariables>;

/**
 * __useRemoveExternalIdRoleMutation__
 *
 * To run a mutation, you first call `useRemoveExternalIdRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalIdRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExternalIdRoleMutation, { data, loading, error }] = useRemoveExternalIdRoleMutation({
 *   variables: {
 *      externalIdTypeRoleId: // value for 'externalIdTypeRoleId'
 *   },
 * });
 */
export function useRemoveExternalIdRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExternalIdRoleMutation, RemoveExternalIdRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExternalIdRoleMutation, RemoveExternalIdRoleMutationVariables>(RemoveExternalIdRoleDocument, options);
      }
export type RemoveExternalIdRoleMutationHookResult = ReturnType<typeof useRemoveExternalIdRoleMutation>;
export type RemoveExternalIdRoleMutationResult = Apollo.MutationResult<RemoveExternalIdRoleMutation>;
export type RemoveExternalIdRoleMutationOptions = Apollo.BaseMutationOptions<RemoveExternalIdRoleMutation, RemoveExternalIdRoleMutationVariables>;
export const UpdateExternalIdRoleDocument = gql`
    mutation UpdateExternalIdRole($externalIdTypeRoleId: Int!, $allowRead: Boolean!, $allowMutation: Boolean!) {
  setExternalIdTypeRoleRules(
    externalIdTypeRoleId: $externalIdTypeRoleId
    allowRead: $allowRead
    allowMutation: $allowMutation
  ) {
    id
    allowRead
    allowMutation
  }
}
    `;
export type UpdateExternalIdRoleMutationFn = Apollo.MutationFunction<UpdateExternalIdRoleMutation, UpdateExternalIdRoleMutationVariables>;

/**
 * __useUpdateExternalIdRoleMutation__
 *
 * To run a mutation, you first call `useUpdateExternalIdRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalIdRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalIdRoleMutation, { data, loading, error }] = useUpdateExternalIdRoleMutation({
 *   variables: {
 *      externalIdTypeRoleId: // value for 'externalIdTypeRoleId'
 *      allowRead: // value for 'allowRead'
 *      allowMutation: // value for 'allowMutation'
 *   },
 * });
 */
export function useUpdateExternalIdRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalIdRoleMutation, UpdateExternalIdRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalIdRoleMutation, UpdateExternalIdRoleMutationVariables>(UpdateExternalIdRoleDocument, options);
      }
export type UpdateExternalIdRoleMutationHookResult = ReturnType<typeof useUpdateExternalIdRoleMutation>;
export type UpdateExternalIdRoleMutationResult = Apollo.MutationResult<UpdateExternalIdRoleMutation>;
export type UpdateExternalIdRoleMutationOptions = Apollo.BaseMutationOptions<UpdateExternalIdRoleMutation, UpdateExternalIdRoleMutationVariables>;
export const CustomerSelectionQueryDocument = gql`
    query CustomerSelectionQuery($customerCode: String!) {
  selectionImfCustomers(criteria: {customerCode: $customerCode}) {
    hash
    nodes {
      code
      countryCode
      isActive
      selections {
        hash
        nodes {
          id
          description
          type
          groups {
            hash
            nodes {
              id
              description
              rows {
                hash
                nodes {
                  id
                  persons {
                    hash
                    totalCount
                  }
                  sites {
                    hash
                    totalCount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerSelectionQueryQuery__
 *
 * To run a query within a React component, call `useCustomerSelectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSelectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSelectionQueryQuery({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useCustomerSelectionQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomerSelectionQueryQuery, CustomerSelectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSelectionQueryQuery, CustomerSelectionQueryQueryVariables>(CustomerSelectionQueryDocument, options);
      }
export function useCustomerSelectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSelectionQueryQuery, CustomerSelectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSelectionQueryQuery, CustomerSelectionQueryQueryVariables>(CustomerSelectionQueryDocument, options);
        }
export type CustomerSelectionQueryQueryHookResult = ReturnType<typeof useCustomerSelectionQueryQuery>;
export type CustomerSelectionQueryLazyQueryHookResult = ReturnType<typeof useCustomerSelectionQueryLazyQuery>;
export type CustomerSelectionQueryQueryResult = Apollo.QueryResult<CustomerSelectionQueryQuery, CustomerSelectionQueryQueryVariables>;
export const InstanceDeploymentDetailsQueryDocument = gql`
    query InstanceDeploymentDetailsQuery($customerCode: String!) {
  pureAdvanceCustomer(customerCode: $customerCode) {
    code
    heading
  }
}
    `;

/**
 * __useInstanceDeploymentDetailsQueryQuery__
 *
 * To run a query within a React component, call `useInstanceDeploymentDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceDeploymentDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceDeploymentDetailsQueryQuery({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useInstanceDeploymentDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<InstanceDeploymentDetailsQueryQuery, InstanceDeploymentDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceDeploymentDetailsQueryQuery, InstanceDeploymentDetailsQueryQueryVariables>(InstanceDeploymentDetailsQueryDocument, options);
      }
export function useInstanceDeploymentDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceDeploymentDetailsQueryQuery, InstanceDeploymentDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceDeploymentDetailsQueryQuery, InstanceDeploymentDetailsQueryQueryVariables>(InstanceDeploymentDetailsQueryDocument, options);
        }
export type InstanceDeploymentDetailsQueryQueryHookResult = ReturnType<typeof useInstanceDeploymentDetailsQueryQuery>;
export type InstanceDeploymentDetailsQueryLazyQueryHookResult = ReturnType<typeof useInstanceDeploymentDetailsQueryLazyQuery>;
export type InstanceDeploymentDetailsQueryQueryResult = Apollo.QueryResult<InstanceDeploymentDetailsQueryQuery, InstanceDeploymentDetailsQueryQueryVariables>;
export const InstanceDeploymentQueryDocument = gql`
    query InstanceDeploymentQuery($criteria: PureAdvanceCustomerCriteria) {
  connection: pureAdvanceCustomers(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...InstanceDeploymentTableFragment
    }
  }
}
    ${InstanceDeploymentTableFragmentFragmentDoc}`;

/**
 * __useInstanceDeploymentQueryQuery__
 *
 * To run a query within a React component, call `useInstanceDeploymentQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceDeploymentQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceDeploymentQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useInstanceDeploymentQueryQuery(baseOptions?: Apollo.QueryHookOptions<InstanceDeploymentQueryQuery, InstanceDeploymentQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceDeploymentQueryQuery, InstanceDeploymentQueryQueryVariables>(InstanceDeploymentQueryDocument, options);
      }
export function useInstanceDeploymentQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceDeploymentQueryQuery, InstanceDeploymentQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceDeploymentQueryQuery, InstanceDeploymentQueryQueryVariables>(InstanceDeploymentQueryDocument, options);
        }
export type InstanceDeploymentQueryQueryHookResult = ReturnType<typeof useInstanceDeploymentQueryQuery>;
export type InstanceDeploymentQueryLazyQueryHookResult = ReturnType<typeof useInstanceDeploymentQueryLazyQuery>;
export type InstanceDeploymentQueryQueryResult = Apollo.QueryResult<InstanceDeploymentQueryQuery, InstanceDeploymentQueryQueryVariables>;
export const InstanceDeploymentRecordQueryDocument = gql`
    query InstanceDeploymentRecordQuery($recordId: String!) {
  record: pureAdvanceCustomer(customerCode: $recordId) {
    code
    ...InstanceDeploymentTableFragment
  }
}
    ${InstanceDeploymentTableFragmentFragmentDoc}`;

/**
 * __useInstanceDeploymentRecordQueryQuery__
 *
 * To run a query within a React component, call `useInstanceDeploymentRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceDeploymentRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceDeploymentRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useInstanceDeploymentRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<InstanceDeploymentRecordQueryQuery, InstanceDeploymentRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceDeploymentRecordQueryQuery, InstanceDeploymentRecordQueryQueryVariables>(InstanceDeploymentRecordQueryDocument, options);
      }
export function useInstanceDeploymentRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceDeploymentRecordQueryQuery, InstanceDeploymentRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceDeploymentRecordQueryQuery, InstanceDeploymentRecordQueryQueryVariables>(InstanceDeploymentRecordQueryDocument, options);
        }
export type InstanceDeploymentRecordQueryQueryHookResult = ReturnType<typeof useInstanceDeploymentRecordQueryQuery>;
export type InstanceDeploymentRecordQueryLazyQueryHookResult = ReturnType<typeof useInstanceDeploymentRecordQueryLazyQuery>;
export type InstanceDeploymentRecordQueryQueryResult = Apollo.QueryResult<InstanceDeploymentRecordQueryQuery, InstanceDeploymentRecordQueryQueryVariables>;
export const PureAdvanceCustomerProfileDocument = gql`
    query PureAdvanceCustomerProfile($customerCode: String!) {
  pureAdvanceModules {
    hash
    nodes {
      id
      name
      enum
      description
    }
  }
  pureAdvanceCustomer(customerCode: $customerCode) {
    code
    modules {
      hash
      nodes {
        id {
          customerCode
          moduleId
        }
        module {
          id
          name
          enum
          description
        }
      }
    }
  }
}
    `;

/**
 * __usePureAdvanceCustomerProfileQuery__
 *
 * To run a query within a React component, call `usePureAdvanceCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePureAdvanceCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePureAdvanceCustomerProfileQuery({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function usePureAdvanceCustomerProfileQuery(baseOptions: Apollo.QueryHookOptions<PureAdvanceCustomerProfileQuery, PureAdvanceCustomerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PureAdvanceCustomerProfileQuery, PureAdvanceCustomerProfileQueryVariables>(PureAdvanceCustomerProfileDocument, options);
      }
export function usePureAdvanceCustomerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PureAdvanceCustomerProfileQuery, PureAdvanceCustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PureAdvanceCustomerProfileQuery, PureAdvanceCustomerProfileQueryVariables>(PureAdvanceCustomerProfileDocument, options);
        }
export type PureAdvanceCustomerProfileQueryHookResult = ReturnType<typeof usePureAdvanceCustomerProfileQuery>;
export type PureAdvanceCustomerProfileLazyQueryHookResult = ReturnType<typeof usePureAdvanceCustomerProfileLazyQuery>;
export type PureAdvanceCustomerProfileQueryResult = Apollo.QueryResult<PureAdvanceCustomerProfileQuery, PureAdvanceCustomerProfileQueryVariables>;
export const UpdateCustomerModuleDocument = gql`
    mutation UpdateCustomerModule($customerCode: String!, $module: ModuleEnumType!, $enabled: Boolean!) {
  updatePureAdvanceCustomerModule(
    customerCode: $customerCode
    module: $module
    enabled: $enabled
  ) {
    code
    modules {
      hash
      nodes {
        id {
          customerCode
          moduleId
        }
        module {
          id
          name
          description
        }
      }
    }
  }
}
    `;
export type UpdateCustomerModuleMutationFn = Apollo.MutationFunction<UpdateCustomerModuleMutation, UpdateCustomerModuleMutationVariables>;

/**
 * __useUpdateCustomerModuleMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerModuleMutation, { data, loading, error }] = useUpdateCustomerModuleMutation({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *      module: // value for 'module'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateCustomerModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerModuleMutation, UpdateCustomerModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerModuleMutation, UpdateCustomerModuleMutationVariables>(UpdateCustomerModuleDocument, options);
      }
export type UpdateCustomerModuleMutationHookResult = ReturnType<typeof useUpdateCustomerModuleMutation>;
export type UpdateCustomerModuleMutationResult = Apollo.MutationResult<UpdateCustomerModuleMutation>;
export type UpdateCustomerModuleMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerModuleMutation, UpdateCustomerModuleMutationVariables>;
export const InstanceDeploymentSchedulesQueryDocument = gql`
    query InstanceDeploymentSchedulesQuery($customerCode: String!) {
  pureAdvanceCustomer(customerCode: $customerCode) {
    code
    heading
    dataSyncSchedule {
      ...ScheduleFragment
    }
    dcrSyncSchedule {
      ...ScheduleFragment
    }
  }
}
    ${ScheduleFragmentFragmentDoc}`;

/**
 * __useInstanceDeploymentSchedulesQueryQuery__
 *
 * To run a query within a React component, call `useInstanceDeploymentSchedulesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceDeploymentSchedulesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceDeploymentSchedulesQueryQuery({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useInstanceDeploymentSchedulesQueryQuery(baseOptions: Apollo.QueryHookOptions<InstanceDeploymentSchedulesQueryQuery, InstanceDeploymentSchedulesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceDeploymentSchedulesQueryQuery, InstanceDeploymentSchedulesQueryQueryVariables>(InstanceDeploymentSchedulesQueryDocument, options);
      }
export function useInstanceDeploymentSchedulesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceDeploymentSchedulesQueryQuery, InstanceDeploymentSchedulesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceDeploymentSchedulesQueryQuery, InstanceDeploymentSchedulesQueryQueryVariables>(InstanceDeploymentSchedulesQueryDocument, options);
        }
export type InstanceDeploymentSchedulesQueryQueryHookResult = ReturnType<typeof useInstanceDeploymentSchedulesQueryQuery>;
export type InstanceDeploymentSchedulesQueryLazyQueryHookResult = ReturnType<typeof useInstanceDeploymentSchedulesQueryLazyQuery>;
export type InstanceDeploymentSchedulesQueryQueryResult = Apollo.QueryResult<InstanceDeploymentSchedulesQueryQuery, InstanceDeploymentSchedulesQueryQueryVariables>;
export const ScheduleDcrSyncMutationDocument = gql`
    mutation ScheduleDcrSyncMutation($customerCode: String!) {
  runDcrSynchronization(customerCode: $customerCode)
}
    `;
export type ScheduleDcrSyncMutationMutationFn = Apollo.MutationFunction<ScheduleDcrSyncMutationMutation, ScheduleDcrSyncMutationMutationVariables>;

/**
 * __useScheduleDcrSyncMutationMutation__
 *
 * To run a mutation, you first call `useScheduleDcrSyncMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDcrSyncMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDcrSyncMutationMutation, { data, loading, error }] = useScheduleDcrSyncMutationMutation({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useScheduleDcrSyncMutationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDcrSyncMutationMutation, ScheduleDcrSyncMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDcrSyncMutationMutation, ScheduleDcrSyncMutationMutationVariables>(ScheduleDcrSyncMutationDocument, options);
      }
export type ScheduleDcrSyncMutationMutationHookResult = ReturnType<typeof useScheduleDcrSyncMutationMutation>;
export type ScheduleDcrSyncMutationMutationResult = Apollo.MutationResult<ScheduleDcrSyncMutationMutation>;
export type ScheduleDcrSyncMutationMutationOptions = Apollo.BaseMutationOptions<ScheduleDcrSyncMutationMutation, ScheduleDcrSyncMutationMutationVariables>;
export const ScheduleDataLoaderMutationDocument = gql`
    mutation ScheduleDataLoaderMutation($customerCode: String!) {
  runDataLoader(customerCode: $customerCode)
}
    `;
export type ScheduleDataLoaderMutationMutationFn = Apollo.MutationFunction<ScheduleDataLoaderMutationMutation, ScheduleDataLoaderMutationMutationVariables>;

/**
 * __useScheduleDataLoaderMutationMutation__
 *
 * To run a mutation, you first call `useScheduleDataLoaderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDataLoaderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDataLoaderMutationMutation, { data, loading, error }] = useScheduleDataLoaderMutationMutation({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useScheduleDataLoaderMutationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDataLoaderMutationMutation, ScheduleDataLoaderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDataLoaderMutationMutation, ScheduleDataLoaderMutationMutationVariables>(ScheduleDataLoaderMutationDocument, options);
      }
export type ScheduleDataLoaderMutationMutationHookResult = ReturnType<typeof useScheduleDataLoaderMutationMutation>;
export type ScheduleDataLoaderMutationMutationResult = Apollo.MutationResult<ScheduleDataLoaderMutationMutation>;
export type ScheduleDataLoaderMutationMutationOptions = Apollo.BaseMutationOptions<ScheduleDataLoaderMutationMutation, ScheduleDataLoaderMutationMutationVariables>;
export const UpdateInstanceDeploymentBoxSettingDocument = gql`
    mutation UpdateInstanceDeploymentBoxSetting($customerCode: String!, $value: String) {
  setPureAdvanceCustomerInstanceSetting(
    customerCode: $customerCode
    setting: DOWNLOAD_FILES_VIA_BOX
    value: $value
  ) {
    code
    downloadFilesViaBoxSetting: systemSetting(setting: DOWNLOAD_FILES_VIA_BOX)
  }
}
    `;
export type UpdateInstanceDeploymentBoxSettingMutationFn = Apollo.MutationFunction<UpdateInstanceDeploymentBoxSettingMutation, UpdateInstanceDeploymentBoxSettingMutationVariables>;

/**
 * __useUpdateInstanceDeploymentBoxSettingMutation__
 *
 * To run a mutation, you first call `useUpdateInstanceDeploymentBoxSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstanceDeploymentBoxSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstanceDeploymentBoxSettingMutation, { data, loading, error }] = useUpdateInstanceDeploymentBoxSettingMutation({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateInstanceDeploymentBoxSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstanceDeploymentBoxSettingMutation, UpdateInstanceDeploymentBoxSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstanceDeploymentBoxSettingMutation, UpdateInstanceDeploymentBoxSettingMutationVariables>(UpdateInstanceDeploymentBoxSettingDocument, options);
      }
export type UpdateInstanceDeploymentBoxSettingMutationHookResult = ReturnType<typeof useUpdateInstanceDeploymentBoxSettingMutation>;
export type UpdateInstanceDeploymentBoxSettingMutationResult = Apollo.MutationResult<UpdateInstanceDeploymentBoxSettingMutation>;
export type UpdateInstanceDeploymentBoxSettingMutationOptions = Apollo.BaseMutationOptions<UpdateInstanceDeploymentBoxSettingMutation, UpdateInstanceDeploymentBoxSettingMutationVariables>;
export const InstanceDeploymentProfileDocument = gql`
    query InstanceDeploymentProfile($customerCode: String!) {
  pureAdvanceCustomer(customerCode: $customerCode) {
    code
    heading
    downloadFilesViaBoxSetting: systemSetting(setting: DOWNLOAD_FILES_VIA_BOX)
  }
}
    `;

/**
 * __useInstanceDeploymentProfileQuery__
 *
 * To run a query within a React component, call `useInstanceDeploymentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceDeploymentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceDeploymentProfileQuery({
 *   variables: {
 *      customerCode: // value for 'customerCode'
 *   },
 * });
 */
export function useInstanceDeploymentProfileQuery(baseOptions: Apollo.QueryHookOptions<InstanceDeploymentProfileQuery, InstanceDeploymentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceDeploymentProfileQuery, InstanceDeploymentProfileQueryVariables>(InstanceDeploymentProfileDocument, options);
      }
export function useInstanceDeploymentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceDeploymentProfileQuery, InstanceDeploymentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceDeploymentProfileQuery, InstanceDeploymentProfileQueryVariables>(InstanceDeploymentProfileDocument, options);
        }
export type InstanceDeploymentProfileQueryHookResult = ReturnType<typeof useInstanceDeploymentProfileQuery>;
export type InstanceDeploymentProfileLazyQueryHookResult = ReturnType<typeof useInstanceDeploymentProfileLazyQuery>;
export type InstanceDeploymentProfileQueryResult = Apollo.QueryResult<InstanceDeploymentProfileQuery, InstanceDeploymentProfileQueryVariables>;
export const JiraVersionReleaseNotesQueryDocument = gql`
    query JiraVersionReleaseNotesQuery($version: String!) {
  jiraIssues(version: $version) {
    total
    issues {
      key
      self
      fields {
        summary
        issuetype {
          id
          name
          iconUrl
        }
      }
    }
  }
}
    `;

/**
 * __useJiraVersionReleaseNotesQueryQuery__
 *
 * To run a query within a React component, call `useJiraVersionReleaseNotesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useJiraVersionReleaseNotesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJiraVersionReleaseNotesQueryQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useJiraVersionReleaseNotesQueryQuery(baseOptions: Apollo.QueryHookOptions<JiraVersionReleaseNotesQueryQuery, JiraVersionReleaseNotesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JiraVersionReleaseNotesQueryQuery, JiraVersionReleaseNotesQueryQueryVariables>(JiraVersionReleaseNotesQueryDocument, options);
      }
export function useJiraVersionReleaseNotesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JiraVersionReleaseNotesQueryQuery, JiraVersionReleaseNotesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JiraVersionReleaseNotesQueryQuery, JiraVersionReleaseNotesQueryQueryVariables>(JiraVersionReleaseNotesQueryDocument, options);
        }
export type JiraVersionReleaseNotesQueryQueryHookResult = ReturnType<typeof useJiraVersionReleaseNotesQueryQuery>;
export type JiraVersionReleaseNotesQueryLazyQueryHookResult = ReturnType<typeof useJiraVersionReleaseNotesQueryLazyQuery>;
export type JiraVersionReleaseNotesQueryQueryResult = Apollo.QueryResult<JiraVersionReleaseNotesQueryQuery, JiraVersionReleaseNotesQueryQueryVariables>;
export const PureAdvanceReleasesQueryDocument = gql`
    query PureAdvanceReleasesQuery($limit: Int!, $offset: Int!) {
  releases(criteria: {limit: $limit, offset: $offset}) {
    self
    total
    values {
      id
      version: name
      description
      releaseDate
    }
  }
}
    `;

/**
 * __usePureAdvanceReleasesQueryQuery__
 *
 * To run a query within a React component, call `usePureAdvanceReleasesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePureAdvanceReleasesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePureAdvanceReleasesQueryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function usePureAdvanceReleasesQueryQuery(baseOptions: Apollo.QueryHookOptions<PureAdvanceReleasesQueryQuery, PureAdvanceReleasesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PureAdvanceReleasesQueryQuery, PureAdvanceReleasesQueryQueryVariables>(PureAdvanceReleasesQueryDocument, options);
      }
export function usePureAdvanceReleasesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PureAdvanceReleasesQueryQuery, PureAdvanceReleasesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PureAdvanceReleasesQueryQuery, PureAdvanceReleasesQueryQueryVariables>(PureAdvanceReleasesQueryDocument, options);
        }
export type PureAdvanceReleasesQueryQueryHookResult = ReturnType<typeof usePureAdvanceReleasesQueryQuery>;
export type PureAdvanceReleasesQueryLazyQueryHookResult = ReturnType<typeof usePureAdvanceReleasesQueryLazyQuery>;
export type PureAdvanceReleasesQueryQueryResult = Apollo.QueryResult<PureAdvanceReleasesQueryQuery, PureAdvanceReleasesQueryQueryVariables>;
export const CreateCustomSelectFieldMutationDocument = gql`
    mutation CreateCustomSelectFieldMutation($input: CreateCustomFieldInput!) {
  createCustomField(input: $input) {
    code
    heading
  }
}
    `;
export type CreateCustomSelectFieldMutationMutationFn = Apollo.MutationFunction<CreateCustomSelectFieldMutationMutation, CreateCustomSelectFieldMutationMutationVariables>;

/**
 * __useCreateCustomSelectFieldMutationMutation__
 *
 * To run a mutation, you first call `useCreateCustomSelectFieldMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomSelectFieldMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomSelectFieldMutationMutation, { data, loading, error }] = useCreateCustomSelectFieldMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomSelectFieldMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomSelectFieldMutationMutation, CreateCustomSelectFieldMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomSelectFieldMutationMutation, CreateCustomSelectFieldMutationMutationVariables>(CreateCustomSelectFieldMutationDocument, options);
      }
export type CreateCustomSelectFieldMutationMutationHookResult = ReturnType<typeof useCreateCustomSelectFieldMutationMutation>;
export type CreateCustomSelectFieldMutationMutationResult = Apollo.MutationResult<CreateCustomSelectFieldMutationMutation>;
export type CreateCustomSelectFieldMutationMutationOptions = Apollo.BaseMutationOptions<CreateCustomSelectFieldMutationMutation, CreateCustomSelectFieldMutationMutationVariables>;
export const UpdateCustomSelectFieldMutationDocument = gql`
    mutation UpdateCustomSelectFieldMutation($input: UpdateCustomFieldInput!) {
  updateCustomField(input: $input) {
    code
    heading
  }
}
    `;
export type UpdateCustomSelectFieldMutationMutationFn = Apollo.MutationFunction<UpdateCustomSelectFieldMutationMutation, UpdateCustomSelectFieldMutationMutationVariables>;

/**
 * __useUpdateCustomSelectFieldMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomSelectFieldMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomSelectFieldMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomSelectFieldMutationMutation, { data, loading, error }] = useUpdateCustomSelectFieldMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomSelectFieldMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomSelectFieldMutationMutation, UpdateCustomSelectFieldMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomSelectFieldMutationMutation, UpdateCustomSelectFieldMutationMutationVariables>(UpdateCustomSelectFieldMutationDocument, options);
      }
export type UpdateCustomSelectFieldMutationMutationHookResult = ReturnType<typeof useUpdateCustomSelectFieldMutationMutation>;
export type UpdateCustomSelectFieldMutationMutationResult = Apollo.MutationResult<UpdateCustomSelectFieldMutationMutation>;
export type UpdateCustomSelectFieldMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomSelectFieldMutationMutation, UpdateCustomSelectFieldMutationMutationVariables>;
export const UpdateCustomFieldQueryDocument = gql`
    query UpdateCustomFieldQuery($customFieldCode: String!) {
  customField(code: $customFieldCode) {
    code
    heading
    color
    isActive
    allowMultiple
    allowUserCreate
    isCheckableTag
    allowCountrySpecificValues
    entityTypeEnum
    fieldType {
      code
      enum
    }
    fieldGridConfigurations {
      hash
      totalCount
    }
    options(criteria: {fetchSize: {limit: null}}) {
      hash
      nodes {
        id
        selectedCountries(criteria: {fetchSize: {limit: null}}) {
          hash
          nodes {
            id
            country
          }
        }
        relations {
          hash
          totalCount
        }
        value {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useUpdateCustomFieldQueryQuery__
 *
 * To run a query within a React component, call `useUpdateCustomFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCustomFieldQueryQuery({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *   },
 * });
 */
export function useUpdateCustomFieldQueryQuery(baseOptions: Apollo.QueryHookOptions<UpdateCustomFieldQueryQuery, UpdateCustomFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCustomFieldQueryQuery, UpdateCustomFieldQueryQueryVariables>(UpdateCustomFieldQueryDocument, options);
      }
export function useUpdateCustomFieldQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCustomFieldQueryQuery, UpdateCustomFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCustomFieldQueryQuery, UpdateCustomFieldQueryQueryVariables>(UpdateCustomFieldQueryDocument, options);
        }
export type UpdateCustomFieldQueryQueryHookResult = ReturnType<typeof useUpdateCustomFieldQueryQuery>;
export type UpdateCustomFieldQueryLazyQueryHookResult = ReturnType<typeof useUpdateCustomFieldQueryLazyQuery>;
export type UpdateCustomFieldQueryQueryResult = Apollo.QueryResult<UpdateCustomFieldQueryQuery, UpdateCustomFieldQueryQueryVariables>;
export const CustomFieldPermissionQueryDocument = gql`
    query CustomFieldPermissionQuery($customFieldCode: String!) {
  customField(code: $customFieldCode) {
    code
    accessRules {
      hash
      nodes {
        id
        allowRead
        allowMutation
        roleId
      }
    }
  }
}
    `;

/**
 * __useCustomFieldPermissionQueryQuery__
 *
 * To run a query within a React component, call `useCustomFieldPermissionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldPermissionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldPermissionQueryQuery({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *   },
 * });
 */
export function useCustomFieldPermissionQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldPermissionQueryQuery, CustomFieldPermissionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldPermissionQueryQuery, CustomFieldPermissionQueryQueryVariables>(CustomFieldPermissionQueryDocument, options);
      }
export function useCustomFieldPermissionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldPermissionQueryQuery, CustomFieldPermissionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldPermissionQueryQuery, CustomFieldPermissionQueryQueryVariables>(CustomFieldPermissionQueryDocument, options);
        }
export type CustomFieldPermissionQueryQueryHookResult = ReturnType<typeof useCustomFieldPermissionQueryQuery>;
export type CustomFieldPermissionQueryLazyQueryHookResult = ReturnType<typeof useCustomFieldPermissionQueryLazyQuery>;
export type CustomFieldPermissionQueryQueryResult = Apollo.QueryResult<CustomFieldPermissionQueryQuery, CustomFieldPermissionQueryQueryVariables>;
export const CustomFieldPermissionRolesQueryDocument = gql`
    query CustomFieldPermissionRolesQuery($search: String) {
  roles(criteria: {heading: $search}) {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useCustomFieldPermissionRolesQueryQuery__
 *
 * To run a query within a React component, call `useCustomFieldPermissionRolesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldPermissionRolesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldPermissionRolesQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCustomFieldPermissionRolesQueryQuery(baseOptions?: Apollo.QueryHookOptions<CustomFieldPermissionRolesQueryQuery, CustomFieldPermissionRolesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldPermissionRolesQueryQuery, CustomFieldPermissionRolesQueryQueryVariables>(CustomFieldPermissionRolesQueryDocument, options);
      }
export function useCustomFieldPermissionRolesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldPermissionRolesQueryQuery, CustomFieldPermissionRolesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldPermissionRolesQueryQuery, CustomFieldPermissionRolesQueryQueryVariables>(CustomFieldPermissionRolesQueryDocument, options);
        }
export type CustomFieldPermissionRolesQueryQueryHookResult = ReturnType<typeof useCustomFieldPermissionRolesQueryQuery>;
export type CustomFieldPermissionRolesQueryLazyQueryHookResult = ReturnType<typeof useCustomFieldPermissionRolesQueryLazyQuery>;
export type CustomFieldPermissionRolesQueryQueryResult = Apollo.QueryResult<CustomFieldPermissionRolesQueryQuery, CustomFieldPermissionRolesQueryQueryVariables>;
export const CreateCustomFieldRoleMutationDocument = gql`
    mutation CreateCustomFieldRoleMutation($customFieldCode: String!, $roleId: Int!) {
  addRoleToCustomField(customFieldCode: $customFieldCode, roleId: $roleId) {
    id
  }
}
    `;
export type CreateCustomFieldRoleMutationMutationFn = Apollo.MutationFunction<CreateCustomFieldRoleMutationMutation, CreateCustomFieldRoleMutationMutationVariables>;

/**
 * __useCreateCustomFieldRoleMutationMutation__
 *
 * To run a mutation, you first call `useCreateCustomFieldRoleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomFieldRoleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomFieldRoleMutationMutation, { data, loading, error }] = useCreateCustomFieldRoleMutationMutation({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useCreateCustomFieldRoleMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomFieldRoleMutationMutation, CreateCustomFieldRoleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomFieldRoleMutationMutation, CreateCustomFieldRoleMutationMutationVariables>(CreateCustomFieldRoleMutationDocument, options);
      }
export type CreateCustomFieldRoleMutationMutationHookResult = ReturnType<typeof useCreateCustomFieldRoleMutationMutation>;
export type CreateCustomFieldRoleMutationMutationResult = Apollo.MutationResult<CreateCustomFieldRoleMutationMutation>;
export type CreateCustomFieldRoleMutationMutationOptions = Apollo.BaseMutationOptions<CreateCustomFieldRoleMutationMutation, CreateCustomFieldRoleMutationMutationVariables>;
export const UpdateCustomFieldRoleMutationDocument = gql`
    mutation UpdateCustomFieldRoleMutation($fieldRoleId: Int!, $read: Boolean, $mutation: Boolean) {
  updateCustomFieldRoleRules(
    fieldRoleId: $fieldRoleId
    allowRead: $read
    allowMutation: $mutation
  ) {
    id
    allowMutation
    allowRead
  }
}
    `;
export type UpdateCustomFieldRoleMutationMutationFn = Apollo.MutationFunction<UpdateCustomFieldRoleMutationMutation, UpdateCustomFieldRoleMutationMutationVariables>;

/**
 * __useUpdateCustomFieldRoleMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldRoleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldRoleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldRoleMutationMutation, { data, loading, error }] = useUpdateCustomFieldRoleMutationMutation({
 *   variables: {
 *      fieldRoleId: // value for 'fieldRoleId'
 *      read: // value for 'read'
 *      mutation: // value for 'mutation'
 *   },
 * });
 */
export function useUpdateCustomFieldRoleMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldRoleMutationMutation, UpdateCustomFieldRoleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldRoleMutationMutation, UpdateCustomFieldRoleMutationMutationVariables>(UpdateCustomFieldRoleMutationDocument, options);
      }
export type UpdateCustomFieldRoleMutationMutationHookResult = ReturnType<typeof useUpdateCustomFieldRoleMutationMutation>;
export type UpdateCustomFieldRoleMutationMutationResult = Apollo.MutationResult<UpdateCustomFieldRoleMutationMutation>;
export type UpdateCustomFieldRoleMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldRoleMutationMutation, UpdateCustomFieldRoleMutationMutationVariables>;
export const RemoveCustomFieldRoleMutationDocument = gql`
    mutation RemoveCustomFieldRoleMutation($fieldRoleId: Int!) {
  removeRoleFromCustomField(fieldRoleId: $fieldRoleId)
}
    `;
export type RemoveCustomFieldRoleMutationMutationFn = Apollo.MutationFunction<RemoveCustomFieldRoleMutationMutation, RemoveCustomFieldRoleMutationMutationVariables>;

/**
 * __useRemoveCustomFieldRoleMutationMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldRoleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldRoleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldRoleMutationMutation, { data, loading, error }] = useRemoveCustomFieldRoleMutationMutation({
 *   variables: {
 *      fieldRoleId: // value for 'fieldRoleId'
 *   },
 * });
 */
export function useRemoveCustomFieldRoleMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldRoleMutationMutation, RemoveCustomFieldRoleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldRoleMutationMutation, RemoveCustomFieldRoleMutationMutationVariables>(RemoveCustomFieldRoleMutationDocument, options);
      }
export type RemoveCustomFieldRoleMutationMutationHookResult = ReturnType<typeof useRemoveCustomFieldRoleMutationMutation>;
export type RemoveCustomFieldRoleMutationMutationResult = Apollo.MutationResult<RemoveCustomFieldRoleMutationMutation>;
export type RemoveCustomFieldRoleMutationMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldRoleMutationMutation, RemoveCustomFieldRoleMutationMutationVariables>;
export const CustomFieldUsageOverviewQueryDocument = gql`
    query CustomFieldUsageOverviewQuery($customFieldCode: String!) {
  customField(code: $customFieldCode) {
    code
    fieldGridConfigurations {
      hash
      nodes {
        id
        fieldConfig {
          id
          itemConfiguration {
            id
            heading
            tab {
              code
              headingKey
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCustomFieldUsageOverviewQueryQuery__
 *
 * To run a query within a React component, call `useCustomFieldUsageOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldUsageOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldUsageOverviewQueryQuery({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *   },
 * });
 */
export function useCustomFieldUsageOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldUsageOverviewQueryQuery, CustomFieldUsageOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldUsageOverviewQueryQuery, CustomFieldUsageOverviewQueryQueryVariables>(CustomFieldUsageOverviewQueryDocument, options);
      }
export function useCustomFieldUsageOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldUsageOverviewQueryQuery, CustomFieldUsageOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldUsageOverviewQueryQuery, CustomFieldUsageOverviewQueryQueryVariables>(CustomFieldUsageOverviewQueryDocument, options);
        }
export type CustomFieldUsageOverviewQueryQueryHookResult = ReturnType<typeof useCustomFieldUsageOverviewQueryQuery>;
export type CustomFieldUsageOverviewQueryLazyQueryHookResult = ReturnType<typeof useCustomFieldUsageOverviewQueryLazyQuery>;
export type CustomFieldUsageOverviewQueryQueryResult = Apollo.QueryResult<CustomFieldUsageOverviewQueryQuery, CustomFieldUsageOverviewQueryQueryVariables>;
export const ActivityTypesForConfigurationDocument = gql`
    query ActivityTypesForConfiguration($includeActive: ActiveEnum!) {
  activitySuperTypes {
    hash
    nodes {
      code
      heading
      types(criteria: {isActive: $includeActive}) {
        hash
        totalCount
        nodes {
          ...ActivityTypeMutationFragment
        }
      }
    }
  }
}
    ${ActivityTypeMutationFragmentFragmentDoc}`;

/**
 * __useActivityTypesForConfigurationQuery__
 *
 * To run a query within a React component, call `useActivityTypesForConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypesForConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTypesForConfigurationQuery({
 *   variables: {
 *      includeActive: // value for 'includeActive'
 *   },
 * });
 */
export function useActivityTypesForConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ActivityTypesForConfigurationQuery, ActivityTypesForConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityTypesForConfigurationQuery, ActivityTypesForConfigurationQueryVariables>(ActivityTypesForConfigurationDocument, options);
      }
export function useActivityTypesForConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityTypesForConfigurationQuery, ActivityTypesForConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityTypesForConfigurationQuery, ActivityTypesForConfigurationQueryVariables>(ActivityTypesForConfigurationDocument, options);
        }
export type ActivityTypesForConfigurationQueryHookResult = ReturnType<typeof useActivityTypesForConfigurationQuery>;
export type ActivityTypesForConfigurationLazyQueryHookResult = ReturnType<typeof useActivityTypesForConfigurationLazyQuery>;
export type ActivityTypesForConfigurationQueryResult = Apollo.QueryResult<ActivityTypesForConfigurationQuery, ActivityTypesForConfigurationQueryVariables>;
export const UpdateActivityTypeMutationDocument = gql`
    mutation UpdateActivityTypeMutation($typeCode: String!, $input: UpdateActivityTypeInput!) {
  updateActivityType(typeCode: $typeCode, input: $input) {
    ...ActivityTypeMutationFragment
  }
}
    ${ActivityTypeMutationFragmentFragmentDoc}`;
export type UpdateActivityTypeMutationMutationFn = Apollo.MutationFunction<UpdateActivityTypeMutationMutation, UpdateActivityTypeMutationMutationVariables>;

/**
 * __useUpdateActivityTypeMutationMutation__
 *
 * To run a mutation, you first call `useUpdateActivityTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityTypeMutationMutation, { data, loading, error }] = useUpdateActivityTypeMutationMutation({
 *   variables: {
 *      typeCode: // value for 'typeCode'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActivityTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityTypeMutationMutation, UpdateActivityTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityTypeMutationMutation, UpdateActivityTypeMutationMutationVariables>(UpdateActivityTypeMutationDocument, options);
      }
export type UpdateActivityTypeMutationMutationHookResult = ReturnType<typeof useUpdateActivityTypeMutationMutation>;
export type UpdateActivityTypeMutationMutationResult = Apollo.MutationResult<UpdateActivityTypeMutationMutation>;
export type UpdateActivityTypeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateActivityTypeMutationMutation, UpdateActivityTypeMutationMutationVariables>;
export const ConfigureCustomFieldsActivityTypeDocument = gql`
    query ConfigureCustomFieldsActivityType($search: String) {
  customFields(criteria: {heading: $search, entityType: ACTIVITY}) {
    hash
    nodes {
      code
      heading
    }
  }
}
    `;

/**
 * __useConfigureCustomFieldsActivityTypeQuery__
 *
 * To run a query within a React component, call `useConfigureCustomFieldsActivityTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureCustomFieldsActivityTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureCustomFieldsActivityTypeQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useConfigureCustomFieldsActivityTypeQuery(baseOptions?: Apollo.QueryHookOptions<ConfigureCustomFieldsActivityTypeQuery, ConfigureCustomFieldsActivityTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigureCustomFieldsActivityTypeQuery, ConfigureCustomFieldsActivityTypeQueryVariables>(ConfigureCustomFieldsActivityTypeDocument, options);
      }
export function useConfigureCustomFieldsActivityTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigureCustomFieldsActivityTypeQuery, ConfigureCustomFieldsActivityTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigureCustomFieldsActivityTypeQuery, ConfigureCustomFieldsActivityTypeQueryVariables>(ConfigureCustomFieldsActivityTypeDocument, options);
        }
export type ConfigureCustomFieldsActivityTypeQueryHookResult = ReturnType<typeof useConfigureCustomFieldsActivityTypeQuery>;
export type ConfigureCustomFieldsActivityTypeLazyQueryHookResult = ReturnType<typeof useConfigureCustomFieldsActivityTypeLazyQuery>;
export type ConfigureCustomFieldsActivityTypeQueryResult = Apollo.QueryResult<ConfigureCustomFieldsActivityTypeQuery, ConfigureCustomFieldsActivityTypeQueryVariables>;
export const SetCustomFieldsToActivityTypeDocument = gql`
    mutation SetCustomFieldsToActivityType($activityTypeCode: String!, $customFieldCodes: [String!]!) {
  setCustomFieldsToActivityType(
    activityTypeCode: $activityTypeCode
    customFieldCodes: $customFieldCodes
  ) {
    code
    ...ActivityTypeMutationFragment
  }
}
    ${ActivityTypeMutationFragmentFragmentDoc}`;
export type SetCustomFieldsToActivityTypeMutationFn = Apollo.MutationFunction<SetCustomFieldsToActivityTypeMutation, SetCustomFieldsToActivityTypeMutationVariables>;

/**
 * __useSetCustomFieldsToActivityTypeMutation__
 *
 * To run a mutation, you first call `useSetCustomFieldsToActivityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomFieldsToActivityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomFieldsToActivityTypeMutation, { data, loading, error }] = useSetCustomFieldsToActivityTypeMutation({
 *   variables: {
 *      activityTypeCode: // value for 'activityTypeCode'
 *      customFieldCodes: // value for 'customFieldCodes'
 *   },
 * });
 */
export function useSetCustomFieldsToActivityTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomFieldsToActivityTypeMutation, SetCustomFieldsToActivityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomFieldsToActivityTypeMutation, SetCustomFieldsToActivityTypeMutationVariables>(SetCustomFieldsToActivityTypeDocument, options);
      }
export type SetCustomFieldsToActivityTypeMutationHookResult = ReturnType<typeof useSetCustomFieldsToActivityTypeMutation>;
export type SetCustomFieldsToActivityTypeMutationResult = Apollo.MutationResult<SetCustomFieldsToActivityTypeMutation>;
export type SetCustomFieldsToActivityTypeMutationOptions = Apollo.BaseMutationOptions<SetCustomFieldsToActivityTypeMutation, SetCustomFieldsToActivityTypeMutationVariables>;
export const ConfigureFieldDaysQueryDocument = gql`
    query ConfigureFieldDaysQuery($country: CountryCode!, $year: Year!) {
  activityFieldDaysInYear(country: $country, year: $year) {
    id
    country
    month
    year
    count
  }
}
    `;

/**
 * __useConfigureFieldDaysQueryQuery__
 *
 * To run a query within a React component, call `useConfigureFieldDaysQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigureFieldDaysQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigureFieldDaysQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useConfigureFieldDaysQueryQuery(baseOptions: Apollo.QueryHookOptions<ConfigureFieldDaysQueryQuery, ConfigureFieldDaysQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigureFieldDaysQueryQuery, ConfigureFieldDaysQueryQueryVariables>(ConfigureFieldDaysQueryDocument, options);
      }
export function useConfigureFieldDaysQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigureFieldDaysQueryQuery, ConfigureFieldDaysQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigureFieldDaysQueryQuery, ConfigureFieldDaysQueryQueryVariables>(ConfigureFieldDaysQueryDocument, options);
        }
export type ConfigureFieldDaysQueryQueryHookResult = ReturnType<typeof useConfigureFieldDaysQueryQuery>;
export type ConfigureFieldDaysQueryLazyQueryHookResult = ReturnType<typeof useConfigureFieldDaysQueryLazyQuery>;
export type ConfigureFieldDaysQueryQueryResult = Apollo.QueryResult<ConfigureFieldDaysQueryQuery, ConfigureFieldDaysQueryQueryVariables>;
export const UpdateFieldDaysMutationDocument = gql`
    mutation UpdateFieldDaysMutation($country: CountryCode!, $year: Year!, $month: Month!, $count: Int!) {
  updateActivityFieldDaysInMonth(
    country: $country
    year: $year
    month: $month
    count: $count
  ) {
    id
    count
  }
}
    `;
export type UpdateFieldDaysMutationMutationFn = Apollo.MutationFunction<UpdateFieldDaysMutationMutation, UpdateFieldDaysMutationMutationVariables>;

/**
 * __useUpdateFieldDaysMutationMutation__
 *
 * To run a mutation, you first call `useUpdateFieldDaysMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldDaysMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldDaysMutationMutation, { data, loading, error }] = useUpdateFieldDaysMutationMutation({
 *   variables: {
 *      country: // value for 'country'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useUpdateFieldDaysMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFieldDaysMutationMutation, UpdateFieldDaysMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFieldDaysMutationMutation, UpdateFieldDaysMutationMutationVariables>(UpdateFieldDaysMutationDocument, options);
      }
export type UpdateFieldDaysMutationMutationHookResult = ReturnType<typeof useUpdateFieldDaysMutationMutation>;
export type UpdateFieldDaysMutationMutationResult = Apollo.MutationResult<UpdateFieldDaysMutationMutation>;
export type UpdateFieldDaysMutationMutationOptions = Apollo.BaseMutationOptions<UpdateFieldDaysMutationMutation, UpdateFieldDaysMutationMutationVariables>;
export const MassAssignSettingsQueryDocument = gql`
    query MassAssignSettingsQuery($type: InstanceSettingEnum!) {
  instanceSetting(type: $type) {
    code
    value
  }
}
    `;

/**
 * __useMassAssignSettingsQueryQuery__
 *
 * To run a query within a React component, call `useMassAssignSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassAssignSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassAssignSettingsQueryQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMassAssignSettingsQueryQuery(baseOptions: Apollo.QueryHookOptions<MassAssignSettingsQueryQuery, MassAssignSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassAssignSettingsQueryQuery, MassAssignSettingsQueryQueryVariables>(MassAssignSettingsQueryDocument, options);
      }
export function useMassAssignSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassAssignSettingsQueryQuery, MassAssignSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassAssignSettingsQueryQuery, MassAssignSettingsQueryQueryVariables>(MassAssignSettingsQueryDocument, options);
        }
export type MassAssignSettingsQueryQueryHookResult = ReturnType<typeof useMassAssignSettingsQueryQuery>;
export type MassAssignSettingsQueryLazyQueryHookResult = ReturnType<typeof useMassAssignSettingsQueryLazyQuery>;
export type MassAssignSettingsQueryQueryResult = Apollo.QueryResult<MassAssignSettingsQueryQuery, MassAssignSettingsQueryQueryVariables>;
export const UpdateMassAssignSettingDocument = gql`
    mutation UpdateMassAssignSetting($type: InstanceSettingEnum!, $newValue: String!) {
  updateInstanceSetting(type: $type, newValue: $newValue) {
    code
    value
  }
}
    `;
export type UpdateMassAssignSettingMutationFn = Apollo.MutationFunction<UpdateMassAssignSettingMutation, UpdateMassAssignSettingMutationVariables>;

/**
 * __useUpdateMassAssignSettingMutation__
 *
 * To run a mutation, you first call `useUpdateMassAssignSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMassAssignSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMassAssignSettingMutation, { data, loading, error }] = useUpdateMassAssignSettingMutation({
 *   variables: {
 *      type: // value for 'type'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateMassAssignSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMassAssignSettingMutation, UpdateMassAssignSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMassAssignSettingMutation, UpdateMassAssignSettingMutationVariables>(UpdateMassAssignSettingDocument, options);
      }
export type UpdateMassAssignSettingMutationHookResult = ReturnType<typeof useUpdateMassAssignSettingMutation>;
export type UpdateMassAssignSettingMutationResult = Apollo.MutationResult<UpdateMassAssignSettingMutation>;
export type UpdateMassAssignSettingMutationOptions = Apollo.BaseMutationOptions<UpdateMassAssignSettingMutation, UpdateMassAssignSettingMutationVariables>;
export const SegmentationSettingsQueryDocument = gql`
    query SegmentationSettingsQuery {
  person: instanceSetting(type: PERSON_SEGMENTATION) {
    code
    value
  }
  product: instanceSetting(type: PRODUCT_SEGMENTATION) {
    code
    value
  }
  allowMultipleProducts: instanceSetting(type: PRODUCT_SEGMENTATION_MULTIPLE) {
    code
    value
  }
}
    `;

/**
 * __useSegmentationSettingsQueryQuery__
 *
 * To run a query within a React component, call `useSegmentationSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentationSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentationSettingsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentationSettingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SegmentationSettingsQueryQuery, SegmentationSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentationSettingsQueryQuery, SegmentationSettingsQueryQueryVariables>(SegmentationSettingsQueryDocument, options);
      }
export function useSegmentationSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentationSettingsQueryQuery, SegmentationSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentationSettingsQueryQuery, SegmentationSettingsQueryQueryVariables>(SegmentationSettingsQueryDocument, options);
        }
export type SegmentationSettingsQueryQueryHookResult = ReturnType<typeof useSegmentationSettingsQueryQuery>;
export type SegmentationSettingsQueryLazyQueryHookResult = ReturnType<typeof useSegmentationSettingsQueryLazyQuery>;
export type SegmentationSettingsQueryQueryResult = Apollo.QueryResult<SegmentationSettingsQueryQuery, SegmentationSettingsQueryQueryVariables>;
export const UpdateSegmentationSettingDocument = gql`
    mutation UpdateSegmentationSetting($type: InstanceSettingEnum!, $newValue: String!) {
  updateInstanceSetting(type: $type, newValue: $newValue) {
    code
    value
  }
}
    `;
export type UpdateSegmentationSettingMutationFn = Apollo.MutationFunction<UpdateSegmentationSettingMutation, UpdateSegmentationSettingMutationVariables>;

/**
 * __useUpdateSegmentationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentationSettingMutation, { data, loading, error }] = useUpdateSegmentationSettingMutation({
 *   variables: {
 *      type: // value for 'type'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useUpdateSegmentationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentationSettingMutation, UpdateSegmentationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentationSettingMutation, UpdateSegmentationSettingMutationVariables>(UpdateSegmentationSettingDocument, options);
      }
export type UpdateSegmentationSettingMutationHookResult = ReturnType<typeof useUpdateSegmentationSettingMutation>;
export type UpdateSegmentationSettingMutationResult = Apollo.MutationResult<UpdateSegmentationSettingMutation>;
export type UpdateSegmentationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentationSettingMutation, UpdateSegmentationSettingMutationVariables>;
export const CreateTerritoryMutationDocument = gql`
    mutation CreateTerritoryMutation($code: String!, $country: CountryCode!, $heading: String!) {
  createTerritory(code: $code, country: $country, heading: $heading) {
    code
    heading
    countryCode
  }
}
    `;
export type CreateTerritoryMutationMutationFn = Apollo.MutationFunction<CreateTerritoryMutationMutation, CreateTerritoryMutationMutationVariables>;

/**
 * __useCreateTerritoryMutationMutation__
 *
 * To run a mutation, you first call `useCreateTerritoryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTerritoryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTerritoryMutationMutation, { data, loading, error }] = useCreateTerritoryMutationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      country: // value for 'country'
 *      heading: // value for 'heading'
 *   },
 * });
 */
export function useCreateTerritoryMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTerritoryMutationMutation, CreateTerritoryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTerritoryMutationMutation, CreateTerritoryMutationMutationVariables>(CreateTerritoryMutationDocument, options);
      }
export type CreateTerritoryMutationMutationHookResult = ReturnType<typeof useCreateTerritoryMutationMutation>;
export type CreateTerritoryMutationMutationResult = Apollo.MutationResult<CreateTerritoryMutationMutation>;
export type CreateTerritoryMutationMutationOptions = Apollo.BaseMutationOptions<CreateTerritoryMutationMutation, CreateTerritoryMutationMutationVariables>;
export const SiteBrickTerritoryQueryDocument = gql`
    query SiteBrickTerritoryQuery {
  bricks(criteria: {unassigned: true}) {
    hash
    totalCount
  }
  territories {
    hash
    nodes {
      code
      heading
      description
      countryCode
      bricks {
        hash
        totalCount
        siteTotalCount
        nodes {
          code
          heading
        }
      }
      responsibleUser {
        id
        fullname
      }
    }
  }
}
    `;

/**
 * __useSiteBrickTerritoryQueryQuery__
 *
 * To run a query within a React component, call `useSiteBrickTerritoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteBrickTerritoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteBrickTerritoryQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteBrickTerritoryQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteBrickTerritoryQueryQuery, SiteBrickTerritoryQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteBrickTerritoryQueryQuery, SiteBrickTerritoryQueryQueryVariables>(SiteBrickTerritoryQueryDocument, options);
      }
export function useSiteBrickTerritoryQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteBrickTerritoryQueryQuery, SiteBrickTerritoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteBrickTerritoryQueryQuery, SiteBrickTerritoryQueryQueryVariables>(SiteBrickTerritoryQueryDocument, options);
        }
export type SiteBrickTerritoryQueryQueryHookResult = ReturnType<typeof useSiteBrickTerritoryQueryQuery>;
export type SiteBrickTerritoryQueryLazyQueryHookResult = ReturnType<typeof useSiteBrickTerritoryQueryLazyQuery>;
export type SiteBrickTerritoryQueryQueryResult = Apollo.QueryResult<SiteBrickTerritoryQueryQuery, SiteBrickTerritoryQueryQueryVariables>;
export const BricksForTerritorySelectorDocument = gql`
    query BricksForTerritorySelector($territoryCode: String!) {
  bricks(criteria: {territoryCodeOrUnassigned: $territoryCode}) {
    hash
    nodes {
      code
      heading
    }
  }
}
    `;

/**
 * __useBricksForTerritorySelectorQuery__
 *
 * To run a query within a React component, call `useBricksForTerritorySelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBricksForTerritorySelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBricksForTerritorySelectorQuery({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *   },
 * });
 */
export function useBricksForTerritorySelectorQuery(baseOptions: Apollo.QueryHookOptions<BricksForTerritorySelectorQuery, BricksForTerritorySelectorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BricksForTerritorySelectorQuery, BricksForTerritorySelectorQueryVariables>(BricksForTerritorySelectorDocument, options);
      }
export function useBricksForTerritorySelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BricksForTerritorySelectorQuery, BricksForTerritorySelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BricksForTerritorySelectorQuery, BricksForTerritorySelectorQueryVariables>(BricksForTerritorySelectorDocument, options);
        }
export type BricksForTerritorySelectorQueryHookResult = ReturnType<typeof useBricksForTerritorySelectorQuery>;
export type BricksForTerritorySelectorLazyQueryHookResult = ReturnType<typeof useBricksForTerritorySelectorLazyQuery>;
export type BricksForTerritorySelectorQueryResult = Apollo.QueryResult<BricksForTerritorySelectorQuery, BricksForTerritorySelectorQueryVariables>;
export const SetTerritoryBricksDocument = gql`
    mutation SetTerritoryBricks($territoryCode: String!, $brickCodes: [String!]!) {
  setBricksForTerritory(territoryCode: $territoryCode, brickCodes: $brickCodes) {
    code
  }
}
    `;
export type SetTerritoryBricksMutationFn = Apollo.MutationFunction<SetTerritoryBricksMutation, SetTerritoryBricksMutationVariables>;

/**
 * __useSetTerritoryBricksMutation__
 *
 * To run a mutation, you first call `useSetTerritoryBricksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTerritoryBricksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTerritoryBricksMutation, { data, loading, error }] = useSetTerritoryBricksMutation({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *      brickCodes: // value for 'brickCodes'
 *   },
 * });
 */
export function useSetTerritoryBricksMutation(baseOptions?: Apollo.MutationHookOptions<SetTerritoryBricksMutation, SetTerritoryBricksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTerritoryBricksMutation, SetTerritoryBricksMutationVariables>(SetTerritoryBricksDocument, options);
      }
export type SetTerritoryBricksMutationHookResult = ReturnType<typeof useSetTerritoryBricksMutation>;
export type SetTerritoryBricksMutationResult = Apollo.MutationResult<SetTerritoryBricksMutation>;
export type SetTerritoryBricksMutationOptions = Apollo.BaseMutationOptions<SetTerritoryBricksMutation, SetTerritoryBricksMutationVariables>;
export const TerritorySitesUserResponsibleDocument = gql`
    query TerritorySitesUserResponsible($territoryCode: String!) {
  users(
    criteria: {responsibleForSitesInTerritoryCode: $territoryCode, isHidden: null, isLocked: null}
  ) {
    hash
    nodes {
      id
      fullname
      sitesResponsibleFor(criteria: {territoryCode: $territoryCode}) {
        hash
        totalCount
      }
    }
  }
}
    `;

/**
 * __useTerritorySitesUserResponsibleQuery__
 *
 * To run a query within a React component, call `useTerritorySitesUserResponsibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerritorySitesUserResponsibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerritorySitesUserResponsibleQuery({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *   },
 * });
 */
export function useTerritorySitesUserResponsibleQuery(baseOptions: Apollo.QueryHookOptions<TerritorySitesUserResponsibleQuery, TerritorySitesUserResponsibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerritorySitesUserResponsibleQuery, TerritorySitesUserResponsibleQueryVariables>(TerritorySitesUserResponsibleDocument, options);
      }
export function useTerritorySitesUserResponsibleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerritorySitesUserResponsibleQuery, TerritorySitesUserResponsibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerritorySitesUserResponsibleQuery, TerritorySitesUserResponsibleQueryVariables>(TerritorySitesUserResponsibleDocument, options);
        }
export type TerritorySitesUserResponsibleQueryHookResult = ReturnType<typeof useTerritorySitesUserResponsibleQuery>;
export type TerritorySitesUserResponsibleLazyQueryHookResult = ReturnType<typeof useTerritorySitesUserResponsibleLazyQuery>;
export type TerritorySitesUserResponsibleQueryResult = Apollo.QueryResult<TerritorySitesUserResponsibleQuery, TerritorySitesUserResponsibleQueryVariables>;
export const UpdateTerritoryHeadingMutationDocument = gql`
    mutation UpdateTerritoryHeadingMutation($territoryCode: String!, $newHeading: String!) {
  updateTerritoryHeading(territoryCode: $territoryCode, heading: $newHeading) {
    code
    heading
  }
}
    `;
export type UpdateTerritoryHeadingMutationMutationFn = Apollo.MutationFunction<UpdateTerritoryHeadingMutationMutation, UpdateTerritoryHeadingMutationMutationVariables>;

/**
 * __useUpdateTerritoryHeadingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateTerritoryHeadingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerritoryHeadingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerritoryHeadingMutationMutation, { data, loading, error }] = useUpdateTerritoryHeadingMutationMutation({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *      newHeading: // value for 'newHeading'
 *   },
 * });
 */
export function useUpdateTerritoryHeadingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTerritoryHeadingMutationMutation, UpdateTerritoryHeadingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTerritoryHeadingMutationMutation, UpdateTerritoryHeadingMutationMutationVariables>(UpdateTerritoryHeadingMutationDocument, options);
      }
export type UpdateTerritoryHeadingMutationMutationHookResult = ReturnType<typeof useUpdateTerritoryHeadingMutationMutation>;
export type UpdateTerritoryHeadingMutationMutationResult = Apollo.MutationResult<UpdateTerritoryHeadingMutationMutation>;
export type UpdateTerritoryHeadingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateTerritoryHeadingMutationMutation, UpdateTerritoryHeadingMutationMutationVariables>;
export const InactivateTerritoryDocument = gql`
    mutation InactivateTerritory($territoryCode: String!) {
  inactivateTerritory(territoryCode: $territoryCode) {
    code
    isActive
  }
}
    `;
export type InactivateTerritoryMutationFn = Apollo.MutationFunction<InactivateTerritoryMutation, InactivateTerritoryMutationVariables>;

/**
 * __useInactivateTerritoryMutation__
 *
 * To run a mutation, you first call `useInactivateTerritoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateTerritoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateTerritoryMutation, { data, loading, error }] = useInactivateTerritoryMutation({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *   },
 * });
 */
export function useInactivateTerritoryMutation(baseOptions?: Apollo.MutationHookOptions<InactivateTerritoryMutation, InactivateTerritoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateTerritoryMutation, InactivateTerritoryMutationVariables>(InactivateTerritoryDocument, options);
      }
export type InactivateTerritoryMutationHookResult = ReturnType<typeof useInactivateTerritoryMutation>;
export type InactivateTerritoryMutationResult = Apollo.MutationResult<InactivateTerritoryMutation>;
export type InactivateTerritoryMutationOptions = Apollo.BaseMutationOptions<InactivateTerritoryMutation, InactivateTerritoryMutationVariables>;
export const UpdateTerritoryResponsibleDocument = gql`
    mutation UpdateTerritoryResponsible($territoryCode: String!, $responsibleUserId: Int) {
  updateTerritoryResponsibleUser(
    territoryCode: $territoryCode
    responsibleUserId: $responsibleUserId
  ) {
    code
    responsibleUserId
    responsibleUser {
      id
    }
  }
}
    `;
export type UpdateTerritoryResponsibleMutationFn = Apollo.MutationFunction<UpdateTerritoryResponsibleMutation, UpdateTerritoryResponsibleMutationVariables>;

/**
 * __useUpdateTerritoryResponsibleMutation__
 *
 * To run a mutation, you first call `useUpdateTerritoryResponsibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTerritoryResponsibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTerritoryResponsibleMutation, { data, loading, error }] = useUpdateTerritoryResponsibleMutation({
 *   variables: {
 *      territoryCode: // value for 'territoryCode'
 *      responsibleUserId: // value for 'responsibleUserId'
 *   },
 * });
 */
export function useUpdateTerritoryResponsibleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTerritoryResponsibleMutation, UpdateTerritoryResponsibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTerritoryResponsibleMutation, UpdateTerritoryResponsibleMutationVariables>(UpdateTerritoryResponsibleDocument, options);
      }
export type UpdateTerritoryResponsibleMutationHookResult = ReturnType<typeof useUpdateTerritoryResponsibleMutation>;
export type UpdateTerritoryResponsibleMutationResult = Apollo.MutationResult<UpdateTerritoryResponsibleMutation>;
export type UpdateTerritoryResponsibleMutationOptions = Apollo.BaseMutationOptions<UpdateTerritoryResponsibleMutation, UpdateTerritoryResponsibleMutationVariables>;
export const UpdateGroupMenuItemDocument = gql`
    mutation UpdateGroupMenuItem($menuItemCode: String!, $menuGroup: MenuGroupEnum!) {
  updateMenuItemGroup(menuItemCode: $menuItemCode, menuGroup: $menuGroup) {
    code
    menuGroup {
      code
      enum
    }
  }
}
    `;
export type UpdateGroupMenuItemMutationFn = Apollo.MutationFunction<UpdateGroupMenuItemMutation, UpdateGroupMenuItemMutationVariables>;

/**
 * __useUpdateGroupMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMenuItemMutation, { data, loading, error }] = useUpdateGroupMenuItemMutation({
 *   variables: {
 *      menuItemCode: // value for 'menuItemCode'
 *      menuGroup: // value for 'menuGroup'
 *   },
 * });
 */
export function useUpdateGroupMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMenuItemMutation, UpdateGroupMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMenuItemMutation, UpdateGroupMenuItemMutationVariables>(UpdateGroupMenuItemDocument, options);
      }
export type UpdateGroupMenuItemMutationHookResult = ReturnType<typeof useUpdateGroupMenuItemMutation>;
export type UpdateGroupMenuItemMutationResult = Apollo.MutationResult<UpdateGroupMenuItemMutation>;
export type UpdateGroupMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMenuItemMutation, UpdateGroupMenuItemMutationVariables>;
export const UpdateMenuSortingMutationDocument = gql`
    mutation UpdateMenuSortingMutation($menuGroup: MenuGroupEnum!, $menuItemCodes: [String!]!) {
  updateMenuItemsSorting(menuGroup: $menuGroup, menuItemCodes: $menuItemCodes) {
    code
    sort
  }
}
    `;
export type UpdateMenuSortingMutationMutationFn = Apollo.MutationFunction<UpdateMenuSortingMutationMutation, UpdateMenuSortingMutationMutationVariables>;

/**
 * __useUpdateMenuSortingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateMenuSortingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMenuSortingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMenuSortingMutationMutation, { data, loading, error }] = useUpdateMenuSortingMutationMutation({
 *   variables: {
 *      menuGroup: // value for 'menuGroup'
 *      menuItemCodes: // value for 'menuItemCodes'
 *   },
 * });
 */
export function useUpdateMenuSortingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMenuSortingMutationMutation, UpdateMenuSortingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMenuSortingMutationMutation, UpdateMenuSortingMutationMutationVariables>(UpdateMenuSortingMutationDocument, options);
      }
export type UpdateMenuSortingMutationMutationHookResult = ReturnType<typeof useUpdateMenuSortingMutationMutation>;
export type UpdateMenuSortingMutationMutationResult = Apollo.MutationResult<UpdateMenuSortingMutationMutation>;
export type UpdateMenuSortingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateMenuSortingMutationMutation, UpdateMenuSortingMutationMutationVariables>;
export const AdminMenuDataQueryDocument = gql`
    query AdminMenuDataQuery {
  menuItems(criteria: {group: MENU, isActive: null}) {
    hash
    nodes {
      ...AdminMenuItemFragment
    }
  }
  functionMenuItems: menuItems(criteria: {group: FUNC, isActive: null}) {
    hash
    nodes {
      ...AdminMenuItemFragment
    }
  }
}
    ${AdminMenuItemFragmentFragmentDoc}`;

/**
 * __useAdminMenuDataQueryQuery__
 *
 * To run a query within a React component, call `useAdminMenuDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminMenuDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminMenuDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminMenuDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<AdminMenuDataQueryQuery, AdminMenuDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminMenuDataQueryQuery, AdminMenuDataQueryQueryVariables>(AdminMenuDataQueryDocument, options);
      }
export function useAdminMenuDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminMenuDataQueryQuery, AdminMenuDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminMenuDataQueryQuery, AdminMenuDataQueryQueryVariables>(AdminMenuDataQueryDocument, options);
        }
export type AdminMenuDataQueryQueryHookResult = ReturnType<typeof useAdminMenuDataQueryQuery>;
export type AdminMenuDataQueryLazyQueryHookResult = ReturnType<typeof useAdminMenuDataQueryLazyQuery>;
export type AdminMenuDataQueryQueryResult = Apollo.QueryResult<AdminMenuDataQueryQuery, AdminMenuDataQueryQueryVariables>;
export const UpdateStatusMenuItemDocument = gql`
    mutation UpdateStatusMenuItem($menuItemCode: String!, $isActive: Boolean!) {
  updateMenuItemStatus(menuItemCode: $menuItemCode, isActive: $isActive) {
    code
    isActive
  }
}
    `;
export type UpdateStatusMenuItemMutationFn = Apollo.MutationFunction<UpdateStatusMenuItemMutation, UpdateStatusMenuItemMutationVariables>;

/**
 * __useUpdateStatusMenuItemMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMenuItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMenuItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMenuItemMutation, { data, loading, error }] = useUpdateStatusMenuItemMutation({
 *   variables: {
 *      menuItemCode: // value for 'menuItemCode'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateStatusMenuItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMenuItemMutation, UpdateStatusMenuItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusMenuItemMutation, UpdateStatusMenuItemMutationVariables>(UpdateStatusMenuItemDocument, options);
      }
export type UpdateStatusMenuItemMutationHookResult = ReturnType<typeof useUpdateStatusMenuItemMutation>;
export type UpdateStatusMenuItemMutationResult = Apollo.MutationResult<UpdateStatusMenuItemMutation>;
export type UpdateStatusMenuItemMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMenuItemMutation, UpdateStatusMenuItemMutationVariables>;
export const AddActivityTypeToReportDocument = gql`
    mutation AddActivityTypeToReport($reportCode: String!, $country: CountryCode!, $activityTypeCode: String!) {
  addActivityTypeToReport(
    country: $country
    reportCode: $reportCode
    activityTypeCode: $activityTypeCode
  ) {
    id
    includeInReport
  }
}
    `;
export type AddActivityTypeToReportMutationFn = Apollo.MutationFunction<AddActivityTypeToReportMutation, AddActivityTypeToReportMutationVariables>;

/**
 * __useAddActivityTypeToReportMutation__
 *
 * To run a mutation, you first call `useAddActivityTypeToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityTypeToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityTypeToReportMutation, { data, loading, error }] = useAddActivityTypeToReportMutation({
 *   variables: {
 *      reportCode: // value for 'reportCode'
 *      country: // value for 'country'
 *      activityTypeCode: // value for 'activityTypeCode'
 *   },
 * });
 */
export function useAddActivityTypeToReportMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityTypeToReportMutation, AddActivityTypeToReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityTypeToReportMutation, AddActivityTypeToReportMutationVariables>(AddActivityTypeToReportDocument, options);
      }
export type AddActivityTypeToReportMutationHookResult = ReturnType<typeof useAddActivityTypeToReportMutation>;
export type AddActivityTypeToReportMutationResult = Apollo.MutationResult<AddActivityTypeToReportMutation>;
export type AddActivityTypeToReportMutationOptions = Apollo.BaseMutationOptions<AddActivityTypeToReportMutation, AddActivityTypeToReportMutationVariables>;
export const RemoveActivityTypeToReportDocument = gql`
    mutation RemoveActivityTypeToReport($reportCode: String!, $country: CountryCode!, $activityTypeCode: String!) {
  removeActivityTypeFromReport(
    country: $country
    reportCode: $reportCode
    activityTypeCode: $activityTypeCode
  ) {
    id
    includeInReport
  }
}
    `;
export type RemoveActivityTypeToReportMutationFn = Apollo.MutationFunction<RemoveActivityTypeToReportMutation, RemoveActivityTypeToReportMutationVariables>;

/**
 * __useRemoveActivityTypeToReportMutation__
 *
 * To run a mutation, you first call `useRemoveActivityTypeToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActivityTypeToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActivityTypeToReportMutation, { data, loading, error }] = useRemoveActivityTypeToReportMutation({
 *   variables: {
 *      reportCode: // value for 'reportCode'
 *      country: // value for 'country'
 *      activityTypeCode: // value for 'activityTypeCode'
 *   },
 * });
 */
export function useRemoveActivityTypeToReportMutation(baseOptions?: Apollo.MutationHookOptions<RemoveActivityTypeToReportMutation, RemoveActivityTypeToReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveActivityTypeToReportMutation, RemoveActivityTypeToReportMutationVariables>(RemoveActivityTypeToReportDocument, options);
      }
export type RemoveActivityTypeToReportMutationHookResult = ReturnType<typeof useRemoveActivityTypeToReportMutation>;
export type RemoveActivityTypeToReportMutationResult = Apollo.MutationResult<RemoveActivityTypeToReportMutation>;
export type RemoveActivityTypeToReportMutationOptions = Apollo.BaseMutationOptions<RemoveActivityTypeToReportMutation, RemoveActivityTypeToReportMutationVariables>;
export const ActivityTypesForInReportsQueryDocument = gql`
    query ActivityTypesForInReportsQuery($reportCode: String!, $country: CountryCode!) {
  activitySuperTypes {
    hash
    nodes {
      code
      heading
      types(criteria: {excludeSelectedInReportSettingByReportCode: $reportCode}) {
        hash
        nodes {
          code
          heading
          colorCode
        }
      }
    }
  }
  reportSettingsActivityTypes(
    criteria: {country: $country, reportCode: $reportCode}
  ) {
    hash
    nodes {
      id
      activityType {
        code
        heading
        colorCode
        color {
          code
          value
        }
      }
    }
  }
}
    `;

/**
 * __useActivityTypesForInReportsQueryQuery__
 *
 * To run a query within a React component, call `useActivityTypesForInReportsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTypesForInReportsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTypesForInReportsQueryQuery({
 *   variables: {
 *      reportCode: // value for 'reportCode'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useActivityTypesForInReportsQueryQuery(baseOptions: Apollo.QueryHookOptions<ActivityTypesForInReportsQueryQuery, ActivityTypesForInReportsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityTypesForInReportsQueryQuery, ActivityTypesForInReportsQueryQueryVariables>(ActivityTypesForInReportsQueryDocument, options);
      }
export function useActivityTypesForInReportsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityTypesForInReportsQueryQuery, ActivityTypesForInReportsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityTypesForInReportsQueryQuery, ActivityTypesForInReportsQueryQueryVariables>(ActivityTypesForInReportsQueryDocument, options);
        }
export type ActivityTypesForInReportsQueryQueryHookResult = ReturnType<typeof useActivityTypesForInReportsQueryQuery>;
export type ActivityTypesForInReportsQueryLazyQueryHookResult = ReturnType<typeof useActivityTypesForInReportsQueryLazyQuery>;
export type ActivityTypesForInReportsQueryQueryResult = Apollo.QueryResult<ActivityTypesForInReportsQueryQuery, ActivityTypesForInReportsQueryQueryVariables>;
export const updateSaleCycleMutationDocument = gql`
    mutation updateSaleCycleMutation($year: Int!, $cycleStartMonth: Month!, $countryCode: CountryCode!, $cycleAmount: Int!, $id: Int!, $segmentations: [SegmentationSaleCycleInput!]!) {
  updateSaleCycle(
    id: $id
    country: $countryCode
    cycleAmount: $cycleAmount
    cycleStartMonth: $cycleStartMonth
    year: $year
    segmentationValues: $segmentations
  ) {
    id
    country
    createdByUserId
    cycleStartMonth
    modifiedByUserId
    numberOfCyclesInYear
    startMonth
    year
  }
}
    `;
export type updateSaleCycleMutationMutationFn = Apollo.MutationFunction<updateSaleCycleMutationMutation, updateSaleCycleMutationMutationVariables>;

/**
 * __useupdateSaleCycleMutationMutation__
 *
 * To run a mutation, you first call `useupdateSaleCycleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateSaleCycleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleCycleMutationMutation, { data, loading, error }] = useupdateSaleCycleMutationMutation({
 *   variables: {
 *      year: // value for 'year'
 *      cycleStartMonth: // value for 'cycleStartMonth'
 *      countryCode: // value for 'countryCode'
 *      cycleAmount: // value for 'cycleAmount'
 *      id: // value for 'id'
 *      segmentations: // value for 'segmentations'
 *   },
 * });
 */
export function useupdateSaleCycleMutationMutation(baseOptions?: Apollo.MutationHookOptions<updateSaleCycleMutationMutation, updateSaleCycleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<updateSaleCycleMutationMutation, updateSaleCycleMutationMutationVariables>(updateSaleCycleMutationDocument, options);
      }
export type updateSaleCycleMutationMutationHookResult = ReturnType<typeof useupdateSaleCycleMutationMutation>;
export type updateSaleCycleMutationMutationResult = Apollo.MutationResult<updateSaleCycleMutationMutation>;
export type updateSaleCycleMutationMutationOptions = Apollo.BaseMutationOptions<updateSaleCycleMutationMutation, updateSaleCycleMutationMutationVariables>;
export const KPIQueryDocument = gql`
    query KPIQuery($selectedCountry: CountryCode!) {
  segmentationCodes {
    hash
    nodes {
      id
      heading
    }
  }
  salesCycleSetups(criteria: {countries: [$selectedCountry]}) {
    hash
    totalCount
    nodes {
      id
      countryCode
      year
      numberOfCyclesInYear
      cycleStartMonth
      targets {
        hash
        nodes {
          id
          goal
          segmentationCodeId
          segmentationCode {
            id
            heading
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __useKPIQueryQuery__
 *
 * To run a query within a React component, call `useKPIQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKPIQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKPIQueryQuery({
 *   variables: {
 *      selectedCountry: // value for 'selectedCountry'
 *   },
 * });
 */
export function useKPIQueryQuery(baseOptions: Apollo.QueryHookOptions<KPIQueryQuery, KPIQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KPIQueryQuery, KPIQueryQueryVariables>(KPIQueryDocument, options);
      }
export function useKPIQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KPIQueryQuery, KPIQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KPIQueryQuery, KPIQueryQueryVariables>(KPIQueryDocument, options);
        }
export type KPIQueryQueryHookResult = ReturnType<typeof useKPIQueryQuery>;
export type KPIQueryLazyQueryHookResult = ReturnType<typeof useKPIQueryLazyQuery>;
export type KPIQueryQueryResult = Apollo.QueryResult<KPIQueryQuery, KPIQueryQueryVariables>;
export const CreateNewSalesCycleMutationDocument = gql`
    mutation CreateNewSalesCycleMutation($year: Int!, $countryCode: CountryCode!, $cycleAmount: Int!, $cycleStartMonth: Month!, $segmentations: [SegmentationSaleCycleInput!]!) {
  createNewSalesCycle(
    country: $countryCode
    cycleStartMonth: $cycleStartMonth
    year: $year
    cycleAmount: $cycleAmount
    segmentationValues: $segmentations
  ) {
    id
  }
}
    `;
export type CreateNewSalesCycleMutationMutationFn = Apollo.MutationFunction<CreateNewSalesCycleMutationMutation, CreateNewSalesCycleMutationMutationVariables>;

/**
 * __useCreateNewSalesCycleMutationMutation__
 *
 * To run a mutation, you first call `useCreateNewSalesCycleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSalesCycleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSalesCycleMutationMutation, { data, loading, error }] = useCreateNewSalesCycleMutationMutation({
 *   variables: {
 *      year: // value for 'year'
 *      countryCode: // value for 'countryCode'
 *      cycleAmount: // value for 'cycleAmount'
 *      cycleStartMonth: // value for 'cycleStartMonth'
 *      segmentations: // value for 'segmentations'
 *   },
 * });
 */
export function useCreateNewSalesCycleMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSalesCycleMutationMutation, CreateNewSalesCycleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSalesCycleMutationMutation, CreateNewSalesCycleMutationMutationVariables>(CreateNewSalesCycleMutationDocument, options);
      }
export type CreateNewSalesCycleMutationMutationHookResult = ReturnType<typeof useCreateNewSalesCycleMutationMutation>;
export type CreateNewSalesCycleMutationMutationResult = Apollo.MutationResult<CreateNewSalesCycleMutationMutation>;
export type CreateNewSalesCycleMutationMutationOptions = Apollo.BaseMutationOptions<CreateNewSalesCycleMutationMutation, CreateNewSalesCycleMutationMutationVariables>;
export const ReportCallFreqDataQueryDocument = gql`
    query ReportCallFreqDataQuery {
  reportSettingIsHalfDay(reportCode: "No3")
  reportSettingDailyCallTarget(reportCode: "No3") {
    id
    country
    amount
  }
  reportSettingFieldDays(criteria: {reportCode: "No3"}) {
    hash
    nodes {
      id
      activityTypeCode
      amountForOne
      activityType {
        code
        heading
        colorCode
      }
    }
  }
  activitySuperTypes {
    hash
    nodes {
      code
      heading
      types {
        hash
        nodes {
          code
          heading
        }
      }
    }
  }
}
    `;

/**
 * __useReportCallFreqDataQueryQuery__
 *
 * To run a query within a React component, call `useReportCallFreqDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCallFreqDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCallFreqDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportCallFreqDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<ReportCallFreqDataQueryQuery, ReportCallFreqDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportCallFreqDataQueryQuery, ReportCallFreqDataQueryQueryVariables>(ReportCallFreqDataQueryDocument, options);
      }
export function useReportCallFreqDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportCallFreqDataQueryQuery, ReportCallFreqDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportCallFreqDataQueryQuery, ReportCallFreqDataQueryQueryVariables>(ReportCallFreqDataQueryDocument, options);
        }
export type ReportCallFreqDataQueryQueryHookResult = ReturnType<typeof useReportCallFreqDataQueryQuery>;
export type ReportCallFreqDataQueryLazyQueryHookResult = ReturnType<typeof useReportCallFreqDataQueryLazyQuery>;
export type ReportCallFreqDataQueryQueryResult = Apollo.QueryResult<ReportCallFreqDataQueryQuery, ReportCallFreqDataQueryQueryVariables>;
export const SetHalfDayMutationDocument = gql`
    mutation SetHalfDayMutation($isHalfDay: Boolean!) {
  setReportSettingIsHalfDay(reportCode: "No3", isHalfDay: $isHalfDay)
}
    `;
export type SetHalfDayMutationMutationFn = Apollo.MutationFunction<SetHalfDayMutationMutation, SetHalfDayMutationMutationVariables>;

/**
 * __useSetHalfDayMutationMutation__
 *
 * To run a mutation, you first call `useSetHalfDayMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHalfDayMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHalfDayMutationMutation, { data, loading, error }] = useSetHalfDayMutationMutation({
 *   variables: {
 *      isHalfDay: // value for 'isHalfDay'
 *   },
 * });
 */
export function useSetHalfDayMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetHalfDayMutationMutation, SetHalfDayMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHalfDayMutationMutation, SetHalfDayMutationMutationVariables>(SetHalfDayMutationDocument, options);
      }
export type SetHalfDayMutationMutationHookResult = ReturnType<typeof useSetHalfDayMutationMutation>;
export type SetHalfDayMutationMutationResult = Apollo.MutationResult<SetHalfDayMutationMutation>;
export type SetHalfDayMutationMutationOptions = Apollo.BaseMutationOptions<SetHalfDayMutationMutation, SetHalfDayMutationMutationVariables>;
export const SetDailyTargetMutationDocument = gql`
    mutation SetDailyTargetMutation($country: CountryCode!, $amount: Int!) {
  setReportSettingDailyCallTarget(
    reportCode: "No3"
    country: $country
    amount: $amount
  ) {
    id
    country
    amount
  }
}
    `;
export type SetDailyTargetMutationMutationFn = Apollo.MutationFunction<SetDailyTargetMutationMutation, SetDailyTargetMutationMutationVariables>;

/**
 * __useSetDailyTargetMutationMutation__
 *
 * To run a mutation, you first call `useSetDailyTargetMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDailyTargetMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDailyTargetMutationMutation, { data, loading, error }] = useSetDailyTargetMutationMutation({
 *   variables: {
 *      country: // value for 'country'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useSetDailyTargetMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetDailyTargetMutationMutation, SetDailyTargetMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDailyTargetMutationMutation, SetDailyTargetMutationMutationVariables>(SetDailyTargetMutationDocument, options);
      }
export type SetDailyTargetMutationMutationHookResult = ReturnType<typeof useSetDailyTargetMutationMutation>;
export type SetDailyTargetMutationMutationResult = Apollo.MutationResult<SetDailyTargetMutationMutation>;
export type SetDailyTargetMutationMutationOptions = Apollo.BaseMutationOptions<SetDailyTargetMutationMutation, SetDailyTargetMutationMutationVariables>;
export const AddFieldDayMutationDocument = gql`
    mutation AddFieldDayMutation($activityTypeCode: String!, $amountForOne: Int!) {
  addReportSettingFieldDay(
    reportCode: "No3"
    activityTypeCode: $activityTypeCode
    amountForOne: $amountForOne
  ) {
    id
    activityTypeCode
    amountForOne
  }
}
    `;
export type AddFieldDayMutationMutationFn = Apollo.MutationFunction<AddFieldDayMutationMutation, AddFieldDayMutationMutationVariables>;

/**
 * __useAddFieldDayMutationMutation__
 *
 * To run a mutation, you first call `useAddFieldDayMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFieldDayMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFieldDayMutationMutation, { data, loading, error }] = useAddFieldDayMutationMutation({
 *   variables: {
 *      activityTypeCode: // value for 'activityTypeCode'
 *      amountForOne: // value for 'amountForOne'
 *   },
 * });
 */
export function useAddFieldDayMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddFieldDayMutationMutation, AddFieldDayMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFieldDayMutationMutation, AddFieldDayMutationMutationVariables>(AddFieldDayMutationDocument, options);
      }
export type AddFieldDayMutationMutationHookResult = ReturnType<typeof useAddFieldDayMutationMutation>;
export type AddFieldDayMutationMutationResult = Apollo.MutationResult<AddFieldDayMutationMutation>;
export type AddFieldDayMutationMutationOptions = Apollo.BaseMutationOptions<AddFieldDayMutationMutation, AddFieldDayMutationMutationVariables>;
export const RemoveFieldDayMutationDocument = gql`
    mutation RemoveFieldDayMutation($id: Int!) {
  removeReportSettingFieldDay(id: $id)
}
    `;
export type RemoveFieldDayMutationMutationFn = Apollo.MutationFunction<RemoveFieldDayMutationMutation, RemoveFieldDayMutationMutationVariables>;

/**
 * __useRemoveFieldDayMutationMutation__
 *
 * To run a mutation, you first call `useRemoveFieldDayMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFieldDayMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFieldDayMutationMutation, { data, loading, error }] = useRemoveFieldDayMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFieldDayMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFieldDayMutationMutation, RemoveFieldDayMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFieldDayMutationMutation, RemoveFieldDayMutationMutationVariables>(RemoveFieldDayMutationDocument, options);
      }
export type RemoveFieldDayMutationMutationHookResult = ReturnType<typeof useRemoveFieldDayMutationMutation>;
export type RemoveFieldDayMutationMutationResult = Apollo.MutationResult<RemoveFieldDayMutationMutation>;
export type RemoveFieldDayMutationMutationOptions = Apollo.BaseMutationOptions<RemoveFieldDayMutationMutation, RemoveFieldDayMutationMutationVariables>;
export const CreateNewSandboxMutationDocument = gql`
    mutation CreateNewSandboxMutation($name: String!) {
  deployNewSandbox(heading: $name) {
    id
    heading
  }
}
    `;
export type CreateNewSandboxMutationMutationFn = Apollo.MutationFunction<CreateNewSandboxMutationMutation, CreateNewSandboxMutationMutationVariables>;

/**
 * __useCreateNewSandboxMutationMutation__
 *
 * To run a mutation, you first call `useCreateNewSandboxMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewSandboxMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewSandboxMutationMutation, { data, loading, error }] = useCreateNewSandboxMutationMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateNewSandboxMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewSandboxMutationMutation, CreateNewSandboxMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewSandboxMutationMutation, CreateNewSandboxMutationMutationVariables>(CreateNewSandboxMutationDocument, options);
      }
export type CreateNewSandboxMutationMutationHookResult = ReturnType<typeof useCreateNewSandboxMutationMutation>;
export type CreateNewSandboxMutationMutationResult = Apollo.MutationResult<CreateNewSandboxMutationMutation>;
export type CreateNewSandboxMutationMutationOptions = Apollo.BaseMutationOptions<CreateNewSandboxMutationMutation, CreateNewSandboxMutationMutationVariables>;
export const SandboxInformationQueryDocument = gql`
    query SandboxInformationQuery {
  instance {
    code
    maxSandboxes
    sandboxes {
      hash
      totalCount
      nodes {
        id
        heading
        isActive
        serverCode
        ct
        ut
        deploymentStatus {
          code
          currentPercentage
          totalSteps
          app {
            currentStatus
            message
          }
          clone {
            currentStatus
            message
          }
          db {
            currentStatus
            message
          }
          activityJob {
            currentStatus
            message
          }
          schedule {
            code
            cron
            isActive
            lastRun
            status
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSandboxInformationQueryQuery__
 *
 * To run a query within a React component, call `useSandboxInformationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxInformationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxInformationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSandboxInformationQueryQuery(baseOptions?: Apollo.QueryHookOptions<SandboxInformationQueryQuery, SandboxInformationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SandboxInformationQueryQuery, SandboxInformationQueryQueryVariables>(SandboxInformationQueryDocument, options);
      }
export function useSandboxInformationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SandboxInformationQueryQuery, SandboxInformationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SandboxInformationQueryQuery, SandboxInformationQueryQueryVariables>(SandboxInformationQueryDocument, options);
        }
export type SandboxInformationQueryQueryHookResult = ReturnType<typeof useSandboxInformationQueryQuery>;
export type SandboxInformationQueryLazyQueryHookResult = ReturnType<typeof useSandboxInformationQueryLazyQuery>;
export type SandboxInformationQueryQueryResult = Apollo.QueryResult<SandboxInformationQueryQuery, SandboxInformationQueryQueryVariables>;
export const DestroySandboxMutationDocument = gql`
    mutation DestroySandboxMutation($sandboxId: Int!) {
  destroySandbox(sandboxId: $sandboxId) {
    id
    isActive
  }
}
    `;
export type DestroySandboxMutationMutationFn = Apollo.MutationFunction<DestroySandboxMutationMutation, DestroySandboxMutationMutationVariables>;

/**
 * __useDestroySandboxMutationMutation__
 *
 * To run a mutation, you first call `useDestroySandboxMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySandboxMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySandboxMutationMutation, { data, loading, error }] = useDestroySandboxMutationMutation({
 *   variables: {
 *      sandboxId: // value for 'sandboxId'
 *   },
 * });
 */
export function useDestroySandboxMutationMutation(baseOptions?: Apollo.MutationHookOptions<DestroySandboxMutationMutation, DestroySandboxMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroySandboxMutationMutation, DestroySandboxMutationMutationVariables>(DestroySandboxMutationDocument, options);
      }
export type DestroySandboxMutationMutationHookResult = ReturnType<typeof useDestroySandboxMutationMutation>;
export type DestroySandboxMutationMutationResult = Apollo.MutationResult<DestroySandboxMutationMutation>;
export type DestroySandboxMutationMutationOptions = Apollo.BaseMutationOptions<DestroySandboxMutationMutation, DestroySandboxMutationMutationVariables>;
export const ResetSandboxDbMutationDocument = gql`
    mutation ResetSandboxDbMutation($sandboxId: Int!) {
  resetSandboxDb(sandboxId: $sandboxId) {
    id
    isActive
  }
}
    `;
export type ResetSandboxDbMutationMutationFn = Apollo.MutationFunction<ResetSandboxDbMutationMutation, ResetSandboxDbMutationMutationVariables>;

/**
 * __useResetSandboxDbMutationMutation__
 *
 * To run a mutation, you first call `useResetSandboxDbMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSandboxDbMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSandboxDbMutationMutation, { data, loading, error }] = useResetSandboxDbMutationMutation({
 *   variables: {
 *      sandboxId: // value for 'sandboxId'
 *   },
 * });
 */
export function useResetSandboxDbMutationMutation(baseOptions?: Apollo.MutationHookOptions<ResetSandboxDbMutationMutation, ResetSandboxDbMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSandboxDbMutationMutation, ResetSandboxDbMutationMutationVariables>(ResetSandboxDbMutationDocument, options);
      }
export type ResetSandboxDbMutationMutationHookResult = ReturnType<typeof useResetSandboxDbMutationMutation>;
export type ResetSandboxDbMutationMutationResult = Apollo.MutationResult<ResetSandboxDbMutationMutation>;
export type ResetSandboxDbMutationMutationOptions = Apollo.BaseMutationOptions<ResetSandboxDbMutationMutation, ResetSandboxDbMutationMutationVariables>;
export const UpdateInstanceSettingMutationDocument = gql`
    mutation UpdateInstanceSettingMutation($type: InstanceSettingEnum!, $value: String) {
  updateInstanceSetting(type: $type, newValue: $value) {
    code
    value
  }
}
    `;
export type UpdateInstanceSettingMutationMutationFn = Apollo.MutationFunction<UpdateInstanceSettingMutationMutation, UpdateInstanceSettingMutationMutationVariables>;

/**
 * __useUpdateInstanceSettingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateInstanceSettingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInstanceSettingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInstanceSettingMutationMutation, { data, loading, error }] = useUpdateInstanceSettingMutationMutation({
 *   variables: {
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateInstanceSettingMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInstanceSettingMutationMutation, UpdateInstanceSettingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInstanceSettingMutationMutation, UpdateInstanceSettingMutationMutationVariables>(UpdateInstanceSettingMutationDocument, options);
      }
export type UpdateInstanceSettingMutationMutationHookResult = ReturnType<typeof useUpdateInstanceSettingMutationMutation>;
export type UpdateInstanceSettingMutationMutationResult = Apollo.MutationResult<UpdateInstanceSettingMutationMutation>;
export type UpdateInstanceSettingMutationMutationOptions = Apollo.BaseMutationOptions<UpdateInstanceSettingMutationMutation, UpdateInstanceSettingMutationMutationVariables>;
export const GeneralSystemSettingsQueryDocument = gql`
    query GeneralSystemSettingsQuery {
  name: instanceSetting(type: NAME) {
    ...InstanceSettingFragment
  }
  img: instanceSetting(type: IMG_PATH) {
    ...InstanceSettingFragment
  }
  domain: instanceSetting(type: DOMAIN_PATH) {
    ...InstanceSettingFragment
  }
}
    ${InstanceSettingFragmentFragmentDoc}`;

/**
 * __useGeneralSystemSettingsQueryQuery__
 *
 * To run a query within a React component, call `useGeneralSystemSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSystemSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSystemSettingsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeneralSystemSettingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<GeneralSystemSettingsQueryQuery, GeneralSystemSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralSystemSettingsQueryQuery, GeneralSystemSettingsQueryQueryVariables>(GeneralSystemSettingsQueryDocument, options);
      }
export function useGeneralSystemSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralSystemSettingsQueryQuery, GeneralSystemSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralSystemSettingsQueryQuery, GeneralSystemSettingsQueryQueryVariables>(GeneralSystemSettingsQueryDocument, options);
        }
export type GeneralSystemSettingsQueryQueryHookResult = ReturnType<typeof useGeneralSystemSettingsQueryQuery>;
export type GeneralSystemSettingsQueryLazyQueryHookResult = ReturnType<typeof useGeneralSystemSettingsQueryLazyQuery>;
export type GeneralSystemSettingsQueryQueryResult = Apollo.QueryResult<GeneralSystemSettingsQueryQuery, GeneralSystemSettingsQueryQueryVariables>;
export const createUserMutationDocument = gql`
    mutation createUserMutation($input: CreateUserInputdata!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type createUserMutationMutationFn = Apollo.MutationFunction<createUserMutationMutation, createUserMutationMutationVariables>;

/**
 * __usecreateUserMutationMutation__
 *
 * To run a mutation, you first call `usecreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usecreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = usecreateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usecreateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<createUserMutationMutation, createUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<createUserMutationMutation, createUserMutationMutationVariables>(createUserMutationDocument, options);
      }
export type createUserMutationMutationHookResult = ReturnType<typeof usecreateUserMutationMutation>;
export type createUserMutationMutationResult = Apollo.MutationResult<createUserMutationMutation>;
export type createUserMutationMutationOptions = Apollo.BaseMutationOptions<createUserMutationMutation, createUserMutationMutationVariables>;
export const GetAllCountiresQueryDocument = gql`
    query GetAllCountiresQuery {
  countries {
    hash
    nodes {
      code
      label
      labelGb
    }
  }
}
    `;

/**
 * __useGetAllCountiresQueryQuery__
 *
 * To run a query within a React component, call `useGetAllCountiresQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountiresQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountiresQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountiresQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountiresQueryQuery, GetAllCountiresQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountiresQueryQuery, GetAllCountiresQueryQueryVariables>(GetAllCountiresQueryDocument, options);
      }
export function useGetAllCountiresQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountiresQueryQuery, GetAllCountiresQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountiresQueryQuery, GetAllCountiresQueryQueryVariables>(GetAllCountiresQueryDocument, options);
        }
export type GetAllCountiresQueryQueryHookResult = ReturnType<typeof useGetAllCountiresQueryQuery>;
export type GetAllCountiresQueryLazyQueryHookResult = ReturnType<typeof useGetAllCountiresQueryLazyQuery>;
export type GetAllCountiresQueryQueryResult = Apollo.QueryResult<GetAllCountiresQueryQuery, GetAllCountiresQueryQueryVariables>;
export const UserAdminConnectionQueryDocument = gql`
    query UserAdminConnectionQuery($criteria: UserCriteria) {
  connection: users(criteria: $criteria) {
    hash
    totalCount
    nodes {
      id
      ...UserAdminTableFragment
    }
  }
}
    ${UserAdminTableFragmentFragmentDoc}`;

/**
 * __useUserAdminConnectionQueryQuery__
 *
 * To run a query within a React component, call `useUserAdminConnectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdminConnectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdminConnectionQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useUserAdminConnectionQueryQuery(baseOptions?: Apollo.QueryHookOptions<UserAdminConnectionQueryQuery, UserAdminConnectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAdminConnectionQueryQuery, UserAdminConnectionQueryQueryVariables>(UserAdminConnectionQueryDocument, options);
      }
export function useUserAdminConnectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAdminConnectionQueryQuery, UserAdminConnectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAdminConnectionQueryQuery, UserAdminConnectionQueryQueryVariables>(UserAdminConnectionQueryDocument, options);
        }
export type UserAdminConnectionQueryQueryHookResult = ReturnType<typeof useUserAdminConnectionQueryQuery>;
export type UserAdminConnectionQueryLazyQueryHookResult = ReturnType<typeof useUserAdminConnectionQueryLazyQuery>;
export type UserAdminConnectionQueryQueryResult = Apollo.QueryResult<UserAdminConnectionQueryQuery, UserAdminConnectionQueryQueryVariables>;
export const UserAdminRecordQueryDocument = gql`
    query UserAdminRecordQuery($recordId: Int!) {
  record: user(userId: $recordId) {
    id
    ...UserAdminTableFragment
  }
}
    ${UserAdminTableFragmentFragmentDoc}`;

/**
 * __useUserAdminRecordQueryQuery__
 *
 * To run a query within a React component, call `useUserAdminRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdminRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdminRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useUserAdminRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<UserAdminRecordQueryQuery, UserAdminRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAdminRecordQueryQuery, UserAdminRecordQueryQueryVariables>(UserAdminRecordQueryDocument, options);
      }
export function useUserAdminRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAdminRecordQueryQuery, UserAdminRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAdminRecordQueryQuery, UserAdminRecordQueryQueryVariables>(UserAdminRecordQueryDocument, options);
        }
export type UserAdminRecordQueryQueryHookResult = ReturnType<typeof useUserAdminRecordQueryQuery>;
export type UserAdminRecordQueryLazyQueryHookResult = ReturnType<typeof useUserAdminRecordQueryLazyQuery>;
export type UserAdminRecordQueryQueryResult = Apollo.QueryResult<UserAdminRecordQueryQuery, UserAdminRecordQueryQueryVariables>;
export const RoleAdminTableQueryDocument = gql`
    query RoleAdminTableQuery($criteria: RoleCriteria) {
  connection: roles(criteria: $criteria) {
    hash
    totalCount
    nodes {
      id
      ...RoleAdminTableFragment
    }
  }
}
    ${RoleAdminTableFragmentFragmentDoc}`;

/**
 * __useRoleAdminTableQueryQuery__
 *
 * To run a query within a React component, call `useRoleAdminTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleAdminTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleAdminTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useRoleAdminTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<RoleAdminTableQueryQuery, RoleAdminTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleAdminTableQueryQuery, RoleAdminTableQueryQueryVariables>(RoleAdminTableQueryDocument, options);
      }
export function useRoleAdminTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleAdminTableQueryQuery, RoleAdminTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleAdminTableQueryQuery, RoleAdminTableQueryQueryVariables>(RoleAdminTableQueryDocument, options);
        }
export type RoleAdminTableQueryQueryHookResult = ReturnType<typeof useRoleAdminTableQueryQuery>;
export type RoleAdminTableQueryLazyQueryHookResult = ReturnType<typeof useRoleAdminTableQueryLazyQuery>;
export type RoleAdminTableQueryQueryResult = Apollo.QueryResult<RoleAdminTableQueryQuery, RoleAdminTableQueryQueryVariables>;
export const RoleAdminRecordQueryDocument = gql`
    query RoleAdminRecordQuery($recordId: Int!) {
  record: role(id: $recordId) {
    id
    ...RoleAdminTableFragment
  }
}
    ${RoleAdminTableFragmentFragmentDoc}`;

/**
 * __useRoleAdminRecordQueryQuery__
 *
 * To run a query within a React component, call `useRoleAdminRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleAdminRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleAdminRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useRoleAdminRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<RoleAdminRecordQueryQuery, RoleAdminRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleAdminRecordQueryQuery, RoleAdminRecordQueryQueryVariables>(RoleAdminRecordQueryDocument, options);
      }
export function useRoleAdminRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleAdminRecordQueryQuery, RoleAdminRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleAdminRecordQueryQuery, RoleAdminRecordQueryQueryVariables>(RoleAdminRecordQueryDocument, options);
        }
export type RoleAdminRecordQueryQueryHookResult = ReturnType<typeof useRoleAdminRecordQueryQuery>;
export type RoleAdminRecordQueryLazyQueryHookResult = ReturnType<typeof useRoleAdminRecordQueryLazyQuery>;
export type RoleAdminRecordQueryQueryResult = Apollo.QueryResult<RoleAdminRecordQueryQuery, RoleAdminRecordQueryQueryVariables>;
export const RoleOverviewQueryDocument = gql`
    query RoleOverviewQuery($roleId: Int!) {
  role(id: $roleId) {
    id
    heading
    description: note
    isAdminRole
    users {
      hash
      totalCount
    }
    permissions {
      permissionEnum
      roleId
      module
      heading
      description
      create
      read
      update
      delete
    }
  }
}
    `;

/**
 * __useRoleOverviewQueryQuery__
 *
 * To run a query within a React component, call `useRoleOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleOverviewQueryQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useRoleOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<RoleOverviewQueryQuery, RoleOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleOverviewQueryQuery, RoleOverviewQueryQueryVariables>(RoleOverviewQueryDocument, options);
      }
export function useRoleOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleOverviewQueryQuery, RoleOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleOverviewQueryQuery, RoleOverviewQueryQueryVariables>(RoleOverviewQueryDocument, options);
        }
export type RoleOverviewQueryQueryHookResult = ReturnType<typeof useRoleOverviewQueryQuery>;
export type RoleOverviewQueryLazyQueryHookResult = ReturnType<typeof useRoleOverviewQueryLazyQuery>;
export type RoleOverviewQueryQueryResult = Apollo.QueryResult<RoleOverviewQueryQuery, RoleOverviewQueryQueryVariables>;
export const UpdatePermissionMutationDocument = gql`
    mutation UpdatePermissionMutation($roleId: Int!, $permission: PermissionEnum!, $level: PermissionLevel!, $allow: Boolean!) {
  updateRolePermission(
    roleId: $roleId
    permission: $permission
    level: $level
    allow: $allow
  ) {
    permissionEnum
    roleId
    module
    heading
    description
    create
    read
    update
    delete
  }
}
    `;
export type UpdatePermissionMutationMutationFn = Apollo.MutationFunction<UpdatePermissionMutationMutation, UpdatePermissionMutationMutationVariables>;

/**
 * __useUpdatePermissionMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutationMutation, { data, loading, error }] = useUpdatePermissionMutationMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      permission: // value for 'permission'
 *      level: // value for 'level'
 *      allow: // value for 'allow'
 *   },
 * });
 */
export function useUpdatePermissionMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionMutationMutation, UpdatePermissionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionMutationMutation, UpdatePermissionMutationMutationVariables>(UpdatePermissionMutationDocument, options);
      }
export type UpdatePermissionMutationMutationHookResult = ReturnType<typeof useUpdatePermissionMutationMutation>;
export type UpdatePermissionMutationMutationResult = Apollo.MutationResult<UpdatePermissionMutationMutation>;
export type UpdatePermissionMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionMutationMutation, UpdatePermissionMutationMutationVariables>;
export const UpdateUserMutationDocument = gql`
    mutation UpdateUserMutation($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    fullname
    firstname
    lastname
    email
    roleId
    role {
      id
    }
    countries {
      hash
      nodes {
        code
      }
    }
  }
}
    `;
export type UpdateUserMutationMutationFn = Apollo.MutationFunction<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;

/**
 * __useUpdateUserMutationMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutationMutation, { data, loading, error }] = useUpdateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>(UpdateUserMutationDocument, options);
      }
export type UpdateUserMutationMutationHookResult = ReturnType<typeof useUpdateUserMutationMutation>;
export type UpdateUserMutationMutationResult = Apollo.MutationResult<UpdateUserMutationMutation>;
export type UpdateUserMutationMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;
export const AdminUserQueryDocument = gql`
    query AdminUserQuery($userId: Int!) {
  user(userId: $userId) {
    id
    fullname
    firstname
    lastname
    email
  }
}
    `;

/**
 * __useAdminUserQueryQuery__
 *
 * To run a query within a React component, call `useAdminUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAdminUserQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminUserQueryQuery, AdminUserQueryQueryVariables>(AdminUserQueryDocument, options);
      }
export function useAdminUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminUserQueryQuery, AdminUserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminUserQueryQuery, AdminUserQueryQueryVariables>(AdminUserQueryDocument, options);
        }
export type AdminUserQueryQueryHookResult = ReturnType<typeof useAdminUserQueryQuery>;
export type AdminUserQueryLazyQueryHookResult = ReturnType<typeof useAdminUserQueryLazyQuery>;
export type AdminUserQueryQueryResult = Apollo.QueryResult<AdminUserQueryQuery, AdminUserQueryQueryVariables>;
export const UserAdminGeneralQueryDocument = gql`
    query UserAdminGeneralQuery($userId: Int!) {
  user(userId: $userId) {
    id
    firstname
    lastname
    email
    countries {
      hash
      nodes {
        code
        label
      }
    }
  }
}
    `;

/**
 * __useUserAdminGeneralQueryQuery__
 *
 * To run a query within a React component, call `useUserAdminGeneralQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdminGeneralQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdminGeneralQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAdminGeneralQueryQuery(baseOptions: Apollo.QueryHookOptions<UserAdminGeneralQueryQuery, UserAdminGeneralQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAdminGeneralQueryQuery, UserAdminGeneralQueryQueryVariables>(UserAdminGeneralQueryDocument, options);
      }
export function useUserAdminGeneralQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAdminGeneralQueryQuery, UserAdminGeneralQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAdminGeneralQueryQuery, UserAdminGeneralQueryQueryVariables>(UserAdminGeneralQueryDocument, options);
        }
export type UserAdminGeneralQueryQueryHookResult = ReturnType<typeof useUserAdminGeneralQueryQuery>;
export type UserAdminGeneralQueryLazyQueryHookResult = ReturnType<typeof useUserAdminGeneralQueryLazyQuery>;
export type UserAdminGeneralQueryQueryResult = Apollo.QueryResult<UserAdminGeneralQueryQuery, UserAdminGeneralQueryQueryVariables>;
export const UserAdminRoleQueryDocument = gql`
    query UserAdminRoleQuery($userId: Int!) {
  user(userId: $userId) {
    id
    role {
      id
      heading
    }
    teams {
      hash
      nodes {
        id
        heading: title
      }
    }
  }
  roles {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useUserAdminRoleQueryQuery__
 *
 * To run a query within a React component, call `useUserAdminRoleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAdminRoleQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAdminRoleQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAdminRoleQueryQuery(baseOptions: Apollo.QueryHookOptions<UserAdminRoleQueryQuery, UserAdminRoleQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAdminRoleQueryQuery, UserAdminRoleQueryQueryVariables>(UserAdminRoleQueryDocument, options);
      }
export function useUserAdminRoleQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAdminRoleQueryQuery, UserAdminRoleQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAdminRoleQueryQuery, UserAdminRoleQueryQueryVariables>(UserAdminRoleQueryDocument, options);
        }
export type UserAdminRoleQueryQueryHookResult = ReturnType<typeof useUserAdminRoleQueryQuery>;
export type UserAdminRoleQueryLazyQueryHookResult = ReturnType<typeof useUserAdminRoleQueryLazyQuery>;
export type UserAdminRoleQueryQueryResult = Apollo.QueryResult<UserAdminRoleQueryQuery, UserAdminRoleQueryQueryVariables>;
export const GenerateImpersonateTokenMutationDocument = gql`
    mutation GenerateImpersonateTokenMutation($userId: Int!) {
  impersonateUser(userId: $userId) {
    token
    expireDate
  }
}
    `;
export type GenerateImpersonateTokenMutationMutationFn = Apollo.MutationFunction<GenerateImpersonateTokenMutationMutation, GenerateImpersonateTokenMutationMutationVariables>;

/**
 * __useGenerateImpersonateTokenMutationMutation__
 *
 * To run a mutation, you first call `useGenerateImpersonateTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateImpersonateTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateImpersonateTokenMutationMutation, { data, loading, error }] = useGenerateImpersonateTokenMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGenerateImpersonateTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateImpersonateTokenMutationMutation, GenerateImpersonateTokenMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateImpersonateTokenMutationMutation, GenerateImpersonateTokenMutationMutationVariables>(GenerateImpersonateTokenMutationDocument, options);
      }
export type GenerateImpersonateTokenMutationMutationHookResult = ReturnType<typeof useGenerateImpersonateTokenMutationMutation>;
export type GenerateImpersonateTokenMutationMutationResult = Apollo.MutationResult<GenerateImpersonateTokenMutationMutation>;
export type GenerateImpersonateTokenMutationMutationOptions = Apollo.BaseMutationOptions<GenerateImpersonateTokenMutationMutation, GenerateImpersonateTokenMutationMutationVariables>;
export const BrickDetailQueryDocument = gql`
    query BrickDetailQuery($code: String!) {
  brick(code: $code) {
    code
    territoryCode
    ct
    ut
    heading
  }
}
    `;

/**
 * __useBrickDetailQueryQuery__
 *
 * To run a query within a React component, call `useBrickDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrickDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrickDetailQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useBrickDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<BrickDetailQueryQuery, BrickDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrickDetailQueryQuery, BrickDetailQueryQueryVariables>(BrickDetailQueryDocument, options);
      }
export function useBrickDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrickDetailQueryQuery, BrickDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrickDetailQueryQuery, BrickDetailQueryQueryVariables>(BrickDetailQueryDocument, options);
        }
export type BrickDetailQueryQueryHookResult = ReturnType<typeof useBrickDetailQueryQuery>;
export type BrickDetailQueryLazyQueryHookResult = ReturnType<typeof useBrickDetailQueryLazyQuery>;
export type BrickDetailQueryQueryResult = Apollo.QueryResult<BrickDetailQueryQuery, BrickDetailQueryQueryVariables>;
export const BrickTableQueryDocument = gql`
    query BrickTableQuery($criteria: BrickCriteria) {
  connection: bricks(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...BrickTableFragment
    }
  }
}
    ${BrickTableFragmentFragmentDoc}`;

/**
 * __useBrickTableQueryQuery__
 *
 * To run a query within a React component, call `useBrickTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrickTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrickTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useBrickTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<BrickTableQueryQuery, BrickTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrickTableQueryQuery, BrickTableQueryQueryVariables>(BrickTableQueryDocument, options);
      }
export function useBrickTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrickTableQueryQuery, BrickTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrickTableQueryQuery, BrickTableQueryQueryVariables>(BrickTableQueryDocument, options);
        }
export type BrickTableQueryQueryHookResult = ReturnType<typeof useBrickTableQueryQuery>;
export type BrickTableQueryLazyQueryHookResult = ReturnType<typeof useBrickTableQueryLazyQuery>;
export type BrickTableQueryQueryResult = Apollo.QueryResult<BrickTableQueryQuery, BrickTableQueryQueryVariables>;
export const AllDashboardItemsQueryDocument = gql`
    query AllDashboardItemsQuery {
  dashboardItems {
    hash
    nodes {
      code
      headingKey
      descriptionKey
    }
  }
}
    `;

/**
 * __useAllDashboardItemsQueryQuery__
 *
 * To run a query within a React component, call `useAllDashboardItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDashboardItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDashboardItemsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllDashboardItemsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AllDashboardItemsQueryQuery, AllDashboardItemsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDashboardItemsQueryQuery, AllDashboardItemsQueryQueryVariables>(AllDashboardItemsQueryDocument, options);
      }
export function useAllDashboardItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDashboardItemsQueryQuery, AllDashboardItemsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDashboardItemsQueryQuery, AllDashboardItemsQueryQueryVariables>(AllDashboardItemsQueryDocument, options);
        }
export type AllDashboardItemsQueryQueryHookResult = ReturnType<typeof useAllDashboardItemsQueryQuery>;
export type AllDashboardItemsQueryLazyQueryHookResult = ReturnType<typeof useAllDashboardItemsQueryLazyQuery>;
export type AllDashboardItemsQueryQueryResult = Apollo.QueryResult<AllDashboardItemsQueryQuery, AllDashboardItemsQueryQueryVariables>;
export const AddDashboardItemMutationDocument = gql`
    mutation AddDashboardItemMutation($dashboardId: Int!, $dashboardItemCode: String!) {
  addDashboardItem(
    dashboardId: $dashboardId
    dashboardItemCode: $dashboardItemCode
  ) {
    id
  }
}
    `;
export type AddDashboardItemMutationMutationFn = Apollo.MutationFunction<AddDashboardItemMutationMutation, AddDashboardItemMutationMutationVariables>;

/**
 * __useAddDashboardItemMutationMutation__
 *
 * To run a mutation, you first call `useAddDashboardItemMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDashboardItemMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDashboardItemMutationMutation, { data, loading, error }] = useAddDashboardItemMutationMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *      dashboardItemCode: // value for 'dashboardItemCode'
 *   },
 * });
 */
export function useAddDashboardItemMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddDashboardItemMutationMutation, AddDashboardItemMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDashboardItemMutationMutation, AddDashboardItemMutationMutationVariables>(AddDashboardItemMutationDocument, options);
      }
export type AddDashboardItemMutationMutationHookResult = ReturnType<typeof useAddDashboardItemMutationMutation>;
export type AddDashboardItemMutationMutationResult = Apollo.MutationResult<AddDashboardItemMutationMutation>;
export type AddDashboardItemMutationMutationOptions = Apollo.BaseMutationOptions<AddDashboardItemMutationMutation, AddDashboardItemMutationMutationVariables>;
export const DashboardItemsQueryDocument = gql`
    query DashboardItemsQuery($dashboardId: Int!) {
  dashboard(id: $dashboardId) {
    id
    isDefaultDashboard
    dashboardItemConfigurations {
      hash
      nodes {
        id
        x
        y
        height
        width
        ...DashboardItemFragment
      }
    }
  }
}
    ${DashboardItemFragmentFragmentDoc}`;

/**
 * __useDashboardItemsQueryQuery__
 *
 * To run a query within a React component, call `useDashboardItemsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardItemsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardItemsQueryQuery({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useDashboardItemsQueryQuery(baseOptions: Apollo.QueryHookOptions<DashboardItemsQueryQuery, DashboardItemsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardItemsQueryQuery, DashboardItemsQueryQueryVariables>(DashboardItemsQueryDocument, options);
      }
export function useDashboardItemsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardItemsQueryQuery, DashboardItemsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardItemsQueryQuery, DashboardItemsQueryQueryVariables>(DashboardItemsQueryDocument, options);
        }
export type DashboardItemsQueryQueryHookResult = ReturnType<typeof useDashboardItemsQueryQuery>;
export type DashboardItemsQueryLazyQueryHookResult = ReturnType<typeof useDashboardItemsQueryLazyQuery>;
export type DashboardItemsQueryQueryResult = Apollo.QueryResult<DashboardItemsQueryQuery, DashboardItemsQueryQueryVariables>;
export const UpdateGridPositionsMutationDocument = gql`
    mutation UpdateGridPositionsMutation($input: DashboardItemConfigurationInput!) {
  updateDashboardItems(input: $input) {
    id
  }
}
    `;
export type UpdateGridPositionsMutationMutationFn = Apollo.MutationFunction<UpdateGridPositionsMutationMutation, UpdateGridPositionsMutationMutationVariables>;

/**
 * __useUpdateGridPositionsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateGridPositionsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGridPositionsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGridPositionsMutationMutation, { data, loading, error }] = useUpdateGridPositionsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGridPositionsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGridPositionsMutationMutation, UpdateGridPositionsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGridPositionsMutationMutation, UpdateGridPositionsMutationMutationVariables>(UpdateGridPositionsMutationDocument, options);
      }
export type UpdateGridPositionsMutationMutationHookResult = ReturnType<typeof useUpdateGridPositionsMutationMutation>;
export type UpdateGridPositionsMutationMutationResult = Apollo.MutationResult<UpdateGridPositionsMutationMutation>;
export type UpdateGridPositionsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateGridPositionsMutationMutation, UpdateGridPositionsMutationMutationVariables>;
export const CreateNewDashboardMutationDocument = gql`
    mutation CreateNewDashboardMutation($title: String!) {
  createNewDashboard(title: $title) {
    id
  }
}
    `;
export type CreateNewDashboardMutationMutationFn = Apollo.MutationFunction<CreateNewDashboardMutationMutation, CreateNewDashboardMutationMutationVariables>;

/**
 * __useCreateNewDashboardMutationMutation__
 *
 * To run a mutation, you first call `useCreateNewDashboardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewDashboardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewDashboardMutationMutation, { data, loading, error }] = useCreateNewDashboardMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateNewDashboardMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewDashboardMutationMutation, CreateNewDashboardMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewDashboardMutationMutation, CreateNewDashboardMutationMutationVariables>(CreateNewDashboardMutationDocument, options);
      }
export type CreateNewDashboardMutationMutationHookResult = ReturnType<typeof useCreateNewDashboardMutationMutation>;
export type CreateNewDashboardMutationMutationResult = Apollo.MutationResult<CreateNewDashboardMutationMutation>;
export type CreateNewDashboardMutationMutationOptions = Apollo.BaseMutationOptions<CreateNewDashboardMutationMutation, CreateNewDashboardMutationMutationVariables>;
export const DisableDashboardMutationDocument = gql`
    mutation DisableDashboardMutation($dashboardId: Int!) {
  RemoveDashboard(dashboardId: $dashboardId) {
    id
  }
}
    `;
export type DisableDashboardMutationMutationFn = Apollo.MutationFunction<DisableDashboardMutationMutation, DisableDashboardMutationMutationVariables>;

/**
 * __useDisableDashboardMutationMutation__
 *
 * To run a mutation, you first call `useDisableDashboardMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDashboardMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDashboardMutationMutation, { data, loading, error }] = useDisableDashboardMutationMutation({
 *   variables: {
 *      dashboardId: // value for 'dashboardId'
 *   },
 * });
 */
export function useDisableDashboardMutationMutation(baseOptions?: Apollo.MutationHookOptions<DisableDashboardMutationMutation, DisableDashboardMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableDashboardMutationMutation, DisableDashboardMutationMutationVariables>(DisableDashboardMutationDocument, options);
      }
export type DisableDashboardMutationMutationHookResult = ReturnType<typeof useDisableDashboardMutationMutation>;
export type DisableDashboardMutationMutationResult = Apollo.MutationResult<DisableDashboardMutationMutation>;
export type DisableDashboardMutationMutationOptions = Apollo.BaseMutationOptions<DisableDashboardMutationMutation, DisableDashboardMutationMutationVariables>;
export const DashboardViewQueryDocument = gql`
    query DashboardViewQuery {
  viewer {
    id
    dashboards {
      hash
      nodes {
        id
        headingKey
        isDefaultDashboard
        dashboardItemConfigurations {
          hash
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardViewQueryQuery__
 *
 * To run a query within a React component, call `useDashboardViewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardViewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardViewQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardViewQueryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>(DashboardViewQueryDocument, options);
      }
export function useDashboardViewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>(DashboardViewQueryDocument, options);
        }
export type DashboardViewQueryQueryHookResult = ReturnType<typeof useDashboardViewQueryQuery>;
export type DashboardViewQueryLazyQueryHookResult = ReturnType<typeof useDashboardViewQueryLazyQuery>;
export type DashboardViewQueryQueryResult = Apollo.QueryResult<DashboardViewQueryQuery, DashboardViewQueryQueryVariables>;
export const ManageGroupDcrMutationDocument = gql`
    mutation ManageGroupDcrMutation($id: Int!, $maintainRecord: Boolean!, $isMdmEnabled: Boolean!) {
  manageGroupDcrMutation(
    groupId: $id
    maintainRecord: $maintainRecord
    isMdmEnabled: $isMdmEnabled
  ) {
    id
  }
}
    `;
export type ManageGroupDcrMutationMutationFn = Apollo.MutationFunction<ManageGroupDcrMutationMutation, ManageGroupDcrMutationMutationVariables>;

/**
 * __useManageGroupDcrMutationMutation__
 *
 * To run a mutation, you first call `useManageGroupDcrMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageGroupDcrMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageGroupDcrMutationMutation, { data, loading, error }] = useManageGroupDcrMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      maintainRecord: // value for 'maintainRecord'
 *      isMdmEnabled: // value for 'isMdmEnabled'
 *   },
 * });
 */
export function useManageGroupDcrMutationMutation(baseOptions?: Apollo.MutationHookOptions<ManageGroupDcrMutationMutation, ManageGroupDcrMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageGroupDcrMutationMutation, ManageGroupDcrMutationMutationVariables>(ManageGroupDcrMutationDocument, options);
      }
export type ManageGroupDcrMutationMutationHookResult = ReturnType<typeof useManageGroupDcrMutationMutation>;
export type ManageGroupDcrMutationMutationResult = Apollo.MutationResult<ManageGroupDcrMutationMutation>;
export type ManageGroupDcrMutationMutationOptions = Apollo.BaseMutationOptions<ManageGroupDcrMutationMutation, ManageGroupDcrMutationMutationVariables>;
export const DcrGroupDetailDocument = gql`
    query DcrGroupDetail($id: Int!) {
  hasAccessToModule(module: MDM)
  dcrGroup(id: $id) {
    id
    ct
    areYouDcrOwner
    responsibleUserId
    isDcrGroupKeptAsLocalRecord
    GroupComment {
      id
      byUserId
      comment
      ct
      ut
    }
    responses {
      hash
      nodes {
        id
        comment: responseComment
        ct
        responseTypeEnum
        dcrNoteTemplate {
          id
          key
          status
          sort
          addedBy
          ct
          ut
        }
        user {
          id
          fullname
        }
      }
    }
    responsibleUser {
      id
      fullname
    }
    responseStatus {
      id
      responseTypeCode
      responseTypeEnum
      responseComment
    }
    dcrs {
      hash
      totalCount
      nodes {
        id
        requestTypeEnum
        dcrSnapshotInfo {
          id
          dcrId
          entityAffiliationId
          entityTypeEnum
          affiliationEntity(nullIfMissingPermission: true) {
            id
            ... on Activity {
              heading
            }
            ... on List {
              title
              isShared
              createdUser {
                id
                fullname
              }
              listType {
                id
                heading
                code
              }
            }
          }
        }
        entityTypeEnum
        requestTypeEnum
        requestType {
          code
          heading
        }
        ct
        entityAffiliationId
        ut
        lines {
          hash
          totalCount
          nodes {
            id
            newValue
            dcrNewValue
            dcrOldValue
            newValueMapped
            oldValueMapped
            oldValue
            fieldCode
            fieldLabel
            fieldLabelKey
          }
        }
        affiliationEntity {
          id
          ... on Person {
            fullName
          }
          ... on Site {
            name
          }
          ... on SitePerson {
            siteId
            persId
            position {
              code
              type
              label
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDcrGroupDetailQuery__
 *
 * To run a query within a React component, call `useDcrGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcrGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcrGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDcrGroupDetailQuery(baseOptions: Apollo.QueryHookOptions<DcrGroupDetailQuery, DcrGroupDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcrGroupDetailQuery, DcrGroupDetailQueryVariables>(DcrGroupDetailDocument, options);
      }
export function useDcrGroupDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcrGroupDetailQuery, DcrGroupDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcrGroupDetailQuery, DcrGroupDetailQueryVariables>(DcrGroupDetailDocument, options);
        }
export type DcrGroupDetailQueryHookResult = ReturnType<typeof useDcrGroupDetailQuery>;
export type DcrGroupDetailLazyQueryHookResult = ReturnType<typeof useDcrGroupDetailLazyQuery>;
export type DcrGroupDetailQueryResult = Apollo.QueryResult<DcrGroupDetailQuery, DcrGroupDetailQueryVariables>;
export const DCRGroupTableQueryDocument = gql`
    query DCRGroupTableQuery($criteria: DcrGroupCriteria) {
  connection: dcrGroups(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...DcrGroupTableFragment
    }
  }
}
    ${DcrGroupTableFragmentFragmentDoc}`;

/**
 * __useDCRGroupTableQueryQuery__
 *
 * To run a query within a React component, call `useDCRGroupTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDCRGroupTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDCRGroupTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useDCRGroupTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<DCRGroupTableQueryQuery, DCRGroupTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DCRGroupTableQueryQuery, DCRGroupTableQueryQueryVariables>(DCRGroupTableQueryDocument, options);
      }
export function useDCRGroupTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DCRGroupTableQueryQuery, DCRGroupTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DCRGroupTableQueryQuery, DCRGroupTableQueryQueryVariables>(DCRGroupTableQueryDocument, options);
        }
export type DCRGroupTableQueryQueryHookResult = ReturnType<typeof useDCRGroupTableQueryQuery>;
export type DCRGroupTableQueryLazyQueryHookResult = ReturnType<typeof useDCRGroupTableQueryLazyQuery>;
export type DCRGroupTableQueryQueryResult = Apollo.QueryResult<DCRGroupTableQueryQuery, DCRGroupTableQueryQueryVariables>;
export const DCRGroupRecordQueryDocument = gql`
    query DCRGroupRecordQuery($recordId: Int!) {
  record: dcrGroup(id: $recordId) {
    id
    ...DcrGroupTableFragment
  }
}
    ${DcrGroupTableFragmentFragmentDoc}`;

/**
 * __useDCRGroupRecordQueryQuery__
 *
 * To run a query within a React component, call `useDCRGroupRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDCRGroupRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDCRGroupRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useDCRGroupRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<DCRGroupRecordQueryQuery, DCRGroupRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DCRGroupRecordQueryQuery, DCRGroupRecordQueryQueryVariables>(DCRGroupRecordQueryDocument, options);
      }
export function useDCRGroupRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DCRGroupRecordQueryQuery, DCRGroupRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DCRGroupRecordQueryQuery, DCRGroupRecordQueryQueryVariables>(DCRGroupRecordQueryDocument, options);
        }
export type DCRGroupRecordQueryQueryHookResult = ReturnType<typeof useDCRGroupRecordQueryQuery>;
export type DCRGroupRecordQueryLazyQueryHookResult = ReturnType<typeof useDCRGroupRecordQueryLazyQuery>;
export type DCRGroupRecordQueryQueryResult = Apollo.QueryResult<DCRGroupRecordQueryQuery, DCRGroupRecordQueryQueryVariables>;
export const ClearLinkMutationDocument = gql`
    mutation ClearLinkMutation($hcoId: Int!) {
  setSitePersonActiveStatus(id: $hcoId, isActive: false) {
    id
    isActive
  }
}
    `;
export type ClearLinkMutationMutationFn = Apollo.MutationFunction<ClearLinkMutationMutation, ClearLinkMutationMutationVariables>;

/**
 * __useClearLinkMutationMutation__
 *
 * To run a mutation, you first call `useClearLinkMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearLinkMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearLinkMutationMutation, { data, loading, error }] = useClearLinkMutationMutation({
 *   variables: {
 *      hcoId: // value for 'hcoId'
 *   },
 * });
 */
export function useClearLinkMutationMutation(baseOptions?: Apollo.MutationHookOptions<ClearLinkMutationMutation, ClearLinkMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearLinkMutationMutation, ClearLinkMutationMutationVariables>(ClearLinkMutationDocument, options);
      }
export type ClearLinkMutationMutationHookResult = ReturnType<typeof useClearLinkMutationMutation>;
export type ClearLinkMutationMutationResult = Apollo.MutationResult<ClearLinkMutationMutation>;
export type ClearLinkMutationMutationOptions = Apollo.BaseMutationOptions<ClearLinkMutationMutation, ClearLinkMutationMutationVariables>;
export const ClearHcpMutationDocument = gql`
    mutation ClearHcpMutation($hcpId: Int!, $isChecked: Boolean!) {
  inactivateHcpAndActivityAffiliations(
    persId: $hcpId
    removeAffiliations: $isChecked
  ) {
    id
    isActive
  }
}
    `;
export type ClearHcpMutationMutationFn = Apollo.MutationFunction<ClearHcpMutationMutation, ClearHcpMutationMutationVariables>;

/**
 * __useClearHcpMutationMutation__
 *
 * To run a mutation, you first call `useClearHcpMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearHcpMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearHcpMutationMutation, { data, loading, error }] = useClearHcpMutationMutation({
 *   variables: {
 *      hcpId: // value for 'hcpId'
 *      isChecked: // value for 'isChecked'
 *   },
 * });
 */
export function useClearHcpMutationMutation(baseOptions?: Apollo.MutationHookOptions<ClearHcpMutationMutation, ClearHcpMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearHcpMutationMutation, ClearHcpMutationMutationVariables>(ClearHcpMutationDocument, options);
      }
export type ClearHcpMutationMutationHookResult = ReturnType<typeof useClearHcpMutationMutation>;
export type ClearHcpMutationMutationResult = Apollo.MutationResult<ClearHcpMutationMutation>;
export type ClearHcpMutationMutationOptions = Apollo.BaseMutationOptions<ClearHcpMutationMutation, ClearHcpMutationMutationVariables>;
export const ClearHopMutationDocument = gql`
    mutation ClearHopMutation($hcoId: Int!) {
  setSiteActiveStatus(siteId: $hcoId, isActive: false) {
    id
    isActive
  }
}
    `;
export type ClearHopMutationMutationFn = Apollo.MutationFunction<ClearHopMutationMutation, ClearHopMutationMutationVariables>;

/**
 * __useClearHopMutationMutation__
 *
 * To run a mutation, you first call `useClearHopMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearHopMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearHopMutationMutation, { data, loading, error }] = useClearHopMutationMutation({
 *   variables: {
 *      hcoId: // value for 'hcoId'
 *   },
 * });
 */
export function useClearHopMutationMutation(baseOptions?: Apollo.MutationHookOptions<ClearHopMutationMutation, ClearHopMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearHopMutationMutation, ClearHopMutationMutationVariables>(ClearHopMutationDocument, options);
      }
export type ClearHopMutationMutationHookResult = ReturnType<typeof useClearHopMutationMutation>;
export type ClearHopMutationMutationResult = Apollo.MutationResult<ClearHopMutationMutation>;
export type ClearHopMutationMutationOptions = Apollo.BaseMutationOptions<ClearHopMutationMutation, ClearHopMutationMutationVariables>;
export const DcrGroupHeadingQueryDocument = gql`
    query DcrGroupHeadingQuery($groupId: Int!) {
  dcrGroup(id: $groupId) {
    id
    ...DcrGroupHeadingFragment
  }
}
    ${DcrGroupHeadingFragmentFragmentDoc}`;

/**
 * __useDcrGroupHeadingQueryQuery__
 *
 * To run a query within a React component, call `useDcrGroupHeadingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDcrGroupHeadingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDcrGroupHeadingQueryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDcrGroupHeadingQueryQuery(baseOptions: Apollo.QueryHookOptions<DcrGroupHeadingQueryQuery, DcrGroupHeadingQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DcrGroupHeadingQueryQuery, DcrGroupHeadingQueryQueryVariables>(DcrGroupHeadingQueryDocument, options);
      }
export function useDcrGroupHeadingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DcrGroupHeadingQueryQuery, DcrGroupHeadingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DcrGroupHeadingQueryQuery, DcrGroupHeadingQueryQueryVariables>(DcrGroupHeadingQueryDocument, options);
        }
export type DcrGroupHeadingQueryQueryHookResult = ReturnType<typeof useDcrGroupHeadingQueryQuery>;
export type DcrGroupHeadingQueryLazyQueryHookResult = ReturnType<typeof useDcrGroupHeadingQueryLazyQuery>;
export type DcrGroupHeadingQueryQueryResult = Apollo.QueryResult<DcrGroupHeadingQueryQuery, DcrGroupHeadingQueryQueryVariables>;
export const FinishedImportProjectDetailsQueryDocument = gql`
    query FinishedImportProjectDetailsQuery($projectId: Int!) {
  importProject(id: $projectId) {
    id
    effects {
      hash
      nodes {
        id
        actionType
        entityType
        note
        affiliationEntity {
          id
          ... on ActivityBrand {
            activity {
              id
              title: heading
            }
            productBrand {
              id
              name
            }
          }
          ... on Activity {
            title: heading
          }
          ... on Brand {
            id
            name
          }
          ... on Project {
            id
            title
          }
          ... on User {
            id
            fullname
          }
          ... on Person {
            id
            fullname: fullName
          }
          ... on Site {
            id
            name
          }
          ... on ActivityProduct {
            id
            activity {
              id
              title: heading
            }
            product {
              id
              heading
            }
          }
          ... on CustomValue {
            id
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFinishedImportProjectDetailsQueryQuery__
 *
 * To run a query within a React component, call `useFinishedImportProjectDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedImportProjectDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishedImportProjectDetailsQueryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFinishedImportProjectDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<FinishedImportProjectDetailsQueryQuery, FinishedImportProjectDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinishedImportProjectDetailsQueryQuery, FinishedImportProjectDetailsQueryQueryVariables>(FinishedImportProjectDetailsQueryDocument, options);
      }
export function useFinishedImportProjectDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinishedImportProjectDetailsQueryQuery, FinishedImportProjectDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinishedImportProjectDetailsQueryQuery, FinishedImportProjectDetailsQueryQueryVariables>(FinishedImportProjectDetailsQueryDocument, options);
        }
export type FinishedImportProjectDetailsQueryQueryHookResult = ReturnType<typeof useFinishedImportProjectDetailsQueryQuery>;
export type FinishedImportProjectDetailsQueryLazyQueryHookResult = ReturnType<typeof useFinishedImportProjectDetailsQueryLazyQuery>;
export type FinishedImportProjectDetailsQueryQueryResult = Apollo.QueryResult<FinishedImportProjectDetailsQueryQuery, FinishedImportProjectDetailsQueryQueryVariables>;
export const ImportProjectDetailsQueryDocument = gql`
    query ImportProjectDetailsQuery($id: Int!) {
  project: importProject(id: $id) {
    id
    heading
    currentPhase {
      id
      heading
    }
  }
}
    `;

/**
 * __useImportProjectDetailsQueryQuery__
 *
 * To run a query within a React component, call `useImportProjectDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportProjectDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportProjectDetailsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useImportProjectDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<ImportProjectDetailsQueryQuery, ImportProjectDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportProjectDetailsQueryQuery, ImportProjectDetailsQueryQueryVariables>(ImportProjectDetailsQueryDocument, options);
      }
export function useImportProjectDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportProjectDetailsQueryQuery, ImportProjectDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportProjectDetailsQueryQuery, ImportProjectDetailsQueryQueryVariables>(ImportProjectDetailsQueryDocument, options);
        }
export type ImportProjectDetailsQueryQueryHookResult = ReturnType<typeof useImportProjectDetailsQueryQuery>;
export type ImportProjectDetailsQueryLazyQueryHookResult = ReturnType<typeof useImportProjectDetailsQueryLazyQuery>;
export type ImportProjectDetailsQueryQueryResult = Apollo.QueryResult<ImportProjectDetailsQueryQuery, ImportProjectDetailsQueryQueryVariables>;
export const BasicImportProjectStatusDocument = gql`
    query BasicImportProjectStatus($projectId: Int!) {
  importProject(id: $projectId) {
    id
    statusCode
  }
}
    `;

/**
 * __useBasicImportProjectStatusQuery__
 *
 * To run a query within a React component, call `useBasicImportProjectStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicImportProjectStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicImportProjectStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBasicImportProjectStatusQuery(baseOptions: Apollo.QueryHookOptions<BasicImportProjectStatusQuery, BasicImportProjectStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BasicImportProjectStatusQuery, BasicImportProjectStatusQueryVariables>(BasicImportProjectStatusDocument, options);
      }
export function useBasicImportProjectStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BasicImportProjectStatusQuery, BasicImportProjectStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BasicImportProjectStatusQuery, BasicImportProjectStatusQueryVariables>(BasicImportProjectStatusDocument, options);
        }
export type BasicImportProjectStatusQueryHookResult = ReturnType<typeof useBasicImportProjectStatusQuery>;
export type BasicImportProjectStatusLazyQueryHookResult = ReturnType<typeof useBasicImportProjectStatusLazyQuery>;
export type BasicImportProjectStatusQueryResult = Apollo.QueryResult<BasicImportProjectStatusQuery, BasicImportProjectStatusQueryVariables>;
export const CurrentImportProjectStateDocument = gql`
    query CurrentImportProjectState($projectId: Int!) {
  importProject(id: $projectId) {
    ...currentImportState
  }
}
    ${currentImportStateFragmentDoc}`;

/**
 * __useCurrentImportProjectStateQuery__
 *
 * To run a query within a React component, call `useCurrentImportProjectStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentImportProjectStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentImportProjectStateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCurrentImportProjectStateQuery(baseOptions: Apollo.QueryHookOptions<CurrentImportProjectStateQuery, CurrentImportProjectStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentImportProjectStateQuery, CurrentImportProjectStateQueryVariables>(CurrentImportProjectStateDocument, options);
      }
export function useCurrentImportProjectStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentImportProjectStateQuery, CurrentImportProjectStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentImportProjectStateQuery, CurrentImportProjectStateQueryVariables>(CurrentImportProjectStateDocument, options);
        }
export type CurrentImportProjectStateQueryHookResult = ReturnType<typeof useCurrentImportProjectStateQuery>;
export type CurrentImportProjectStateLazyQueryHookResult = ReturnType<typeof useCurrentImportProjectStateLazyQuery>;
export type CurrentImportProjectStateQueryResult = Apollo.QueryResult<CurrentImportProjectStateQuery, CurrentImportProjectStateQueryVariables>;
export const StartImportProjectDocument = gql`
    mutation StartImportProject($projectId: Int!) {
  startImportProject(id: $projectId) {
    ...currentImportState
  }
}
    ${currentImportStateFragmentDoc}`;
export type StartImportProjectMutationFn = Apollo.MutationFunction<StartImportProjectMutation, StartImportProjectMutationVariables>;

/**
 * __useStartImportProjectMutation__
 *
 * To run a mutation, you first call `useStartImportProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImportProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImportProjectMutation, { data, loading, error }] = useStartImportProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useStartImportProjectMutation(baseOptions?: Apollo.MutationHookOptions<StartImportProjectMutation, StartImportProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartImportProjectMutation, StartImportProjectMutationVariables>(StartImportProjectDocument, options);
      }
export type StartImportProjectMutationHookResult = ReturnType<typeof useStartImportProjectMutation>;
export type StartImportProjectMutationResult = Apollo.MutationResult<StartImportProjectMutation>;
export type StartImportProjectMutationOptions = Apollo.BaseMutationOptions<StartImportProjectMutation, StartImportProjectMutationVariables>;
export const ManualPersonMatchingDataDocument = gql`
    query ManualPersonMatchingData {
  contactCategories {
    hash
    nodes {
      code
      heading
      type: typeEnum
      entityType
    }
  }
  addressTypes {
    hash
    nodes {
      code
      headingKey
      entityType
    }
  }
}
    `;

/**
 * __useManualPersonMatchingDataQuery__
 *
 * To run a query within a React component, call `useManualPersonMatchingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useManualPersonMatchingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManualPersonMatchingDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useManualPersonMatchingDataQuery(baseOptions?: Apollo.QueryHookOptions<ManualPersonMatchingDataQuery, ManualPersonMatchingDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManualPersonMatchingDataQuery, ManualPersonMatchingDataQueryVariables>(ManualPersonMatchingDataDocument, options);
      }
export function useManualPersonMatchingDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManualPersonMatchingDataQuery, ManualPersonMatchingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManualPersonMatchingDataQuery, ManualPersonMatchingDataQueryVariables>(ManualPersonMatchingDataDocument, options);
        }
export type ManualPersonMatchingDataQueryHookResult = ReturnType<typeof useManualPersonMatchingDataQuery>;
export type ManualPersonMatchingDataLazyQueryHookResult = ReturnType<typeof useManualPersonMatchingDataLazyQuery>;
export type ManualPersonMatchingDataQueryResult = Apollo.QueryResult<ManualPersonMatchingDataQuery, ManualPersonMatchingDataQueryVariables>;
export const SelectExternalSystemForImportDocument = gql`
    query SelectExternalSystemForImport {
  externalIdSystems {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useSelectExternalSystemForImportQuery__
 *
 * To run a query within a React component, call `useSelectExternalSystemForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectExternalSystemForImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectExternalSystemForImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectExternalSystemForImportQuery(baseOptions?: Apollo.QueryHookOptions<SelectExternalSystemForImportQuery, SelectExternalSystemForImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectExternalSystemForImportQuery, SelectExternalSystemForImportQueryVariables>(SelectExternalSystemForImportDocument, options);
      }
export function useSelectExternalSystemForImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectExternalSystemForImportQuery, SelectExternalSystemForImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectExternalSystemForImportQuery, SelectExternalSystemForImportQueryVariables>(SelectExternalSystemForImportDocument, options);
        }
export type SelectExternalSystemForImportQueryHookResult = ReturnType<typeof useSelectExternalSystemForImportQuery>;
export type SelectExternalSystemForImportLazyQueryHookResult = ReturnType<typeof useSelectExternalSystemForImportLazyQuery>;
export type SelectExternalSystemForImportQueryResult = Apollo.QueryResult<SelectExternalSystemForImportQuery, SelectExternalSystemForImportQueryVariables>;
export const SaveSelectedExternalSystemDocument = gql`
    mutation SaveSelectedExternalSystem($processorId: Int!, $projectId: Int!, $value: String) {
  saveImportProcessorData(
    key: "SelectExternalSystem"
    processorId: $processorId
    projectId: $projectId
    value: $value
  ) {
    id
    value
  }
}
    `;
export type SaveSelectedExternalSystemMutationFn = Apollo.MutationFunction<SaveSelectedExternalSystemMutation, SaveSelectedExternalSystemMutationVariables>;

/**
 * __useSaveSelectedExternalSystemMutation__
 *
 * To run a mutation, you first call `useSaveSelectedExternalSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSelectedExternalSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSelectedExternalSystemMutation, { data, loading, error }] = useSaveSelectedExternalSystemMutation({
 *   variables: {
 *      processorId: // value for 'processorId'
 *      projectId: // value for 'projectId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveSelectedExternalSystemMutation(baseOptions?: Apollo.MutationHookOptions<SaveSelectedExternalSystemMutation, SaveSelectedExternalSystemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSelectedExternalSystemMutation, SaveSelectedExternalSystemMutationVariables>(SaveSelectedExternalSystemDocument, options);
      }
export type SaveSelectedExternalSystemMutationHookResult = ReturnType<typeof useSaveSelectedExternalSystemMutation>;
export type SaveSelectedExternalSystemMutationResult = Apollo.MutationResult<SaveSelectedExternalSystemMutation>;
export type SaveSelectedExternalSystemMutationOptions = Apollo.BaseMutationOptions<SaveSelectedExternalSystemMutation, SaveSelectedExternalSystemMutationVariables>;
export const SaveImportLineProcessDocument = gql`
    mutation SaveImportLineProcess($input: ImportSaveProcessInput!) {
  saveImportLineProcess(input: $input) {
    id
  }
}
    `;
export type SaveImportLineProcessMutationFn = Apollo.MutationFunction<SaveImportLineProcessMutation, SaveImportLineProcessMutationVariables>;

/**
 * __useSaveImportLineProcessMutation__
 *
 * To run a mutation, you first call `useSaveImportLineProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveImportLineProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveImportLineProcessMutation, { data, loading, error }] = useSaveImportLineProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveImportLineProcessMutation(baseOptions?: Apollo.MutationHookOptions<SaveImportLineProcessMutation, SaveImportLineProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveImportLineProcessMutation, SaveImportLineProcessMutationVariables>(SaveImportLineProcessDocument, options);
      }
export type SaveImportLineProcessMutationHookResult = ReturnType<typeof useSaveImportLineProcessMutation>;
export type SaveImportLineProcessMutationResult = Apollo.MutationResult<SaveImportLineProcessMutation>;
export type SaveImportLineProcessMutationOptions = Apollo.BaseMutationOptions<SaveImportLineProcessMutation, SaveImportLineProcessMutationVariables>;
export const SkipImportLineProcessDocument = gql`
    mutation SkipImportLineProcess($input: ImportSkipProcessInput!) {
  skipImportLineProcess(input: $input) {
    id
  }
}
    `;
export type SkipImportLineProcessMutationFn = Apollo.MutationFunction<SkipImportLineProcessMutation, SkipImportLineProcessMutationVariables>;

/**
 * __useSkipImportLineProcessMutation__
 *
 * To run a mutation, you first call `useSkipImportLineProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipImportLineProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipImportLineProcessMutation, { data, loading, error }] = useSkipImportLineProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipImportLineProcessMutation(baseOptions?: Apollo.MutationHookOptions<SkipImportLineProcessMutation, SkipImportLineProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipImportLineProcessMutation, SkipImportLineProcessMutationVariables>(SkipImportLineProcessDocument, options);
      }
export type SkipImportLineProcessMutationHookResult = ReturnType<typeof useSkipImportLineProcessMutation>;
export type SkipImportLineProcessMutationResult = Apollo.MutationResult<SkipImportLineProcessMutation>;
export type SkipImportLineProcessMutationOptions = Apollo.BaseMutationOptions<SkipImportLineProcessMutation, SkipImportLineProcessMutationVariables>;
export const PersonCustomFieldsForImportDocument = gql`
    query PersonCustomFieldsForImport {
  customFields(criteria: {entityType: PERSON, isActive: true}) {
    hash
    nodes {
      code
      heading
      fieldTypeEnum
      allowMultiple
      allowUserCreate
    }
  }
}
    `;

/**
 * __usePersonCustomFieldsForImportQuery__
 *
 * To run a query within a React component, call `usePersonCustomFieldsForImportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonCustomFieldsForImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonCustomFieldsForImportQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonCustomFieldsForImportQuery(baseOptions?: Apollo.QueryHookOptions<PersonCustomFieldsForImportQuery, PersonCustomFieldsForImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonCustomFieldsForImportQuery, PersonCustomFieldsForImportQueryVariables>(PersonCustomFieldsForImportDocument, options);
      }
export function usePersonCustomFieldsForImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonCustomFieldsForImportQuery, PersonCustomFieldsForImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonCustomFieldsForImportQuery, PersonCustomFieldsForImportQueryVariables>(PersonCustomFieldsForImportDocument, options);
        }
export type PersonCustomFieldsForImportQueryHookResult = ReturnType<typeof usePersonCustomFieldsForImportQuery>;
export type PersonCustomFieldsForImportLazyQueryHookResult = ReturnType<typeof usePersonCustomFieldsForImportLazyQuery>;
export type PersonCustomFieldsForImportQueryResult = Apollo.QueryResult<PersonCustomFieldsForImportQuery, PersonCustomFieldsForImportQueryVariables>;
export const ImportTemplatesDocument = gql`
    query ImportTemplates {
  importTemplates {
    hash
    totalCount
    nodes {
      id
      name
      note
      processes {
        hash
        nodes {
          id
          processorId
          processorDataKey
          requiresCustomFieldsImportMapping
          heading
          note
          sort
          fields {
            hash
            nodes {
              id
              lineDataIndex
              field {
                code
                heading
                note
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useImportTemplatesQuery__
 *
 * To run a query within a React component, call `useImportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useImportTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ImportTemplatesQuery, ImportTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportTemplatesQuery, ImportTemplatesQueryVariables>(ImportTemplatesDocument, options);
      }
export function useImportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportTemplatesQuery, ImportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportTemplatesQuery, ImportTemplatesQueryVariables>(ImportTemplatesDocument, options);
        }
export type ImportTemplatesQueryHookResult = ReturnType<typeof useImportTemplatesQuery>;
export type ImportTemplatesLazyQueryHookResult = ReturnType<typeof useImportTemplatesLazyQuery>;
export type ImportTemplatesQueryResult = Apollo.QueryResult<ImportTemplatesQuery, ImportTemplatesQueryVariables>;
export const SaveCustomFieldsImportMappingDocument = gql`
    mutation SaveCustomFieldsImportMapping($key: String!, $processorId: Int!, $projectId: Int!, $value: String) {
  saveImportProcessorData(
    key: $key
    processorId: $processorId
    projectId: $projectId
    value: $value
  ) {
    id
    value
  }
}
    `;
export type SaveCustomFieldsImportMappingMutationFn = Apollo.MutationFunction<SaveCustomFieldsImportMappingMutation, SaveCustomFieldsImportMappingMutationVariables>;

/**
 * __useSaveCustomFieldsImportMappingMutation__
 *
 * To run a mutation, you first call `useSaveCustomFieldsImportMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomFieldsImportMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomFieldsImportMappingMutation, { data, loading, error }] = useSaveCustomFieldsImportMappingMutation({
 *   variables: {
 *      key: // value for 'key'
 *      processorId: // value for 'processorId'
 *      projectId: // value for 'projectId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSaveCustomFieldsImportMappingMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomFieldsImportMappingMutation, SaveCustomFieldsImportMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomFieldsImportMappingMutation, SaveCustomFieldsImportMappingMutationVariables>(SaveCustomFieldsImportMappingDocument, options);
      }
export type SaveCustomFieldsImportMappingMutationHookResult = ReturnType<typeof useSaveCustomFieldsImportMappingMutation>;
export type SaveCustomFieldsImportMappingMutationResult = Apollo.MutationResult<SaveCustomFieldsImportMappingMutation>;
export type SaveCustomFieldsImportMappingMutationOptions = Apollo.BaseMutationOptions<SaveCustomFieldsImportMappingMutation, SaveCustomFieldsImportMappingMutationVariables>;
export const FileValidationQueryDocument = gql`
    query FileValidationQuery($projectId: Int!) {
  delimiters
  charsets
  importProject(id: $projectId) {
    id
    linePreview(linesCount: 5) {
      projectId
      charset
      delimiter
      firstLineHeader
      columns {
        code
        label
        note
      }
      values {
        key
        values {
          index
          code
          value
        }
      }
    }
  }
}
    `;

/**
 * __useFileValidationQueryQuery__
 *
 * To run a query within a React component, call `useFileValidationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileValidationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileValidationQueryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useFileValidationQueryQuery(baseOptions: Apollo.QueryHookOptions<FileValidationQueryQuery, FileValidationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileValidationQueryQuery, FileValidationQueryQueryVariables>(FileValidationQueryDocument, options);
      }
export function useFileValidationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileValidationQueryQuery, FileValidationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileValidationQueryQuery, FileValidationQueryQueryVariables>(FileValidationQueryDocument, options);
        }
export type FileValidationQueryQueryHookResult = ReturnType<typeof useFileValidationQueryQuery>;
export type FileValidationQueryLazyQueryHookResult = ReturnType<typeof useFileValidationQueryLazyQuery>;
export type FileValidationQueryQueryResult = Apollo.QueryResult<FileValidationQueryQuery, FileValidationQueryQueryVariables>;
export const UpdateDelimiterOfFileDocument = gql`
    mutation UpdateDelimiterOfFile($importProjectId: ID!, $delimiter: DelimiterEnum!) {
  updateImportedFileSettings(
    importProjectId: $importProjectId
    delimiter: $delimiter
  ) {
    id
  }
}
    `;
export type UpdateDelimiterOfFileMutationFn = Apollo.MutationFunction<UpdateDelimiterOfFileMutation, UpdateDelimiterOfFileMutationVariables>;

/**
 * __useUpdateDelimiterOfFileMutation__
 *
 * To run a mutation, you first call `useUpdateDelimiterOfFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDelimiterOfFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDelimiterOfFileMutation, { data, loading, error }] = useUpdateDelimiterOfFileMutation({
 *   variables: {
 *      importProjectId: // value for 'importProjectId'
 *      delimiter: // value for 'delimiter'
 *   },
 * });
 */
export function useUpdateDelimiterOfFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDelimiterOfFileMutation, UpdateDelimiterOfFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDelimiterOfFileMutation, UpdateDelimiterOfFileMutationVariables>(UpdateDelimiterOfFileDocument, options);
      }
export type UpdateDelimiterOfFileMutationHookResult = ReturnType<typeof useUpdateDelimiterOfFileMutation>;
export type UpdateDelimiterOfFileMutationResult = Apollo.MutationResult<UpdateDelimiterOfFileMutation>;
export type UpdateDelimiterOfFileMutationOptions = Apollo.BaseMutationOptions<UpdateDelimiterOfFileMutation, UpdateDelimiterOfFileMutationVariables>;
export const UsersForUserMappingDocument = gql`
    query UsersForUserMapping {
  usersConnection: users {
    hash
    totalCount
    nodes {
      id
      firstname
      lastname
      email
    }
  }
}
    `;

/**
 * __useUsersForUserMappingQuery__
 *
 * To run a query within a React component, call `useUsersForUserMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForUserMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForUserMappingQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersForUserMappingQuery(baseOptions?: Apollo.QueryHookOptions<UsersForUserMappingQuery, UsersForUserMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForUserMappingQuery, UsersForUserMappingQueryVariables>(UsersForUserMappingDocument, options);
      }
export function useUsersForUserMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForUserMappingQuery, UsersForUserMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForUserMappingQuery, UsersForUserMappingQueryVariables>(UsersForUserMappingDocument, options);
        }
export type UsersForUserMappingQueryHookResult = ReturnType<typeof useUsersForUserMappingQuery>;
export type UsersForUserMappingLazyQueryHookResult = ReturnType<typeof useUsersForUserMappingLazyQuery>;
export type UsersForUserMappingQueryResult = Apollo.QueryResult<UsersForUserMappingQuery, UsersForUserMappingQueryVariables>;
export const LinkUserWithExternalIdDocument = gql`
    mutation LinkUserWithExternalId($input: ExternalIdMutationInput!) {
  setExternalId(input: $input) {
    id
  }
}
    `;
export type LinkUserWithExternalIdMutationFn = Apollo.MutationFunction<LinkUserWithExternalIdMutation, LinkUserWithExternalIdMutationVariables>;

/**
 * __useLinkUserWithExternalIdMutation__
 *
 * To run a mutation, you first call `useLinkUserWithExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUserWithExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUserWithExternalIdMutation, { data, loading, error }] = useLinkUserWithExternalIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkUserWithExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<LinkUserWithExternalIdMutation, LinkUserWithExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUserWithExternalIdMutation, LinkUserWithExternalIdMutationVariables>(LinkUserWithExternalIdDocument, options);
      }
export type LinkUserWithExternalIdMutationHookResult = ReturnType<typeof useLinkUserWithExternalIdMutation>;
export type LinkUserWithExternalIdMutationResult = Apollo.MutationResult<LinkUserWithExternalIdMutation>;
export type LinkUserWithExternalIdMutationOptions = Apollo.BaseMutationOptions<LinkUserWithExternalIdMutation, LinkUserWithExternalIdMutationVariables>;
export const DownloadPersonByApbIdDocument = gql`
    mutation DownloadPersonByApbId($apbId: Int!) {
  person: cherryPick(entityType: PERSON, apurebaseIds: [$apbId]) {
    id
  }
}
    `;
export type DownloadPersonByApbIdMutationFn = Apollo.MutationFunction<DownloadPersonByApbIdMutation, DownloadPersonByApbIdMutationVariables>;

/**
 * __useDownloadPersonByApbIdMutation__
 *
 * To run a mutation, you first call `useDownloadPersonByApbIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPersonByApbIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPersonByApbIdMutation, { data, loading, error }] = useDownloadPersonByApbIdMutation({
 *   variables: {
 *      apbId: // value for 'apbId'
 *   },
 * });
 */
export function useDownloadPersonByApbIdMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPersonByApbIdMutation, DownloadPersonByApbIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPersonByApbIdMutation, DownloadPersonByApbIdMutationVariables>(DownloadPersonByApbIdDocument, options);
      }
export type DownloadPersonByApbIdMutationHookResult = ReturnType<typeof useDownloadPersonByApbIdMutation>;
export type DownloadPersonByApbIdMutationResult = Apollo.MutationResult<DownloadPersonByApbIdMutation>;
export type DownloadPersonByApbIdMutationOptions = Apollo.BaseMutationOptions<DownloadPersonByApbIdMutation, DownloadPersonByApbIdMutationVariables>;
export const LinkHeaderDocument = gql`
    query LinkHeader($id: Int!) {
  sitePersonAffiliation(id: $id) {
    id
    apurebaseId
    countryCode
    yesIfIsPrimary
    isActive
    maintainerSourceCode
    person {
      id
      countryCode
      fullName
    }
    specialties {
      hash
      nodes {
        id
        specialty {
          code
          label
          type
          displayLabel
        }
      }
    }
    site {
      id
      name
    }
    position {
      code
      type
      label
      displayLabel
    }
  }
}
    `;

/**
 * __useLinkHeaderQuery__
 *
 * To run a query within a React component, call `useLinkHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLinkHeaderQuery(baseOptions: Apollo.QueryHookOptions<LinkHeaderQuery, LinkHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkHeaderQuery, LinkHeaderQueryVariables>(LinkHeaderDocument, options);
      }
export function useLinkHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkHeaderQuery, LinkHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkHeaderQuery, LinkHeaderQueryVariables>(LinkHeaderDocument, options);
        }
export type LinkHeaderQueryHookResult = ReturnType<typeof useLinkHeaderQuery>;
export type LinkHeaderLazyQueryHookResult = ReturnType<typeof useLinkHeaderLazyQuery>;
export type LinkHeaderQueryResult = Apollo.QueryResult<LinkHeaderQuery, LinkHeaderQueryVariables>;
export const SitePersonAffiliationNoteDetailQueryDocument = gql`
    query SitePersonAffiliationNoteDetailQuery($linkId: Int!) {
  sitePersonAffiliation(id: $linkId) {
    id
    notes {
      hash
      totalCount
      nodes {
        id
        ...NoteDrawerFragment
      }
    }
  }
}
    ${NoteDrawerFragmentFragmentDoc}`;

/**
 * __useSitePersonAffiliationNoteDetailQueryQuery__
 *
 * To run a query within a React component, call `useSitePersonAffiliationNoteDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePersonAffiliationNoteDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePersonAffiliationNoteDetailQueryQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useSitePersonAffiliationNoteDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<SitePersonAffiliationNoteDetailQueryQuery, SitePersonAffiliationNoteDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePersonAffiliationNoteDetailQueryQuery, SitePersonAffiliationNoteDetailQueryQueryVariables>(SitePersonAffiliationNoteDetailQueryDocument, options);
      }
export function useSitePersonAffiliationNoteDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePersonAffiliationNoteDetailQueryQuery, SitePersonAffiliationNoteDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePersonAffiliationNoteDetailQueryQuery, SitePersonAffiliationNoteDetailQueryQueryVariables>(SitePersonAffiliationNoteDetailQueryDocument, options);
        }
export type SitePersonAffiliationNoteDetailQueryQueryHookResult = ReturnType<typeof useSitePersonAffiliationNoteDetailQueryQuery>;
export type SitePersonAffiliationNoteDetailQueryLazyQueryHookResult = ReturnType<typeof useSitePersonAffiliationNoteDetailQueryLazyQuery>;
export type SitePersonAffiliationNoteDetailQueryQueryResult = Apollo.QueryResult<SitePersonAffiliationNoteDetailQueryQuery, SitePersonAffiliationNoteDetailQueryQueryVariables>;
export const LinkSelectionRowResultContainerDocument = gql`
    query LinkSelectionRowResultContainer($linkApureBaseID: Int!, $selectionType: SlicerSelectionType) {
  selectionImfCustomers(
    criteria: {linkApbIdInSelection: [$linkApureBaseID], selectionType: $selectionType}
  ) {
    hash
    nodes {
      code
      callName
      name
    }
  }
}
    `;

/**
 * __useLinkSelectionRowResultContainerQuery__
 *
 * To run a query within a React component, call `useLinkSelectionRowResultContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkSelectionRowResultContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkSelectionRowResultContainerQuery({
 *   variables: {
 *      linkApureBaseID: // value for 'linkApureBaseID'
 *      selectionType: // value for 'selectionType'
 *   },
 * });
 */
export function useLinkSelectionRowResultContainerQuery(baseOptions: Apollo.QueryHookOptions<LinkSelectionRowResultContainerQuery, LinkSelectionRowResultContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkSelectionRowResultContainerQuery, LinkSelectionRowResultContainerQueryVariables>(LinkSelectionRowResultContainerDocument, options);
      }
export function useLinkSelectionRowResultContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkSelectionRowResultContainerQuery, LinkSelectionRowResultContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkSelectionRowResultContainerQuery, LinkSelectionRowResultContainerQueryVariables>(LinkSelectionRowResultContainerDocument, options);
        }
export type LinkSelectionRowResultContainerQueryHookResult = ReturnType<typeof useLinkSelectionRowResultContainerQuery>;
export type LinkSelectionRowResultContainerLazyQueryHookResult = ReturnType<typeof useLinkSelectionRowResultContainerLazyQuery>;
export type LinkSelectionRowResultContainerQueryResult = Apollo.QueryResult<LinkSelectionRowResultContainerQuery, LinkSelectionRowResultContainerQueryVariables>;
export const SetActiveLinkSiteDocument = gql`
    mutation SetActiveLinkSite($linkId: Int!, $isActive: Boolean!) {
  setSitePersonActiveStatus(id: $linkId, isActive: $isActive) {
    id
    isActive
  }
}
    `;
export type SetActiveLinkSiteMutationFn = Apollo.MutationFunction<SetActiveLinkSiteMutation, SetActiveLinkSiteMutationVariables>;

/**
 * __useSetActiveLinkSiteMutation__
 *
 * To run a mutation, you first call `useSetActiveLinkSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveLinkSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveLinkSiteMutation, { data, loading, error }] = useSetActiveLinkSiteMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useSetActiveLinkSiteMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveLinkSiteMutation, SetActiveLinkSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveLinkSiteMutation, SetActiveLinkSiteMutationVariables>(SetActiveLinkSiteDocument, options);
      }
export type SetActiveLinkSiteMutationHookResult = ReturnType<typeof useSetActiveLinkSiteMutation>;
export type SetActiveLinkSiteMutationResult = Apollo.MutationResult<SetActiveLinkSiteMutation>;
export type SetActiveLinkSiteMutationOptions = Apollo.BaseMutationOptions<SetActiveLinkSiteMutation, SetActiveLinkSiteMutationVariables>;
export const InactivateLinkActionDocument = gql`
    query InactivateLinkAction($linkId: Int!) {
  sitePersonAffiliation(id: $linkId) {
    id
    isActive
    maintainerSourceCode
  }
}
    `;

/**
 * __useInactivateLinkActionQuery__
 *
 * To run a query within a React component, call `useInactivateLinkActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactivateLinkActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactivateLinkActionQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useInactivateLinkActionQuery(baseOptions: Apollo.QueryHookOptions<InactivateLinkActionQuery, InactivateLinkActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactivateLinkActionQuery, InactivateLinkActionQueryVariables>(InactivateLinkActionDocument, options);
      }
export function useInactivateLinkActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactivateLinkActionQuery, InactivateLinkActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactivateLinkActionQuery, InactivateLinkActionQueryVariables>(InactivateLinkActionDocument, options);
        }
export type InactivateLinkActionQueryHookResult = ReturnType<typeof useInactivateLinkActionQuery>;
export type InactivateLinkActionLazyQueryHookResult = ReturnType<typeof useInactivateLinkActionLazyQuery>;
export type InactivateLinkActionQueryResult = Apollo.QueryResult<InactivateLinkActionQuery, InactivateLinkActionQueryVariables>;
export const LinkTabDetailDocument = gql`
    query LinkTabDetail($recordId: Int!) {
  sitePersonAffiliation(id: $recordId) {
    id
    siteId
    apurebaseId
    selectionRowsCustomerCount(criteria: {selectionType: DYNAMIC})
    notes {
      hash
      totalCount
    }
    site {
      id
      name
      persons {
        totalCount
        hash
      }
    }
    person {
      id
      fullName
      title
      ct
      activities {
        hash
        totalCount
        nodes {
          id
          heading
          type {
            code
            heading
          }
        }
      }
      notes {
        hash
        totalCount
        nodes {
          id
          title
        }
      }
      lists {
        hash
        totalCount
        nodes {
          id
          title
        }
      }
      projects {
        hash
        totalCount
        nodes {
          id
          title
        }
      }
      segmentation {
        code
        heading
      }
      affiliations {
        hash
        totalCount
        nodes {
          id
          site {
            id
            name
          }
        }
      }
      persType {
        code
        type
        label
      }
    }
  }
}
    `;

/**
 * __useLinkTabDetailQuery__
 *
 * To run a query within a React component, call `useLinkTabDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkTabDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkTabDetailQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useLinkTabDetailQuery(baseOptions: Apollo.QueryHookOptions<LinkTabDetailQuery, LinkTabDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkTabDetailQuery, LinkTabDetailQueryVariables>(LinkTabDetailDocument, options);
      }
export function useLinkTabDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkTabDetailQuery, LinkTabDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkTabDetailQuery, LinkTabDetailQueryVariables>(LinkTabDetailDocument, options);
        }
export type LinkTabDetailQueryHookResult = ReturnType<typeof useLinkTabDetailQuery>;
export type LinkTabDetailLazyQueryHookResult = ReturnType<typeof useLinkTabDetailLazyQuery>;
export type LinkTabDetailQueryResult = Apollo.QueryResult<LinkTabDetailQuery, LinkTabDetailQueryVariables>;
export const LinkCardsContainerQueryDocument = gql`
    query LinkCardsContainerQuery($linkId: Int!, $entityGridItemConfigurationId: Int!) {
  cardFieldKeys(entityGridItemConfigurationId: $entityGridItemConfigurationId) {
    entityGridItemConfigurationId
    person {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
    link {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
    site {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
  }
  sitePersonAffiliation(id: $linkId) {
    id
    position {
      code
      type
      label
    }
    person {
      id
      fullName
    }
    site {
      id
      name
    }
  }
}
    ${GridCardFieldFragmentDoc}`;

/**
 * __useLinkCardsContainerQueryQuery__
 *
 * To run a query within a React component, call `useLinkCardsContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkCardsContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkCardsContainerQueryQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function useLinkCardsContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<LinkCardsContainerQueryQuery, LinkCardsContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkCardsContainerQueryQuery, LinkCardsContainerQueryQueryVariables>(LinkCardsContainerQueryDocument, options);
      }
export function useLinkCardsContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkCardsContainerQueryQuery, LinkCardsContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkCardsContainerQueryQuery, LinkCardsContainerQueryQueryVariables>(LinkCardsContainerQueryDocument, options);
        }
export type LinkCardsContainerQueryQueryHookResult = ReturnType<typeof useLinkCardsContainerQueryQuery>;
export type LinkCardsContainerQueryLazyQueryHookResult = ReturnType<typeof useLinkCardsContainerQueryLazyQuery>;
export type LinkCardsContainerQueryQueryResult = Apollo.QueryResult<LinkCardsContainerQueryQuery, LinkCardsContainerQueryQueryVariables>;
export const LinkDetailDocument = gql`
    query LinkDetail($linkId: Int!) {
  sitePersonAffiliation(id: $linkId) {
    id
    apurebaseId
    isActive
    countryCode
    position {
      code
      type
      label
    }
    site {
      id
      name
    }
    person {
      id
      fullName
    }
  }
}
    `;

/**
 * __useLinkDetailQuery__
 *
 * To run a query within a React component, call `useLinkDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkDetailQuery({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useLinkDetailQuery(baseOptions: Apollo.QueryHookOptions<LinkDetailQuery, LinkDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkDetailQuery, LinkDetailQueryVariables>(LinkDetailDocument, options);
      }
export function useLinkDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkDetailQuery, LinkDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkDetailQuery, LinkDetailQueryVariables>(LinkDetailDocument, options);
        }
export type LinkDetailQueryHookResult = ReturnType<typeof useLinkDetailQuery>;
export type LinkDetailLazyQueryHookResult = ReturnType<typeof useLinkDetailLazyQuery>;
export type LinkDetailQueryResult = Apollo.QueryResult<LinkDetailQuery, LinkDetailQueryVariables>;
export const LinkConnectionQueryDocument = gql`
    query LinkConnectionQuery($criteria: SitePersonCriteria) {
  connection: sitePersonAffiliations(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...LinkTableFragment
    }
  }
}
    ${LinkTableFragmentFragmentDoc}`;

/**
 * __useLinkConnectionQueryQuery__
 *
 * To run a query within a React component, call `useLinkConnectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkConnectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkConnectionQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useLinkConnectionQueryQuery(baseOptions?: Apollo.QueryHookOptions<LinkConnectionQueryQuery, LinkConnectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkConnectionQueryQuery, LinkConnectionQueryQueryVariables>(LinkConnectionQueryDocument, options);
      }
export function useLinkConnectionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkConnectionQueryQuery, LinkConnectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkConnectionQueryQuery, LinkConnectionQueryQueryVariables>(LinkConnectionQueryDocument, options);
        }
export type LinkConnectionQueryQueryHookResult = ReturnType<typeof useLinkConnectionQueryQuery>;
export type LinkConnectionQueryLazyQueryHookResult = ReturnType<typeof useLinkConnectionQueryLazyQuery>;
export type LinkConnectionQueryQueryResult = Apollo.QueryResult<LinkConnectionQueryQuery, LinkConnectionQueryQueryVariables>;
export const LinkRecordQueryDocument = gql`
    query LinkRecordQuery($recordId: Int!) {
  record: sitePersonAffiliation(id: $recordId) {
    id
    ...LinkTableFragment
  }
}
    ${LinkTableFragmentFragmentDoc}`;

/**
 * __useLinkRecordQueryQuery__
 *
 * To run a query within a React component, call `useLinkRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useLinkRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<LinkRecordQueryQuery, LinkRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkRecordQueryQuery, LinkRecordQueryQueryVariables>(LinkRecordQueryDocument, options);
      }
export function useLinkRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkRecordQueryQuery, LinkRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkRecordQueryQuery, LinkRecordQueryQueryVariables>(LinkRecordQueryDocument, options);
        }
export type LinkRecordQueryQueryHookResult = ReturnType<typeof useLinkRecordQueryQuery>;
export type LinkRecordQueryLazyQueryHookResult = ReturnType<typeof useLinkRecordQueryLazyQuery>;
export type LinkRecordQueryQueryResult = Apollo.QueryResult<LinkRecordQueryQuery, LinkRecordQueryQueryVariables>;
export const UpdateLinkIsPrimaryMutationDocument = gql`
    mutation UpdateLinkIsPrimaryMutation($linkId: ID!, $personId: ID!) {
  setPrimaryLink(linkId: $linkId, personId: $personId) {
    id
    isPrimary
  }
}
    `;
export type UpdateLinkIsPrimaryMutationMutationFn = Apollo.MutationFunction<UpdateLinkIsPrimaryMutationMutation, UpdateLinkIsPrimaryMutationMutationVariables>;

/**
 * __useUpdateLinkIsPrimaryMutationMutation__
 *
 * To run a mutation, you first call `useUpdateLinkIsPrimaryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkIsPrimaryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkIsPrimaryMutationMutation, { data, loading, error }] = useUpdateLinkIsPrimaryMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useUpdateLinkIsPrimaryMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkIsPrimaryMutationMutation, UpdateLinkIsPrimaryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkIsPrimaryMutationMutation, UpdateLinkIsPrimaryMutationMutationVariables>(UpdateLinkIsPrimaryMutationDocument, options);
      }
export type UpdateLinkIsPrimaryMutationMutationHookResult = ReturnType<typeof useUpdateLinkIsPrimaryMutationMutation>;
export type UpdateLinkIsPrimaryMutationMutationResult = Apollo.MutationResult<UpdateLinkIsPrimaryMutationMutation>;
export type UpdateLinkIsPrimaryMutationMutationOptions = Apollo.BaseMutationOptions<UpdateLinkIsPrimaryMutationMutation, UpdateLinkIsPrimaryMutationMutationVariables>;
export const UpdateNumberOfPatientsMutationDocument = gql`
    mutation UpdateNumberOfPatientsMutation($linkId: Int!, $numberOfPatients: Int) {
  updateNumberOfPatients(id: $linkId, numberOfPatients: $numberOfPatients) {
    id
    numberOfPatients
  }
}
    `;
export type UpdateNumberOfPatientsMutationMutationFn = Apollo.MutationFunction<UpdateNumberOfPatientsMutationMutation, UpdateNumberOfPatientsMutationMutationVariables>;

/**
 * __useUpdateNumberOfPatientsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateNumberOfPatientsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNumberOfPatientsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNumberOfPatientsMutationMutation, { data, loading, error }] = useUpdateNumberOfPatientsMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      numberOfPatients: // value for 'numberOfPatients'
 *   },
 * });
 */
export function useUpdateNumberOfPatientsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNumberOfPatientsMutationMutation, UpdateNumberOfPatientsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNumberOfPatientsMutationMutation, UpdateNumberOfPatientsMutationMutationVariables>(UpdateNumberOfPatientsMutationDocument, options);
      }
export type UpdateNumberOfPatientsMutationMutationHookResult = ReturnType<typeof useUpdateNumberOfPatientsMutationMutation>;
export type UpdateNumberOfPatientsMutationMutationResult = Apollo.MutationResult<UpdateNumberOfPatientsMutationMutation>;
export type UpdateNumberOfPatientsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateNumberOfPatientsMutationMutation, UpdateNumberOfPatientsMutationMutationVariables>;
export const UpdateLinkPersonTitleMutationDocument = gql`
    mutation UpdateLinkPersonTitleMutation($persId: Int!, $title: String!) {
  updatePersonTitle(persId: $persId, title: $title) {
    id
    title
  }
}
    `;
export type UpdateLinkPersonTitleMutationMutationFn = Apollo.MutationFunction<UpdateLinkPersonTitleMutationMutation, UpdateLinkPersonTitleMutationMutationVariables>;

/**
 * __useUpdateLinkPersonTitleMutationMutation__
 *
 * To run a mutation, you first call `useUpdateLinkPersonTitleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkPersonTitleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkPersonTitleMutationMutation, { data, loading, error }] = useUpdateLinkPersonTitleMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateLinkPersonTitleMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkPersonTitleMutationMutation, UpdateLinkPersonTitleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkPersonTitleMutationMutation, UpdateLinkPersonTitleMutationMutationVariables>(UpdateLinkPersonTitleMutationDocument, options);
      }
export type UpdateLinkPersonTitleMutationMutationHookResult = ReturnType<typeof useUpdateLinkPersonTitleMutationMutation>;
export type UpdateLinkPersonTitleMutationMutationResult = Apollo.MutationResult<UpdateLinkPersonTitleMutationMutation>;
export type UpdateLinkPersonTitleMutationMutationOptions = Apollo.BaseMutationOptions<UpdateLinkPersonTitleMutationMutation, UpdateLinkPersonTitleMutationMutationVariables>;
export const SuggestedLinkPersonStandardTitleQueryDocument = gql`
    query SuggestedLinkPersonStandardTitleQuery($countryCode: String!) {
  standardTitles(criteria: {country: $countryCode, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      id
      label
    }
  }
}
    `;

/**
 * __useSuggestedLinkPersonStandardTitleQueryQuery__
 *
 * To run a query within a React component, call `useSuggestedLinkPersonStandardTitleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedLinkPersonStandardTitleQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedLinkPersonStandardTitleQueryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSuggestedLinkPersonStandardTitleQueryQuery(baseOptions: Apollo.QueryHookOptions<SuggestedLinkPersonStandardTitleQueryQuery, SuggestedLinkPersonStandardTitleQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedLinkPersonStandardTitleQueryQuery, SuggestedLinkPersonStandardTitleQueryQueryVariables>(SuggestedLinkPersonStandardTitleQueryDocument, options);
      }
export function useSuggestedLinkPersonStandardTitleQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedLinkPersonStandardTitleQueryQuery, SuggestedLinkPersonStandardTitleQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedLinkPersonStandardTitleQueryQuery, SuggestedLinkPersonStandardTitleQueryQueryVariables>(SuggestedLinkPersonStandardTitleQueryDocument, options);
        }
export type SuggestedLinkPersonStandardTitleQueryQueryHookResult = ReturnType<typeof useSuggestedLinkPersonStandardTitleQueryQuery>;
export type SuggestedLinkPersonStandardTitleQueryLazyQueryHookResult = ReturnType<typeof useSuggestedLinkPersonStandardTitleQueryLazyQuery>;
export type SuggestedLinkPersonStandardTitleQueryQueryResult = Apollo.QueryResult<SuggestedLinkPersonStandardTitleQueryQuery, SuggestedLinkPersonStandardTitleQueryQueryVariables>;
export const UpdatePersonPositionMutationDocument = gql`
    mutation UpdatePersonPositionMutation($linkId: Int!, $positionCode: String) {
  updatePosition(id: $linkId, positionCode: $positionCode) {
    id
    positionCode
    position {
      code
      type
    }
  }
}
    `;
export type UpdatePersonPositionMutationMutationFn = Apollo.MutationFunction<UpdatePersonPositionMutationMutation, UpdatePersonPositionMutationMutationVariables>;

/**
 * __useUpdatePersonPositionMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonPositionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonPositionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonPositionMutationMutation, { data, loading, error }] = useUpdatePersonPositionMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      positionCode: // value for 'positionCode'
 *   },
 * });
 */
export function useUpdatePersonPositionMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonPositionMutationMutation, UpdatePersonPositionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonPositionMutationMutation, UpdatePersonPositionMutationMutationVariables>(UpdatePersonPositionMutationDocument, options);
      }
export type UpdatePersonPositionMutationMutationHookResult = ReturnType<typeof useUpdatePersonPositionMutationMutation>;
export type UpdatePersonPositionMutationMutationResult = Apollo.MutationResult<UpdatePersonPositionMutationMutation>;
export type UpdatePersonPositionMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonPositionMutationMutation, UpdatePersonPositionMutationMutationVariables>;
export const SelectPersonPosSuggestionQueryDocument = gql`
    query SelectPersonPosSuggestionQuery($search: String, $country: CountryCode!) {
  positions(
    criteria: {country: $country, label: $search, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectPersonPosSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectPersonPosSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonPosSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonPosSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSelectPersonPosSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonPosSuggestionQueryQuery, SelectPersonPosSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonPosSuggestionQueryQuery, SelectPersonPosSuggestionQueryQueryVariables>(SelectPersonPosSuggestionQueryDocument, options);
      }
export function useSelectPersonPosSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonPosSuggestionQueryQuery, SelectPersonPosSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonPosSuggestionQueryQuery, SelectPersonPosSuggestionQueryQueryVariables>(SelectPersonPosSuggestionQueryDocument, options);
        }
export type SelectPersonPosSuggestionQueryQueryHookResult = ReturnType<typeof useSelectPersonPosSuggestionQueryQuery>;
export type SelectPersonPosSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectPersonPosSuggestionQueryLazyQuery>;
export type SelectPersonPosSuggestionQueryQueryResult = Apollo.QueryResult<SelectPersonPosSuggestionQueryQuery, SelectPersonPosSuggestionQueryQueryVariables>;
export const NewLinkFromExistingMutationDocument = gql`
    mutation NewLinkFromExistingMutation($linkId: ID!, $siteId: ID!) {
  newLinkFromExisting(linkId: $linkId, siteId: $siteId) {
    id
    person {
      id
      sites {
        hash
        nodes {
          id
        }
      }
      affiliations {
        hash
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type NewLinkFromExistingMutationMutationFn = Apollo.MutationFunction<NewLinkFromExistingMutationMutation, NewLinkFromExistingMutationMutationVariables>;

/**
 * __useNewLinkFromExistingMutationMutation__
 *
 * To run a mutation, you first call `useNewLinkFromExistingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewLinkFromExistingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newLinkFromExistingMutationMutation, { data, loading, error }] = useNewLinkFromExistingMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useNewLinkFromExistingMutationMutation(baseOptions?: Apollo.MutationHookOptions<NewLinkFromExistingMutationMutation, NewLinkFromExistingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewLinkFromExistingMutationMutation, NewLinkFromExistingMutationMutationVariables>(NewLinkFromExistingMutationDocument, options);
      }
export type NewLinkFromExistingMutationMutationHookResult = ReturnType<typeof useNewLinkFromExistingMutationMutation>;
export type NewLinkFromExistingMutationMutationResult = Apollo.MutationResult<NewLinkFromExistingMutationMutation>;
export type NewLinkFromExistingMutationMutationOptions = Apollo.BaseMutationOptions<NewLinkFromExistingMutationMutation, NewLinkFromExistingMutationMutationVariables>;
export const UpdateTherapeuticFocusesMutationDocument = gql`
    mutation UpdateTherapeuticFocusesMutation($linkId: Int!, $therapeuticFocusCodes: [String!]!) {
  updateSitePersonTherapeuticFocuses(
    sitePersonId: $linkId
    therapeuticFocusCodes: $therapeuticFocusCodes
  ) {
    id
    therapeuticFocusCode
    sitePerson {
      id
      therapeuticFocuses {
        hash
        nodes {
          code
          label
          type
        }
      }
    }
  }
}
    `;
export type UpdateTherapeuticFocusesMutationMutationFn = Apollo.MutationFunction<UpdateTherapeuticFocusesMutationMutation, UpdateTherapeuticFocusesMutationMutationVariables>;

/**
 * __useUpdateTherapeuticFocusesMutationMutation__
 *
 * To run a mutation, you first call `useUpdateTherapeuticFocusesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTherapeuticFocusesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTherapeuticFocusesMutationMutation, { data, loading, error }] = useUpdateTherapeuticFocusesMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      therapeuticFocusCodes: // value for 'therapeuticFocusCodes'
 *   },
 * });
 */
export function useUpdateTherapeuticFocusesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTherapeuticFocusesMutationMutation, UpdateTherapeuticFocusesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTherapeuticFocusesMutationMutation, UpdateTherapeuticFocusesMutationMutationVariables>(UpdateTherapeuticFocusesMutationDocument, options);
      }
export type UpdateTherapeuticFocusesMutationMutationHookResult = ReturnType<typeof useUpdateTherapeuticFocusesMutationMutation>;
export type UpdateTherapeuticFocusesMutationMutationResult = Apollo.MutationResult<UpdateTherapeuticFocusesMutationMutation>;
export type UpdateTherapeuticFocusesMutationMutationOptions = Apollo.BaseMutationOptions<UpdateTherapeuticFocusesMutationMutation, UpdateTherapeuticFocusesMutationMutationVariables>;
export const TherapeuticFocusSuggestionQueryDocument = gql`
    query TherapeuticFocusSuggestionQuery($search: String, $countryCode: CountryCode!) {
  therapeuticFocuses(
    criteria: {label: $search, countries: [$countryCode], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label
      type
    }
  }
}
    `;

/**
 * __useTherapeuticFocusSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useTherapeuticFocusSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTherapeuticFocusSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTherapeuticFocusSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useTherapeuticFocusSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<TherapeuticFocusSuggestionQueryQuery, TherapeuticFocusSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TherapeuticFocusSuggestionQueryQuery, TherapeuticFocusSuggestionQueryQueryVariables>(TherapeuticFocusSuggestionQueryDocument, options);
      }
export function useTherapeuticFocusSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TherapeuticFocusSuggestionQueryQuery, TherapeuticFocusSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TherapeuticFocusSuggestionQueryQuery, TherapeuticFocusSuggestionQueryQueryVariables>(TherapeuticFocusSuggestionQueryDocument, options);
        }
export type TherapeuticFocusSuggestionQueryQueryHookResult = ReturnType<typeof useTherapeuticFocusSuggestionQueryQuery>;
export type TherapeuticFocusSuggestionQueryLazyQueryHookResult = ReturnType<typeof useTherapeuticFocusSuggestionQueryLazyQuery>;
export type TherapeuticFocusSuggestionQueryQueryResult = Apollo.QueryResult<TherapeuticFocusSuggestionQueryQuery, TherapeuticFocusSuggestionQueryQueryVariables>;
export const FieldWorkingSpecialtiesQueryDocument = gql`
    query FieldWorkingSpecialtiesQuery($countries: [CountryCode!]!) {
  availableSpecialties: workingSpecialties(
    criteria: {countries: $countries, fetchSize: {limit: 5000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useFieldWorkingSpecialtiesQueryQuery__
 *
 * To run a query within a React component, call `useFieldWorkingSpecialtiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldWorkingSpecialtiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldWorkingSpecialtiesQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useFieldWorkingSpecialtiesQueryQuery(baseOptions: Apollo.QueryHookOptions<FieldWorkingSpecialtiesQueryQuery, FieldWorkingSpecialtiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldWorkingSpecialtiesQueryQuery, FieldWorkingSpecialtiesQueryQueryVariables>(FieldWorkingSpecialtiesQueryDocument, options);
      }
export function useFieldWorkingSpecialtiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldWorkingSpecialtiesQueryQuery, FieldWorkingSpecialtiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldWorkingSpecialtiesQueryQuery, FieldWorkingSpecialtiesQueryQueryVariables>(FieldWorkingSpecialtiesQueryDocument, options);
        }
export type FieldWorkingSpecialtiesQueryQueryHookResult = ReturnType<typeof useFieldWorkingSpecialtiesQueryQuery>;
export type FieldWorkingSpecialtiesQueryLazyQueryHookResult = ReturnType<typeof useFieldWorkingSpecialtiesQueryLazyQuery>;
export type FieldWorkingSpecialtiesQueryQueryResult = Apollo.QueryResult<FieldWorkingSpecialtiesQueryQuery, FieldWorkingSpecialtiesQueryQueryVariables>;
export const UpdateSitePersonWorkingSpecialtiesMutationDocument = gql`
    mutation UpdateSitePersonWorkingSpecialtiesMutation($linkId: Int!, $specialties: [String!]!) {
  updateSitePersonWorkingSpecialties(
    linkId: $linkId
    workingSpecialtyCodes: $specialties
  ) {
    id
    specialty {
      type
      code
      label
    }
  }
}
    `;
export type UpdateSitePersonWorkingSpecialtiesMutationMutationFn = Apollo.MutationFunction<UpdateSitePersonWorkingSpecialtiesMutationMutation, UpdateSitePersonWorkingSpecialtiesMutationMutationVariables>;

/**
 * __useUpdateSitePersonWorkingSpecialtiesMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSitePersonWorkingSpecialtiesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSitePersonWorkingSpecialtiesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSitePersonWorkingSpecialtiesMutationMutation, { data, loading, error }] = useUpdateSitePersonWorkingSpecialtiesMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      specialties: // value for 'specialties'
 *   },
 * });
 */
export function useUpdateSitePersonWorkingSpecialtiesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSitePersonWorkingSpecialtiesMutationMutation, UpdateSitePersonWorkingSpecialtiesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSitePersonWorkingSpecialtiesMutationMutation, UpdateSitePersonWorkingSpecialtiesMutationMutationVariables>(UpdateSitePersonWorkingSpecialtiesMutationDocument, options);
      }
export type UpdateSitePersonWorkingSpecialtiesMutationMutationHookResult = ReturnType<typeof useUpdateSitePersonWorkingSpecialtiesMutationMutation>;
export type UpdateSitePersonWorkingSpecialtiesMutationMutationResult = Apollo.MutationResult<UpdateSitePersonWorkingSpecialtiesMutationMutation>;
export type UpdateSitePersonWorkingSpecialtiesMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSitePersonWorkingSpecialtiesMutationMutation, UpdateSitePersonWorkingSpecialtiesMutationMutationVariables>;
export const AddToStaticListMutationDocument = gql`
    mutation AddToStaticListMutation($listId: Int!, $selection: SelectionCriteriaInput!) {
  addToStaticList(listId: $listId, selection: $selection) {
    id
  }
}
    `;
export type AddToStaticListMutationMutationFn = Apollo.MutationFunction<AddToStaticListMutationMutation, AddToStaticListMutationMutationVariables>;

/**
 * __useAddToStaticListMutationMutation__
 *
 * To run a mutation, you first call `useAddToStaticListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToStaticListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToStaticListMutationMutation, { data, loading, error }] = useAddToStaticListMutationMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useAddToStaticListMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddToStaticListMutationMutation, AddToStaticListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToStaticListMutationMutation, AddToStaticListMutationMutationVariables>(AddToStaticListMutationDocument, options);
      }
export type AddToStaticListMutationMutationHookResult = ReturnType<typeof useAddToStaticListMutationMutation>;
export type AddToStaticListMutationMutationResult = Apollo.MutationResult<AddToStaticListMutationMutation>;
export type AddToStaticListMutationMutationOptions = Apollo.BaseMutationOptions<AddToStaticListMutationMutation, AddToStaticListMutationMutationVariables>;
export const CreateListInModalDocument = gql`
    mutation CreateListInModal($input: ListInput!) {
  createList(input: $input) {
    id
  }
}
    `;
export type CreateListInModalMutationFn = Apollo.MutationFunction<CreateListInModalMutation, CreateListInModalMutationVariables>;

/**
 * __useCreateListInModalMutation__
 *
 * To run a mutation, you first call `useCreateListInModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListInModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListInModalMutation, { data, loading, error }] = useCreateListInModalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListInModalMutation(baseOptions?: Apollo.MutationHookOptions<CreateListInModalMutation, CreateListInModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListInModalMutation, CreateListInModalMutationVariables>(CreateListInModalDocument, options);
      }
export type CreateListInModalMutationHookResult = ReturnType<typeof useCreateListInModalMutation>;
export type CreateListInModalMutationResult = Apollo.MutationResult<CreateListInModalMutation>;
export type CreateListInModalMutationOptions = Apollo.BaseMutationOptions<CreateListInModalMutation, CreateListInModalMutationVariables>;
export const CreateListMutationDocument = gql`
    mutation CreateListMutation($input: ListInput!) {
  createList(input: $input) {
    id
  }
}
    `;
export type CreateListMutationMutationFn = Apollo.MutationFunction<CreateListMutationMutation, CreateListMutationMutationVariables>;

/**
 * __useCreateListMutationMutation__
 *
 * To run a mutation, you first call `useCreateListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListMutationMutation, { data, loading, error }] = useCreateListMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateListMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateListMutationMutation, CreateListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListMutationMutation, CreateListMutationMutationVariables>(CreateListMutationDocument, options);
      }
export type CreateListMutationMutationHookResult = ReturnType<typeof useCreateListMutationMutation>;
export type CreateListMutationMutationResult = Apollo.MutationResult<CreateListMutationMutation>;
export type CreateListMutationMutationOptions = Apollo.BaseMutationOptions<CreateListMutationMutation, CreateListMutationMutationVariables>;
export const CreateStaticListMutationDocument = gql`
    mutation CreateStaticListMutation($title: String!, $selection: SelectionCriteriaInput!, $description: String!, $shared: Boolean!, $entityType: EntityTypeEnum!) {
  createStaticList(
    title: $title
    selection: $selection
    description: $description
    isShared: $shared
    entityType: $entityType
  ) {
    id
  }
}
    `;
export type CreateStaticListMutationMutationFn = Apollo.MutationFunction<CreateStaticListMutationMutation, CreateStaticListMutationMutationVariables>;

/**
 * __useCreateStaticListMutationMutation__
 *
 * To run a mutation, you first call `useCreateStaticListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaticListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaticListMutationMutation, { data, loading, error }] = useCreateStaticListMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      selection: // value for 'selection'
 *      description: // value for 'description'
 *      shared: // value for 'shared'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useCreateStaticListMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaticListMutationMutation, CreateStaticListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaticListMutationMutation, CreateStaticListMutationMutationVariables>(CreateStaticListMutationDocument, options);
      }
export type CreateStaticListMutationMutationHookResult = ReturnType<typeof useCreateStaticListMutationMutation>;
export type CreateStaticListMutationMutationResult = Apollo.MutationResult<CreateStaticListMutationMutation>;
export type CreateStaticListMutationMutationOptions = Apollo.BaseMutationOptions<CreateStaticListMutationMutation, CreateStaticListMutationMutationVariables>;
export const GetStaticListsDocument = gql`
    query GetStaticLists {
  connection: getStaticLists {
    hash
    nodes {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useGetStaticListsQuery__
 *
 * To run a query within a React component, call `useGetStaticListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaticListsQuery(baseOptions?: Apollo.QueryHookOptions<GetStaticListsQuery, GetStaticListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaticListsQuery, GetStaticListsQueryVariables>(GetStaticListsDocument, options);
      }
export function useGetStaticListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaticListsQuery, GetStaticListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaticListsQuery, GetStaticListsQueryVariables>(GetStaticListsDocument, options);
        }
export type GetStaticListsQueryHookResult = ReturnType<typeof useGetStaticListsQuery>;
export type GetStaticListsLazyQueryHookResult = ReturnType<typeof useGetStaticListsLazyQuery>;
export type GetStaticListsQueryResult = Apollo.QueryResult<GetStaticListsQuery, GetStaticListsQueryVariables>;
export const AddDynamicRulesToListDocument = gql`
    mutation AddDynamicRulesToList($input: DynamicRulesInput!) {
  addDynamicRulesToList(input: $input) {
    id
  }
}
    `;
export type AddDynamicRulesToListMutationFn = Apollo.MutationFunction<AddDynamicRulesToListMutation, AddDynamicRulesToListMutationVariables>;

/**
 * __useAddDynamicRulesToListMutation__
 *
 * To run a mutation, you first call `useAddDynamicRulesToListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDynamicRulesToListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDynamicRulesToListMutation, { data, loading, error }] = useAddDynamicRulesToListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDynamicRulesToListMutation(baseOptions?: Apollo.MutationHookOptions<AddDynamicRulesToListMutation, AddDynamicRulesToListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDynamicRulesToListMutation, AddDynamicRulesToListMutationVariables>(AddDynamicRulesToListDocument, options);
      }
export type AddDynamicRulesToListMutationHookResult = ReturnType<typeof useAddDynamicRulesToListMutation>;
export type AddDynamicRulesToListMutationResult = Apollo.MutationResult<AddDynamicRulesToListMutation>;
export type AddDynamicRulesToListMutationOptions = Apollo.BaseMutationOptions<AddDynamicRulesToListMutation, AddDynamicRulesToListMutationVariables>;
export const SetListCountriesDocument = gql`
    mutation SetListCountries($listId: Int!, $countries: [CountryCode!]) {
  updateListCountries(listId: $listId, countries: $countries) {
    id
  }
}
    `;
export type SetListCountriesMutationFn = Apollo.MutationFunction<SetListCountriesMutation, SetListCountriesMutationVariables>;

/**
 * __useSetListCountriesMutation__
 *
 * To run a mutation, you first call `useSetListCountriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetListCountriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setListCountriesMutation, { data, loading, error }] = useSetListCountriesMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useSetListCountriesMutation(baseOptions?: Apollo.MutationHookOptions<SetListCountriesMutation, SetListCountriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetListCountriesMutation, SetListCountriesMutationVariables>(SetListCountriesDocument, options);
      }
export type SetListCountriesMutationHookResult = ReturnType<typeof useSetListCountriesMutation>;
export type SetListCountriesMutationResult = Apollo.MutationResult<SetListCountriesMutation>;
export type SetListCountriesMutationOptions = Apollo.BaseMutationOptions<SetListCountriesMutation, SetListCountriesMutationVariables>;
export const ListDetailsQueryDocument = gql`
    query ListDetailsQuery($listId: Int!) {
  list(id: $listId) {
    id
    isFavoriteList
    isShared
    description
    title
    sort
    ct
    ut
    editAccess
    entityTypeEnum
    typeEnum
    countries {
      hash
      nodes {
        id
        countryCode
      }
    }
    entityType {
      code
      heading
    }
    criterias {
      hash
      totalCount
    }
    listType {
      code
      heading
    }
    createdUser {
      id
      fullname
    }
  }
}
    `;

/**
 * __useListDetailsQueryQuery__
 *
 * To run a query within a React component, call `useListDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDetailsQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useListDetailsQueryQuery(baseOptions: Apollo.QueryHookOptions<ListDetailsQueryQuery, ListDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDetailsQueryQuery, ListDetailsQueryQueryVariables>(ListDetailsQueryDocument, options);
      }
export function useListDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDetailsQueryQuery, ListDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDetailsQueryQuery, ListDetailsQueryQueryVariables>(ListDetailsQueryDocument, options);
        }
export type ListDetailsQueryQueryHookResult = ReturnType<typeof useListDetailsQueryQuery>;
export type ListDetailsQueryLazyQueryHookResult = ReturnType<typeof useListDetailsQueryLazyQuery>;
export type ListDetailsQueryQueryResult = Apollo.QueryResult<ListDetailsQueryQuery, ListDetailsQueryQueryVariables>;
export const UpdateListTitleDocument = gql`
    mutation UpdateListTitle($id: Int!, $value: String!) {
  updateList(input: {id: $id, title: $value}) {
    id
    title
  }
}
    `;
export type UpdateListTitleMutationFn = Apollo.MutationFunction<UpdateListTitleMutation, UpdateListTitleMutationVariables>;

/**
 * __useUpdateListTitleMutation__
 *
 * To run a mutation, you first call `useUpdateListTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListTitleMutation, { data, loading, error }] = useUpdateListTitleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateListTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListTitleMutation, UpdateListTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListTitleMutation, UpdateListTitleMutationVariables>(UpdateListTitleDocument, options);
      }
export type UpdateListTitleMutationHookResult = ReturnType<typeof useUpdateListTitleMutation>;
export type UpdateListTitleMutationResult = Apollo.MutationResult<UpdateListTitleMutation>;
export type UpdateListTitleMutationOptions = Apollo.BaseMutationOptions<UpdateListTitleMutation, UpdateListTitleMutationVariables>;
export const UpdateListDescriptionDocument = gql`
    mutation UpdateListDescription($id: Int!, $value: String) {
  updateList(input: {id: $id, description: $value}) {
    id
    description
  }
}
    `;
export type UpdateListDescriptionMutationFn = Apollo.MutationFunction<UpdateListDescriptionMutation, UpdateListDescriptionMutationVariables>;

/**
 * __useUpdateListDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateListDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListDescriptionMutation, { data, loading, error }] = useUpdateListDescriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateListDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListDescriptionMutation, UpdateListDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListDescriptionMutation, UpdateListDescriptionMutationVariables>(UpdateListDescriptionDocument, options);
      }
export type UpdateListDescriptionMutationHookResult = ReturnType<typeof useUpdateListDescriptionMutation>;
export type UpdateListDescriptionMutationResult = Apollo.MutationResult<UpdateListDescriptionMutation>;
export type UpdateListDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateListDescriptionMutation, UpdateListDescriptionMutationVariables>;
export const DeactivateListMutationDocument = gql`
    mutation DeactivateListMutation($id: Int!) {
  deactivateList(id: $id) {
    id
    isActive
  }
}
    `;
export type DeactivateListMutationMutationFn = Apollo.MutationFunction<DeactivateListMutationMutation, DeactivateListMutationMutationVariables>;

/**
 * __useDeactivateListMutationMutation__
 *
 * To run a mutation, you first call `useDeactivateListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateListMutationMutation, { data, loading, error }] = useDeactivateListMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateListMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateListMutationMutation, DeactivateListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateListMutationMutation, DeactivateListMutationMutationVariables>(DeactivateListMutationDocument, options);
      }
export type DeactivateListMutationMutationHookResult = ReturnType<typeof useDeactivateListMutationMutation>;
export type DeactivateListMutationMutationResult = Apollo.MutationResult<DeactivateListMutationMutation>;
export type DeactivateListMutationMutationOptions = Apollo.BaseMutationOptions<DeactivateListMutationMutation, DeactivateListMutationMutationVariables>;
export const DynamicRulesQueryDocument = gql`
    query DynamicRulesQuery($listId: Int!, $entityTypeEnum: EntityTypeEnum) {
  list(id: $listId) {
    id
    ...ListDynamicRulesFragment
  }
  criteriaGroups(criteria: {entityType: $entityTypeEnum}) {
    hash
    nodes {
      ...CriteriasGroupsFragment
    }
  }
}
    ${ListDynamicRulesFragmentFragmentDoc}
${CriteriasGroupsFragmentFragmentDoc}`;

/**
 * __useDynamicRulesQueryQuery__
 *
 * To run a query within a React component, call `useDynamicRulesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicRulesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicRulesQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      entityTypeEnum: // value for 'entityTypeEnum'
 *   },
 * });
 */
export function useDynamicRulesQueryQuery(baseOptions: Apollo.QueryHookOptions<DynamicRulesQueryQuery, DynamicRulesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicRulesQueryQuery, DynamicRulesQueryQueryVariables>(DynamicRulesQueryDocument, options);
      }
export function useDynamicRulesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicRulesQueryQuery, DynamicRulesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicRulesQueryQuery, DynamicRulesQueryQueryVariables>(DynamicRulesQueryDocument, options);
        }
export type DynamicRulesQueryQueryHookResult = ReturnType<typeof useDynamicRulesQueryQuery>;
export type DynamicRulesQueryLazyQueryHookResult = ReturnType<typeof useDynamicRulesQueryLazyQuery>;
export type DynamicRulesQueryQueryResult = Apollo.QueryResult<DynamicRulesQueryQuery, DynamicRulesQueryQueryVariables>;
export const ListDetailsTableQueryDocument = gql`
    query ListDetailsTableQuery($listId: Int!, $fetchSize: FetchSize, $ordering: [String!]) {
  list(id: $listId) {
    id
    entityTypeEnum
    listType {
      code
    }
  }
}
    `;

/**
 * __useListDetailsTableQueryQuery__
 *
 * To run a query within a React component, call `useListDetailsTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDetailsTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDetailsTableQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      fetchSize: // value for 'fetchSize'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useListDetailsTableQueryQuery(baseOptions: Apollo.QueryHookOptions<ListDetailsTableQueryQuery, ListDetailsTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDetailsTableQueryQuery, ListDetailsTableQueryQueryVariables>(ListDetailsTableQueryDocument, options);
      }
export function useListDetailsTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDetailsTableQueryQuery, ListDetailsTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDetailsTableQueryQuery, ListDetailsTableQueryQueryVariables>(ListDetailsTableQueryDocument, options);
        }
export type ListDetailsTableQueryQueryHookResult = ReturnType<typeof useListDetailsTableQueryQuery>;
export type ListDetailsTableQueryLazyQueryHookResult = ReturnType<typeof useListDetailsTableQueryLazyQuery>;
export type ListDetailsTableQueryQueryResult = Apollo.QueryResult<ListDetailsTableQueryQuery, ListDetailsTableQueryQueryVariables>;
export const UpdateListSubTitleDocument = gql`
    mutation UpdateListSubTitle($listId: Int!, $description: String!) {
  updateList(input: {id: $listId, description: $description}) {
    id
    description
  }
}
    `;
export type UpdateListSubTitleMutationFn = Apollo.MutationFunction<UpdateListSubTitleMutation, UpdateListSubTitleMutationVariables>;

/**
 * __useUpdateListSubTitleMutation__
 *
 * To run a mutation, you first call `useUpdateListSubTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListSubTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListSubTitleMutation, { data, loading, error }] = useUpdateListSubTitleMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateListSubTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListSubTitleMutation, UpdateListSubTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListSubTitleMutation, UpdateListSubTitleMutationVariables>(UpdateListSubTitleDocument, options);
      }
export type UpdateListSubTitleMutationHookResult = ReturnType<typeof useUpdateListSubTitleMutation>;
export type UpdateListSubTitleMutationResult = Apollo.MutationResult<UpdateListSubTitleMutation>;
export type UpdateListSubTitleMutationOptions = Apollo.BaseMutationOptions<UpdateListSubTitleMutation, UpdateListSubTitleMutationVariables>;
export const UpdateListCountriesDocument = gql`
    mutation UpdateListCountries($listId: Int!, $countries: [CountryCode!]) {
  updateListCountries(listId: $listId, countries: $countries) {
    id
    countries {
      hash
      nodes {
        id
        countryCode
      }
    }
  }
}
    `;
export type UpdateListCountriesMutationFn = Apollo.MutationFunction<UpdateListCountriesMutation, UpdateListCountriesMutationVariables>;

/**
 * __useUpdateListCountriesMutation__
 *
 * To run a mutation, you first call `useUpdateListCountriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListCountriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListCountriesMutation, { data, loading, error }] = useUpdateListCountriesMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useUpdateListCountriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListCountriesMutation, UpdateListCountriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListCountriesMutation, UpdateListCountriesMutationVariables>(UpdateListCountriesDocument, options);
      }
export type UpdateListCountriesMutationHookResult = ReturnType<typeof useUpdateListCountriesMutation>;
export type UpdateListCountriesMutationResult = Apollo.MutationResult<UpdateListCountriesMutation>;
export type UpdateListCountriesMutationOptions = Apollo.BaseMutationOptions<UpdateListCountriesMutation, UpdateListCountriesMutationVariables>;
export const SetDynamicRulesForListDocument = gql`
    mutation SetDynamicRulesForList($input: DynamicRulesInput!) {
  setDynamicRulesToList(input: $input) {
    id
    list {
      id
      ...ListDynamicRulesFragment
      affiliations {
        ... on PersonConnection {
          hash
          totalCount
        }
        ... on SiteConnection {
          hash
          totalCount
        }
        ... on ActivityConnection {
          hash
          totalCount
        }
        ... on SitePersonConnection {
          hash
          totalCount
        }
      }
    }
  }
}
    ${ListDynamicRulesFragmentFragmentDoc}`;
export type SetDynamicRulesForListMutationFn = Apollo.MutationFunction<SetDynamicRulesForListMutation, SetDynamicRulesForListMutationVariables>;

/**
 * __useSetDynamicRulesForListMutation__
 *
 * To run a mutation, you first call `useSetDynamicRulesForListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDynamicRulesForListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDynamicRulesForListMutation, { data, loading, error }] = useSetDynamicRulesForListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDynamicRulesForListMutation(baseOptions?: Apollo.MutationHookOptions<SetDynamicRulesForListMutation, SetDynamicRulesForListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDynamicRulesForListMutation, SetDynamicRulesForListMutationVariables>(SetDynamicRulesForListDocument, options);
      }
export type SetDynamicRulesForListMutationHookResult = ReturnType<typeof useSetDynamicRulesForListMutation>;
export type SetDynamicRulesForListMutationResult = Apollo.MutationResult<SetDynamicRulesForListMutation>;
export type SetDynamicRulesForListMutationOptions = Apollo.BaseMutationOptions<SetDynamicRulesForListMutation, SetDynamicRulesForListMutationVariables>;
export const ListDynamicRulesQueryDocument = gql`
    query ListDynamicRulesQuery($listId: Int!) {
  list(id: $listId) {
    id
    ...ListDynamicRulesFragment
    countries {
      hash
      nodes {
        id
        countryCode
      }
    }
  }
}
    ${ListDynamicRulesFragmentFragmentDoc}`;

/**
 * __useListDynamicRulesQueryQuery__
 *
 * To run a query within a React component, call `useListDynamicRulesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDynamicRulesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDynamicRulesQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useListDynamicRulesQueryQuery(baseOptions: Apollo.QueryHookOptions<ListDynamicRulesQueryQuery, ListDynamicRulesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDynamicRulesQueryQuery, ListDynamicRulesQueryQueryVariables>(ListDynamicRulesQueryDocument, options);
      }
export function useListDynamicRulesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDynamicRulesQueryQuery, ListDynamicRulesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDynamicRulesQueryQuery, ListDynamicRulesQueryQueryVariables>(ListDynamicRulesQueryDocument, options);
        }
export type ListDynamicRulesQueryQueryHookResult = ReturnType<typeof useListDynamicRulesQueryQuery>;
export type ListDynamicRulesQueryLazyQueryHookResult = ReturnType<typeof useListDynamicRulesQueryLazyQuery>;
export type ListDynamicRulesQueryQueryResult = Apollo.QueryResult<ListDynamicRulesQueryQuery, ListDynamicRulesQueryQueryVariables>;
export const updateFavListDocument = gql`
    mutation updateFavList($listId: Int!) {
  toggleFavoriteList(listId: $listId) {
    id
    list {
      id
      isPinned
      isFavoriteList
    }
  }
}
    `;
export type updateFavListMutationFn = Apollo.MutationFunction<updateFavListMutation, updateFavListMutationVariables>;

/**
 * __useupdateFavListMutation__
 *
 * To run a mutation, you first call `useupdateFavListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateFavListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavListMutation, { data, loading, error }] = useupdateFavListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useupdateFavListMutation(baseOptions?: Apollo.MutationHookOptions<updateFavListMutation, updateFavListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<updateFavListMutation, updateFavListMutationVariables>(updateFavListDocument, options);
      }
export type updateFavListMutationHookResult = ReturnType<typeof useupdateFavListMutation>;
export type updateFavListMutationResult = Apollo.MutationResult<updateFavListMutation>;
export type updateFavListMutationOptions = Apollo.BaseMutationOptions<updateFavListMutation, updateFavListMutationVariables>;
export const DownloadFileDocument = gql`
    mutation DownloadFile($listId: Int!, $listFormatId: Int!) {
  downloadList(listId: $listId, listFormatId: $listFormatId) {
    filename
    url
  }
}
    `;
export type DownloadFileMutationFn = Apollo.MutationFunction<DownloadFileMutation, DownloadFileMutationVariables>;

/**
 * __useDownloadFileMutation__
 *
 * To run a mutation, you first call `useDownloadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadFileMutation, { data, loading, error }] = useDownloadFileMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      listFormatId: // value for 'listFormatId'
 *   },
 * });
 */
export function useDownloadFileMutation(baseOptions?: Apollo.MutationHookOptions<DownloadFileMutation, DownloadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadFileMutation, DownloadFileMutationVariables>(DownloadFileDocument, options);
      }
export type DownloadFileMutationHookResult = ReturnType<typeof useDownloadFileMutation>;
export type DownloadFileMutationResult = Apollo.MutationResult<DownloadFileMutation>;
export type DownloadFileMutationOptions = Apollo.BaseMutationOptions<DownloadFileMutation, DownloadFileMutationVariables>;
export const AvailableListFormatsDocument = gql`
    query AvailableListFormats($listId: Int!) {
  downloadFilesViaBox: instanceSettingValue(type: DOWNLOAD_FILES_VIA_BOX)
  list(id: $listId) {
    id
    affiliations {
      ... on ActivityConnection {
        hash
        totalCount
      }
      ... on SiteConnection {
        hash
        totalCount
      }
      ... on PersonConnection {
        hash
        totalCount
      }
    }
    availableFormats {
      hash
      nodes {
        id
        heading
      }
    }
  }
}
    `;

/**
 * __useAvailableListFormatsQuery__
 *
 * To run a query within a React component, call `useAvailableListFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableListFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableListFormatsQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useAvailableListFormatsQuery(baseOptions: Apollo.QueryHookOptions<AvailableListFormatsQuery, AvailableListFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableListFormatsQuery, AvailableListFormatsQueryVariables>(AvailableListFormatsDocument, options);
      }
export function useAvailableListFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableListFormatsQuery, AvailableListFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableListFormatsQuery, AvailableListFormatsQueryVariables>(AvailableListFormatsDocument, options);
        }
export type AvailableListFormatsQueryHookResult = ReturnType<typeof useAvailableListFormatsQuery>;
export type AvailableListFormatsLazyQueryHookResult = ReturnType<typeof useAvailableListFormatsLazyQuery>;
export type AvailableListFormatsQueryResult = Apollo.QueryResult<AvailableListFormatsQuery, AvailableListFormatsQueryVariables>;
export const SetSharedStatusForListDocument = gql`
    mutation SetSharedStatusForList($listId: Int!, $isShared: Boolean!) {
  updateList(input: {id: $listId, isShared: $isShared}) {
    id
    isShared
  }
}
    `;
export type SetSharedStatusForListMutationFn = Apollo.MutationFunction<SetSharedStatusForListMutation, SetSharedStatusForListMutationVariables>;

/**
 * __useSetSharedStatusForListMutation__
 *
 * To run a mutation, you first call `useSetSharedStatusForListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSharedStatusForListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSharedStatusForListMutation, { data, loading, error }] = useSetSharedStatusForListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      isShared: // value for 'isShared'
 *   },
 * });
 */
export function useSetSharedStatusForListMutation(baseOptions?: Apollo.MutationHookOptions<SetSharedStatusForListMutation, SetSharedStatusForListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSharedStatusForListMutation, SetSharedStatusForListMutationVariables>(SetSharedStatusForListDocument, options);
      }
export type SetSharedStatusForListMutationHookResult = ReturnType<typeof useSetSharedStatusForListMutation>;
export type SetSharedStatusForListMutationResult = Apollo.MutationResult<SetSharedStatusForListMutation>;
export type SetSharedStatusForListMutationOptions = Apollo.BaseMutationOptions<SetSharedStatusForListMutation, SetSharedStatusForListMutationVariables>;
export const ListSharedDataQueryDocument = gql`
    query ListSharedDataQuery($listId: Int!) {
  list(id: $listId) {
    id
    isShared
  }
}
    `;

/**
 * __useListSharedDataQueryQuery__
 *
 * To run a query within a React component, call `useListSharedDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSharedDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSharedDataQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useListSharedDataQueryQuery(baseOptions: Apollo.QueryHookOptions<ListSharedDataQueryQuery, ListSharedDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSharedDataQueryQuery, ListSharedDataQueryQueryVariables>(ListSharedDataQueryDocument, options);
      }
export function useListSharedDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSharedDataQueryQuery, ListSharedDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSharedDataQueryQuery, ListSharedDataQueryQueryVariables>(ListSharedDataQueryDocument, options);
        }
export type ListSharedDataQueryQueryHookResult = ReturnType<typeof useListSharedDataQueryQuery>;
export type ListSharedDataQueryLazyQueryHookResult = ReturnType<typeof useListSharedDataQueryLazyQuery>;
export type ListSharedDataQueryQueryResult = Apollo.QueryResult<ListSharedDataQueryQuery, ListSharedDataQueryQueryVariables>;
export const SetPinStatusForListDocument = gql`
    mutation SetPinStatusForList($listId: Int!, $enabled: Boolean!) {
  updatePinList(listId: $listId, enabled: $enabled) {
    id
  }
  updateFavoriteList(listId: $listId, enabled: false) @include(if: $enabled) {
    id
  }
}
    `;
export type SetPinStatusForListMutationFn = Apollo.MutationFunction<SetPinStatusForListMutation, SetPinStatusForListMutationVariables>;

/**
 * __useSetPinStatusForListMutation__
 *
 * To run a mutation, you first call `useSetPinStatusForListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPinStatusForListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPinStatusForListMutation, { data, loading, error }] = useSetPinStatusForListMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetPinStatusForListMutation(baseOptions?: Apollo.MutationHookOptions<SetPinStatusForListMutation, SetPinStatusForListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPinStatusForListMutation, SetPinStatusForListMutationVariables>(SetPinStatusForListDocument, options);
      }
export type SetPinStatusForListMutationHookResult = ReturnType<typeof useSetPinStatusForListMutation>;
export type SetPinStatusForListMutationResult = Apollo.MutationResult<SetPinStatusForListMutation>;
export type SetPinStatusForListMutationOptions = Apollo.BaseMutationOptions<SetPinStatusForListMutation, SetPinStatusForListMutationVariables>;
export const updateFavListByStarDocument = gql`
    mutation updateFavListByStar($listId: Int!, $enabled: Boolean!) {
  updateFavoriteList(listId: $listId, enabled: $enabled) {
    id
  }
}
    `;
export type updateFavListByStarMutationFn = Apollo.MutationFunction<updateFavListByStarMutation, updateFavListByStarMutationVariables>;

/**
 * __useupdateFavListByStarMutation__
 *
 * To run a mutation, you first call `useupdateFavListByStarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateFavListByStarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavListByStarMutation, { data, loading, error }] = useupdateFavListByStarMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useupdateFavListByStarMutation(baseOptions?: Apollo.MutationHookOptions<updateFavListByStarMutation, updateFavListByStarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<updateFavListByStarMutation, updateFavListByStarMutationVariables>(updateFavListByStarDocument, options);
      }
export type updateFavListByStarMutationHookResult = ReturnType<typeof useupdateFavListByStarMutation>;
export type updateFavListByStarMutationResult = Apollo.MutationResult<updateFavListByStarMutation>;
export type updateFavListByStarMutationOptions = Apollo.BaseMutationOptions<updateFavListByStarMutation, updateFavListByStarMutationVariables>;
export const ListStarQueryDocument = gql`
    query ListStarQuery($listId: Int!) {
  list(id: $listId) {
    id
    isPinned
    isFavoriteList
  }
}
    `;

/**
 * __useListStarQueryQuery__
 *
 * To run a query within a React component, call `useListStarQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListStarQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListStarQueryQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useListStarQueryQuery(baseOptions: Apollo.QueryHookOptions<ListStarQueryQuery, ListStarQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListStarQueryQuery, ListStarQueryQueryVariables>(ListStarQueryDocument, options);
      }
export function useListStarQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListStarQueryQuery, ListStarQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListStarQueryQuery, ListStarQueryQueryVariables>(ListStarQueryDocument, options);
        }
export type ListStarQueryQueryHookResult = ReturnType<typeof useListStarQueryQuery>;
export type ListStarQueryLazyQueryHookResult = ReturnType<typeof useListStarQueryLazyQuery>;
export type ListStarQueryQueryResult = Apollo.QueryResult<ListStarQueryQuery, ListStarQueryQueryVariables>;
export const ListTableQueryDocument = gql`
    query ListTableQuery($criteria: ListCriteria) {
  connection: lists(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...ListTableFragment
    }
  }
}
    ${ListTableFragmentFragmentDoc}`;

/**
 * __useListTableQueryQuery__
 *
 * To run a query within a React component, call `useListTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useListTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<ListTableQueryQuery, ListTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTableQueryQuery, ListTableQueryQueryVariables>(ListTableQueryDocument, options);
      }
export function useListTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTableQueryQuery, ListTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTableQueryQuery, ListTableQueryQueryVariables>(ListTableQueryDocument, options);
        }
export type ListTableQueryQueryHookResult = ReturnType<typeof useListTableQueryQuery>;
export type ListTableQueryLazyQueryHookResult = ReturnType<typeof useListTableQueryLazyQuery>;
export type ListTableQueryQueryResult = Apollo.QueryResult<ListTableQueryQuery, ListTableQueryQueryVariables>;
export const ListRecordQueryDocument = gql`
    query ListRecordQuery($recordId: Int!) {
  record: list(id: $recordId) {
    id
    ...ListTableFragment
  }
}
    ${ListTableFragmentFragmentDoc}`;

/**
 * __useListRecordQueryQuery__
 *
 * To run a query within a React component, call `useListRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useListRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<ListRecordQueryQuery, ListRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRecordQueryQuery, ListRecordQueryQueryVariables>(ListRecordQueryDocument, options);
      }
export function useListRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRecordQueryQuery, ListRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRecordQueryQuery, ListRecordQueryQueryVariables>(ListRecordQueryDocument, options);
        }
export type ListRecordQueryQueryHookResult = ReturnType<typeof useListRecordQueryQuery>;
export type ListRecordQueryLazyQueryHookResult = ReturnType<typeof useListRecordQueryLazyQuery>;
export type ListRecordQueryQueryResult = Apollo.QueryResult<ListRecordQueryQuery, ListRecordQueryQueryVariables>;
export const RemoveFromStaticListMutationDocument = gql`
    mutation RemoveFromStaticListMutation($id: Int!, $listId: Int!) {
  removeFromStaticList(id: $id, listId: $listId) {
    id
  }
}
    `;
export type RemoveFromStaticListMutationMutationFn = Apollo.MutationFunction<RemoveFromStaticListMutationMutation, RemoveFromStaticListMutationMutationVariables>;

/**
 * __useRemoveFromStaticListMutationMutation__
 *
 * To run a mutation, you first call `useRemoveFromStaticListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromStaticListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromStaticListMutationMutation, { data, loading, error }] = useRemoveFromStaticListMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useRemoveFromStaticListMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromStaticListMutationMutation, RemoveFromStaticListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromStaticListMutationMutation, RemoveFromStaticListMutationMutationVariables>(RemoveFromStaticListMutationDocument, options);
      }
export type RemoveFromStaticListMutationMutationHookResult = ReturnType<typeof useRemoveFromStaticListMutationMutation>;
export type RemoveFromStaticListMutationMutationResult = Apollo.MutationResult<RemoveFromStaticListMutationMutation>;
export type RemoveFromStaticListMutationMutationOptions = Apollo.BaseMutationOptions<RemoveFromStaticListMutationMutation, RemoveFromStaticListMutationMutationVariables>;
export const AvailableMassAssignFieldsQueryDocument = gql`
    query AvailableMassAssignFieldsQuery($entityType: EntityTypeEnum!) {
  availableMassAssignFields(filter: {entityTypes: [$entityType]}) {
    heading
    isHeadingKey
    fieldType
    entityTypes
    actionName
    accessRules {
      customFieldCode
      allowMutation
      allowRead
    }
  }
}
    `;

/**
 * __useAvailableMassAssignFieldsQueryQuery__
 *
 * To run a query within a React component, call `useAvailableMassAssignFieldsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableMassAssignFieldsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableMassAssignFieldsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useAvailableMassAssignFieldsQueryQuery(baseOptions: Apollo.QueryHookOptions<AvailableMassAssignFieldsQueryQuery, AvailableMassAssignFieldsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableMassAssignFieldsQueryQuery, AvailableMassAssignFieldsQueryQueryVariables>(AvailableMassAssignFieldsQueryDocument, options);
      }
export function useAvailableMassAssignFieldsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableMassAssignFieldsQueryQuery, AvailableMassAssignFieldsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableMassAssignFieldsQueryQuery, AvailableMassAssignFieldsQueryQueryVariables>(AvailableMassAssignFieldsQueryDocument, options);
        }
export type AvailableMassAssignFieldsQueryQueryHookResult = ReturnType<typeof useAvailableMassAssignFieldsQueryQuery>;
export type AvailableMassAssignFieldsQueryLazyQueryHookResult = ReturnType<typeof useAvailableMassAssignFieldsQueryLazyQuery>;
export type AvailableMassAssignFieldsQueryQueryResult = Apollo.QueryResult<AvailableMassAssignFieldsQueryQuery, AvailableMassAssignFieldsQueryQueryVariables>;
export const MassAssignPreviewQueryDocument = gql`
    query MassAssignPreviewQuery($actionName: String!, $selectionCriteria: SelectionCriteriaInput!, $input: MassAssignFieldInput!) {
  previewMassAssign(
    actionName: $actionName
    selection: $selectionCriteria
    input: $input
  ) {
    tbd
    addCount
    addLabel
    skipCount
    skipLabel
    updatedCount
    updatedLabel
    blankOutLabel
    blankOutSize
  }
}
    `;

/**
 * __useMassAssignPreviewQueryQuery__
 *
 * To run a query within a React component, call `useMassAssignPreviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassAssignPreviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassAssignPreviewQueryQuery({
 *   variables: {
 *      actionName: // value for 'actionName'
 *      selectionCriteria: // value for 'selectionCriteria'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMassAssignPreviewQueryQuery(baseOptions: Apollo.QueryHookOptions<MassAssignPreviewQueryQuery, MassAssignPreviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassAssignPreviewQueryQuery, MassAssignPreviewQueryQueryVariables>(MassAssignPreviewQueryDocument, options);
      }
export function useMassAssignPreviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassAssignPreviewQueryQuery, MassAssignPreviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassAssignPreviewQueryQuery, MassAssignPreviewQueryQueryVariables>(MassAssignPreviewQueryDocument, options);
        }
export type MassAssignPreviewQueryQueryHookResult = ReturnType<typeof useMassAssignPreviewQueryQuery>;
export type MassAssignPreviewQueryLazyQueryHookResult = ReturnType<typeof useMassAssignPreviewQueryLazyQuery>;
export type MassAssignPreviewQueryQueryResult = Apollo.QueryResult<MassAssignPreviewQueryQuery, MassAssignPreviewQueryQueryVariables>;
export const SubmitMassAssignSingleSelectMutationDocument = gql`
    mutation SubmitMassAssignSingleSelectMutation($actionName: String!, $selectionCriteria: SelectionCriteriaInput!, $input: MassAssignFieldInput!) {
  executeMassAssign(
    actionName: $actionName
    selection: $selectionCriteria
    input: $input
  )
}
    `;
export type SubmitMassAssignSingleSelectMutationMutationFn = Apollo.MutationFunction<SubmitMassAssignSingleSelectMutationMutation, SubmitMassAssignSingleSelectMutationMutationVariables>;

/**
 * __useSubmitMassAssignSingleSelectMutationMutation__
 *
 * To run a mutation, you first call `useSubmitMassAssignSingleSelectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMassAssignSingleSelectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMassAssignSingleSelectMutationMutation, { data, loading, error }] = useSubmitMassAssignSingleSelectMutationMutation({
 *   variables: {
 *      actionName: // value for 'actionName'
 *      selectionCriteria: // value for 'selectionCriteria'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMassAssignSingleSelectMutationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMassAssignSingleSelectMutationMutation, SubmitMassAssignSingleSelectMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMassAssignSingleSelectMutationMutation, SubmitMassAssignSingleSelectMutationMutationVariables>(SubmitMassAssignSingleSelectMutationDocument, options);
      }
export type SubmitMassAssignSingleSelectMutationMutationHookResult = ReturnType<typeof useSubmitMassAssignSingleSelectMutationMutation>;
export type SubmitMassAssignSingleSelectMutationMutationResult = Apollo.MutationResult<SubmitMassAssignSingleSelectMutationMutation>;
export type SubmitMassAssignSingleSelectMutationMutationOptions = Apollo.BaseMutationOptions<SubmitMassAssignSingleSelectMutationMutation, SubmitMassAssignSingleSelectMutationMutationVariables>;
export const MassAssignMultiOptionsQueryDocument = gql`
    query MassAssignMultiOptionsQuery($actionName: String!, $search: String!, $countries: [CountryCode!]) {
  massAssignFieldOptions(
    actionName: $actionName
    search: $search
    countries: $countries
  ) {
    key
    heading
    isHeadingKey
  }
}
    `;

/**
 * __useMassAssignMultiOptionsQueryQuery__
 *
 * To run a query within a React component, call `useMassAssignMultiOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassAssignMultiOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassAssignMultiOptionsQueryQuery({
 *   variables: {
 *      actionName: // value for 'actionName'
 *      search: // value for 'search'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useMassAssignMultiOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<MassAssignMultiOptionsQueryQuery, MassAssignMultiOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassAssignMultiOptionsQueryQuery, MassAssignMultiOptionsQueryQueryVariables>(MassAssignMultiOptionsQueryDocument, options);
      }
export function useMassAssignMultiOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassAssignMultiOptionsQueryQuery, MassAssignMultiOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassAssignMultiOptionsQueryQuery, MassAssignMultiOptionsQueryQueryVariables>(MassAssignMultiOptionsQueryDocument, options);
        }
export type MassAssignMultiOptionsQueryQueryHookResult = ReturnType<typeof useMassAssignMultiOptionsQueryQuery>;
export type MassAssignMultiOptionsQueryLazyQueryHookResult = ReturnType<typeof useMassAssignMultiOptionsQueryLazyQuery>;
export type MassAssignMultiOptionsQueryQueryResult = Apollo.QueryResult<MassAssignMultiOptionsQueryQuery, MassAssignMultiOptionsQueryQueryVariables>;
export const MassAssignOptionsQueryDocument = gql`
    query MassAssignOptionsQuery($actionName: String!, $search: String!, $countries: [CountryCode!]) {
  massAssignFieldOptions(
    actionName: $actionName
    search: $search
    countries: $countries
  ) {
    key
    heading
    isHeadingKey
  }
}
    `;

/**
 * __useMassAssignOptionsQueryQuery__
 *
 * To run a query within a React component, call `useMassAssignOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassAssignOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassAssignOptionsQueryQuery({
 *   variables: {
 *      actionName: // value for 'actionName'
 *      search: // value for 'search'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useMassAssignOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<MassAssignOptionsQueryQuery, MassAssignOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassAssignOptionsQueryQuery, MassAssignOptionsQueryQueryVariables>(MassAssignOptionsQueryDocument, options);
      }
export function useMassAssignOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassAssignOptionsQueryQuery, MassAssignOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassAssignOptionsQueryQuery, MassAssignOptionsQueryQueryVariables>(MassAssignOptionsQueryDocument, options);
        }
export type MassAssignOptionsQueryQueryHookResult = ReturnType<typeof useMassAssignOptionsQueryQuery>;
export type MassAssignOptionsQueryLazyQueryHookResult = ReturnType<typeof useMassAssignOptionsQueryLazyQuery>;
export type MassAssignOptionsQueryQueryResult = Apollo.QueryResult<MassAssignOptionsQueryQuery, MassAssignOptionsQueryQueryVariables>;
export const MassAssignMultiTagOptionsQueryDocument = gql`
    query MassAssignMultiTagOptionsQuery($actionName: String!, $search: String!) {
  massAssignFieldOptions(actionName: $actionName, search: $search) {
    key
    heading
    isHeadingKey
  }
}
    `;

/**
 * __useMassAssignMultiTagOptionsQueryQuery__
 *
 * To run a query within a React component, call `useMassAssignMultiTagOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassAssignMultiTagOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassAssignMultiTagOptionsQueryQuery({
 *   variables: {
 *      actionName: // value for 'actionName'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMassAssignMultiTagOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<MassAssignMultiTagOptionsQueryQuery, MassAssignMultiTagOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassAssignMultiTagOptionsQueryQuery, MassAssignMultiTagOptionsQueryQueryVariables>(MassAssignMultiTagOptionsQueryDocument, options);
      }
export function useMassAssignMultiTagOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassAssignMultiTagOptionsQueryQuery, MassAssignMultiTagOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassAssignMultiTagOptionsQueryQuery, MassAssignMultiTagOptionsQueryQueryVariables>(MassAssignMultiTagOptionsQueryDocument, options);
        }
export type MassAssignMultiTagOptionsQueryQueryHookResult = ReturnType<typeof useMassAssignMultiTagOptionsQueryQuery>;
export type MassAssignMultiTagOptionsQueryLazyQueryHookResult = ReturnType<typeof useMassAssignMultiTagOptionsQueryLazyQuery>;
export type MassAssignMultiTagOptionsQueryQueryResult = Apollo.QueryResult<MassAssignMultiTagOptionsQueryQuery, MassAssignMultiTagOptionsQueryQueryVariables>;
export const ActivityScrollListDocument = gql`
    query ActivityScrollList($personId: Int!) {
  person(id: $personId) {
    id
    activities {
      totalCount
      nodes {
        id
        title: heading
        startDate
        endDate
        ct
        notes {
          hash
          nodes {
            id
            text
          }
        }
        status {
          code
          headingKey
        }
        type {
          code
          heading
          color {
            code
            colorName: headingKey
          }
        }
        responsibleUsers {
          hash
          nodes {
            id
            fullname
          }
        }
      }
    }
  }
}
    `;

/**
 * __useActivityScrollListQuery__
 *
 * To run a query within a React component, call `useActivityScrollListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityScrollListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityScrollListQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useActivityScrollListQuery(baseOptions: Apollo.QueryHookOptions<ActivityScrollListQuery, ActivityScrollListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityScrollListQuery, ActivityScrollListQueryVariables>(ActivityScrollListDocument, options);
      }
export function useActivityScrollListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityScrollListQuery, ActivityScrollListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityScrollListQuery, ActivityScrollListQueryVariables>(ActivityScrollListDocument, options);
        }
export type ActivityScrollListQueryHookResult = ReturnType<typeof useActivityScrollListQuery>;
export type ActivityScrollListLazyQueryHookResult = ReturnType<typeof useActivityScrollListLazyQuery>;
export type ActivityScrollListQueryResult = Apollo.QueryResult<ActivityScrollListQuery, ActivityScrollListQueryVariables>;
export const BulkPersToActivityDocument = gql`
    mutation BulkPersToActivity($activityId: Int!, $selection: SelectionCriteriaInput, $personId: Int) {
  addPersonsToActivity(
    activityId: $activityId
    selection: $selection
    personId: $personId
  ) {
    id
    heading
    persons {
      hash
      totalCount
    }
  }
}
    `;
export type BulkPersToActivityMutationFn = Apollo.MutationFunction<BulkPersToActivityMutation, BulkPersToActivityMutationVariables>;

/**
 * __useBulkPersToActivityMutation__
 *
 * To run a mutation, you first call `useBulkPersToActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPersToActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPersToActivityMutation, { data, loading, error }] = useBulkPersToActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      selection: // value for 'selection'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useBulkPersToActivityMutation(baseOptions?: Apollo.MutationHookOptions<BulkPersToActivityMutation, BulkPersToActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPersToActivityMutation, BulkPersToActivityMutationVariables>(BulkPersToActivityDocument, options);
      }
export type BulkPersToActivityMutationHookResult = ReturnType<typeof useBulkPersToActivityMutation>;
export type BulkPersToActivityMutationResult = Apollo.MutationResult<BulkPersToActivityMutation>;
export type BulkPersToActivityMutationOptions = Apollo.BaseMutationOptions<BulkPersToActivityMutation, BulkPersToActivityMutationVariables>;
export const ContactFormQueryDocument = gql`
    query ContactFormQuery($entityType: EntityTypeEnum, $contactType: ContactTypeEnum) {
  contactCategories(
    criteria: {entityType: $entityType, contactType: $contactType}
  ) {
    hash
    nodes {
      code
      heading
    }
  }
}
    `;

/**
 * __useContactFormQueryQuery__
 *
 * To run a query within a React component, call `useContactFormQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFormQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      contactType: // value for 'contactType'
 *   },
 * });
 */
export function useContactFormQueryQuery(baseOptions?: Apollo.QueryHookOptions<ContactFormQueryQuery, ContactFormQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFormQueryQuery, ContactFormQueryQueryVariables>(ContactFormQueryDocument, options);
      }
export function useContactFormQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFormQueryQuery, ContactFormQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFormQueryQuery, ContactFormQueryQueryVariables>(ContactFormQueryDocument, options);
        }
export type ContactFormQueryQueryHookResult = ReturnType<typeof useContactFormQueryQuery>;
export type ContactFormQueryLazyQueryHookResult = ReturnType<typeof useContactFormQueryLazyQuery>;
export type ContactFormQueryQueryResult = Apollo.QueryResult<ContactFormQueryQuery, ContactFormQueryQueryVariables>;
export const CherryPickDataQueryDocument = gql`
    query CherryPickDataQuery($country: CountryCode!) {
  cherryPickOverview(country: $country) {
    customerCode
    country
    amount
    amountAvailable
    amountUsed
  }
}
    `;

/**
 * __useCherryPickDataQueryQuery__
 *
 * To run a query within a React component, call `useCherryPickDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCherryPickDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCherryPickDataQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCherryPickDataQueryQuery(baseOptions: Apollo.QueryHookOptions<CherryPickDataQueryQuery, CherryPickDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CherryPickDataQueryQuery, CherryPickDataQueryQueryVariables>(CherryPickDataQueryDocument, options);
      }
export function useCherryPickDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CherryPickDataQueryQuery, CherryPickDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CherryPickDataQueryQuery, CherryPickDataQueryQueryVariables>(CherryPickDataQueryDocument, options);
        }
export type CherryPickDataQueryQueryHookResult = ReturnType<typeof useCherryPickDataQueryQuery>;
export type CherryPickDataQueryLazyQueryHookResult = ReturnType<typeof useCherryPickDataQueryLazyQuery>;
export type CherryPickDataQueryQueryResult = Apollo.QueryResult<CherryPickDataQueryQuery, CherryPickDataQueryQueryVariables>;
export const EducationDataQueryDocument = gql`
    query EducationDataQuery($countries: [CountryCode!], $search: String) {
  educations(
    criteria: {label: $search, countries: $countries, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useEducationDataQueryQuery__
 *
 * To run a query within a React component, call `useEducationDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEducationDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEducationDataQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEducationDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<EducationDataQueryQuery, EducationDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EducationDataQueryQuery, EducationDataQueryQueryVariables>(EducationDataQueryDocument, options);
      }
export function useEducationDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EducationDataQueryQuery, EducationDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EducationDataQueryQuery, EducationDataQueryQueryVariables>(EducationDataQueryDocument, options);
        }
export type EducationDataQueryQueryHookResult = ReturnType<typeof useEducationDataQueryQuery>;
export type EducationDataQueryLazyQueryHookResult = ReturnType<typeof useEducationDataQueryLazyQuery>;
export type EducationDataQueryQueryResult = Apollo.QueryResult<EducationDataQueryQuery, EducationDataQueryQueryVariables>;
export const ExternalIdFormDocument = gql`
    query ExternalIdForm($entityType: EntityTypeEnum) {
  externalIdTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      isHeadingKey
      heading
    }
  }
}
    `;

/**
 * __useExternalIdFormQuery__
 *
 * To run a query within a React component, call `useExternalIdFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdFormQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useExternalIdFormQuery(baseOptions?: Apollo.QueryHookOptions<ExternalIdFormQuery, ExternalIdFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdFormQuery, ExternalIdFormQueryVariables>(ExternalIdFormDocument, options);
      }
export function useExternalIdFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdFormQuery, ExternalIdFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdFormQuery, ExternalIdFormQueryVariables>(ExternalIdFormDocument, options);
        }
export type ExternalIdFormQueryHookResult = ReturnType<typeof useExternalIdFormQuery>;
export type ExternalIdFormLazyQueryHookResult = ReturnType<typeof useExternalIdFormLazyQuery>;
export type ExternalIdFormQueryResult = Apollo.QueryResult<ExternalIdFormQuery, ExternalIdFormQueryVariables>;
export const UpdatePersonFilterCodeMutationDocument = gql`
    mutation UpdatePersonFilterCodeMutation($persId: Int!, $filterCodeIds: [Int!]!) {
  updatePersonFilterCode(personId: $persId, filterCodeIds: $filterCodeIds) {
    id
    person {
      id
      filterCodes {
        hash
        hasKOL: containsType(code: "KOL")
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type UpdatePersonFilterCodeMutationMutationFn = Apollo.MutationFunction<UpdatePersonFilterCodeMutationMutation, UpdatePersonFilterCodeMutationMutationVariables>;

/**
 * __useUpdatePersonFilterCodeMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonFilterCodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonFilterCodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonFilterCodeMutationMutation, { data, loading, error }] = useUpdatePersonFilterCodeMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      filterCodeIds: // value for 'filterCodeIds'
 *   },
 * });
 */
export function useUpdatePersonFilterCodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonFilterCodeMutationMutation, UpdatePersonFilterCodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonFilterCodeMutationMutation, UpdatePersonFilterCodeMutationMutationVariables>(UpdatePersonFilterCodeMutationDocument, options);
      }
export type UpdatePersonFilterCodeMutationMutationHookResult = ReturnType<typeof useUpdatePersonFilterCodeMutationMutation>;
export type UpdatePersonFilterCodeMutationMutationResult = Apollo.MutationResult<UpdatePersonFilterCodeMutationMutation>;
export type UpdatePersonFilterCodeMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonFilterCodeMutationMutation, UpdatePersonFilterCodeMutationMutationVariables>;
export const FilterCodesSearchQueryDocument = gql`
    query FilterCodesSearchQuery($search: String) {
  filterCodeTypes(criteria: {filterCodeTypeOrFilterCodeLabel: $search}) {
    hash
    nodes {
      id
      code
      heading
      getFilterCodesByTypeId(criteria: {header: $search}) {
        hash
        totalCount
        nodes {
          id
          header
        }
      }
    }
  }
}
    `;

/**
 * __useFilterCodesSearchQueryQuery__
 *
 * To run a query within a React component, call `useFilterCodesSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCodesSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCodesSearchQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFilterCodesSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<FilterCodesSearchQueryQuery, FilterCodesSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCodesSearchQueryQuery, FilterCodesSearchQueryQueryVariables>(FilterCodesSearchQueryDocument, options);
      }
export function useFilterCodesSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCodesSearchQueryQuery, FilterCodesSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCodesSearchQueryQuery, FilterCodesSearchQueryQueryVariables>(FilterCodesSearchQueryDocument, options);
        }
export type FilterCodesSearchQueryQueryHookResult = ReturnType<typeof useFilterCodesSearchQueryQuery>;
export type FilterCodesSearchQueryLazyQueryHookResult = ReturnType<typeof useFilterCodesSearchQueryLazyQuery>;
export type FilterCodesSearchQueryQueryResult = Apollo.QueryResult<FilterCodesSearchQueryQuery, FilterCodesSearchQueryQueryVariables>;
export const PersonFilterCodesQueryDocument = gql`
    query PersonFilterCodesQuery($personId: Int!) {
  person(id: $personId) {
    id
    filterCodes {
      hash
      hasKOL: containsType(code: "KOL")
      nodes {
        id
        filterCodeTypeId
        header
      }
    }
  }
}
    `;

/**
 * __usePersonFilterCodesQueryQuery__
 *
 * To run a query within a React component, call `usePersonFilterCodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonFilterCodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonFilterCodesQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonFilterCodesQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonFilterCodesQueryQuery, PersonFilterCodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonFilterCodesQueryQuery, PersonFilterCodesQueryQueryVariables>(PersonFilterCodesQueryDocument, options);
      }
export function usePersonFilterCodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonFilterCodesQueryQuery, PersonFilterCodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonFilterCodesQueryQuery, PersonFilterCodesQueryQueryVariables>(PersonFilterCodesQueryDocument, options);
        }
export type PersonFilterCodesQueryQueryHookResult = ReturnType<typeof usePersonFilterCodesQueryQuery>;
export type PersonFilterCodesQueryLazyQueryHookResult = ReturnType<typeof usePersonFilterCodesQueryLazyQuery>;
export type PersonFilterCodesQueryQueryResult = Apollo.QueryResult<PersonFilterCodesQueryQuery, PersonFilterCodesQueryQueryVariables>;
export const GenerateGdprReportDocument = gql`
    mutation GenerateGdprReport($hcpId: Int!) {
  report: generateGdprInformation(hcpId: $hcpId) {
    url
  }
}
    `;
export type GenerateGdprReportMutationFn = Apollo.MutationFunction<GenerateGdprReportMutation, GenerateGdprReportMutationVariables>;

/**
 * __useGenerateGdprReportMutation__
 *
 * To run a mutation, you first call `useGenerateGdprReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGdprReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGdprReportMutation, { data, loading, error }] = useGenerateGdprReportMutation({
 *   variables: {
 *      hcpId: // value for 'hcpId'
 *   },
 * });
 */
export function useGenerateGdprReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGdprReportMutation, GenerateGdprReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGdprReportMutation, GenerateGdprReportMutationVariables>(GenerateGdprReportDocument, options);
      }
export type GenerateGdprReportMutationHookResult = ReturnType<typeof useGenerateGdprReportMutation>;
export type GenerateGdprReportMutationResult = Apollo.MutationResult<GenerateGdprReportMutation>;
export type GenerateGdprReportMutationOptions = Apollo.BaseMutationOptions<GenerateGdprReportMutation, GenerateGdprReportMutationVariables>;
export const PersonAffiliationsContainerQueryDocument = gql`
    query PersonAffiliationsContainerQuery($recordId: Int!) {
  person(id: $recordId) {
    id
    apurebaseId
    countryCode
    activities {
      hash
      totalCount
    }
    notes {
      hash
      totalCount
    }
    projects {
      hash
      totalCount
    }
    lists {
      hash
      totalCount
    }
    dcrGroups {
      hash
      totalCount
    }
    affiliations {
      hash
      totalCount
    }
    selectionRowsCustomerCount(criteria: {selectionType: DYNAMIC})
  }
}
    `;

/**
 * __usePersonAffiliationsContainerQueryQuery__
 *
 * To run a query within a React component, call `usePersonAffiliationsContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonAffiliationsContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonAffiliationsContainerQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function usePersonAffiliationsContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonAffiliationsContainerQueryQuery, PersonAffiliationsContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonAffiliationsContainerQueryQuery, PersonAffiliationsContainerQueryQueryVariables>(PersonAffiliationsContainerQueryDocument, options);
      }
export function usePersonAffiliationsContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonAffiliationsContainerQueryQuery, PersonAffiliationsContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonAffiliationsContainerQueryQuery, PersonAffiliationsContainerQueryQueryVariables>(PersonAffiliationsContainerQueryDocument, options);
        }
export type PersonAffiliationsContainerQueryQueryHookResult = ReturnType<typeof usePersonAffiliationsContainerQueryQuery>;
export type PersonAffiliationsContainerQueryLazyQueryHookResult = ReturnType<typeof usePersonAffiliationsContainerQueryLazyQuery>;
export type PersonAffiliationsContainerQueryQueryResult = Apollo.QueryResult<PersonAffiliationsContainerQueryQuery, PersonAffiliationsContainerQueryQueryVariables>;
export const PersonCardContainerQueryDocument = gql`
    query PersonCardContainerQuery($personId: Int!, $entityGridItemConfigurationId: Int!) {
  cardFieldKeys(entityGridItemConfigurationId: $entityGridItemConfigurationId) {
    entityGridItemConfigurationId
    person {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
    link {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
    site {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
  }
  person(id: $personId) {
    id
    segmentationCode {
      id
      heading
    }
    affiliations {
      hash
      nodes {
        id
        isPrimary
        siteId
      }
    }
  }
}
    ${GridCardFieldFragmentDoc}`;

/**
 * __usePersonCardContainerQueryQuery__
 *
 * To run a query within a React component, call `usePersonCardContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonCardContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonCardContainerQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function usePersonCardContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonCardContainerQueryQuery, PersonCardContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonCardContainerQueryQuery, PersonCardContainerQueryQueryVariables>(PersonCardContainerQueryDocument, options);
      }
export function usePersonCardContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonCardContainerQueryQuery, PersonCardContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonCardContainerQueryQuery, PersonCardContainerQueryQueryVariables>(PersonCardContainerQueryDocument, options);
        }
export type PersonCardContainerQueryQueryHookResult = ReturnType<typeof usePersonCardContainerQueryQuery>;
export type PersonCardContainerQueryLazyQueryHookResult = ReturnType<typeof usePersonCardContainerQueryLazyQuery>;
export type PersonCardContainerQueryQueryResult = Apollo.QueryResult<PersonCardContainerQueryQuery, PersonCardContainerQueryQueryVariables>;
export const RecordTabDcrGroupsQueryDocument = gql`
    query RecordTabDcrGroupsQuery($record: DcrGroupContainsRecordDcr!, $limit: Int!, $offset: Int!) {
  dcrGroups(
    criteria: {hasRecord: $record, fetchSize: {limit: $limit, offset: $offset}}
  ) {
    hash
    totalCount
    nodes {
      ...DcrGroupTableFragment
    }
  }
}
    ${DcrGroupTableFragmentFragmentDoc}`;

/**
 * __useRecordTabDcrGroupsQueryQuery__
 *
 * To run a query within a React component, call `useRecordTabDcrGroupsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordTabDcrGroupsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordTabDcrGroupsQueryQuery({
 *   variables: {
 *      record: // value for 'record'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRecordTabDcrGroupsQueryQuery(baseOptions: Apollo.QueryHookOptions<RecordTabDcrGroupsQueryQuery, RecordTabDcrGroupsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordTabDcrGroupsQueryQuery, RecordTabDcrGroupsQueryQueryVariables>(RecordTabDcrGroupsQueryDocument, options);
      }
export function useRecordTabDcrGroupsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordTabDcrGroupsQueryQuery, RecordTabDcrGroupsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordTabDcrGroupsQueryQuery, RecordTabDcrGroupsQueryQueryVariables>(RecordTabDcrGroupsQueryDocument, options);
        }
export type RecordTabDcrGroupsQueryQueryHookResult = ReturnType<typeof useRecordTabDcrGroupsQueryQuery>;
export type RecordTabDcrGroupsQueryLazyQueryHookResult = ReturnType<typeof useRecordTabDcrGroupsQueryLazyQuery>;
export type RecordTabDcrGroupsQueryQueryResult = Apollo.QueryResult<RecordTabDcrGroupsQueryQuery, RecordTabDcrGroupsQueryQueryVariables>;
export const HcpHeaderDocument = gql`
    query HcpHeader($personId: Int!) {
  person(id: $personId) {
    id
    fullName
    title
    countryCode
    maintainerSourceCode
    isCherryPicked
    isGdprInformed
    apurebaseId
    isActive
    primarySite {
      id
      name
      visitAddress {
        id
        street
        city
        postalCode
      }
      countryCode
      phone: mainContact(type: PHONE) {
        id
        value
      }
      email: mainContact(type: EMAIL) {
        id
        value
      }
    }
    segmentationCode {
      id
      heading
    }
  }
}
    `;

/**
 * __useHcpHeaderQuery__
 *
 * To run a query within a React component, call `useHcpHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useHcpHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHcpHeaderQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useHcpHeaderQuery(baseOptions: Apollo.QueryHookOptions<HcpHeaderQuery, HcpHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HcpHeaderQuery, HcpHeaderQueryVariables>(HcpHeaderDocument, options);
      }
export function useHcpHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HcpHeaderQuery, HcpHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HcpHeaderQuery, HcpHeaderQueryVariables>(HcpHeaderDocument, options);
        }
export type HcpHeaderQueryHookResult = ReturnType<typeof useHcpHeaderQuery>;
export type HcpHeaderLazyQueryHookResult = ReturnType<typeof useHcpHeaderLazyQuery>;
export type HcpHeaderQueryResult = Apollo.QueryResult<HcpHeaderQuery, HcpHeaderQueryVariables>;
export const CheckPersonMergeRequestQueryDocument = gql`
    query CheckPersonMergeRequestQuery($personId: Int!) {
  person(id: $personId) {
    id
    mergeRequests {
      hash
      totalCount
      nodes {
        id
        status
        entityAffiliationId
        intoEntityAffiliationId
        into {
          ... on Person {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckPersonMergeRequestQueryQuery__
 *
 * To run a query within a React component, call `useCheckPersonMergeRequestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPersonMergeRequestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPersonMergeRequestQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useCheckPersonMergeRequestQueryQuery(baseOptions: Apollo.QueryHookOptions<CheckPersonMergeRequestQueryQuery, CheckPersonMergeRequestQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPersonMergeRequestQueryQuery, CheckPersonMergeRequestQueryQueryVariables>(CheckPersonMergeRequestQueryDocument, options);
      }
export function useCheckPersonMergeRequestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPersonMergeRequestQueryQuery, CheckPersonMergeRequestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPersonMergeRequestQueryQuery, CheckPersonMergeRequestQueryQueryVariables>(CheckPersonMergeRequestQueryDocument, options);
        }
export type CheckPersonMergeRequestQueryQueryHookResult = ReturnType<typeof useCheckPersonMergeRequestQueryQuery>;
export type CheckPersonMergeRequestQueryLazyQueryHookResult = ReturnType<typeof useCheckPersonMergeRequestQueryLazyQuery>;
export type CheckPersonMergeRequestQueryQueryResult = Apollo.QueryResult<CheckPersonMergeRequestQueryQuery, CheckPersonMergeRequestQueryQueryVariables>;
export const PersonDetailListsDocument = gql`
    query PersonDetailLists($personId: Int!) {
  person(id: $personId) {
    id
    lists {
      hash
      nodes {
        id
        title
        description
        ct
        entityType {
          id
          heading
        }
        listType {
          id
          heading
        }
        createdUser {
          fullname
          id
        }
      }
    }
  }
}
    `;

/**
 * __usePersonDetailListsQuery__
 *
 * To run a query within a React component, call `usePersonDetailListsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailListsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDetailListsQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailListsQuery, PersonDetailListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailListsQuery, PersonDetailListsQueryVariables>(PersonDetailListsDocument, options);
      }
export function usePersonDetailListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailListsQuery, PersonDetailListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailListsQuery, PersonDetailListsQueryVariables>(PersonDetailListsDocument, options);
        }
export type PersonDetailListsQueryHookResult = ReturnType<typeof usePersonDetailListsQuery>;
export type PersonDetailListsLazyQueryHookResult = ReturnType<typeof usePersonDetailListsLazyQuery>;
export type PersonDetailListsQueryResult = Apollo.QueryResult<PersonDetailListsQuery, PersonDetailListsQueryVariables>;
export const PersonNoteDetailQueryDocument = gql`
    query PersonNoteDetailQuery($personId: Int!) {
  person(id: $personId) {
    id
    notes {
      hash
      totalCount
      nodes {
        id
        ...NoteDrawerFragment
      }
    }
  }
}
    ${NoteDrawerFragmentFragmentDoc}`;

/**
 * __usePersonNoteDetailQueryQuery__
 *
 * To run a query within a React component, call `usePersonNoteDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonNoteDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonNoteDetailQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonNoteDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonNoteDetailQueryQuery, PersonNoteDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonNoteDetailQueryQuery, PersonNoteDetailQueryQueryVariables>(PersonNoteDetailQueryDocument, options);
      }
export function usePersonNoteDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonNoteDetailQueryQuery, PersonNoteDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonNoteDetailQueryQuery, PersonNoteDetailQueryQueryVariables>(PersonNoteDetailQueryDocument, options);
        }
export type PersonNoteDetailQueryQueryHookResult = ReturnType<typeof usePersonNoteDetailQueryQuery>;
export type PersonNoteDetailQueryLazyQueryHookResult = ReturnType<typeof usePersonNoteDetailQueryLazyQuery>;
export type PersonNoteDetailQueryQueryResult = Apollo.QueryResult<PersonNoteDetailQueryQuery, PersonNoteDetailQueryQueryVariables>;
export const PersonDetailSegmentationQueryDocument = gql`
    query PersonDetailSegmentationQuery($personId: Int!) {
  person(id: $personId) {
    id
    productSegmentations {
      hash
      totalCount
      nodes {
        id
        person {
          id
          fullName
        }
        segmentationCode {
          id
          heading
        }
        product {
          id
          heading
          strengthUnitType {
            id
            abbreviation
            description
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePersonDetailSegmentationQueryQuery__
 *
 * To run a query within a React component, call `usePersonDetailSegmentationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailSegmentationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailSegmentationQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDetailSegmentationQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailSegmentationQueryQuery, PersonDetailSegmentationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailSegmentationQueryQuery, PersonDetailSegmentationQueryQueryVariables>(PersonDetailSegmentationQueryDocument, options);
      }
export function usePersonDetailSegmentationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailSegmentationQueryQuery, PersonDetailSegmentationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailSegmentationQueryQuery, PersonDetailSegmentationQueryQueryVariables>(PersonDetailSegmentationQueryDocument, options);
        }
export type PersonDetailSegmentationQueryQueryHookResult = ReturnType<typeof usePersonDetailSegmentationQueryQuery>;
export type PersonDetailSegmentationQueryLazyQueryHookResult = ReturnType<typeof usePersonDetailSegmentationQueryLazyQuery>;
export type PersonDetailSegmentationQueryQueryResult = Apollo.QueryResult<PersonDetailSegmentationQueryQuery, PersonDetailSegmentationQueryQueryVariables>;
export const PersonDetailProjectsDocument = gql`
    query PersonDetailProjects($personId: Int!) {
  person(id: $personId) {
    id
    projects {
      hash
      nodes {
        id
        title
        location
        startDate
        endDate
        notes {
          hash
          nodes {
            id
            text
          }
        }
        ct
        responsibleUsers {
          hash
          nodes {
            id
            fullname
          }
        }
        projectStatus {
          id
          heading
          code
        }
        projectType {
          id
          heading
          color {
            colorName: headingKey
            code
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePersonDetailProjectsQuery__
 *
 * To run a query within a React component, call `usePersonDetailProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailProjectsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDetailProjectsQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailProjectsQuery, PersonDetailProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailProjectsQuery, PersonDetailProjectsQueryVariables>(PersonDetailProjectsDocument, options);
      }
export function usePersonDetailProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailProjectsQuery, PersonDetailProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailProjectsQuery, PersonDetailProjectsQueryVariables>(PersonDetailProjectsDocument, options);
        }
export type PersonDetailProjectsQueryHookResult = ReturnType<typeof usePersonDetailProjectsQuery>;
export type PersonDetailProjectsLazyQueryHookResult = ReturnType<typeof usePersonDetailProjectsLazyQuery>;
export type PersonDetailProjectsQueryResult = Apollo.QueryResult<PersonDetailProjectsQuery, PersonDetailProjectsQueryVariables>;
export const PersonSelectionRowContainerDocument = gql`
    query PersonSelectionRowContainer($personApureBaseID: Int!, $selectionType: SlicerSelectionType) {
  selectionImfCustomers(
    criteria: {personApbIdInSelection: [$personApureBaseID], selectionType: $selectionType}
  ) {
    hash
    nodes {
      code
      callName
      name
    }
  }
}
    `;

/**
 * __usePersonSelectionRowContainerQuery__
 *
 * To run a query within a React component, call `usePersonSelectionRowContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSelectionRowContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSelectionRowContainerQuery({
 *   variables: {
 *      personApureBaseID: // value for 'personApureBaseID'
 *      selectionType: // value for 'selectionType'
 *   },
 * });
 */
export function usePersonSelectionRowContainerQuery(baseOptions: Apollo.QueryHookOptions<PersonSelectionRowContainerQuery, PersonSelectionRowContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonSelectionRowContainerQuery, PersonSelectionRowContainerQueryVariables>(PersonSelectionRowContainerDocument, options);
      }
export function usePersonSelectionRowContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonSelectionRowContainerQuery, PersonSelectionRowContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonSelectionRowContainerQuery, PersonSelectionRowContainerQueryVariables>(PersonSelectionRowContainerDocument, options);
        }
export type PersonSelectionRowContainerQueryHookResult = ReturnType<typeof usePersonSelectionRowContainerQuery>;
export type PersonSelectionRowContainerLazyQueryHookResult = ReturnType<typeof usePersonSelectionRowContainerLazyQuery>;
export type PersonSelectionRowContainerQueryResult = Apollo.QueryResult<PersonSelectionRowContainerQuery, PersonSelectionRowContainerQueryVariables>;
export const SegmentationCodesQueryDocument = gql`
    query SegmentationCodesQuery($personId: Int!) {
  person(id: $personId) {
    id
    segmentationCode {
      id
      heading
    }
  }
  segmentationCodes {
    hash
    nodes {
      code
      id
      description
      heading
    }
  }
}
    `;

/**
 * __useSegmentationCodesQueryQuery__
 *
 * To run a query within a React component, call `useSegmentationCodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentationCodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentationCodesQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSegmentationCodesQueryQuery(baseOptions: Apollo.QueryHookOptions<SegmentationCodesQueryQuery, SegmentationCodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentationCodesQueryQuery, SegmentationCodesQueryQueryVariables>(SegmentationCodesQueryDocument, options);
      }
export function useSegmentationCodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentationCodesQueryQuery, SegmentationCodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentationCodesQueryQuery, SegmentationCodesQueryQueryVariables>(SegmentationCodesQueryDocument, options);
        }
export type SegmentationCodesQueryQueryHookResult = ReturnType<typeof useSegmentationCodesQueryQuery>;
export type SegmentationCodesQueryLazyQueryHookResult = ReturnType<typeof useSegmentationCodesQueryLazyQuery>;
export type SegmentationCodesQueryQueryResult = Apollo.QueryResult<SegmentationCodesQueryQuery, SegmentationCodesQueryQueryVariables>;
export const RemoveSegmentationCodeMutationDocument = gql`
    mutation RemoveSegmentationCodeMutation($id: Int!) {
  removeSegmentationCode(personId: $id)
}
    `;
export type RemoveSegmentationCodeMutationMutationFn = Apollo.MutationFunction<RemoveSegmentationCodeMutationMutation, RemoveSegmentationCodeMutationMutationVariables>;

/**
 * __useRemoveSegmentationCodeMutationMutation__
 *
 * To run a mutation, you first call `useRemoveSegmentationCodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSegmentationCodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSegmentationCodeMutationMutation, { data, loading, error }] = useRemoveSegmentationCodeMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveSegmentationCodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSegmentationCodeMutationMutation, RemoveSegmentationCodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSegmentationCodeMutationMutation, RemoveSegmentationCodeMutationMutationVariables>(RemoveSegmentationCodeMutationDocument, options);
      }
export type RemoveSegmentationCodeMutationMutationHookResult = ReturnType<typeof useRemoveSegmentationCodeMutationMutation>;
export type RemoveSegmentationCodeMutationMutationResult = Apollo.MutationResult<RemoveSegmentationCodeMutationMutation>;
export type RemoveSegmentationCodeMutationMutationOptions = Apollo.BaseMutationOptions<RemoveSegmentationCodeMutationMutation, RemoveSegmentationCodeMutationMutationVariables>;
export const UpsertSegmentationCodeDocument = gql`
    mutation UpsertSegmentationCode($id: Int!, $segmentationId: Int!) {
  upsertPersonSegmentationCode(id: $id, segmentationId: $segmentationId) {
    id
    segmentationCode {
      id
      code
      heading
    }
  }
}
    `;
export type UpsertSegmentationCodeMutationFn = Apollo.MutationFunction<UpsertSegmentationCodeMutation, UpsertSegmentationCodeMutationVariables>;

/**
 * __useUpsertSegmentationCodeMutation__
 *
 * To run a mutation, you first call `useUpsertSegmentationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSegmentationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSegmentationCodeMutation, { data, loading, error }] = useUpsertSegmentationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useUpsertSegmentationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSegmentationCodeMutation, UpsertSegmentationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSegmentationCodeMutation, UpsertSegmentationCodeMutationVariables>(UpsertSegmentationCodeDocument, options);
      }
export type UpsertSegmentationCodeMutationHookResult = ReturnType<typeof useUpsertSegmentationCodeMutation>;
export type UpsertSegmentationCodeMutationResult = Apollo.MutationResult<UpsertSegmentationCodeMutation>;
export type UpsertSegmentationCodeMutationOptions = Apollo.BaseMutationOptions<UpsertSegmentationCodeMutation, UpsertSegmentationCodeMutationVariables>;
export const InsertEntityValidationLogDocument = gql`
    mutation InsertEntityValidationLog($id: Int!, $entity: EntityTypeEnum!, $valDate: DateTime!) {
  insertEntityValidationLog(
    affiliationId: $id
    entityType: $entity
    validationDate: $valDate
  ) {
    id
    entityAffiliationId
    entityTypeId
    validatedTime
    ct
    ut
    validatedByUser
    affiliationEntity {
      id
      ... on Person {
        imfVt
      }
      ... on Site {
        imfVt
      }
      ... on SitePerson {
        imfVt
      }
    }
  }
}
    `;
export type InsertEntityValidationLogMutationFn = Apollo.MutationFunction<InsertEntityValidationLogMutation, InsertEntityValidationLogMutationVariables>;

/**
 * __useInsertEntityValidationLogMutation__
 *
 * To run a mutation, you first call `useInsertEntityValidationLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEntityValidationLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEntityValidationLogMutation, { data, loading, error }] = useInsertEntityValidationLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entity: // value for 'entity'
 *      valDate: // value for 'valDate'
 *   },
 * });
 */
export function useInsertEntityValidationLogMutation(baseOptions?: Apollo.MutationHookOptions<InsertEntityValidationLogMutation, InsertEntityValidationLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEntityValidationLogMutation, InsertEntityValidationLogMutationVariables>(InsertEntityValidationLogDocument, options);
      }
export type InsertEntityValidationLogMutationHookResult = ReturnType<typeof useInsertEntityValidationLogMutation>;
export type InsertEntityValidationLogMutationResult = Apollo.MutationResult<InsertEntityValidationLogMutation>;
export type InsertEntityValidationLogMutationOptions = Apollo.BaseMutationOptions<InsertEntityValidationLogMutation, InsertEntityValidationLogMutationVariables>;
export const hasMdmAccessDocument = gql`
    query hasMdmAccess($id: Int!, $entityType: EntityTypeEnum!) {
  getAffiliationByEntity(id: $id, entityType: $entityType) {
    id
    imfVt
    ct
    maintainerSourceCode
  }
}
    `;

/**
 * __usehasMdmAccessQuery__
 *
 * To run a query within a React component, call `usehasMdmAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `usehasMdmAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usehasMdmAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function usehasMdmAccessQuery(baseOptions: Apollo.QueryHookOptions<hasMdmAccessQuery, hasMdmAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<hasMdmAccessQuery, hasMdmAccessQueryVariables>(hasMdmAccessDocument, options);
      }
export function usehasMdmAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<hasMdmAccessQuery, hasMdmAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<hasMdmAccessQuery, hasMdmAccessQueryVariables>(hasMdmAccessDocument, options);
        }
export type hasMdmAccessQueryHookResult = ReturnType<typeof usehasMdmAccessQuery>;
export type hasMdmAccessLazyQueryHookResult = ReturnType<typeof usehasMdmAccessLazyQuery>;
export type hasMdmAccessQueryResult = Apollo.QueryResult<hasMdmAccessQuery, hasMdmAccessQueryVariables>;
export const globalHasMdmAccessDocument = gql`
    query globalHasMdmAccess {
  hasAccessToModule(module: MDM)
}
    `;

/**
 * __useglobalHasMdmAccessQuery__
 *
 * To run a query within a React component, call `useglobalHasMdmAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useglobalHasMdmAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useglobalHasMdmAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useglobalHasMdmAccessQuery(baseOptions?: Apollo.QueryHookOptions<globalHasMdmAccessQuery, globalHasMdmAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<globalHasMdmAccessQuery, globalHasMdmAccessQueryVariables>(globalHasMdmAccessDocument, options);
      }
export function useglobalHasMdmAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<globalHasMdmAccessQuery, globalHasMdmAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<globalHasMdmAccessQuery, globalHasMdmAccessQueryVariables>(globalHasMdmAccessDocument, options);
        }
export type globalHasMdmAccessQueryHookResult = ReturnType<typeof useglobalHasMdmAccessQuery>;
export type globalHasMdmAccessLazyQueryHookResult = ReturnType<typeof useglobalHasMdmAccessLazyQuery>;
export type globalHasMdmAccessQueryResult = Apollo.QueryResult<globalHasMdmAccessQuery, globalHasMdmAccessQueryVariables>;
export const InsertMassEntityValidationLogDocument = gql`
    mutation InsertMassEntityValidationLog($id: [Int!]!, $entity: EntityTypeEnum!, $valDate: DateTime!) {
  insertMassEntityValidationLog(
    ids: $id
    entityType: $entity
    validationDate: $valDate
  )
}
    `;
export type InsertMassEntityValidationLogMutationFn = Apollo.MutationFunction<InsertMassEntityValidationLogMutation, InsertMassEntityValidationLogMutationVariables>;

/**
 * __useInsertMassEntityValidationLogMutation__
 *
 * To run a mutation, you first call `useInsertMassEntityValidationLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMassEntityValidationLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMassEntityValidationLogMutation, { data, loading, error }] = useInsertMassEntityValidationLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entity: // value for 'entity'
 *      valDate: // value for 'valDate'
 *   },
 * });
 */
export function useInsertMassEntityValidationLogMutation(baseOptions?: Apollo.MutationHookOptions<InsertMassEntityValidationLogMutation, InsertMassEntityValidationLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMassEntityValidationLogMutation, InsertMassEntityValidationLogMutationVariables>(InsertMassEntityValidationLogDocument, options);
      }
export type InsertMassEntityValidationLogMutationHookResult = ReturnType<typeof useInsertMassEntityValidationLogMutation>;
export type InsertMassEntityValidationLogMutationResult = Apollo.MutationResult<InsertMassEntityValidationLogMutation>;
export type InsertMassEntityValidationLogMutationOptions = Apollo.BaseMutationOptions<InsertMassEntityValidationLogMutation, InsertMassEntityValidationLogMutationVariables>;
export const CherryPickDocument = gql`
    mutation CherryPick($type: EntityTypeEnum!, $apurebaseIds: [Int!]!) {
  cherryPick(entityType: $type, apurebaseIds: $apurebaseIds) {
    id
    ... on Person {
      fullName
    }
  }
}
    `;
export type CherryPickMutationFn = Apollo.MutationFunction<CherryPickMutation, CherryPickMutationVariables>;

/**
 * __useCherryPickMutation__
 *
 * To run a mutation, you first call `useCherryPickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCherryPickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cherryPickMutation, { data, loading, error }] = useCherryPickMutation({
 *   variables: {
 *      type: // value for 'type'
 *      apurebaseIds: // value for 'apurebaseIds'
 *   },
 * });
 */
export function useCherryPickMutation(baseOptions?: Apollo.MutationHookOptions<CherryPickMutation, CherryPickMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CherryPickMutation, CherryPickMutationVariables>(CherryPickDocument, options);
      }
export type CherryPickMutationHookResult = ReturnType<typeof useCherryPickMutation>;
export type CherryPickMutationResult = Apollo.MutationResult<CherryPickMutation>;
export type CherryPickMutationOptions = Apollo.BaseMutationOptions<CherryPickMutation, CherryPickMutationVariables>;
export const SetActiveStatusPersonDocument = gql`
    mutation SetActiveStatusPerson($personId: Int!, $isActive: Boolean!) {
  setPersonActiveStatus(persId: $personId, isActive: $isActive) {
    id
    isActive
  }
}
    `;
export type SetActiveStatusPersonMutationFn = Apollo.MutationFunction<SetActiveStatusPersonMutation, SetActiveStatusPersonMutationVariables>;

/**
 * __useSetActiveStatusPersonMutation__
 *
 * To run a mutation, you first call `useSetActiveStatusPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveStatusPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveStatusPersonMutation, { data, loading, error }] = useSetActiveStatusPersonMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useSetActiveStatusPersonMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveStatusPersonMutation, SetActiveStatusPersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveStatusPersonMutation, SetActiveStatusPersonMutationVariables>(SetActiveStatusPersonDocument, options);
      }
export type SetActiveStatusPersonMutationHookResult = ReturnType<typeof useSetActiveStatusPersonMutation>;
export type SetActiveStatusPersonMutationResult = Apollo.MutationResult<SetActiveStatusPersonMutation>;
export type SetActiveStatusPersonMutationOptions = Apollo.BaseMutationOptions<SetActiveStatusPersonMutation, SetActiveStatusPersonMutationVariables>;
export const InactivatePersonLinkDocument = gql`
    mutation InactivatePersonLink($linkId: Int!) {
  setSitePersonActiveStatus(id: $linkId, isActive: false) {
    id
    isActive
    person {
      id
      affiliations {
        hash
        totalCount
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type InactivatePersonLinkMutationFn = Apollo.MutationFunction<InactivatePersonLinkMutation, InactivatePersonLinkMutationVariables>;

/**
 * __useInactivatePersonLinkMutation__
 *
 * To run a mutation, you first call `useInactivatePersonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivatePersonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivatePersonLinkMutation, { data, loading, error }] = useInactivatePersonLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useInactivatePersonLinkMutation(baseOptions?: Apollo.MutationHookOptions<InactivatePersonLinkMutation, InactivatePersonLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivatePersonLinkMutation, InactivatePersonLinkMutationVariables>(InactivatePersonLinkDocument, options);
      }
export type InactivatePersonLinkMutationHookResult = ReturnType<typeof useInactivatePersonLinkMutation>;
export type InactivatePersonLinkMutationResult = Apollo.MutationResult<InactivatePersonLinkMutation>;
export type InactivatePersonLinkMutationOptions = Apollo.BaseMutationOptions<InactivatePersonLinkMutation, InactivatePersonLinkMutationVariables>;
export const InactivatePersonActionDocument = gql`
    query InactivatePersonAction($personId: Int!) {
  person(id: $personId) {
    id
    isActive
    maintainerSourceCode
    mergeRequests {
      hash
      totalCount
    }
    affiliations {
      hash
      totalCount
      nodes {
        id
      }
    }
  }
}
    `;

/**
 * __useInactivatePersonActionQuery__
 *
 * To run a query within a React component, call `useInactivatePersonActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactivatePersonActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactivatePersonActionQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useInactivatePersonActionQuery(baseOptions: Apollo.QueryHookOptions<InactivatePersonActionQuery, InactivatePersonActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactivatePersonActionQuery, InactivatePersonActionQueryVariables>(InactivatePersonActionDocument, options);
      }
export function useInactivatePersonActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactivatePersonActionQuery, InactivatePersonActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactivatePersonActionQuery, InactivatePersonActionQueryVariables>(InactivatePersonActionDocument, options);
        }
export type InactivatePersonActionQueryHookResult = ReturnType<typeof useInactivatePersonActionQuery>;
export type InactivatePersonActionLazyQueryHookResult = ReturnType<typeof useInactivatePersonActionLazyQuery>;
export type InactivatePersonActionQueryResult = Apollo.QueryResult<InactivatePersonActionQuery, InactivatePersonActionQueryVariables>;
export const MultiCherryPickDataQueryDocument = gql`
    query MultiCherryPickDataQuery($country: CountryCode!) {
  cherryPickOverview(country: $country) {
    customerCode
    country
    amount
    amountAvailable
    amountUsed
  }
}
    `;

/**
 * __useMultiCherryPickDataQueryQuery__
 *
 * To run a query within a React component, call `useMultiCherryPickDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiCherryPickDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiCherryPickDataQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useMultiCherryPickDataQueryQuery(baseOptions: Apollo.QueryHookOptions<MultiCherryPickDataQueryQuery, MultiCherryPickDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiCherryPickDataQueryQuery, MultiCherryPickDataQueryQueryVariables>(MultiCherryPickDataQueryDocument, options);
      }
export function useMultiCherryPickDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiCherryPickDataQueryQuery, MultiCherryPickDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiCherryPickDataQueryQuery, MultiCherryPickDataQueryQueryVariables>(MultiCherryPickDataQueryDocument, options);
        }
export type MultiCherryPickDataQueryQueryHookResult = ReturnType<typeof useMultiCherryPickDataQueryQuery>;
export type MultiCherryPickDataQueryLazyQueryHookResult = ReturnType<typeof useMultiCherryPickDataQueryLazyQuery>;
export type MultiCherryPickDataQueryQueryResult = Apollo.QueryResult<MultiCherryPickDataQueryQuery, MultiCherryPickDataQueryQueryVariables>;
export const PersonDetailDocument = gql`
    query PersonDetail($personId: Int!) {
  person(id: $personId) {
    id
    fullName
    isActive
    countryCode
    affiliations {
      hash
      nodes {
        id
        isPrimary
      }
    }
    consentInstructions {
      hash
      optedOutFromAPB
    }
  }
}
    `;

/**
 * __usePersonDetailQuery__
 *
 * To run a query within a React component, call `usePersonDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDetailQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailQuery, PersonDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailQuery, PersonDetailQueryVariables>(PersonDetailDocument, options);
      }
export function usePersonDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailQuery, PersonDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailQuery, PersonDetailQueryVariables>(PersonDetailDocument, options);
        }
export type PersonDetailQueryHookResult = ReturnType<typeof usePersonDetailQuery>;
export type PersonDetailLazyQueryHookResult = ReturnType<typeof usePersonDetailLazyQuery>;
export type PersonDetailQueryResult = Apollo.QueryResult<PersonDetailQuery, PersonDetailQueryVariables>;
export const PersonSiteAffiliationsQueryDocument = gql`
    query PersonSiteAffiliationsQuery($personId: Int!) {
  person(id: $personId) {
    id
    countryCode
    maintainerSourceCode
    affiliations {
      hash
      nodes {
        id
        persId
        siteId
        isPrimary
      }
    }
  }
}
    `;

/**
 * __usePersonSiteAffiliationsQueryQuery__
 *
 * To run a query within a React component, call `usePersonSiteAffiliationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSiteAffiliationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSiteAffiliationsQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonSiteAffiliationsQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonSiteAffiliationsQueryQuery, PersonSiteAffiliationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonSiteAffiliationsQueryQuery, PersonSiteAffiliationsQueryQueryVariables>(PersonSiteAffiliationsQueryDocument, options);
      }
export function usePersonSiteAffiliationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonSiteAffiliationsQueryQuery, PersonSiteAffiliationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonSiteAffiliationsQueryQuery, PersonSiteAffiliationsQueryQueryVariables>(PersonSiteAffiliationsQueryDocument, options);
        }
export type PersonSiteAffiliationsQueryQueryHookResult = ReturnType<typeof usePersonSiteAffiliationsQueryQuery>;
export type PersonSiteAffiliationsQueryLazyQueryHookResult = ReturnType<typeof usePersonSiteAffiliationsQueryLazyQuery>;
export type PersonSiteAffiliationsQueryQueryResult = Apollo.QueryResult<PersonSiteAffiliationsQueryQuery, PersonSiteAffiliationsQueryQueryVariables>;
export const PersonsBuiltQueryDocument = gql`
    query PersonsBuiltQuery($criteria: PersonCriteria) {
  connection: persons(criteria: $criteria) {
    hash
    totalCount
    nodes {
      id
      countryCode
      fullName
      isLocal
      ...PersonTableBuiltFragment
    }
  }
}
    ${PersonTableBuiltFragmentFragmentDoc}`;

/**
 * __usePersonsBuiltQueryQuery__
 *
 * To run a query within a React component, call `usePersonsBuiltQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonsBuiltQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonsBuiltQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function usePersonsBuiltQueryQuery(baseOptions?: Apollo.QueryHookOptions<PersonsBuiltQueryQuery, PersonsBuiltQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonsBuiltQueryQuery, PersonsBuiltQueryQueryVariables>(PersonsBuiltQueryDocument, options);
      }
export function usePersonsBuiltQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonsBuiltQueryQuery, PersonsBuiltQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonsBuiltQueryQuery, PersonsBuiltQueryQueryVariables>(PersonsBuiltQueryDocument, options);
        }
export type PersonsBuiltQueryQueryHookResult = ReturnType<typeof usePersonsBuiltQueryQuery>;
export type PersonsBuiltQueryLazyQueryHookResult = ReturnType<typeof usePersonsBuiltQueryLazyQuery>;
export type PersonsBuiltQueryQueryResult = Apollo.QueryResult<PersonsBuiltQueryQuery, PersonsBuiltQueryQueryVariables>;
export const PersonsRecordBuiltQueryDocument = gql`
    query PersonsRecordBuiltQuery($recordId: Int!) {
  record: person(id: $recordId) {
    id
    countryCode
    fullName
    isLocal
    ...PersonTableBuiltFragment
  }
}
    ${PersonTableBuiltFragmentFragmentDoc}`;

/**
 * __usePersonsRecordBuiltQueryQuery__
 *
 * To run a query within a React component, call `usePersonsRecordBuiltQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonsRecordBuiltQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonsRecordBuiltQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function usePersonsRecordBuiltQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonsRecordBuiltQueryQuery, PersonsRecordBuiltQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonsRecordBuiltQueryQuery, PersonsRecordBuiltQueryQueryVariables>(PersonsRecordBuiltQueryDocument, options);
      }
export function usePersonsRecordBuiltQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonsRecordBuiltQueryQuery, PersonsRecordBuiltQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonsRecordBuiltQueryQuery, PersonsRecordBuiltQueryQueryVariables>(PersonsRecordBuiltQueryDocument, options);
        }
export type PersonsRecordBuiltQueryQueryHookResult = ReturnType<typeof usePersonsRecordBuiltQueryQuery>;
export type PersonsRecordBuiltQueryLazyQueryHookResult = ReturnType<typeof usePersonsRecordBuiltQueryLazyQuery>;
export type PersonsRecordBuiltQueryQueryResult = Apollo.QueryResult<PersonsRecordBuiltQueryQuery, PersonsRecordBuiltQueryQueryVariables>;
export const searchHasMdmAccessDocument = gql`
    query searchHasMdmAccess {
  hasAccessToModule(module: MDM)
}
    `;

/**
 * __usesearchHasMdmAccessQuery__
 *
 * To run a query within a React component, call `usesearchHasMdmAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `usesearchHasMdmAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usesearchHasMdmAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function usesearchHasMdmAccessQuery(baseOptions?: Apollo.QueryHookOptions<searchHasMdmAccessQuery, searchHasMdmAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<searchHasMdmAccessQuery, searchHasMdmAccessQueryVariables>(searchHasMdmAccessDocument, options);
      }
export function usesearchHasMdmAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<searchHasMdmAccessQuery, searchHasMdmAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<searchHasMdmAccessQuery, searchHasMdmAccessQueryVariables>(searchHasMdmAccessDocument, options);
        }
export type searchHasMdmAccessQueryHookResult = ReturnType<typeof usesearchHasMdmAccessQuery>;
export type searchHasMdmAccessLazyQueryHookResult = ReturnType<typeof usesearchHasMdmAccessLazyQuery>;
export type searchHasMdmAccessQueryResult = Apollo.QueryResult<searchHasMdmAccessQuery, searchHasMdmAccessQueryVariables>;
export const PersonPopoverCardQueryDocument = gql`
    query PersonPopoverCardQuery($personId: Int!) {
  person(id: $personId) {
    id
    firstName
    lastName
    countryCode
    title
    gender
    externalIds(criteria: {externalIdTypeCode: "APB_OFFICIAL"}) {
      hash
      nodes {
        id
        externalId
      }
    }
    persType {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __usePersonPopoverCardQueryQuery__
 *
 * To run a query within a React component, call `usePersonPopoverCardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonPopoverCardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonPopoverCardQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonPopoverCardQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonPopoverCardQueryQuery, PersonPopoverCardQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonPopoverCardQueryQuery, PersonPopoverCardQueryQueryVariables>(PersonPopoverCardQueryDocument, options);
      }
export function usePersonPopoverCardQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonPopoverCardQueryQuery, PersonPopoverCardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonPopoverCardQueryQuery, PersonPopoverCardQueryQueryVariables>(PersonPopoverCardQueryDocument, options);
        }
export type PersonPopoverCardQueryQueryHookResult = ReturnType<typeof usePersonPopoverCardQueryQuery>;
export type PersonPopoverCardQueryLazyQueryHookResult = ReturnType<typeof usePersonPopoverCardQueryLazyQuery>;
export type PersonPopoverCardQueryQueryResult = Apollo.QueryResult<PersonPopoverCardQueryQuery, PersonPopoverCardQueryQueryVariables>;
export const PersonConsentQueryDocument = gql`
    query PersonConsentQuery($personId: Int!) {
  person(id: $personId) {
    id
    hasConsentedEmail
    consents: virtualConsents {
      entityType
      entityAffiliationId
      consentTypeCode
      isEnabled
      type {
        code
        headingKey
        isManaged
      }
    }
  }
}
    `;

/**
 * __usePersonConsentQueryQuery__
 *
 * To run a query within a React component, call `usePersonConsentQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonConsentQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonConsentQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonConsentQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonConsentQueryQuery, PersonConsentQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonConsentQueryQuery, PersonConsentQueryQueryVariables>(PersonConsentQueryDocument, options);
      }
export function usePersonConsentQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonConsentQueryQuery, PersonConsentQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonConsentQueryQuery, PersonConsentQueryQueryVariables>(PersonConsentQueryDocument, options);
        }
export type PersonConsentQueryQueryHookResult = ReturnType<typeof usePersonConsentQueryQuery>;
export type PersonConsentQueryLazyQueryHookResult = ReturnType<typeof usePersonConsentQueryLazyQuery>;
export type PersonConsentQueryQueryResult = Apollo.QueryResult<PersonConsentQueryQuery, PersonConsentQueryQueryVariables>;
export const updatePersonConsentMutationDocument = gql`
    mutation updatePersonConsentMutation($personId: Int!, $consentTypeCode: String!, $enabled: Boolean!) {
  setConsentValue(
    entityAffiliationId: $personId
    typeCode: $consentTypeCode
    isEnabled: $enabled
  ) {
    entityType
    entityAffiliationId
    consentTypeCode
    type {
      code
      headingKey
    }
    isEnabled
  }
}
    `;
export type updatePersonConsentMutationMutationFn = Apollo.MutationFunction<updatePersonConsentMutationMutation, updatePersonConsentMutationMutationVariables>;

/**
 * __useupdatePersonConsentMutationMutation__
 *
 * To run a mutation, you first call `useupdatePersonConsentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdatePersonConsentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonConsentMutationMutation, { data, loading, error }] = useupdatePersonConsentMutationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      consentTypeCode: // value for 'consentTypeCode'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useupdatePersonConsentMutationMutation(baseOptions?: Apollo.MutationHookOptions<updatePersonConsentMutationMutation, updatePersonConsentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<updatePersonConsentMutationMutation, updatePersonConsentMutationMutationVariables>(updatePersonConsentMutationDocument, options);
      }
export type updatePersonConsentMutationMutationHookResult = ReturnType<typeof useupdatePersonConsentMutationMutation>;
export type updatePersonConsentMutationMutationResult = Apollo.MutationResult<updatePersonConsentMutationMutation>;
export type updatePersonConsentMutationMutationOptions = Apollo.BaseMutationOptions<updatePersonConsentMutationMutation, updatePersonConsentMutationMutationVariables>;
export const CreateAddAddressQueryDocument = gql`
    query CreateAddAddressQuery($entityType: EntityTypeEnum) {
  addressTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      headingKey
    }
  }
}
    `;

/**
 * __useCreateAddAddressQueryQuery__
 *
 * To run a query within a React component, call `useCreateAddAddressQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateAddAddressQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateAddAddressQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useCreateAddAddressQueryQuery(baseOptions?: Apollo.QueryHookOptions<CreateAddAddressQueryQuery, CreateAddAddressQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateAddAddressQueryQuery, CreateAddAddressQueryQueryVariables>(CreateAddAddressQueryDocument, options);
      }
export function useCreateAddAddressQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateAddAddressQueryQuery, CreateAddAddressQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateAddAddressQueryQuery, CreateAddAddressQueryQueryVariables>(CreateAddAddressQueryDocument, options);
        }
export type CreateAddAddressQueryQueryHookResult = ReturnType<typeof useCreateAddAddressQueryQuery>;
export type CreateAddAddressQueryLazyQueryHookResult = ReturnType<typeof useCreateAddAddressQueryLazyQuery>;
export type CreateAddAddressQueryQueryResult = Apollo.QueryResult<CreateAddAddressQueryQuery, CreateAddAddressQueryQueryVariables>;
export const SuggestedStandardTitleQueryDocument = gql`
    query SuggestedStandardTitleQuery($countryCode: String) {
  standardTitles(criteria: {country: $countryCode, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      id
      label
    }
  }
}
    `;

/**
 * __useSuggestedStandardTitleQueryQuery__
 *
 * To run a query within a React component, call `useSuggestedStandardTitleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedStandardTitleQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedStandardTitleQueryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSuggestedStandardTitleQueryQuery(baseOptions?: Apollo.QueryHookOptions<SuggestedStandardTitleQueryQuery, SuggestedStandardTitleQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedStandardTitleQueryQuery, SuggestedStandardTitleQueryQueryVariables>(SuggestedStandardTitleQueryDocument, options);
      }
export function useSuggestedStandardTitleQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedStandardTitleQueryQuery, SuggestedStandardTitleQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedStandardTitleQueryQuery, SuggestedStandardTitleQueryQueryVariables>(SuggestedStandardTitleQueryDocument, options);
        }
export type SuggestedStandardTitleQueryQueryHookResult = ReturnType<typeof useSuggestedStandardTitleQueryQuery>;
export type SuggestedStandardTitleQueryLazyQueryHookResult = ReturnType<typeof useSuggestedStandardTitleQueryLazyQuery>;
export type SuggestedStandardTitleQueryQueryResult = Apollo.QueryResult<SuggestedStandardTitleQueryQuery, SuggestedStandardTitleQueryQueryVariables>;
export const CreatePersonMutationDocument = gql`
    mutation CreatePersonMutation($input: PersonInput!) {
  createPerson(input: $input) {
    person {
      id
      fullName
    }
    dcr {
      id
      currentResponseCode
    }
  }
}
    `;
export type CreatePersonMutationMutationFn = Apollo.MutationFunction<CreatePersonMutationMutation, CreatePersonMutationMutationVariables>;

/**
 * __useCreatePersonMutationMutation__
 *
 * To run a mutation, you first call `useCreatePersonMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonMutationMutation, { data, loading, error }] = useCreatePersonMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePersonMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonMutationMutation, CreatePersonMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonMutationMutation, CreatePersonMutationMutationVariables>(CreatePersonMutationDocument, options);
      }
export type CreatePersonMutationMutationHookResult = ReturnType<typeof useCreatePersonMutationMutation>;
export type CreatePersonMutationMutationResult = Apollo.MutationResult<CreatePersonMutationMutation>;
export type CreatePersonMutationMutationOptions = Apollo.BaseMutationOptions<CreatePersonMutationMutation, CreatePersonMutationMutationVariables>;
export const EntityContactTypesQueryDocument = gql`
    query EntityContactTypesQuery($entityType: EntityTypeEnum!) {
  contactTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      label: heading
    }
  }
}
    `;

/**
 * __useEntityContactTypesQueryQuery__
 *
 * To run a query within a React component, call `useEntityContactTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityContactTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityContactTypesQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityContactTypesQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityContactTypesQueryQuery, EntityContactTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityContactTypesQueryQuery, EntityContactTypesQueryQueryVariables>(EntityContactTypesQueryDocument, options);
      }
export function useEntityContactTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityContactTypesQueryQuery, EntityContactTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityContactTypesQueryQuery, EntityContactTypesQueryQueryVariables>(EntityContactTypesQueryDocument, options);
        }
export type EntityContactTypesQueryQueryHookResult = ReturnType<typeof useEntityContactTypesQueryQuery>;
export type EntityContactTypesQueryLazyQueryHookResult = ReturnType<typeof useEntityContactTypesQueryLazyQuery>;
export type EntityContactTypesQueryQueryResult = Apollo.QueryResult<EntityContactTypesQueryQuery, EntityContactTypesQueryQueryVariables>;
export const ContactFieldCategoriesDocument = gql`
    query ContactFieldCategories($type: ContactTypeEnum!, $entityType: EntityTypeEnum!) {
  contactCategories(criteria: {contactType: $type, entityType: $entityType}) {
    hash
    nodes {
      code
      heading
      isHeadingKey
      allowMultipleValues
      isMapped
      typeEnum
    }
  }
}
    `;

/**
 * __useContactFieldCategoriesQuery__
 *
 * To run a query within a React component, call `useContactFieldCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFieldCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFieldCategoriesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useContactFieldCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ContactFieldCategoriesQuery, ContactFieldCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFieldCategoriesQuery, ContactFieldCategoriesQueryVariables>(ContactFieldCategoriesDocument, options);
      }
export function useContactFieldCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFieldCategoriesQuery, ContactFieldCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFieldCategoriesQuery, ContactFieldCategoriesQueryVariables>(ContactFieldCategoriesDocument, options);
        }
export type ContactFieldCategoriesQueryHookResult = ReturnType<typeof useContactFieldCategoriesQuery>;
export type ContactFieldCategoriesLazyQueryHookResult = ReturnType<typeof useContactFieldCategoriesLazyQuery>;
export type ContactFieldCategoriesQueryResult = Apollo.QueryResult<ContactFieldCategoriesQuery, ContactFieldCategoriesQueryVariables>;
export const UpsertContactValuesMutationDocument = gql`
    mutation UpsertContactValuesMutation($type: ContactTypeEnum!, $entityType: EntityTypeEnum!, $entityAffiliationId: Int!, $values: [ContactValueInput!]!) {
  upsertContactValues(
    type: $type
    entityType: $entityType
    entityAffiliationId: $entityAffiliationId
    values: $values
  ) {
    id
    value
  }
}
    `;
export type UpsertContactValuesMutationMutationFn = Apollo.MutationFunction<UpsertContactValuesMutationMutation, UpsertContactValuesMutationMutationVariables>;

/**
 * __useUpsertContactValuesMutationMutation__
 *
 * To run a mutation, you first call `useUpsertContactValuesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContactValuesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContactValuesMutationMutation, { data, loading, error }] = useUpsertContactValuesMutationMutation({
 *   variables: {
 *      type: // value for 'type'
 *      entityType: // value for 'entityType'
 *      entityAffiliationId: // value for 'entityAffiliationId'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpsertContactValuesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContactValuesMutationMutation, UpsertContactValuesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContactValuesMutationMutation, UpsertContactValuesMutationMutationVariables>(UpsertContactValuesMutationDocument, options);
      }
export type UpsertContactValuesMutationMutationHookResult = ReturnType<typeof useUpsertContactValuesMutationMutation>;
export type UpsertContactValuesMutationMutationResult = Apollo.MutationResult<UpsertContactValuesMutationMutation>;
export type UpsertContactValuesMutationMutationOptions = Apollo.BaseMutationOptions<UpsertContactValuesMutationMutation, UpsertContactValuesMutationMutationVariables>;
export const SetContactPrimaryStateMutationDocument = gql`
    mutation SetContactPrimaryStateMutation($entityType: EntityTypeEnum!, $contactValueId: Int!, $isPrimary: Boolean!) {
  setContactPrimaryState(
    entityType: $entityType
    contactValueId: $contactValueId
    isPrimary: $isPrimary
  )
}
    `;
export type SetContactPrimaryStateMutationMutationFn = Apollo.MutationFunction<SetContactPrimaryStateMutationMutation, SetContactPrimaryStateMutationMutationVariables>;

/**
 * __useSetContactPrimaryStateMutationMutation__
 *
 * To run a mutation, you first call `useSetContactPrimaryStateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactPrimaryStateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactPrimaryStateMutationMutation, { data, loading, error }] = useSetContactPrimaryStateMutationMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      contactValueId: // value for 'contactValueId'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useSetContactPrimaryStateMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetContactPrimaryStateMutationMutation, SetContactPrimaryStateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactPrimaryStateMutationMutation, SetContactPrimaryStateMutationMutationVariables>(SetContactPrimaryStateMutationDocument, options);
      }
export type SetContactPrimaryStateMutationMutationHookResult = ReturnType<typeof useSetContactPrimaryStateMutationMutation>;
export type SetContactPrimaryStateMutationMutationResult = Apollo.MutationResult<SetContactPrimaryStateMutationMutation>;
export type SetContactPrimaryStateMutationMutationOptions = Apollo.BaseMutationOptions<SetContactPrimaryStateMutationMutation, SetContactPrimaryStateMutationMutationVariables>;
export const UpdatePersonMailToPrivateMutationDocument = gql`
    mutation UpdatePersonMailToPrivateMutation($persId: Int!, $mailToPrivate: Boolean!) {
  updateMailToPrivate(persId: $persId, mailToPrivate: $mailToPrivate) {
    id
    mailToPrivate
  }
}
    `;
export type UpdatePersonMailToPrivateMutationMutationFn = Apollo.MutationFunction<UpdatePersonMailToPrivateMutationMutation, UpdatePersonMailToPrivateMutationMutationVariables>;

/**
 * __useUpdatePersonMailToPrivateMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMailToPrivateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMailToPrivateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMailToPrivateMutationMutation, { data, loading, error }] = useUpdatePersonMailToPrivateMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      mailToPrivate: // value for 'mailToPrivate'
 *   },
 * });
 */
export function useUpdatePersonMailToPrivateMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonMailToPrivateMutationMutation, UpdatePersonMailToPrivateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonMailToPrivateMutationMutation, UpdatePersonMailToPrivateMutationMutationVariables>(UpdatePersonMailToPrivateMutationDocument, options);
      }
export type UpdatePersonMailToPrivateMutationMutationHookResult = ReturnType<typeof useUpdatePersonMailToPrivateMutationMutation>;
export type UpdatePersonMailToPrivateMutationMutationResult = Apollo.MutationResult<UpdatePersonMailToPrivateMutationMutation>;
export type UpdatePersonMailToPrivateMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonMailToPrivateMutationMutation, UpdatePersonMailToPrivateMutationMutationVariables>;
export const GenerateApureBaseIdDocument = gql`
    mutation GenerateApureBaseId($entityType: EntityTypeEnum!, $id: ID!) {
  synchronizeApureBaseId(entityType: $entityType, entityAffiliationId: $id) {
    ... on Person {
      id
      apurebaseId
    }
    ... on Site {
      id
      apurebaseId
    }
    ... on SitePerson {
      id
      apurebaseId
    }
  }
}
    `;
export type GenerateApureBaseIdMutationFn = Apollo.MutationFunction<GenerateApureBaseIdMutation, GenerateApureBaseIdMutationVariables>;

/**
 * __useGenerateApureBaseIdMutation__
 *
 * To run a mutation, you first call `useGenerateApureBaseIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApureBaseIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApureBaseIdMutation, { data, loading, error }] = useGenerateApureBaseIdMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateApureBaseIdMutation(baseOptions?: Apollo.MutationHookOptions<GenerateApureBaseIdMutation, GenerateApureBaseIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateApureBaseIdMutation, GenerateApureBaseIdMutationVariables>(GenerateApureBaseIdDocument, options);
      }
export type GenerateApureBaseIdMutationHookResult = ReturnType<typeof useGenerateApureBaseIdMutation>;
export type GenerateApureBaseIdMutationResult = Apollo.MutationResult<GenerateApureBaseIdMutation>;
export type GenerateApureBaseIdMutationOptions = Apollo.BaseMutationOptions<GenerateApureBaseIdMutation, GenerateApureBaseIdMutationVariables>;
export const CanIGenerateApureBaseIdDocument = gql`
    query CanIGenerateApureBaseId {
  canIGenerateApureBaseId
}
    `;

/**
 * __useCanIGenerateApureBaseIdQuery__
 *
 * To run a query within a React component, call `useCanIGenerateApureBaseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanIGenerateApureBaseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanIGenerateApureBaseIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCanIGenerateApureBaseIdQuery(baseOptions?: Apollo.QueryHookOptions<CanIGenerateApureBaseIdQuery, CanIGenerateApureBaseIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanIGenerateApureBaseIdQuery, CanIGenerateApureBaseIdQueryVariables>(CanIGenerateApureBaseIdDocument, options);
      }
export function useCanIGenerateApureBaseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanIGenerateApureBaseIdQuery, CanIGenerateApureBaseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanIGenerateApureBaseIdQuery, CanIGenerateApureBaseIdQueryVariables>(CanIGenerateApureBaseIdDocument, options);
        }
export type CanIGenerateApureBaseIdQueryHookResult = ReturnType<typeof useCanIGenerateApureBaseIdQuery>;
export type CanIGenerateApureBaseIdLazyQueryHookResult = ReturnType<typeof useCanIGenerateApureBaseIdLazyQuery>;
export type CanIGenerateApureBaseIdQueryResult = Apollo.QueryResult<CanIGenerateApureBaseIdQuery, CanIGenerateApureBaseIdQueryVariables>;
export const UpdatePersonDateOfBirthMutationDocument = gql`
    mutation UpdatePersonDateOfBirthMutation($persId: Int!, $date: DateTime!) {
  updatePersonDateOfBirth(persId: $persId, date: $date) {
    id
    birth
  }
}
    `;
export type UpdatePersonDateOfBirthMutationMutationFn = Apollo.MutationFunction<UpdatePersonDateOfBirthMutationMutation, UpdatePersonDateOfBirthMutationMutationVariables>;

/**
 * __useUpdatePersonDateOfBirthMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonDateOfBirthMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonDateOfBirthMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonDateOfBirthMutationMutation, { data, loading, error }] = useUpdatePersonDateOfBirthMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useUpdatePersonDateOfBirthMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonDateOfBirthMutationMutation, UpdatePersonDateOfBirthMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonDateOfBirthMutationMutation, UpdatePersonDateOfBirthMutationMutationVariables>(UpdatePersonDateOfBirthMutationDocument, options);
      }
export type UpdatePersonDateOfBirthMutationMutationHookResult = ReturnType<typeof useUpdatePersonDateOfBirthMutationMutation>;
export type UpdatePersonDateOfBirthMutationMutationResult = Apollo.MutationResult<UpdatePersonDateOfBirthMutationMutation>;
export type UpdatePersonDateOfBirthMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonDateOfBirthMutationMutation, UpdatePersonDateOfBirthMutationMutationVariables>;
export const UpdatePersonEducationMutationDocument = gql`
    mutation UpdatePersonEducationMutation($persId: Int!, $educations: [String!]!) {
  updatePersonEducations(persId: $persId, educations: $educations) {
    id
    person {
      id
      educations {
        hash
        nodes {
          code
          type
        }
      }
    }
  }
}
    `;
export type UpdatePersonEducationMutationMutationFn = Apollo.MutationFunction<UpdatePersonEducationMutationMutation, UpdatePersonEducationMutationMutationVariables>;

/**
 * __useUpdatePersonEducationMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonEducationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonEducationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonEducationMutationMutation, { data, loading, error }] = useUpdatePersonEducationMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      educations: // value for 'educations'
 *   },
 * });
 */
export function useUpdatePersonEducationMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonEducationMutationMutation, UpdatePersonEducationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonEducationMutationMutation, UpdatePersonEducationMutationMutationVariables>(UpdatePersonEducationMutationDocument, options);
      }
export type UpdatePersonEducationMutationMutationHookResult = ReturnType<typeof useUpdatePersonEducationMutationMutation>;
export type UpdatePersonEducationMutationMutationResult = Apollo.MutationResult<UpdatePersonEducationMutationMutation>;
export type UpdatePersonEducationMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonEducationMutationMutation, UpdatePersonEducationMutationMutationVariables>;
export const SelectPersonEduSuggestionQueryDocument = gql`
    query SelectPersonEduSuggestionQuery($countries: [CountryCode!]!) {
  availableSpecialties: educations(
    criteria: {countries: $countries, fetchSize: {limit: 5000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectPersonEduSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectPersonEduSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonEduSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonEduSuggestionQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useSelectPersonEduSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonEduSuggestionQueryQuery, SelectPersonEduSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonEduSuggestionQueryQuery, SelectPersonEduSuggestionQueryQueryVariables>(SelectPersonEduSuggestionQueryDocument, options);
      }
export function useSelectPersonEduSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonEduSuggestionQueryQuery, SelectPersonEduSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonEduSuggestionQueryQuery, SelectPersonEduSuggestionQueryQueryVariables>(SelectPersonEduSuggestionQueryDocument, options);
        }
export type SelectPersonEduSuggestionQueryQueryHookResult = ReturnType<typeof useSelectPersonEduSuggestionQueryQuery>;
export type SelectPersonEduSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectPersonEduSuggestionQueryLazyQuery>;
export type SelectPersonEduSuggestionQueryQueryResult = Apollo.QueryResult<SelectPersonEduSuggestionQueryQuery, SelectPersonEduSuggestionQueryQueryVariables>;
export const UpdatePersonExamYearMutationDocument = gql`
    mutation UpdatePersonExamYearMutation($persId: Int!, $year: Year) {
  updatePersonExamYear(persId: $persId, date: $year) {
    id
    examYear
    examYearAsDate
  }
}
    `;
export type UpdatePersonExamYearMutationMutationFn = Apollo.MutationFunction<UpdatePersonExamYearMutationMutation, UpdatePersonExamYearMutationMutationVariables>;

/**
 * __useUpdatePersonExamYearMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonExamYearMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonExamYearMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonExamYearMutationMutation, { data, loading, error }] = useUpdatePersonExamYearMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useUpdatePersonExamYearMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonExamYearMutationMutation, UpdatePersonExamYearMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonExamYearMutationMutation, UpdatePersonExamYearMutationMutationVariables>(UpdatePersonExamYearMutationDocument, options);
      }
export type UpdatePersonExamYearMutationMutationHookResult = ReturnType<typeof useUpdatePersonExamYearMutationMutation>;
export type UpdatePersonExamYearMutationMutationResult = Apollo.MutationResult<UpdatePersonExamYearMutationMutation>;
export type UpdatePersonExamYearMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonExamYearMutationMutation, UpdatePersonExamYearMutationMutationVariables>;
export const UpdateHcpFirstNameMutationDocument = gql`
    mutation UpdateHcpFirstNameMutation($persId: Int!, $firstName: String!) {
  updatePersonFirstName(persId: $persId, firstName: $firstName) {
    id
    firstName
    lastName
    fullName
    title
  }
}
    `;
export type UpdateHcpFirstNameMutationMutationFn = Apollo.MutationFunction<UpdateHcpFirstNameMutationMutation, UpdateHcpFirstNameMutationMutationVariables>;

/**
 * __useUpdateHcpFirstNameMutationMutation__
 *
 * To run a mutation, you first call `useUpdateHcpFirstNameMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHcpFirstNameMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHcpFirstNameMutationMutation, { data, loading, error }] = useUpdateHcpFirstNameMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      firstName: // value for 'firstName'
 *   },
 * });
 */
export function useUpdateHcpFirstNameMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHcpFirstNameMutationMutation, UpdateHcpFirstNameMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHcpFirstNameMutationMutation, UpdateHcpFirstNameMutationMutationVariables>(UpdateHcpFirstNameMutationDocument, options);
      }
export type UpdateHcpFirstNameMutationMutationHookResult = ReturnType<typeof useUpdateHcpFirstNameMutationMutation>;
export type UpdateHcpFirstNameMutationMutationResult = Apollo.MutationResult<UpdateHcpFirstNameMutationMutation>;
export type UpdateHcpFirstNameMutationMutationOptions = Apollo.BaseMutationOptions<UpdateHcpFirstNameMutationMutation, UpdateHcpFirstNameMutationMutationVariables>;
export const UpdatePersonGenderMutationDocument = gql`
    mutation UpdatePersonGenderMutation($persId: Int!, $gender: GenderEnum!) {
  updatePersonSex(persId: $persId, sex: $gender) {
    id
    sex
    genderEnum
  }
}
    `;
export type UpdatePersonGenderMutationMutationFn = Apollo.MutationFunction<UpdatePersonGenderMutationMutation, UpdatePersonGenderMutationMutationVariables>;

/**
 * __useUpdatePersonGenderMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonGenderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonGenderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonGenderMutationMutation, { data, loading, error }] = useUpdatePersonGenderMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      gender: // value for 'gender'
 *   },
 * });
 */
export function useUpdatePersonGenderMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonGenderMutationMutation, UpdatePersonGenderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonGenderMutationMutation, UpdatePersonGenderMutationMutationVariables>(UpdatePersonGenderMutationDocument, options);
      }
export type UpdatePersonGenderMutationMutationHookResult = ReturnType<typeof useUpdatePersonGenderMutationMutation>;
export type UpdatePersonGenderMutationMutationResult = Apollo.MutationResult<UpdatePersonGenderMutationMutation>;
export type UpdatePersonGenderMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonGenderMutationMutation, UpdatePersonGenderMutationMutationVariables>;
export const UpdatePersonLanguageMutationDocument = gql`
    mutation UpdatePersonLanguageMutation($persId: Int!, $languageCodes: [String!]!) {
  updatePersonLanguage(persId: $persId, languageCodes: $languageCodes) {
    id
  }
}
    `;
export type UpdatePersonLanguageMutationMutationFn = Apollo.MutationFunction<UpdatePersonLanguageMutationMutation, UpdatePersonLanguageMutationMutationVariables>;

/**
 * __useUpdatePersonLanguageMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonLanguageMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonLanguageMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonLanguageMutationMutation, { data, loading, error }] = useUpdatePersonLanguageMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      languageCodes: // value for 'languageCodes'
 *   },
 * });
 */
export function useUpdatePersonLanguageMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonLanguageMutationMutation, UpdatePersonLanguageMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonLanguageMutationMutation, UpdatePersonLanguageMutationMutationVariables>(UpdatePersonLanguageMutationDocument, options);
      }
export type UpdatePersonLanguageMutationMutationHookResult = ReturnType<typeof useUpdatePersonLanguageMutationMutation>;
export type UpdatePersonLanguageMutationMutationResult = Apollo.MutationResult<UpdatePersonLanguageMutationMutation>;
export type UpdatePersonLanguageMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonLanguageMutationMutation, UpdatePersonLanguageMutationMutationVariables>;
export const SelectPersonLanguageSuggestionQueryDocument = gql`
    query SelectPersonLanguageSuggestionQuery($search: String) {
  languages(criteria: {heading: $search, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      code
      id: code
      heading
    }
  }
}
    `;

/**
 * __useSelectPersonLanguageSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectPersonLanguageSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonLanguageSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonLanguageSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSelectPersonLanguageSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectPersonLanguageSuggestionQueryQuery, SelectPersonLanguageSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonLanguageSuggestionQueryQuery, SelectPersonLanguageSuggestionQueryQueryVariables>(SelectPersonLanguageSuggestionQueryDocument, options);
      }
export function useSelectPersonLanguageSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonLanguageSuggestionQueryQuery, SelectPersonLanguageSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonLanguageSuggestionQueryQuery, SelectPersonLanguageSuggestionQueryQueryVariables>(SelectPersonLanguageSuggestionQueryDocument, options);
        }
export type SelectPersonLanguageSuggestionQueryQueryHookResult = ReturnType<typeof useSelectPersonLanguageSuggestionQueryQuery>;
export type SelectPersonLanguageSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectPersonLanguageSuggestionQueryLazyQuery>;
export type SelectPersonLanguageSuggestionQueryQueryResult = Apollo.QueryResult<SelectPersonLanguageSuggestionQueryQuery, SelectPersonLanguageSuggestionQueryQueryVariables>;
export const UpdatePersonLastNameMutationDocument = gql`
    mutation UpdatePersonLastNameMutation($persId: Int!, $lastName: String!) {
  updatePersonLastName(persId: $persId, lastName: $lastName) {
    id
    firstName
    lastName
    fullName
    title
  }
}
    `;
export type UpdatePersonLastNameMutationMutationFn = Apollo.MutationFunction<UpdatePersonLastNameMutationMutation, UpdatePersonLastNameMutationMutationVariables>;

/**
 * __useUpdatePersonLastNameMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonLastNameMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonLastNameMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonLastNameMutationMutation, { data, loading, error }] = useUpdatePersonLastNameMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdatePersonLastNameMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonLastNameMutationMutation, UpdatePersonLastNameMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonLastNameMutationMutation, UpdatePersonLastNameMutationMutationVariables>(UpdatePersonLastNameMutationDocument, options);
      }
export type UpdatePersonLastNameMutationMutationHookResult = ReturnType<typeof useUpdatePersonLastNameMutationMutation>;
export type UpdatePersonLastNameMutationMutationResult = Apollo.MutationResult<UpdatePersonLastNameMutationMutation>;
export type UpdatePersonLastNameMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonLastNameMutationMutation, UpdatePersonLastNameMutationMutationVariables>;
export const UpdateHcpMiddleNameMutationDocument = gql`
    mutation UpdateHcpMiddleNameMutation($persId: Int!, $middleName: String!) {
  updatePersonMiddleName(persId: $persId, middleName: $middleName) {
    id
    firstName
    middleName
    lastName
    fullName
    title
  }
}
    `;
export type UpdateHcpMiddleNameMutationMutationFn = Apollo.MutationFunction<UpdateHcpMiddleNameMutationMutation, UpdateHcpMiddleNameMutationMutationVariables>;

/**
 * __useUpdateHcpMiddleNameMutationMutation__
 *
 * To run a mutation, you first call `useUpdateHcpMiddleNameMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHcpMiddleNameMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHcpMiddleNameMutationMutation, { data, loading, error }] = useUpdateHcpMiddleNameMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      middleName: // value for 'middleName'
 *   },
 * });
 */
export function useUpdateHcpMiddleNameMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHcpMiddleNameMutationMutation, UpdateHcpMiddleNameMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHcpMiddleNameMutationMutation, UpdateHcpMiddleNameMutationMutationVariables>(UpdateHcpMiddleNameMutationDocument, options);
      }
export type UpdateHcpMiddleNameMutationMutationHookResult = ReturnType<typeof useUpdateHcpMiddleNameMutationMutation>;
export type UpdateHcpMiddleNameMutationMutationResult = Apollo.MutationResult<UpdateHcpMiddleNameMutationMutation>;
export type UpdateHcpMiddleNameMutationMutationOptions = Apollo.BaseMutationOptions<UpdateHcpMiddleNameMutationMutation, UpdateHcpMiddleNameMutationMutationVariables>;
export const SetConsentInstructionsDocument = gql`
    mutation SetConsentInstructions($imfCustomerCodes: [String!]!, $personId: Int!, $optedOut: Boolean!) {
  setConsentInstructions(imfCustomerCodes: $imfCustomerCodes, personId: $personId) {
    isOptedOutForAll
    optedOut
  }
}
    `;
export type SetConsentInstructionsMutationFn = Apollo.MutationFunction<SetConsentInstructionsMutation, SetConsentInstructionsMutationVariables>;

/**
 * __useSetConsentInstructionsMutation__
 *
 * To run a mutation, you first call `useSetConsentInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConsentInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConsentInstructionsMutation, { data, loading, error }] = useSetConsentInstructionsMutation({
 *   variables: {
 *      imfCustomerCodes: // value for 'imfCustomerCodes'
 *      personId: // value for 'personId'
 *      optedOut: // value for 'optedOut'
 *   },
 * });
 */
export function useSetConsentInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<SetConsentInstructionsMutation, SetConsentInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetConsentInstructionsMutation, SetConsentInstructionsMutationVariables>(SetConsentInstructionsDocument, options);
      }
export type SetConsentInstructionsMutationHookResult = ReturnType<typeof useSetConsentInstructionsMutation>;
export type SetConsentInstructionsMutationResult = Apollo.MutationResult<SetConsentInstructionsMutation>;
export type SetConsentInstructionsMutationOptions = Apollo.BaseMutationOptions<SetConsentInstructionsMutation, SetConsentInstructionsMutationVariables>;
export const ConsentInstructionCustomersDocument = gql`
    query ConsentInstructionCustomers($countryCode: CountryCode!) {
  internationalCustomers(
    criteria: {countries: [$countryCode], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      isActive
      label: heading
    }
  }
}
    `;

/**
 * __useConsentInstructionCustomersQuery__
 *
 * To run a query within a React component, call `useConsentInstructionCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsentInstructionCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsentInstructionCustomersQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useConsentInstructionCustomersQuery(baseOptions: Apollo.QueryHookOptions<ConsentInstructionCustomersQuery, ConsentInstructionCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsentInstructionCustomersQuery, ConsentInstructionCustomersQueryVariables>(ConsentInstructionCustomersDocument, options);
      }
export function useConsentInstructionCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsentInstructionCustomersQuery, ConsentInstructionCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsentInstructionCustomersQuery, ConsentInstructionCustomersQueryVariables>(ConsentInstructionCustomersDocument, options);
        }
export type ConsentInstructionCustomersQueryHookResult = ReturnType<typeof useConsentInstructionCustomersQuery>;
export type ConsentInstructionCustomersLazyQueryHookResult = ReturnType<typeof useConsentInstructionCustomersLazyQuery>;
export type ConsentInstructionCustomersQueryResult = Apollo.QueryResult<ConsentInstructionCustomersQuery, ConsentInstructionCustomersQueryVariables>;
export const UpdateHcpAddressMutationDocument = gql`
    mutation UpdateHcpAddressMutation($hcpId: Int!, $input: AddressInput!) {
  setPersonSingleAddress(
    personId: $hcpId
    addressTypeCode: "HCPPRIVATE"
    addressInput: $input
  ) {
    id
    affiliationEntity {
      id
      ... on Person {
        privateAddresses {
          id
          city
          countryCode
          street
          postalCode
        }
      }
    }
  }
}
    `;
export type UpdateHcpAddressMutationMutationFn = Apollo.MutationFunction<UpdateHcpAddressMutationMutation, UpdateHcpAddressMutationMutationVariables>;

/**
 * __useUpdateHcpAddressMutationMutation__
 *
 * To run a mutation, you first call `useUpdateHcpAddressMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHcpAddressMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHcpAddressMutationMutation, { data, loading, error }] = useUpdateHcpAddressMutationMutation({
 *   variables: {
 *      hcpId: // value for 'hcpId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHcpAddressMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHcpAddressMutationMutation, UpdateHcpAddressMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHcpAddressMutationMutation, UpdateHcpAddressMutationMutationVariables>(UpdateHcpAddressMutationDocument, options);
      }
export type UpdateHcpAddressMutationMutationHookResult = ReturnType<typeof useUpdateHcpAddressMutationMutation>;
export type UpdateHcpAddressMutationMutationResult = Apollo.MutationResult<UpdateHcpAddressMutationMutation>;
export type UpdateHcpAddressMutationMutationOptions = Apollo.BaseMutationOptions<UpdateHcpAddressMutationMutation, UpdateHcpAddressMutationMutationVariables>;
export const UpdatePersonTherapeuticFocusesMutationDocument = gql`
    mutation UpdatePersonTherapeuticFocusesMutation($persId: ID!, $therapeuticFocuses: [String!]!) {
  updatePersonTherapeuticFocuses(
    personId: $persId
    therapeuticFocusCodes: $therapeuticFocuses
  ) {
    id
    person {
      id
      therapeuticFocuses {
        hash
        nodes {
          code
          type
        }
      }
    }
  }
}
    `;
export type UpdatePersonTherapeuticFocusesMutationMutationFn = Apollo.MutationFunction<UpdatePersonTherapeuticFocusesMutationMutation, UpdatePersonTherapeuticFocusesMutationMutationVariables>;

/**
 * __useUpdatePersonTherapeuticFocusesMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonTherapeuticFocusesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonTherapeuticFocusesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonTherapeuticFocusesMutationMutation, { data, loading, error }] = useUpdatePersonTherapeuticFocusesMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      therapeuticFocuses: // value for 'therapeuticFocuses'
 *   },
 * });
 */
export function useUpdatePersonTherapeuticFocusesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonTherapeuticFocusesMutationMutation, UpdatePersonTherapeuticFocusesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonTherapeuticFocusesMutationMutation, UpdatePersonTherapeuticFocusesMutationMutationVariables>(UpdatePersonTherapeuticFocusesMutationDocument, options);
      }
export type UpdatePersonTherapeuticFocusesMutationMutationHookResult = ReturnType<typeof useUpdatePersonTherapeuticFocusesMutationMutation>;
export type UpdatePersonTherapeuticFocusesMutationMutationResult = Apollo.MutationResult<UpdatePersonTherapeuticFocusesMutationMutation>;
export type UpdatePersonTherapeuticFocusesMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonTherapeuticFocusesMutationMutation, UpdatePersonTherapeuticFocusesMutationMutationVariables>;
export const SelectPersonTherapeuticFocusesSuggestionQueryDocument = gql`
    query SelectPersonTherapeuticFocusesSuggestionQuery($countries: [CountryCode!]!) {
  therapeuticFocuses(criteria: {countries: $countries, fetchSize: {limit: 5000}}) {
    hash
    nodes {
      code
      label
      type
    }
  }
}
    `;

/**
 * __useSelectPersonTherapeuticFocusesSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectPersonTherapeuticFocusesSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonTherapeuticFocusesSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonTherapeuticFocusesSuggestionQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useSelectPersonTherapeuticFocusesSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectPersonTherapeuticFocusesSuggestionQueryQuery, SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonTherapeuticFocusesSuggestionQueryQuery, SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables>(SelectPersonTherapeuticFocusesSuggestionQueryDocument, options);
      }
export function useSelectPersonTherapeuticFocusesSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonTherapeuticFocusesSuggestionQueryQuery, SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonTherapeuticFocusesSuggestionQueryQuery, SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables>(SelectPersonTherapeuticFocusesSuggestionQueryDocument, options);
        }
export type SelectPersonTherapeuticFocusesSuggestionQueryQueryHookResult = ReturnType<typeof useSelectPersonTherapeuticFocusesSuggestionQueryQuery>;
export type SelectPersonTherapeuticFocusesSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectPersonTherapeuticFocusesSuggestionQueryLazyQuery>;
export type SelectPersonTherapeuticFocusesSuggestionQueryQueryResult = Apollo.QueryResult<SelectPersonTherapeuticFocusesSuggestionQueryQuery, SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables>;
export const UpdatePersonTitleMutationDocument = gql`
    mutation UpdatePersonTitleMutation($persId: Int!, $title: String!) {
  updatePersonTitle(persId: $persId, title: $title) {
    id
    title
  }
}
    `;
export type UpdatePersonTitleMutationMutationFn = Apollo.MutationFunction<UpdatePersonTitleMutationMutation, UpdatePersonTitleMutationMutationVariables>;

/**
 * __useUpdatePersonTitleMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonTitleMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonTitleMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonTitleMutationMutation, { data, loading, error }] = useUpdatePersonTitleMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdatePersonTitleMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonTitleMutationMutation, UpdatePersonTitleMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonTitleMutationMutation, UpdatePersonTitleMutationMutationVariables>(UpdatePersonTitleMutationDocument, options);
      }
export type UpdatePersonTitleMutationMutationHookResult = ReturnType<typeof useUpdatePersonTitleMutationMutation>;
export type UpdatePersonTitleMutationMutationResult = Apollo.MutationResult<UpdatePersonTitleMutationMutation>;
export type UpdatePersonTitleMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonTitleMutationMutation, UpdatePersonTitleMutationMutationVariables>;
export const SuggestedStandardTitleDetailPageQueryDocument = gql`
    query SuggestedStandardTitleDetailPageQuery($countryCode: String!) {
  standardTitles(criteria: {country: $countryCode, fetchSize: {limit: 3500}}) {
    hash
    nodes {
      id
      label
    }
  }
}
    `;

/**
 * __useSuggestedStandardTitleDetailPageQueryQuery__
 *
 * To run a query within a React component, call `useSuggestedStandardTitleDetailPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedStandardTitleDetailPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedStandardTitleDetailPageQueryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSuggestedStandardTitleDetailPageQueryQuery(baseOptions: Apollo.QueryHookOptions<SuggestedStandardTitleDetailPageQueryQuery, SuggestedStandardTitleDetailPageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedStandardTitleDetailPageQueryQuery, SuggestedStandardTitleDetailPageQueryQueryVariables>(SuggestedStandardTitleDetailPageQueryDocument, options);
      }
export function useSuggestedStandardTitleDetailPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedStandardTitleDetailPageQueryQuery, SuggestedStandardTitleDetailPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedStandardTitleDetailPageQueryQuery, SuggestedStandardTitleDetailPageQueryQueryVariables>(SuggestedStandardTitleDetailPageQueryDocument, options);
        }
export type SuggestedStandardTitleDetailPageQueryQueryHookResult = ReturnType<typeof useSuggestedStandardTitleDetailPageQueryQuery>;
export type SuggestedStandardTitleDetailPageQueryLazyQueryHookResult = ReturnType<typeof useSuggestedStandardTitleDetailPageQueryLazyQuery>;
export type SuggestedStandardTitleDetailPageQueryQueryResult = Apollo.QueryResult<SuggestedStandardTitleDetailPageQueryQuery, SuggestedStandardTitleDetailPageQueryQueryVariables>;
export const UpdatePersonTypeMutationDocument = gql`
    mutation UpdatePersonTypeMutation($persId: Int!, $typeCode: String) {
  updatePersonType(persId: $persId, typeCode: $typeCode) {
    id
    persTypeCode
    persType {
      code
      type
    }
  }
}
    `;
export type UpdatePersonTypeMutationMutationFn = Apollo.MutationFunction<UpdatePersonTypeMutationMutation, UpdatePersonTypeMutationMutationVariables>;

/**
 * __useUpdatePersonTypeMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonTypeMutationMutation, { data, loading, error }] = useUpdatePersonTypeMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      typeCode: // value for 'typeCode'
 *   },
 * });
 */
export function useUpdatePersonTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonTypeMutationMutation, UpdatePersonTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonTypeMutationMutation, UpdatePersonTypeMutationMutationVariables>(UpdatePersonTypeMutationDocument, options);
      }
export type UpdatePersonTypeMutationMutationHookResult = ReturnType<typeof useUpdatePersonTypeMutationMutation>;
export type UpdatePersonTypeMutationMutationResult = Apollo.MutationResult<UpdatePersonTypeMutationMutation>;
export type UpdatePersonTypeMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonTypeMutationMutation, UpdatePersonTypeMutationMutationVariables>;
export const SelectPersonTypeSuggestionQuery2Document = gql`
    query SelectPersonTypeSuggestionQuery2($country: CountryCode!, $search: String) {
  personTypes(
    criteria: {countries: [$country], label: $search, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectPersonTypeSuggestionQuery2Query__
 *
 * To run a query within a React component, call `useSelectPersonTypeSuggestionQuery2Query` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonTypeSuggestionQuery2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonTypeSuggestionQuery2Query({
 *   variables: {
 *      country: // value for 'country'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSelectPersonTypeSuggestionQuery2Query(baseOptions: Apollo.QueryHookOptions<SelectPersonTypeSuggestionQuery2Query, SelectPersonTypeSuggestionQuery2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonTypeSuggestionQuery2Query, SelectPersonTypeSuggestionQuery2QueryVariables>(SelectPersonTypeSuggestionQuery2Document, options);
      }
export function useSelectPersonTypeSuggestionQuery2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonTypeSuggestionQuery2Query, SelectPersonTypeSuggestionQuery2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonTypeSuggestionQuery2Query, SelectPersonTypeSuggestionQuery2QueryVariables>(SelectPersonTypeSuggestionQuery2Document, options);
        }
export type SelectPersonTypeSuggestionQuery2QueryHookResult = ReturnType<typeof useSelectPersonTypeSuggestionQuery2Query>;
export type SelectPersonTypeSuggestionQuery2LazyQueryHookResult = ReturnType<typeof useSelectPersonTypeSuggestionQuery2LazyQuery>;
export type SelectPersonTypeSuggestionQuery2QueryResult = Apollo.QueryResult<SelectPersonTypeSuggestionQuery2Query, SelectPersonTypeSuggestionQuery2QueryVariables>;
export const AddWorkplaceMutationDocument = gql`
    mutation AddWorkplaceMutation($input: AddWorkplaceInput!) {
  createSitePerson(input: $input) {
    dcr {
      id
    }
    sitePerson {
      id
      ...PersonSitesFragment
    }
  }
}
    ${PersonSitesFragmentFragmentDoc}`;
export type AddWorkplaceMutationMutationFn = Apollo.MutationFunction<AddWorkplaceMutationMutation, AddWorkplaceMutationMutationVariables>;

/**
 * __useAddWorkplaceMutationMutation__
 *
 * To run a mutation, you first call `useAddWorkplaceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkplaceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkplaceMutationMutation, { data, loading, error }] = useAddWorkplaceMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddWorkplaceMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddWorkplaceMutationMutation, AddWorkplaceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWorkplaceMutationMutation, AddWorkplaceMutationMutationVariables>(AddWorkplaceMutationDocument, options);
      }
export type AddWorkplaceMutationMutationHookResult = ReturnType<typeof useAddWorkplaceMutationMutation>;
export type AddWorkplaceMutationMutationResult = Apollo.MutationResult<AddWorkplaceMutationMutation>;
export type AddWorkplaceMutationMutationOptions = Apollo.BaseMutationOptions<AddWorkplaceMutationMutation, AddWorkplaceMutationMutationVariables>;
export const ActivateHcpSiteRelationDocument = gql`
    mutation ActivateHcpSiteRelation($linkId: Int!) {
  setSitePersonActiveStatus(id: $linkId, isActive: true) {
    id
    isActive
  }
}
    `;
export type ActivateHcpSiteRelationMutationFn = Apollo.MutationFunction<ActivateHcpSiteRelationMutation, ActivateHcpSiteRelationMutationVariables>;

/**
 * __useActivateHcpSiteRelationMutation__
 *
 * To run a mutation, you first call `useActivateHcpSiteRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateHcpSiteRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateHcpSiteRelationMutation, { data, loading, error }] = useActivateHcpSiteRelationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useActivateHcpSiteRelationMutation(baseOptions?: Apollo.MutationHookOptions<ActivateHcpSiteRelationMutation, ActivateHcpSiteRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateHcpSiteRelationMutation, ActivateHcpSiteRelationMutationVariables>(ActivateHcpSiteRelationDocument, options);
      }
export type ActivateHcpSiteRelationMutationHookResult = ReturnType<typeof useActivateHcpSiteRelationMutation>;
export type ActivateHcpSiteRelationMutationResult = Apollo.MutationResult<ActivateHcpSiteRelationMutation>;
export type ActivateHcpSiteRelationMutationOptions = Apollo.BaseMutationOptions<ActivateHcpSiteRelationMutation, ActivateHcpSiteRelationMutationVariables>;
export const RemoveHcpSiteRelationDocument = gql`
    mutation RemoveHcpSiteRelation($linkIds: [Int!]!, $comment: String, $reason: DeleteReasonDcrEnum!) {
  removeHcpSiteRelation(linkIds: $linkIds, comment: $comment, reason: $reason)
}
    `;
export type RemoveHcpSiteRelationMutationFn = Apollo.MutationFunction<RemoveHcpSiteRelationMutation, RemoveHcpSiteRelationMutationVariables>;

/**
 * __useRemoveHcpSiteRelationMutation__
 *
 * To run a mutation, you first call `useRemoveHcpSiteRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHcpSiteRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHcpSiteRelationMutation, { data, loading, error }] = useRemoveHcpSiteRelationMutation({
 *   variables: {
 *      linkIds: // value for 'linkIds'
 *      comment: // value for 'comment'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRemoveHcpSiteRelationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHcpSiteRelationMutation, RemoveHcpSiteRelationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHcpSiteRelationMutation, RemoveHcpSiteRelationMutationVariables>(RemoveHcpSiteRelationDocument, options);
      }
export type RemoveHcpSiteRelationMutationHookResult = ReturnType<typeof useRemoveHcpSiteRelationMutation>;
export type RemoveHcpSiteRelationMutationResult = Apollo.MutationResult<RemoveHcpSiteRelationMutation>;
export type RemoveHcpSiteRelationMutationOptions = Apollo.BaseMutationOptions<RemoveHcpSiteRelationMutation, RemoveHcpSiteRelationMutationVariables>;
export const SetPrimaryLinkMutationDocument = gql`
    mutation SetPrimaryLinkMutation($linkId: ID!, $personId: ID!) {
  setPrimaryLink(linkId: $linkId, personId: $personId) {
    id
    isPrimary
  }
}
    `;
export type SetPrimaryLinkMutationMutationFn = Apollo.MutationFunction<SetPrimaryLinkMutationMutation, SetPrimaryLinkMutationMutationVariables>;

/**
 * __useSetPrimaryLinkMutationMutation__
 *
 * To run a mutation, you first call `useSetPrimaryLinkMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryLinkMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryLinkMutationMutation, { data, loading, error }] = useSetPrimaryLinkMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSetPrimaryLinkMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryLinkMutationMutation, SetPrimaryLinkMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryLinkMutationMutation, SetPrimaryLinkMutationMutationVariables>(SetPrimaryLinkMutationDocument, options);
      }
export type SetPrimaryLinkMutationMutationHookResult = ReturnType<typeof useSetPrimaryLinkMutationMutation>;
export type SetPrimaryLinkMutationMutationResult = Apollo.MutationResult<SetPrimaryLinkMutationMutation>;
export type SetPrimaryLinkMutationMutationOptions = Apollo.BaseMutationOptions<SetPrimaryLinkMutationMutation, SetPrimaryLinkMutationMutationVariables>;
export const SetNonPrimaryLinkMutationDocument = gql`
    mutation SetNonPrimaryLinkMutation($linkId: ID!, $personId: ID!) {
  setNonPrimaryLink(linkId: $linkId, personId: $personId) {
    id
    isPrimary
  }
}
    `;
export type SetNonPrimaryLinkMutationMutationFn = Apollo.MutationFunction<SetNonPrimaryLinkMutationMutation, SetNonPrimaryLinkMutationMutationVariables>;

/**
 * __useSetNonPrimaryLinkMutationMutation__
 *
 * To run a mutation, you first call `useSetNonPrimaryLinkMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNonPrimaryLinkMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNonPrimaryLinkMutationMutation, { data, loading, error }] = useSetNonPrimaryLinkMutationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSetNonPrimaryLinkMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetNonPrimaryLinkMutationMutation, SetNonPrimaryLinkMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNonPrimaryLinkMutationMutation, SetNonPrimaryLinkMutationMutationVariables>(SetNonPrimaryLinkMutationDocument, options);
      }
export type SetNonPrimaryLinkMutationMutationHookResult = ReturnType<typeof useSetNonPrimaryLinkMutationMutation>;
export type SetNonPrimaryLinkMutationMutationResult = Apollo.MutationResult<SetNonPrimaryLinkMutationMutation>;
export type SetNonPrimaryLinkMutationMutationOptions = Apollo.BaseMutationOptions<SetNonPrimaryLinkMutationMutation, SetNonPrimaryLinkMutationMutationVariables>;
export const PersonSelectionRowTableQueryDocument = gql`
    query PersonSelectionRowTableQuery($criteria: PersonSelectionRowCriteria) {
  connection: personSelectionRows(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...PersonSelectionRowTableBuiltFragment
    }
  }
}
    ${PersonSelectionRowTableBuiltFragmentFragmentDoc}`;

/**
 * __usePersonSelectionRowTableQueryQuery__
 *
 * To run a query within a React component, call `usePersonSelectionRowTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSelectionRowTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSelectionRowTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function usePersonSelectionRowTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<PersonSelectionRowTableQueryQuery, PersonSelectionRowTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonSelectionRowTableQueryQuery, PersonSelectionRowTableQueryQueryVariables>(PersonSelectionRowTableQueryDocument, options);
      }
export function usePersonSelectionRowTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonSelectionRowTableQueryQuery, PersonSelectionRowTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonSelectionRowTableQueryQuery, PersonSelectionRowTableQueryQueryVariables>(PersonSelectionRowTableQueryDocument, options);
        }
export type PersonSelectionRowTableQueryQueryHookResult = ReturnType<typeof usePersonSelectionRowTableQueryQuery>;
export type PersonSelectionRowTableQueryLazyQueryHookResult = ReturnType<typeof usePersonSelectionRowTableQueryLazyQuery>;
export type PersonSelectionRowTableQueryQueryResult = Apollo.QueryResult<PersonSelectionRowTableQueryQuery, PersonSelectionRowTableQueryQueryVariables>;
export const PersonSelectionRowRecordQueryDocument = gql`
    query PersonSelectionRowRecordQuery($recordId: Long!) {
  record: personSelectionRow(id: $recordId) {
    id
    ...PersonSelectionRowTableBuiltFragment
  }
}
    ${PersonSelectionRowTableBuiltFragmentFragmentDoc}`;

/**
 * __usePersonSelectionRowRecordQueryQuery__
 *
 * To run a query within a React component, call `usePersonSelectionRowRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonSelectionRowRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonSelectionRowRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function usePersonSelectionRowRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonSelectionRowRecordQueryQuery, PersonSelectionRowRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonSelectionRowRecordQueryQuery, PersonSelectionRowRecordQueryQueryVariables>(PersonSelectionRowRecordQueryDocument, options);
      }
export function usePersonSelectionRowRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonSelectionRowRecordQueryQuery, PersonSelectionRowRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonSelectionRowRecordQueryQuery, PersonSelectionRowRecordQueryQueryVariables>(PersonSelectionRowRecordQueryDocument, options);
        }
export type PersonSelectionRowRecordQueryQueryHookResult = ReturnType<typeof usePersonSelectionRowRecordQueryQuery>;
export type PersonSelectionRowRecordQueryLazyQueryHookResult = ReturnType<typeof usePersonSelectionRowRecordQueryLazyQuery>;
export type PersonSelectionRowRecordQueryQueryResult = Apollo.QueryResult<PersonSelectionRowRecordQueryQuery, PersonSelectionRowRecordQueryQueryVariables>;
export const ProductDetailQueryDocument = gql`
    query ProductDetailQuery($productId: Int!) {
  product: getProductById(id: $productId) {
    id
    code
    name: heading
    ct
    ut
    strength
    strengthUnitType {
      id
      abbreviation
      description
      name
    }
    productDeliveries {
      totalCount
      nodes {
        person {
          id
          fullname: fullName
        }
      }
    }
  }
}
    `;

/**
 * __useProductDetailQueryQuery__
 *
 * To run a query within a React component, call `useProductDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailQueryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<ProductDetailQueryQuery, ProductDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailQueryQuery, ProductDetailQueryQueryVariables>(ProductDetailQueryDocument, options);
      }
export function useProductDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailQueryQuery, ProductDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailQueryQuery, ProductDetailQueryQueryVariables>(ProductDetailQueryDocument, options);
        }
export type ProductDetailQueryQueryHookResult = ReturnType<typeof useProductDetailQueryQuery>;
export type ProductDetailQueryLazyQueryHookResult = ReturnType<typeof useProductDetailQueryLazyQuery>;
export type ProductDetailQueryQueryResult = Apollo.QueryResult<ProductDetailQueryQuery, ProductDetailQueryQueryVariables>;
export const CreateNewProjectDocument = gql`
    mutation CreateNewProject($title: String!, $typeId: Int!, $start: DateTime!, $end: DateTime!) {
  createNewProject(title: $title, typeId: $typeId, start: $start, end: $end) {
    id
  }
}
    `;
export type CreateNewProjectMutationFn = Apollo.MutationFunction<CreateNewProjectMutation, CreateNewProjectMutationVariables>;

/**
 * __useCreateNewProjectMutation__
 *
 * To run a mutation, you first call `useCreateNewProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewProjectMutation, { data, loading, error }] = useCreateNewProjectMutation({
 *   variables: {
 *      title: // value for 'title'
 *      typeId: // value for 'typeId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCreateNewProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewProjectMutation, CreateNewProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewProjectMutation, CreateNewProjectMutationVariables>(CreateNewProjectDocument, options);
      }
export type CreateNewProjectMutationHookResult = ReturnType<typeof useCreateNewProjectMutation>;
export type CreateNewProjectMutationResult = Apollo.MutationResult<CreateNewProjectMutation>;
export type CreateNewProjectMutationOptions = Apollo.BaseMutationOptions<CreateNewProjectMutation, CreateNewProjectMutationVariables>;
export const ProjectTypesDocument = gql`
    query ProjectTypes {
  projectTypes {
    hash
    nodes {
      id
      code
      heading
      note
      ct
      ut
    }
  }
}
    `;

/**
 * __useProjectTypesQuery__
 *
 * To run a query within a React component, call `useProjectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProjectTypesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectTypesQuery, ProjectTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectTypesQuery, ProjectTypesQueryVariables>(ProjectTypesDocument, options);
      }
export function useProjectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectTypesQuery, ProjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectTypesQuery, ProjectTypesQueryVariables>(ProjectTypesDocument, options);
        }
export type ProjectTypesQueryHookResult = ReturnType<typeof useProjectTypesQuery>;
export type ProjectTypesLazyQueryHookResult = ReturnType<typeof useProjectTypesLazyQuery>;
export type ProjectTypesQueryResult = Apollo.QueryResult<ProjectTypesQuery, ProjectTypesQueryVariables>;
export const AssignValuesStepQueryDocument = gql`
    query AssignValuesStepQuery {
  roles: personProjectRoles {
    hash
    nodes {
      id
      heading
      description
    }
  }
  responses: projectResponses {
    hash
    nodes {
      id
      heading
      description
    }
  }
  preferences {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useAssignValuesStepQueryQuery__
 *
 * To run a query within a React component, call `useAssignValuesStepQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignValuesStepQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignValuesStepQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignValuesStepQueryQuery(baseOptions?: Apollo.QueryHookOptions<AssignValuesStepQueryQuery, AssignValuesStepQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignValuesStepQueryQuery, AssignValuesStepQueryQueryVariables>(AssignValuesStepQueryDocument, options);
      }
export function useAssignValuesStepQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignValuesStepQueryQuery, AssignValuesStepQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignValuesStepQueryQuery, AssignValuesStepQueryQueryVariables>(AssignValuesStepQueryDocument, options);
        }
export type AssignValuesStepQueryQueryHookResult = ReturnType<typeof useAssignValuesStepQueryQuery>;
export type AssignValuesStepQueryLazyQueryHookResult = ReturnType<typeof useAssignValuesStepQueryLazyQuery>;
export type AssignValuesStepQueryQueryResult = Apollo.QueryResult<AssignValuesStepQueryQuery, AssignValuesStepQueryQueryVariables>;
export const BulkProjectConfirmStepQueryDocument = gql`
    query BulkProjectConfirmStepQuery {
  projectTypes {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useBulkProjectConfirmStepQueryQuery__
 *
 * To run a query within a React component, call `useBulkProjectConfirmStepQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkProjectConfirmStepQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkProjectConfirmStepQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBulkProjectConfirmStepQueryQuery(baseOptions?: Apollo.QueryHookOptions<BulkProjectConfirmStepQueryQuery, BulkProjectConfirmStepQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkProjectConfirmStepQueryQuery, BulkProjectConfirmStepQueryQueryVariables>(BulkProjectConfirmStepQueryDocument, options);
      }
export function useBulkProjectConfirmStepQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkProjectConfirmStepQueryQuery, BulkProjectConfirmStepQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkProjectConfirmStepQueryQuery, BulkProjectConfirmStepQueryQueryVariables>(BulkProjectConfirmStepQueryDocument, options);
        }
export type BulkProjectConfirmStepQueryQueryHookResult = ReturnType<typeof useBulkProjectConfirmStepQueryQuery>;
export type BulkProjectConfirmStepQueryLazyQueryHookResult = ReturnType<typeof useBulkProjectConfirmStepQueryLazyQuery>;
export type BulkProjectConfirmStepQueryQueryResult = Apollo.QueryResult<BulkProjectConfirmStepQueryQuery, BulkProjectConfirmStepQueryQueryVariables>;
export const NewProjectStepDefaultValuesQueryDocument = gql`
    query NewProjectStepDefaultValuesQuery {
  projectTypes {
    hash
    defaultOption {
      id
    }
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useNewProjectStepDefaultValuesQueryQuery__
 *
 * To run a query within a React component, call `useNewProjectStepDefaultValuesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewProjectStepDefaultValuesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewProjectStepDefaultValuesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useNewProjectStepDefaultValuesQueryQuery(baseOptions?: Apollo.QueryHookOptions<NewProjectStepDefaultValuesQueryQuery, NewProjectStepDefaultValuesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewProjectStepDefaultValuesQueryQuery, NewProjectStepDefaultValuesQueryQueryVariables>(NewProjectStepDefaultValuesQueryDocument, options);
      }
export function useNewProjectStepDefaultValuesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewProjectStepDefaultValuesQueryQuery, NewProjectStepDefaultValuesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewProjectStepDefaultValuesQueryQuery, NewProjectStepDefaultValuesQueryQueryVariables>(NewProjectStepDefaultValuesQueryDocument, options);
        }
export type NewProjectStepDefaultValuesQueryQueryHookResult = ReturnType<typeof useNewProjectStepDefaultValuesQueryQuery>;
export type NewProjectStepDefaultValuesQueryLazyQueryHookResult = ReturnType<typeof useNewProjectStepDefaultValuesQueryLazyQuery>;
export type NewProjectStepDefaultValuesQueryQueryResult = Apollo.QueryResult<NewProjectStepDefaultValuesQueryQuery, NewProjectStepDefaultValuesQueryQueryVariables>;
export const BulkPersProjDocument = gql`
    mutation BulkPersProj($input: BulkProjectInput!) {
  bulkPersProject(input: $input) {
    id
  }
}
    `;
export type BulkPersProjMutationFn = Apollo.MutationFunction<BulkPersProjMutation, BulkPersProjMutationVariables>;

/**
 * __useBulkPersProjMutation__
 *
 * To run a mutation, you first call `useBulkPersProjMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPersProjMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPersProjMutation, { data, loading, error }] = useBulkPersProjMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkPersProjMutation(baseOptions?: Apollo.MutationHookOptions<BulkPersProjMutation, BulkPersProjMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPersProjMutation, BulkPersProjMutationVariables>(BulkPersProjDocument, options);
      }
export type BulkPersProjMutationHookResult = ReturnType<typeof useBulkPersProjMutation>;
export type BulkPersProjMutationResult = Apollo.MutationResult<BulkPersProjMutation>;
export type BulkPersProjMutationOptions = Apollo.BaseMutationOptions<BulkPersProjMutation, BulkPersProjMutationVariables>;
export const CreateProjectMutationDocument = gql`
    mutation CreateProjectMutation($title: String!, $typeId: Int!, $location: String, $note: String, $start: DateTime!, $end: DateTime!) {
  project: createNewProject(
    title: $title
    typeId: $typeId
    location: $location
    note: $note
    start: $start
    end: $end
  ) {
    id
    title
  }
}
    `;
export type CreateProjectMutationMutationFn = Apollo.MutationFunction<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>;

/**
 * __useCreateProjectMutationMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutationMutation, { data, loading, error }] = useCreateProjectMutationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      typeId: // value for 'typeId'
 *      location: // value for 'location'
 *      note: // value for 'note'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCreateProjectMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>(CreateProjectMutationDocument, options);
      }
export type CreateProjectMutationMutationHookResult = ReturnType<typeof useCreateProjectMutationMutation>;
export type CreateProjectMutationMutationResult = Apollo.MutationResult<CreateProjectMutationMutation>;
export type CreateProjectMutationMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutationMutation, CreateProjectMutationMutationVariables>;
export const PeopleInProjectQueryDocument = gql`
    query PeopleInProjectQuery($id: Int!, $isNewProject: Boolean!) {
  project(id: $id) @skip(if: $isNewProject) {
    id
    title
    affiliations: persProjectsByProjectId(criteria: {fetchSize: {limit: null}}) {
      hash
      nodes {
        id
        persId: personId
        roleId: valProjectRoleId
        responseId: valProjectResponseId
        personPreferences {
          hash
          nodes {
            id
            preferenceId
          }
        }
      }
    }
  }
  roles: personProjectRoles {
    hash
    defaultOption {
      id
      heading
    }
  }
  responses: projectResponses {
    hash
    defaultOption {
      id
      heading
    }
  }
  preferences {
    hash
    defaultOption {
      id
    }
  }
}
    `;

/**
 * __usePeopleInProjectQueryQuery__
 *
 * To run a query within a React component, call `usePeopleInProjectQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePeopleInProjectQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePeopleInProjectQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isNewProject: // value for 'isNewProject'
 *   },
 * });
 */
export function usePeopleInProjectQueryQuery(baseOptions: Apollo.QueryHookOptions<PeopleInProjectQueryQuery, PeopleInProjectQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PeopleInProjectQueryQuery, PeopleInProjectQueryQueryVariables>(PeopleInProjectQueryDocument, options);
      }
export function usePeopleInProjectQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PeopleInProjectQueryQuery, PeopleInProjectQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PeopleInProjectQueryQuery, PeopleInProjectQueryQueryVariables>(PeopleInProjectQueryDocument, options);
        }
export type PeopleInProjectQueryQueryHookResult = ReturnType<typeof usePeopleInProjectQueryQuery>;
export type PeopleInProjectQueryLazyQueryHookResult = ReturnType<typeof usePeopleInProjectQueryLazyQuery>;
export type PeopleInProjectQueryQueryResult = Apollo.QueryResult<PeopleInProjectQueryQuery, PeopleInProjectQueryQueryVariables>;
export const updateProjectLocationDocument = gql`
    mutation updateProjectLocation($projectId: Int!, $location: String!) {
  updateProjectLocation(projectId: $projectId, location: $location) {
    id
  }
}
    `;
export type updateProjectLocationMutationFn = Apollo.MutationFunction<updateProjectLocationMutation, updateProjectLocationMutationVariables>;

/**
 * __useupdateProjectLocationMutation__
 *
 * To run a mutation, you first call `useupdateProjectLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useupdateProjectLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectLocationMutation, { data, loading, error }] = useupdateProjectLocationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useupdateProjectLocationMutation(baseOptions?: Apollo.MutationHookOptions<updateProjectLocationMutation, updateProjectLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<updateProjectLocationMutation, updateProjectLocationMutationVariables>(updateProjectLocationDocument, options);
      }
export type updateProjectLocationMutationHookResult = ReturnType<typeof useupdateProjectLocationMutation>;
export type updateProjectLocationMutationResult = Apollo.MutationResult<updateProjectLocationMutation>;
export type updateProjectLocationMutationOptions = Apollo.BaseMutationOptions<updateProjectLocationMutation, updateProjectLocationMutationVariables>;
export const ProjectNotesQueryDocument = gql`
    query ProjectNotesQuery($projectId: Int!) {
  project(id: $projectId) {
    id
  }
}
    `;

/**
 * __useProjectNotesQueryQuery__
 *
 * To run a query within a React component, call `useProjectNotesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNotesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNotesQueryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectNotesQueryQuery(baseOptions: Apollo.QueryHookOptions<ProjectNotesQueryQuery, ProjectNotesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectNotesQueryQuery, ProjectNotesQueryQueryVariables>(ProjectNotesQueryDocument, options);
      }
export function useProjectNotesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectNotesQueryQuery, ProjectNotesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectNotesQueryQuery, ProjectNotesQueryQueryVariables>(ProjectNotesQueryDocument, options);
        }
export type ProjectNotesQueryQueryHookResult = ReturnType<typeof useProjectNotesQueryQuery>;
export type ProjectNotesQueryLazyQueryHookResult = ReturnType<typeof useProjectNotesQueryLazyQuery>;
export type ProjectNotesQueryQueryResult = Apollo.QueryResult<ProjectNotesQueryQuery, ProjectNotesQueryQueryVariables>;
export const UpdateProjectNotesDocument = gql`
    mutation UpdateProjectNotes($projectId: Int!, $notes: String!) {
  updateProjectNotes(id: $projectId, note: $notes) {
    id
  }
}
    `;
export type UpdateProjectNotesMutationFn = Apollo.MutationFunction<UpdateProjectNotesMutation, UpdateProjectNotesMutationVariables>;

/**
 * __useUpdateProjectNotesMutation__
 *
 * To run a mutation, you first call `useUpdateProjectNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectNotesMutation, { data, loading, error }] = useUpdateProjectNotesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateProjectNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectNotesMutation, UpdateProjectNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectNotesMutation, UpdateProjectNotesMutationVariables>(UpdateProjectNotesDocument, options);
      }
export type UpdateProjectNotesMutationHookResult = ReturnType<typeof useUpdateProjectNotesMutation>;
export type UpdateProjectNotesMutationResult = Apollo.MutationResult<UpdateProjectNotesMutation>;
export type UpdateProjectNotesMutationOptions = Apollo.BaseMutationOptions<UpdateProjectNotesMutation, UpdateProjectNotesMutationVariables>;
export const ProjectNoteDocument = gql`
    query ProjectNote($id: Int!) {
  project(id: $id) {
    id
    notes {
      hash
      totalCount
      nodes {
        id
        text
        ct
        ut
        status
        private
        title
        user {
          id
          fullname
        }
      }
    }
  }
}
    `;

/**
 * __useProjectNoteQuery__
 *
 * To run a query within a React component, call `useProjectNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectNoteQuery(baseOptions: Apollo.QueryHookOptions<ProjectNoteQuery, ProjectNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectNoteQuery, ProjectNoteQueryVariables>(ProjectNoteDocument, options);
      }
export function useProjectNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectNoteQuery, ProjectNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectNoteQuery, ProjectNoteQueryVariables>(ProjectNoteDocument, options);
        }
export type ProjectNoteQueryHookResult = ReturnType<typeof useProjectNoteQuery>;
export type ProjectNoteLazyQueryHookResult = ReturnType<typeof useProjectNoteLazyQuery>;
export type ProjectNoteQueryResult = Apollo.QueryResult<ProjectNoteQuery, ProjectNoteQueryVariables>;
export const AddProductToProjectDocument = gql`
    mutation AddProductToProject($projectId: Int!, $productId: Int!) {
  addProductToProject(projectId: $projectId, productId: $productId) {
    id
    project {
      id
      productsAffiliations {
        hash
        nodes {
          id
          product {
            id
            heading
          }
        }
      }
    }
  }
}
    `;
export type AddProductToProjectMutationFn = Apollo.MutationFunction<AddProductToProjectMutation, AddProductToProjectMutationVariables>;

/**
 * __useAddProductToProjectMutation__
 *
 * To run a mutation, you first call `useAddProductToProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToProjectMutation, { data, loading, error }] = useAddProductToProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useAddProductToProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToProjectMutation, AddProductToProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToProjectMutation, AddProductToProjectMutationVariables>(AddProductToProjectDocument, options);
      }
export type AddProductToProjectMutationHookResult = ReturnType<typeof useAddProductToProjectMutation>;
export type AddProductToProjectMutationResult = Apollo.MutationResult<AddProductToProjectMutation>;
export type AddProductToProjectMutationOptions = Apollo.BaseMutationOptions<AddProductToProjectMutation, AddProductToProjectMutationVariables>;
export const RemoveProductFromProjectDocument = gql`
    mutation RemoveProductFromProject($projectId: Int!, $productId: Int!) {
  removeProductFromProject(projectId: $projectId, productId: $productId) {
    id
    project {
      id
      productsAffiliations {
        hash
        nodes {
          id
          product {
            id
            heading
          }
        }
      }
    }
  }
}
    `;
export type RemoveProductFromProjectMutationFn = Apollo.MutationFunction<RemoveProductFromProjectMutation, RemoveProductFromProjectMutationVariables>;

/**
 * __useRemoveProductFromProjectMutation__
 *
 * To run a mutation, you first call `useRemoveProductFromProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductFromProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductFromProjectMutation, { data, loading, error }] = useRemoveProductFromProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveProductFromProjectMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductFromProjectMutation, RemoveProductFromProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductFromProjectMutation, RemoveProductFromProjectMutationVariables>(RemoveProductFromProjectDocument, options);
      }
export type RemoveProductFromProjectMutationHookResult = ReturnType<typeof useRemoveProductFromProjectMutation>;
export type RemoveProductFromProjectMutationResult = Apollo.MutationResult<RemoveProductFromProjectMutation>;
export type RemoveProductFromProjectMutationOptions = Apollo.BaseMutationOptions<RemoveProductFromProjectMutation, RemoveProductFromProjectMutationVariables>;
export const GetAllProductsDocument = gql`
    query GetAllProducts {
  products {
    hash
    nodes {
      id
      code
      label: heading
    }
  }
}
    `;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export const ProjectProductBrandsQueryDocument = gql`
    query ProjectProductBrandsQuery($projectId: Int!) {
  project(id: $projectId) {
    id
    productsAffiliations {
      hash
      nodes {
        id
        product {
          id
          code
          heading
        }
      }
    }
  }
}
    `;

/**
 * __useProjectProductBrandsQueryQuery__
 *
 * To run a query within a React component, call `useProjectProductBrandsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProductBrandsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProductBrandsQueryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectProductBrandsQueryQuery(baseOptions: Apollo.QueryHookOptions<ProjectProductBrandsQueryQuery, ProjectProductBrandsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectProductBrandsQueryQuery, ProjectProductBrandsQueryQueryVariables>(ProjectProductBrandsQueryDocument, options);
      }
export function useProjectProductBrandsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectProductBrandsQueryQuery, ProjectProductBrandsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectProductBrandsQueryQuery, ProjectProductBrandsQueryQueryVariables>(ProjectProductBrandsQueryDocument, options);
        }
export type ProjectProductBrandsQueryQueryHookResult = ReturnType<typeof useProjectProductBrandsQueryQuery>;
export type ProjectProductBrandsQueryLazyQueryHookResult = ReturnType<typeof useProjectProductBrandsQueryLazyQuery>;
export type ProjectProductBrandsQueryQueryResult = Apollo.QueryResult<ProjectProductBrandsQueryQuery, ProjectProductBrandsQueryQueryVariables>;
export const UpdateProjectResUsersDocument = gql`
    mutation UpdateProjectResUsers($projectId: Int!, $userIds: [Int!]!) {
  updateProjectResUsers(projectId: $projectId, ids: $userIds) {
    id
    editAccess
    responsibleUsers {
      hash
      nodes {
        id
        fullname
      }
    }
  }
}
    `;
export type UpdateProjectResUsersMutationFn = Apollo.MutationFunction<UpdateProjectResUsersMutation, UpdateProjectResUsersMutationVariables>;

/**
 * __useUpdateProjectResUsersMutation__
 *
 * To run a mutation, you first call `useUpdateProjectResUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectResUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectResUsersMutation, { data, loading, error }] = useUpdateProjectResUsersMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUpdateProjectResUsersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectResUsersMutation, UpdateProjectResUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectResUsersMutation, UpdateProjectResUsersMutationVariables>(UpdateProjectResUsersDocument, options);
      }
export type UpdateProjectResUsersMutationHookResult = ReturnType<typeof useUpdateProjectResUsersMutation>;
export type UpdateProjectResUsersMutationResult = Apollo.MutationResult<UpdateProjectResUsersMutation>;
export type UpdateProjectResUsersMutationOptions = Apollo.BaseMutationOptions<UpdateProjectResUsersMutation, UpdateProjectResUsersMutationVariables>;
export const ProjectRightActionsDocument = gql`
    query ProjectRightActions($projectId: Int!) {
  project(id: $projectId) {
    id
    editAccess
    responsibleUsers {
      hash
      nodes {
        id
        fullname
      }
    }
  }
  users {
    hash
    nodes {
      id
      fullname
      email
    }
  }
}
    `;

/**
 * __useProjectRightActionsQuery__
 *
 * To run a query within a React component, call `useProjectRightActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRightActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRightActionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRightActionsQuery(baseOptions: Apollo.QueryHookOptions<ProjectRightActionsQuery, ProjectRightActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRightActionsQuery, ProjectRightActionsQueryVariables>(ProjectRightActionsDocument, options);
      }
export function useProjectRightActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRightActionsQuery, ProjectRightActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRightActionsQuery, ProjectRightActionsQueryVariables>(ProjectRightActionsDocument, options);
        }
export type ProjectRightActionsQueryHookResult = ReturnType<typeof useProjectRightActionsQuery>;
export type ProjectRightActionsLazyQueryHookResult = ReturnType<typeof useProjectRightActionsLazyQuery>;
export type ProjectRightActionsQueryResult = Apollo.QueryResult<ProjectRightActionsQuery, ProjectRightActionsQueryVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation UpdateProjectStatus($projectId: Int!, $status: Int!) {
  updateProjectStatus(projectId: $projectId, status: $status) {
    id
  }
}
    `;
export type UpdateProjectStatusMutationFn = Apollo.MutationFunction<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusMutation, { data, loading, error }] = useUpdateProjectStatusMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
      }
export type UpdateProjectStatusMutationHookResult = ReturnType<typeof useUpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationResult = Apollo.MutationResult<UpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const UpdateProjectTitleDocument = gql`
    mutation UpdateProjectTitle($projectId: Int!, $title: String!) {
  updateProjectTitle(projectId: $projectId, title: $title) {
    id
  }
}
    `;
export type UpdateProjectTitleMutationFn = Apollo.MutationFunction<UpdateProjectTitleMutation, UpdateProjectTitleMutationVariables>;

/**
 * __useUpdateProjectTitleMutation__
 *
 * To run a mutation, you first call `useUpdateProjectTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectTitleMutation, { data, loading, error }] = useUpdateProjectTitleMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateProjectTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectTitleMutation, UpdateProjectTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectTitleMutation, UpdateProjectTitleMutationVariables>(UpdateProjectTitleDocument, options);
      }
export type UpdateProjectTitleMutationHookResult = ReturnType<typeof useUpdateProjectTitleMutation>;
export type UpdateProjectTitleMutationResult = Apollo.MutationResult<UpdateProjectTitleMutation>;
export type UpdateProjectTitleMutationOptions = Apollo.BaseMutationOptions<UpdateProjectTitleMutation, UpdateProjectTitleMutationVariables>;
export const UpdateProjectTypeDocument = gql`
    mutation UpdateProjectType($projectId: Int!, $type: Int!) {
  updateProjectType(projectId: $projectId, type: $type) {
    id
  }
}
    `;
export type UpdateProjectTypeMutationFn = Apollo.MutationFunction<UpdateProjectTypeMutation, UpdateProjectTypeMutationVariables>;

/**
 * __useUpdateProjectTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProjectTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectTypeMutation, { data, loading, error }] = useUpdateProjectTypeMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateProjectTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectTypeMutation, UpdateProjectTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectTypeMutation, UpdateProjectTypeMutationVariables>(UpdateProjectTypeDocument, options);
      }
export type UpdateProjectTypeMutationHookResult = ReturnType<typeof useUpdateProjectTypeMutation>;
export type UpdateProjectTypeMutationResult = Apollo.MutationResult<UpdateProjectTypeMutation>;
export type UpdateProjectTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProjectTypeMutation, UpdateProjectTypeMutationVariables>;
export const UsersForReportOverviewDocument = gql`
    query UsersForReportOverview($userIds: [ID!]) {
  users(criteria: {ids: $userIds}) {
    hash
    nodes {
      id
      fullname
    }
  }
}
    `;

/**
 * __useUsersForReportOverviewQuery__
 *
 * To run a query within a React component, call `useUsersForReportOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForReportOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForReportOverviewQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useUsersForReportOverviewQuery(baseOptions?: Apollo.QueryHookOptions<UsersForReportOverviewQuery, UsersForReportOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForReportOverviewQuery, UsersForReportOverviewQueryVariables>(UsersForReportOverviewDocument, options);
      }
export function useUsersForReportOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForReportOverviewQuery, UsersForReportOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForReportOverviewQuery, UsersForReportOverviewQueryVariables>(UsersForReportOverviewDocument, options);
        }
export type UsersForReportOverviewQueryHookResult = ReturnType<typeof useUsersForReportOverviewQuery>;
export type UsersForReportOverviewLazyQueryHookResult = ReturnType<typeof useUsersForReportOverviewLazyQuery>;
export type UsersForReportOverviewQueryResult = Apollo.QueryResult<UsersForReportOverviewQuery, UsersForReportOverviewQueryVariables>;
export const ProductsForReportOverviewDocument = gql`
    query ProductsForReportOverview($productIds: [ID!]) {
  products(criteria: {ids: $productIds}) {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useProductsForReportOverviewQuery__
 *
 * To run a query within a React component, call `useProductsForReportOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsForReportOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsForReportOverviewQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useProductsForReportOverviewQuery(baseOptions?: Apollo.QueryHookOptions<ProductsForReportOverviewQuery, ProductsForReportOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsForReportOverviewQuery, ProductsForReportOverviewQueryVariables>(ProductsForReportOverviewDocument, options);
      }
export function useProductsForReportOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsForReportOverviewQuery, ProductsForReportOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsForReportOverviewQuery, ProductsForReportOverviewQueryVariables>(ProductsForReportOverviewDocument, options);
        }
export type ProductsForReportOverviewQueryHookResult = ReturnType<typeof useProductsForReportOverviewQuery>;
export type ProductsForReportOverviewLazyQueryHookResult = ReturnType<typeof useProductsForReportOverviewLazyQuery>;
export type ProductsForReportOverviewQueryResult = Apollo.QueryResult<ProductsForReportOverviewQuery, ProductsForReportOverviewQueryVariables>;
export const CountriesQueryForReportsDocument = gql`
    query CountriesQueryForReports($search: String) {
  countries(
    criteria: {label: $search, ordering: [ALPHABETICALLY], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label
    }
  }
}
    `;

/**
 * __useCountriesQueryForReportsQuery__
 *
 * To run a query within a React component, call `useCountriesQueryForReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQueryForReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQueryForReportsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCountriesQueryForReportsQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQueryForReportsQuery, CountriesQueryForReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQueryForReportsQuery, CountriesQueryForReportsQueryVariables>(CountriesQueryForReportsDocument, options);
      }
export function useCountriesQueryForReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQueryForReportsQuery, CountriesQueryForReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQueryForReportsQuery, CountriesQueryForReportsQueryVariables>(CountriesQueryForReportsDocument, options);
        }
export type CountriesQueryForReportsQueryHookResult = ReturnType<typeof useCountriesQueryForReportsQuery>;
export type CountriesQueryForReportsLazyQueryHookResult = ReturnType<typeof useCountriesQueryForReportsLazyQuery>;
export type CountriesQueryForReportsQueryResult = Apollo.QueryResult<CountriesQueryForReportsQuery, CountriesQueryForReportsQueryVariables>;
export const ReportProductInputQueryDocument = gql`
    query ReportProductInputQuery($search: String) {
  products(criteria: {name: $search, fetchSize: {limit: 250}}) {
    hash
    nodes {
      id
      heading
    }
  }
}
    `;

/**
 * __useReportProductInputQueryQuery__
 *
 * To run a query within a React component, call `useReportProductInputQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportProductInputQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportProductInputQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useReportProductInputQueryQuery(baseOptions?: Apollo.QueryHookOptions<ReportProductInputQueryQuery, ReportProductInputQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportProductInputQueryQuery, ReportProductInputQueryQueryVariables>(ReportProductInputQueryDocument, options);
      }
export function useReportProductInputQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportProductInputQueryQuery, ReportProductInputQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportProductInputQueryQuery, ReportProductInputQueryQueryVariables>(ReportProductInputQueryDocument, options);
        }
export type ReportProductInputQueryQueryHookResult = ReturnType<typeof useReportProductInputQueryQuery>;
export type ReportProductInputQueryLazyQueryHookResult = ReturnType<typeof useReportProductInputQueryLazyQuery>;
export type ReportProductInputQueryQueryResult = Apollo.QueryResult<ReportProductInputQueryQuery, ReportProductInputQueryQueryVariables>;
export const ReportUsersInputQueryDocument = gql`
    query ReportUsersInputQuery($search: String) {
  users(criteria: {name: $search, fetchSize: {limit: 250}}) {
    hash
    nodes {
      id
      fullname
    }
  }
}
    `;

/**
 * __useReportUsersInputQueryQuery__
 *
 * To run a query within a React component, call `useReportUsersInputQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportUsersInputQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportUsersInputQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useReportUsersInputQueryQuery(baseOptions?: Apollo.QueryHookOptions<ReportUsersInputQueryQuery, ReportUsersInputQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUsersInputQueryQuery, ReportUsersInputQueryQueryVariables>(ReportUsersInputQueryDocument, options);
      }
export function useReportUsersInputQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUsersInputQueryQuery, ReportUsersInputQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUsersInputQueryQuery, ReportUsersInputQueryQueryVariables>(ReportUsersInputQueryDocument, options);
        }
export type ReportUsersInputQueryQueryHookResult = ReturnType<typeof useReportUsersInputQueryQuery>;
export type ReportUsersInputQueryLazyQueryHookResult = ReturnType<typeof useReportUsersInputQueryLazyQuery>;
export type ReportUsersInputQueryQueryResult = Apollo.QueryResult<ReportUsersInputQueryQuery, ReportUsersInputQueryQueryVariables>;
export const KPIReportInputQueryDocument = gql`
    query KPIReportInputQuery($country: CountryCode!) {
  salesCycleSetups(criteria: {countries: [$country]}) {
    hash
    nodes {
      id
      year
    }
  }
}
    `;

/**
 * __useKPIReportInputQueryQuery__
 *
 * To run a query within a React component, call `useKPIReportInputQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKPIReportInputQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKPIReportInputQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useKPIReportInputQueryQuery(baseOptions: Apollo.QueryHookOptions<KPIReportInputQueryQuery, KPIReportInputQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KPIReportInputQueryQuery, KPIReportInputQueryQueryVariables>(KPIReportInputQueryDocument, options);
      }
export function useKPIReportInputQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KPIReportInputQueryQuery, KPIReportInputQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KPIReportInputQueryQuery, KPIReportInputQueryQueryVariables>(KPIReportInputQueryDocument, options);
        }
export type KPIReportInputQueryQueryHookResult = ReturnType<typeof useKPIReportInputQueryQuery>;
export type KPIReportInputQueryLazyQueryHookResult = ReturnType<typeof useKPIReportInputQueryLazyQuery>;
export type KPIReportInputQueryQueryResult = Apollo.QueryResult<KPIReportInputQueryQuery, KPIReportInputQueryQueryVariables>;
export const GenerateReportMutationDocument = gql`
    mutation GenerateReportMutation($input: ReportInput!) {
  generateReport(input: $input) {
    url
  }
}
    `;
export type GenerateReportMutationMutationFn = Apollo.MutationFunction<GenerateReportMutationMutation, GenerateReportMutationMutationVariables>;

/**
 * __useGenerateReportMutationMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutationMutation, { data, loading, error }] = useGenerateReportMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateReportMutationMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutationMutation, GenerateReportMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutationMutation, GenerateReportMutationMutationVariables>(GenerateReportMutationDocument, options);
      }
export type GenerateReportMutationMutationHookResult = ReturnType<typeof useGenerateReportMutationMutation>;
export type GenerateReportMutationMutationResult = Apollo.MutationResult<GenerateReportMutationMutation>;
export type GenerateReportMutationMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutationMutation, GenerateReportMutationMutationVariables>;
export const reportsDocument = gql`
    query reports {
  reports {
    totalCount
    hash
    nodes {
      code
      sort
      heading
      description
      ut
      ct
    }
  }
}
    `;

/**
 * __usereportsQuery__
 *
 * To run a query within a React component, call `usereportsQuery` and pass it any options that fit your needs.
 * When your component renders, `usereportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usereportsQuery({
 *   variables: {
 *   },
 * });
 */
export function usereportsQuery(baseOptions?: Apollo.QueryHookOptions<reportsQuery, reportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<reportsQuery, reportsQueryVariables>(reportsDocument, options);
      }
export function usereportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<reportsQuery, reportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<reportsQuery, reportsQueryVariables>(reportsDocument, options);
        }
export type reportsQueryHookResult = ReturnType<typeof usereportsQuery>;
export type reportsLazyQueryHookResult = ReturnType<typeof usereportsLazyQuery>;
export type reportsQueryResult = Apollo.QueryResult<reportsQuery, reportsQueryVariables>;
export const ReportInputsQueryDocument = gql`
    query ReportInputsQuery($reportCode: String!) {
  report(code: $reportCode) {
    code
    inputDefs {
      key
      labelKey
      placeholderKey
      rules {
        type
        messageKey
        required
      }
    }
  }
}
    `;

/**
 * __useReportInputsQueryQuery__
 *
 * To run a query within a React component, call `useReportInputsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportInputsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportInputsQueryQuery({
 *   variables: {
 *      reportCode: // value for 'reportCode'
 *   },
 * });
 */
export function useReportInputsQueryQuery(baseOptions: Apollo.QueryHookOptions<ReportInputsQueryQuery, ReportInputsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportInputsQueryQuery, ReportInputsQueryQueryVariables>(ReportInputsQueryDocument, options);
      }
export function useReportInputsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportInputsQueryQuery, ReportInputsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportInputsQueryQuery, ReportInputsQueryQueryVariables>(ReportInputsQueryDocument, options);
        }
export type ReportInputsQueryQueryHookResult = ReturnType<typeof useReportInputsQueryQuery>;
export type ReportInputsQueryLazyQueryHookResult = ReturnType<typeof useReportInputsQueryLazyQuery>;
export type ReportInputsQueryQueryResult = Apollo.QueryResult<ReportInputsQueryQuery, ReportInputsQueryQueryVariables>;
export const SelectionRowResultTableQueryDocument = gql`
    query SelectionRowResultTableQuery($criteria: SelectionRowResultCriteria) {
  connection: selectionRowResults(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...SelectionRowResultTableBuiltFragment
    }
  }
}
    ${SelectionRowResultTableBuiltFragmentFragmentDoc}`;

/**
 * __useSelectionRowResultTableQueryQuery__
 *
 * To run a query within a React component, call `useSelectionRowResultTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectionRowResultTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectionRowResultTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useSelectionRowResultTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectionRowResultTableQueryQuery, SelectionRowResultTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectionRowResultTableQueryQuery, SelectionRowResultTableQueryQueryVariables>(SelectionRowResultTableQueryDocument, options);
      }
export function useSelectionRowResultTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectionRowResultTableQueryQuery, SelectionRowResultTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectionRowResultTableQueryQuery, SelectionRowResultTableQueryQueryVariables>(SelectionRowResultTableQueryDocument, options);
        }
export type SelectionRowResultTableQueryQueryHookResult = ReturnType<typeof useSelectionRowResultTableQueryQuery>;
export type SelectionRowResultTableQueryLazyQueryHookResult = ReturnType<typeof useSelectionRowResultTableQueryLazyQuery>;
export type SelectionRowResultTableQueryQueryResult = Apollo.QueryResult<SelectionRowResultTableQueryQuery, SelectionRowResultTableQueryQueryVariables>;
export const SelectionRowResultRecordQueryDocument = gql`
    query SelectionRowResultRecordQuery($recordId: ID!) {
  record: selectionRowResult(id: $recordId) {
    id
    ...SelectionRowResultTableBuiltFragment
  }
}
    ${SelectionRowResultTableBuiltFragmentFragmentDoc}`;

/**
 * __useSelectionRowResultRecordQueryQuery__
 *
 * To run a query within a React component, call `useSelectionRowResultRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectionRowResultRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectionRowResultRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSelectionRowResultRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectionRowResultRecordQueryQuery, SelectionRowResultRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectionRowResultRecordQueryQuery, SelectionRowResultRecordQueryQueryVariables>(SelectionRowResultRecordQueryDocument, options);
      }
export function useSelectionRowResultRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectionRowResultRecordQueryQuery, SelectionRowResultRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectionRowResultRecordQueryQuery, SelectionRowResultRecordQueryQueryVariables>(SelectionRowResultRecordQueryDocument, options);
        }
export type SelectionRowResultRecordQueryQueryHookResult = ReturnType<typeof useSelectionRowResultRecordQueryQuery>;
export type SelectionRowResultRecordQueryLazyQueryHookResult = ReturnType<typeof useSelectionRowResultRecordQueryLazyQuery>;
export type SelectionRowResultRecordQueryQueryResult = Apollo.QueryResult<SelectionRowResultRecordQueryQuery, SelectionRowResultRecordQueryQueryVariables>;
export const FetchSitePositionsGroupsDocument = gql`
    query FetchSitePositionsGroups($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
    positionGroups {
      code
      heading
      count
    }
    affiliations {
      hash
      totalCount
      nodes {
        id
        person {
          id
          fullName
        }
        position {
          code
          type
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSitePositionsGroupsQuery__
 *
 * To run a query within a React component, call `useFetchSitePositionsGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSitePositionsGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSitePositionsGroupsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useFetchSitePositionsGroupsQuery(baseOptions: Apollo.QueryHookOptions<FetchSitePositionsGroupsQuery, FetchSitePositionsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSitePositionsGroupsQuery, FetchSitePositionsGroupsQueryVariables>(FetchSitePositionsGroupsDocument, options);
      }
export function useFetchSitePositionsGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSitePositionsGroupsQuery, FetchSitePositionsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSitePositionsGroupsQuery, FetchSitePositionsGroupsQueryVariables>(FetchSitePositionsGroupsDocument, options);
        }
export type FetchSitePositionsGroupsQueryHookResult = ReturnType<typeof useFetchSitePositionsGroupsQuery>;
export type FetchSitePositionsGroupsLazyQueryHookResult = ReturnType<typeof useFetchSitePositionsGroupsLazyQuery>;
export type FetchSitePositionsGroupsQueryResult = Apollo.QueryResult<FetchSitePositionsGroupsQuery, FetchSitePositionsGroupsQueryVariables>;
export const FindNewSiteQueryByApbIdDocument = gql`
    query FindNewSiteQueryByApbId($apbId: Int!) {
  sites(criteria: {aPureBaseId: $apbId}) {
    hash
    nodes {
      id
    }
  }
}
    `;

/**
 * __useFindNewSiteQueryByApbIdQuery__
 *
 * To run a query within a React component, call `useFindNewSiteQueryByApbIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNewSiteQueryByApbIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNewSiteQueryByApbIdQuery({
 *   variables: {
 *      apbId: // value for 'apbId'
 *   },
 * });
 */
export function useFindNewSiteQueryByApbIdQuery(baseOptions: Apollo.QueryHookOptions<FindNewSiteQueryByApbIdQuery, FindNewSiteQueryByApbIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindNewSiteQueryByApbIdQuery, FindNewSiteQueryByApbIdQueryVariables>(FindNewSiteQueryByApbIdDocument, options);
      }
export function useFindNewSiteQueryByApbIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNewSiteQueryByApbIdQuery, FindNewSiteQueryByApbIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindNewSiteQueryByApbIdQuery, FindNewSiteQueryByApbIdQueryVariables>(FindNewSiteQueryByApbIdDocument, options);
        }
export type FindNewSiteQueryByApbIdQueryHookResult = ReturnType<typeof useFindNewSiteQueryByApbIdQuery>;
export type FindNewSiteQueryByApbIdLazyQueryHookResult = ReturnType<typeof useFindNewSiteQueryByApbIdLazyQuery>;
export type FindNewSiteQueryByApbIdQueryResult = Apollo.QueryResult<FindNewSiteQueryByApbIdQuery, FindNewSiteQueryByApbIdQueryVariables>;
export const SiteDetailDocument = gql`
    query SiteDetail($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
    isUnplaced
    countryCode
    maintainerSourceCode
    isHcoCherryPicked
    isActive
  }
}
    `;

/**
 * __useSiteDetailQuery__
 *
 * To run a query within a React component, call `useSiteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteDetailQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteDetailQuery(baseOptions: Apollo.QueryHookOptions<SiteDetailQuery, SiteDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteDetailQuery, SiteDetailQueryVariables>(SiteDetailDocument, options);
      }
export function useSiteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteDetailQuery, SiteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteDetailQuery, SiteDetailQueryVariables>(SiteDetailDocument, options);
        }
export type SiteDetailQueryHookResult = ReturnType<typeof useSiteDetailQuery>;
export type SiteDetailLazyQueryHookResult = ReturnType<typeof useSiteDetailLazyQuery>;
export type SiteDetailQueryResult = Apollo.QueryResult<SiteDetailQuery, SiteDetailQueryVariables>;
export const AddNewPersonToSiteMutationDocument = gql`
    mutation AddNewPersonToSiteMutation($personInput: PersonInput!) {
  createPerson(input: $personInput) {
    dcr {
      id
    }
    person {
      id
      affiliations {
        hash
        nodes {
          ...SitePersonForCache
        }
      }
    }
  }
}
    ${SitePersonForCacheFragmentDoc}`;
export type AddNewPersonToSiteMutationMutationFn = Apollo.MutationFunction<AddNewPersonToSiteMutationMutation, AddNewPersonToSiteMutationMutationVariables>;

/**
 * __useAddNewPersonToSiteMutationMutation__
 *
 * To run a mutation, you first call `useAddNewPersonToSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewPersonToSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewPersonToSiteMutationMutation, { data, loading, error }] = useAddNewPersonToSiteMutationMutation({
 *   variables: {
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useAddNewPersonToSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddNewPersonToSiteMutationMutation, AddNewPersonToSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewPersonToSiteMutationMutation, AddNewPersonToSiteMutationMutationVariables>(AddNewPersonToSiteMutationDocument, options);
      }
export type AddNewPersonToSiteMutationMutationHookResult = ReturnType<typeof useAddNewPersonToSiteMutationMutation>;
export type AddNewPersonToSiteMutationMutationResult = Apollo.MutationResult<AddNewPersonToSiteMutationMutation>;
export type AddNewPersonToSiteMutationMutationOptions = Apollo.BaseMutationOptions<AddNewPersonToSiteMutationMutation, AddNewPersonToSiteMutationMutationVariables>;
export const AddExistingPersonToSiteMutationDocument = gql`
    mutation AddExistingPersonToSiteMutation($workplaceInput: AddWorkplaceInput!) {
  createSitePerson(input: $workplaceInput) {
    dcr {
      id
    }
    sitePerson {
      ...SitePersonForCache
    }
  }
}
    ${SitePersonForCacheFragmentDoc}`;
export type AddExistingPersonToSiteMutationMutationFn = Apollo.MutationFunction<AddExistingPersonToSiteMutationMutation, AddExistingPersonToSiteMutationMutationVariables>;

/**
 * __useAddExistingPersonToSiteMutationMutation__
 *
 * To run a mutation, you first call `useAddExistingPersonToSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExistingPersonToSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExistingPersonToSiteMutationMutation, { data, loading, error }] = useAddExistingPersonToSiteMutationMutation({
 *   variables: {
 *      workplaceInput: // value for 'workplaceInput'
 *   },
 * });
 */
export function useAddExistingPersonToSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddExistingPersonToSiteMutationMutation, AddExistingPersonToSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExistingPersonToSiteMutationMutation, AddExistingPersonToSiteMutationMutationVariables>(AddExistingPersonToSiteMutationDocument, options);
      }
export type AddExistingPersonToSiteMutationMutationHookResult = ReturnType<typeof useAddExistingPersonToSiteMutationMutation>;
export type AddExistingPersonToSiteMutationMutationResult = Apollo.MutationResult<AddExistingPersonToSiteMutationMutation>;
export type AddExistingPersonToSiteMutationMutationOptions = Apollo.BaseMutationOptions<AddExistingPersonToSiteMutationMutation, AddExistingPersonToSiteMutationMutationVariables>;
export const AddPersonsToSiteModalQueryDocument = gql`
    query AddPersonsToSiteModalQuery {
  affiliationSetting: entityControlSetting(entityType: AFFILIATION) {
    id
    createDcr
  }
  personSetting: entityControlSetting(entityType: PERSON) {
    id
    createDcr
  }
}
    `;

/**
 * __useAddPersonsToSiteModalQueryQuery__
 *
 * To run a query within a React component, call `useAddPersonsToSiteModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddPersonsToSiteModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddPersonsToSiteModalQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddPersonsToSiteModalQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddPersonsToSiteModalQueryQuery, AddPersonsToSiteModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddPersonsToSiteModalQueryQuery, AddPersonsToSiteModalQueryQueryVariables>(AddPersonsToSiteModalQueryDocument, options);
      }
export function useAddPersonsToSiteModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddPersonsToSiteModalQueryQuery, AddPersonsToSiteModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddPersonsToSiteModalQueryQuery, AddPersonsToSiteModalQueryQueryVariables>(AddPersonsToSiteModalQueryDocument, options);
        }
export type AddPersonsToSiteModalQueryQueryHookResult = ReturnType<typeof useAddPersonsToSiteModalQueryQuery>;
export type AddPersonsToSiteModalQueryLazyQueryHookResult = ReturnType<typeof useAddPersonsToSiteModalQueryLazyQuery>;
export type AddPersonsToSiteModalQueryQueryResult = Apollo.QueryResult<AddPersonsToSiteModalQueryQuery, AddPersonsToSiteModalQueryQueryVariables>;
export const HcoSectionRightQueryDocument = gql`
    query HcoSectionRightQuery {
  canICreate(entityType: AFFILIATION)
}
    `;

/**
 * __useHcoSectionRightQueryQuery__
 *
 * To run a query within a React component, call `useHcoSectionRightQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHcoSectionRightQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHcoSectionRightQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHcoSectionRightQueryQuery(baseOptions?: Apollo.QueryHookOptions<HcoSectionRightQueryQuery, HcoSectionRightQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HcoSectionRightQueryQuery, HcoSectionRightQueryQueryVariables>(HcoSectionRightQueryDocument, options);
      }
export function useHcoSectionRightQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HcoSectionRightQueryQuery, HcoSectionRightQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HcoSectionRightQueryQuery, HcoSectionRightQueryQueryVariables>(HcoSectionRightQueryDocument, options);
        }
export type HcoSectionRightQueryQueryHookResult = ReturnType<typeof useHcoSectionRightQueryQuery>;
export type HcoSectionRightQueryLazyQueryHookResult = ReturnType<typeof useHcoSectionRightQueryLazyQuery>;
export type HcoSectionRightQueryQueryResult = Apollo.QueryResult<HcoSectionRightQueryQuery, HcoSectionRightQueryQueryVariables>;
export const ValueChainQueryDocument = gql`
    query ValueChainQuery($countries: [CountryCode!], $search: String) {
  valueChains(
    criteria: {label: $search, countries: $countries, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useValueChainQueryQuery__
 *
 * To run a query within a React component, call `useValueChainQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useValueChainQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValueChainQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useValueChainQueryQuery(baseOptions?: Apollo.QueryHookOptions<ValueChainQueryQuery, ValueChainQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValueChainQueryQuery, ValueChainQueryQueryVariables>(ValueChainQueryDocument, options);
      }
export function useValueChainQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValueChainQueryQuery, ValueChainQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValueChainQueryQuery, ValueChainQueryQueryVariables>(ValueChainQueryDocument, options);
        }
export type ValueChainQueryQueryHookResult = ReturnType<typeof useValueChainQueryQuery>;
export type ValueChainQueryLazyQueryHookResult = ReturnType<typeof useValueChainQueryLazyQuery>;
export type ValueChainQueryQueryResult = Apollo.QueryResult<ValueChainQueryQuery, ValueChainQueryQueryVariables>;
export const SiteActivityContainerQueryDocument = gql`
    query SiteActivityContainerQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    activities {
      hash
      nodes {
        id
        title: heading
        startDate
        endDate
        ct
        activityStatus: status {
          code
        }
        responsibleUsers {
          hash
          nodes {
            id
            fullname
          }
        }
        type {
          code
          color {
            code
          }
        }
        notes {
          hash
          nodes {
            id
            text
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSiteActivityContainerQueryQuery__
 *
 * To run a query within a React component, call `useSiteActivityContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteActivityContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteActivityContainerQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteActivityContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteActivityContainerQueryQuery, SiteActivityContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteActivityContainerQueryQuery, SiteActivityContainerQueryQueryVariables>(SiteActivityContainerQueryDocument, options);
      }
export function useSiteActivityContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteActivityContainerQueryQuery, SiteActivityContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteActivityContainerQueryQuery, SiteActivityContainerQueryQueryVariables>(SiteActivityContainerQueryDocument, options);
        }
export type SiteActivityContainerQueryQueryHookResult = ReturnType<typeof useSiteActivityContainerQueryQuery>;
export type SiteActivityContainerQueryLazyQueryHookResult = ReturnType<typeof useSiteActivityContainerQueryLazyQuery>;
export type SiteActivityContainerQueryQueryResult = Apollo.QueryResult<SiteActivityContainerQueryQuery, SiteActivityContainerQueryQueryVariables>;
export const SiteAffiliationContainerQueryDocument = gql`
    query SiteAffiliationContainerQuery($recordId: Int!) {
  site(siteId: $recordId) {
    id
    name
    apurebaseId
    countryCode
    persons {
      hash
      totalCount
    }
    childrenHierarchy {
      hash
      totalCount
    }
    activities {
      hash
      totalCount
    }
    notes {
      hash
      totalCount
    }
    dcrGroups {
      hash
      totalCount
    }
    selectionRowsCustomerCount(criteria: {selectionType: DYNAMIC})
  }
}
    `;

/**
 * __useSiteAffiliationContainerQueryQuery__
 *
 * To run a query within a React component, call `useSiteAffiliationContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAffiliationContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAffiliationContainerQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSiteAffiliationContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteAffiliationContainerQueryQuery, SiteAffiliationContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAffiliationContainerQueryQuery, SiteAffiliationContainerQueryQueryVariables>(SiteAffiliationContainerQueryDocument, options);
      }
export function useSiteAffiliationContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAffiliationContainerQueryQuery, SiteAffiliationContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAffiliationContainerQueryQuery, SiteAffiliationContainerQueryQueryVariables>(SiteAffiliationContainerQueryDocument, options);
        }
export type SiteAffiliationContainerQueryQueryHookResult = ReturnType<typeof useSiteAffiliationContainerQueryQuery>;
export type SiteAffiliationContainerQueryLazyQueryHookResult = ReturnType<typeof useSiteAffiliationContainerQueryLazyQuery>;
export type SiteAffiliationContainerQueryQueryResult = Apollo.QueryResult<SiteAffiliationContainerQueryQuery, SiteAffiliationContainerQueryQueryVariables>;
export const SiteNameQueryDocument = gql`
    query SiteNameQuery($siteId: Int!) {
  site(siteId: $siteId) {
    name
  }
}
    `;

/**
 * __useSiteNameQueryQuery__
 *
 * To run a query within a React component, call `useSiteNameQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteNameQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteNameQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteNameQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteNameQueryQuery, SiteNameQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteNameQueryQuery, SiteNameQueryQueryVariables>(SiteNameQueryDocument, options);
      }
export function useSiteNameQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteNameQueryQuery, SiteNameQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteNameQueryQuery, SiteNameQueryQueryVariables>(SiteNameQueryDocument, options);
        }
export type SiteNameQueryQueryHookResult = ReturnType<typeof useSiteNameQueryQuery>;
export type SiteNameQueryLazyQueryHookResult = ReturnType<typeof useSiteNameQueryLazyQuery>;
export type SiteNameQueryQueryResult = Apollo.QueryResult<SiteNameQueryQuery, SiteNameQueryQueryVariables>;
export const SiteCardContainerQueryDocument = gql`
    query SiteCardContainerQuery($siteId: Int!, $entityGridItemConfigurationId: Int!) {
  cardFieldKeys(entityGridItemConfigurationId: $entityGridItemConfigurationId) {
    entityGridItemConfigurationId
    person {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
    site {
      entityGridItemConfigurationId
      entityType
      fields {
        ...GridCardField
      }
      drawerFields {
        ...GridCardField
      }
    }
  }
  site(siteId: $siteId) {
    id
    name
    siteSegmentationCode {
      id
      heading
    }
  }
}
    ${GridCardFieldFragmentDoc}`;

/**
 * __useSiteCardContainerQueryQuery__
 *
 * To run a query within a React component, call `useSiteCardContainerQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteCardContainerQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteCardContainerQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      entityGridItemConfigurationId: // value for 'entityGridItemConfigurationId'
 *   },
 * });
 */
export function useSiteCardContainerQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteCardContainerQueryQuery, SiteCardContainerQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteCardContainerQueryQuery, SiteCardContainerQueryQueryVariables>(SiteCardContainerQueryDocument, options);
      }
export function useSiteCardContainerQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteCardContainerQueryQuery, SiteCardContainerQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteCardContainerQueryQuery, SiteCardContainerQueryQueryVariables>(SiteCardContainerQueryDocument, options);
        }
export type SiteCardContainerQueryQueryHookResult = ReturnType<typeof useSiteCardContainerQueryQuery>;
export type SiteCardContainerQueryLazyQueryHookResult = ReturnType<typeof useSiteCardContainerQueryLazyQuery>;
export type SiteCardContainerQueryQueryResult = Apollo.QueryResult<SiteCardContainerQueryQuery, SiteCardContainerQueryQueryVariables>;
export const UpdateSiteFilterCodeDocument = gql`
    mutation UpdateSiteFilterCode($siteId: Int!, $filterCodeIds: [Int!]!) {
  updateSiteFilterCode(siteId: $siteId, filterCodeIds: $filterCodeIds) {
    id
  }
}
    `;
export type UpdateSiteFilterCodeMutationFn = Apollo.MutationFunction<UpdateSiteFilterCodeMutation, UpdateSiteFilterCodeMutationVariables>;

/**
 * __useUpdateSiteFilterCodeMutation__
 *
 * To run a mutation, you first call `useUpdateSiteFilterCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteFilterCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteFilterCodeMutation, { data, loading, error }] = useUpdateSiteFilterCodeMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      filterCodeIds: // value for 'filterCodeIds'
 *   },
 * });
 */
export function useUpdateSiteFilterCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteFilterCodeMutation, UpdateSiteFilterCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteFilterCodeMutation, UpdateSiteFilterCodeMutationVariables>(UpdateSiteFilterCodeDocument, options);
      }
export type UpdateSiteFilterCodeMutationHookResult = ReturnType<typeof useUpdateSiteFilterCodeMutation>;
export type UpdateSiteFilterCodeMutationResult = Apollo.MutationResult<UpdateSiteFilterCodeMutation>;
export type UpdateSiteFilterCodeMutationOptions = Apollo.BaseMutationOptions<UpdateSiteFilterCodeMutation, UpdateSiteFilterCodeMutationVariables>;
export const SiteFilterCodesSearchQueryDocument = gql`
    query SiteFilterCodesSearchQuery($search: String) {
  filterCodeTypes(criteria: {filterCodeTypeOrFilterCodeLabel: $search}) {
    hash
    nodes {
      id
      code
      heading
      getFilterCodesByTypeId(criteria: {header: $search}) {
        hash
        totalCount
        nodes {
          id
          header
        }
      }
    }
  }
}
    `;

/**
 * __useSiteFilterCodesSearchQueryQuery__
 *
 * To run a query within a React component, call `useSiteFilterCodesSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteFilterCodesSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteFilterCodesSearchQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSiteFilterCodesSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteFilterCodesSearchQueryQuery, SiteFilterCodesSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteFilterCodesSearchQueryQuery, SiteFilterCodesSearchQueryQueryVariables>(SiteFilterCodesSearchQueryDocument, options);
      }
export function useSiteFilterCodesSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteFilterCodesSearchQueryQuery, SiteFilterCodesSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteFilterCodesSearchQueryQuery, SiteFilterCodesSearchQueryQueryVariables>(SiteFilterCodesSearchQueryDocument, options);
        }
export type SiteFilterCodesSearchQueryQueryHookResult = ReturnType<typeof useSiteFilterCodesSearchQueryQuery>;
export type SiteFilterCodesSearchQueryLazyQueryHookResult = ReturnType<typeof useSiteFilterCodesSearchQueryLazyQuery>;
export type SiteFilterCodesSearchQueryQueryResult = Apollo.QueryResult<SiteFilterCodesSearchQueryQuery, SiteFilterCodesSearchQueryQueryVariables>;
export const SiteFilterCodesQueryDocument = gql`
    query SiteFilterCodesQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    filterCodes {
      hash
      nodes {
        id
        filterCodeTypeId
        header
      }
    }
  }
}
    `;

/**
 * __useSiteFilterCodesQueryQuery__
 *
 * To run a query within a React component, call `useSiteFilterCodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteFilterCodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteFilterCodesQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteFilterCodesQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteFilterCodesQueryQuery, SiteFilterCodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteFilterCodesQueryQuery, SiteFilterCodesQueryQueryVariables>(SiteFilterCodesQueryDocument, options);
      }
export function useSiteFilterCodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteFilterCodesQueryQuery, SiteFilterCodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteFilterCodesQueryQuery, SiteFilterCodesQueryQueryVariables>(SiteFilterCodesQueryDocument, options);
        }
export type SiteFilterCodesQueryQueryHookResult = ReturnType<typeof useSiteFilterCodesQueryQuery>;
export type SiteFilterCodesQueryLazyQueryHookResult = ReturnType<typeof useSiteFilterCodesQueryLazyQuery>;
export type SiteFilterCodesQueryQueryResult = Apollo.QueryResult<SiteFilterCodesQueryQuery, SiteFilterCodesQueryQueryVariables>;
export const CheckSiteMergeRequestQueryDocument = gql`
    query CheckSiteMergeRequestQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    mergeRequests {
      hash
      totalCount
      nodes {
        id
        status
        entityAffiliationId
        intoEntityAffiliationId
        into {
          ... on Site {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckSiteMergeRequestQueryQuery__
 *
 * To run a query within a React component, call `useCheckSiteMergeRequestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSiteMergeRequestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSiteMergeRequestQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCheckSiteMergeRequestQueryQuery(baseOptions: Apollo.QueryHookOptions<CheckSiteMergeRequestQueryQuery, CheckSiteMergeRequestQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSiteMergeRequestQueryQuery, CheckSiteMergeRequestQueryQueryVariables>(CheckSiteMergeRequestQueryDocument, options);
      }
export function useCheckSiteMergeRequestQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSiteMergeRequestQueryQuery, CheckSiteMergeRequestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSiteMergeRequestQueryQuery, CheckSiteMergeRequestQueryQueryVariables>(CheckSiteMergeRequestQueryDocument, options);
        }
export type CheckSiteMergeRequestQueryQueryHookResult = ReturnType<typeof useCheckSiteMergeRequestQueryQuery>;
export type CheckSiteMergeRequestQueryLazyQueryHookResult = ReturnType<typeof useCheckSiteMergeRequestQueryLazyQuery>;
export type CheckSiteMergeRequestQueryQueryResult = Apollo.QueryResult<CheckSiteMergeRequestQueryQuery, CheckSiteMergeRequestQueryQueryVariables>;
export const SiteNoteDetailDocument = gql`
    query SiteNoteDetail($siteId: Int!) {
  site(siteId: $siteId) {
    id
    notes {
      hash
      totalCount
      nodes {
        id
        text
        ct
        ut
        status
        private
        title
        user {
          id
          fullname
        }
      }
    }
  }
}
    `;

/**
 * __useSiteNoteDetailQuery__
 *
 * To run a query within a React component, call `useSiteNoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteNoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteNoteDetailQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteNoteDetailQuery(baseOptions: Apollo.QueryHookOptions<SiteNoteDetailQuery, SiteNoteDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteNoteDetailQuery, SiteNoteDetailQueryVariables>(SiteNoteDetailDocument, options);
      }
export function useSiteNoteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteNoteDetailQuery, SiteNoteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteNoteDetailQuery, SiteNoteDetailQueryVariables>(SiteNoteDetailDocument, options);
        }
export type SiteNoteDetailQueryHookResult = ReturnType<typeof useSiteNoteDetailQuery>;
export type SiteNoteDetailLazyQueryHookResult = ReturnType<typeof useSiteNoteDetailLazyQuery>;
export type SiteNoteDetailQueryResult = Apollo.QueryResult<SiteNoteDetailQuery, SiteNoteDetailQueryVariables>;
export const SiteSpecialityTypeQueryDocument = gql`
    query SiteSpecialityTypeQuery($search: String) {
  siteSectorTypes(criteria: {label: $search}) {
    hash
    nodes {
      code
      label
    }
  }
}
    `;

/**
 * __useSiteSpecialityTypeQueryQuery__
 *
 * To run a query within a React component, call `useSiteSpecialityTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSpecialityTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSpecialityTypeQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSiteSpecialityTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteSpecialityTypeQueryQuery, SiteSpecialityTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSpecialityTypeQueryQuery, SiteSpecialityTypeQueryQueryVariables>(SiteSpecialityTypeQueryDocument, options);
      }
export function useSiteSpecialityTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSpecialityTypeQueryQuery, SiteSpecialityTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSpecialityTypeQueryQuery, SiteSpecialityTypeQueryQueryVariables>(SiteSpecialityTypeQueryDocument, options);
        }
export type SiteSpecialityTypeQueryQueryHookResult = ReturnType<typeof useSiteSpecialityTypeQueryQuery>;
export type SiteSpecialityTypeQueryLazyQueryHookResult = ReturnType<typeof useSiteSpecialityTypeQueryLazyQuery>;
export type SiteSpecialityTypeQueryQueryResult = Apollo.QueryResult<SiteSpecialityTypeQueryQuery, SiteSpecialityTypeQueryQueryVariables>;
export const UpsertSiteSegmentationCodeDocument = gql`
    mutation UpsertSiteSegmentationCode($id: Int!, $segmentationId: Int!) {
  upsertSiteSegmentationCode(siteId: $id, segmentationCodeId: $segmentationId) {
    id
    segmentationCode {
      id
      heading
    }
  }
}
    `;
export type UpsertSiteSegmentationCodeMutationFn = Apollo.MutationFunction<UpsertSiteSegmentationCodeMutation, UpsertSiteSegmentationCodeMutationVariables>;

/**
 * __useUpsertSiteSegmentationCodeMutation__
 *
 * To run a mutation, you first call `useUpsertSiteSegmentationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSiteSegmentationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSiteSegmentationCodeMutation, { data, loading, error }] = useUpsertSiteSegmentationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useUpsertSiteSegmentationCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSiteSegmentationCodeMutation, UpsertSiteSegmentationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSiteSegmentationCodeMutation, UpsertSiteSegmentationCodeMutationVariables>(UpsertSiteSegmentationCodeDocument, options);
      }
export type UpsertSiteSegmentationCodeMutationHookResult = ReturnType<typeof useUpsertSiteSegmentationCodeMutation>;
export type UpsertSiteSegmentationCodeMutationResult = Apollo.MutationResult<UpsertSiteSegmentationCodeMutation>;
export type UpsertSiteSegmentationCodeMutationOptions = Apollo.BaseMutationOptions<UpsertSiteSegmentationCodeMutation, UpsertSiteSegmentationCodeMutationVariables>;
export const HcoSegmentationCodesTabQueryDocument = gql`
    query HcoSegmentationCodesTabQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    siteSegmentationCode {
      id
      heading
    }
  }
  segmentationCodes {
    hash
    nodes {
      code
      id
      description
      heading
    }
  }
}
    `;

/**
 * __useHcoSegmentationCodesTabQueryQuery__
 *
 * To run a query within a React component, call `useHcoSegmentationCodesTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHcoSegmentationCodesTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHcoSegmentationCodesTabQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useHcoSegmentationCodesTabQueryQuery(baseOptions: Apollo.QueryHookOptions<HcoSegmentationCodesTabQueryQuery, HcoSegmentationCodesTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HcoSegmentationCodesTabQueryQuery, HcoSegmentationCodesTabQueryQueryVariables>(HcoSegmentationCodesTabQueryDocument, options);
      }
export function useHcoSegmentationCodesTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HcoSegmentationCodesTabQueryQuery, HcoSegmentationCodesTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HcoSegmentationCodesTabQueryQuery, HcoSegmentationCodesTabQueryQueryVariables>(HcoSegmentationCodesTabQueryDocument, options);
        }
export type HcoSegmentationCodesTabQueryQueryHookResult = ReturnType<typeof useHcoSegmentationCodesTabQueryQuery>;
export type HcoSegmentationCodesTabQueryLazyQueryHookResult = ReturnType<typeof useHcoSegmentationCodesTabQueryLazyQuery>;
export type HcoSegmentationCodesTabQueryQueryResult = Apollo.QueryResult<HcoSegmentationCodesTabQueryQuery, HcoSegmentationCodesTabQueryQueryVariables>;
export const RemoveHcoSegmentationCodeMutationDocument = gql`
    mutation RemoveHcoSegmentationCodeMutation($id: Int!) {
  removeSiteSegmentation(id: $id) {
    id
  }
}
    `;
export type RemoveHcoSegmentationCodeMutationMutationFn = Apollo.MutationFunction<RemoveHcoSegmentationCodeMutationMutation, RemoveHcoSegmentationCodeMutationMutationVariables>;

/**
 * __useRemoveHcoSegmentationCodeMutationMutation__
 *
 * To run a mutation, you first call `useRemoveHcoSegmentationCodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHcoSegmentationCodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHcoSegmentationCodeMutationMutation, { data, loading, error }] = useRemoveHcoSegmentationCodeMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveHcoSegmentationCodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHcoSegmentationCodeMutationMutation, RemoveHcoSegmentationCodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHcoSegmentationCodeMutationMutation, RemoveHcoSegmentationCodeMutationMutationVariables>(RemoveHcoSegmentationCodeMutationDocument, options);
      }
export type RemoveHcoSegmentationCodeMutationMutationHookResult = ReturnType<typeof useRemoveHcoSegmentationCodeMutationMutation>;
export type RemoveHcoSegmentationCodeMutationMutationResult = Apollo.MutationResult<RemoveHcoSegmentationCodeMutationMutation>;
export type RemoveHcoSegmentationCodeMutationMutationOptions = Apollo.BaseMutationOptions<RemoveHcoSegmentationCodeMutationMutation, RemoveHcoSegmentationCodeMutationMutationVariables>;
export const SiteSelectionRowContainerDocument = gql`
    query SiteSelectionRowContainer($siteApureBaseID: Int!, $selectionType: SlicerSelectionType) {
  selectionImfCustomers(
    criteria: {siteApbIdInSelection: [$siteApureBaseID], selectionType: $selectionType}
  ) {
    hash
    nodes {
      code
      callName
      name
    }
  }
}
    `;

/**
 * __useSiteSelectionRowContainerQuery__
 *
 * To run a query within a React component, call `useSiteSelectionRowContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSelectionRowContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSelectionRowContainerQuery({
 *   variables: {
 *      siteApureBaseID: // value for 'siteApureBaseID'
 *      selectionType: // value for 'selectionType'
 *   },
 * });
 */
export function useSiteSelectionRowContainerQuery(baseOptions: Apollo.QueryHookOptions<SiteSelectionRowContainerQuery, SiteSelectionRowContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSelectionRowContainerQuery, SiteSelectionRowContainerQueryVariables>(SiteSelectionRowContainerDocument, options);
      }
export function useSiteSelectionRowContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSelectionRowContainerQuery, SiteSelectionRowContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSelectionRowContainerQuery, SiteSelectionRowContainerQueryVariables>(SiteSelectionRowContainerDocument, options);
        }
export type SiteSelectionRowContainerQueryHookResult = ReturnType<typeof useSiteSelectionRowContainerQuery>;
export type SiteSelectionRowContainerLazyQueryHookResult = ReturnType<typeof useSiteSelectionRowContainerLazyQuery>;
export type SiteSelectionRowContainerQueryResult = Apollo.QueryResult<SiteSelectionRowContainerQuery, SiteSelectionRowContainerQueryVariables>;
export const SiteSpecialityQueryDocument = gql`
    query SiteSpecialityQuery($countries: [CountryCode!], $search: String) {
  siteSpecialties(
    criteria: {label: $search, countries: $countries, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSiteSpecialityQueryQuery__
 *
 * To run a query within a React component, call `useSiteSpecialityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSpecialityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSpecialityQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSiteSpecialityQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteSpecialityQueryQuery, SiteSpecialityQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSpecialityQueryQuery, SiteSpecialityQueryQueryVariables>(SiteSpecialityQueryDocument, options);
      }
export function useSiteSpecialityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSpecialityQueryQuery, SiteSpecialityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSpecialityQueryQuery, SiteSpecialityQueryQueryVariables>(SiteSpecialityQueryDocument, options);
        }
export type SiteSpecialityQueryQueryHookResult = ReturnType<typeof useSiteSpecialityQueryQuery>;
export type SiteSpecialityQueryLazyQueryHookResult = ReturnType<typeof useSiteSpecialityQueryLazyQuery>;
export type SiteSpecialityQueryQueryResult = Apollo.QueryResult<SiteSpecialityQueryQuery, SiteSpecialityQueryQueryVariables>;
export const SetActiveStatusSiteDocument = gql`
    mutation SetActiveStatusSite($siteId: Int!, $isActive: Boolean!) {
  setSiteActiveStatus(siteId: $siteId, isActive: $isActive) {
    id
    isActive
  }
}
    `;
export type SetActiveStatusSiteMutationFn = Apollo.MutationFunction<SetActiveStatusSiteMutation, SetActiveStatusSiteMutationVariables>;

/**
 * __useSetActiveStatusSiteMutation__
 *
 * To run a mutation, you first call `useSetActiveStatusSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveStatusSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveStatusSiteMutation, { data, loading, error }] = useSetActiveStatusSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useSetActiveStatusSiteMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveStatusSiteMutation, SetActiveStatusSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveStatusSiteMutation, SetActiveStatusSiteMutationVariables>(SetActiveStatusSiteDocument, options);
      }
export type SetActiveStatusSiteMutationHookResult = ReturnType<typeof useSetActiveStatusSiteMutation>;
export type SetActiveStatusSiteMutationResult = Apollo.MutationResult<SetActiveStatusSiteMutation>;
export type SetActiveStatusSiteMutationOptions = Apollo.BaseMutationOptions<SetActiveStatusSiteMutation, SetActiveStatusSiteMutationVariables>;
export const InactivateSiteLinkDocument = gql`
    mutation InactivateSiteLink($linkId: Int!) {
  setSitePersonActiveStatus(id: $linkId, isActive: false) {
    id
    isActive
    site {
      id
      affiliations {
        hash
        totalCount
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type InactivateSiteLinkMutationFn = Apollo.MutationFunction<InactivateSiteLinkMutation, InactivateSiteLinkMutationVariables>;

/**
 * __useInactivateSiteLinkMutation__
 *
 * To run a mutation, you first call `useInactivateSiteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateSiteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateSiteLinkMutation, { data, loading, error }] = useInactivateSiteLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useInactivateSiteLinkMutation(baseOptions?: Apollo.MutationHookOptions<InactivateSiteLinkMutation, InactivateSiteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateSiteLinkMutation, InactivateSiteLinkMutationVariables>(InactivateSiteLinkDocument, options);
      }
export type InactivateSiteLinkMutationHookResult = ReturnType<typeof useInactivateSiteLinkMutation>;
export type InactivateSiteLinkMutationResult = Apollo.MutationResult<InactivateSiteLinkMutation>;
export type InactivateSiteLinkMutationOptions = Apollo.BaseMutationOptions<InactivateSiteLinkMutation, InactivateSiteLinkMutationVariables>;
export const InactivateSiteActionDocument = gql`
    query InactivateSiteAction($siteId: Int!) {
  site(siteId: $siteId) {
    id
    isActive
    maintainerSourceCode
    mergeRequests {
      hash
      totalCount
    }
    affiliations {
      hash
      totalCount
      nodes {
        id
      }
    }
  }
}
    `;

/**
 * __useInactivateSiteActionQuery__
 *
 * To run a query within a React component, call `useInactivateSiteActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactivateSiteActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactivateSiteActionQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useInactivateSiteActionQuery(baseOptions: Apollo.QueryHookOptions<InactivateSiteActionQuery, InactivateSiteActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactivateSiteActionQuery, InactivateSiteActionQueryVariables>(InactivateSiteActionDocument, options);
      }
export function useInactivateSiteActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactivateSiteActionQuery, InactivateSiteActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactivateSiteActionQuery, InactivateSiteActionQueryVariables>(InactivateSiteActionDocument, options);
        }
export type InactivateSiteActionQueryHookResult = ReturnType<typeof useInactivateSiteActionQuery>;
export type InactivateSiteActionLazyQueryHookResult = ReturnType<typeof useInactivateSiteActionLazyQuery>;
export type InactivateSiteActionQueryResult = Apollo.QueryResult<InactivateSiteActionQuery, InactivateSiteActionQueryVariables>;
export const CreateSiteDataQueryDocument = gql`
    query CreateSiteDataQuery {
  canICreate(entityType: SITE)
}
    `;

/**
 * __useCreateSiteDataQueryQuery__
 *
 * To run a query within a React component, call `useCreateSiteDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateSiteDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateSiteDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<CreateSiteDataQueryQuery, CreateSiteDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateSiteDataQueryQuery, CreateSiteDataQueryQueryVariables>(CreateSiteDataQueryDocument, options);
      }
export function useCreateSiteDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateSiteDataQueryQuery, CreateSiteDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateSiteDataQueryQuery, CreateSiteDataQueryQueryVariables>(CreateSiteDataQueryDocument, options);
        }
export type CreateSiteDataQueryQueryHookResult = ReturnType<typeof useCreateSiteDataQueryQuery>;
export type CreateSiteDataQueryLazyQueryHookResult = ReturnType<typeof useCreateSiteDataQueryLazyQuery>;
export type CreateSiteDataQueryQueryResult = Apollo.QueryResult<CreateSiteDataQueryQuery, CreateSiteDataQueryQueryVariables>;
export const TotalAddressTypeQueryDocument = gql`
    query TotalAddressTypeQuery($entityType: EntityTypeEnum) {
  addressTypes(criteria: {entityType: $entityType}) {
    hash
    totalCount
  }
}
    `;

/**
 * __useTotalAddressTypeQueryQuery__
 *
 * To run a query within a React component, call `useTotalAddressTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalAddressTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalAddressTypeQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useTotalAddressTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<TotalAddressTypeQueryQuery, TotalAddressTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalAddressTypeQueryQuery, TotalAddressTypeQueryQueryVariables>(TotalAddressTypeQueryDocument, options);
      }
export function useTotalAddressTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalAddressTypeQueryQuery, TotalAddressTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalAddressTypeQueryQuery, TotalAddressTypeQueryQueryVariables>(TotalAddressTypeQueryDocument, options);
        }
export type TotalAddressTypeQueryQueryHookResult = ReturnType<typeof useTotalAddressTypeQueryQuery>;
export type TotalAddressTypeQueryLazyQueryHookResult = ReturnType<typeof useTotalAddressTypeQueryLazyQuery>;
export type TotalAddressTypeQueryQueryResult = Apollo.QueryResult<TotalAddressTypeQueryQuery, TotalAddressTypeQueryQueryVariables>;
export const CreateSiteMutationDocument = gql`
    mutation CreateSiteMutation($input: SiteInput!) {
  createSite(input: $input) {
    site {
      id
      name
    }
    dcrGroup {
      id
      currentResponseCode
    }
  }
}
    `;
export type CreateSiteMutationMutationFn = Apollo.MutationFunction<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>;

/**
 * __useCreateSiteMutationMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutationMutation, { data, loading, error }] = useCreateSiteMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>(CreateSiteMutationDocument, options);
      }
export type CreateSiteMutationMutationHookResult = ReturnType<typeof useCreateSiteMutationMutation>;
export type CreateSiteMutationMutationResult = Apollo.MutationResult<CreateSiteMutationMutation>;
export type CreateSiteMutationMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>;
export const EntityCustomFieldConfigQueryDocument = gql`
    query EntityCustomFieldConfigQuery($entityType: EntityTypeEnum!) {
  customFields(criteria: {entityType: $entityType}) {
    hash
    nodes {
      allowMultiple
      code
      label: heading
    }
  }
}
    `;

/**
 * __useEntityCustomFieldConfigQueryQuery__
 *
 * To run a query within a React component, call `useEntityCustomFieldConfigQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCustomFieldConfigQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCustomFieldConfigQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityCustomFieldConfigQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityCustomFieldConfigQueryQuery, EntityCustomFieldConfigQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCustomFieldConfigQueryQuery, EntityCustomFieldConfigQueryQueryVariables>(EntityCustomFieldConfigQueryDocument, options);
      }
export function useEntityCustomFieldConfigQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCustomFieldConfigQueryQuery, EntityCustomFieldConfigQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCustomFieldConfigQueryQuery, EntityCustomFieldConfigQueryQueryVariables>(EntityCustomFieldConfigQueryDocument, options);
        }
export type EntityCustomFieldConfigQueryQueryHookResult = ReturnType<typeof useEntityCustomFieldConfigQueryQuery>;
export type EntityCustomFieldConfigQueryLazyQueryHookResult = ReturnType<typeof useEntityCustomFieldConfigQueryLazyQuery>;
export type EntityCustomFieldConfigQueryQueryResult = Apollo.QueryResult<EntityCustomFieldConfigQueryQuery, EntityCustomFieldConfigQueryQueryVariables>;
export const GetFieldTypeQueryDocument = gql`
    query GetFieldTypeQuery($code: String!) {
  customField(code: $code) {
    code
    fieldType {
      code
      enum
    }
  }
}
    `;

/**
 * __useGetFieldTypeQueryQuery__
 *
 * To run a query within a React component, call `useGetFieldTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldTypeQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetFieldTypeQueryQuery(baseOptions: Apollo.QueryHookOptions<GetFieldTypeQueryQuery, GetFieldTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFieldTypeQueryQuery, GetFieldTypeQueryQueryVariables>(GetFieldTypeQueryDocument, options);
      }
export function useGetFieldTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFieldTypeQueryQuery, GetFieldTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFieldTypeQueryQuery, GetFieldTypeQueryQueryVariables>(GetFieldTypeQueryDocument, options);
        }
export type GetFieldTypeQueryQueryHookResult = ReturnType<typeof useGetFieldTypeQueryQuery>;
export type GetFieldTypeQueryLazyQueryHookResult = ReturnType<typeof useGetFieldTypeQueryLazyQuery>;
export type GetFieldTypeQueryQueryResult = Apollo.QueryResult<GetFieldTypeQueryQuery, GetFieldTypeQueryQueryVariables>;
export const CustomFieldRuleQueryDocument = gql`
    query CustomFieldRuleQuery($code: String!) {
  customField(code: $code) {
    myAccessRules {
      id
      allowMutation
      allowRead
    }
  }
}
    `;

/**
 * __useCustomFieldRuleQueryQuery__
 *
 * To run a query within a React component, call `useCustomFieldRuleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomFieldRuleQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomFieldRuleQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCustomFieldRuleQueryQuery(baseOptions: Apollo.QueryHookOptions<CustomFieldRuleQueryQuery, CustomFieldRuleQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomFieldRuleQueryQuery, CustomFieldRuleQueryQueryVariables>(CustomFieldRuleQueryDocument, options);
      }
export function useCustomFieldRuleQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomFieldRuleQueryQuery, CustomFieldRuleQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomFieldRuleQueryQuery, CustomFieldRuleQueryQueryVariables>(CustomFieldRuleQueryDocument, options);
        }
export type CustomFieldRuleQueryQueryHookResult = ReturnType<typeof useCustomFieldRuleQueryQuery>;
export type CustomFieldRuleQueryLazyQueryHookResult = ReturnType<typeof useCustomFieldRuleQueryLazyQuery>;
export type CustomFieldRuleQueryQueryResult = Apollo.QueryResult<CustomFieldRuleQueryQuery, CustomFieldRuleQueryQueryVariables>;
export const ExternalIdTypesForFieldQueryDocument = gql`
    query ExternalIdTypesForFieldQuery($entityType: EntityTypeEnum!) {
  externalIdTypes(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      heading
      isHeadingKey
      id
    }
  }
}
    `;

/**
 * __useExternalIdTypesForFieldQueryQuery__
 *
 * To run a query within a React component, call `useExternalIdTypesForFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdTypesForFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdTypesForFieldQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useExternalIdTypesForFieldQueryQuery(baseOptions: Apollo.QueryHookOptions<ExternalIdTypesForFieldQueryQuery, ExternalIdTypesForFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdTypesForFieldQueryQuery, ExternalIdTypesForFieldQueryQueryVariables>(ExternalIdTypesForFieldQueryDocument, options);
      }
export function useExternalIdTypesForFieldQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdTypesForFieldQueryQuery, ExternalIdTypesForFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdTypesForFieldQueryQuery, ExternalIdTypesForFieldQueryQueryVariables>(ExternalIdTypesForFieldQueryDocument, options);
        }
export type ExternalIdTypesForFieldQueryQueryHookResult = ReturnType<typeof useExternalIdTypesForFieldQueryQuery>;
export type ExternalIdTypesForFieldQueryLazyQueryHookResult = ReturnType<typeof useExternalIdTypesForFieldQueryLazyQuery>;
export type ExternalIdTypesForFieldQueryQueryResult = Apollo.QueryResult<ExternalIdTypesForFieldQueryQuery, ExternalIdTypesForFieldQueryQueryVariables>;
export const ExternalIdRuleQueryDocument = gql`
    query ExternalIdRuleQuery($typeCode: String!, $roleId: ID!) {
  externalIdTypeRoles(criteria: {typeCode: $typeCode, roleId: $roleId}) {
    hash
    nodes {
      id
      type {
        code
        controlSetting {
          id
          createDcr
        }
        rules {
          key
          allowRead
          allowMutation
        }
      }
    }
  }
}
    `;

/**
 * __useExternalIdRuleQueryQuery__
 *
 * To run a query within a React component, call `useExternalIdRuleQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdRuleQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdRuleQueryQuery({
 *   variables: {
 *      typeCode: // value for 'typeCode'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useExternalIdRuleQueryQuery(baseOptions: Apollo.QueryHookOptions<ExternalIdRuleQueryQuery, ExternalIdRuleQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdRuleQueryQuery, ExternalIdRuleQueryQueryVariables>(ExternalIdRuleQueryDocument, options);
      }
export function useExternalIdRuleQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdRuleQueryQuery, ExternalIdRuleQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdRuleQueryQuery, ExternalIdRuleQueryQueryVariables>(ExternalIdRuleQueryDocument, options);
        }
export type ExternalIdRuleQueryQueryHookResult = ReturnType<typeof useExternalIdRuleQueryQuery>;
export type ExternalIdRuleQueryLazyQueryHookResult = ReturnType<typeof useExternalIdRuleQueryLazyQuery>;
export type ExternalIdRuleQueryQueryResult = Apollo.QueryResult<ExternalIdRuleQueryQuery, ExternalIdRuleQueryQueryVariables>;
export const UpdateExternalIdValueDocument = gql`
    mutation UpdateExternalIdValue($input: ExternalIdMutationInput!) {
  setExternalId(input: $input) {
    id
  }
}
    `;
export type UpdateExternalIdValueMutationFn = Apollo.MutationFunction<UpdateExternalIdValueMutation, UpdateExternalIdValueMutationVariables>;

/**
 * __useUpdateExternalIdValueMutation__
 *
 * To run a mutation, you first call `useUpdateExternalIdValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExternalIdValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExternalIdValueMutation, { data, loading, error }] = useUpdateExternalIdValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExternalIdValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExternalIdValueMutation, UpdateExternalIdValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExternalIdValueMutation, UpdateExternalIdValueMutationVariables>(UpdateExternalIdValueDocument, options);
      }
export type UpdateExternalIdValueMutationHookResult = ReturnType<typeof useUpdateExternalIdValueMutation>;
export type UpdateExternalIdValueMutationResult = Apollo.MutationResult<UpdateExternalIdValueMutation>;
export type UpdateExternalIdValueMutationOptions = Apollo.BaseMutationOptions<UpdateExternalIdValueMutation, UpdateExternalIdValueMutationVariables>;
export const RemoveExternalIdValueDocument = gql`
    mutation RemoveExternalIdValue($input: Int!) {
  removeExternalId(externalIdId: $input) {
    id
  }
}
    `;
export type RemoveExternalIdValueMutationFn = Apollo.MutationFunction<RemoveExternalIdValueMutation, RemoveExternalIdValueMutationVariables>;

/**
 * __useRemoveExternalIdValueMutation__
 *
 * To run a mutation, you first call `useRemoveExternalIdValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveExternalIdValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeExternalIdValueMutation, { data, loading, error }] = useRemoveExternalIdValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveExternalIdValueMutation(baseOptions?: Apollo.MutationHookOptions<RemoveExternalIdValueMutation, RemoveExternalIdValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveExternalIdValueMutation, RemoveExternalIdValueMutationVariables>(RemoveExternalIdValueDocument, options);
      }
export type RemoveExternalIdValueMutationHookResult = ReturnType<typeof useRemoveExternalIdValueMutation>;
export type RemoveExternalIdValueMutationResult = Apollo.MutationResult<RemoveExternalIdValueMutation>;
export type RemoveExternalIdValueMutationOptions = Apollo.BaseMutationOptions<RemoveExternalIdValueMutation, RemoveExternalIdValueMutationVariables>;
export const ExternalIdControlDocument = gql`
    query ExternalIdControl($externalIdTypeCode: String!) {
  externalIdType(code: $externalIdTypeCode) {
    id
    code
    controlSetting {
      id
      createDcr
    }
  }
}
    `;

/**
 * __useExternalIdControlQuery__
 *
 * To run a query within a React component, call `useExternalIdControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalIdControlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalIdControlQuery({
 *   variables: {
 *      externalIdTypeCode: // value for 'externalIdTypeCode'
 *   },
 * });
 */
export function useExternalIdControlQuery(baseOptions: Apollo.QueryHookOptions<ExternalIdControlQuery, ExternalIdControlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalIdControlQuery, ExternalIdControlQueryVariables>(ExternalIdControlDocument, options);
      }
export function useExternalIdControlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalIdControlQuery, ExternalIdControlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalIdControlQuery, ExternalIdControlQueryVariables>(ExternalIdControlDocument, options);
        }
export type ExternalIdControlQueryHookResult = ReturnType<typeof useExternalIdControlQuery>;
export type ExternalIdControlLazyQueryHookResult = ReturnType<typeof useExternalIdControlLazyQuery>;
export type ExternalIdControlQueryResult = Apollo.QueryResult<ExternalIdControlQuery, ExternalIdControlQueryVariables>;
export const DuplicateExternalIDQueryDocument = gql`
    query DuplicateExternalIDQuery($typeId: ID!, $entityAffiliationId: ID!, $externalId: String!) {
  validateExternalId(
    typeId: $typeId
    entityAffiliationId: $entityAffiliationId
    externalId: $externalId
  ) {
    errorMessage
    isOk
  }
}
    `;

/**
 * __useDuplicateExternalIDQueryQuery__
 *
 * To run a query within a React component, call `useDuplicateExternalIDQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateExternalIDQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateExternalIDQueryQuery({
 *   variables: {
 *      typeId: // value for 'typeId'
 *      entityAffiliationId: // value for 'entityAffiliationId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useDuplicateExternalIDQueryQuery(baseOptions: Apollo.QueryHookOptions<DuplicateExternalIDQueryQuery, DuplicateExternalIDQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateExternalIDQueryQuery, DuplicateExternalIDQueryQueryVariables>(DuplicateExternalIDQueryDocument, options);
      }
export function useDuplicateExternalIDQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateExternalIDQueryQuery, DuplicateExternalIDQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateExternalIDQueryQuery, DuplicateExternalIDQueryQueryVariables>(DuplicateExternalIDQueryDocument, options);
        }
export type DuplicateExternalIDQueryQueryHookResult = ReturnType<typeof useDuplicateExternalIDQueryQuery>;
export type DuplicateExternalIDQueryLazyQueryHookResult = ReturnType<typeof useDuplicateExternalIDQueryLazyQuery>;
export type DuplicateExternalIDQueryQueryResult = Apollo.QueryResult<DuplicateExternalIDQueryQuery, DuplicateExternalIDQueryQueryVariables>;
export const EntityCustomFieldCheckableOptionsQueryDocument = gql`
    query EntityCustomFieldCheckableOptionsQuery($code: String!) {
  customField(code: $code) {
    isCheckableTag
    options {
      hash
      nodes {
        id
        value {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useEntityCustomFieldCheckableOptionsQueryQuery__
 *
 * To run a query within a React component, call `useEntityCustomFieldCheckableOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCustomFieldCheckableOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCustomFieldCheckableOptionsQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEntityCustomFieldCheckableOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityCustomFieldCheckableOptionsQueryQuery, EntityCustomFieldCheckableOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCustomFieldCheckableOptionsQueryQuery, EntityCustomFieldCheckableOptionsQueryQueryVariables>(EntityCustomFieldCheckableOptionsQueryDocument, options);
      }
export function useEntityCustomFieldCheckableOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCustomFieldCheckableOptionsQueryQuery, EntityCustomFieldCheckableOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCustomFieldCheckableOptionsQueryQuery, EntityCustomFieldCheckableOptionsQueryQueryVariables>(EntityCustomFieldCheckableOptionsQueryDocument, options);
        }
export type EntityCustomFieldCheckableOptionsQueryQueryHookResult = ReturnType<typeof useEntityCustomFieldCheckableOptionsQueryQuery>;
export type EntityCustomFieldCheckableOptionsQueryLazyQueryHookResult = ReturnType<typeof useEntityCustomFieldCheckableOptionsQueryLazyQuery>;
export type EntityCustomFieldCheckableOptionsQueryQueryResult = Apollo.QueryResult<EntityCustomFieldCheckableOptionsQueryQuery, EntityCustomFieldCheckableOptionsQueryQueryVariables>;
export const EntityRadioCustomFieldCheckableOptionsQueryDocument = gql`
    query EntityRadioCustomFieldCheckableOptionsQuery($code: String!) {
  customField(code: $code) {
    isCheckableTag
    options {
      hash
      nodes {
        id
        value {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useEntityRadioCustomFieldCheckableOptionsQueryQuery__
 *
 * To run a query within a React component, call `useEntityRadioCustomFieldCheckableOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRadioCustomFieldCheckableOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRadioCustomFieldCheckableOptionsQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEntityRadioCustomFieldCheckableOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityRadioCustomFieldCheckableOptionsQueryQuery, EntityRadioCustomFieldCheckableOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRadioCustomFieldCheckableOptionsQueryQuery, EntityRadioCustomFieldCheckableOptionsQueryQueryVariables>(EntityRadioCustomFieldCheckableOptionsQueryDocument, options);
      }
export function useEntityRadioCustomFieldCheckableOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRadioCustomFieldCheckableOptionsQueryQuery, EntityRadioCustomFieldCheckableOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRadioCustomFieldCheckableOptionsQueryQuery, EntityRadioCustomFieldCheckableOptionsQueryQueryVariables>(EntityRadioCustomFieldCheckableOptionsQueryDocument, options);
        }
export type EntityRadioCustomFieldCheckableOptionsQueryQueryHookResult = ReturnType<typeof useEntityRadioCustomFieldCheckableOptionsQueryQuery>;
export type EntityRadioCustomFieldCheckableOptionsQueryLazyQueryHookResult = ReturnType<typeof useEntityRadioCustomFieldCheckableOptionsQueryLazyQuery>;
export type EntityRadioCustomFieldCheckableOptionsQueryQueryResult = Apollo.QueryResult<EntityRadioCustomFieldCheckableOptionsQueryQuery, EntityRadioCustomFieldCheckableOptionsQueryQueryVariables>;
export const EntityCustomFieldTagOptionsQueryDocument = gql`
    query EntityCustomFieldTagOptionsQuery($code: String!) {
  customField(code: $code) {
    color
    options {
      hash
      nodes {
        id
        value {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useEntityCustomFieldTagOptionsQueryQuery__
 *
 * To run a query within a React component, call `useEntityCustomFieldTagOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCustomFieldTagOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCustomFieldTagOptionsQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEntityCustomFieldTagOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityCustomFieldTagOptionsQueryQuery, EntityCustomFieldTagOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCustomFieldTagOptionsQueryQuery, EntityCustomFieldTagOptionsQueryQueryVariables>(EntityCustomFieldTagOptionsQueryDocument, options);
      }
export function useEntityCustomFieldTagOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCustomFieldTagOptionsQueryQuery, EntityCustomFieldTagOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCustomFieldTagOptionsQueryQuery, EntityCustomFieldTagOptionsQueryQueryVariables>(EntityCustomFieldTagOptionsQueryDocument, options);
        }
export type EntityCustomFieldTagOptionsQueryQueryHookResult = ReturnType<typeof useEntityCustomFieldTagOptionsQueryQuery>;
export type EntityCustomFieldTagOptionsQueryLazyQueryHookResult = ReturnType<typeof useEntityCustomFieldTagOptionsQueryLazyQuery>;
export type EntityCustomFieldTagOptionsQueryQueryResult = Apollo.QueryResult<EntityCustomFieldTagOptionsQueryQuery, EntityCustomFieldTagOptionsQueryQueryVariables>;
export const UpsertCustomFieldInputValueDocument = gql`
    mutation UpsertCustomFieldInputValue($customFieldCode: String!, $customValues: [UpdateSelectCustomFieldValueForRecord!]!, $recordId: Int!) {
  setCustomLinkValues(
    customFieldCode: $customFieldCode
    customValues: $customValues
    recordId: $recordId
  ) {
    customFieldCode
  }
}
    `;
export type UpsertCustomFieldInputValueMutationFn = Apollo.MutationFunction<UpsertCustomFieldInputValueMutation, UpsertCustomFieldInputValueMutationVariables>;

/**
 * __useUpsertCustomFieldInputValueMutation__
 *
 * To run a mutation, you first call `useUpsertCustomFieldInputValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomFieldInputValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomFieldInputValueMutation, { data, loading, error }] = useUpsertCustomFieldInputValueMutation({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *      customValues: // value for 'customValues'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useUpsertCustomFieldInputValueMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCustomFieldInputValueMutation, UpsertCustomFieldInputValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCustomFieldInputValueMutation, UpsertCustomFieldInputValueMutationVariables>(UpsertCustomFieldInputValueDocument, options);
      }
export type UpsertCustomFieldInputValueMutationHookResult = ReturnType<typeof useUpsertCustomFieldInputValueMutation>;
export type UpsertCustomFieldInputValueMutationResult = Apollo.MutationResult<UpsertCustomFieldInputValueMutation>;
export type UpsertCustomFieldInputValueMutationOptions = Apollo.BaseMutationOptions<UpsertCustomFieldInputValueMutation, UpsertCustomFieldInputValueMutationVariables>;
export const RemoveCustomFieldInputValueDocument = gql`
    mutation RemoveCustomFieldInputValue($customValues: [ID!]!) {
  removeCustomLinkValues(customLinkValueIds: $customValues)
}
    `;
export type RemoveCustomFieldInputValueMutationFn = Apollo.MutationFunction<RemoveCustomFieldInputValueMutation, RemoveCustomFieldInputValueMutationVariables>;

/**
 * __useRemoveCustomFieldInputValueMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldInputValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldInputValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldInputValueMutation, { data, loading, error }] = useRemoveCustomFieldInputValueMutation({
 *   variables: {
 *      customValues: // value for 'customValues'
 *   },
 * });
 */
export function useRemoveCustomFieldInputValueMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldInputValueMutation, RemoveCustomFieldInputValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldInputValueMutation, RemoveCustomFieldInputValueMutationVariables>(RemoveCustomFieldInputValueDocument, options);
      }
export type RemoveCustomFieldInputValueMutationHookResult = ReturnType<typeof useRemoveCustomFieldInputValueMutation>;
export type RemoveCustomFieldInputValueMutationResult = Apollo.MutationResult<RemoveCustomFieldInputValueMutation>;
export type RemoveCustomFieldInputValueMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldInputValueMutation, RemoveCustomFieldInputValueMutationVariables>;
export const EntityCustomFieldOptionsQueryDocument = gql`
    query EntityCustomFieldOptionsQuery($code: String!) {
  customField(code: $code) {
    options {
      hash
      nodes {
        id
        value {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useEntityCustomFieldOptionsQueryQuery__
 *
 * To run a query within a React component, call `useEntityCustomFieldOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCustomFieldOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCustomFieldOptionsQueryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEntityCustomFieldOptionsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityCustomFieldOptionsQueryQuery, EntityCustomFieldOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCustomFieldOptionsQueryQuery, EntityCustomFieldOptionsQueryQueryVariables>(EntityCustomFieldOptionsQueryDocument, options);
      }
export function useEntityCustomFieldOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCustomFieldOptionsQueryQuery, EntityCustomFieldOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCustomFieldOptionsQueryQuery, EntityCustomFieldOptionsQueryQueryVariables>(EntityCustomFieldOptionsQueryDocument, options);
        }
export type EntityCustomFieldOptionsQueryQueryHookResult = ReturnType<typeof useEntityCustomFieldOptionsQueryQuery>;
export type EntityCustomFieldOptionsQueryLazyQueryHookResult = ReturnType<typeof useEntityCustomFieldOptionsQueryLazyQuery>;
export type EntityCustomFieldOptionsQueryQueryResult = Apollo.QueryResult<EntityCustomFieldOptionsQueryQuery, EntityCustomFieldOptionsQueryQueryVariables>;
export const UpdateSiteAddressMutationDocument = gql`
    mutation UpdateSiteAddressMutation($existingAffiliationId: Int, $siteId: Int!, $addressInput: AddressInput!) {
  updateOrCreateAddress(
    addressAffiliationId: $existingAffiliationId
    entityType: SITE
    entityAffiliationId: $siteId
    addressInput: $addressInput
  ) {
    id
  }
}
    `;
export type UpdateSiteAddressMutationMutationFn = Apollo.MutationFunction<UpdateSiteAddressMutationMutation, UpdateSiteAddressMutationMutationVariables>;

/**
 * __useUpdateSiteAddressMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteAddressMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteAddressMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteAddressMutationMutation, { data, loading, error }] = useUpdateSiteAddressMutationMutation({
 *   variables: {
 *      existingAffiliationId: // value for 'existingAffiliationId'
 *      siteId: // value for 'siteId'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useUpdateSiteAddressMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteAddressMutationMutation, UpdateSiteAddressMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteAddressMutationMutation, UpdateSiteAddressMutationMutationVariables>(UpdateSiteAddressMutationDocument, options);
      }
export type UpdateSiteAddressMutationMutationHookResult = ReturnType<typeof useUpdateSiteAddressMutationMutation>;
export type UpdateSiteAddressMutationMutationResult = Apollo.MutationResult<UpdateSiteAddressMutationMutation>;
export type UpdateSiteAddressMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteAddressMutationMutation, UpdateSiteAddressMutationMutationVariables>;
export const SiteAddressTypesQueryDocument = gql`
    query SiteAddressTypesQuery {
  addressTypes(criteria: {entityType: SITE}) {
    hash
    nodes {
      code
      headingKey
    }
  }
}
    `;

/**
 * __useSiteAddressTypesQueryQuery__
 *
 * To run a query within a React component, call `useSiteAddressTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteAddressTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteAddressTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteAddressTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteAddressTypesQueryQuery, SiteAddressTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteAddressTypesQueryQuery, SiteAddressTypesQueryQueryVariables>(SiteAddressTypesQueryDocument, options);
      }
export function useSiteAddressTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteAddressTypesQueryQuery, SiteAddressTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteAddressTypesQueryQuery, SiteAddressTypesQueryQueryVariables>(SiteAddressTypesQueryDocument, options);
        }
export type SiteAddressTypesQueryQueryHookResult = ReturnType<typeof useSiteAddressTypesQueryQuery>;
export type SiteAddressTypesQueryLazyQueryHookResult = ReturnType<typeof useSiteAddressTypesQueryLazyQuery>;
export type SiteAddressTypesQueryQueryResult = Apollo.QueryResult<SiteAddressTypesQueryQuery, SiteAddressTypesQueryQueryVariables>;
export const UpdateSiteChainMutationDocument = gql`
    mutation UpdateSiteChainMutation($siteId: Int!, $chainCode: String!) {
  updateSiteChain(siteId: $siteId, chainCode: $chainCode) {
    id {
      siteId
      chainCode
    }
  }
}
    `;
export type UpdateSiteChainMutationMutationFn = Apollo.MutationFunction<UpdateSiteChainMutationMutation, UpdateSiteChainMutationMutationVariables>;

/**
 * __useUpdateSiteChainMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteChainMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteChainMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteChainMutationMutation, { data, loading, error }] = useUpdateSiteChainMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      chainCode: // value for 'chainCode'
 *   },
 * });
 */
export function useUpdateSiteChainMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteChainMutationMutation, UpdateSiteChainMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteChainMutationMutation, UpdateSiteChainMutationMutationVariables>(UpdateSiteChainMutationDocument, options);
      }
export type UpdateSiteChainMutationMutationHookResult = ReturnType<typeof useUpdateSiteChainMutationMutation>;
export type UpdateSiteChainMutationMutationResult = Apollo.MutationResult<UpdateSiteChainMutationMutation>;
export type UpdateSiteChainMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteChainMutationMutation, UpdateSiteChainMutationMutationVariables>;
export const SelectValueChainSuggestionQueryDocument = gql`
    query SelectValueChainSuggestionQuery($search: String, $countryCode: CountryCode!) {
  valueChains(
    criteria: {label: $search, countries: [$countryCode], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectValueChainSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectValueChainSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectValueChainSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectValueChainSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSelectValueChainSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectValueChainSuggestionQueryQuery, SelectValueChainSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectValueChainSuggestionQueryQuery, SelectValueChainSuggestionQueryQueryVariables>(SelectValueChainSuggestionQueryDocument, options);
      }
export function useSelectValueChainSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectValueChainSuggestionQueryQuery, SelectValueChainSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectValueChainSuggestionQueryQuery, SelectValueChainSuggestionQueryQueryVariables>(SelectValueChainSuggestionQueryDocument, options);
        }
export type SelectValueChainSuggestionQueryQueryHookResult = ReturnType<typeof useSelectValueChainSuggestionQueryQuery>;
export type SelectValueChainSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectValueChainSuggestionQueryLazyQuery>;
export type SelectValueChainSuggestionQueryQueryResult = Apollo.QueryResult<SelectValueChainSuggestionQueryQuery, SelectValueChainSuggestionQueryQueryVariables>;
export const SelectSiteCountyQueryDocument = gql`
    query SelectSiteCountyQuery($search: String, $country: CountryCode!) {
  counties(criteria: {label: $search, countries: [$country]}) {
    hash
    nodes {
      code
      type
      label
    }
  }
}
    `;

/**
 * __useSelectSiteCountyQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteCountyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteCountyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteCountyQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSelectSiteCountyQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectSiteCountyQueryQuery, SelectSiteCountyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteCountyQueryQuery, SelectSiteCountyQueryQueryVariables>(SelectSiteCountyQueryDocument, options);
      }
export function useSelectSiteCountyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteCountyQueryQuery, SelectSiteCountyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteCountyQueryQuery, SelectSiteCountyQueryQueryVariables>(SelectSiteCountyQueryDocument, options);
        }
export type SelectSiteCountyQueryQueryHookResult = ReturnType<typeof useSelectSiteCountyQueryQuery>;
export type SelectSiteCountyQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteCountyQueryLazyQuery>;
export type SelectSiteCountyQueryQueryResult = Apollo.QueryResult<SelectSiteCountyQueryQuery, SelectSiteCountyQueryQueryVariables>;
export const UpdateAddressMutationDocument = gql`
    mutation UpdateAddressMutation($addressAffiliationId: Int!, $input: AddressInput!) {
  updateAddress(addressAffiliationId: $addressAffiliationId, input: $input) {
    id
    city
    countryCode
    countryEnum
    county {
      code
    }
    countyCode
    street
    postalCode
  }
}
    `;
export type UpdateAddressMutationMutationFn = Apollo.MutationFunction<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>;

/**
 * __useUpdateAddressMutationMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutationMutation, { data, loading, error }] = useUpdateAddressMutationMutation({
 *   variables: {
 *      addressAffiliationId: // value for 'addressAffiliationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAddressMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>(UpdateAddressMutationDocument, options);
      }
export type UpdateAddressMutationMutationHookResult = ReturnType<typeof useUpdateAddressMutationMutation>;
export type UpdateAddressMutationMutationResult = Apollo.MutationResult<UpdateAddressMutationMutation>;
export type UpdateAddressMutationMutationOptions = Apollo.BaseMutationOptions<UpdateAddressMutationMutation, UpdateAddressMutationMutationVariables>;
export const UpdateSiteName2MutationDocument = gql`
    mutation UpdateSiteName2Mutation($siteId: Int!, $siteName2: String!) {
  updateSiteName2(siteId: $siteId, siteName2: $siteName2) {
    id
    name2
  }
}
    `;
export type UpdateSiteName2MutationMutationFn = Apollo.MutationFunction<UpdateSiteName2MutationMutation, UpdateSiteName2MutationMutationVariables>;

/**
 * __useUpdateSiteName2MutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteName2MutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteName2MutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteName2MutationMutation, { data, loading, error }] = useUpdateSiteName2MutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      siteName2: // value for 'siteName2'
 *   },
 * });
 */
export function useUpdateSiteName2MutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteName2MutationMutation, UpdateSiteName2MutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteName2MutationMutation, UpdateSiteName2MutationMutationVariables>(UpdateSiteName2MutationDocument, options);
      }
export type UpdateSiteName2MutationMutationHookResult = ReturnType<typeof useUpdateSiteName2MutationMutation>;
export type UpdateSiteName2MutationMutationResult = Apollo.MutationResult<UpdateSiteName2MutationMutation>;
export type UpdateSiteName2MutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteName2MutationMutation, UpdateSiteName2MutationMutationVariables>;
export const UpdateSiteNameMutationDocument = gql`
    mutation UpdateSiteNameMutation($siteId: Int!, $siteName: String!) {
  updateSiteName(siteId: $siteId, title: $siteName) {
    id
    name
  }
}
    `;
export type UpdateSiteNameMutationMutationFn = Apollo.MutationFunction<UpdateSiteNameMutationMutation, UpdateSiteNameMutationMutationVariables>;

/**
 * __useUpdateSiteNameMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteNameMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteNameMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteNameMutationMutation, { data, loading, error }] = useUpdateSiteNameMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      siteName: // value for 'siteName'
 *   },
 * });
 */
export function useUpdateSiteNameMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteNameMutationMutation, UpdateSiteNameMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteNameMutationMutation, UpdateSiteNameMutationMutationVariables>(UpdateSiteNameMutationDocument, options);
      }
export type UpdateSiteNameMutationMutationHookResult = ReturnType<typeof useUpdateSiteNameMutationMutation>;
export type UpdateSiteNameMutationMutationResult = Apollo.MutationResult<UpdateSiteNameMutationMutation>;
export type UpdateSiteNameMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteNameMutationMutation, UpdateSiteNameMutationMutationVariables>;
export const UpdateSiteNumberOfBedsMutationDocument = gql`
    mutation UpdateSiteNumberOfBedsMutation($siteId: Int!, $beds: Int) {
  updateSiteNumberOfBeds(siteId: $siteId, numberOfBeds: $beds) {
    id
    numberOfBeds
  }
}
    `;
export type UpdateSiteNumberOfBedsMutationMutationFn = Apollo.MutationFunction<UpdateSiteNumberOfBedsMutationMutation, UpdateSiteNumberOfBedsMutationMutationVariables>;

/**
 * __useUpdateSiteNumberOfBedsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteNumberOfBedsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteNumberOfBedsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteNumberOfBedsMutationMutation, { data, loading, error }] = useUpdateSiteNumberOfBedsMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      beds: // value for 'beds'
 *   },
 * });
 */
export function useUpdateSiteNumberOfBedsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteNumberOfBedsMutationMutation, UpdateSiteNumberOfBedsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteNumberOfBedsMutationMutation, UpdateSiteNumberOfBedsMutationMutationVariables>(UpdateSiteNumberOfBedsMutationDocument, options);
      }
export type UpdateSiteNumberOfBedsMutationMutationHookResult = ReturnType<typeof useUpdateSiteNumberOfBedsMutationMutation>;
export type UpdateSiteNumberOfBedsMutationMutationResult = Apollo.MutationResult<UpdateSiteNumberOfBedsMutationMutation>;
export type UpdateSiteNumberOfBedsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteNumberOfBedsMutationMutation, UpdateSiteNumberOfBedsMutationMutationVariables>;
export const UpdateSiteNumberOfChairsMutationDocument = gql`
    mutation UpdateSiteNumberOfChairsMutation($siteId: Int!, $chairs: Int) {
  updateSiteNumberOfChairs(siteId: $siteId, numberOfChairs: $chairs) {
    id
    numberOfChairs
  }
}
    `;
export type UpdateSiteNumberOfChairsMutationMutationFn = Apollo.MutationFunction<UpdateSiteNumberOfChairsMutationMutation, UpdateSiteNumberOfChairsMutationMutationVariables>;

/**
 * __useUpdateSiteNumberOfChairsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteNumberOfChairsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteNumberOfChairsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteNumberOfChairsMutationMutation, { data, loading, error }] = useUpdateSiteNumberOfChairsMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      chairs: // value for 'chairs'
 *   },
 * });
 */
export function useUpdateSiteNumberOfChairsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteNumberOfChairsMutationMutation, UpdateSiteNumberOfChairsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteNumberOfChairsMutationMutation, UpdateSiteNumberOfChairsMutationMutationVariables>(UpdateSiteNumberOfChairsMutationDocument, options);
      }
export type UpdateSiteNumberOfChairsMutationMutationHookResult = ReturnType<typeof useUpdateSiteNumberOfChairsMutationMutation>;
export type UpdateSiteNumberOfChairsMutationMutationResult = Apollo.MutationResult<UpdateSiteNumberOfChairsMutationMutation>;
export type UpdateSiteNumberOfChairsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteNumberOfChairsMutationMutation, UpdateSiteNumberOfChairsMutationMutationVariables>;
export const SelectSiteParentSuggestionQueryDocument = gql`
    query SelectSiteParentSuggestionQuery($search: String, $countryCode: CountryCode!) {
  sites(
    criteria: {siteName: $search, countries: [$countryCode], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useSelectSiteParentSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteParentSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteParentSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteParentSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSelectSiteParentSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectSiteParentSuggestionQueryQuery, SelectSiteParentSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteParentSuggestionQueryQuery, SelectSiteParentSuggestionQueryQueryVariables>(SelectSiteParentSuggestionQueryDocument, options);
      }
export function useSelectSiteParentSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteParentSuggestionQueryQuery, SelectSiteParentSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteParentSuggestionQueryQuery, SelectSiteParentSuggestionQueryQueryVariables>(SelectSiteParentSuggestionQueryDocument, options);
        }
export type SelectSiteParentSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteParentSuggestionQueryQuery>;
export type SelectSiteParentSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteParentSuggestionQueryLazyQuery>;
export type SelectSiteParentSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteParentSuggestionQueryQuery, SelectSiteParentSuggestionQueryQueryVariables>;
export const UpdateSiteParentMutationDocument = gql`
    mutation UpdateSiteParentMutation($siteId: Int!, $parentId: Int) {
  updateSiteParentId(siteId: $siteId, parentId: $parentId) {
    id
    parentId
    parentSite {
      id
      name
    }
  }
}
    `;
export type UpdateSiteParentMutationMutationFn = Apollo.MutationFunction<UpdateSiteParentMutationMutation, UpdateSiteParentMutationMutationVariables>;

/**
 * __useUpdateSiteParentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteParentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteParentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteParentMutationMutation, { data, loading, error }] = useUpdateSiteParentMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useUpdateSiteParentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteParentMutationMutation, UpdateSiteParentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteParentMutationMutation, UpdateSiteParentMutationMutationVariables>(UpdateSiteParentMutationDocument, options);
      }
export type UpdateSiteParentMutationMutationHookResult = ReturnType<typeof useUpdateSiteParentMutationMutation>;
export type UpdateSiteParentMutationMutationResult = Apollo.MutationResult<UpdateSiteParentMutationMutation>;
export type UpdateSiteParentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteParentMutationMutation, UpdateSiteParentMutationMutationVariables>;
export const SetSiteResponsibleUserDocument = gql`
    mutation SetSiteResponsibleUser($siteId: ID!, $userId: ID) {
  setSiteResponsibleUser(siteId: $siteId, userId: $userId) {
    id
    siteId
    site {
      id
      responsibleUser {
        id
        user {
          id
          fullname
        }
      }
    }
  }
}
    `;
export type SetSiteResponsibleUserMutationFn = Apollo.MutationFunction<SetSiteResponsibleUserMutation, SetSiteResponsibleUserMutationVariables>;

/**
 * __useSetSiteResponsibleUserMutation__
 *
 * To run a mutation, you first call `useSetSiteResponsibleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSiteResponsibleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSiteResponsibleUserMutation, { data, loading, error }] = useSetSiteResponsibleUserMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetSiteResponsibleUserMutation(baseOptions?: Apollo.MutationHookOptions<SetSiteResponsibleUserMutation, SetSiteResponsibleUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSiteResponsibleUserMutation, SetSiteResponsibleUserMutationVariables>(SetSiteResponsibleUserDocument, options);
      }
export type SetSiteResponsibleUserMutationHookResult = ReturnType<typeof useSetSiteResponsibleUserMutation>;
export type SetSiteResponsibleUserMutationResult = Apollo.MutationResult<SetSiteResponsibleUserMutation>;
export type SetSiteResponsibleUserMutationOptions = Apollo.BaseMutationOptions<SetSiteResponsibleUserMutation, SetSiteResponsibleUserMutationVariables>;
export const SelectSiteResSuggestionQueryDocument = gql`
    query SelectSiteResSuggestionQuery($search: String) {
  users(criteria: {search: $search, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      id
      fullname
    }
  }
}
    `;

/**
 * __useSelectSiteResSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteResSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteResSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteResSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSelectSiteResSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectSiteResSuggestionQueryQuery, SelectSiteResSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteResSuggestionQueryQuery, SelectSiteResSuggestionQueryQueryVariables>(SelectSiteResSuggestionQueryDocument, options);
      }
export function useSelectSiteResSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteResSuggestionQueryQuery, SelectSiteResSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteResSuggestionQueryQuery, SelectSiteResSuggestionQueryQueryVariables>(SelectSiteResSuggestionQueryDocument, options);
        }
export type SelectSiteResSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteResSuggestionQueryQuery>;
export type SelectSiteResSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteResSuggestionQueryLazyQuery>;
export type SelectSiteResSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteResSuggestionQueryQuery, SelectSiteResSuggestionQueryQueryVariables>;
export const UpdateSiteSectorTypeMutationDocument = gql`
    mutation UpdateSiteSectorTypeMutation($siteId: Int!, $sectorType: String) {
  updateSiteSectorType(siteId: $siteId, siteSectorType: $sectorType) {
    id
  }
}
    `;
export type UpdateSiteSectorTypeMutationMutationFn = Apollo.MutationFunction<UpdateSiteSectorTypeMutationMutation, UpdateSiteSectorTypeMutationMutationVariables>;

/**
 * __useUpdateSiteSectorTypeMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSectorTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSectorTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSectorTypeMutationMutation, { data, loading, error }] = useUpdateSiteSectorTypeMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      sectorType: // value for 'sectorType'
 *   },
 * });
 */
export function useUpdateSiteSectorTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteSectorTypeMutationMutation, UpdateSiteSectorTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteSectorTypeMutationMutation, UpdateSiteSectorTypeMutationMutationVariables>(UpdateSiteSectorTypeMutationDocument, options);
      }
export type UpdateSiteSectorTypeMutationMutationHookResult = ReturnType<typeof useUpdateSiteSectorTypeMutationMutation>;
export type UpdateSiteSectorTypeMutationMutationResult = Apollo.MutationResult<UpdateSiteSectorTypeMutationMutation>;
export type UpdateSiteSectorTypeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteSectorTypeMutationMutation, UpdateSiteSectorTypeMutationMutationVariables>;
export const SelectSiteSegmentTypeSuggestionQueryDocument = gql`
    query SelectSiteSegmentTypeSuggestionQuery($search: String) {
  siteSectorTypes(criteria: {label: $search, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      code
      label
    }
  }
}
    `;

/**
 * __useSelectSiteSegmentTypeSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteSegmentTypeSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteSegmentTypeSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteSegmentTypeSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSelectSiteSegmentTypeSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectSiteSegmentTypeSuggestionQueryQuery, SelectSiteSegmentTypeSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteSegmentTypeSuggestionQueryQuery, SelectSiteSegmentTypeSuggestionQueryQueryVariables>(SelectSiteSegmentTypeSuggestionQueryDocument, options);
      }
export function useSelectSiteSegmentTypeSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteSegmentTypeSuggestionQueryQuery, SelectSiteSegmentTypeSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteSegmentTypeSuggestionQueryQuery, SelectSiteSegmentTypeSuggestionQueryQueryVariables>(SelectSiteSegmentTypeSuggestionQueryDocument, options);
        }
export type SelectSiteSegmentTypeSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteSegmentTypeSuggestionQueryQuery>;
export type SelectSiteSegmentTypeSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteSegmentTypeSuggestionQueryLazyQuery>;
export type SelectSiteSegmentTypeSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteSegmentTypeSuggestionQueryQuery, SelectSiteSegmentTypeSuggestionQueryQueryVariables>;
export const UpdateSiteSegmentationCodeMutationDocument = gql`
    mutation UpdateSiteSegmentationCodeMutation($siteId: Int!, $segmentCodeId: Int!) {
  upsertSiteSegmentationCode(siteId: $siteId, segmentationCodeId: $segmentCodeId) {
    id
  }
}
    `;
export type UpdateSiteSegmentationCodeMutationMutationFn = Apollo.MutationFunction<UpdateSiteSegmentationCodeMutationMutation, UpdateSiteSegmentationCodeMutationMutationVariables>;

/**
 * __useUpdateSiteSegmentationCodeMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSegmentationCodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSegmentationCodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSegmentationCodeMutationMutation, { data, loading, error }] = useUpdateSiteSegmentationCodeMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      segmentCodeId: // value for 'segmentCodeId'
 *   },
 * });
 */
export function useUpdateSiteSegmentationCodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteSegmentationCodeMutationMutation, UpdateSiteSegmentationCodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteSegmentationCodeMutationMutation, UpdateSiteSegmentationCodeMutationMutationVariables>(UpdateSiteSegmentationCodeMutationDocument, options);
      }
export type UpdateSiteSegmentationCodeMutationMutationHookResult = ReturnType<typeof useUpdateSiteSegmentationCodeMutationMutation>;
export type UpdateSiteSegmentationCodeMutationMutationResult = Apollo.MutationResult<UpdateSiteSegmentationCodeMutationMutation>;
export type UpdateSiteSegmentationCodeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteSegmentationCodeMutationMutation, UpdateSiteSegmentationCodeMutationMutationVariables>;
export const SelectSiteSegmentationCodeSuggestionQueryDocument = gql`
    query SelectSiteSegmentationCodeSuggestionQuery {
  segmentationCodes(criteria: {fetchSize: {limit: 1000}}) {
    hash
    nodes {
      id
      code
      heading
    }
  }
}
    `;

/**
 * __useSelectSiteSegmentationCodeSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteSegmentationCodeSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteSegmentationCodeSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteSegmentationCodeSuggestionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectSiteSegmentationCodeSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectSiteSegmentationCodeSuggestionQueryQuery, SelectSiteSegmentationCodeSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteSegmentationCodeSuggestionQueryQuery, SelectSiteSegmentationCodeSuggestionQueryQueryVariables>(SelectSiteSegmentationCodeSuggestionQueryDocument, options);
      }
export function useSelectSiteSegmentationCodeSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteSegmentationCodeSuggestionQueryQuery, SelectSiteSegmentationCodeSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteSegmentationCodeSuggestionQueryQuery, SelectSiteSegmentationCodeSuggestionQueryQueryVariables>(SelectSiteSegmentationCodeSuggestionQueryDocument, options);
        }
export type SelectSiteSegmentationCodeSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteSegmentationCodeSuggestionQueryQuery>;
export type SelectSiteSegmentationCodeSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteSegmentationCodeSuggestionQueryLazyQuery>;
export type SelectSiteSegmentationCodeSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteSegmentationCodeSuggestionQueryQuery, SelectSiteSegmentationCodeSuggestionQueryQueryVariables>;
export const UpdateSiteSpecialtiesMutationDocument = gql`
    mutation UpdateSiteSpecialtiesMutation($siteId: Int!, $specialties: [String!]!) {
  updateSiteSpecialties(siteId: $siteId, specialties: $specialties) {
    id {
      siteId
      siteSpecialtyCode
    }
  }
}
    `;
export type UpdateSiteSpecialtiesMutationMutationFn = Apollo.MutationFunction<UpdateSiteSpecialtiesMutationMutation, UpdateSiteSpecialtiesMutationMutationVariables>;

/**
 * __useUpdateSiteSpecialtiesMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteSpecialtiesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteSpecialtiesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteSpecialtiesMutationMutation, { data, loading, error }] = useUpdateSiteSpecialtiesMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      specialties: // value for 'specialties'
 *   },
 * });
 */
export function useUpdateSiteSpecialtiesMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteSpecialtiesMutationMutation, UpdateSiteSpecialtiesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteSpecialtiesMutationMutation, UpdateSiteSpecialtiesMutationMutationVariables>(UpdateSiteSpecialtiesMutationDocument, options);
      }
export type UpdateSiteSpecialtiesMutationMutationHookResult = ReturnType<typeof useUpdateSiteSpecialtiesMutationMutation>;
export type UpdateSiteSpecialtiesMutationMutationResult = Apollo.MutationResult<UpdateSiteSpecialtiesMutationMutation>;
export type UpdateSiteSpecialtiesMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteSpecialtiesMutationMutation, UpdateSiteSpecialtiesMutationMutationVariables>;
export const SelectSiteSpecialtiesSuggestionQueryDocument = gql`
    query SelectSiteSpecialtiesSuggestionQuery($countries: [CountryCode!]!) {
  availableSpecialties: siteSpecialties(
    criteria: {countries: $countries, fetchSize: {limit: 5000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectSiteSpecialtiesSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteSpecialtiesSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteSpecialtiesSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteSpecialtiesSuggestionQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useSelectSiteSpecialtiesSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectSiteSpecialtiesSuggestionQueryQuery, SelectSiteSpecialtiesSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteSpecialtiesSuggestionQueryQuery, SelectSiteSpecialtiesSuggestionQueryQueryVariables>(SelectSiteSpecialtiesSuggestionQueryDocument, options);
      }
export function useSelectSiteSpecialtiesSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteSpecialtiesSuggestionQueryQuery, SelectSiteSpecialtiesSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteSpecialtiesSuggestionQueryQuery, SelectSiteSpecialtiesSuggestionQueryQueryVariables>(SelectSiteSpecialtiesSuggestionQueryDocument, options);
        }
export type SelectSiteSpecialtiesSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteSpecialtiesSuggestionQueryQuery>;
export type SelectSiteSpecialtiesSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteSpecialtiesSuggestionQueryLazyQuery>;
export type SelectSiteSpecialtiesSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteSpecialtiesSuggestionQueryQuery, SelectSiteSpecialtiesSuggestionQueryQueryVariables>;
export const UpdateSiteTypeMutationDocument = gql`
    mutation UpdateSiteTypeMutation($siteId: Int!, $typeCode: String) {
  updateSiteTypeCode(siteId: $siteId, typeCode: $typeCode) {
    id
  }
}
    `;
export type UpdateSiteTypeMutationMutationFn = Apollo.MutationFunction<UpdateSiteTypeMutationMutation, UpdateSiteTypeMutationMutationVariables>;

/**
 * __useUpdateSiteTypeMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteTypeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteTypeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteTypeMutationMutation, { data, loading, error }] = useUpdateSiteTypeMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      typeCode: // value for 'typeCode'
 *   },
 * });
 */
export function useUpdateSiteTypeMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteTypeMutationMutation, UpdateSiteTypeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteTypeMutationMutation, UpdateSiteTypeMutationMutationVariables>(UpdateSiteTypeMutationDocument, options);
      }
export type UpdateSiteTypeMutationMutationHookResult = ReturnType<typeof useUpdateSiteTypeMutationMutation>;
export type UpdateSiteTypeMutationMutationResult = Apollo.MutationResult<UpdateSiteTypeMutationMutation>;
export type UpdateSiteTypeMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteTypeMutationMutation, UpdateSiteTypeMutationMutationVariables>;
export const SelectSiteTypeSuggestionQueryDocument = gql`
    query SelectSiteTypeSuggestionQuery($search: String, $country: CountryCode!) {
  siteTypes(
    criteria: {country: $country, label: $search, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectSiteTypeSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteTypeSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteTypeSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteTypeSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useSelectSiteTypeSuggestionQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectSiteTypeSuggestionQueryQuery, SelectSiteTypeSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteTypeSuggestionQueryQuery, SelectSiteTypeSuggestionQueryQueryVariables>(SelectSiteTypeSuggestionQueryDocument, options);
      }
export function useSelectSiteTypeSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteTypeSuggestionQueryQuery, SelectSiteTypeSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteTypeSuggestionQueryQuery, SelectSiteTypeSuggestionQueryQueryVariables>(SelectSiteTypeSuggestionQueryDocument, options);
        }
export type SelectSiteTypeSuggestionQueryQueryHookResult = ReturnType<typeof useSelectSiteTypeSuggestionQueryQuery>;
export type SelectSiteTypeSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteTypeSuggestionQueryLazyQuery>;
export type SelectSiteTypeSuggestionQueryQueryResult = Apollo.QueryResult<SelectSiteTypeSuggestionQueryQuery, SelectSiteTypeSuggestionQueryQueryVariables>;
export const UpdateSiteWebsiteMutationDocument = gql`
    mutation UpdateSiteWebsiteMutation($siteId: Int!, $webpage: String!) {
  updateSiteWebpage(siteId: $siteId, webpage: $webpage) {
    id
    siteWebpage
  }
}
    `;
export type UpdateSiteWebsiteMutationMutationFn = Apollo.MutationFunction<UpdateSiteWebsiteMutationMutation, UpdateSiteWebsiteMutationMutationVariables>;

/**
 * __useUpdateSiteWebsiteMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteWebsiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteWebsiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteWebsiteMutationMutation, { data, loading, error }] = useUpdateSiteWebsiteMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      webpage: // value for 'webpage'
 *   },
 * });
 */
export function useUpdateSiteWebsiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteWebsiteMutationMutation, UpdateSiteWebsiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteWebsiteMutationMutation, UpdateSiteWebsiteMutationMutationVariables>(UpdateSiteWebsiteMutationDocument, options);
      }
export type UpdateSiteWebsiteMutationMutationHookResult = ReturnType<typeof useUpdateSiteWebsiteMutationMutation>;
export type UpdateSiteWebsiteMutationMutationResult = Apollo.MutationResult<UpdateSiteWebsiteMutationMutation>;
export type UpdateSiteWebsiteMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteWebsiteMutationMutation, UpdateSiteWebsiteMutationMutationVariables>;
export const FindHcpAffiliationsDocument = gql`
    query FindHcpAffiliations($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
    affiliations {
      totalCount
      nodes {
        id
        person {
          id
          fullName
          title
          persType {
            type
            code
            label
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindHcpAffiliationsQuery__
 *
 * To run a query within a React component, call `useFindHcpAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindHcpAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindHcpAffiliationsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useFindHcpAffiliationsQuery(baseOptions: Apollo.QueryHookOptions<FindHcpAffiliationsQuery, FindHcpAffiliationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindHcpAffiliationsQuery, FindHcpAffiliationsQueryVariables>(FindHcpAffiliationsDocument, options);
      }
export function useFindHcpAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindHcpAffiliationsQuery, FindHcpAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindHcpAffiliationsQuery, FindHcpAffiliationsQueryVariables>(FindHcpAffiliationsDocument, options);
        }
export type FindHcpAffiliationsQueryHookResult = ReturnType<typeof useFindHcpAffiliationsQuery>;
export type FindHcpAffiliationsLazyQueryHookResult = ReturnType<typeof useFindHcpAffiliationsLazyQuery>;
export type FindHcpAffiliationsQueryResult = Apollo.QueryResult<FindHcpAffiliationsQuery, FindHcpAffiliationsQueryVariables>;
export const RemoveSiteModalQueryDocument = gql`
    query RemoveSiteModalQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
    maintainerSource {
      code
      heading
    }
    affiliations {
      totalCount
      nodes {
        id
        person {
          id
          fullName
          title
        }
      }
    }
  }
}
    `;

/**
 * __useRemoveSiteModalQueryQuery__
 *
 * To run a query within a React component, call `useRemoveSiteModalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoveSiteModalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoveSiteModalQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRemoveSiteModalQueryQuery(baseOptions: Apollo.QueryHookOptions<RemoveSiteModalQueryQuery, RemoveSiteModalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoveSiteModalQueryQuery, RemoveSiteModalQueryQueryVariables>(RemoveSiteModalQueryDocument, options);
      }
export function useRemoveSiteModalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemoveSiteModalQueryQuery, RemoveSiteModalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoveSiteModalQueryQuery, RemoveSiteModalQueryQueryVariables>(RemoveSiteModalQueryDocument, options);
        }
export type RemoveSiteModalQueryQueryHookResult = ReturnType<typeof useRemoveSiteModalQueryQuery>;
export type RemoveSiteModalQueryLazyQueryHookResult = ReturnType<typeof useRemoveSiteModalQueryLazyQuery>;
export type RemoveSiteModalQueryQueryResult = Apollo.QueryResult<RemoveSiteModalQueryQuery, RemoveSiteModalQueryQueryVariables>;
export const removeSiteMutationDocument = gql`
    mutation removeSiteMutation($siteId: Int!, $comment: String!, $reason: DeleteReasonDcrEnum!) {
  removeSite(siteId: $siteId, comment: $comment, reason: $reason)
}
    `;
export type removeSiteMutationMutationFn = Apollo.MutationFunction<removeSiteMutationMutation, removeSiteMutationMutationVariables>;

/**
 * __useremoveSiteMutationMutation__
 *
 * To run a mutation, you first call `useremoveSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useremoveSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSiteMutationMutation, { data, loading, error }] = useremoveSiteMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      comment: // value for 'comment'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useremoveSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<removeSiteMutationMutation, removeSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<removeSiteMutationMutation, removeSiteMutationMutationVariables>(removeSiteMutationDocument, options);
      }
export type removeSiteMutationMutationHookResult = ReturnType<typeof useremoveSiteMutationMutation>;
export type removeSiteMutationMutationResult = Apollo.MutationResult<removeSiteMutationMutation>;
export type removeSiteMutationMutationOptions = Apollo.BaseMutationOptions<removeSiteMutationMutation, removeSiteMutationMutationVariables>;
export const SitePersonAffiliationsQueryDocument = gql`
    query SitePersonAffiliationsQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    countryCode
    maintainerSourceCode
    affiliations {
      hash
      nodes {
        id
        persId
        siteId
      }
    }
  }
}
    `;

/**
 * __useSitePersonAffiliationsQueryQuery__
 *
 * To run a query within a React component, call `useSitePersonAffiliationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePersonAffiliationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePersonAffiliationsQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSitePersonAffiliationsQueryQuery(baseOptions: Apollo.QueryHookOptions<SitePersonAffiliationsQueryQuery, SitePersonAffiliationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePersonAffiliationsQueryQuery, SitePersonAffiliationsQueryQueryVariables>(SitePersonAffiliationsQueryDocument, options);
      }
export function useSitePersonAffiliationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePersonAffiliationsQueryQuery, SitePersonAffiliationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePersonAffiliationsQueryQuery, SitePersonAffiliationsQueryQueryVariables>(SitePersonAffiliationsQueryDocument, options);
        }
export type SitePersonAffiliationsQueryQueryHookResult = ReturnType<typeof useSitePersonAffiliationsQueryQuery>;
export type SitePersonAffiliationsQueryLazyQueryHookResult = ReturnType<typeof useSitePersonAffiliationsQueryLazyQuery>;
export type SitePersonAffiliationsQueryQueryResult = Apollo.QueryResult<SitePersonAffiliationsQueryQuery, SitePersonAffiliationsQueryQueryVariables>;
export const SelectWorkingSpecialtiesQueryDocument = gql`
    query SelectWorkingSpecialtiesQuery($countries: [CountryCode!]!, $search: String) {
  availableSpecialties: workingSpecialties(
    criteria: {label: $search, countries: $countries, fetchSize: {limit: 5000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectWorkingSpecialtiesQueryQuery__
 *
 * To run a query within a React component, call `useSelectWorkingSpecialtiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWorkingSpecialtiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectWorkingSpecialtiesQueryQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSelectWorkingSpecialtiesQueryQuery(baseOptions: Apollo.QueryHookOptions<SelectWorkingSpecialtiesQueryQuery, SelectWorkingSpecialtiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectWorkingSpecialtiesQueryQuery, SelectWorkingSpecialtiesQueryQueryVariables>(SelectWorkingSpecialtiesQueryDocument, options);
      }
export function useSelectWorkingSpecialtiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectWorkingSpecialtiesQueryQuery, SelectWorkingSpecialtiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectWorkingSpecialtiesQueryQuery, SelectWorkingSpecialtiesQueryQueryVariables>(SelectWorkingSpecialtiesQueryDocument, options);
        }
export type SelectWorkingSpecialtiesQueryQueryHookResult = ReturnType<typeof useSelectWorkingSpecialtiesQueryQuery>;
export type SelectWorkingSpecialtiesQueryLazyQueryHookResult = ReturnType<typeof useSelectWorkingSpecialtiesQueryLazyQuery>;
export type SelectWorkingSpecialtiesQueryQueryResult = Apollo.QueryResult<SelectWorkingSpecialtiesQueryQuery, SelectWorkingSpecialtiesQueryQueryVariables>;
export const SiteInformationForWorkplaceQueryDocument = gql`
    query SiteInformationForWorkplaceQuery($siteId: Int!, $positionCode: String!) {
  site(siteId: $siteId) {
    id
    name
    countryCode
  }
  position(id: $positionCode) {
    code
    type
    displayLabel
  }
}
    `;

/**
 * __useSiteInformationForWorkplaceQueryQuery__
 *
 * To run a query within a React component, call `useSiteInformationForWorkplaceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteInformationForWorkplaceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteInformationForWorkplaceQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      positionCode: // value for 'positionCode'
 *   },
 * });
 */
export function useSiteInformationForWorkplaceQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteInformationForWorkplaceQueryQuery, SiteInformationForWorkplaceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteInformationForWorkplaceQueryQuery, SiteInformationForWorkplaceQueryQueryVariables>(SiteInformationForWorkplaceQueryDocument, options);
      }
export function useSiteInformationForWorkplaceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteInformationForWorkplaceQueryQuery, SiteInformationForWorkplaceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteInformationForWorkplaceQueryQuery, SiteInformationForWorkplaceQueryQueryVariables>(SiteInformationForWorkplaceQueryDocument, options);
        }
export type SiteInformationForWorkplaceQueryQueryHookResult = ReturnType<typeof useSiteInformationForWorkplaceQueryQuery>;
export type SiteInformationForWorkplaceQueryLazyQueryHookResult = ReturnType<typeof useSiteInformationForWorkplaceQueryLazyQuery>;
export type SiteInformationForWorkplaceQueryQueryResult = Apollo.QueryResult<SiteInformationForWorkplaceQueryQuery, SiteInformationForWorkplaceQueryQueryVariables>;
export const ActivateHcpAffiliationDocument = gql`
    mutation ActivateHcpAffiliation($linkId: Int!) {
  setSitePersonActiveStatus(id: $linkId, isActive: true) {
    id
    isActive
  }
}
    `;
export type ActivateHcpAffiliationMutationFn = Apollo.MutationFunction<ActivateHcpAffiliationMutation, ActivateHcpAffiliationMutationVariables>;

/**
 * __useActivateHcpAffiliationMutation__
 *
 * To run a mutation, you first call `useActivateHcpAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateHcpAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateHcpAffiliationMutation, { data, loading, error }] = useActivateHcpAffiliationMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useActivateHcpAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<ActivateHcpAffiliationMutation, ActivateHcpAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateHcpAffiliationMutation, ActivateHcpAffiliationMutationVariables>(ActivateHcpAffiliationDocument, options);
      }
export type ActivateHcpAffiliationMutationHookResult = ReturnType<typeof useActivateHcpAffiliationMutation>;
export type ActivateHcpAffiliationMutationResult = Apollo.MutationResult<ActivateHcpAffiliationMutation>;
export type ActivateHcpAffiliationMutationOptions = Apollo.BaseMutationOptions<ActivateHcpAffiliationMutation, ActivateHcpAffiliationMutationVariables>;
export const removeHcpHcoRelationMutationDocument = gql`
    mutation removeHcpHcoRelationMutation($linkIds: [Int!]!, $comment: String, $reason: DeleteReasonDcrEnum!) {
  removeHcpSiteRelation(linkIds: $linkIds, comment: $comment, reason: $reason)
}
    `;
export type removeHcpHcoRelationMutationMutationFn = Apollo.MutationFunction<removeHcpHcoRelationMutationMutation, removeHcpHcoRelationMutationMutationVariables>;

/**
 * __useremoveHcpHcoRelationMutationMutation__
 *
 * To run a mutation, you first call `useremoveHcpHcoRelationMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useremoveHcpHcoRelationMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHcpHcoRelationMutationMutation, { data, loading, error }] = useremoveHcpHcoRelationMutationMutation({
 *   variables: {
 *      linkIds: // value for 'linkIds'
 *      comment: // value for 'comment'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useremoveHcpHcoRelationMutationMutation(baseOptions?: Apollo.MutationHookOptions<removeHcpHcoRelationMutationMutation, removeHcpHcoRelationMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<removeHcpHcoRelationMutationMutation, removeHcpHcoRelationMutationMutationVariables>(removeHcpHcoRelationMutationDocument, options);
      }
export type removeHcpHcoRelationMutationMutationHookResult = ReturnType<typeof useremoveHcpHcoRelationMutationMutation>;
export type removeHcpHcoRelationMutationMutationResult = Apollo.MutationResult<removeHcpHcoRelationMutationMutation>;
export type removeHcpHcoRelationMutationMutationOptions = Apollo.BaseMutationOptions<removeHcpHcoRelationMutationMutation, removeHcpHcoRelationMutationMutationVariables>;
export const SiteSelectionRowTableQueryDocument = gql`
    query SiteSelectionRowTableQuery($criteria: SiteSelectionRowCriteria) {
  connection: siteSelectionRows(criteria: $criteria) {
    hash
    totalCount
    nodes {
      ...SiteSelectionRowTableBuiltFragment
    }
  }
}
    ${SiteSelectionRowTableBuiltFragmentFragmentDoc}`;

/**
 * __useSiteSelectionRowTableQueryQuery__
 *
 * To run a query within a React component, call `useSiteSelectionRowTableQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSelectionRowTableQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSelectionRowTableQueryQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useSiteSelectionRowTableQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteSelectionRowTableQueryQuery, SiteSelectionRowTableQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSelectionRowTableQueryQuery, SiteSelectionRowTableQueryQueryVariables>(SiteSelectionRowTableQueryDocument, options);
      }
export function useSiteSelectionRowTableQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSelectionRowTableQueryQuery, SiteSelectionRowTableQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSelectionRowTableQueryQuery, SiteSelectionRowTableQueryQueryVariables>(SiteSelectionRowTableQueryDocument, options);
        }
export type SiteSelectionRowTableQueryQueryHookResult = ReturnType<typeof useSiteSelectionRowTableQueryQuery>;
export type SiteSelectionRowTableQueryLazyQueryHookResult = ReturnType<typeof useSiteSelectionRowTableQueryLazyQuery>;
export type SiteSelectionRowTableQueryQueryResult = Apollo.QueryResult<SiteSelectionRowTableQueryQuery, SiteSelectionRowTableQueryQueryVariables>;
export const SiteSelectionRowRecordQueryDocument = gql`
    query SiteSelectionRowRecordQuery($recordId: Long!) {
  record: siteSelectionRow(id: $recordId) {
    ...SiteSelectionRowTableBuiltFragment
  }
}
    ${SiteSelectionRowTableBuiltFragmentFragmentDoc}`;

/**
 * __useSiteSelectionRowRecordQueryQuery__
 *
 * To run a query within a React component, call `useSiteSelectionRowRecordQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSelectionRowRecordQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSelectionRowRecordQueryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSiteSelectionRowRecordQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteSelectionRowRecordQueryQuery, SiteSelectionRowRecordQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSelectionRowRecordQueryQuery, SiteSelectionRowRecordQueryQueryVariables>(SiteSelectionRowRecordQueryDocument, options);
      }
export function useSiteSelectionRowRecordQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSelectionRowRecordQueryQuery, SiteSelectionRowRecordQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSelectionRowRecordQueryQuery, SiteSelectionRowRecordQueryQueryVariables>(SiteSelectionRowRecordQueryDocument, options);
        }
export type SiteSelectionRowRecordQueryQueryHookResult = ReturnType<typeof useSiteSelectionRowRecordQueryQuery>;
export type SiteSelectionRowRecordQueryLazyQueryHookResult = ReturnType<typeof useSiteSelectionRowRecordQueryLazyQuery>;
export type SiteSelectionRowRecordQueryQueryResult = Apollo.QueryResult<SiteSelectionRowRecordQueryQuery, SiteSelectionRowRecordQueryQueryVariables>;
export const GetAvailableListsDocument = gql`
    query GetAvailableLists($criteria: ListCriteria) {
  lists(criteria: $criteria) {
    hash
    nodes {
      id
      title
      description
    }
  }
}
    `;

/**
 * __useGetAvailableListsQuery__
 *
 * To run a query within a React component, call `useGetAvailableListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableListsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetAvailableListsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableListsQuery, GetAvailableListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableListsQuery, GetAvailableListsQueryVariables>(GetAvailableListsDocument, options);
      }
export function useGetAvailableListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableListsQuery, GetAvailableListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableListsQuery, GetAvailableListsQueryVariables>(GetAvailableListsDocument, options);
        }
export type GetAvailableListsQueryHookResult = ReturnType<typeof useGetAvailableListsQuery>;
export type GetAvailableListsLazyQueryHookResult = ReturnType<typeof useGetAvailableListsLazyQuery>;
export type GetAvailableListsQueryResult = Apollo.QueryResult<GetAvailableListsQuery, GetAvailableListsQueryVariables>;
export const AddSingleToStaticListMutationDocument = gql`
    mutation AddSingleToStaticListMutation($listId: Int!, $selection: SelectionCriteriaInput!) {
  addToStaticList(listId: $listId, selection: $selection) {
    id
    affiliations {
      ... on PersonConnection {
        hash
        totalCount
        nodes {
          id
        }
      }
      ... on SiteConnection {
        hash
        totalCount
        nodes {
          id
        }
      }
      ... on ActivityConnection {
        hash
        totalCount
        nodes {
          id
        }
      }
      ... on SitePersonConnection {
        hash
        totalCount
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type AddSingleToStaticListMutationMutationFn = Apollo.MutationFunction<AddSingleToStaticListMutationMutation, AddSingleToStaticListMutationMutationVariables>;

/**
 * __useAddSingleToStaticListMutationMutation__
 *
 * To run a mutation, you first call `useAddSingleToStaticListMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSingleToStaticListMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSingleToStaticListMutationMutation, { data, loading, error }] = useAddSingleToStaticListMutationMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function useAddSingleToStaticListMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddSingleToStaticListMutationMutation, AddSingleToStaticListMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSingleToStaticListMutationMutation, AddSingleToStaticListMutationMutationVariables>(AddSingleToStaticListMutationDocument, options);
      }
export type AddSingleToStaticListMutationMutationHookResult = ReturnType<typeof useAddSingleToStaticListMutationMutation>;
export type AddSingleToStaticListMutationMutationResult = Apollo.MutationResult<AddSingleToStaticListMutationMutation>;
export type AddSingleToStaticListMutationMutationOptions = Apollo.BaseMutationOptions<AddSingleToStaticListMutationMutation, AddSingleToStaticListMutationMutationVariables>;
export const AddressFormDataQueryDocument = gql`
    query AddressFormDataQuery {
  countries {
    hash
    nodes {
      code
      label
    }
  }
}
    `;

/**
 * __useAddressFormDataQueryQuery__
 *
 * To run a query within a React component, call `useAddressFormDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressFormDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressFormDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddressFormDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<AddressFormDataQueryQuery, AddressFormDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressFormDataQueryQuery, AddressFormDataQueryQueryVariables>(AddressFormDataQueryDocument, options);
      }
export function useAddressFormDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressFormDataQueryQuery, AddressFormDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressFormDataQueryQuery, AddressFormDataQueryQueryVariables>(AddressFormDataQueryDocument, options);
        }
export type AddressFormDataQueryQueryHookResult = ReturnType<typeof useAddressFormDataQueryQuery>;
export type AddressFormDataQueryLazyQueryHookResult = ReturnType<typeof useAddressFormDataQueryLazyQuery>;
export type AddressFormDataQueryQueryResult = Apollo.QueryResult<AddressFormDataQueryQuery, AddressFormDataQueryQueryVariables>;
export const PostcodeQueryDocument = gql`
    query PostcodeQuery($country: CountryCode!, $postcode: String!) {
  postcode(country: $country, postcode: $postcode) {
    postcode
    city
    region
    regionCode
    county
    countyCode
  }
}
    `;

/**
 * __usePostcodeQueryQuery__
 *
 * To run a query within a React component, call `usePostcodeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostcodeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostcodeQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function usePostcodeQueryQuery(baseOptions: Apollo.QueryHookOptions<PostcodeQueryQuery, PostcodeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostcodeQueryQuery, PostcodeQueryQueryVariables>(PostcodeQueryDocument, options);
      }
export function usePostcodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostcodeQueryQuery, PostcodeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostcodeQueryQuery, PostcodeQueryQueryVariables>(PostcodeQueryDocument, options);
        }
export type PostcodeQueryQueryHookResult = ReturnType<typeof usePostcodeQueryQuery>;
export type PostcodeQueryLazyQueryHookResult = ReturnType<typeof usePostcodeQueryLazyQuery>;
export type PostcodeQueryQueryResult = Apollo.QueryResult<PostcodeQueryQuery, PostcodeQueryQueryVariables>;
export const CountycodeQueryDocument = gql`
    query CountycodeQuery($country: [CountryCode!]!) {
  counties(criteria: {countries: $country, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      code
      type
      label
    }
  }
}
    `;

/**
 * __useCountycodeQueryQuery__
 *
 * To run a query within a React component, call `useCountycodeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountycodeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountycodeQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCountycodeQueryQuery(baseOptions: Apollo.QueryHookOptions<CountycodeQueryQuery, CountycodeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountycodeQueryQuery, CountycodeQueryQueryVariables>(CountycodeQueryDocument, options);
      }
export function useCountycodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountycodeQueryQuery, CountycodeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountycodeQueryQuery, CountycodeQueryQueryVariables>(CountycodeQueryDocument, options);
        }
export type CountycodeQueryQueryHookResult = ReturnType<typeof useCountycodeQueryQuery>;
export type CountycodeQueryLazyQueryHookResult = ReturnType<typeof useCountycodeQueryLazyQuery>;
export type CountycodeQueryQueryResult = Apollo.QueryResult<CountycodeQueryQuery, CountycodeQueryQueryVariables>;
export const CommuneCodeQueryDocument = gql`
    query CommuneCodeQuery($country: [CountryCode!]) {
  communes(criteria: {countries: $country, fetchSize: {limit: 1000}}) {
    hash
    nodes {
      code
      type
      label
    }
  }
}
    `;

/**
 * __useCommuneCodeQueryQuery__
 *
 * To run a query within a React component, call `useCommuneCodeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommuneCodeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommuneCodeQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCommuneCodeQueryQuery(baseOptions?: Apollo.QueryHookOptions<CommuneCodeQueryQuery, CommuneCodeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommuneCodeQueryQuery, CommuneCodeQueryQueryVariables>(CommuneCodeQueryDocument, options);
      }
export function useCommuneCodeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommuneCodeQueryQuery, CommuneCodeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommuneCodeQueryQuery, CommuneCodeQueryQueryVariables>(CommuneCodeQueryDocument, options);
        }
export type CommuneCodeQueryQueryHookResult = ReturnType<typeof useCommuneCodeQueryQuery>;
export type CommuneCodeQueryLazyQueryHookResult = ReturnType<typeof useCommuneCodeQueryLazyQuery>;
export type CommuneCodeQueryQueryResult = Apollo.QueryResult<CommuneCodeQueryQuery, CommuneCodeQueryQueryVariables>;
export const CriteriaSuggestionDropdownValuesAdvanceDocument = gql`
    query CriteriaSuggestionDropdownValuesAdvance($countryCodes: [CountryCode!], $service: String!, $offset: Int!, $limit: Int!, $search: String, $fromEntityType: EntityTypeEnum!) {
  dropdownSuggestions(
    countryCodes: $countryCodes
    service: $service
    includeInactive: false
    includeUnplaced: false
    includeOptedOut: false
    search: $search
    fromEntityType: $fromEntityType
    fetchSize: {offset: $offset, limit: $limit}
  ) {
    hash
    totalCount
    search
    service
    countryCodes
    nodes {
      key
      isGlobalOnly
      cacheKey
      isHeadingKey
      englishHeading
      heading
    }
  }
}
    `;

/**
 * __useCriteriaSuggestionDropdownValuesAdvanceQuery__
 *
 * To run a query within a React component, call `useCriteriaSuggestionDropdownValuesAdvanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCriteriaSuggestionDropdownValuesAdvanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCriteriaSuggestionDropdownValuesAdvanceQuery({
 *   variables: {
 *      countryCodes: // value for 'countryCodes'
 *      service: // value for 'service'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      fromEntityType: // value for 'fromEntityType'
 *   },
 * });
 */
export function useCriteriaSuggestionDropdownValuesAdvanceQuery(baseOptions: Apollo.QueryHookOptions<CriteriaSuggestionDropdownValuesAdvanceQuery, CriteriaSuggestionDropdownValuesAdvanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CriteriaSuggestionDropdownValuesAdvanceQuery, CriteriaSuggestionDropdownValuesAdvanceQueryVariables>(CriteriaSuggestionDropdownValuesAdvanceDocument, options);
      }
export function useCriteriaSuggestionDropdownValuesAdvanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CriteriaSuggestionDropdownValuesAdvanceQuery, CriteriaSuggestionDropdownValuesAdvanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CriteriaSuggestionDropdownValuesAdvanceQuery, CriteriaSuggestionDropdownValuesAdvanceQueryVariables>(CriteriaSuggestionDropdownValuesAdvanceDocument, options);
        }
export type CriteriaSuggestionDropdownValuesAdvanceQueryHookResult = ReturnType<typeof useCriteriaSuggestionDropdownValuesAdvanceQuery>;
export type CriteriaSuggestionDropdownValuesAdvanceLazyQueryHookResult = ReturnType<typeof useCriteriaSuggestionDropdownValuesAdvanceLazyQuery>;
export type CriteriaSuggestionDropdownValuesAdvanceQueryResult = Apollo.QueryResult<CriteriaSuggestionDropdownValuesAdvanceQuery, CriteriaSuggestionDropdownValuesAdvanceQueryVariables>;
export const personsCalendarQueryDocument = gql`
    query personsCalendarQuery($personId: Int!) {
  person(id: $personId) {
    id
    fullName
    daysSinceLastActivity
    primarySite {
      id
      name
    }
  }
}
    `;

/**
 * __usepersonsCalendarQueryQuery__
 *
 * To run a query within a React component, call `usepersonsCalendarQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usepersonsCalendarQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usepersonsCalendarQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usepersonsCalendarQueryQuery(baseOptions: Apollo.QueryHookOptions<personsCalendarQueryQuery, personsCalendarQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<personsCalendarQueryQuery, personsCalendarQueryQueryVariables>(personsCalendarQueryDocument, options);
      }
export function usepersonsCalendarQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<personsCalendarQueryQuery, personsCalendarQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<personsCalendarQueryQuery, personsCalendarQueryQueryVariables>(personsCalendarQueryDocument, options);
        }
export type personsCalendarQueryQueryHookResult = ReturnType<typeof usepersonsCalendarQueryQuery>;
export type personsCalendarQueryLazyQueryHookResult = ReturnType<typeof usepersonsCalendarQueryLazyQuery>;
export type personsCalendarQueryQueryResult = Apollo.QueryResult<personsCalendarQueryQuery, personsCalendarQueryQueryVariables>;
export const InternationalCustomersForCherryPickDocument = gql`
    query InternationalCustomersForCherryPick($criteria: InternationalCustomerCriteria!) {
  internationalCustomers(criteria: $criteria) {
    hash
    nodes {
      code
      heading
      countryCode
      cherryPickOverview {
        customerCode
        country
        amount
        amountAvailable
        amountUsed
      }
    }
  }
}
    `;

/**
 * __useInternationalCustomersForCherryPickQuery__
 *
 * To run a query within a React component, call `useInternationalCustomersForCherryPickQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternationalCustomersForCherryPickQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternationalCustomersForCherryPickQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useInternationalCustomersForCherryPickQuery(baseOptions: Apollo.QueryHookOptions<InternationalCustomersForCherryPickQuery, InternationalCustomersForCherryPickQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternationalCustomersForCherryPickQuery, InternationalCustomersForCherryPickQueryVariables>(InternationalCustomersForCherryPickDocument, options);
      }
export function useInternationalCustomersForCherryPickLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternationalCustomersForCherryPickQuery, InternationalCustomersForCherryPickQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternationalCustomersForCherryPickQuery, InternationalCustomersForCherryPickQueryVariables>(InternationalCustomersForCherryPickDocument, options);
        }
export type InternationalCustomersForCherryPickQueryHookResult = ReturnType<typeof useInternationalCustomersForCherryPickQuery>;
export type InternationalCustomersForCherryPickLazyQueryHookResult = ReturnType<typeof useInternationalCustomersForCherryPickLazyQuery>;
export type InternationalCustomersForCherryPickQueryResult = Apollo.QueryResult<InternationalCustomersForCherryPickQuery, InternationalCustomersForCherryPickQueryVariables>;
export const CherryPickOnBeHalfOfCustomerDocument = gql`
    mutation CherryPickOnBeHalfOfCustomer($entityType: EntityTypeEnum!, $customerCode: String!, $entityApbId: Int!) {
  cherryPick(
    customerCode: $customerCode
    entityType: $entityType
    apurebaseIds: [$entityApbId]
  ) {
    id
  }
}
    `;
export type CherryPickOnBeHalfOfCustomerMutationFn = Apollo.MutationFunction<CherryPickOnBeHalfOfCustomerMutation, CherryPickOnBeHalfOfCustomerMutationVariables>;

/**
 * __useCherryPickOnBeHalfOfCustomerMutation__
 *
 * To run a mutation, you first call `useCherryPickOnBeHalfOfCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCherryPickOnBeHalfOfCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cherryPickOnBeHalfOfCustomerMutation, { data, loading, error }] = useCherryPickOnBeHalfOfCustomerMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      customerCode: // value for 'customerCode'
 *      entityApbId: // value for 'entityApbId'
 *   },
 * });
 */
export function useCherryPickOnBeHalfOfCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CherryPickOnBeHalfOfCustomerMutation, CherryPickOnBeHalfOfCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CherryPickOnBeHalfOfCustomerMutation, CherryPickOnBeHalfOfCustomerMutationVariables>(CherryPickOnBeHalfOfCustomerDocument, options);
      }
export type CherryPickOnBeHalfOfCustomerMutationHookResult = ReturnType<typeof useCherryPickOnBeHalfOfCustomerMutation>;
export type CherryPickOnBeHalfOfCustomerMutationResult = Apollo.MutationResult<CherryPickOnBeHalfOfCustomerMutation>;
export type CherryPickOnBeHalfOfCustomerMutationOptions = Apollo.BaseMutationOptions<CherryPickOnBeHalfOfCustomerMutation, CherryPickOnBeHalfOfCustomerMutationVariables>;
export const EntityCherryPickOverviewDocument = gql`
    query EntityCherryPickOverview($entityApbId: Int!, $entityType: EntityTypeEnum!) {
  instancesRecordCherryPickOverview(
    entityType: $entityType
    entityApbId: $entityApbId
  ) {
    apurebaseId
    internationalId
    cherryPickedForCustomerCodes {
      customerCode
      bySystem
      bySystemUserId
      timestamp
      customer {
        code
        heading
      }
      byUser {
        id
        fullname
      }
    }
  }
}
    `;

/**
 * __useEntityCherryPickOverviewQuery__
 *
 * To run a query within a React component, call `useEntityCherryPickOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCherryPickOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCherryPickOverviewQuery({
 *   variables: {
 *      entityApbId: // value for 'entityApbId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityCherryPickOverviewQuery(baseOptions: Apollo.QueryHookOptions<EntityCherryPickOverviewQuery, EntityCherryPickOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCherryPickOverviewQuery, EntityCherryPickOverviewQueryVariables>(EntityCherryPickOverviewDocument, options);
      }
export function useEntityCherryPickOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCherryPickOverviewQuery, EntityCherryPickOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCherryPickOverviewQuery, EntityCherryPickOverviewQueryVariables>(EntityCherryPickOverviewDocument, options);
        }
export type EntityCherryPickOverviewQueryHookResult = ReturnType<typeof useEntityCherryPickOverviewQuery>;
export type EntityCherryPickOverviewLazyQueryHookResult = ReturnType<typeof useEntityCherryPickOverviewLazyQuery>;
export type EntityCherryPickOverviewQueryResult = Apollo.QueryResult<EntityCherryPickOverviewQuery, EntityCherryPickOverviewQueryVariables>;
export const AdminTableColumnSettingsQueryDocument = gql`
    query AdminTableColumnSettingsQuery($entityType: EntityTypeEnum!) {
  defaultTableColumns(criteria: {entityType: $entityType}) {
    hash
    nodes {
      id
      sort
      columnKey
    }
  }
}
    `;

/**
 * __useAdminTableColumnSettingsQueryQuery__
 *
 * To run a query within a React component, call `useAdminTableColumnSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminTableColumnSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminTableColumnSettingsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useAdminTableColumnSettingsQueryQuery(baseOptions: Apollo.QueryHookOptions<AdminTableColumnSettingsQueryQuery, AdminTableColumnSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminTableColumnSettingsQueryQuery, AdminTableColumnSettingsQueryQueryVariables>(AdminTableColumnSettingsQueryDocument, options);
      }
export function useAdminTableColumnSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminTableColumnSettingsQueryQuery, AdminTableColumnSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminTableColumnSettingsQueryQuery, AdminTableColumnSettingsQueryQueryVariables>(AdminTableColumnSettingsQueryDocument, options);
        }
export type AdminTableColumnSettingsQueryQueryHookResult = ReturnType<typeof useAdminTableColumnSettingsQueryQuery>;
export type AdminTableColumnSettingsQueryLazyQueryHookResult = ReturnType<typeof useAdminTableColumnSettingsQueryLazyQuery>;
export type AdminTableColumnSettingsQueryQueryResult = Apollo.QueryResult<AdminTableColumnSettingsQueryQuery, AdminTableColumnSettingsQueryQueryVariables>;
export const UserTableColumnsQueryDocument = gql`
    query UserTableColumnsQuery($userId: ID!, $entityType: EntityTypeEnum!) {
  userTableColumns(criteria: {userId: $userId, entityType: $entityType}) {
    hash
    nodes {
      id
      columnKey
      sort
    }
  }
  defaultTableColumns(criteria: {entityType: $entityType}) {
    hash
    nodes {
      id
      columnKey
      sort
    }
  }
}
    `;

/**
 * __useUserTableColumnsQueryQuery__
 *
 * To run a query within a React component, call `useUserTableColumnsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTableColumnsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTableColumnsQueryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useUserTableColumnsQueryQuery(baseOptions: Apollo.QueryHookOptions<UserTableColumnsQueryQuery, UserTableColumnsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTableColumnsQueryQuery, UserTableColumnsQueryQueryVariables>(UserTableColumnsQueryDocument, options);
      }
export function useUserTableColumnsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTableColumnsQueryQuery, UserTableColumnsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTableColumnsQueryQuery, UserTableColumnsQueryQueryVariables>(UserTableColumnsQueryDocument, options);
        }
export type UserTableColumnsQueryQueryHookResult = ReturnType<typeof useUserTableColumnsQueryQuery>;
export type UserTableColumnsQueryLazyQueryHookResult = ReturnType<typeof useUserTableColumnsQueryLazyQuery>;
export type UserTableColumnsQueryQueryResult = Apollo.QueryResult<UserTableColumnsQueryQuery, UserTableColumnsQueryQueryVariables>;
export const UpdateUserTableColumnsMutationDocument = gql`
    mutation UpdateUserTableColumnsMutation($entityType: EntityTypeEnum!, $columnKeys: [String!]!) {
  updateUserTableColumns(entityType: $entityType, columnKeys: $columnKeys) {
    id
  }
}
    `;
export type UpdateUserTableColumnsMutationMutationFn = Apollo.MutationFunction<UpdateUserTableColumnsMutationMutation, UpdateUserTableColumnsMutationMutationVariables>;

/**
 * __useUpdateUserTableColumnsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateUserTableColumnsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTableColumnsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTableColumnsMutationMutation, { data, loading, error }] = useUpdateUserTableColumnsMutationMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      columnKeys: // value for 'columnKeys'
 *   },
 * });
 */
export function useUpdateUserTableColumnsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTableColumnsMutationMutation, UpdateUserTableColumnsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTableColumnsMutationMutation, UpdateUserTableColumnsMutationMutationVariables>(UpdateUserTableColumnsMutationDocument, options);
      }
export type UpdateUserTableColumnsMutationMutationHookResult = ReturnType<typeof useUpdateUserTableColumnsMutationMutation>;
export type UpdateUserTableColumnsMutationMutationResult = Apollo.MutationResult<UpdateUserTableColumnsMutationMutation>;
export type UpdateUserTableColumnsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateUserTableColumnsMutationMutation, UpdateUserTableColumnsMutationMutationVariables>;
export const UpdateDefaultTableColumnsMutationDocument = gql`
    mutation UpdateDefaultTableColumnsMutation($entityType: EntityTypeEnum!, $columnKeys: [String!]!) {
  updateDefaultTableColumns(entityType: $entityType, columnKeys: $columnKeys) {
    hash
    nodes {
      id
      sort
      columnKey
    }
  }
}
    `;
export type UpdateDefaultTableColumnsMutationMutationFn = Apollo.MutationFunction<UpdateDefaultTableColumnsMutationMutation, UpdateDefaultTableColumnsMutationMutationVariables>;

/**
 * __useUpdateDefaultTableColumnsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultTableColumnsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultTableColumnsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultTableColumnsMutationMutation, { data, loading, error }] = useUpdateDefaultTableColumnsMutationMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      columnKeys: // value for 'columnKeys'
 *   },
 * });
 */
export function useUpdateDefaultTableColumnsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultTableColumnsMutationMutation, UpdateDefaultTableColumnsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultTableColumnsMutationMutation, UpdateDefaultTableColumnsMutationMutationVariables>(UpdateDefaultTableColumnsMutationDocument, options);
      }
export type UpdateDefaultTableColumnsMutationMutationHookResult = ReturnType<typeof useUpdateDefaultTableColumnsMutationMutation>;
export type UpdateDefaultTableColumnsMutationMutationResult = Apollo.MutationResult<UpdateDefaultTableColumnsMutationMutation>;
export type UpdateDefaultTableColumnsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultTableColumnsMutationMutation, UpdateDefaultTableColumnsMutationMutationVariables>;
export const RemoveProductSegmentationDocument = gql`
    mutation RemoveProductSegmentation($personId: Int!, $productId: Int!) {
  removeProductSegmentation(personId: $personId, productId: $productId)
}
    `;
export type RemoveProductSegmentationMutationFn = Apollo.MutationFunction<RemoveProductSegmentationMutation, RemoveProductSegmentationMutationVariables>;

/**
 * __useRemoveProductSegmentationMutation__
 *
 * To run a mutation, you first call `useRemoveProductSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductSegmentationMutation, { data, loading, error }] = useRemoveProductSegmentationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveProductSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductSegmentationMutation, RemoveProductSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductSegmentationMutation, RemoveProductSegmentationMutationVariables>(RemoveProductSegmentationDocument, options);
      }
export type RemoveProductSegmentationMutationHookResult = ReturnType<typeof useRemoveProductSegmentationMutation>;
export type RemoveProductSegmentationMutationResult = Apollo.MutationResult<RemoveProductSegmentationMutation>;
export type RemoveProductSegmentationMutationOptions = Apollo.BaseMutationOptions<RemoveProductSegmentationMutation, RemoveProductSegmentationMutationVariables>;
export const AddProductSegmentationDocument = gql`
    mutation AddProductSegmentation($personId: Int!, $productId: Int!, $segmentationCode: Int!) {
  addProductSegmentation(
    personId: $personId
    productId: $productId
    segmentationCodeId: $segmentationCode
  ) {
    id
  }
}
    `;
export type AddProductSegmentationMutationFn = Apollo.MutationFunction<AddProductSegmentationMutation, AddProductSegmentationMutationVariables>;

/**
 * __useAddProductSegmentationMutation__
 *
 * To run a mutation, you first call `useAddProductSegmentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductSegmentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductSegmentationMutation, { data, loading, error }] = useAddProductSegmentationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *      segmentationCode: // value for 'segmentationCode'
 *   },
 * });
 */
export function useAddProductSegmentationMutation(baseOptions?: Apollo.MutationHookOptions<AddProductSegmentationMutation, AddProductSegmentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductSegmentationMutation, AddProductSegmentationMutationVariables>(AddProductSegmentationDocument, options);
      }
export type AddProductSegmentationMutationHookResult = ReturnType<typeof useAddProductSegmentationMutation>;
export type AddProductSegmentationMutationResult = Apollo.MutationResult<AddProductSegmentationMutation>;
export type AddProductSegmentationMutationOptions = Apollo.BaseMutationOptions<AddProductSegmentationMutation, AddProductSegmentationMutationVariables>;
export const ProductForSegmentationDocument = gql`
    query ProductForSegmentation {
  products {
    hash
    nodes {
      id
      heading
      strength
    }
  }
}
    `;

/**
 * __useProductForSegmentationQuery__
 *
 * To run a query within a React component, call `useProductForSegmentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductForSegmentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductForSegmentationQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductForSegmentationQuery(baseOptions?: Apollo.QueryHookOptions<ProductForSegmentationQuery, ProductForSegmentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductForSegmentationQuery, ProductForSegmentationQueryVariables>(ProductForSegmentationDocument, options);
      }
export function useProductForSegmentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductForSegmentationQuery, ProductForSegmentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductForSegmentationQuery, ProductForSegmentationQueryVariables>(ProductForSegmentationDocument, options);
        }
export type ProductForSegmentationQueryHookResult = ReturnType<typeof useProductForSegmentationQuery>;
export type ProductForSegmentationLazyQueryHookResult = ReturnType<typeof useProductForSegmentationLazyQuery>;
export type ProductForSegmentationQueryResult = Apollo.QueryResult<ProductForSegmentationQuery, ProductForSegmentationQueryVariables>;
export const SegmentationForProductDocument = gql`
    query SegmentationForProduct {
  segmentationCodes {
    hash
    nodes {
      id
      code
      description
      heading
    }
  }
}
    `;

/**
 * __useSegmentationForProductQuery__
 *
 * To run a query within a React component, call `useSegmentationForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentationForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentationForProductQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentationForProductQuery(baseOptions?: Apollo.QueryHookOptions<SegmentationForProductQuery, SegmentationForProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentationForProductQuery, SegmentationForProductQueryVariables>(SegmentationForProductDocument, options);
      }
export function useSegmentationForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentationForProductQuery, SegmentationForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentationForProductQuery, SegmentationForProductQueryVariables>(SegmentationForProductDocument, options);
        }
export type SegmentationForProductQueryHookResult = ReturnType<typeof useSegmentationForProductQuery>;
export type SegmentationForProductLazyQueryHookResult = ReturnType<typeof useSegmentationForProductLazyQuery>;
export type SegmentationForProductQueryResult = Apollo.QueryResult<SegmentationForProductQuery, SegmentationForProductQueryVariables>;
export const UserPreferEnglishQueryDocument = gql`
    query UserPreferEnglishQuery {
  viewer {
    id
    user {
      id
      hasEnglishAsDefault
    }
  }
}
    `;

/**
 * __useUserPreferEnglishQueryQuery__
 *
 * To run a query within a React component, call `useUserPreferEnglishQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPreferEnglishQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPreferEnglishQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPreferEnglishQueryQuery(baseOptions?: Apollo.QueryHookOptions<UserPreferEnglishQueryQuery, UserPreferEnglishQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPreferEnglishQueryQuery, UserPreferEnglishQueryQueryVariables>(UserPreferEnglishQueryDocument, options);
      }
export function useUserPreferEnglishQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPreferEnglishQueryQuery, UserPreferEnglishQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPreferEnglishQueryQuery, UserPreferEnglishQueryQueryVariables>(UserPreferEnglishQueryDocument, options);
        }
export type UserPreferEnglishQueryQueryHookResult = ReturnType<typeof useUserPreferEnglishQueryQuery>;
export type UserPreferEnglishQueryLazyQueryHookResult = ReturnType<typeof useUserPreferEnglishQueryLazyQuery>;
export type UserPreferEnglishQueryQueryResult = Apollo.QueryResult<UserPreferEnglishQueryQuery, UserPreferEnglishQueryQueryVariables>;
export const preferEnglishLovDocument = gql`
    mutation preferEnglishLov {
  preferEnglishLov {
    id
    user {
      id
      hasEnglishAsDefault
    }
  }
}
    `;
export type preferEnglishLovMutationFn = Apollo.MutationFunction<preferEnglishLovMutation, preferEnglishLovMutationVariables>;

/**
 * __usepreferEnglishLovMutation__
 *
 * To run a mutation, you first call `usepreferEnglishLovMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usepreferEnglishLovMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preferEnglishLovMutation, { data, loading, error }] = usepreferEnglishLovMutation({
 *   variables: {
 *   },
 * });
 */
export function usepreferEnglishLovMutation(baseOptions?: Apollo.MutationHookOptions<preferEnglishLovMutation, preferEnglishLovMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<preferEnglishLovMutation, preferEnglishLovMutationVariables>(preferEnglishLovDocument, options);
      }
export type preferEnglishLovMutationHookResult = ReturnType<typeof usepreferEnglishLovMutation>;
export type preferEnglishLovMutationResult = Apollo.MutationResult<preferEnglishLovMutation>;
export type preferEnglishLovMutationOptions = Apollo.BaseMutationOptions<preferEnglishLovMutation, preferEnglishLovMutationVariables>;
export const CriteriaSuggestionDropdownValuesDocument = gql`
    query CriteriaSuggestionDropdownValues($countryCodes: [CountryCode!], $service: String!, $criteriaPathId: Int!, $offset: Int!, $limit: Int!, $search: String) {
  suggestions(
    countryCodes: $countryCodes
    service: $service
    criteriaPathId: $criteriaPathId
    includeInactive: false
    includeUnplaced: false
    includeOptedOut: false
    search: $search
    fetchSize: {offset: $offset, limit: $limit}
  ) {
    hash
    totalCount
    search
    service
    countryCodes
    nodes {
      key
      parentKey
      isValueHeadingKey
      isGlobalOnly
      value
      valueGb
      cacheKey
    }
  }
}
    `;

/**
 * __useCriteriaSuggestionDropdownValuesQuery__
 *
 * To run a query within a React component, call `useCriteriaSuggestionDropdownValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCriteriaSuggestionDropdownValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCriteriaSuggestionDropdownValuesQuery({
 *   variables: {
 *      countryCodes: // value for 'countryCodes'
 *      service: // value for 'service'
 *      criteriaPathId: // value for 'criteriaPathId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCriteriaSuggestionDropdownValuesQuery(baseOptions: Apollo.QueryHookOptions<CriteriaSuggestionDropdownValuesQuery, CriteriaSuggestionDropdownValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CriteriaSuggestionDropdownValuesQuery, CriteriaSuggestionDropdownValuesQueryVariables>(CriteriaSuggestionDropdownValuesDocument, options);
      }
export function useCriteriaSuggestionDropdownValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CriteriaSuggestionDropdownValuesQuery, CriteriaSuggestionDropdownValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CriteriaSuggestionDropdownValuesQuery, CriteriaSuggestionDropdownValuesQueryVariables>(CriteriaSuggestionDropdownValuesDocument, options);
        }
export type CriteriaSuggestionDropdownValuesQueryHookResult = ReturnType<typeof useCriteriaSuggestionDropdownValuesQuery>;
export type CriteriaSuggestionDropdownValuesLazyQueryHookResult = ReturnType<typeof useCriteriaSuggestionDropdownValuesLazyQuery>;
export type CriteriaSuggestionDropdownValuesQueryResult = Apollo.QueryResult<CriteriaSuggestionDropdownValuesQuery, CriteriaSuggestionDropdownValuesQueryVariables>;
export const UpsertCustomFieldValueDocument = gql`
    mutation UpsertCustomFieldValue($customFieldCode: String!, $customValues: [UpdateSelectCustomFieldValueForRecord!]!, $recordId: Int!) {
  setCustomLinkValues(
    customFieldCode: $customFieldCode
    customValues: $customValues
    recordId: $recordId
  ) {
    customFieldCode
  }
}
    `;
export type UpsertCustomFieldValueMutationFn = Apollo.MutationFunction<UpsertCustomFieldValueMutation, UpsertCustomFieldValueMutationVariables>;

/**
 * __useUpsertCustomFieldValueMutation__
 *
 * To run a mutation, you first call `useUpsertCustomFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomFieldValueMutation, { data, loading, error }] = useUpsertCustomFieldValueMutation({
 *   variables: {
 *      customFieldCode: // value for 'customFieldCode'
 *      customValues: // value for 'customValues'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useUpsertCustomFieldValueMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCustomFieldValueMutation, UpsertCustomFieldValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCustomFieldValueMutation, UpsertCustomFieldValueMutationVariables>(UpsertCustomFieldValueDocument, options);
      }
export type UpsertCustomFieldValueMutationHookResult = ReturnType<typeof useUpsertCustomFieldValueMutation>;
export type UpsertCustomFieldValueMutationResult = Apollo.MutationResult<UpsertCustomFieldValueMutation>;
export type UpsertCustomFieldValueMutationOptions = Apollo.BaseMutationOptions<UpsertCustomFieldValueMutation, UpsertCustomFieldValueMutationVariables>;
export const RemoveCustomFieldValueDocument = gql`
    mutation RemoveCustomFieldValue($customValues: [ID!]!) {
  removeCustomLinkValues(customLinkValueIds: $customValues)
}
    `;
export type RemoveCustomFieldValueMutationFn = Apollo.MutationFunction<RemoveCustomFieldValueMutation, RemoveCustomFieldValueMutationVariables>;

/**
 * __useRemoveCustomFieldValueMutation__
 *
 * To run a mutation, you first call `useRemoveCustomFieldValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomFieldValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomFieldValueMutation, { data, loading, error }] = useRemoveCustomFieldValueMutation({
 *   variables: {
 *      customValues: // value for 'customValues'
 *   },
 * });
 */
export function useRemoveCustomFieldValueMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCustomFieldValueMutation, RemoveCustomFieldValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCustomFieldValueMutation, RemoveCustomFieldValueMutationVariables>(RemoveCustomFieldValueDocument, options);
      }
export type RemoveCustomFieldValueMutationHookResult = ReturnType<typeof useRemoveCustomFieldValueMutation>;
export type RemoveCustomFieldValueMutationResult = Apollo.MutationResult<RemoveCustomFieldValueMutation>;
export type RemoveCustomFieldValueMutationOptions = Apollo.BaseMutationOptions<RemoveCustomFieldValueMutation, RemoveCustomFieldValueMutationVariables>;
export const RemoveDashboardItemMutationDocument = gql`
    mutation RemoveDashboardItemMutation($id: Int!) {
  removeDashboardItem(id: $id) {
    id
  }
}
    `;
export type RemoveDashboardItemMutationMutationFn = Apollo.MutationFunction<RemoveDashboardItemMutationMutation, RemoveDashboardItemMutationMutationVariables>;

/**
 * __useRemoveDashboardItemMutationMutation__
 *
 * To run a mutation, you first call `useRemoveDashboardItemMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDashboardItemMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDashboardItemMutationMutation, { data, loading, error }] = useRemoveDashboardItemMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveDashboardItemMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDashboardItemMutationMutation, RemoveDashboardItemMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDashboardItemMutationMutation, RemoveDashboardItemMutationMutationVariables>(RemoveDashboardItemMutationDocument, options);
      }
export type RemoveDashboardItemMutationMutationHookResult = ReturnType<typeof useRemoveDashboardItemMutationMutation>;
export type RemoveDashboardItemMutationMutationResult = Apollo.MutationResult<RemoveDashboardItemMutationMutation>;
export type RemoveDashboardItemMutationMutationOptions = Apollo.BaseMutationOptions<RemoveDashboardItemMutationMutation, RemoveDashboardItemMutationMutationVariables>;
export const DashboardCherryPickOverviewQueryDocument = gql`
    query DashboardCherryPickOverviewQuery {
  cherryPickOverviews {
    customerCode
    country
    amount
    amountAvailable
    amountUsed
  }
}
    `;

/**
 * __useDashboardCherryPickOverviewQueryQuery__
 *
 * To run a query within a React component, call `useDashboardCherryPickOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCherryPickOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCherryPickOverviewQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardCherryPickOverviewQueryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCherryPickOverviewQueryQuery, DashboardCherryPickOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCherryPickOverviewQueryQuery, DashboardCherryPickOverviewQueryQueryVariables>(DashboardCherryPickOverviewQueryDocument, options);
      }
export function useDashboardCherryPickOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCherryPickOverviewQueryQuery, DashboardCherryPickOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCherryPickOverviewQueryQuery, DashboardCherryPickOverviewQueryQueryVariables>(DashboardCherryPickOverviewQueryDocument, options);
        }
export type DashboardCherryPickOverviewQueryQueryHookResult = ReturnType<typeof useDashboardCherryPickOverviewQueryQuery>;
export type DashboardCherryPickOverviewQueryLazyQueryHookResult = ReturnType<typeof useDashboardCherryPickOverviewQueryLazyQuery>;
export type DashboardCherryPickOverviewQueryQueryResult = Apollo.QueryResult<DashboardCherryPickOverviewQueryQuery, DashboardCherryPickOverviewQueryQueryVariables>;
export const DashboardDCRStatusesQueryDocument = gql`
    query DashboardDCRStatusesQuery {
  getDcrCounts {
    seriesLabel
    label
    value
    color
  }
}
    `;

/**
 * __useDashboardDCRStatusesQueryQuery__
 *
 * To run a query within a React component, call `useDashboardDCRStatusesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardDCRStatusesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardDCRStatusesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardDCRStatusesQueryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardDCRStatusesQueryQuery, DashboardDCRStatusesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardDCRStatusesQueryQuery, DashboardDCRStatusesQueryQueryVariables>(DashboardDCRStatusesQueryDocument, options);
      }
export function useDashboardDCRStatusesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardDCRStatusesQueryQuery, DashboardDCRStatusesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardDCRStatusesQueryQuery, DashboardDCRStatusesQueryQueryVariables>(DashboardDCRStatusesQueryDocument, options);
        }
export type DashboardDCRStatusesQueryQueryHookResult = ReturnType<typeof useDashboardDCRStatusesQueryQuery>;
export type DashboardDCRStatusesQueryLazyQueryHookResult = ReturnType<typeof useDashboardDCRStatusesQueryLazyQuery>;
export type DashboardDCRStatusesQueryQueryResult = Apollo.QueryResult<DashboardDCRStatusesQueryQuery, DashboardDCRStatusesQueryQueryVariables>;
export const DashboardMasterDataOverviewQueryDocument = gql`
    query DashboardMasterDataOverviewQuery($from: DateTime!) {
  dashboardMasterDataOverview(from: $from) {
    entity
    state
    value
  }
}
    `;

/**
 * __useDashboardMasterDataOverviewQueryQuery__
 *
 * To run a query within a React component, call `useDashboardMasterDataOverviewQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardMasterDataOverviewQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardMasterDataOverviewQueryQuery({
 *   variables: {
 *      from: // value for 'from'
 *   },
 * });
 */
export function useDashboardMasterDataOverviewQueryQuery(baseOptions: Apollo.QueryHookOptions<DashboardMasterDataOverviewQueryQuery, DashboardMasterDataOverviewQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardMasterDataOverviewQueryQuery, DashboardMasterDataOverviewQueryQueryVariables>(DashboardMasterDataOverviewQueryDocument, options);
      }
export function useDashboardMasterDataOverviewQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardMasterDataOverviewQueryQuery, DashboardMasterDataOverviewQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardMasterDataOverviewQueryQuery, DashboardMasterDataOverviewQueryQueryVariables>(DashboardMasterDataOverviewQueryDocument, options);
        }
export type DashboardMasterDataOverviewQueryQueryHookResult = ReturnType<typeof useDashboardMasterDataOverviewQueryQuery>;
export type DashboardMasterDataOverviewQueryLazyQueryHookResult = ReturnType<typeof useDashboardMasterDataOverviewQueryLazyQuery>;
export type DashboardMasterDataOverviewQueryQueryResult = Apollo.QueryResult<DashboardMasterDataOverviewQueryQuery, DashboardMasterDataOverviewQueryQueryVariables>;
export const DashboardRecordsImportedItemQueryDocument = gql`
    query DashboardRecordsImportedItemQuery($grouping: GroupByDateRanges!) {
  dashboardRecordsImportedDataPoints(grouping: $grouping) {
    time
    value
  }
}
    `;

/**
 * __useDashboardRecordsImportedItemQueryQuery__
 *
 * To run a query within a React component, call `useDashboardRecordsImportedItemQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardRecordsImportedItemQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardRecordsImportedItemQueryQuery({
 *   variables: {
 *      grouping: // value for 'grouping'
 *   },
 * });
 */
export function useDashboardRecordsImportedItemQueryQuery(baseOptions: Apollo.QueryHookOptions<DashboardRecordsImportedItemQueryQuery, DashboardRecordsImportedItemQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardRecordsImportedItemQueryQuery, DashboardRecordsImportedItemQueryQueryVariables>(DashboardRecordsImportedItemQueryDocument, options);
      }
export function useDashboardRecordsImportedItemQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardRecordsImportedItemQueryQuery, DashboardRecordsImportedItemQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardRecordsImportedItemQueryQuery, DashboardRecordsImportedItemQueryQueryVariables>(DashboardRecordsImportedItemQueryDocument, options);
        }
export type DashboardRecordsImportedItemQueryQueryHookResult = ReturnType<typeof useDashboardRecordsImportedItemQueryQuery>;
export type DashboardRecordsImportedItemQueryLazyQueryHookResult = ReturnType<typeof useDashboardRecordsImportedItemQueryLazyQuery>;
export type DashboardRecordsImportedItemQueryQueryResult = Apollo.QueryResult<DashboardRecordsImportedItemQueryQuery, DashboardRecordsImportedItemQueryQueryVariables>;
export const EntityPieSettingsQueryDocument = gql`
    query EntityPieSettingsQuery($entityType: EntityTypeEnum!) {
  dashboardEntityPieSupportedFields(entityType: $entityType) {
    code
    entityType
    heading
    headingKey
  }
}
    `;

/**
 * __useEntityPieSettingsQueryQuery__
 *
 * To run a query within a React component, call `useEntityPieSettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPieSettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPieSettingsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityPieSettingsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityPieSettingsQueryQuery, EntityPieSettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPieSettingsQueryQuery, EntityPieSettingsQueryQueryVariables>(EntityPieSettingsQueryDocument, options);
      }
export function useEntityPieSettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPieSettingsQueryQuery, EntityPieSettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPieSettingsQueryQuery, EntityPieSettingsQueryQueryVariables>(EntityPieSettingsQueryDocument, options);
        }
export type EntityPieSettingsQueryQueryHookResult = ReturnType<typeof useEntityPieSettingsQueryQuery>;
export type EntityPieSettingsQueryLazyQueryHookResult = ReturnType<typeof useEntityPieSettingsQueryLazyQuery>;
export type EntityPieSettingsQueryQueryResult = Apollo.QueryResult<EntityPieSettingsQueryQuery, EntityPieSettingsQueryQueryVariables>;
export const UpdateEntityPieSettingsMutationDocument = gql`
    mutation UpdateEntityPieSettingsMutation($input: DashboardEntityPieUpdateInput!) {
  updateDashboardEntityPieSettings(input: $input)
}
    `;
export type UpdateEntityPieSettingsMutationMutationFn = Apollo.MutationFunction<UpdateEntityPieSettingsMutationMutation, UpdateEntityPieSettingsMutationMutationVariables>;

/**
 * __useUpdateEntityPieSettingsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPieSettingsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPieSettingsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPieSettingsMutationMutation, { data, loading, error }] = useUpdateEntityPieSettingsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntityPieSettingsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityPieSettingsMutationMutation, UpdateEntityPieSettingsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityPieSettingsMutationMutation, UpdateEntityPieSettingsMutationMutationVariables>(UpdateEntityPieSettingsMutationDocument, options);
      }
export type UpdateEntityPieSettingsMutationMutationHookResult = ReturnType<typeof useUpdateEntityPieSettingsMutationMutation>;
export type UpdateEntityPieSettingsMutationMutationResult = Apollo.MutationResult<UpdateEntityPieSettingsMutationMutation>;
export type UpdateEntityPieSettingsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityPieSettingsMutationMutation, UpdateEntityPieSettingsMutationMutationVariables>;
export const DashboardPieFullscreenQueryDocument = gql`
    query DashboardPieFullscreenQuery($itemConfigurationId: Int!) {
  dashboardEntityPieSettings(dashboardItemConfigurationId: $itemConfigurationId) {
    id
    entityType
  }
}
    `;

/**
 * __useDashboardPieFullscreenQueryQuery__
 *
 * To run a query within a React component, call `useDashboardPieFullscreenQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPieFullscreenQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPieFullscreenQueryQuery({
 *   variables: {
 *      itemConfigurationId: // value for 'itemConfigurationId'
 *   },
 * });
 */
export function useDashboardPieFullscreenQueryQuery(baseOptions: Apollo.QueryHookOptions<DashboardPieFullscreenQueryQuery, DashboardPieFullscreenQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPieFullscreenQueryQuery, DashboardPieFullscreenQueryQueryVariables>(DashboardPieFullscreenQueryDocument, options);
      }
export function useDashboardPieFullscreenQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPieFullscreenQueryQuery, DashboardPieFullscreenQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPieFullscreenQueryQuery, DashboardPieFullscreenQueryQueryVariables>(DashboardPieFullscreenQueryDocument, options);
        }
export type DashboardPieFullscreenQueryQueryHookResult = ReturnType<typeof useDashboardPieFullscreenQueryQuery>;
export type DashboardPieFullscreenQueryLazyQueryHookResult = ReturnType<typeof useDashboardPieFullscreenQueryLazyQuery>;
export type DashboardPieFullscreenQueryQueryResult = Apollo.QueryResult<DashboardPieFullscreenQueryQuery, DashboardPieFullscreenQueryQueryVariables>;
export const PieDataQueryDocument = gql`
    query PieDataQuery($configurationId: Int!) {
  dashboardEntityPieSettings(dashboardItemConfigurationId: $configurationId) {
    id
    entityType
    fieldCode
    customFieldCode
    fieldHeading
    fieldHeadingKey
  }
}
    `;

/**
 * __usePieDataQueryQuery__
 *
 * To run a query within a React component, call `usePieDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieDataQueryQuery({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function usePieDataQueryQuery(baseOptions: Apollo.QueryHookOptions<PieDataQueryQuery, PieDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieDataQueryQuery, PieDataQueryQueryVariables>(PieDataQueryDocument, options);
      }
export function usePieDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieDataQueryQuery, PieDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieDataQueryQuery, PieDataQueryQueryVariables>(PieDataQueryDocument, options);
        }
export type PieDataQueryQueryHookResult = ReturnType<typeof usePieDataQueryQuery>;
export type PieDataQueryLazyQueryHookResult = ReturnType<typeof usePieDataQueryLazyQuery>;
export type PieDataQueryQueryResult = Apollo.QueryResult<PieDataQueryQuery, PieDataQueryQueryVariables>;
export const PieLevelDataQueryDocument = gql`
    query PieLevelDataQuery($configurationId: Int!, $selection: [DashboardPieSelectionInput!]) {
  dashboardEntityPieData(
    dashboardItemConfigurationId: $configurationId
    selection: $selection
  ) {
    values {
      code
      label
      value
    }
    criterias {
      name
      value
      values
    }
  }
}
    `;

/**
 * __usePieLevelDataQueryQuery__
 *
 * To run a query within a React component, call `usePieLevelDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePieLevelDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePieLevelDataQueryQuery({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *      selection: // value for 'selection'
 *   },
 * });
 */
export function usePieLevelDataQueryQuery(baseOptions: Apollo.QueryHookOptions<PieLevelDataQueryQuery, PieLevelDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PieLevelDataQueryQuery, PieLevelDataQueryQueryVariables>(PieLevelDataQueryDocument, options);
      }
export function usePieLevelDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PieLevelDataQueryQuery, PieLevelDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PieLevelDataQueryQuery, PieLevelDataQueryQueryVariables>(PieLevelDataQueryDocument, options);
        }
export type PieLevelDataQueryQueryHookResult = ReturnType<typeof usePieLevelDataQueryQuery>;
export type PieLevelDataQueryLazyQueryHookResult = ReturnType<typeof usePieLevelDataQueryLazyQuery>;
export type PieLevelDataQueryQueryResult = Apollo.QueryResult<PieLevelDataQueryQuery, PieLevelDataQueryQueryVariables>;
export const validationLogHistoryDocument = gql`
    query validationLogHistory($id: Int!, $entityType: EntityTypeEnum!) {
  entityValidationLogsByValues(id: $id, entity: $entityType) {
    id
    entityAffiliationId
    entityTypeId
    ct
    ut
    validatedTime
    user {
      id
      email
      fullname
    }
  }
}
    `;

/**
 * __usevalidationLogHistoryQuery__
 *
 * To run a query within a React component, call `usevalidationLogHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usevalidationLogHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usevalidationLogHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function usevalidationLogHistoryQuery(baseOptions: Apollo.QueryHookOptions<validationLogHistoryQuery, validationLogHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<validationLogHistoryQuery, validationLogHistoryQueryVariables>(validationLogHistoryDocument, options);
      }
export function usevalidationLogHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<validationLogHistoryQuery, validationLogHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<validationLogHistoryQuery, validationLogHistoryQueryVariables>(validationLogHistoryDocument, options);
        }
export type validationLogHistoryQueryHookResult = ReturnType<typeof usevalidationLogHistoryQuery>;
export type validationLogHistoryLazyQueryHookResult = ReturnType<typeof usevalidationLogHistoryLazyQuery>;
export type validationLogHistoryQueryResult = Apollo.QueryResult<validationLogHistoryQuery, validationLogHistoryQueryVariables>;
export const AttributeLabelDcrInfoDocument = gql`
    query AttributeLabelDcrInfo($entityType: EntityTypeEnum!, $entityAffiliationId: Int!, $fields: [DcrLineCriteriaField!]!) {
  line: findDcrLine(
    entityType: $entityType
    entityAffiliationId: $entityAffiliationId
    fields: $fields
  ) {
    hash
    hasActiveLines
    newValue
    oldValue
    nodes {
      id
      dcr {
        id
        dcrGroupId
      }
    }
  }
}
    `;

/**
 * __useAttributeLabelDcrInfoQuery__
 *
 * To run a query within a React component, call `useAttributeLabelDcrInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeLabelDcrInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeLabelDcrInfoQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityAffiliationId: // value for 'entityAffiliationId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useAttributeLabelDcrInfoQuery(baseOptions: Apollo.QueryHookOptions<AttributeLabelDcrInfoQuery, AttributeLabelDcrInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeLabelDcrInfoQuery, AttributeLabelDcrInfoQueryVariables>(AttributeLabelDcrInfoDocument, options);
      }
export function useAttributeLabelDcrInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeLabelDcrInfoQuery, AttributeLabelDcrInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeLabelDcrInfoQuery, AttributeLabelDcrInfoQueryVariables>(AttributeLabelDcrInfoDocument, options);
        }
export type AttributeLabelDcrInfoQueryHookResult = ReturnType<typeof useAttributeLabelDcrInfoQuery>;
export type AttributeLabelDcrInfoLazyQueryHookResult = ReturnType<typeof useAttributeLabelDcrInfoLazyQuery>;
export type AttributeLabelDcrInfoQueryResult = Apollo.QueryResult<AttributeLabelDcrInfoQuery, AttributeLabelDcrInfoQueryVariables>;
export const EntityPropertyDataQueryDocument = gql`
    query EntityPropertyDataQuery($entityType: EntityTypeEnum!) {
  tableMapper(entityType: $entityType) {
    mappingName
    id: entityType
    tableColumns {
      id: columnName
      dataType
      isHeadingKey
      heading
      columnName
      dataType
      supportedCriteriaTypes
      service
    }
    tableName
    ...TableMapperFragment
  }
}
    ${TableMapperFragmentFragmentDoc}`;

/**
 * __useEntityPropertyDataQueryQuery__
 *
 * To run a query within a React component, call `useEntityPropertyDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPropertyDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPropertyDataQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useEntityPropertyDataQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityPropertyDataQueryQuery, EntityPropertyDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPropertyDataQueryQuery, EntityPropertyDataQueryQueryVariables>(EntityPropertyDataQueryDocument, options);
      }
export function useEntityPropertyDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPropertyDataQueryQuery, EntityPropertyDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPropertyDataQueryQuery, EntityPropertyDataQueryQueryVariables>(EntityPropertyDataQueryDocument, options);
        }
export type EntityPropertyDataQueryQueryHookResult = ReturnType<typeof useEntityPropertyDataQueryQuery>;
export type EntityPropertyDataQueryLazyQueryHookResult = ReturnType<typeof useEntityPropertyDataQueryLazyQuery>;
export type EntityPropertyDataQueryQueryResult = Apollo.QueryResult<EntityPropertyDataQueryQuery, EntityPropertyDataQueryQueryVariables>;
export const CreateMergeRequestFlowDocument = gql`
    mutation CreateMergeRequestFlow($entityType: EntityTypeEnum!, $loserId: ID!, $winnerId: ID!) {
  createMergeRequest(
    entityType: $entityType
    loserId: $loserId
    winnerId: $winnerId
  ) {
    id
  }
}
    `;
export type CreateMergeRequestFlowMutationFn = Apollo.MutationFunction<CreateMergeRequestFlowMutation, CreateMergeRequestFlowMutationVariables>;

/**
 * __useCreateMergeRequestFlowMutation__
 *
 * To run a mutation, you first call `useCreateMergeRequestFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMergeRequestFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMergeRequestFlowMutation, { data, loading, error }] = useCreateMergeRequestFlowMutation({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      loserId: // value for 'loserId'
 *      winnerId: // value for 'winnerId'
 *   },
 * });
 */
export function useCreateMergeRequestFlowMutation(baseOptions?: Apollo.MutationHookOptions<CreateMergeRequestFlowMutation, CreateMergeRequestFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMergeRequestFlowMutation, CreateMergeRequestFlowMutationVariables>(CreateMergeRequestFlowDocument, options);
      }
export type CreateMergeRequestFlowMutationHookResult = ReturnType<typeof useCreateMergeRequestFlowMutation>;
export type CreateMergeRequestFlowMutationResult = Apollo.MutationResult<CreateMergeRequestFlowMutation>;
export type CreateMergeRequestFlowMutationOptions = Apollo.BaseMutationOptions<CreateMergeRequestFlowMutation, CreateMergeRequestFlowMutationVariables>;
export const PerformMergeRequestFlowDocument = gql`
    mutation PerformMergeRequestFlow($mergeRequestId: ID!) {
  performMerge(mergeRequestId: $mergeRequestId) {
    hasConflict
    entityMerge {
      id
      from {
        ... on Person {
          id
          isActive
        }
        ... on Site {
          id
          isActive
        }
      }
    }
  }
}
    `;
export type PerformMergeRequestFlowMutationFn = Apollo.MutationFunction<PerformMergeRequestFlowMutation, PerformMergeRequestFlowMutationVariables>;

/**
 * __usePerformMergeRequestFlowMutation__
 *
 * To run a mutation, you first call `usePerformMergeRequestFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePerformMergeRequestFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [performMergeRequestFlowMutation, { data, loading, error }] = usePerformMergeRequestFlowMutation({
 *   variables: {
 *      mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function usePerformMergeRequestFlowMutation(baseOptions?: Apollo.MutationHookOptions<PerformMergeRequestFlowMutation, PerformMergeRequestFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PerformMergeRequestFlowMutation, PerformMergeRequestFlowMutationVariables>(PerformMergeRequestFlowDocument, options);
      }
export type PerformMergeRequestFlowMutationHookResult = ReturnType<typeof usePerformMergeRequestFlowMutation>;
export type PerformMergeRequestFlowMutationResult = Apollo.MutationResult<PerformMergeRequestFlowMutation>;
export type PerformMergeRequestFlowMutationOptions = Apollo.BaseMutationOptions<PerformMergeRequestFlowMutation, PerformMergeRequestFlowMutationVariables>;
export const DynamicEntityTabsQueryDocument = gql`
    query DynamicEntityTabsQuery($entityType: EntityTypeEnum!) {
  entityTabs(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      headingKey
      gridItems {
        hash
        nodes {
          id
          ...DynamicTabGridFragment
        }
      }
    }
  }
}
    ${DynamicTabGridFragmentFragmentDoc}`;

/**
 * __useDynamicEntityTabsQueryQuery__
 *
 * To run a query within a React component, call `useDynamicEntityTabsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicEntityTabsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicEntityTabsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useDynamicEntityTabsQueryQuery(baseOptions: Apollo.QueryHookOptions<DynamicEntityTabsQueryQuery, DynamicEntityTabsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicEntityTabsQueryQuery, DynamicEntityTabsQueryQueryVariables>(DynamicEntityTabsQueryDocument, options);
      }
export function useDynamicEntityTabsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicEntityTabsQueryQuery, DynamicEntityTabsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicEntityTabsQueryQuery, DynamicEntityTabsQueryQueryVariables>(DynamicEntityTabsQueryDocument, options);
        }
export type DynamicEntityTabsQueryQueryHookResult = ReturnType<typeof useDynamicEntityTabsQueryQuery>;
export type DynamicEntityTabsQueryLazyQueryHookResult = ReturnType<typeof useDynamicEntityTabsQueryLazyQuery>;
export type DynamicEntityTabsQueryQueryResult = Apollo.QueryResult<DynamicEntityTabsQueryQuery, DynamicEntityTabsQueryQueryVariables>;
export const EntityCardFieldsQueryDocument = gql`
    query EntityCardFieldsQuery($configurationId: ID!) {
  entityTabGridConfigurationFields(criteria: {configurationId: $configurationId}) {
    hash
    nodes {
      id
      typeCode: gridItemFieldTypeCode
    }
  }
}
    `;

/**
 * __useEntityCardFieldsQueryQuery__
 *
 * To run a query within a React component, call `useEntityCardFieldsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCardFieldsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCardFieldsQueryQuery({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function useEntityCardFieldsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityCardFieldsQueryQuery, EntityCardFieldsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCardFieldsQueryQuery, EntityCardFieldsQueryQueryVariables>(EntityCardFieldsQueryDocument, options);
      }
export function useEntityCardFieldsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCardFieldsQueryQuery, EntityCardFieldsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCardFieldsQueryQuery, EntityCardFieldsQueryQueryVariables>(EntityCardFieldsQueryDocument, options);
        }
export type EntityCardFieldsQueryQueryHookResult = ReturnType<typeof useEntityCardFieldsQueryQuery>;
export type EntityCardFieldsQueryLazyQueryHookResult = ReturnType<typeof useEntityCardFieldsQueryLazyQuery>;
export type EntityCardFieldsQueryQueryResult = Apollo.QueryResult<EntityCardFieldsQueryQuery, EntityCardFieldsQueryQueryVariables>;
export const EntityTabCustomFieldDataQueryDocument = gql`
    query EntityTabCustomFieldDataQuery($fieldId: Int!, $recordId: Int!, $countries: [CountryCode!]) {
  info: entityTabGridConfigurationField(id: $fieldId) {
    id
    fieldConfig: customFieldConfiguration {
      id
      customField {
        code
        heading
        myAccessRules {
          id
          allowMutation
          allowRead
        }
        ...CustomFieldFragment
        customLinkValues(recordId: $recordId, criteria: {fetchSize: {limit: null}}) {
          hash
          ...CustomFieldValueFragment
        }
      }
    }
  }
}
    ${CustomFieldFragmentFragmentDoc}
${CustomFieldValueFragmentFragmentDoc}`;

/**
 * __useEntityTabCustomFieldDataQueryQuery__
 *
 * To run a query within a React component, call `useEntityTabCustomFieldDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTabCustomFieldDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTabCustomFieldDataQueryQuery({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *      recordId: // value for 'recordId'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useEntityTabCustomFieldDataQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityTabCustomFieldDataQueryQuery, EntityTabCustomFieldDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityTabCustomFieldDataQueryQuery, EntityTabCustomFieldDataQueryQueryVariables>(EntityTabCustomFieldDataQueryDocument, options);
      }
export function useEntityTabCustomFieldDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityTabCustomFieldDataQueryQuery, EntityTabCustomFieldDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityTabCustomFieldDataQueryQuery, EntityTabCustomFieldDataQueryQueryVariables>(EntityTabCustomFieldDataQueryDocument, options);
        }
export type EntityTabCustomFieldDataQueryQueryHookResult = ReturnType<typeof useEntityTabCustomFieldDataQueryQuery>;
export type EntityTabCustomFieldDataQueryLazyQueryHookResult = ReturnType<typeof useEntityTabCustomFieldDataQueryLazyQuery>;
export type EntityTabCustomFieldDataQueryQueryResult = Apollo.QueryResult<EntityTabCustomFieldDataQueryQuery, EntityTabCustomFieldDataQueryQueryVariables>;
export const PersonConsentTabQueryDocument = gql`
    query PersonConsentTabQuery($personId: Int!) {
  person(id: $personId) {
    id
    consents: virtualConsents {
      entityType
      entityAffiliationId
      consentTypeCode
      isEnabled
      type {
        code
        headingKey
        isManaged
      }
    }
  }
}
    `;

/**
 * __usePersonConsentTabQueryQuery__
 *
 * To run a query within a React component, call `usePersonConsentTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonConsentTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonConsentTabQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonConsentTabQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonConsentTabQueryQuery, PersonConsentTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonConsentTabQueryQuery, PersonConsentTabQueryQueryVariables>(PersonConsentTabQueryDocument, options);
      }
export function usePersonConsentTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonConsentTabQueryQuery, PersonConsentTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonConsentTabQueryQuery, PersonConsentTabQueryQueryVariables>(PersonConsentTabQueryDocument, options);
        }
export type PersonConsentTabQueryQueryHookResult = ReturnType<typeof usePersonConsentTabQueryQuery>;
export type PersonConsentTabQueryLazyQueryHookResult = ReturnType<typeof usePersonConsentTabQueryLazyQuery>;
export type PersonConsentTabQueryQueryResult = Apollo.QueryResult<PersonConsentTabQueryQuery, PersonConsentTabQueryQueryVariables>;
export const UpdatePersonConsentTabMutationDocument = gql`
    mutation UpdatePersonConsentTabMutation($personId: Int!, $consentTypeCode: String!, $enabled: Boolean!) {
  setConsentValue(
    entityAffiliationId: $personId
    typeCode: $consentTypeCode
    isEnabled: $enabled
  ) {
    entityType
    entityAffiliationId
    consentTypeCode
    type {
      code
      headingKey
    }
    isEnabled
  }
}
    `;
export type UpdatePersonConsentTabMutationMutationFn = Apollo.MutationFunction<UpdatePersonConsentTabMutationMutation, UpdatePersonConsentTabMutationMutationVariables>;

/**
 * __useUpdatePersonConsentTabMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonConsentTabMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonConsentTabMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonConsentTabMutationMutation, { data, loading, error }] = useUpdatePersonConsentTabMutationMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      consentTypeCode: // value for 'consentTypeCode'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdatePersonConsentTabMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonConsentTabMutationMutation, UpdatePersonConsentTabMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonConsentTabMutationMutation, UpdatePersonConsentTabMutationMutationVariables>(UpdatePersonConsentTabMutationDocument, options);
      }
export type UpdatePersonConsentTabMutationMutationHookResult = ReturnType<typeof useUpdatePersonConsentTabMutationMutation>;
export type UpdatePersonConsentTabMutationMutationResult = Apollo.MutationResult<UpdatePersonConsentTabMutationMutation>;
export type UpdatePersonConsentTabMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonConsentTabMutationMutation, UpdatePersonConsentTabMutationMutationVariables>;
export const PersonExternalIdsQueryDocument = gql`
    query PersonExternalIdsQuery($personId: Int!) {
  person(id: $personId) {
    id
    externalIds {
      hash
      nodes {
        id
        externalId
        type {
          id
          heading
          isHeadingKey
          description: note
        }
      }
    }
  }
}
    `;

/**
 * __usePersonExternalIdsQueryQuery__
 *
 * To run a query within a React component, call `usePersonExternalIdsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonExternalIdsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonExternalIdsQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonExternalIdsQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonExternalIdsQueryQuery, PersonExternalIdsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonExternalIdsQueryQuery, PersonExternalIdsQueryQueryVariables>(PersonExternalIdsQueryDocument, options);
      }
export function usePersonExternalIdsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonExternalIdsQueryQuery, PersonExternalIdsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonExternalIdsQueryQuery, PersonExternalIdsQueryQueryVariables>(PersonExternalIdsQueryDocument, options);
        }
export type PersonExternalIdsQueryQueryHookResult = ReturnType<typeof usePersonExternalIdsQueryQuery>;
export type PersonExternalIdsQueryLazyQueryHookResult = ReturnType<typeof usePersonExternalIdsQueryLazyQuery>;
export type PersonExternalIdsQueryQueryResult = Apollo.QueryResult<PersonExternalIdsQueryQuery, PersonExternalIdsQueryQueryVariables>;
export const UpsertResponsibleAreaTabDocument = gql`
    mutation UpsertResponsibleAreaTab($persId: Int!, $areaId: Int!, $userId: Int!) {
  upsertResponsibleArea(persId: $persId, areaId: $areaId, userId: $userId) {
    id
  }
}
    `;
export type UpsertResponsibleAreaTabMutationFn = Apollo.MutationFunction<UpsertResponsibleAreaTabMutation, UpsertResponsibleAreaTabMutationVariables>;

/**
 * __useUpsertResponsibleAreaTabMutation__
 *
 * To run a mutation, you first call `useUpsertResponsibleAreaTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertResponsibleAreaTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertResponsibleAreaTabMutation, { data, loading, error }] = useUpsertResponsibleAreaTabMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      areaId: // value for 'areaId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpsertResponsibleAreaTabMutation(baseOptions?: Apollo.MutationHookOptions<UpsertResponsibleAreaTabMutation, UpsertResponsibleAreaTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertResponsibleAreaTabMutation, UpsertResponsibleAreaTabMutationVariables>(UpsertResponsibleAreaTabDocument, options);
      }
export type UpsertResponsibleAreaTabMutationHookResult = ReturnType<typeof useUpsertResponsibleAreaTabMutation>;
export type UpsertResponsibleAreaTabMutationResult = Apollo.MutationResult<UpsertResponsibleAreaTabMutation>;
export type UpsertResponsibleAreaTabMutationOptions = Apollo.BaseMutationOptions<UpsertResponsibleAreaTabMutation, UpsertResponsibleAreaTabMutationVariables>;
export const PersonResponsibleUserTabDocument = gql`
    query PersonResponsibleUserTab($personId: Int!) {
  person(id: $personId) {
    id
    fullName
    userResponsibilites {
      hash
      nodes {
        ct
        id
        user {
          id
        }
        person {
          id
          fullName
        }
        responsibleArea {
          id
          code
          ct
          heading
        }
      }
    }
  }
}
    `;

/**
 * __usePersonResponsibleUserTabQuery__
 *
 * To run a query within a React component, call `usePersonResponsibleUserTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonResponsibleUserTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonResponsibleUserTabQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonResponsibleUserTabQuery(baseOptions: Apollo.QueryHookOptions<PersonResponsibleUserTabQuery, PersonResponsibleUserTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonResponsibleUserTabQuery, PersonResponsibleUserTabQueryVariables>(PersonResponsibleUserTabDocument, options);
      }
export function usePersonResponsibleUserTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonResponsibleUserTabQuery, PersonResponsibleUserTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonResponsibleUserTabQuery, PersonResponsibleUserTabQueryVariables>(PersonResponsibleUserTabDocument, options);
        }
export type PersonResponsibleUserTabQueryHookResult = ReturnType<typeof usePersonResponsibleUserTabQuery>;
export type PersonResponsibleUserTabLazyQueryHookResult = ReturnType<typeof usePersonResponsibleUserTabLazyQuery>;
export type PersonResponsibleUserTabQueryResult = Apollo.QueryResult<PersonResponsibleUserTabQuery, PersonResponsibleUserTabQueryVariables>;
export const GetResponsibleUsersTabDocument = gql`
    query GetResponsibleUsersTab {
  users {
    hash
    nodes {
      id
      fullname
    }
  }
  responsibleAreas {
    hash
    nodes {
      id
      code
      heading
    }
  }
}
    `;

/**
 * __useGetResponsibleUsersTabQuery__
 *
 * To run a query within a React component, call `useGetResponsibleUsersTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResponsibleUsersTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResponsibleUsersTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResponsibleUsersTabQuery(baseOptions?: Apollo.QueryHookOptions<GetResponsibleUsersTabQuery, GetResponsibleUsersTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResponsibleUsersTabQuery, GetResponsibleUsersTabQueryVariables>(GetResponsibleUsersTabDocument, options);
      }
export function useGetResponsibleUsersTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResponsibleUsersTabQuery, GetResponsibleUsersTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResponsibleUsersTabQuery, GetResponsibleUsersTabQueryVariables>(GetResponsibleUsersTabDocument, options);
        }
export type GetResponsibleUsersTabQueryHookResult = ReturnType<typeof useGetResponsibleUsersTabQuery>;
export type GetResponsibleUsersTabLazyQueryHookResult = ReturnType<typeof useGetResponsibleUsersTabLazyQuery>;
export type GetResponsibleUsersTabQueryResult = Apollo.QueryResult<GetResponsibleUsersTabQuery, GetResponsibleUsersTabQueryVariables>;
export const RemoveResponsibleAreaMutationDocument = gql`
    mutation RemoveResponsibleAreaMutation($persId: Int!, $areaId: Int!) {
  removeResponsibleArea(persId: $persId, areaId: $areaId)
}
    `;
export type RemoveResponsibleAreaMutationMutationFn = Apollo.MutationFunction<RemoveResponsibleAreaMutationMutation, RemoveResponsibleAreaMutationMutationVariables>;

/**
 * __useRemoveResponsibleAreaMutationMutation__
 *
 * To run a mutation, you first call `useRemoveResponsibleAreaMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResponsibleAreaMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResponsibleAreaMutationMutation, { data, loading, error }] = useRemoveResponsibleAreaMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      areaId: // value for 'areaId'
 *   },
 * });
 */
export function useRemoveResponsibleAreaMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveResponsibleAreaMutationMutation, RemoveResponsibleAreaMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveResponsibleAreaMutationMutation, RemoveResponsibleAreaMutationMutationVariables>(RemoveResponsibleAreaMutationDocument, options);
      }
export type RemoveResponsibleAreaMutationMutationHookResult = ReturnType<typeof useRemoveResponsibleAreaMutationMutation>;
export type RemoveResponsibleAreaMutationMutationResult = Apollo.MutationResult<RemoveResponsibleAreaMutationMutation>;
export type RemoveResponsibleAreaMutationMutationOptions = Apollo.BaseMutationOptions<RemoveResponsibleAreaMutationMutation, RemoveResponsibleAreaMutationMutationVariables>;
export const PersonDetailSegmentationTabQueryDocument = gql`
    query PersonDetailSegmentationTabQuery($personId: Int!) {
  allowMultiple: instanceSetting(type: PRODUCT_SEGMENTATION_MULTIPLE) {
    code
    value
  }
  person(id: $personId) {
    id
    fullName
    productSegmentations {
      hash
      totalCount
      nodes {
        ...PersonDetailSegmentationFragment
      }
    }
  }
}
    ${PersonDetailSegmentationFragmentFragmentDoc}`;

/**
 * __usePersonDetailSegmentationTabQueryQuery__
 *
 * To run a query within a React component, call `usePersonDetailSegmentationTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonDetailSegmentationTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonDetailSegmentationTabQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonDetailSegmentationTabQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonDetailSegmentationTabQueryQuery, PersonDetailSegmentationTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonDetailSegmentationTabQueryQuery, PersonDetailSegmentationTabQueryQueryVariables>(PersonDetailSegmentationTabQueryDocument, options);
      }
export function usePersonDetailSegmentationTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonDetailSegmentationTabQueryQuery, PersonDetailSegmentationTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonDetailSegmentationTabQueryQuery, PersonDetailSegmentationTabQueryQueryVariables>(PersonDetailSegmentationTabQueryDocument, options);
        }
export type PersonDetailSegmentationTabQueryQueryHookResult = ReturnType<typeof usePersonDetailSegmentationTabQueryQuery>;
export type PersonDetailSegmentationTabQueryLazyQueryHookResult = ReturnType<typeof usePersonDetailSegmentationTabQueryLazyQuery>;
export type PersonDetailSegmentationTabQueryQueryResult = Apollo.QueryResult<PersonDetailSegmentationTabQueryQuery, PersonDetailSegmentationTabQueryQueryVariables>;
export const RemoveProductSegmentationTabDocument = gql`
    mutation RemoveProductSegmentationTab($personId: Int!, $productId: Int!) {
  removeProductSegmentation(personId: $personId, productId: $productId)
}
    `;
export type RemoveProductSegmentationTabMutationFn = Apollo.MutationFunction<RemoveProductSegmentationTabMutation, RemoveProductSegmentationTabMutationVariables>;

/**
 * __useRemoveProductSegmentationTabMutation__
 *
 * To run a mutation, you first call `useRemoveProductSegmentationTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductSegmentationTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductSegmentationTabMutation, { data, loading, error }] = useRemoveProductSegmentationTabMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useRemoveProductSegmentationTabMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductSegmentationTabMutation, RemoveProductSegmentationTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductSegmentationTabMutation, RemoveProductSegmentationTabMutationVariables>(RemoveProductSegmentationTabDocument, options);
      }
export type RemoveProductSegmentationTabMutationHookResult = ReturnType<typeof useRemoveProductSegmentationTabMutation>;
export type RemoveProductSegmentationTabMutationResult = Apollo.MutationResult<RemoveProductSegmentationTabMutation>;
export type RemoveProductSegmentationTabMutationOptions = Apollo.BaseMutationOptions<RemoveProductSegmentationTabMutation, RemoveProductSegmentationTabMutationVariables>;
export const AddProductSegmentationTabDocument = gql`
    mutation AddProductSegmentationTab($personId: Int!, $productId: Int!, $segmentationCode: Int!) {
  addProductSegmentation(
    personId: $personId
    productId: $productId
    segmentationCodeId: $segmentationCode
  ) {
    id
    person {
      id
      productSegmentations {
        hash
        nodes {
          ...PersonDetailSegmentationFragment
        }
      }
    }
  }
}
    ${PersonDetailSegmentationFragmentFragmentDoc}`;
export type AddProductSegmentationTabMutationFn = Apollo.MutationFunction<AddProductSegmentationTabMutation, AddProductSegmentationTabMutationVariables>;

/**
 * __useAddProductSegmentationTabMutation__
 *
 * To run a mutation, you first call `useAddProductSegmentationTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductSegmentationTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductSegmentationTabMutation, { data, loading, error }] = useAddProductSegmentationTabMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      productId: // value for 'productId'
 *      segmentationCode: // value for 'segmentationCode'
 *   },
 * });
 */
export function useAddProductSegmentationTabMutation(baseOptions?: Apollo.MutationHookOptions<AddProductSegmentationTabMutation, AddProductSegmentationTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductSegmentationTabMutation, AddProductSegmentationTabMutationVariables>(AddProductSegmentationTabDocument, options);
      }
export type AddProductSegmentationTabMutationHookResult = ReturnType<typeof useAddProductSegmentationTabMutation>;
export type AddProductSegmentationTabMutationResult = Apollo.MutationResult<AddProductSegmentationTabMutation>;
export type AddProductSegmentationTabMutationOptions = Apollo.BaseMutationOptions<AddProductSegmentationTabMutation, AddProductSegmentationTabMutationVariables>;
export const PersonProductSegmentationModalDataDocument = gql`
    query PersonProductSegmentationModalData {
  products(criteria: {}) {
    hash
    nodes {
      id
      heading
      strength
    }
  }
  segmentationCodes {
    hash
    nodes {
      id
      code
      description
      heading
    }
  }
}
    `;

/**
 * __usePersonProductSegmentationModalDataQuery__
 *
 * To run a query within a React component, call `usePersonProductSegmentationModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonProductSegmentationModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonProductSegmentationModalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePersonProductSegmentationModalDataQuery(baseOptions?: Apollo.QueryHookOptions<PersonProductSegmentationModalDataQuery, PersonProductSegmentationModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonProductSegmentationModalDataQuery, PersonProductSegmentationModalDataQueryVariables>(PersonProductSegmentationModalDataDocument, options);
      }
export function usePersonProductSegmentationModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonProductSegmentationModalDataQuery, PersonProductSegmentationModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonProductSegmentationModalDataQuery, PersonProductSegmentationModalDataQueryVariables>(PersonProductSegmentationModalDataDocument, options);
        }
export type PersonProductSegmentationModalDataQueryHookResult = ReturnType<typeof usePersonProductSegmentationModalDataQuery>;
export type PersonProductSegmentationModalDataLazyQueryHookResult = ReturnType<typeof usePersonProductSegmentationModalDataLazyQuery>;
export type PersonProductSegmentationModalDataQueryResult = Apollo.QueryResult<PersonProductSegmentationModalDataQuery, PersonProductSegmentationModalDataQueryVariables>;
export const SegmentationCodesTabQueryDocument = gql`
    query SegmentationCodesTabQuery($personId: Int!) {
  person(id: $personId) {
    id
    segmentationCode {
      id
      heading
    }
  }
  segmentationCodes {
    hash
    nodes {
      code
      id
      description
      heading
    }
  }
}
    `;

/**
 * __useSegmentationCodesTabQueryQuery__
 *
 * To run a query within a React component, call `useSegmentationCodesTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentationCodesTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentationCodesTabQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useSegmentationCodesTabQueryQuery(baseOptions: Apollo.QueryHookOptions<SegmentationCodesTabQueryQuery, SegmentationCodesTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentationCodesTabQueryQuery, SegmentationCodesTabQueryQueryVariables>(SegmentationCodesTabQueryDocument, options);
      }
export function useSegmentationCodesTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentationCodesTabQueryQuery, SegmentationCodesTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentationCodesTabQueryQuery, SegmentationCodesTabQueryQueryVariables>(SegmentationCodesTabQueryDocument, options);
        }
export type SegmentationCodesTabQueryQueryHookResult = ReturnType<typeof useSegmentationCodesTabQueryQuery>;
export type SegmentationCodesTabQueryLazyQueryHookResult = ReturnType<typeof useSegmentationCodesTabQueryLazyQuery>;
export type SegmentationCodesTabQueryQueryResult = Apollo.QueryResult<SegmentationCodesTabQueryQuery, SegmentationCodesTabQueryQueryVariables>;
export const removeHcpSegmentationCodeDocument = gql`
    mutation removeHcpSegmentationCode($id: Int!) {
  removeSegmentationCode(personId: $id)
}
    `;
export type removeHcpSegmentationCodeMutationFn = Apollo.MutationFunction<removeHcpSegmentationCodeMutation, removeHcpSegmentationCodeMutationVariables>;

/**
 * __useremoveHcpSegmentationCodeMutation__
 *
 * To run a mutation, you first call `useremoveHcpSegmentationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useremoveHcpSegmentationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHcpSegmentationCodeMutation, { data, loading, error }] = useremoveHcpSegmentationCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useremoveHcpSegmentationCodeMutation(baseOptions?: Apollo.MutationHookOptions<removeHcpSegmentationCodeMutation, removeHcpSegmentationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<removeHcpSegmentationCodeMutation, removeHcpSegmentationCodeMutationVariables>(removeHcpSegmentationCodeDocument, options);
      }
export type removeHcpSegmentationCodeMutationHookResult = ReturnType<typeof useremoveHcpSegmentationCodeMutation>;
export type removeHcpSegmentationCodeMutationResult = Apollo.MutationResult<removeHcpSegmentationCodeMutation>;
export type removeHcpSegmentationCodeMutationOptions = Apollo.BaseMutationOptions<removeHcpSegmentationCodeMutation, removeHcpSegmentationCodeMutationVariables>;
export const UpsertSegmentationCodeTabDocument = gql`
    mutation UpsertSegmentationCodeTab($id: Int!, $segmentationId: Int!) {
  upsertPersonSegmentationCode(id: $id, segmentationId: $segmentationId) {
    id
    segmentationCode {
      id
      code
      heading
    }
  }
}
    `;
export type UpsertSegmentationCodeTabMutationFn = Apollo.MutationFunction<UpsertSegmentationCodeTabMutation, UpsertSegmentationCodeTabMutationVariables>;

/**
 * __useUpsertSegmentationCodeTabMutation__
 *
 * To run a mutation, you first call `useUpsertSegmentationCodeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSegmentationCodeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSegmentationCodeTabMutation, { data, loading, error }] = useUpsertSegmentationCodeTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useUpsertSegmentationCodeTabMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSegmentationCodeTabMutation, UpsertSegmentationCodeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSegmentationCodeTabMutation, UpsertSegmentationCodeTabMutationVariables>(UpsertSegmentationCodeTabDocument, options);
      }
export type UpsertSegmentationCodeTabMutationHookResult = ReturnType<typeof useUpsertSegmentationCodeTabMutation>;
export type UpsertSegmentationCodeTabMutationResult = Apollo.MutationResult<UpsertSegmentationCodeTabMutation>;
export type UpsertSegmentationCodeTabMutationOptions = Apollo.BaseMutationOptions<UpsertSegmentationCodeTabMutation, UpsertSegmentationCodeTabMutationVariables>;
export const SegmentationsettingsQueryDocument = gql`
    query SegmentationsettingsQuery {
  product: instanceSetting(type: PRODUCT_SEGMENTATION) {
    code
    value
  }
  person: instanceSetting(type: PERSON_SEGMENTATION) {
    code
    value
  }
}
    `;

/**
 * __useSegmentationsettingsQueryQuery__
 *
 * To run a query within a React component, call `useSegmentationsettingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSegmentationsettingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSegmentationsettingsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSegmentationsettingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SegmentationsettingsQueryQuery, SegmentationsettingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SegmentationsettingsQueryQuery, SegmentationsettingsQueryQueryVariables>(SegmentationsettingsQueryDocument, options);
      }
export function useSegmentationsettingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SegmentationsettingsQueryQuery, SegmentationsettingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SegmentationsettingsQueryQuery, SegmentationsettingsQueryQueryVariables>(SegmentationsettingsQueryDocument, options);
        }
export type SegmentationsettingsQueryQueryHookResult = ReturnType<typeof useSegmentationsettingsQueryQuery>;
export type SegmentationsettingsQueryLazyQueryHookResult = ReturnType<typeof useSegmentationsettingsQueryLazyQuery>;
export type SegmentationsettingsQueryQueryResult = Apollo.QueryResult<SegmentationsettingsQueryQuery, SegmentationsettingsQueryQueryVariables>;
export const UpdatePersonFilterCodeTabMutationDocument = gql`
    mutation UpdatePersonFilterCodeTabMutation($persId: Int!, $filterCodeIds: [Int!]!) {
  updatePersonFilterCode(personId: $persId, filterCodeIds: $filterCodeIds) {
    id
    person {
      id
      filterCodes {
        hash
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type UpdatePersonFilterCodeTabMutationMutationFn = Apollo.MutationFunction<UpdatePersonFilterCodeTabMutationMutation, UpdatePersonFilterCodeTabMutationMutationVariables>;

/**
 * __useUpdatePersonFilterCodeTabMutationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonFilterCodeTabMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonFilterCodeTabMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonFilterCodeTabMutationMutation, { data, loading, error }] = useUpdatePersonFilterCodeTabMutationMutation({
 *   variables: {
 *      persId: // value for 'persId'
 *      filterCodeIds: // value for 'filterCodeIds'
 *   },
 * });
 */
export function useUpdatePersonFilterCodeTabMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonFilterCodeTabMutationMutation, UpdatePersonFilterCodeTabMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonFilterCodeTabMutationMutation, UpdatePersonFilterCodeTabMutationMutationVariables>(UpdatePersonFilterCodeTabMutationDocument, options);
      }
export type UpdatePersonFilterCodeTabMutationMutationHookResult = ReturnType<typeof useUpdatePersonFilterCodeTabMutationMutation>;
export type UpdatePersonFilterCodeTabMutationMutationResult = Apollo.MutationResult<UpdatePersonFilterCodeTabMutationMutation>;
export type UpdatePersonFilterCodeTabMutationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonFilterCodeTabMutationMutation, UpdatePersonFilterCodeTabMutationMutationVariables>;
export const FilterCodesSearchTabQueryDocument = gql`
    query FilterCodesSearchTabQuery($search: String) {
  filterCodeTypes(criteria: {filterCodeTypeOrFilterCodeLabel: $search}) {
    hash
    nodes {
      id
      code
      heading
      getFilterCodesByTypeId(criteria: {header: $search}) {
        hash
        totalCount
        nodes {
          id
          header
        }
      }
    }
  }
}
    `;

/**
 * __useFilterCodesSearchTabQueryQuery__
 *
 * To run a query within a React component, call `useFilterCodesSearchTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCodesSearchTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCodesSearchTabQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFilterCodesSearchTabQueryQuery(baseOptions?: Apollo.QueryHookOptions<FilterCodesSearchTabQueryQuery, FilterCodesSearchTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCodesSearchTabQueryQuery, FilterCodesSearchTabQueryQueryVariables>(FilterCodesSearchTabQueryDocument, options);
      }
export function useFilterCodesSearchTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCodesSearchTabQueryQuery, FilterCodesSearchTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCodesSearchTabQueryQuery, FilterCodesSearchTabQueryQueryVariables>(FilterCodesSearchTabQueryDocument, options);
        }
export type FilterCodesSearchTabQueryQueryHookResult = ReturnType<typeof useFilterCodesSearchTabQueryQuery>;
export type FilterCodesSearchTabQueryLazyQueryHookResult = ReturnType<typeof useFilterCodesSearchTabQueryLazyQuery>;
export type FilterCodesSearchTabQueryQueryResult = Apollo.QueryResult<FilterCodesSearchTabQueryQuery, FilterCodesSearchTabQueryQueryVariables>;
export const PersonFilterCodesTabQueryDocument = gql`
    query PersonFilterCodesTabQuery($personId: Int!) {
  person(id: $personId) {
    id
    filterCodes {
      hash
      nodes {
        id
        filterCodeTypeId
        header
      }
    }
  }
}
    `;

/**
 * __usePersonFilterCodesTabQueryQuery__
 *
 * To run a query within a React component, call `usePersonFilterCodesTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonFilterCodesTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonFilterCodesTabQueryQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function usePersonFilterCodesTabQueryQuery(baseOptions: Apollo.QueryHookOptions<PersonFilterCodesTabQueryQuery, PersonFilterCodesTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonFilterCodesTabQueryQuery, PersonFilterCodesTabQueryQueryVariables>(PersonFilterCodesTabQueryDocument, options);
      }
export function usePersonFilterCodesTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonFilterCodesTabQueryQuery, PersonFilterCodesTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonFilterCodesTabQueryQuery, PersonFilterCodesTabQueryQueryVariables>(PersonFilterCodesTabQueryDocument, options);
        }
export type PersonFilterCodesTabQueryQueryHookResult = ReturnType<typeof usePersonFilterCodesTabQueryQuery>;
export type PersonFilterCodesTabQueryLazyQueryHookResult = ReturnType<typeof usePersonFilterCodesTabQueryLazyQuery>;
export type PersonFilterCodesTabQueryQueryResult = Apollo.QueryResult<PersonFilterCodesTabQueryQuery, PersonFilterCodesTabQueryQueryVariables>;
export const SiteExternalIdsQueryDocument = gql`
    query SiteExternalIdsQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    externalIds {
      hash
      nodes {
        id
        externalId
        type {
          id
          heading
          isHeadingKey
          description: note
        }
      }
    }
  }
}
    `;

/**
 * __useSiteExternalIdsQueryQuery__
 *
 * To run a query within a React component, call `useSiteExternalIdsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteExternalIdsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteExternalIdsQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteExternalIdsQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>(SiteExternalIdsQueryDocument, options);
      }
export function useSiteExternalIdsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>(SiteExternalIdsQueryDocument, options);
        }
export type SiteExternalIdsQueryQueryHookResult = ReturnType<typeof useSiteExternalIdsQueryQuery>;
export type SiteExternalIdsQueryLazyQueryHookResult = ReturnType<typeof useSiteExternalIdsQueryLazyQuery>;
export type SiteExternalIdsQueryQueryResult = Apollo.QueryResult<SiteExternalIdsQueryQuery, SiteExternalIdsQueryQueryVariables>;
export const SiteSegmentationCodesTabQueryDocument = gql`
    query SiteSegmentationCodesTabQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    siteSegmentationCode {
      id
      heading
    }
  }
  segmentationCodes {
    hash
    nodes {
      code
      id
      description
      heading
    }
  }
}
    `;

/**
 * __useSiteSegmentationCodesTabQueryQuery__
 *
 * To run a query within a React component, call `useSiteSegmentationCodesTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSegmentationCodesTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSegmentationCodesTabQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteSegmentationCodesTabQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteSegmentationCodesTabQueryQuery, SiteSegmentationCodesTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteSegmentationCodesTabQueryQuery, SiteSegmentationCodesTabQueryQueryVariables>(SiteSegmentationCodesTabQueryDocument, options);
      }
export function useSiteSegmentationCodesTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteSegmentationCodesTabQueryQuery, SiteSegmentationCodesTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteSegmentationCodesTabQueryQuery, SiteSegmentationCodesTabQueryQueryVariables>(SiteSegmentationCodesTabQueryDocument, options);
        }
export type SiteSegmentationCodesTabQueryQueryHookResult = ReturnType<typeof useSiteSegmentationCodesTabQueryQuery>;
export type SiteSegmentationCodesTabQueryLazyQueryHookResult = ReturnType<typeof useSiteSegmentationCodesTabQueryLazyQuery>;
export type SiteSegmentationCodesTabQueryQueryResult = Apollo.QueryResult<SiteSegmentationCodesTabQueryQuery, SiteSegmentationCodesTabQueryQueryVariables>;
export const UpsertSiteSegmentationCodeTabDocument = gql`
    mutation UpsertSiteSegmentationCodeTab($id: Int!, $segmentationId: Int!) {
  upsertSiteSegmentationCode(siteId: $id, segmentationCodeId: $segmentationId) {
    id
    segmentationCode {
      id
      code
      heading
    }
  }
}
    `;
export type UpsertSiteSegmentationCodeTabMutationFn = Apollo.MutationFunction<UpsertSiteSegmentationCodeTabMutation, UpsertSiteSegmentationCodeTabMutationVariables>;

/**
 * __useUpsertSiteSegmentationCodeTabMutation__
 *
 * To run a mutation, you first call `useUpsertSiteSegmentationCodeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSiteSegmentationCodeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSiteSegmentationCodeTabMutation, { data, loading, error }] = useUpsertSiteSegmentationCodeTabMutation({
 *   variables: {
 *      id: // value for 'id'
 *      segmentationId: // value for 'segmentationId'
 *   },
 * });
 */
export function useUpsertSiteSegmentationCodeTabMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSiteSegmentationCodeTabMutation, UpsertSiteSegmentationCodeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSiteSegmentationCodeTabMutation, UpsertSiteSegmentationCodeTabMutationVariables>(UpsertSiteSegmentationCodeTabDocument, options);
      }
export type UpsertSiteSegmentationCodeTabMutationHookResult = ReturnType<typeof useUpsertSiteSegmentationCodeTabMutation>;
export type UpsertSiteSegmentationCodeTabMutationResult = Apollo.MutationResult<UpsertSiteSegmentationCodeTabMutation>;
export type UpsertSiteSegmentationCodeTabMutationOptions = Apollo.BaseMutationOptions<UpsertSiteSegmentationCodeTabMutation, UpsertSiteSegmentationCodeTabMutationVariables>;
export const RemoveHcoTabSegmentationCodeMutationDocument = gql`
    mutation RemoveHcoTabSegmentationCodeMutation($id: Int!) {
  removeSiteSegmentation(id: $id) {
    id
  }
}
    `;
export type RemoveHcoTabSegmentationCodeMutationMutationFn = Apollo.MutationFunction<RemoveHcoTabSegmentationCodeMutationMutation, RemoveHcoTabSegmentationCodeMutationMutationVariables>;

/**
 * __useRemoveHcoTabSegmentationCodeMutationMutation__
 *
 * To run a mutation, you first call `useRemoveHcoTabSegmentationCodeMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHcoTabSegmentationCodeMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHcoTabSegmentationCodeMutationMutation, { data, loading, error }] = useRemoveHcoTabSegmentationCodeMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveHcoTabSegmentationCodeMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveHcoTabSegmentationCodeMutationMutation, RemoveHcoTabSegmentationCodeMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveHcoTabSegmentationCodeMutationMutation, RemoveHcoTabSegmentationCodeMutationMutationVariables>(RemoveHcoTabSegmentationCodeMutationDocument, options);
      }
export type RemoveHcoTabSegmentationCodeMutationMutationHookResult = ReturnType<typeof useRemoveHcoTabSegmentationCodeMutationMutation>;
export type RemoveHcoTabSegmentationCodeMutationMutationResult = Apollo.MutationResult<RemoveHcoTabSegmentationCodeMutationMutation>;
export type RemoveHcoTabSegmentationCodeMutationMutationOptions = Apollo.BaseMutationOptions<RemoveHcoTabSegmentationCodeMutationMutation, RemoveHcoTabSegmentationCodeMutationMutationVariables>;
export const UpdateSiteFilterCodeTabMutationDocument = gql`
    mutation UpdateSiteFilterCodeTabMutation($siteId: Int!, $filterCodeIds: [Int!]!) {
  updateSiteFilterCode(siteId: $siteId, filterCodeIds: $filterCodeIds) {
    id
    site {
      id
      filterCodes {
        hash
        nodes {
          id
        }
      }
    }
  }
}
    `;
export type UpdateSiteFilterCodeTabMutationMutationFn = Apollo.MutationFunction<UpdateSiteFilterCodeTabMutationMutation, UpdateSiteFilterCodeTabMutationMutationVariables>;

/**
 * __useUpdateSiteFilterCodeTabMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteFilterCodeTabMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteFilterCodeTabMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteFilterCodeTabMutationMutation, { data, loading, error }] = useUpdateSiteFilterCodeTabMutationMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      filterCodeIds: // value for 'filterCodeIds'
 *   },
 * });
 */
export function useUpdateSiteFilterCodeTabMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteFilterCodeTabMutationMutation, UpdateSiteFilterCodeTabMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteFilterCodeTabMutationMutation, UpdateSiteFilterCodeTabMutationMutationVariables>(UpdateSiteFilterCodeTabMutationDocument, options);
      }
export type UpdateSiteFilterCodeTabMutationMutationHookResult = ReturnType<typeof useUpdateSiteFilterCodeTabMutationMutation>;
export type UpdateSiteFilterCodeTabMutationMutationResult = Apollo.MutationResult<UpdateSiteFilterCodeTabMutationMutation>;
export type UpdateSiteFilterCodeTabMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteFilterCodeTabMutationMutation, UpdateSiteFilterCodeTabMutationMutationVariables>;
export const SiteFilterCodesSearchTabQueryDocument = gql`
    query SiteFilterCodesSearchTabQuery($search: String) {
  filterCodeTypes(criteria: {filterCodeTypeOrFilterCodeLabel: $search}) {
    hash
    nodes {
      id
      code
      heading
      getFilterCodesByTypeId(criteria: {header: $search}) {
        hash
        totalCount
        nodes {
          id
          header
        }
      }
    }
  }
}
    `;

/**
 * __useSiteFilterCodesSearchTabQueryQuery__
 *
 * To run a query within a React component, call `useSiteFilterCodesSearchTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteFilterCodesSearchTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteFilterCodesSearchTabQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSiteFilterCodesSearchTabQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteFilterCodesSearchTabQueryQuery, SiteFilterCodesSearchTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteFilterCodesSearchTabQueryQuery, SiteFilterCodesSearchTabQueryQueryVariables>(SiteFilterCodesSearchTabQueryDocument, options);
      }
export function useSiteFilterCodesSearchTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteFilterCodesSearchTabQueryQuery, SiteFilterCodesSearchTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteFilterCodesSearchTabQueryQuery, SiteFilterCodesSearchTabQueryQueryVariables>(SiteFilterCodesSearchTabQueryDocument, options);
        }
export type SiteFilterCodesSearchTabQueryQueryHookResult = ReturnType<typeof useSiteFilterCodesSearchTabQueryQuery>;
export type SiteFilterCodesSearchTabQueryLazyQueryHookResult = ReturnType<typeof useSiteFilterCodesSearchTabQueryLazyQuery>;
export type SiteFilterCodesSearchTabQueryQueryResult = Apollo.QueryResult<SiteFilterCodesSearchTabQueryQuery, SiteFilterCodesSearchTabQueryQueryVariables>;
export const SiteFilterCodesTabQueryDocument = gql`
    query SiteFilterCodesTabQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    filterCodes {
      hash
      nodes {
        id
        filterCodeTypeId
        header
      }
    }
  }
}
    `;

/**
 * __useSiteFilterCodesTabQueryQuery__
 *
 * To run a query within a React component, call `useSiteFilterCodesTabQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteFilterCodesTabQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteFilterCodesTabQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteFilterCodesTabQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteFilterCodesTabQueryQuery, SiteFilterCodesTabQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteFilterCodesTabQueryQuery, SiteFilterCodesTabQueryQueryVariables>(SiteFilterCodesTabQueryDocument, options);
      }
export function useSiteFilterCodesTabQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteFilterCodesTabQueryQuery, SiteFilterCodesTabQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteFilterCodesTabQueryQuery, SiteFilterCodesTabQueryQueryVariables>(SiteFilterCodesTabQueryDocument, options);
        }
export type SiteFilterCodesTabQueryQueryHookResult = ReturnType<typeof useSiteFilterCodesTabQueryQuery>;
export type SiteFilterCodesTabQueryLazyQueryHookResult = ReturnType<typeof useSiteFilterCodesTabQueryLazyQuery>;
export type SiteFilterCodesTabQueryQueryResult = Apollo.QueryResult<SiteFilterCodesTabQueryQuery, SiteFilterCodesTabQueryQueryVariables>;
export const EntityRelationTabsQueryDocument = gql`
    query EntityRelationTabsQuery($configurationId: ID!) {
  entityGridItemRelationFields(
    criteria: {entityGridItemConfigurationId: $configurationId}
  ) {
    hash
    nodes {
      id
      relationTabKey
    }
  }
}
    `;

/**
 * __useEntityRelationTabsQueryQuery__
 *
 * To run a query within a React component, call `useEntityRelationTabsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRelationTabsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRelationTabsQueryQuery({
 *   variables: {
 *      configurationId: // value for 'configurationId'
 *   },
 * });
 */
export function useEntityRelationTabsQueryQuery(baseOptions: Apollo.QueryHookOptions<EntityRelationTabsQueryQuery, EntityRelationTabsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRelationTabsQueryQuery, EntityRelationTabsQueryQueryVariables>(EntityRelationTabsQueryDocument, options);
      }
export function useEntityRelationTabsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRelationTabsQueryQuery, EntityRelationTabsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRelationTabsQueryQuery, EntityRelationTabsQueryQueryVariables>(EntityRelationTabsQueryDocument, options);
        }
export type EntityRelationTabsQueryQueryHookResult = ReturnType<typeof useEntityRelationTabsQueryQuery>;
export type EntityRelationTabsQueryLazyQueryHookResult = ReturnType<typeof useEntityRelationTabsQueryLazyQuery>;
export type EntityRelationTabsQueryQueryResult = Apollo.QueryResult<EntityRelationTabsQueryQuery, EntityRelationTabsQueryQueryVariables>;
export const AvailableFlagsQueryDocument = gql`
    query AvailableFlagsQuery {
  countries {
    hash
    nodes {
      code
    }
  }
}
    `;

/**
 * __useAvailableFlagsQueryQuery__
 *
 * To run a query within a React component, call `useAvailableFlagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableFlagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableFlagsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableFlagsQueryQuery(baseOptions?: Apollo.QueryHookOptions<AvailableFlagsQueryQuery, AvailableFlagsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableFlagsQueryQuery, AvailableFlagsQueryQueryVariables>(AvailableFlagsQueryDocument, options);
      }
export function useAvailableFlagsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableFlagsQueryQuery, AvailableFlagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableFlagsQueryQuery, AvailableFlagsQueryQueryVariables>(AvailableFlagsQueryDocument, options);
        }
export type AvailableFlagsQueryQueryHookResult = ReturnType<typeof useAvailableFlagsQueryQuery>;
export type AvailableFlagsQueryLazyQueryHookResult = ReturnType<typeof useAvailableFlagsQueryLazyQuery>;
export type AvailableFlagsQueryQueryResult = Apollo.QueryResult<AvailableFlagsQueryQuery, AvailableFlagsQueryQueryVariables>;
export const CountriesQueryDocument = gql`
    query CountriesQuery($search: String) {
  countries(
    criteria: {label: $search, ordering: [ALPHABETICALLY], fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      id: code
      label
    }
  }
}
    `;

/**
 * __useCountriesQueryQuery__
 *
 * To run a query within a React component, call `useCountriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCountriesQueryQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQueryQuery, CountriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQueryQuery, CountriesQueryQueryVariables>(CountriesQueryDocument, options);
      }
export function useCountriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQueryQuery, CountriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQueryQuery, CountriesQueryQueryVariables>(CountriesQueryDocument, options);
        }
export type CountriesQueryQueryHookResult = ReturnType<typeof useCountriesQueryQuery>;
export type CountriesQueryLazyQueryHookResult = ReturnType<typeof useCountriesQueryLazyQuery>;
export type CountriesQueryQueryResult = Apollo.QueryResult<CountriesQueryQuery, CountriesQueryQueryVariables>;
export const SelectPersonTypeSuggestionQueryDocument = gql`
    query SelectPersonTypeSuggestionQuery($search: String, $countries: [CountryCode!]) {
  personTypes(
    criteria: {label: $search, countries: $countries, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectPersonTypeSuggestionQueryQuery__
 *
 * To run a query within a React component, call `useSelectPersonTypeSuggestionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPersonTypeSuggestionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPersonTypeSuggestionQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useSelectPersonTypeSuggestionQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectPersonTypeSuggestionQueryQuery, SelectPersonTypeSuggestionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPersonTypeSuggestionQueryQuery, SelectPersonTypeSuggestionQueryQueryVariables>(SelectPersonTypeSuggestionQueryDocument, options);
      }
export function useSelectPersonTypeSuggestionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPersonTypeSuggestionQueryQuery, SelectPersonTypeSuggestionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPersonTypeSuggestionQueryQuery, SelectPersonTypeSuggestionQueryQueryVariables>(SelectPersonTypeSuggestionQueryDocument, options);
        }
export type SelectPersonTypeSuggestionQueryQueryHookResult = ReturnType<typeof useSelectPersonTypeSuggestionQueryQuery>;
export type SelectPersonTypeSuggestionQueryLazyQueryHookResult = ReturnType<typeof useSelectPersonTypeSuggestionQueryLazyQuery>;
export type SelectPersonTypeSuggestionQueryQueryResult = Apollo.QueryResult<SelectPersonTypeSuggestionQueryQuery, SelectPersonTypeSuggestionQueryQueryVariables>;
export const SelectPositionSuggestionsQueryDocument = gql`
    query SelectPositionSuggestionsQuery($search: String, $countryCode: CountryCode) {
  positions(
    criteria: {label: $search, country: $countryCode, fetchSize: {limit: 1000}}
  ) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectPositionSuggestionsQueryQuery__
 *
 * To run a query within a React component, call `useSelectPositionSuggestionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectPositionSuggestionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectPositionSuggestionsQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSelectPositionSuggestionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectPositionSuggestionsQueryQuery, SelectPositionSuggestionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectPositionSuggestionsQueryQuery, SelectPositionSuggestionsQueryQueryVariables>(SelectPositionSuggestionsQueryDocument, options);
      }
export function useSelectPositionSuggestionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectPositionSuggestionsQueryQuery, SelectPositionSuggestionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectPositionSuggestionsQueryQuery, SelectPositionSuggestionsQueryQueryVariables>(SelectPositionSuggestionsQueryDocument, options);
        }
export type SelectPositionSuggestionsQueryQueryHookResult = ReturnType<typeof useSelectPositionSuggestionsQueryQuery>;
export type SelectPositionSuggestionsQueryLazyQueryHookResult = ReturnType<typeof useSelectPositionSuggestionsQueryLazyQuery>;
export type SelectPositionSuggestionsQueryQueryResult = Apollo.QueryResult<SelectPositionSuggestionsQueryQuery, SelectPositionSuggestionsQueryQueryVariables>;
export const SelectSiteTypeQueryDocument = gql`
    query SelectSiteTypeQuery($search: String, $countryCode: CountryCode) {
  siteTypes(criteria: {label: $search, country: $countryCode}) {
    hash
    nodes {
      code
      label: displayLabel
      type
    }
  }
}
    `;

/**
 * __useSelectSiteTypeQueryQuery__
 *
 * To run a query within a React component, call `useSelectSiteTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectSiteTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectSiteTypeQueryQuery({
 *   variables: {
 *      search: // value for 'search'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useSelectSiteTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SelectSiteTypeQueryQuery, SelectSiteTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectSiteTypeQueryQuery, SelectSiteTypeQueryQueryVariables>(SelectSiteTypeQueryDocument, options);
      }
export function useSelectSiteTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectSiteTypeQueryQuery, SelectSiteTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectSiteTypeQueryQuery, SelectSiteTypeQueryQueryVariables>(SelectSiteTypeQueryDocument, options);
        }
export type SelectSiteTypeQueryQueryHookResult = ReturnType<typeof useSelectSiteTypeQueryQuery>;
export type SelectSiteTypeQueryLazyQueryHookResult = ReturnType<typeof useSelectSiteTypeQueryLazyQuery>;
export type SelectSiteTypeQueryQueryResult = Apollo.QueryResult<SelectSiteTypeQueryQuery, SelectSiteTypeQueryQueryVariables>;
export const GetAllFavListsDocument = gql`
    query GetAllFavLists {
  viewer {
    id
    getAllFavoriteLists {
      hash
      totalCount
      nodes {
        id
        title
        sort
        listType {
          id
          code
          color
          ct
          heading
          note
          status
          ut
        }
        entityType {
          id
          code
          heading
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllFavListsQuery__
 *
 * To run a query within a React component, call `useGetAllFavListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFavListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFavListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFavListsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFavListsQuery, GetAllFavListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFavListsQuery, GetAllFavListsQueryVariables>(GetAllFavListsDocument, options);
      }
export function useGetAllFavListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFavListsQuery, GetAllFavListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFavListsQuery, GetAllFavListsQueryVariables>(GetAllFavListsDocument, options);
        }
export type GetAllFavListsQueryHookResult = ReturnType<typeof useGetAllFavListsQuery>;
export type GetAllFavListsLazyQueryHookResult = ReturnType<typeof useGetAllFavListsLazyQuery>;
export type GetAllFavListsQueryResult = Apollo.QueryResult<GetAllFavListsQuery, GetAllFavListsQueryVariables>;
export const UpdateFavSortMutationDocument = gql`
    mutation UpdateFavSortMutation($input: [UserFavInput!]!) {
  updateFavSort(input: $input)
}
    `;
export type UpdateFavSortMutationMutationFn = Apollo.MutationFunction<UpdateFavSortMutationMutation, UpdateFavSortMutationMutationVariables>;

/**
 * __useUpdateFavSortMutationMutation__
 *
 * To run a mutation, you first call `useUpdateFavSortMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavSortMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavSortMutationMutation, { data, loading, error }] = useUpdateFavSortMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFavSortMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavSortMutationMutation, UpdateFavSortMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavSortMutationMutation, UpdateFavSortMutationMutationVariables>(UpdateFavSortMutationDocument, options);
      }
export type UpdateFavSortMutationMutationHookResult = ReturnType<typeof useUpdateFavSortMutationMutation>;
export type UpdateFavSortMutationMutationResult = Apollo.MutationResult<UpdateFavSortMutationMutation>;
export type UpdateFavSortMutationMutationOptions = Apollo.BaseMutationOptions<UpdateFavSortMutationMutation, UpdateFavSortMutationMutationVariables>;
export const PersonElasticMatchDocument = gql`
    query PersonElasticMatch($minScore: Int = 51, $person: PersonMatchInput, $site: SiteMatchInput, $link: SitePersonMatchInput) {
  elasticMatch(
    person: $person
    link: $link
    site: $site
    criteria: {limit: 5, minScore: $minScore}
  ) {
    apurebaseId
    inLocal
    score
    person {
      apurebaseId
      firstName
      lastName
      countryCode
      title
      gender
      personType
    }
    site {
      apurebaseId
      name
    }
    link {
      apurebaseId
      role
      specialty
    }
  }
}
    `;

/**
 * __usePersonElasticMatchQuery__
 *
 * To run a query within a React component, call `usePersonElasticMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonElasticMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonElasticMatchQuery({
 *   variables: {
 *      minScore: // value for 'minScore'
 *      person: // value for 'person'
 *      site: // value for 'site'
 *      link: // value for 'link'
 *   },
 * });
 */
export function usePersonElasticMatchQuery(baseOptions?: Apollo.QueryHookOptions<PersonElasticMatchQuery, PersonElasticMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonElasticMatchQuery, PersonElasticMatchQueryVariables>(PersonElasticMatchDocument, options);
      }
export function usePersonElasticMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonElasticMatchQuery, PersonElasticMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonElasticMatchQuery, PersonElasticMatchQueryVariables>(PersonElasticMatchDocument, options);
        }
export type PersonElasticMatchQueryHookResult = ReturnType<typeof usePersonElasticMatchQuery>;
export type PersonElasticMatchLazyQueryHookResult = ReturnType<typeof usePersonElasticMatchLazyQuery>;
export type PersonElasticMatchQueryResult = Apollo.QueryResult<PersonElasticMatchQuery, PersonElasticMatchQueryVariables>;
export const LiveMatchFetchHCPIdDocument = gql`
    query LiveMatchFetchHCPId($apbId: Int!) {
  persons(criteria: {aPureBaseId: $apbId}) {
    hash
    nodes {
      id
      apurebaseId
    }
  }
}
    `;

/**
 * __useLiveMatchFetchHCPIdQuery__
 *
 * To run a query within a React component, call `useLiveMatchFetchHCPIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveMatchFetchHCPIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMatchFetchHCPIdQuery({
 *   variables: {
 *      apbId: // value for 'apbId'
 *   },
 * });
 */
export function useLiveMatchFetchHCPIdQuery(baseOptions: Apollo.QueryHookOptions<LiveMatchFetchHCPIdQuery, LiveMatchFetchHCPIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveMatchFetchHCPIdQuery, LiveMatchFetchHCPIdQueryVariables>(LiveMatchFetchHCPIdDocument, options);
      }
export function useLiveMatchFetchHCPIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveMatchFetchHCPIdQuery, LiveMatchFetchHCPIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveMatchFetchHCPIdQuery, LiveMatchFetchHCPIdQueryVariables>(LiveMatchFetchHCPIdDocument, options);
        }
export type LiveMatchFetchHCPIdQueryHookResult = ReturnType<typeof useLiveMatchFetchHCPIdQuery>;
export type LiveMatchFetchHCPIdLazyQueryHookResult = ReturnType<typeof useLiveMatchFetchHCPIdLazyQuery>;
export type LiveMatchFetchHCPIdQueryResult = Apollo.QueryResult<LiveMatchFetchHCPIdQuery, LiveMatchFetchHCPIdQueryVariables>;
export const LiveMatchOfficialIdDocument = gql`
    query LiveMatchOfficialId($officialId: String!) {
  externalIds(
    criteria: {entityType: PERSON, externalId: $officialId, externalIdTypeCode: "APB_OFFICIAL"}
  ) {
    hash
    nodes {
      id
      externalId
      entityAffiliation {
        id
        ... on Person {
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useLiveMatchOfficialIdQuery__
 *
 * To run a query within a React component, call `useLiveMatchOfficialIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveMatchOfficialIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveMatchOfficialIdQuery({
 *   variables: {
 *      officialId: // value for 'officialId'
 *   },
 * });
 */
export function useLiveMatchOfficialIdQuery(baseOptions: Apollo.QueryHookOptions<LiveMatchOfficialIdQuery, LiveMatchOfficialIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveMatchOfficialIdQuery, LiveMatchOfficialIdQueryVariables>(LiveMatchOfficialIdDocument, options);
      }
export function useLiveMatchOfficialIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveMatchOfficialIdQuery, LiveMatchOfficialIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveMatchOfficialIdQuery, LiveMatchOfficialIdQueryVariables>(LiveMatchOfficialIdDocument, options);
        }
export type LiveMatchOfficialIdQueryHookResult = ReturnType<typeof useLiveMatchOfficialIdQuery>;
export type LiveMatchOfficialIdLazyQueryHookResult = ReturnType<typeof useLiveMatchOfficialIdLazyQuery>;
export type LiveMatchOfficialIdQueryResult = Apollo.QueryResult<LiveMatchOfficialIdQuery, LiveMatchOfficialIdQueryVariables>;
export const LiveSearchElasticSiteDocument = gql`
    query LiveSearchElasticSite($search: ApiSiteMatchInputSearch!) {
  elasticSiteMatch(search: $search, criteria: {limit: 10, minScore: 0}) {
    apurebaseId
    score
    inLocalDb
    result {
      id
      address
      city
      country
      ct
      name
      people {
        id
        firstname
      }
      site_type
      spc
      status
      ut
      zip
    }
  }
}
    `;

/**
 * __useLiveSearchElasticSiteQuery__
 *
 * To run a query within a React component, call `useLiveSearchElasticSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveSearchElasticSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveSearchElasticSiteQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useLiveSearchElasticSiteQuery(baseOptions: Apollo.QueryHookOptions<LiveSearchElasticSiteQuery, LiveSearchElasticSiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveSearchElasticSiteQuery, LiveSearchElasticSiteQueryVariables>(LiveSearchElasticSiteDocument, options);
      }
export function useLiveSearchElasticSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveSearchElasticSiteQuery, LiveSearchElasticSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveSearchElasticSiteQuery, LiveSearchElasticSiteQueryVariables>(LiveSearchElasticSiteDocument, options);
        }
export type LiveSearchElasticSiteQueryHookResult = ReturnType<typeof useLiveSearchElasticSiteQuery>;
export type LiveSearchElasticSiteLazyQueryHookResult = ReturnType<typeof useLiveSearchElasticSiteLazyQuery>;
export type LiveSearchElasticSiteQueryResult = Apollo.QueryResult<LiveSearchElasticSiteQuery, LiveSearchElasticSiteQueryVariables>;
export const PersonUpdateNoteMutationDocument = gql`
    mutation PersonUpdateNoteMutation($id: Int!, $title: String!, $text: String!, $private: Boolean!) {
  updateNote(id: $id, text: $text, title: $title, private: $private) {
    id
    text
    title
  }
}
    `;
export type PersonUpdateNoteMutationMutationFn = Apollo.MutationFunction<PersonUpdateNoteMutationMutation, PersonUpdateNoteMutationMutationVariables>;

/**
 * __usePersonUpdateNoteMutationMutation__
 *
 * To run a mutation, you first call `usePersonUpdateNoteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonUpdateNoteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personUpdateNoteMutationMutation, { data, loading, error }] = usePersonUpdateNoteMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      private: // value for 'private'
 *   },
 * });
 */
export function usePersonUpdateNoteMutationMutation(baseOptions?: Apollo.MutationHookOptions<PersonUpdateNoteMutationMutation, PersonUpdateNoteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonUpdateNoteMutationMutation, PersonUpdateNoteMutationMutationVariables>(PersonUpdateNoteMutationDocument, options);
      }
export type PersonUpdateNoteMutationMutationHookResult = ReturnType<typeof usePersonUpdateNoteMutationMutation>;
export type PersonUpdateNoteMutationMutationResult = Apollo.MutationResult<PersonUpdateNoteMutationMutation>;
export type PersonUpdateNoteMutationMutationOptions = Apollo.BaseMutationOptions<PersonUpdateNoteMutationMutation, PersonUpdateNoteMutationMutationVariables>;
export const PersonCreateNoteMutationDocument = gql`
    mutation PersonCreateNoteMutation($id: Int!, $title: String!, $text: String!, $private: Boolean!, $entity: EntityTypeEnum!) {
  createNote(
    entityType: $entity
    entityAffiliationId: $id
    text: $text
    title: $title
    private: $private
  ) {
    id
    text
  }
}
    `;
export type PersonCreateNoteMutationMutationFn = Apollo.MutationFunction<PersonCreateNoteMutationMutation, PersonCreateNoteMutationMutationVariables>;

/**
 * __usePersonCreateNoteMutationMutation__
 *
 * To run a mutation, you first call `usePersonCreateNoteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersonCreateNoteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [personCreateNoteMutationMutation, { data, loading, error }] = usePersonCreateNoteMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      private: // value for 'private'
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function usePersonCreateNoteMutationMutation(baseOptions?: Apollo.MutationHookOptions<PersonCreateNoteMutationMutation, PersonCreateNoteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersonCreateNoteMutationMutation, PersonCreateNoteMutationMutationVariables>(PersonCreateNoteMutationDocument, options);
      }
export type PersonCreateNoteMutationMutationHookResult = ReturnType<typeof usePersonCreateNoteMutationMutation>;
export type PersonCreateNoteMutationMutationResult = Apollo.MutationResult<PersonCreateNoteMutationMutation>;
export type PersonCreateNoteMutationMutationOptions = Apollo.BaseMutationOptions<PersonCreateNoteMutationMutation, PersonCreateNoteMutationMutationVariables>;
export const DeletePersonNoteMutationDocument = gql`
    mutation DeletePersonNoteMutation($id: Int!) {
  deleteNote(id: $id)
}
    `;
export type DeletePersonNoteMutationMutationFn = Apollo.MutationFunction<DeletePersonNoteMutationMutation, DeletePersonNoteMutationMutationVariables>;

/**
 * __useDeletePersonNoteMutationMutation__
 *
 * To run a mutation, you first call `useDeletePersonNoteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonNoteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonNoteMutationMutation, { data, loading, error }] = useDeletePersonNoteMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePersonNoteMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonNoteMutationMutation, DeletePersonNoteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonNoteMutationMutation, DeletePersonNoteMutationMutationVariables>(DeletePersonNoteMutationDocument, options);
      }
export type DeletePersonNoteMutationMutationHookResult = ReturnType<typeof useDeletePersonNoteMutationMutation>;
export type DeletePersonNoteMutationMutationResult = Apollo.MutationResult<DeletePersonNoteMutationMutation>;
export type DeletePersonNoteMutationMutationOptions = Apollo.BaseMutationOptions<DeletePersonNoteMutationMutation, DeletePersonNoteMutationMutationVariables>;
export const GetCriteriaDefinitionDocument = gql`
    query GetCriteriaDefinition($entityType: EntityTypeEnum!, $code: String!) {
  criteriaByCode(entityType: $entityType, code: $code) {
    id
    inputPaths {
      hash
      nodes {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCriteriaDefinitionQuery__
 *
 * To run a query within a React component, call `useGetCriteriaDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriteriaDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriteriaDefinitionQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCriteriaDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetCriteriaDefinitionQuery, GetCriteriaDefinitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCriteriaDefinitionQuery, GetCriteriaDefinitionQueryVariables>(GetCriteriaDefinitionDocument, options);
      }
export function useGetCriteriaDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCriteriaDefinitionQuery, GetCriteriaDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCriteriaDefinitionQuery, GetCriteriaDefinitionQueryVariables>(GetCriteriaDefinitionDocument, options);
        }
export type GetCriteriaDefinitionQueryHookResult = ReturnType<typeof useGetCriteriaDefinitionQuery>;
export type GetCriteriaDefinitionLazyQueryHookResult = ReturnType<typeof useGetCriteriaDefinitionLazyQuery>;
export type GetCriteriaDefinitionQueryResult = Apollo.QueryResult<GetCriteriaDefinitionQuery, GetCriteriaDefinitionQueryVariables>;
export const SiteHierarchyQueryDocument = gql`
    query SiteHierarchyQuery($siteId: Int!) {
  site(siteId: $siteId) {
    id
    name
    name2
    parentHierarchy {
      ...HierarchyConnectionFragment
    }
    childrenHierarchy {
      ...HierarchyConnectionFragment
    }
  }
}
    ${HierarchyConnectionFragmentFragmentDoc}`;

/**
 * __useSiteHierarchyQueryQuery__
 *
 * To run a query within a React component, call `useSiteHierarchyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteHierarchyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteHierarchyQueryQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteHierarchyQueryQuery(baseOptions: Apollo.QueryHookOptions<SiteHierarchyQueryQuery, SiteHierarchyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteHierarchyQueryQuery, SiteHierarchyQueryQueryVariables>(SiteHierarchyQueryDocument, options);
      }
export function useSiteHierarchyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteHierarchyQueryQuery, SiteHierarchyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteHierarchyQueryQuery, SiteHierarchyQueryQueryVariables>(SiteHierarchyQueryDocument, options);
        }
export type SiteHierarchyQueryQueryHookResult = ReturnType<typeof useSiteHierarchyQueryQuery>;
export type SiteHierarchyQueryLazyQueryHookResult = ReturnType<typeof useSiteHierarchyQueryLazyQuery>;
export type SiteHierarchyQueryQueryResult = Apollo.QueryResult<SiteHierarchyQueryQuery, SiteHierarchyQueryQueryVariables>;
export const UsersForSelectDocument = gql`
    query UsersForSelect {
  users(criteria: {fetchSize: {limit: 10000}}) {
    hash
    totalCount
    nodes {
      id
      fullname
    }
  }
}
    `;

/**
 * __useUsersForSelectQuery__
 *
 * To run a query within a React component, call `useUsersForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersForSelectQuery(baseOptions?: Apollo.QueryHookOptions<UsersForSelectQuery, UsersForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersForSelectQuery, UsersForSelectQueryVariables>(UsersForSelectDocument, options);
      }
export function useUsersForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersForSelectQuery, UsersForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersForSelectQuery, UsersForSelectQueryVariables>(UsersForSelectDocument, options);
        }
export type UsersForSelectQueryHookResult = ReturnType<typeof useUsersForSelectQuery>;
export type UsersForSelectLazyQueryHookResult = ReturnType<typeof useUsersForSelectLazyQuery>;
export type UsersForSelectQueryResult = Apollo.QueryResult<UsersForSelectQuery, UsersForSelectQueryVariables>;
export const LoadDefaultUserCountriesDocument = gql`
    query LoadDefaultUserCountries {
  viewer {
    id
    user {
      id
      countries {
        hash
        totalCount
        nodes {
          code
        }
      }
    }
  }
  countries {
    hash
    nodes {
      code
    }
  }
}
    `;

/**
 * __useLoadDefaultUserCountriesQuery__
 *
 * To run a query within a React component, call `useLoadDefaultUserCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadDefaultUserCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadDefaultUserCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLoadDefaultUserCountriesQuery(baseOptions?: Apollo.QueryHookOptions<LoadDefaultUserCountriesQuery, LoadDefaultUserCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadDefaultUserCountriesQuery, LoadDefaultUserCountriesQueryVariables>(LoadDefaultUserCountriesDocument, options);
      }
export function useLoadDefaultUserCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadDefaultUserCountriesQuery, LoadDefaultUserCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadDefaultUserCountriesQuery, LoadDefaultUserCountriesQueryVariables>(LoadDefaultUserCountriesDocument, options);
        }
export type LoadDefaultUserCountriesQueryHookResult = ReturnType<typeof useLoadDefaultUserCountriesQuery>;
export type LoadDefaultUserCountriesLazyQueryHookResult = ReturnType<typeof useLoadDefaultUserCountriesLazyQuery>;
export type LoadDefaultUserCountriesQueryResult = Apollo.QueryResult<LoadDefaultUserCountriesQuery, LoadDefaultUserCountriesQueryVariables>;
export const LoadCriteriasByCodesQueryDocument = gql`
    query LoadCriteriasByCodesQuery($entityType: EntityTypeEnum!, $codes: [String!]!) {
  criterias(criteria: {entityType: $entityType, codes: $codes}) {
    hash
    nodes {
      id
      code
      ...CriteriaInputFragment
    }
  }
}
    ${CriteriaInputFragmentFragmentDoc}`;

/**
 * __useLoadCriteriasByCodesQueryQuery__
 *
 * To run a query within a React component, call `useLoadCriteriasByCodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadCriteriasByCodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadCriteriasByCodesQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      codes: // value for 'codes'
 *   },
 * });
 */
export function useLoadCriteriasByCodesQueryQuery(baseOptions: Apollo.QueryHookOptions<LoadCriteriasByCodesQueryQuery, LoadCriteriasByCodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadCriteriasByCodesQueryQuery, LoadCriteriasByCodesQueryQueryVariables>(LoadCriteriasByCodesQueryDocument, options);
      }
export function useLoadCriteriasByCodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadCriteriasByCodesQueryQuery, LoadCriteriasByCodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadCriteriasByCodesQueryQuery, LoadCriteriasByCodesQueryQueryVariables>(LoadCriteriasByCodesQueryDocument, options);
        }
export type LoadCriteriasByCodesQueryQueryHookResult = ReturnType<typeof useLoadCriteriasByCodesQueryQuery>;
export type LoadCriteriasByCodesQueryLazyQueryHookResult = ReturnType<typeof useLoadCriteriasByCodesQueryLazyQuery>;
export type LoadCriteriasByCodesQueryQueryResult = Apollo.QueryResult<LoadCriteriasByCodesQueryQuery, LoadCriteriasByCodesQueryQueryVariables>;
export const saveAdvanceSearchDocument = gql`
    mutation saveAdvanceSearch($type: EntityTypeEnum!, $heading: String!, $searchInput: SaveSearchInput!, $isShared: Boolean!) {
  saveSearch(
    type: $type
    heading: $heading
    searchInput: $searchInput
    isShared: $isShared
  ) {
    id
    code
    heading
    isHeadingKey
  }
}
    `;
export type saveAdvanceSearchMutationFn = Apollo.MutationFunction<saveAdvanceSearchMutation, saveAdvanceSearchMutationVariables>;

/**
 * __usesaveAdvanceSearchMutation__
 *
 * To run a mutation, you first call `usesaveAdvanceSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usesaveAdvanceSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdvanceSearchMutation, { data, loading, error }] = usesaveAdvanceSearchMutation({
 *   variables: {
 *      type: // value for 'type'
 *      heading: // value for 'heading'
 *      searchInput: // value for 'searchInput'
 *      isShared: // value for 'isShared'
 *   },
 * });
 */
export function usesaveAdvanceSearchMutation(baseOptions?: Apollo.MutationHookOptions<saveAdvanceSearchMutation, saveAdvanceSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<saveAdvanceSearchMutation, saveAdvanceSearchMutationVariables>(saveAdvanceSearchDocument, options);
      }
export type saveAdvanceSearchMutationHookResult = ReturnType<typeof usesaveAdvanceSearchMutation>;
export type saveAdvanceSearchMutationResult = Apollo.MutationResult<saveAdvanceSearchMutation>;
export type saveAdvanceSearchMutationOptions = Apollo.BaseMutationOptions<saveAdvanceSearchMutation, saveAdvanceSearchMutationVariables>;
export const GetAdvanceSearchDataQueryDocument = gql`
    query GetAdvanceSearchDataQuery($searchId: ID!) {
  singleSearch(id: $searchId) {
    ...SearchNodesFragment
  }
}
    ${SearchNodesFragmentFragmentDoc}`;

/**
 * __useGetAdvanceSearchDataQueryQuery__
 *
 * To run a query within a React component, call `useGetAdvanceSearchDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvanceSearchDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvanceSearchDataQueryQuery({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useGetAdvanceSearchDataQueryQuery(baseOptions: Apollo.QueryHookOptions<GetAdvanceSearchDataQueryQuery, GetAdvanceSearchDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvanceSearchDataQueryQuery, GetAdvanceSearchDataQueryQueryVariables>(GetAdvanceSearchDataQueryDocument, options);
      }
export function useGetAdvanceSearchDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvanceSearchDataQueryQuery, GetAdvanceSearchDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvanceSearchDataQueryQuery, GetAdvanceSearchDataQueryQueryVariables>(GetAdvanceSearchDataQueryDocument, options);
        }
export type GetAdvanceSearchDataQueryQueryHookResult = ReturnType<typeof useGetAdvanceSearchDataQueryQuery>;
export type GetAdvanceSearchDataQueryLazyQueryHookResult = ReturnType<typeof useGetAdvanceSearchDataQueryLazyQuery>;
export type GetAdvanceSearchDataQueryQueryResult = Apollo.QueryResult<GetAdvanceSearchDataQueryQuery, GetAdvanceSearchDataQueryQueryVariables>;
export const DefaultAdvanceSearchQueryDocument = gql`
    query DefaultAdvanceSearchQuery {
  defaultSearch {
    ...SearchNodesFragment
  }
}
    ${SearchNodesFragmentFragmentDoc}`;

/**
 * __useDefaultAdvanceSearchQueryQuery__
 *
 * To run a query within a React component, call `useDefaultAdvanceSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultAdvanceSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultAdvanceSearchQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultAdvanceSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<DefaultAdvanceSearchQueryQuery, DefaultAdvanceSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultAdvanceSearchQueryQuery, DefaultAdvanceSearchQueryQueryVariables>(DefaultAdvanceSearchQueryDocument, options);
      }
export function useDefaultAdvanceSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultAdvanceSearchQueryQuery, DefaultAdvanceSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultAdvanceSearchQueryQuery, DefaultAdvanceSearchQueryQueryVariables>(DefaultAdvanceSearchQueryDocument, options);
        }
export type DefaultAdvanceSearchQueryQueryHookResult = ReturnType<typeof useDefaultAdvanceSearchQueryQuery>;
export type DefaultAdvanceSearchQueryLazyQueryHookResult = ReturnType<typeof useDefaultAdvanceSearchQueryLazyQuery>;
export type DefaultAdvanceSearchQueryQueryResult = Apollo.QueryResult<DefaultAdvanceSearchQueryQuery, DefaultAdvanceSearchQueryQueryVariables>;
export const SingleAdvanceSearchDocument = gql`
    query SingleAdvanceSearch($searchId: ID!) {
  singleSearch(id: $searchId) {
    ...SearchNodesFragment
  }
}
    ${SearchNodesFragmentFragmentDoc}`;

/**
 * __useSingleAdvanceSearchQuery__
 *
 * To run a query within a React component, call `useSingleAdvanceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAdvanceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAdvanceSearchQuery({
 *   variables: {
 *      searchId: // value for 'searchId'
 *   },
 * });
 */
export function useSingleAdvanceSearchQuery(baseOptions: Apollo.QueryHookOptions<SingleAdvanceSearchQuery, SingleAdvanceSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAdvanceSearchQuery, SingleAdvanceSearchQueryVariables>(SingleAdvanceSearchDocument, options);
      }
export function useSingleAdvanceSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleAdvanceSearchQuery, SingleAdvanceSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAdvanceSearchQuery, SingleAdvanceSearchQueryVariables>(SingleAdvanceSearchDocument, options);
        }
export type SingleAdvanceSearchQueryHookResult = ReturnType<typeof useSingleAdvanceSearchQuery>;
export type SingleAdvanceSearchLazyQueryHookResult = ReturnType<typeof useSingleAdvanceSearchLazyQuery>;
export type SingleAdvanceSearchQueryResult = Apollo.QueryResult<SingleAdvanceSearchQuery, SingleAdvanceSearchQueryVariables>;
export const DefaultCriteriasQueryDocument = gql`
    query DefaultCriteriasQuery($entityType: EntityTypeEnum!) {
  defaultCriterias(criteria: {entityType: $entityType}) {
    hash
    nodes {
      id
      criteria {
        id
        ...CriteriaInputFragment
      }
    }
  }
}
    ${CriteriaInputFragmentFragmentDoc}`;

/**
 * __useDefaultCriteriasQueryQuery__
 *
 * To run a query within a React component, call `useDefaultCriteriasQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultCriteriasQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultCriteriasQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useDefaultCriteriasQueryQuery(baseOptions: Apollo.QueryHookOptions<DefaultCriteriasQueryQuery, DefaultCriteriasQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultCriteriasQueryQuery, DefaultCriteriasQueryQueryVariables>(DefaultCriteriasQueryDocument, options);
      }
export function useDefaultCriteriasQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultCriteriasQueryQuery, DefaultCriteriasQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultCriteriasQueryQuery, DefaultCriteriasQueryQueryVariables>(DefaultCriteriasQueryDocument, options);
        }
export type DefaultCriteriasQueryQueryHookResult = ReturnType<typeof useDefaultCriteriasQueryQuery>;
export type DefaultCriteriasQueryLazyQueryHookResult = ReturnType<typeof useDefaultCriteriasQueryLazyQuery>;
export type DefaultCriteriasQueryQueryResult = Apollo.QueryResult<DefaultCriteriasQueryQuery, DefaultCriteriasQueryQueryVariables>;
export const TableColumnsQueryDocument = gql`
    query TableColumnsQuery($entityType: EntityTypeEnum!) {
  viewer {
    id
    tableColumns(entityType: $entityType) {
      columnKey
      sort
    }
  }
}
    `;

/**
 * __useTableColumnsQueryQuery__
 *
 * To run a query within a React component, call `useTableColumnsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableColumnsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableColumnsQueryQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useTableColumnsQueryQuery(baseOptions: Apollo.QueryHookOptions<TableColumnsQueryQuery, TableColumnsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TableColumnsQueryQuery, TableColumnsQueryQueryVariables>(TableColumnsQueryDocument, options);
      }
export function useTableColumnsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableColumnsQueryQuery, TableColumnsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TableColumnsQueryQuery, TableColumnsQueryQueryVariables>(TableColumnsQueryDocument, options);
        }
export type TableColumnsQueryQueryHookResult = ReturnType<typeof useTableColumnsQueryQuery>;
export type TableColumnsQueryLazyQueryHookResult = ReturnType<typeof useTableColumnsQueryLazyQuery>;
export type TableColumnsQueryQueryResult = Apollo.QueryResult<TableColumnsQueryQuery, TableColumnsQueryQueryVariables>;
export const CheckMdmModuleEnabledDocument = gql`
    query CheckMdmModuleEnabled {
  hasAccessToModule(module: MDM)
}
    `;

/**
 * __useCheckMdmModuleEnabledQuery__
 *
 * To run a query within a React component, call `useCheckMdmModuleEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMdmModuleEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMdmModuleEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckMdmModuleEnabledQuery(baseOptions?: Apollo.QueryHookOptions<CheckMdmModuleEnabledQuery, CheckMdmModuleEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMdmModuleEnabledQuery, CheckMdmModuleEnabledQueryVariables>(CheckMdmModuleEnabledDocument, options);
      }
export function useCheckMdmModuleEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMdmModuleEnabledQuery, CheckMdmModuleEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMdmModuleEnabledQuery, CheckMdmModuleEnabledQueryVariables>(CheckMdmModuleEnabledDocument, options);
        }
export type CheckMdmModuleEnabledQueryHookResult = ReturnType<typeof useCheckMdmModuleEnabledQuery>;
export type CheckMdmModuleEnabledLazyQueryHookResult = ReturnType<typeof useCheckMdmModuleEnabledLazyQuery>;
export type CheckMdmModuleEnabledQueryResult = Apollo.QueryResult<CheckMdmModuleEnabledQuery, CheckMdmModuleEnabledQueryVariables>;
export const EntitiesSearchTopCountriesDocument = gql`
    query EntitiesSearchTopCountries($search: String) {
  countries(criteria: {label: $search}) {
    hash
    totalCount
    nodes {
      code
      label
    }
  }
}
    `;

/**
 * __useEntitiesSearchTopCountriesQuery__
 *
 * To run a query within a React component, call `useEntitiesSearchTopCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesSearchTopCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesSearchTopCountriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEntitiesSearchTopCountriesQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesSearchTopCountriesQuery, EntitiesSearchTopCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesSearchTopCountriesQuery, EntitiesSearchTopCountriesQueryVariables>(EntitiesSearchTopCountriesDocument, options);
      }
export function useEntitiesSearchTopCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesSearchTopCountriesQuery, EntitiesSearchTopCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesSearchTopCountriesQuery, EntitiesSearchTopCountriesQueryVariables>(EntitiesSearchTopCountriesDocument, options);
        }
export type EntitiesSearchTopCountriesQueryHookResult = ReturnType<typeof useEntitiesSearchTopCountriesQuery>;
export type EntitiesSearchTopCountriesLazyQueryHookResult = ReturnType<typeof useEntitiesSearchTopCountriesLazyQuery>;
export type EntitiesSearchTopCountriesQueryResult = Apollo.QueryResult<EntitiesSearchTopCountriesQuery, EntitiesSearchTopCountriesQueryVariables>;
export const MyAdvanceSavedSearchesDocument = gql`
    query MyAdvanceSavedSearches {
  allSearches {
    totalCount
    nodes {
      heading
      id
      groupingCode
      isDefault
    }
  }
}
    `;

/**
 * __useMyAdvanceSavedSearchesQuery__
 *
 * To run a query within a React component, call `useMyAdvanceSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAdvanceSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAdvanceSavedSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAdvanceSavedSearchesQuery(baseOptions?: Apollo.QueryHookOptions<MyAdvanceSavedSearchesQuery, MyAdvanceSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAdvanceSavedSearchesQuery, MyAdvanceSavedSearchesQueryVariables>(MyAdvanceSavedSearchesDocument, options);
      }
export function useMyAdvanceSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAdvanceSavedSearchesQuery, MyAdvanceSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAdvanceSavedSearchesQuery, MyAdvanceSavedSearchesQueryVariables>(MyAdvanceSavedSearchesDocument, options);
        }
export type MyAdvanceSavedSearchesQueryHookResult = ReturnType<typeof useMyAdvanceSavedSearchesQuery>;
export type MyAdvanceSavedSearchesLazyQueryHookResult = ReturnType<typeof useMyAdvanceSavedSearchesLazyQuery>;
export type MyAdvanceSavedSearchesQueryResult = Apollo.QueryResult<MyAdvanceSavedSearchesQuery, MyAdvanceSavedSearchesQueryVariables>;
export const SaveAsDefaultDocument = gql`
    mutation SaveAsDefault($searchID: ID!) {
  defaultSearch(searchId: $searchID) {
    searchId
  }
}
    `;
export type SaveAsDefaultMutationFn = Apollo.MutationFunction<SaveAsDefaultMutation, SaveAsDefaultMutationVariables>;

/**
 * __useSaveAsDefaultMutation__
 *
 * To run a mutation, you first call `useSaveAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAsDefaultMutation, { data, loading, error }] = useSaveAsDefaultMutation({
 *   variables: {
 *      searchID: // value for 'searchID'
 *   },
 * });
 */
export function useSaveAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SaveAsDefaultMutation, SaveAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAsDefaultMutation, SaveAsDefaultMutationVariables>(SaveAsDefaultDocument, options);
      }
export type SaveAsDefaultMutationHookResult = ReturnType<typeof useSaveAsDefaultMutation>;
export type SaveAsDefaultMutationResult = Apollo.MutationResult<SaveAsDefaultMutation>;
export type SaveAsDefaultMutationOptions = Apollo.BaseMutationOptions<SaveAsDefaultMutation, SaveAsDefaultMutationVariables>;
export const DeleteSearchDocument = gql`
    mutation DeleteSearch($searchID: ID!) {
  deleteSearch(searchId: $searchID)
}
    `;
export type DeleteSearchMutationFn = Apollo.MutationFunction<DeleteSearchMutation, DeleteSearchMutationVariables>;

/**
 * __useDeleteSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchMutation, { data, loading, error }] = useDeleteSearchMutation({
 *   variables: {
 *      searchID: // value for 'searchID'
 *   },
 * });
 */
export function useDeleteSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchMutation, DeleteSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchMutation, DeleteSearchMutationVariables>(DeleteSearchDocument, options);
      }
export type DeleteSearchMutationHookResult = ReturnType<typeof useDeleteSearchMutation>;
export type DeleteSearchMutationResult = Apollo.MutationResult<DeleteSearchMutation>;
export type DeleteSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSearchMutation, DeleteSearchMutationVariables>;
export const EntitySimpleSearchCriteriasDocument = gql`
    query EntitySimpleSearchCriterias($entityType: EntityTypeEnum!, $search: String) {
  criteriaGroups(criteria: {entityType: $entityType}) {
    hash
    nodes {
      code
      entityId
      heading
      criterias(criteria: {heading: $search}) {
        hash
        nodes {
          ...CriteriaInputFragment
        }
      }
    }
  }
}
    ${CriteriaInputFragmentFragmentDoc}`;

/**
 * __useEntitySimpleSearchCriteriasQuery__
 *
 * To run a query within a React component, call `useEntitySimpleSearchCriteriasQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySimpleSearchCriteriasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySimpleSearchCriteriasQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useEntitySimpleSearchCriteriasQuery(baseOptions: Apollo.QueryHookOptions<EntitySimpleSearchCriteriasQuery, EntitySimpleSearchCriteriasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitySimpleSearchCriteriasQuery, EntitySimpleSearchCriteriasQueryVariables>(EntitySimpleSearchCriteriasDocument, options);
      }
export function useEntitySimpleSearchCriteriasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitySimpleSearchCriteriasQuery, EntitySimpleSearchCriteriasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitySimpleSearchCriteriasQuery, EntitySimpleSearchCriteriasQueryVariables>(EntitySimpleSearchCriteriasDocument, options);
        }
export type EntitySimpleSearchCriteriasQueryHookResult = ReturnType<typeof useEntitySimpleSearchCriteriasQuery>;
export type EntitySimpleSearchCriteriasLazyQueryHookResult = ReturnType<typeof useEntitySimpleSearchCriteriasLazyQuery>;
export type EntitySimpleSearchCriteriasQueryResult = Apollo.QueryResult<EntitySimpleSearchCriteriasQuery, EntitySimpleSearchCriteriasQueryVariables>;
export const MySimpleSavedSearchesDocument = gql`
    query MySimpleSavedSearches($entityType: EntityTypeEnum!, $search: String) {
  viewer {
    id
    savedCriterias(criteria: {entityType: $entityType, heading: $search}) {
      hash
      nodes {
        ...SimpleSavedSearchFragment
      }
    }
  }
}
    ${SimpleSavedSearchFragmentFragmentDoc}`;

/**
 * __useMySimpleSavedSearchesQuery__
 *
 * To run a query within a React component, call `useMySimpleSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySimpleSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySimpleSavedSearchesQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMySimpleSavedSearchesQuery(baseOptions: Apollo.QueryHookOptions<MySimpleSavedSearchesQuery, MySimpleSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySimpleSavedSearchesQuery, MySimpleSavedSearchesQueryVariables>(MySimpleSavedSearchesDocument, options);
      }
export function useMySimpleSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySimpleSavedSearchesQuery, MySimpleSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySimpleSavedSearchesQuery, MySimpleSavedSearchesQueryVariables>(MySimpleSavedSearchesDocument, options);
        }
export type MySimpleSavedSearchesQueryHookResult = ReturnType<typeof useMySimpleSavedSearchesQuery>;
export type MySimpleSavedSearchesLazyQueryHookResult = ReturnType<typeof useMySimpleSavedSearchesLazyQuery>;
export type MySimpleSavedSearchesQueryResult = Apollo.QueryResult<MySimpleSavedSearchesQuery, MySimpleSavedSearchesQueryVariables>;
export const DeleteSavedSearchDocument = gql`
    mutation DeleteSavedSearch($id: Int!) {
  deleteSavedSearchCriteria(id: $id)
}
    `;
export type DeleteSavedSearchMutationFn = Apollo.MutationFunction<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;

/**
 * __useDeleteSavedSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedSearchMutation, { data, loading, error }] = useDeleteSavedSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>(DeleteSavedSearchDocument, options);
      }
export type DeleteSavedSearchMutationHookResult = ReturnType<typeof useDeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationResult = Apollo.MutationResult<DeleteSavedSearchMutation>;
export type DeleteSavedSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;
export const UpdateExistingSearchDocument = gql`
    mutation UpdateExistingSearch($id: Int!, $name: String!, $criterias: [DynamicCriteriaInput!]!) {
  updateSimpleCriteria(id: $id, name: $name, criterias: $criterias) {
    id
    heading
    totalCount
  }
}
    `;
export type UpdateExistingSearchMutationFn = Apollo.MutationFunction<UpdateExistingSearchMutation, UpdateExistingSearchMutationVariables>;

/**
 * __useUpdateExistingSearchMutation__
 *
 * To run a mutation, you first call `useUpdateExistingSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExistingSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExistingSearchMutation, { data, loading, error }] = useUpdateExistingSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      criterias: // value for 'criterias'
 *   },
 * });
 */
export function useUpdateExistingSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExistingSearchMutation, UpdateExistingSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExistingSearchMutation, UpdateExistingSearchMutationVariables>(UpdateExistingSearchDocument, options);
      }
export type UpdateExistingSearchMutationHookResult = ReturnType<typeof useUpdateExistingSearchMutation>;
export type UpdateExistingSearchMutationResult = Apollo.MutationResult<UpdateExistingSearchMutation>;
export type UpdateExistingSearchMutationOptions = Apollo.BaseMutationOptions<UpdateExistingSearchMutation, UpdateExistingSearchMutationVariables>;
export const SaveNewSimpleSearchDocument = gql`
    mutation SaveNewSimpleSearch($name: String!, $entityType: EntityTypeEnum!, $criterias: [DynamicCriteriaInput!]!) {
  saveNewSimpleCriteria(
    entityType: $entityType
    name: $name
    criterias: $criterias
  ) {
    ...SimpleSavedSearchFragment
  }
}
    ${SimpleSavedSearchFragmentFragmentDoc}`;
export type SaveNewSimpleSearchMutationFn = Apollo.MutationFunction<SaveNewSimpleSearchMutation, SaveNewSimpleSearchMutationVariables>;

/**
 * __useSaveNewSimpleSearchMutation__
 *
 * To run a mutation, you first call `useSaveNewSimpleSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNewSimpleSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNewSimpleSearchMutation, { data, loading, error }] = useSaveNewSimpleSearchMutation({
 *   variables: {
 *      name: // value for 'name'
 *      entityType: // value for 'entityType'
 *      criterias: // value for 'criterias'
 *   },
 * });
 */
export function useSaveNewSimpleSearchMutation(baseOptions?: Apollo.MutationHookOptions<SaveNewSimpleSearchMutation, SaveNewSimpleSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNewSimpleSearchMutation, SaveNewSimpleSearchMutationVariables>(SaveNewSimpleSearchDocument, options);
      }
export type SaveNewSimpleSearchMutationHookResult = ReturnType<typeof useSaveNewSimpleSearchMutation>;
export type SaveNewSimpleSearchMutationResult = Apollo.MutationResult<SaveNewSimpleSearchMutation>;
export type SaveNewSimpleSearchMutationOptions = Apollo.BaseMutationOptions<SaveNewSimpleSearchMutation, SaveNewSimpleSearchMutationVariables>;
export const PersonEntityRecordsDocument = gql`
    query PersonEntityRecords($ids: [ID!]!) {
  personsById(ids: $ids) {
    id
    fullName
    ct
    ut
  }
}
    `;

/**
 * __usePersonEntityRecordsQuery__
 *
 * To run a query within a React component, call `usePersonEntityRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonEntityRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonEntityRecordsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePersonEntityRecordsQuery(baseOptions: Apollo.QueryHookOptions<PersonEntityRecordsQuery, PersonEntityRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonEntityRecordsQuery, PersonEntityRecordsQueryVariables>(PersonEntityRecordsDocument, options);
      }
export function usePersonEntityRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonEntityRecordsQuery, PersonEntityRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonEntityRecordsQuery, PersonEntityRecordsQueryVariables>(PersonEntityRecordsDocument, options);
        }
export type PersonEntityRecordsQueryHookResult = ReturnType<typeof usePersonEntityRecordsQuery>;
export type PersonEntityRecordsLazyQueryHookResult = ReturnType<typeof usePersonEntityRecordsLazyQuery>;
export type PersonEntityRecordsQueryResult = Apollo.QueryResult<PersonEntityRecordsQuery, PersonEntityRecordsQueryVariables>;
export const SiteEntityRecordsDocument = gql`
    query SiteEntityRecords($ids: [ID!]!) {
  sitesById(ids: $ids) {
    id
    name
    ct
    ut
  }
}
    `;

/**
 * __useSiteEntityRecordsQuery__
 *
 * To run a query within a React component, call `useSiteEntityRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteEntityRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteEntityRecordsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSiteEntityRecordsQuery(baseOptions: Apollo.QueryHookOptions<SiteEntityRecordsQuery, SiteEntityRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteEntityRecordsQuery, SiteEntityRecordsQueryVariables>(SiteEntityRecordsDocument, options);
      }
export function useSiteEntityRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteEntityRecordsQuery, SiteEntityRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteEntityRecordsQuery, SiteEntityRecordsQueryVariables>(SiteEntityRecordsDocument, options);
        }
export type SiteEntityRecordsQueryHookResult = ReturnType<typeof useSiteEntityRecordsQuery>;
export type SiteEntityRecordsLazyQueryHookResult = ReturnType<typeof useSiteEntityRecordsLazyQuery>;
export type SiteEntityRecordsQueryResult = Apollo.QueryResult<SiteEntityRecordsQuery, SiteEntityRecordsQueryVariables>;
export const MyInfoDocument = gql`
    query MyInfo {
  viewer {
    id
    fullname
    username
    role {
      id
      name: heading
    }
  }
}
    `;

/**
 * __useMyInfoQuery__
 *
 * To run a query within a React component, call `useMyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyInfoQuery(baseOptions?: Apollo.QueryHookOptions<MyInfoQuery, MyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInfoQuery, MyInfoQueryVariables>(MyInfoDocument, options);
      }
export function useMyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInfoQuery, MyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInfoQuery, MyInfoQueryVariables>(MyInfoDocument, options);
        }
export type MyInfoQueryHookResult = ReturnType<typeof useMyInfoQuery>;
export type MyInfoLazyQueryHookResult = ReturnType<typeof useMyInfoLazyQuery>;
export type MyInfoQueryResult = Apollo.QueryResult<MyInfoQuery, MyInfoQueryVariables>;
export const NavigationDataQueryDocument = gql`
    query NavigationDataQuery {
  viewer {
    id
    menuItems {
      hash
      nodes {
        ...MenuItemFragment
      }
    }
    functionMenuItems {
      hash
      nodes {
        ...MenuItemFragment
      }
    }
  }
  person(id: 1) {
    id
    sites {
      totalCount
    }
  }
}
    ${MenuItemFragmentFragmentDoc}`;

/**
 * __useNavigationDataQueryQuery__
 *
 * To run a query within a React component, call `useNavigationDataQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationDataQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationDataQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationDataQueryQuery(baseOptions?: Apollo.QueryHookOptions<NavigationDataQueryQuery, NavigationDataQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationDataQueryQuery, NavigationDataQueryQueryVariables>(NavigationDataQueryDocument, options);
      }
export function useNavigationDataQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationDataQueryQuery, NavigationDataQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationDataQueryQuery, NavigationDataQueryQueryVariables>(NavigationDataQueryDocument, options);
        }
export type NavigationDataQueryQueryHookResult = ReturnType<typeof useNavigationDataQueryQuery>;
export type NavigationDataQueryLazyQueryHookResult = ReturnType<typeof useNavigationDataQueryLazyQuery>;
export type NavigationDataQueryQueryResult = Apollo.QueryResult<NavigationDataQueryQuery, NavigationDataQueryQueryVariables>;
export const FavoriteListsNavigationQueryDocument = gql`
    query FavoriteListsNavigationQuery {
  viewer {
    id
    lists: pinnedAndFavoriteLists(criteria: {fetchSize: {limit: 5}}) {
      hash
      totalCount
      nodes {
        id
        title
        description
        affiliations {
          ... on PersonConnection {
            hash
            totalCount
          }
          ... on ActivityConnection {
            hash
            totalCount
          }
          ... on SiteConnection {
            hash
            totalCount
          }
          ... on SitePersonConnection {
            hash
            totalCount
          }
          ... on ActivityPersonConnection {
            hash
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFavoriteListsNavigationQueryQuery__
 *
 * To run a query within a React component, call `useFavoriteListsNavigationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteListsNavigationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteListsNavigationQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteListsNavigationQueryQuery(baseOptions?: Apollo.QueryHookOptions<FavoriteListsNavigationQueryQuery, FavoriteListsNavigationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteListsNavigationQueryQuery, FavoriteListsNavigationQueryQueryVariables>(FavoriteListsNavigationQueryDocument, options);
      }
export function useFavoriteListsNavigationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteListsNavigationQueryQuery, FavoriteListsNavigationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteListsNavigationQueryQuery, FavoriteListsNavigationQueryQueryVariables>(FavoriteListsNavigationQueryDocument, options);
        }
export type FavoriteListsNavigationQueryQueryHookResult = ReturnType<typeof useFavoriteListsNavigationQueryQuery>;
export type FavoriteListsNavigationQueryLazyQueryHookResult = ReturnType<typeof useFavoriteListsNavigationQueryLazyQuery>;
export type FavoriteListsNavigationQueryQueryResult = Apollo.QueryResult<FavoriteListsNavigationQueryQuery, FavoriteListsNavigationQueryQueryVariables>;
export const InstanceDocument = gql`
    query Instance {
  instanceName
  imgPath
}
    `;

/**
 * __useInstanceQuery__
 *
 * To run a query within a React component, call `useInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstanceQuery(baseOptions?: Apollo.QueryHookOptions<InstanceQuery, InstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstanceQuery, InstanceQueryVariables>(InstanceDocument, options);
      }
export function useInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstanceQuery, InstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstanceQuery, InstanceQueryVariables>(InstanceDocument, options);
        }
export type InstanceQueryHookResult = ReturnType<typeof useInstanceQuery>;
export type InstanceLazyQueryHookResult = ReturnType<typeof useInstanceLazyQuery>;
export type InstanceQueryResult = Apollo.QueryResult<InstanceQuery, InstanceQueryVariables>;
export const HasPermissionQueryDocument = gql`
    query HasPermissionQuery($permissions: [PermissionEnum!]!) {
  hasPermissions(permissions: $permissions) {
    code
    create
    read
    update
    delete
  }
}
    `;

/**
 * __useHasPermissionQueryQuery__
 *
 * To run a query within a React component, call `useHasPermissionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasPermissionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasPermissionQueryQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useHasPermissionQueryQuery(baseOptions: Apollo.QueryHookOptions<HasPermissionQueryQuery, HasPermissionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasPermissionQueryQuery, HasPermissionQueryQueryVariables>(HasPermissionQueryDocument, options);
      }
export function useHasPermissionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasPermissionQueryQuery, HasPermissionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasPermissionQueryQuery, HasPermissionQueryQueryVariables>(HasPermissionQueryDocument, options);
        }
export type HasPermissionQueryQueryHookResult = ReturnType<typeof useHasPermissionQueryQuery>;
export type HasPermissionQueryLazyQueryHookResult = ReturnType<typeof useHasPermissionQueryLazyQuery>;
export type HasPermissionQueryQueryResult = Apollo.QueryResult<HasPermissionQueryQuery, HasPermissionQueryQueryVariables>;
export const CreateEntityFieldQueryDocument = gql`
    query CreateEntityFieldQuery($country: CountryCode!, $entityType: EntityTypeEnum!) {
  getCreateEntityFields(country: $country, entityType: $entityType) {
    id
    fieldKey
  }
}
    `;

/**
 * __useCreateEntityFieldQueryQuery__
 *
 * To run a query within a React component, call `useCreateEntityFieldQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityFieldQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateEntityFieldQueryQuery({
 *   variables: {
 *      country: // value for 'country'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useCreateEntityFieldQueryQuery(baseOptions: Apollo.QueryHookOptions<CreateEntityFieldQueryQuery, CreateEntityFieldQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateEntityFieldQueryQuery, CreateEntityFieldQueryQueryVariables>(CreateEntityFieldQueryDocument, options);
      }
export function useCreateEntityFieldQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateEntityFieldQueryQuery, CreateEntityFieldQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateEntityFieldQueryQuery, CreateEntityFieldQueryQueryVariables>(CreateEntityFieldQueryDocument, options);
        }
export type CreateEntityFieldQueryQueryHookResult = ReturnType<typeof useCreateEntityFieldQueryQuery>;
export type CreateEntityFieldQueryLazyQueryHookResult = ReturnType<typeof useCreateEntityFieldQueryLazyQuery>;
export type CreateEntityFieldQueryQueryResult = Apollo.QueryResult<CreateEntityFieldQueryQuery, CreateEntityFieldQueryQueryVariables>;
export const UsePreferredLOVLanguageDocument = gql`
    query UsePreferredLOVLanguage {
  viewer {
    id
    user {
      id
      hasEnglishAsDefault
    }
  }
}
    `;

/**
 * __useUsePreferredLOVLanguageQuery__
 *
 * To run a query within a React component, call `useUsePreferredLOVLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsePreferredLOVLanguageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsePreferredLOVLanguageQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsePreferredLOVLanguageQuery(baseOptions?: Apollo.QueryHookOptions<UsePreferredLOVLanguageQuery, UsePreferredLOVLanguageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsePreferredLOVLanguageQuery, UsePreferredLOVLanguageQueryVariables>(UsePreferredLOVLanguageDocument, options);
      }
export function useUsePreferredLOVLanguageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsePreferredLOVLanguageQuery, UsePreferredLOVLanguageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsePreferredLOVLanguageQuery, UsePreferredLOVLanguageQueryVariables>(UsePreferredLOVLanguageDocument, options);
        }
export type UsePreferredLOVLanguageQueryHookResult = ReturnType<typeof useUsePreferredLOVLanguageQuery>;
export type UsePreferredLOVLanguageLazyQueryHookResult = ReturnType<typeof useUsePreferredLOVLanguageLazyQuery>;
export type UsePreferredLOVLanguageQueryResult = Apollo.QueryResult<UsePreferredLOVLanguageQuery, UsePreferredLOVLanguageQueryVariables>;
export type ViewerActivitiesCalendarQueryVariables = Exact<{
  responsibleUserId: Scalars['ID'];
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
}>;


export type ViewerActivitiesCalendarQuery = { __typename: 'Query', activities: { __typename: 'ActivityConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Activity', id: number, startDate: any, endDate: any, heading: string, status: { __typename: 'ActivityStatus', code: string, codeEnum: ActivityStatusEnum, headingKey: string }, persons: { __typename: 'PersonConnection', hash: string, nodes: Array<{ __typename: 'Person', id: number, fullName: string }> }, sites: { __typename: 'SiteConnection', hash: string, nodes: Array<{ __typename: 'Site', id: number, name: string, phone?: { __typename: 'ContactValue', id: number, value?: string | null } | null, visitAddress?: { __typename: 'Address', id: number, city?: string | null, countyCode?: string | null, street?: string | null, postalCode?: string | null } | null }> }, type: { __typename: 'ActivityType', code: string, heading: string, color: { __typename: 'Color', code: string, value: string } } }> } };

export type UpdateActivityTimespanMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type UpdateActivityTimespanMutationMutation = { __typename: 'Mutation', updateActivity: { __typename: 'Activity', id: number, startDate: any, endDate: any } };

export type usersResponsibleListQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type usersResponsibleListQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, fullname: string, responsibleHcps: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Person', id: number, fullName: string, daysSinceLastActivity?: number | null, activitiesAffiliatedToMe: { __typename: 'ActivityConnection', hash: string, totalCount: number }, primarySite?: { __typename: 'Site', id: number, name: string } | null }
        & ActivityPersonFragmentFragment
      )> } } | null };

export type AvailableUsersForCalendarQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AvailableUsersForCalendarQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, roleId: number, username: string }> } };

export type ActivityOverviewQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  excludePreviousStatuses?: InputMaybe<Array<ActivityStatusEnum> | ActivityStatusEnum>;
  responsibleUserId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  personLimit?: InputMaybe<Scalars['Int']>;
  pastActivityOrder: Array<ActivityCriteriaOrder> | ActivityCriteriaOrder;
  todayActivityOrder?: InputMaybe<Array<ActivityCriteriaOrder> | ActivityCriteriaOrder>;
  futureActivityOrder?: InputMaybe<Array<ActivityCriteriaOrder> | ActivityCriteriaOrder>;
}>;


export type ActivityOverviewQuery = { __typename: 'Query', user?: { __typename: 'User', id: number, firstname?: string | null, fullname: string, previous: (
      { __typename: 'ActivityConnection' }
      & activityConnectionOverviewFragment
    ), today: (
      { __typename: 'ActivityConnection' }
      & activityConnectionOverviewFragment
    ), next: (
      { __typename: 'ActivityConnection' }
      & activityConnectionOverviewFragment
    ) } | null };

export type activityConnectionOverviewFragment = { __typename: 'ActivityConnection', hash: string, totalCount: number, nodes: Array<(
    { __typename: 'Activity', id: number, heading: string, time: any, end: any, status: { __typename: 'ActivityStatus', code: string, headingKey: string, codeEnum: ActivityStatusEnum }, type: { __typename: 'ActivityType', code: string, label: string, color: { __typename: 'Color', code: string, value: string } }, sites: { __typename: 'SiteConnection', hash: string, nodes: Array<{ __typename: 'Site', id: number, name: string, siteTypeCode?: string | null, visitAddress?: { __typename: 'Address', id: number, city?: string | null, street?: string | null, postalCode?: string | null, commune?: { __typename: 'DataValue', code: string, label: string, type: DataValueMappingName } | null } | null, phone?: { __typename: 'ContactValue', id: number, value?: string | null } | null, fax?: { __typename: 'ContactValue', id: number, value?: string | null } | null, email?: { __typename: 'ContactValue', id: number, value?: string | null } | null }> } }
    & activityConnectionOverviewPersonsFragment
  )> };

export type activityConnectionOverviewPersonsFragment = { __typename: 'Activity', persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Person', id: number, fullName: string, title?: string | null }> } };

export type UserActivityOverViewQueryVariables = Exact<{ [key: string]: never; }>;


export type UserActivityOverViewQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, user: { __typename: 'User', id: number, firstname?: string | null } } | null };

export type ActivityDetailsCalendarListQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
  startOfDay: Scalars['DateTime'];
  endOfDay: Scalars['DateTime'];
}>;


export type ActivityDetailsCalendarListQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, activities: { __typename: 'ActivityConnection', hash: string, nodes: Array<{ __typename: 'Activity', id: number, heading: string, startDate: any, endDate: any }> } } | null, activity?: { __typename: 'Activity', id: number, startDate: any } | null };

export type ActivityTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityTypesQueryQuery = { __typename: 'Query', activityTypes: { __typename: 'ActivityTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivityType', code: string, heading: string, sort?: number | null, superTypeCode: string, locationRule: AttachmentRuleEnum, participationUserRule: AttachmentRuleEnum, personRule: AttachmentRuleEnum, projectRule: AttachmentRuleEnum, responsibleUserRule: AttachmentRuleEnum, productRule: AttachmentRuleEnum, brandRule: AttachmentRuleEnum, standardTimeLengthMinutes: number, superType: { __typename: 'ActivitySuperType', code: string, heading: string }, color: { __typename: 'Color', code: string, value: string, headingKey: string }, customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum }> } }> } };

export type ActivityDetailsQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityDetailsQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, heading: string, typeCode: string, startDate: any } | null };

export type ActivityDetailsCustomFieldsQueryVariables = Exact<{
  activityTypeCode: Scalars['String'];
  activityId?: InputMaybe<Scalars['Int']>;
  includeValues: Scalars['Boolean'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type ActivityDetailsCustomFieldsQuery = { __typename: 'Query', activityType?: { __typename: 'ActivityType', code: string, customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<(
        { __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum, customLinkValues?: (
          { __typename: 'CustomLinkValueConnection', hash?: string }
          & CustomFieldValueFragmentFragment
        ) | null }
        & CustomFieldFragmentFragment
      )> } } | null };

export type ActivityDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ActivityDetailQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Note', id: number }
        & NoteDrawerFragmentFragment
      )> } } | null };

export type contactPersonsFragment = { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Person', id: number, title?: string | null, fullname: string, segmentationCode?: { __typename: 'SegmentationCode', id: number, code: string, heading: string } | null }> };

export type ActivityPersonFragmentFragment = { __typename: 'Person', id: number, fullName: string, title?: string | null, segmentationCode?: { __typename: 'SegmentationCode', code: string, heading: string } | null };

export type FindHcoActivityAffiliationsQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type FindHcoActivityAffiliationsQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string } | null };

export type AddMultiplePersonToActivityMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  selection: SelectionCriteriaInput;
}>;


export type AddMultiplePersonToActivityMutationMutation = { __typename: 'Mutation', addPersonsToActivity: { __typename: 'Activity', id: number, persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Person', id: number }
        & ActivityPersonFragmentFragment
      )> } } };

export type RemoveMultiplePersonToActivityMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  personSelection: SelectionCriteriaInput;
}>;


export type RemoveMultiplePersonToActivityMutationMutation = { __typename: 'Mutation', removePersonsFromActivity: { __typename: 'Activity', id: number, persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Person', id: number }
        & ActivityPersonFragmentFragment
      )> } } };

export type ReplaceSinglePersonToActivityMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  personId: Scalars['Int'];
}>;


export type ReplaceSinglePersonToActivityMutationMutation = { __typename: 'Mutation', replacePersonInActivity: { __typename: 'Activity', id: number, persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Person', id: number }
        & ActivityPersonFragmentFragment
      )> } } };

export type ActivityPersonsQueryQueryVariables = Exact<{
  activityId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  ordering?: InputMaybe<Array<PersonCriteriaOrder> | PersonCriteriaOrder>;
}>;


export type ActivityPersonsQueryQuery = { __typename: 'Query', persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'Person', id: number }
      & ActivityPersonFragmentFragment
      & PersonTableBuiltFragmentFragment
    )> } };

export type ActivityPersonSelectionIdsQueryQueryVariables = Exact<{
  selection: SelectionCriteriaInput;
}>;


export type ActivityPersonSelectionIdsQueryQuery = { __typename: 'Query', selectionToIds: Array<number> };

export type personActivityQueryQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type personActivityQueryQuery = { __typename: 'Query', persons: { __typename: 'PersonConnection', hash: string, nodes: Array<(
      { __typename: 'Person', id: number }
      & ActivityPersonFragmentFragment
      & PersonTableBuiltFragmentFragment
    )> } };

export type ActivityResponsibleUsersQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityResponsibleUsersQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, email: string }> } } | null };

export type ResponsibleUsersSearchQueryQueryVariables = Exact<{
  userSearch?: InputMaybe<Scalars['String']>;
}>;


export type ResponsibleUsersSearchQueryQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, email: string }> } };

export type UpdateActivityResponsibleUsersMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  responsibleUserIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateActivityResponsibleUsersMutationMutation = { __typename: 'Mutation', updateActivityResponsibleUsers: { __typename: 'Activity', id: number, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, email: string }> } } };

export type ActivitySiteSiteFragmentFragment = { __typename: 'Site', id: number, name: string, type?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null };

export type SiteFragmentForDisplayFragment = { __typename: 'Site', id: number, name: string };

export type ActivitySiteAffiliationsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ActivitySiteAffiliationsQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, sites: { __typename: 'SiteConnection', hash: string, nodes: Array<(
        { __typename: 'Site' }
        & ActivitySiteSiteFragmentFragment
      )> }, siteAffiliations: Array<(
      { __typename: 'Site' }
      & SiteFragmentForDisplayFragment
    )> } | null };

export type ActivitySitesSuggestionsQueryVariables = Exact<{
  personIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  activityId?: InputMaybe<Scalars['ID']>;
  siteIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ActivitySitesSuggestionsQuery = { __typename: 'Query', sites: { __typename: 'SiteConnection', hash: string, nodes: Array<(
      { __typename: 'Site' }
      & SiteFragmentForDisplayFragment
    )> } };

export type UpdateActivityLocationMutationVariables = Exact<{
  activityId: Scalars['Int'];
  locationId: Scalars['Int'];
}>;


export type UpdateActivityLocationMutation = { __typename: 'Mutation', updateActivityLocation: { __typename: 'Activity', id: number } };

export type ActivityDateDetailsQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityDateDetailsQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, heading: string, typeCode: string, statusCode: string, startDate: any, endDate: any } | null };

export type UpdateActivityDatesMutationVariables = Exact<{
  input: UpdateActivityInput;
}>;


export type UpdateActivityDatesMutation = { __typename: 'Mutation', updateActivity: { __typename: 'Activity', id: number, startDate: any, endDate: any } };

export type UpdateActivityTitleMutationVariables = Exact<{
  activityId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdateActivityTitleMutation = { __typename: 'Mutation', updateActivity: { __typename: 'Activity', id: number, heading: string } };

export type ActivityHeadingDetailsQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityHeadingDetailsQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, heading: string, typeCode: string, statusCode: string, startDate: any, endDate: any } | null };

export type ActivityProductQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityProductQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, activityProductAffiliations: { __typename: 'ActivityProductConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'ActivityProduct', id: number, product: { __typename: 'Product', id: number, heading: string, code: string } }> } } | null };

export type ActivityProductSuggestionQueryQueryVariables = Exact<{
  activityId?: InputMaybe<Scalars['ID']>;
}>;


export type ActivityProductSuggestionQueryQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, code: string, heading: string }> } };

export type AddProductToActivityMutationVariables = Exact<{
  activityId: Scalars['ID'];
  productId: Scalars['ID'];
}>;


export type AddProductToActivityMutation = { __typename: 'Mutation', addProductToActivity: { __typename: 'Activity', id: number, activityProductAffiliations: { __typename: 'ActivityProductConnection', hash: string, nodes: Array<{ __typename: 'ActivityProduct', id: number, product: { __typename: 'Product', id: number, heading: string, code: string } }> } } };

export type RemoveProductToActivityMutationVariables = Exact<{
  activityId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type RemoveProductToActivityMutation = { __typename: 'Mutation', removeProductToActivity: { __typename: 'Activity', id: number, activityProductAffiliations: { __typename: 'ActivityProductConnection', hash: string, nodes: Array<{ __typename: 'ActivityProduct', id: number, product: { __typename: 'Product', id: number, heading: string, code: string } }> } } };

export type CreateActivityMutationMutationVariables = Exact<{
  input: CreateActivityInput;
}>;


export type CreateActivityMutationMutation = { __typename: 'Mutation', createActivity: { __typename: 'Activity', id: number } };

export type ActivityTableBuiltFragmentFragment = { __typename: 'Activity', id: number };

export type ActivitiesTableConnectionQueryBuiltQueryVariables = Exact<{
  criteria?: InputMaybe<ActivityCriteria>;
}>;


export type ActivitiesTableConnectionQueryBuiltQuery = { __typename: 'Query', connection: { __typename: 'ActivityConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'Activity', id: number, heading: string, startDate: any, endDate: any, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> }, persons: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Person', id: number, fullName: string }> }, sites: { __typename: 'SiteConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Site', id: number, name: string }> } }
      & ActivityTableBuiltFragmentFragment
    )> } };

export type ActivityNestedHCPTableQueryQueryVariables = Exact<{
  activityId: Scalars['ID'];
}>;


export type ActivityNestedHCPTableQueryQuery = { __typename: 'Query', persons: { __typename: 'PersonConnection', hash: string, nodes: Array<(
      { __typename: 'Person' }
      & PersonTableBuiltFragmentFragment
    )> } };

export type ActivityCreatedByQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityCreatedByQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, createdBy?: { __typename: 'User', id: number, fullname: string, email: string, md5Email: string } | null } | null };

export type CompleteActivityMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type CompleteActivityMutationMutation = { __typename: 'Mutation', completeActivity: { __typename: 'Activity', id: number, statusCode: string, status: { __typename: 'ActivityStatus', code: string, headingKey: string } } };

export type DeleteActivityMutationMutationVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type DeleteActivityMutationMutation = { __typename: 'Mutation', deleteActivity: { __typename: 'Activity', id: number, status: { __typename: 'ActivityStatus', code: string, headingKey: string } } };

export type ActivityDetailsSectionRightQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityDetailsSectionRightQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, status: { __typename: 'ActivityStatus', code: string, codeEnum: ActivityStatusEnum } } | null };

export type UpdateActivityStatusMutationVariables = Exact<{
  activityId: Scalars['Int'];
  status: ActivityStatusEnum;
}>;


export type UpdateActivityStatusMutation = { __typename: 'Mutation', updateActivity: { __typename: 'Activity', id: number, statusCode: string, statusLabel: string, status: { __typename: 'ActivityStatus', code: string } } };

export type ActivityStatusesQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityStatusesQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, status: { __typename: 'ActivityStatus', code: string, codeEnum: ActivityStatusEnum, headingKey: string } } | null, activityStatuses: { __typename: 'ActivityStatusConnection', hash: string, nodes: Array<{ __typename: 'ActivityStatus', code: string, codeEnum: ActivityStatusEnum, headingKey: string }> } };

export type ActivityTimeStampsQueryQueryVariables = Exact<{
  activityId: Scalars['Int'];
}>;


export type ActivityTimeStampsQueryQuery = { __typename: 'Query', activity?: { __typename: 'Activity', id: number, ct: any, ut: any } | null };

export type UpdateActivityTypeMutationVariables = Exact<{
  activityId: Scalars['Int'];
  activityTypeCode: Scalars['String'];
}>;


export type UpdateActivityTypeMutation = { __typename: 'Mutation', updateActivity: { __typename: 'Activity', id: number, typeCode: string, heading: string, type: { __typename: 'ActivityType', code: string } } };

export type AdminMenuItemsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMenuItemsQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, adminMenuItems: { __typename: 'MenuItemConnection', hash: string, nodes: Array<{ __typename: 'MenuItem', code: string, headingKey: string, url: string }> } } | null };

export type GridItemTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GridItemTypesQueryQuery = { __typename: 'Query', entityGridItemTypes: { __typename: 'EntityGridItemTypeConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemType', code: string, enum: EntityGridItemTypeEnum, headingKey: string, descriptionKey?: string | null, minHeight: number, minWidth?: number | null }> } };

export type UpdateGridConfigurationHeadingMutationVariables = Exact<{
  id: Scalars['Int'];
  heading: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateGridConfigurationHeadingMutation = { __typename: 'Mutation', updateEntityGridItemConfiguration: { __typename: 'EntityGridItemConfiguration', id: number, heading?: string | null, description?: string | null } };

export type SelectedGridItemQueryQueryVariables = Exact<{
  gridItemId: Scalars['Int'];
}>;


export type SelectedGridItemQueryQuery = { __typename: 'Query', entityGridItemConfiguration?: { __typename: 'EntityGridItemConfiguration', id: number, heading?: string | null, description?: string | null, type: { __typename: 'EntityGridItemType', code: string, enum: EntityGridItemTypeEnum, headingKey: string, descriptionKey?: string | null }, fields: { __typename: 'EntityGridItemFieldConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'EntityGridItemField', id: number }> } } | null };

export type LocalizationKeysSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type LocalizationKeysSearchQuery = { __typename: 'Query', localizations: { __typename: 'LocalizationConnection', nodes: Array<{ __typename: 'Localization', resource: string, id: { __typename: 'LocalizationId', code: string, languageCode: string } }> } };

export type ConfigureGridCardsMutationMutationVariables = Exact<{
  entityGridItemConfigurationId: Scalars['Int'];
  entityGridItemCardFieldType: EntityGridItemCardFieldTypeEnum;
  fields: Array<EntityGridItemCardFieldInput> | EntityGridItemCardFieldInput;
}>;


export type ConfigureGridCardsMutationMutation = { __typename: 'Mutation', updateEntityGridItemCardFields: { __typename: 'EntityGridItemCardFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemCardField', id: number }> } };

export type ConfigureGridCardsQueryQueryVariables = Exact<{
  itemConfigurationId: Scalars['ID'];
  main: EntityGridItemCardFieldTypeEnum;
  meta: EntityGridItemCardFieldTypeEnum;
}>;


export type ConfigureGridCardsQueryQuery = { __typename: 'Query', main: { __typename: 'EntityGridItemCardFieldConnection', hash: string, nodes: Array<(
      { __typename: 'EntityGridItemCardField' }
      & FieldFragmentFragment
    )> }, meta: { __typename: 'EntityGridItemCardFieldConnection', hash: string, nodes: Array<(
      { __typename: 'EntityGridItemCardField' }
      & FieldFragmentFragment
    )> } };

export type FieldFragmentFragment = { __typename: 'EntityGridItemCardField', id: number, fieldKey: string, heading?: string | null, isHeadingKey: boolean, sort: number };

export type AddFieldToFieldsGridMutationMutationVariables = Exact<{
  fieldType: EntityGridItemFieldTypeEnum;
  groupId: Scalars['Int'];
}>;


export type AddFieldToFieldsGridMutationMutation = { __typename: 'Mutation', assignFieldToGroup: { __typename: 'EntityGridItemField', id: number, itemConfiguration: (
      { __typename: 'EntityGridItemConfiguration', id: number }
      & SelectedGridItemConfigurationFragmentFragment
    ) } };

export type LinkCustomFieldMutationMutationVariables = Exact<{
  customFieldCode: Scalars['String'];
  fieldId: Scalars['Int'];
}>;


export type LinkCustomFieldMutationMutation = { __typename: 'Mutation', linkEntityGridFieldToCustomField: { __typename: 'CustomFieldGridConfiguration', id: number, fieldConfig: { __typename: 'EntityGridItemField', id: number, itemConfiguration: (
        { __typename: 'EntityGridItemConfiguration', id: number }
        & SelectedGridItemConfigurationFragmentFragment
      ) } } };

export type ListAllCustomFieldTypesQueryQueryVariables = Exact<{
  tabCode: Scalars['String'];
  entityType: EntityTypeEnum;
}>;


export type ListAllCustomFieldTypesQueryQuery = { __typename: 'Query', entityGridItemFieldTypes: { __typename: 'EntityGridItemFieldTypeConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemFieldType', code: string, enum: EntityGridItemFieldTypeEnum, heading: string, description?: string | null, isInTab: boolean }> }, customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string, description?: string | null, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum } }> } };

export type UpdateGridItemFieldSortingMutationVariables = Exact<{
  gridItemConfigurationId: Scalars['Int'];
  fieldIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateGridItemFieldSortingMutation = { __typename: 'Mutation', updateEntityGridItemFieldSorting: Array<{ __typename: 'EntityGridItemField', id: number, sort?: number | null }> };

export type RemoveEntityGridItemMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveEntityGridItemMutation = { __typename: 'Mutation', removeEntityGridItem: boolean };

export type SelectedFieldsGridItemQueryQueryVariables = Exact<{
  gridItemId: Scalars['Int'];
}>;


export type SelectedFieldsGridItemQueryQuery = { __typename: 'Query', entityGridItemConfiguration?: (
    { __typename: 'EntityGridItemConfiguration', id: number }
    & SelectedGridItemConfigurationFragmentFragment
  ) | null };

export type SelectedGridItemConfigurationFragmentFragment = { __typename: 'EntityGridItemConfiguration', id: number, fields: { __typename: 'EntityGridItemFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemField', id: number, gridItemFieldTypeCode: string, entityGridItemConfigurationId: number, sort?: number | null, type: { __typename: 'EntityGridItemFieldType', code: string, heading: string, isActive: boolean, enum: EntityGridItemFieldTypeEnum }, customFieldConfiguration?: { __typename: 'CustomFieldGridConfiguration', id: number, customField: { __typename: 'CustomField', code: string, heading: string, customFieldTypeCode: string, options?: { __typename: 'CustomFieldOptionConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'CustomFieldOption', code?: string | null, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum } } } | null }> } };

export type UpdateGridRightRelationsSortingMutationMutationVariables = Exact<{
  itemConfigurationId: Scalars['Int'];
  fieldKeys: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateGridRightRelationsSortingMutationMutation = { __typename: 'Mutation', updateEntityGridItemRelationFieldUpdateSorting: Array<{ __typename: 'EntityGridItemRelationField', id: number, sort: number, relationTabKey: string, isActive: boolean }> };

export type UpdateGridRightRelationStatusMutationMutationVariables = Exact<{
  itemConfigurationId: Scalars['Int'];
  fieldKey: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type UpdateGridRightRelationStatusMutationMutation = { __typename: 'Mutation', updateEntityGridItemRelationFieldSwitchStatus: { __typename: 'EntityGridItemRelationField', id: number, sort: number, relationTabKey: string, isActive: boolean } };

export type AdminGridRightRelationsConfiguratorQueryQueryVariables = Exact<{
  itemConfigurationId: Scalars['ID'];
}>;


export type AdminGridRightRelationsConfiguratorQueryQuery = { __typename: 'Query', entityGridItemRelationFields: { __typename: 'EntityGridItemRelationFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemRelationField', id: number, sort: number, relationTabKey: string, isActive: boolean }> } };

export type CreateEntityGridItemConfigurationMutationVariables = Exact<{
  entityTabCode: Scalars['String'];
  itemType: EntityGridItemTypeEnum;
  heading?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateEntityGridItemConfigurationMutation = { __typename: 'Mutation', createEntityGridItemConfiguration: { __typename: 'EntityGridItemConfiguration', id: number } };

export type DeactivateItemGroupMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeactivateItemGroupMutationMutation = { __typename: 'Mutation', deactivateEntityGridItemConfiguration: boolean };

export type entityGridItemConfigurationQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type entityGridItemConfigurationQueryQuery = { __typename: 'Query', entityGridItemConfiguration?: { __typename: 'EntityGridItemConfiguration', x: number, y: number, width?: number | null, height: number, id: number, typeCode: string, typeEnum: EntityGridItemTypeEnum, heading?: string | null, description?: string | null, type: { __typename: 'EntityGridItemType', code: string, headingKey: string, minHeight: number, minWidth?: number | null } } | null };

export type UpdateEntityGridMutationMutationVariables = Exact<{
  input: GridInput;
}>;


export type UpdateEntityGridMutationMutation = { __typename: 'Mutation', updateEntityGrid: boolean };

export type HCPMoreDataQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type HCPMoreDataQueryQuery = { __typename: 'Query', entityTabs: { __typename: 'EntityTabConnection', hash: string, nodes: Array<{ __typename: 'EntityTab', code: string, headingKey: string, sort?: number | null, gridItems: { __typename: 'EntityGridItemConfigurationConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemConfiguration', x: number, y: number, width?: number | null, heading?: string | null, height: number, id: number, type: { __typename: 'EntityGridItemType', code: string, headingKey: string, minHeight: number, minWidth?: number | null } }> } }> } };

export type AdminDetailedGridCardsPreviewQueryQueryVariables = Exact<{
  entityGridItemConfigurationId: Scalars['Int'];
}>;


export type AdminDetailedGridCardsPreviewQueryQuery = { __typename: 'Query', cardFieldKeys: { __typename: 'EntityCardFields', entityGridItemConfigurationId: number, person: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, site: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, link: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> } } };

export type AdminGridRightRelationsPreviewQueryQueryVariables = Exact<{
  entityGridItemConfigurationId: Scalars['ID'];
}>;


export type AdminGridRightRelationsPreviewQueryQuery = { __typename: 'Query', entityGridItemRelationFields: { __typename: 'EntityGridItemRelationFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemRelationField', id: number, sort: number, relationTabKey: string, isActive: boolean }> } };

export type CustomFieldGridDisplayQueryQueryVariables = Exact<{
  entityGridItemConfigurationId: Scalars['Int'];
}>;


export type CustomFieldGridDisplayQueryQuery = { __typename: 'Query', entityGridItemConfiguration?: { __typename: 'EntityGridItemConfiguration', id: number, fields: { __typename: 'EntityGridItemFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemField', id: number, gridItemFieldTypeCode: string, entityGridItemConfigurationId: number, sort?: number | null, type: { __typename: 'EntityGridItemFieldType', code: string, heading: string, isActive: boolean }, customFieldConfiguration?: { __typename: 'CustomFieldGridConfiguration', id: number, customField: { __typename: 'CustomField', code: string, heading: string, customFieldTypeCode: string, options?: { __typename: 'CustomFieldOptionConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'CustomFieldOption', code?: string | null, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum } } } | null }> } } | null };

export type GetAvailableAddressTypesQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type GetAvailableAddressTypesQuery = { __typename: 'Query', addressTypes: { __typename: 'AddressTypeConnection', hash: string, nodes: Array<{ __typename: 'AddressType', code: string, headingKey: string }> } };

export type AddressTypeQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type AddressTypeQueryQuery = { __typename: 'Query', addressType?: { __typename: 'AddressType', code: string, headingKey: string, sort?: number | null, affiliations: { __typename: 'AddressAffiliationConnection', hash: string, totalCount: number } } | null };

export type UpdateDefaultCriteriasMutationMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  criteriaIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateDefaultCriteriasMutationMutation = { __typename: 'Mutation', updateDefaultCriterias: Array<{ __typename: 'DefaultCriteria', id: number, sort: number }> };

export type AdminCriteriaGroupsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type AdminCriteriaGroupsQueryQuery = { __typename: 'Query', criteriaGroups: { __typename: 'CriteriaGroupConnection', hash: string, nodes: Array<{ __typename: 'CriteriaGroup', code: string, entityId: number, heading: string, criterias: { __typename: 'CriteriaConnection', hash: string, nodes: Array<{ __typename: 'Criteria', id: number, entityId: number, heading: string }> } }> } };

export type ConfigureDefaultCriteriasQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type ConfigureDefaultCriteriasQueryQuery = { __typename: 'Query', defaultCriterias: { __typename: 'DefaultCriteriaConnection', hash: string, nodes: Array<{ __typename: 'DefaultCriteria', id: number, sort: number, criteria: { __typename: 'Criteria', id: number, entityId: number, heading: string } }> } };

export type ContactCategoriesQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type ContactCategoriesQueryQuery = { __typename: 'Query', contactCategories: { __typename: 'ContactCategoryConnection', hash: string, nodes: Array<{ __typename: 'ContactCategory', code: string, heading: string, isMapped: boolean }> } };

export type CreateContactCategoryMutationVariables = Exact<{
  input: CreateContactCategoryInput;
}>;


export type CreateContactCategoryMutation = { __typename: 'Mutation', createContactCategory: { __typename: 'ContactCategory', code: string, heading: string } };

export type UpdateContactCategoryMutationVariables = Exact<{
  input: UpdateContactCategoryInput;
}>;


export type UpdateContactCategoryMutation = { __typename: 'Mutation', updateContactCategory: { __typename: 'ContactCategory', code: string, heading: string, isHeadingKey: boolean, allowMultipleValues: boolean, typeEnum: ContactTypeEnum, type: { __typename: 'ContactType', code: string, enum: ContactTypeEnum, heading: string } } };

export type ContactCategorySuggestionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactCategorySuggestionQueryQuery = { __typename: 'Query', contactTypes: { __typename: 'ContactTypeConnection', hash: string, nodes: Array<{ __typename: 'ContactType', code: string, heading: string }> } };

export type ContactCategoryCodeCheckQueryQueryVariables = Exact<{
  categoryCode: Scalars['String'];
}>;


export type ContactCategoryCodeCheckQueryQuery = { __typename: 'Query', contactCategory?: { __typename: 'ContactCategory', code: string } | null };

export type ContactCategoryModalQueryQueryVariables = Exact<{
  categoryCode: Scalars['String'];
}>;


export type ContactCategoryModalQueryQuery = { __typename: 'Query', contactCategory?: { __typename: 'ContactCategory', code: string, heading: string, isHeadingKey: boolean, allowMultipleValues: boolean, mappings: { __typename: 'ContactCategoryMappingConnection', hash: string, nodes: Array<{ __typename: 'ContactCategoryMapping', id: number, mapping: string }> }, type: { __typename: 'ContactType', code: string, heading: string, enum: ContactTypeEnum }, values: { __typename: 'ContactValueConnection', hash: string, totalCount: number } } | null };

export type AdminEntityCustomFieldsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type AdminEntityCustomFieldsQueryQuery = { __typename: 'Query', customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string, isActive: boolean, fieldTypeEnum: CustomFieldTypeEnum, fieldGridConfigurations: { __typename: 'CustomFieldGridConfigurationConnection', hash: string, totalCount: number } }> } };

export type AdminEntityMergeRequestFragmentFragment = { __typename: 'EntityMerge', id: number };

export type AdminEntityMergeRequestConnectionQueryQueryVariables = Exact<{
  criteria?: InputMaybe<EntityMergeCriteria>;
}>;


export type AdminEntityMergeRequestConnectionQueryQuery = { __typename: 'Query', connection: { __typename: 'EntityMergeConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'EntityMerge', id: number }
      & AdminEntityMergeRequestFragmentFragment
    )> } };

export type AdminEntityMergeRequestRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type AdminEntityMergeRequestRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'EntityMerge', id: number }
    & AdminEntityMergeRequestFragmentFragment
  ) | null };

export type AdminEntityMergeRequestBasicQueryVariables = Exact<{
  mergeRequestId: Scalars['Int'];
}>;


export type AdminEntityMergeRequestBasicQuery = { __typename: 'Query', entityMerge?: { __typename: 'EntityMerge', id: number, entityType: EntityTypeEnum, byUser?: { __typename: 'User', id: number, fullname: string } | null, from?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null, into?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null } | null };

export type AdminEntityMergeItemFragmentFragment = { __typename: 'VirtualEntityMergeFieldInfo', hasConflict: boolean, ignoredByMaintainer: boolean, type?: (
    { __typename: 'AffiliationContactValue_EntityDataToBeTransferredType' }
    & MergeItemAffiliationContactValueFragment
  ) | (
    { __typename: 'AffiliationCountryCode_EntityDataToBeTransferredType' }
    & MergeItemAffiliationCountryFragment
  ) | (
    { __typename: 'AffiliationCustomField_EntityDataToBeTransferredType' }
    & MergeItemAffiliationCustomFieldFragment
  ) | (
    { __typename: 'AffiliationExternalId_EntityDataToBeTransferredType' }
    & MergeItemAffiliationExternalIdFragment
  ) | (
    { __typename: 'AffiliationIsPrimary_EntityDataToBeTransferredType' }
    & MergeItemAffiliationIsPrimaryFragment
  ) | (
    { __typename: 'AffiliationNotes_EntityDataToBeTransferredType' }
    & MergeItemAffiliationNotesFragment
  ) | (
    { __typename: 'AffiliationPositionCode_EntityDataToBeTransferredType' }
    & MergeItemAffiliationPositionCodeFragment
  ) | (
    { __typename: 'AffiliationTherapeuticFocus_EntityDataToBeTransferredType' }
    & MergeItemAffiliationTherapeuticFocusFragment
  ) | (
    { __typename: 'AffiliationWorkingSpecialities_EntityDataToBeTransferredType' }
    & MergeItemAffiliationWorkingSpecialitiesFragment
  ) | (
    { __typename: 'PersonActivity_EntityDataToBeTransferredType' }
    & MergeItemPersonActivitiesFragment
  ) | (
    { __typename: 'PersonAddress_EntityDataToBeTransferredType' }
    & MergeItemPersonAddressFragment
  ) | (
    { __typename: 'PersonBirth_EntityDataToBeTransferredType' }
    & MergeItemPersonBirthFragment
  ) | (
    { __typename: 'PersonConsent_EntityDataToBeTransferredType' }
    & MergeItemPersonConsentFragment
  ) | (
    { __typename: 'PersonContactValue_EntityDataToBeTransferredType' }
    & MergeItemPersonContactValueFragment
  ) | (
    { __typename: 'PersonCountry_EntityDataToBeTransferredType' }
    & MergeItemPersonCountryFragment
  ) | (
    { __typename: 'PersonCustomField_EntityDataToBeTransferredType' }
    & MergeItemPersonCustomFieldFragment
  ) | (
    { __typename: 'PersonEducations_EntityDataToBeTransferredType' }
    & MergeItemPersonEducationsFragment
  ) | (
    { __typename: 'PersonExamYear_EntityDataToBeTransferredType' }
    & MergeItemPersonExamYearFragment
  ) | (
    { __typename: 'PersonExternalId_EntityDataToBeTransferredType' }
    & MergeItemPersonExternalIdFragment
  ) | (
    { __typename: 'PersonFirstName_EntityDataToBeTransferredType' }
    & MergeItemPersonFirstNameFragment
  ) | (
    { __typename: 'PersonGdpr_EntityDataToBeTransferredType' }
    & MergeItemPersonGdprFragment
  ) | (
    { __typename: 'PersonGender_EntityDataToBeTransferredType' }
    & MergeItemPersonGenderFragment
  ) | (
    { __typename: 'PersonIsActive_EntityDataToBeTransferredType' }
    & MergeItemPersonIsActiveFragment
  ) | (
    { __typename: 'PersonLastName_EntityDataToBeTransferredType' }
    & MergeItemPersonLastNameFragment
  ) | (
    { __typename: 'PersonLink_EntityDataToBeTransferredType' }
    & MergeItemPersonLinkFragment
  ) | (
    { __typename: 'PersonLists_EntityDataToBeTransferredType' }
    & MergeItemPersonListsFragment
  ) | (
    { __typename: 'PersonMailToPrivate_EntityDataToBeTransferredType' }
    & MergeItemPersonMailToPrivateFragment
  ) | (
    { __typename: 'PersonNotes_EntityDataToBeTransferredType' }
    & MergeItemPersonNotesFragment
  ) | (
    { __typename: 'PersonProductSegmentation_EntityDataToBeTransferredType' }
    & MergeItemPersonProductSegmentationFragment
  ) | { __typename: 'PersonProjects_EntityDataToBeTransferredType' } | (
    { __typename: 'PersonResponsibleArea_EntityDataToBeTransferredType' }
    & MergeItemPersonResponsibleAreasFragment
  ) | (
    { __typename: 'PersonSegmentation_EntityDataToBeTransferredType' }
    & MergeItemPersonSegmentationFragment
  ) | (
    { __typename: 'PersonTags_EntityDataToBeTransferredType' }
    & MergeItemPersonTagsFragment
  ) | (
    { __typename: 'PersonTherapeuticFocus_EntityDataToBeTransferredType' }
    & MergeItemPersonTherapeuticFocusFragment
  ) | (
    { __typename: 'PersonTitle_EntityDataToBeTransferredType' }
    & MergeItemPersonTitleFragment
  ) | (
    { __typename: 'PersonType_EntityDataToBeTransferredType' }
    & MergeItemPersonTypeFragment
  ) | (
    { __typename: 'SiteActivity_EntityDataToBeTransferredType' }
    & MergeItemSiteActivitiesFragment
  ) | (
    { __typename: 'SiteAddress_EntityDataToBeTransferredType' }
    & MergeItemSiteAddressFragment
  ) | (
    { __typename: 'SiteContactValue_EntityDataToBeTransferredType' }
    & MergeItemSiteContactValueFragment
  ) | (
    { __typename: 'SiteCountry_EntityDataToBeTransferredType' }
    & MergeItemSiteCountryFragment
  ) | (
    { __typename: 'SiteCustomField_EntityDataToBeTransferredType' }
    & MergeItemSiteCustomFieldFragment
  ) | (
    { __typename: 'SiteExternalId_EntityDataToBeTransferredType' }
    & MergeItemSiteExternalIdFragment
  ) | (
    { __typename: 'SiteIsUnplaced_EntityDataToBeTransferredType' }
    & MergeItemSiteIsUnplacedFragment
  ) | (
    { __typename: 'SiteLinks_EntityDataToBeTransferredType' }
    & MergeItemSiteLinksFragment
  ) | (
    { __typename: 'SiteLists_EntityDataToBeTransferredType' }
    & MergeItemSiteListsFragment
  ) | (
    { __typename: 'SiteMailingNamePrefix_EntityDataToBeTransferredType' }
    & MergeItemSiteMailingNamePrefixFragment
  ) | (
    { __typename: 'SiteName_EntityDataToBeTransferredType' }
    & MergeItemSiteNameFragment
  ) | (
    { __typename: 'SiteNotes_EntityDataToBeTransferredType' }
    & MergeItemSiteNotesFragment
  ) | (
    { __typename: 'SiteParent_EntityDataToBeTransferredType' }
    & MergeItemSiteParentFragment
  ) | (
    { __typename: 'SiteSegmentation_EntityDataToBeTransferredType' }
    & MergeItemSiteSegmentationFragment
  ) | (
    { __typename: 'SiteTags_EntityDataToBeTransferredType' }
    & MergeItemSiteTagsFragment
  ) | (
    { __typename: 'SiteType_EntityDataToBeTransferredType' }
    & MergeItemSiteTypeFragment
  ) | (
    { __typename: 'SiteWebpage_EntityDataToBeTransferredType' }
    & MergeItemSiteWebpageFragment
  ) | null };

export type MergeItemAffiliationContactValueFragment = { __typename: 'AffiliationContactValue_EntityDataToBeTransferredType', code: string, loserValue: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ), winnerValue?: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ) | null };

export type MergeItemAffiliationCustomFieldFragment = { __typename: 'AffiliationCustomField_EntityDataToBeTransferredType', code: string, field: { __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum }, affiliationsToMove: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, loserExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, winnerExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )> };

export type FieldDataFragment = { __typename: 'CustomFieldToBeTransferredInfo', value: { __typename: 'CustomValue', id: number, value?: string | null }, affiliation: { __typename: 'CustomLinkValue', id: number } };

export type MergeItemAffiliationExternalIdFragment = { __typename: 'AffiliationExternalId_EntityDataToBeTransferredType', code: string, externalId: { __typename: 'ExternalId', id: number, externalId: string, type: { __typename: 'ExternalIdType', code: string, heading: string, isHeadingKey: boolean } }, existingExternalId?: { __typename: 'ExternalId', id: number, externalId: string } | null };

export type MergeItemAffiliationCountryFragment = { __typename: 'AffiliationCountryCode_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, fromAffiliationCountry?: string | null, toAffiliationCountry?: string | null };

export type MergeLinksSetPrimaryLinkMutationVariables = Exact<{
  personId: Scalars['ID'];
  primaryLinkId: Scalars['ID'];
}>;


export type MergeLinksSetPrimaryLinkMutation = { __typename: 'Mutation', setPrimaryLink: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> };

export type MergeRemovePrimaryLinkMutationVariables = Exact<{
  personId: Scalars['ID'];
  currentPrimaryLink: Scalars['ID'];
}>;


export type MergeRemovePrimaryLinkMutation = { __typename: 'Mutation', setNonPrimaryLink: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> };

export type MergeItemAffiliationIsPrimaryFragment = { __typename: 'AffiliationIsPrimary_EntityDataToBeTransferredType', code: string, allLinksFromWinner: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean, personId: number, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null, site: { __typename: 'Site', id: number, name: string } }> };

export type MergeItemAffiliationNotesFragment = { __typename: 'AffiliationNotes_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, noteIds: Array<number> };

export type MRAffiliationPositionCodeQueryVariables = Exact<{
  countryCode: Scalars['CountryCode'];
}>;


export type MRAffiliationPositionCodeQuery = { __typename: 'Query', positions: { __typename: 'ValuePositionConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, label: string, type: DataValueMappingName, displayLabel: string }> } };

export type UpdateAffiliationPositionCodeMutationVariables = Exact<{
  linkId: Scalars['Int'];
  newCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAffiliationPositionCodeMutation = { __typename: 'Mutation', updatePosition: { __typename: 'SitePerson', id: number, positionCode?: string | null, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName } | null } };

export type MergeItemAffiliationPositionCodeFragment = { __typename: 'AffiliationPositionCode_EntityDataToBeTransferredType', code: string, loserLink: { __typename: 'SitePerson', id: number, countryCode: string }, winnerLink?: { __typename: 'SitePerson', id: number } | null, loserType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null, winnerType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type MergeItemAffiliationTherapeuticFocusFragment = { __typename: 'AffiliationTherapeuticFocus_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, toBeMoved: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName, label: string }> };

export type MRSetWorkingSpecialitiesMutationVariables = Exact<{
  linkId: Scalars['Int'];
  workingSpecialtyCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type MRSetWorkingSpecialitiesMutation = { __typename: 'Mutation', updateSitePersonWorkingSpecialties: Array<{ __typename: 'SitePersonWorkingSpecialty', id: number }> };

export type MRWorkingSpecialitiesQueryVariables = Exact<{
  countryCode: Scalars['CountryCode'];
}>;


export type MRWorkingSpecialitiesQuery = { __typename: 'Query', workingSpecialties: { __typename: 'ValueWorkingSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string }> } };

export type MergeItemAffiliationWorkingSpecialitiesFragment = { __typename: 'AffiliationWorkingSpecialities_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, loserSpecialities: Array<{ __typename: 'SitePersonWorkingSpecialty', id: number, specialty: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } }>, winnerSpecialities: Array<{ __typename: 'SitePersonWorkingSpecialty', id: number, specialty: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } }> };

export type MergeItemPersonActivitiesFragment = { __typename: 'PersonActivity_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, activityIds: Array<number> };

export type PersonEntityMergeActivityModalQueryVariables = Exact<{
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PersonEntityMergeActivityModalQuery = { __typename: 'Query', activities: { __typename: 'ActivityConnection', hash: string, nodes: Array<{ __typename: 'Activity', id: number, heading: string }> } };

export type MergeItemPersonAddressFragment = { __typename: 'PersonAddress_EntityDataToBeTransferredType', code: string, addressAffiliation: (
    { __typename: 'AddressAffiliation' }
    & MergeAddressFragment
  ), conflictedWith?: (
    { __typename: 'AddressAffiliation' }
    & MergeAddressFragment
  ) | null };

export type UpdatePersonBirthMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdatePersonBirthMutation = { __typename: 'Mutation', updatePersonDateOfBirth: { __typename: 'Person', id: number, birth?: any | null } };

export type MergeItemPersonBirthFragment = { __typename: 'PersonBirth_EntityDataToBeTransferredType', code: string, birthFrom?: any | null, birthTo?: any | null };

export type UpdatePersonConsentMutationVariables = Exact<{
  personId: Scalars['Int'];
  typeCode: Scalars['String'];
  isEnabled: Scalars['Boolean'];
}>;


export type UpdatePersonConsentMutation = { __typename: 'Mutation', setConsentValue: { __typename: 'VirtualConsentValue', entityAffiliationId: number, entityType: EntityTypeEnum, consentTypeCode: string, isEnabled: boolean } };

export type MergeItemPersonConsentFragment = { __typename: 'PersonConsent_EntityDataToBeTransferredType', code: string, value: { __typename: 'ConsentValue', id: number, consentTypeCode: string, isEnabled: boolean, type: { __typename: 'ConsentType', code: string, headingKey: string } } };

export type MergeItemPersonContactValueFragment = { __typename: 'PersonContactValue_EntityDataToBeTransferredType', code: string, loserValue: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ), winnerValue?: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ) | null };

export type UpdatePersonCountryMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: Scalars['CountryCode'];
}>;


export type UpdatePersonCountryMutation = { __typename: 'Mutation', updatePersonCountry: { __typename: 'Person', id: number, countryCode: string, countryEnum: any, country: { __typename: 'ValueCountry', code: string } } };

export type MergeItemPersonCountryFragment = { __typename: 'PersonCountry_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, fromCountry?: any | null, toCountry?: any | null };

export type MergeItemPersonCustomFieldFragment = { __typename: 'PersonCustomField_EntityDataToBeTransferredType', code: string, field: { __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum }, affiliationsToMove: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, loserExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, winnerExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )> };

export type MergeItemPersonEducationsFragment = { __typename: 'PersonEducations_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, educationCodesToBeMoved: Array<{ __typename: 'PersonEducation', id: number, education: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } }> };

export type UpdatePersonExamYearMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: Scalars['Year'];
}>;


export type UpdatePersonExamYearMutation = { __typename: 'Mutation', updatePersonExamYear: { __typename: 'Person', id: number, examYear?: number | null } };

export type MergeItemPersonExamYearFragment = { __typename: 'PersonExamYear_EntityDataToBeTransferredType', code: string, examYearFrom?: number | null, examYearTo?: number | null };

export type MergeRequestExternalIdMutationVariables = Exact<{
  input: ExternalIdMutationInput;
  existingExternalIdId: Scalars['Int'];
  removeOld: Scalars['Boolean'];
}>;


export type MergeRequestExternalIdMutation = { __typename: 'Mutation', setExternalId?: { __typename: 'ExternalId', id: number, externalId: string } | null, removeExternalId?: { __typename: 'ExternalId', id: number, externalId: string } };

export type MergeItemPersonExternalIdFragment = { __typename: 'PersonExternalId_EntityDataToBeTransferredType', code: string, externalId: { __typename: 'ExternalId', id: number, externalId: string, type: { __typename: 'ExternalIdType', code: string, heading: string, isHeadingKey: boolean } }, existingExternalId?: { __typename: 'ExternalId', id: number, externalId: string } | null };

export type UpdatePersonNameMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdatePersonNameMutation = { __typename: 'Mutation', updatePersonFirstName: { __typename: 'Person', id: number, firstName: string } };

export type MergeItemPersonFirstNameFragment = { __typename: 'PersonFirstName_EntityDataToBeTransferredType', code: string, from: string, to: string };

export type MergeItemPersonGdprFragment = { __typename: 'PersonGdpr_EntityDataToBeTransferredType', code: string, newGdprValue: boolean };

export type MergeItemPersonIsActiveFragment = { __typename: 'PersonIsActive_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, willBeActivated?: { __typename: 'Person', id: number, fullName: string } | null, willBeInactivated?: { __typename: 'Person', id: number, fullName: string } | null };

export type UpdatePersonLastNameMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdatePersonLastNameMutation = { __typename: 'Mutation', updatePersonLastName: { __typename: 'Person', id: number, lastName: string } };

export type MergeItemPersonLastNameFragment = { __typename: 'PersonLastName_EntityDataToBeTransferredType', code: string, from: string, to: string };

export type CreateNestedMergeRequestMutationVariables = Exact<{
  fromLinkId: Scalars['ID'];
  toLinkId: Scalars['ID'];
}>;


export type CreateNestedMergeRequestMutation = { __typename: 'Mutation', createMergeRequest: { __typename: 'EntityMerge', id: number } };

export type PerformNestedMergeRequestMutationVariables = Exact<{
  mergeId: Scalars['ID'];
}>;


export type PerformNestedMergeRequestMutation = { __typename: 'Mutation', performMerge: { __typename: 'VirtualEntityMergeInfo', entityMergeId: number, hasConflict: boolean, fromId: number, intoId: number } };

export type MergeItemPersonLinkFragment = { __typename: 'PersonLink_EntityDataToBeTransferredType', code: string, primaryConflict: boolean, fromLink: { __typename: 'SitePerson', id: number, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null, site: { __typename: 'Site', id: number, name: string } }, toLink?: { __typename: 'SitePerson', id: number } | null };

export type MRPersonLinksPrimaryResolverQueryVariables = Exact<{
  fromPersonId: Scalars['ID'];
  intoPersonId: Scalars['ID'];
}>;


export type MRPersonLinksPrimaryResolverQuery = { __typename: 'Query', from: { __typename: 'SitePersonConnection', hash: string, nodes: Array<(
      { __typename: 'SitePerson' }
      & MRPersonLinkPrimaryFragment
    )> }, into: { __typename: 'SitePersonConnection', hash: string, nodes: Array<(
      { __typename: 'SitePerson' }
      & MRPersonLinkPrimaryFragment
    )> } };

export type MRPersonLinkPrimaryFragment = { __typename: 'SitePerson', id: number, isPrimary: boolean, person: { __typename: 'Person', id: number, fullName: string }, site: { __typename: 'Site', id: number, name: string }, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type MergeItemPersonListsFragment = { __typename: 'PersonLists_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, listIds: Array<number> };

export type MergeItemPersonMailToPrivateFragment = { __typename: 'PersonMailToPrivate_EntityDataToBeTransferredType', code: string, mailToPrivateFrom: boolean, mailToPrivateTo: boolean };

export type MergeItemPersonNotesFragment = { __typename: 'PersonNotes_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, noteIds: Array<number> };

export type DeletePersonProductSegmentationMergeMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type DeletePersonProductSegmentationMergeMutation = { __typename: 'Mutation', removeProductSegmentation: boolean };

export type AddPersonProductSegmentationMergeMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
  segmentationCodeId: Scalars['Int'];
}>;


export type AddPersonProductSegmentationMergeMutation = { __typename: 'Mutation', addProductSegmentation: { __typename: 'PersonProductSegmentation', id: number } };

export type PersonProductSegmentationMergeLookupQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonProductSegmentationMergeLookupQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, heading: string }> } };

export type MergeItemPersonProductSegmentationFragment = { __typename: 'PersonProductSegmentation_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, toBeTransferred?: (
    { __typename: 'PersonProductSegmentation' }
    & persProdSegFragment
  ) | null, conflictFrom?: (
    { __typename: 'PersonProductSegmentation' }
    & persProdSegFragment
  ) | null, conflictTo?: (
    { __typename: 'PersonProductSegmentation' }
    & persProdSegFragment
  ) | null };

export type persProdSegFragment = { __typename: 'PersonProductSegmentation', id: number, product: { __typename: 'Product', id: number, heading: string }, segmentationCode: { __typename: 'SegmentationCode', id: number, heading: string } };

export type MergeItemPersonResponsibleAreasFragment = { __typename: 'PersonResponsibleArea_EntityDataToBeTransferredType', code: string, dataType: EntityDataToBeTransferredDataTypeEnum, entityType: EntityTypeEnum, responsibleArea: { __typename: 'ResponsibleArea', id: number, heading: string }, fromUser: { __typename: 'User', id: number, fullname: string, email: string }, toUser?: { __typename: 'User', id: number, fullname: string, email: string } | null };

export type UpdateResponsibleUserForPersonMutationVariables = Exact<{
  recordId: Scalars['Int'];
  areaId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type UpdateResponsibleUserForPersonMutation = { __typename: 'Mutation', upsertResponsibleArea: { __typename: 'ResponsibleArea', id: number } };

export type UsersListOverviewQueryVariables = Exact<{
  criteria: UserCriteria;
}>;


export type UsersListOverviewQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } };

export type MRSetSegmentationCodeMutationVariables = Exact<{
  personId: Scalars['Int'];
  segmentationCodeId: Scalars['Int'];
}>;


export type MRSetSegmentationCodeMutation = { __typename: 'Mutation', upsertPersonSegmentationCode: { __typename: 'PersonSegmentationCode', id: number } };

export type MergeRequestSegmentationQueryVariables = Exact<{ [key: string]: never; }>;


export type MergeRequestSegmentationQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, heading: string }> } };

export type MergeItemPersonSegmentationFragment = { __typename: 'PersonSegmentation_EntityDataToBeTransferredType', code: string, dataType: EntityDataToBeTransferredDataTypeEnum, entityType: EntityTypeEnum, loser: { __typename: 'SegmentationCode', id: number, heading: string }, winner?: { __typename: 'SegmentationCode', id: number, heading: string } | null };

export type UpdatePersonSexMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: GenderEnum;
}>;


export type UpdatePersonSexMutation = { __typename: 'Mutation', updatePersonSex: { __typename: 'Person', id: number, title?: string | null } };

export type MergeItemPersonGenderFragment = { __typename: 'PersonGender_EntityDataToBeTransferredType', code: string, fromGender?: GenderEnum | null, toGender?: GenderEnum | null };

export type MRSetTagsMutationVariables = Exact<{
  personId: Scalars['Int'];
  filterCodeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type MRSetTagsMutation = { __typename: 'Mutation', updatePersonFilterCode: Array<{ __typename: 'PersonFilterCode', id: number, personId: number }> };

export type MRFilterCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type MRFilterCodesQuery = { __typename: 'Query', filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number, header: string }> } };

export type MergeItemPersonTagsFragment = { __typename: 'PersonTags_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, loserCodes: Array<{ __typename: 'PersonFilterCode', id: number, filterCode: { __typename: 'FilterCode', id: number, header: string } }>, winnerCodes: Array<{ __typename: 'PersonFilterCode', id: number, filterCode: { __typename: 'FilterCode', id: number, header: string } }> };

export type MergeItemPersonTherapeuticFocusFragment = { __typename: 'PersonTherapeuticFocus_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, toBeMoved: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName, label: string }> };

export type UpdatePersonTitleMutationVariables = Exact<{
  personId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdatePersonTitleMutation = { __typename: 'Mutation', updatePersonTitle: { __typename: 'Person', id: number, title?: string | null } };

export type MergeItemPersonTitleFragment = { __typename: 'PersonTitle_EntityDataToBeTransferredType', code: string, fromTitle?: string | null, toTitle?: string | null };

export type MRPersonTypesQueryVariables = Exact<{
  countryCode: Scalars['CountryCode'];
}>;


export type MRPersonTypesQuery = { __typename: 'Query', personTypes: { __typename: 'ValuePersonTypeConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string }> } };

export type UpdatePersonTypeMutationVariables = Exact<{
  personId: Scalars['Int'];
  newCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePersonTypeMutation = { __typename: 'Mutation', updatePersonType: { __typename: 'Person', id: number, persTypeCode?: string | null, persType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName } | null } };

export type MergeItemPersonTypeFragment = { __typename: 'PersonType_EntityDataToBeTransferredType', code: string, loserType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null, winnerType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type MergeAddressUpdateAddressMutationVariables = Exact<{
  addressAffiliationId: Scalars['Int'];
  input: AddressInput;
}>;


export type MergeAddressUpdateAddressMutation = { __typename: 'Mutation', updateAddress: { __typename: 'Address', id: number } };

export type MergeAddressFragment = { __typename: 'AddressAffiliation', id: number, address: { __typename: 'Address', id: number, city?: string | null, postalCode?: string | null, street?: string | null, countryCode?: string | null, countyCode?: string | null, type: { __typename: 'AddressType', code: string, headingKey: string } } };

export type MergeContactValuesMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  type: ContactTypeEnum;
  entityAffiliationId: Scalars['Int'];
  values: Array<ContactValueInput> | ContactValueInput;
}>;


export type MergeContactValuesMutation = { __typename: 'Mutation', upsertContactValues: Array<{ __typename: 'ContactValue', id: number, value?: string | null }> };

export type ContactValueInfoFragment = { __typename: 'ContactValue', id: number, value?: string | null, consent?: { __typename: 'ConsentContactValue', id: number, status: boolean } | null, category: { __typename: 'ContactCategory', code: string, heading: string, isHeadingKey: boolean, typeEnum: ContactTypeEnum } };

export type EntityMergeListsModalQueryVariables = Exact<{
  listIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type EntityMergeListsModalQuery = { __typename: 'Query', lists: { __typename: 'ListConnection', hash: string, nodes: Array<{ __typename: 'List', id: number, title: string }> } };

export type MergeItemSiteActivitiesFragment = { __typename: 'SiteActivity_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, activityIds: Array<number> };

export type SiteEntityMergeActivityModalQueryVariables = Exact<{
  activityIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SiteEntityMergeActivityModalQuery = { __typename: 'Query', activities: { __typename: 'ActivityConnection', hash: string, nodes: Array<{ __typename: 'Activity', id: number, heading: string }> } };

export type MergeItemSiteAddressFragment = { __typename: 'SiteAddress_EntityDataToBeTransferredType', code: string, addressAffiliation: (
    { __typename: 'AddressAffiliation' }
    & MergeAddressFragment
  ), conflictedWith?: (
    { __typename: 'AddressAffiliation' }
    & MergeAddressFragment
  ) | null };

export type MergeItemSiteContactValueFragment = { __typename: 'SiteContactValue_EntityDataToBeTransferredType', code: string, loserValue: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ), winnerValue?: (
    { __typename: 'ContactValue' }
    & ContactValueInfoFragment
  ) | null };

export type MergeItemSiteCountryFragment = { __typename: 'SiteCountry_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, fromSiteCountry: any, toSiteCountry?: any | null };

export type MergeItemSiteCustomFieldFragment = { __typename: 'SiteCustomField_EntityDataToBeTransferredType', code: string, field: { __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum }, affiliationsToMove: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, loserExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )>, winnerExistingAffiliations: Array<(
    { __typename: 'CustomFieldToBeTransferredInfo' }
    & FieldDataFragment
  )> };

export type MergeItemSiteExternalIdFragment = { __typename: 'SiteExternalId_EntityDataToBeTransferredType', code: string, externalId: { __typename: 'ExternalId', id: number, externalId: string, type: { __typename: 'ExternalIdType', code: string, heading: string, isHeadingKey: boolean } }, existingExternalId?: { __typename: 'ExternalId', id: number, externalId: string } | null };

export type MRUpdateIsUnplacedMutationVariables = Exact<{
  siteId: Scalars['ID'];
  isUnplaced: Scalars['Boolean'];
}>;


export type MRUpdateIsUnplacedMutation = { __typename: 'Mutation', setSiteIsUnplaced: { __typename: 'Site', id: number, isUnplaced: boolean } };

export type MergeItemSiteIsUnplacedFragment = { __typename: 'SiteIsUnplaced_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, isUnplacedFrom: boolean, isUnplacedTo: boolean };

export type MergeItemSiteLinksFragment = { __typename: 'SiteLinks_EntityDataToBeTransferredType', code: string, alreadyOnWinner: Array<(
    { __typename: 'SitePerson' }
    & MergeItemSiteLinkFragment
  )>, linksToBeMoved: Array<(
    { __typename: 'SitePerson' }
    & MergeItemSiteLinkFragment
  )>, linksToBeMerged: Array<{ __typename: 'SiteLinkToBeMergedVirtualOverview', loser: (
      { __typename: 'SitePerson' }
      & MergeItemSiteLinkFragment
    ), winner: (
      { __typename: 'SitePerson' }
      & MergeItemSiteLinkFragment
    ) }> };

export type MergeItemSiteLinkFragment = { __typename: 'SitePerson', id: number, siteId: number, personId: number, person: { __typename: 'Person', id: number, fullName: string }, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type MergeMoveLinkToWinnerSiteMutationVariables = Exact<{
  linkId: Scalars['ID'];
  siteId: Scalars['ID'];
}>;


export type MergeMoveLinkToWinnerSiteMutation = { __typename: 'Mutation', newLinkFromExisting?: { __typename: 'SitePerson', id: number } | null };

export type MergeInactivateLinkMutationVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type MergeInactivateLinkMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean } };

export type MergeCreateSubMergeMutationVariables = Exact<{
  fromLinkId: Scalars['ID'];
  toLinkId: Scalars['ID'];
}>;


export type MergeCreateSubMergeMutation = { __typename: 'Mutation', createMergeRequest: { __typename: 'EntityMerge', id: number } };

export type MergeItemSiteListsFragment = { __typename: 'SiteLists_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, listIds: Array<number> };

export type UpdateSiteMailingNamePrefixMutationVariables = Exact<{
  siteId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdateSiteMailingNamePrefixMutation = { __typename: 'Mutation', updateSiteMailingNamePrefix: { __typename: 'Site', id: number, mailingNamePrefix?: string | null } };

export type MergeItemSiteMailingNamePrefixFragment = { __typename: 'SiteMailingNamePrefix_EntityDataToBeTransferredType', code: string, fromPrefixName?: string | null, toPrefixName?: string | null };

export type UpdateSiteNameMutationVariables = Exact<{
  siteId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdateSiteNameMutation = { __typename: 'Mutation', updateSiteName: { __typename: 'Site', id: number, name: string } };

export type MergeItemSiteNameFragment = { __typename: 'SiteName_EntityDataToBeTransferredType', code: string, fromName: string, toName: string };

export type MergeItemSiteNotesFragment = { __typename: 'SiteNotes_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, noteIds: Array<number> };

export type UpdateSiteParentMutationVariables = Exact<{
  siteId: Scalars['Int'];
  newValue: Scalars['Int'];
}>;


export type UpdateSiteParentMutation = { __typename: 'Mutation', updateSiteParentId: { __typename: 'Site', id: number, parentId?: number | null, parentSite?: { __typename: 'Site', id: number, name: string } | null } };

export type MergeItemSiteParentFragment = { __typename: 'SiteParent_EntityDataToBeTransferredType', code: string, fromParentSite?: { __typename: 'Site', id: number, name: string } | null, toParentSite?: { __typename: 'Site', id: number, name: string } | null };

export type MRSiteSetSegmentationCodeMutationVariables = Exact<{
  siteId: Scalars['Int'];
  segmentationCodeId: Scalars['Int'];
}>;


export type MRSiteSetSegmentationCodeMutation = { __typename: 'Mutation', upsertSiteSegmentationCode: { __typename: 'SiteSegmentationCode', id: number } };

export type MergeSiteRequestSegmentationQueryVariables = Exact<{ [key: string]: never; }>;


export type MergeSiteRequestSegmentationQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, heading: string }> } };

export type MergeItemSiteSegmentationFragment = { __typename: 'SiteSegmentation_EntityDataToBeTransferredType', code: string, dataType: EntityDataToBeTransferredDataTypeEnum, entityType: EntityTypeEnum, loser: { __typename: 'SegmentationCode', id: number, heading: string }, winner?: { __typename: 'SegmentationCode', id: number, heading: string } | null };

export type MergeItemSiteTagsFragment = { __typename: 'SiteTags_EntityDataToBeTransferredType', code: string, entityType: EntityTypeEnum, loserCodes: Array<{ __typename: 'SiteFilterCode', id: number, filterCode: { __typename: 'FilterCode', id: number, header: string } }>, winnerCodes: Array<{ __typename: 'SiteFilterCode', id: number, filterCode: { __typename: 'FilterCode', id: number, header: string } }> };

export type UpdateSiteTypeMutationVariables = Exact<{
  siteId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdateSiteTypeMutation = { __typename: 'Mutation', updateSiteTypeCode: { __typename: 'Site', id: number, siteTypeCode?: string | null } };

export type MergeItemSiteTypeFragment = { __typename: 'SiteType_EntityDataToBeTransferredType', code: string, fromCode?: string | null, toCode?: string | null, entityType: EntityTypeEnum, dataType: EntityDataToBeTransferredDataTypeEnum };

export type UpdateSiteWebpageMutationVariables = Exact<{
  siteId: Scalars['Int'];
  newValue: Scalars['String'];
}>;


export type UpdateSiteWebpageMutation = { __typename: 'Mutation', updateSiteWebpage: { __typename: 'Site', id: number, siteWebpage?: string | null } };

export type MergeItemSiteWebpageFragment = { __typename: 'SiteWebpage_EntityDataToBeTransferredType', code: string, fromWebpage?: string | null, toWebpage?: string | null };

export type PerformEntityMergeMutationMutationVariables = Exact<{
  mergeRequestId: Scalars['ID'];
}>;


export type PerformEntityMergeMutationMutation = { __typename: 'Mutation', performMerge: { __typename: 'VirtualEntityMergeInfo', fromId: number, intoId: number, hasConflict: boolean } };

export type AdminEntityMergeRequestQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  fromId: Scalars['ID'];
  intoId: Scalars['ID'];
}>;


export type AdminEntityMergeRequestQuery = { __typename: 'Query', virtualMergeOverview: { __typename: 'VirtualEntityMerge', entityType: EntityTypeEnum, status: EntityMergeStatusEnum, from?: (
      { __typename: 'Activity' }
      & EntityMergeFragment_Activity_Fragment
    ) | (
      { __typename: 'ActivityBrand' }
      & EntityMergeFragment_ActivityBrand_Fragment
    ) | (
      { __typename: 'ActivityFieldDays' }
      & EntityMergeFragment_ActivityFieldDays_Fragment
    ) | (
      { __typename: 'ActivityLocation' }
      & EntityMergeFragment_ActivityLocation_Fragment
    ) | (
      { __typename: 'ActivityPerson' }
      & EntityMergeFragment_ActivityPerson_Fragment
    ) | (
      { __typename: 'ActivityProduct' }
      & EntityMergeFragment_ActivityProduct_Fragment
    ) | (
      { __typename: 'ActivityTypeCustomField' }
      & EntityMergeFragment_ActivityTypeCustomField_Fragment
    ) | (
      { __typename: 'Address' }
      & EntityMergeFragment_Address_Fragment
    ) | (
      { __typename: 'AddressAffiliation' }
      & EntityMergeFragment_AddressAffiliation_Fragment
    ) | (
      { __typename: 'Brand' }
      & EntityMergeFragment_Brand_Fragment
    ) | (
      { __typename: 'ConsentContactValue' }
      & EntityMergeFragment_ConsentContactValue_Fragment
    ) | (
      { __typename: 'ConsentValue' }
      & EntityMergeFragment_ConsentValue_Fragment
    ) | (
      { __typename: 'ContactCategoryMapping' }
      & EntityMergeFragment_ContactCategoryMapping_Fragment
    ) | (
      { __typename: 'ContactValue' }
      & EntityMergeFragment_ContactValue_Fragment
    ) | (
      { __typename: 'CreateEntityField' }
      & EntityMergeFragment_CreateEntityField_Fragment
    ) | (
      { __typename: 'Criteria' }
      & EntityMergeFragment_Criteria_Fragment
    ) | (
      { __typename: 'CriteriaPath' }
      & EntityMergeFragment_CriteriaPath_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSaved' }
      & EntityMergeFragment_CriteriaSimpleSaved_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSavedCriteria' }
      & EntityMergeFragment_CriteriaSimpleSavedCriteria_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSavedPath' }
      & EntityMergeFragment_CriteriaSimpleSavedPath_Fragment
    ) | (
      { __typename: 'CriteriaType' }
      & EntityMergeFragment_CriteriaType_Fragment
    ) | (
      { __typename: 'CustomFieldControlSetting' }
      & EntityMergeFragment_CustomFieldControlSetting_Fragment
    ) | (
      { __typename: 'CustomFieldGridConfiguration' }
      & EntityMergeFragment_CustomFieldGridConfiguration_Fragment
    ) | (
      { __typename: 'CustomFieldOption' }
      & EntityMergeFragment_CustomFieldOption_Fragment
    ) | (
      { __typename: 'CustomFieldOptionCountry' }
      & EntityMergeFragment_CustomFieldOptionCountry_Fragment
    ) | (
      { __typename: 'CustomFieldRole' }
      & EntityMergeFragment_CustomFieldRole_Fragment
    ) | (
      { __typename: 'CustomLinkValue' }
      & EntityMergeFragment_CustomLinkValue_Fragment
    ) | (
      { __typename: 'CustomValue' }
      & EntityMergeFragment_CustomValue_Fragment
    ) | (
      { __typename: 'Dashboard' }
      & EntityMergeFragment_Dashboard_Fragment
    ) | (
      { __typename: 'DashboardEntityPieSetting' }
      & EntityMergeFragment_DashboardEntityPieSetting_Fragment
    ) | (
      { __typename: 'DashboardItemConfiguration' }
      & EntityMergeFragment_DashboardItemConfiguration_Fragment
    ) | (
      { __typename: 'DashboardUser' }
      & EntityMergeFragment_DashboardUser_Fragment
    ) | (
      { __typename: 'Dcr' }
      & EntityMergeFragment_Dcr_Fragment
    ) | (
      { __typename: 'DcrComment' }
      & EntityMergeFragment_DcrComment_Fragment
    ) | (
      { __typename: 'DcrGroup' }
      & EntityMergeFragment_DcrGroup_Fragment
    ) | (
      { __typename: 'DcrGroupResponse' }
      & EntityMergeFragment_DcrGroupResponse_Fragment
    ) | (
      { __typename: 'DcrLine' }
      & EntityMergeFragment_DcrLine_Fragment
    ) | (
      { __typename: 'DcrNoteTemplate' }
      & EntityMergeFragment_DcrNoteTemplate_Fragment
    ) | (
      { __typename: 'DcrSnapshotInfo' }
      & EntityMergeFragment_DcrSnapshotInfo_Fragment
    ) | (
      { __typename: 'DefaultCriteria' }
      & EntityMergeFragment_DefaultCriteria_Fragment
    ) | (
      { __typename: 'DefaultDashboard' }
      & EntityMergeFragment_DefaultDashboard_Fragment
    ) | (
      { __typename: 'DefaultTableColumn' }
      & EntityMergeFragment_DefaultTableColumn_Fragment
    ) | (
      { __typename: 'DisabledDefaultDashboard' }
      & EntityMergeFragment_DisabledDefaultDashboard_Fragment
    ) | (
      { __typename: 'DynamicCriteriaList' }
      & EntityMergeFragment_DynamicCriteriaList_Fragment
    ) | (
      { __typename: 'DynamicCriteriaListValue' }
      & EntityMergeFragment_DynamicCriteriaListValue_Fragment
    ) | (
      { __typename: 'Entity' }
      & EntityMergeFragment_Entity_Fragment
    ) | (
      { __typename: 'EntityControlSetting' }
      & EntityMergeFragment_EntityControlSetting_Fragment
    ) | (
      { __typename: 'EntityGridItemCardField' }
      & EntityMergeFragment_EntityGridItemCardField_Fragment
    ) | (
      { __typename: 'EntityGridItemConfiguration' }
      & EntityMergeFragment_EntityGridItemConfiguration_Fragment
    ) | (
      { __typename: 'EntityGridItemField' }
      & EntityMergeFragment_EntityGridItemField_Fragment
    ) | (
      { __typename: 'EntityGridItemRelationField' }
      & EntityMergeFragment_EntityGridItemRelationField_Fragment
    ) | (
      { __typename: 'EntityMerge' }
      & EntityMergeFragment_EntityMerge_Fragment
    ) | (
      { __typename: 'EntityValidationLog' }
      & EntityMergeFragment_EntityValidationLog_Fragment
    ) | (
      { __typename: 'ExternalId' }
      & EntityMergeFragment_ExternalId_Fragment
    ) | (
      { __typename: 'ExternalIdSystem' }
      & EntityMergeFragment_ExternalIdSystem_Fragment
    ) | (
      { __typename: 'ExternalIdType' }
      & EntityMergeFragment_ExternalIdType_Fragment
    ) | (
      { __typename: 'ExternalIdTypeCountryExceptionRule' }
      & EntityMergeFragment_ExternalIdTypeCountryExceptionRule_Fragment
    ) | (
      { __typename: 'ExternalIdTypeRole' }
      & EntityMergeFragment_ExternalIdTypeRole_Fragment
    ) | (
      { __typename: 'FilterCode' }
      & EntityMergeFragment_FilterCode_Fragment
    ) | (
      { __typename: 'FilterCodeType' }
      & EntityMergeFragment_FilterCodeType_Fragment
    ) | (
      { __typename: 'ImportFile' }
      & EntityMergeFragment_ImportFile_Fragment
    ) | (
      { __typename: 'ImportLine' }
      & EntityMergeFragment_ImportLine_Fragment
    ) | (
      { __typename: 'ImportProcessField' }
      & EntityMergeFragment_ImportProcessField_Fragment
    ) | (
      { __typename: 'ImportProcessLine' }
      & EntityMergeFragment_ImportProcessLine_Fragment
    ) | (
      { __typename: 'ImportProcessLineEffect' }
      & EntityMergeFragment_ImportProcessLineEffect_Fragment
    ) | (
      { __typename: 'ImportProcessorData' }
      & EntityMergeFragment_ImportProcessorData_Fragment
    ) | (
      { __typename: 'ImportProject' }
      & EntityMergeFragment_ImportProject_Fragment
    ) | (
      { __typename: 'ImportTemplate' }
      & EntityMergeFragment_ImportTemplate_Fragment
    ) | (
      { __typename: 'ImportTemplateProcess' }
      & EntityMergeFragment_ImportTemplateProcess_Fragment
    ) | (
      { __typename: 'ImportTemplateProcessField' }
      & EntityMergeFragment_ImportTemplateProcessField_Fragment
    ) | (
      { __typename: 'List' }
      & EntityMergeFragment_List_Fragment
    ) | (
      { __typename: 'ListCountry' }
      & EntityMergeFragment_ListCountry_Fragment
    ) | (
      { __typename: 'ListFormat' }
      & EntityMergeFragment_ListFormat_Fragment
    ) | (
      { __typename: 'ListFormatField' }
      & EntityMergeFragment_ListFormatField_Fragment
    ) | (
      { __typename: 'ListPin' }
      & EntityMergeFragment_ListPin_Fragment
    ) | (
      { __typename: 'ListType' }
      & EntityMergeFragment_ListType_Fragment
    ) | (
      { __typename: 'ListUserFav' }
      & EntityMergeFragment_ListUserFav_Fragment
    ) | (
      { __typename: 'MarketAccessSite' }
      & EntityMergeFragment_MarketAccessSite_Fragment
    ) | (
      { __typename: 'MarketAccessSitePerson' }
      & EntityMergeFragment_MarketAccessSitePerson_Fragment
    ) | (
      { __typename: 'Note' }
      & EntityMergeFragment_Note_Fragment
    ) | (
      { __typename: 'OperatorType' }
      & EntityMergeFragment_OperatorType_Fragment
    ) | (
      { __typename: 'PersProjPreference' }
      & EntityMergeFragment_PersProjPreference_Fragment
    ) | (
      { __typename: 'Person' }
      & EntityMergeFragment_Person_Fragment
    ) | (
      { __typename: 'PersonActivityProduct' }
      & EntityMergeFragment_PersonActivityProduct_Fragment
    ) | (
      { __typename: 'PersonEducation' }
      & EntityMergeFragment_PersonEducation_Fragment
    ) | (
      { __typename: 'PersonFilterCode' }
      & EntityMergeFragment_PersonFilterCode_Fragment
    ) | (
      { __typename: 'PersonLanguage' }
      & EntityMergeFragment_PersonLanguage_Fragment
    ) | (
      { __typename: 'PersonProductSegmentation' }
      & EntityMergeFragment_PersonProductSegmentation_Fragment
    ) | (
      { __typename: 'PersonProject' }
      & EntityMergeFragment_PersonProject_Fragment
    ) | (
      { __typename: 'PersonSegmentationCode' }
      & EntityMergeFragment_PersonSegmentationCode_Fragment
    ) | (
      { __typename: 'PersonTherapeuticFocus' }
      & EntityMergeFragment_PersonTherapeuticFocus_Fragment
    ) | (
      { __typename: 'PersonUser' }
      & EntityMergeFragment_PersonUser_Fragment
    ) | (
      { __typename: 'Preference' }
      & EntityMergeFragment_Preference_Fragment
    ) | (
      { __typename: 'Product' }
      & EntityMergeFragment_Product_Fragment
    ) | (
      { __typename: 'Project' }
      & EntityMergeFragment_Project_Fragment
    ) | (
      { __typename: 'ProjectActivity' }
      & EntityMergeFragment_ProjectActivity_Fragment
    ) | (
      { __typename: 'ProjectProduct' }
      & EntityMergeFragment_ProjectProduct_Fragment
    ) | (
      { __typename: 'ProjectStatus' }
      & EntityMergeFragment_ProjectStatus_Fragment
    ) | (
      { __typename: 'ProjectType' }
      & EntityMergeFragment_ProjectType_Fragment
    ) | (
      { __typename: 'ProjectUser' }
      & EntityMergeFragment_ProjectUser_Fragment
    ) | (
      { __typename: 'PureAdvanceCustomerSandbox' }
      & EntityMergeFragment_PureAdvanceCustomerSandbox_Fragment
    ) | (
      { __typename: 'PureAdvanceCustomerSelection' }
      & EntityMergeFragment_PureAdvanceCustomerSelection_Fragment
    ) | (
      { __typename: 'PureAdvanceModule' }
      & EntityMergeFragment_PureAdvanceModule_Fragment
    ) | (
      { __typename: 'ReportSettingDailyCallTarget' }
      & EntityMergeFragment_ReportSettingDailyCallTarget_Fragment
    ) | (
      { __typename: 'ReportSettingFieldDay' }
      & EntityMergeFragment_ReportSettingFieldDay_Fragment
    ) | (
      { __typename: 'ReportSettingsActivityType' }
      & EntityMergeFragment_ReportSettingsActivityType_Fragment
    ) | (
      { __typename: 'ResponsibleArea' }
      & EntityMergeFragment_ResponsibleArea_Fragment
    ) | (
      { __typename: 'Role' }
      & EntityMergeFragment_Role_Fragment
    ) | (
      { __typename: 'RolePermission' }
      & EntityMergeFragment_RolePermission_Fragment
    ) | (
      { __typename: 'SalesCycle' }
      & EntityMergeFragment_SalesCycle_Fragment
    ) | (
      { __typename: 'SalesCycleSegmentationTarget' }
      & EntityMergeFragment_SalesCycleSegmentationTarget_Fragment
    ) | (
      { __typename: 'SalesCycleSetup' }
      & EntityMergeFragment_SalesCycleSetup_Fragment
    ) | (
      { __typename: 'Search' }
      & EntityMergeFragment_Search_Fragment
    ) | (
      { __typename: 'SegmentationCode' }
      & EntityMergeFragment_SegmentationCode_Fragment
    ) | (
      { __typename: 'Selection' }
      & EntityMergeFragment_Selection_Fragment
    ) | (
      { __typename: 'SelectionGroup' }
      & EntityMergeFragment_SelectionGroup_Fragment
    ) | (
      { __typename: 'SelectionRow' }
      & EntityMergeFragment_SelectionRow_Fragment
    ) | (
      { __typename: 'SelectionRowResult' }
      & EntityMergeFragment_SelectionRowResult_Fragment
    ) | (
      { __typename: 'Site' }
      & EntityMergeFragment_Site_Fragment
    ) | (
      { __typename: 'SiteFilterCode' }
      & EntityMergeFragment_SiteFilterCode_Fragment
    ) | (
      { __typename: 'SitePerson' }
      & EntityMergeFragment_SitePerson_Fragment
    ) | (
      { __typename: 'SitePersonTherapeuticFocus' }
      & EntityMergeFragment_SitePersonTherapeuticFocus_Fragment
    ) | (
      { __typename: 'SitePersonWorkingSpecialty' }
      & EntityMergeFragment_SitePersonWorkingSpecialty_Fragment
    ) | (
      { __typename: 'SiteResponsible' }
      & EntityMergeFragment_SiteResponsible_Fragment
    ) | (
      { __typename: 'SiteSegmentationCode' }
      & EntityMergeFragment_SiteSegmentationCode_Fragment
    ) | (
      { __typename: 'StandardTitle' }
      & EntityMergeFragment_StandardTitle_Fragment
    ) | (
      { __typename: 'Team' }
      & EntityMergeFragment_Team_Fragment
    ) | (
      { __typename: 'UnitType' }
      & EntityMergeFragment_UnitType_Fragment
    ) | (
      { __typename: 'User' }
      & EntityMergeFragment_User_Fragment
    ) | (
      { __typename: 'UserCountry' }
      & EntityMergeFragment_UserCountry_Fragment
    ) | (
      { __typename: 'UserPreferEnglishLov' }
      & EntityMergeFragment_UserPreferEnglishLov_Fragment
    ) | (
      { __typename: 'UserTableColumn' }
      & EntityMergeFragment_UserTableColumn_Fragment
    ) | (
      { __typename: 'UserTeam' }
      & EntityMergeFragment_UserTeam_Fragment
    ) | (
      { __typename: 'ValueModel' }
      & EntityMergeFragment_ValueModel_Fragment
    ) | null, into?: (
      { __typename: 'Activity' }
      & EntityMergeFragment_Activity_Fragment
    ) | (
      { __typename: 'ActivityBrand' }
      & EntityMergeFragment_ActivityBrand_Fragment
    ) | (
      { __typename: 'ActivityFieldDays' }
      & EntityMergeFragment_ActivityFieldDays_Fragment
    ) | (
      { __typename: 'ActivityLocation' }
      & EntityMergeFragment_ActivityLocation_Fragment
    ) | (
      { __typename: 'ActivityPerson' }
      & EntityMergeFragment_ActivityPerson_Fragment
    ) | (
      { __typename: 'ActivityProduct' }
      & EntityMergeFragment_ActivityProduct_Fragment
    ) | (
      { __typename: 'ActivityTypeCustomField' }
      & EntityMergeFragment_ActivityTypeCustomField_Fragment
    ) | (
      { __typename: 'Address' }
      & EntityMergeFragment_Address_Fragment
    ) | (
      { __typename: 'AddressAffiliation' }
      & EntityMergeFragment_AddressAffiliation_Fragment
    ) | (
      { __typename: 'Brand' }
      & EntityMergeFragment_Brand_Fragment
    ) | (
      { __typename: 'ConsentContactValue' }
      & EntityMergeFragment_ConsentContactValue_Fragment
    ) | (
      { __typename: 'ConsentValue' }
      & EntityMergeFragment_ConsentValue_Fragment
    ) | (
      { __typename: 'ContactCategoryMapping' }
      & EntityMergeFragment_ContactCategoryMapping_Fragment
    ) | (
      { __typename: 'ContactValue' }
      & EntityMergeFragment_ContactValue_Fragment
    ) | (
      { __typename: 'CreateEntityField' }
      & EntityMergeFragment_CreateEntityField_Fragment
    ) | (
      { __typename: 'Criteria' }
      & EntityMergeFragment_Criteria_Fragment
    ) | (
      { __typename: 'CriteriaPath' }
      & EntityMergeFragment_CriteriaPath_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSaved' }
      & EntityMergeFragment_CriteriaSimpleSaved_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSavedCriteria' }
      & EntityMergeFragment_CriteriaSimpleSavedCriteria_Fragment
    ) | (
      { __typename: 'CriteriaSimpleSavedPath' }
      & EntityMergeFragment_CriteriaSimpleSavedPath_Fragment
    ) | (
      { __typename: 'CriteriaType' }
      & EntityMergeFragment_CriteriaType_Fragment
    ) | (
      { __typename: 'CustomFieldControlSetting' }
      & EntityMergeFragment_CustomFieldControlSetting_Fragment
    ) | (
      { __typename: 'CustomFieldGridConfiguration' }
      & EntityMergeFragment_CustomFieldGridConfiguration_Fragment
    ) | (
      { __typename: 'CustomFieldOption' }
      & EntityMergeFragment_CustomFieldOption_Fragment
    ) | (
      { __typename: 'CustomFieldOptionCountry' }
      & EntityMergeFragment_CustomFieldOptionCountry_Fragment
    ) | (
      { __typename: 'CustomFieldRole' }
      & EntityMergeFragment_CustomFieldRole_Fragment
    ) | (
      { __typename: 'CustomLinkValue' }
      & EntityMergeFragment_CustomLinkValue_Fragment
    ) | (
      { __typename: 'CustomValue' }
      & EntityMergeFragment_CustomValue_Fragment
    ) | (
      { __typename: 'Dashboard' }
      & EntityMergeFragment_Dashboard_Fragment
    ) | (
      { __typename: 'DashboardEntityPieSetting' }
      & EntityMergeFragment_DashboardEntityPieSetting_Fragment
    ) | (
      { __typename: 'DashboardItemConfiguration' }
      & EntityMergeFragment_DashboardItemConfiguration_Fragment
    ) | (
      { __typename: 'DashboardUser' }
      & EntityMergeFragment_DashboardUser_Fragment
    ) | (
      { __typename: 'Dcr' }
      & EntityMergeFragment_Dcr_Fragment
    ) | (
      { __typename: 'DcrComment' }
      & EntityMergeFragment_DcrComment_Fragment
    ) | (
      { __typename: 'DcrGroup' }
      & EntityMergeFragment_DcrGroup_Fragment
    ) | (
      { __typename: 'DcrGroupResponse' }
      & EntityMergeFragment_DcrGroupResponse_Fragment
    ) | (
      { __typename: 'DcrLine' }
      & EntityMergeFragment_DcrLine_Fragment
    ) | (
      { __typename: 'DcrNoteTemplate' }
      & EntityMergeFragment_DcrNoteTemplate_Fragment
    ) | (
      { __typename: 'DcrSnapshotInfo' }
      & EntityMergeFragment_DcrSnapshotInfo_Fragment
    ) | (
      { __typename: 'DefaultCriteria' }
      & EntityMergeFragment_DefaultCriteria_Fragment
    ) | (
      { __typename: 'DefaultDashboard' }
      & EntityMergeFragment_DefaultDashboard_Fragment
    ) | (
      { __typename: 'DefaultTableColumn' }
      & EntityMergeFragment_DefaultTableColumn_Fragment
    ) | (
      { __typename: 'DisabledDefaultDashboard' }
      & EntityMergeFragment_DisabledDefaultDashboard_Fragment
    ) | (
      { __typename: 'DynamicCriteriaList' }
      & EntityMergeFragment_DynamicCriteriaList_Fragment
    ) | (
      { __typename: 'DynamicCriteriaListValue' }
      & EntityMergeFragment_DynamicCriteriaListValue_Fragment
    ) | (
      { __typename: 'Entity' }
      & EntityMergeFragment_Entity_Fragment
    ) | (
      { __typename: 'EntityControlSetting' }
      & EntityMergeFragment_EntityControlSetting_Fragment
    ) | (
      { __typename: 'EntityGridItemCardField' }
      & EntityMergeFragment_EntityGridItemCardField_Fragment
    ) | (
      { __typename: 'EntityGridItemConfiguration' }
      & EntityMergeFragment_EntityGridItemConfiguration_Fragment
    ) | (
      { __typename: 'EntityGridItemField' }
      & EntityMergeFragment_EntityGridItemField_Fragment
    ) | (
      { __typename: 'EntityGridItemRelationField' }
      & EntityMergeFragment_EntityGridItemRelationField_Fragment
    ) | (
      { __typename: 'EntityMerge' }
      & EntityMergeFragment_EntityMerge_Fragment
    ) | (
      { __typename: 'EntityValidationLog' }
      & EntityMergeFragment_EntityValidationLog_Fragment
    ) | (
      { __typename: 'ExternalId' }
      & EntityMergeFragment_ExternalId_Fragment
    ) | (
      { __typename: 'ExternalIdSystem' }
      & EntityMergeFragment_ExternalIdSystem_Fragment
    ) | (
      { __typename: 'ExternalIdType' }
      & EntityMergeFragment_ExternalIdType_Fragment
    ) | (
      { __typename: 'ExternalIdTypeCountryExceptionRule' }
      & EntityMergeFragment_ExternalIdTypeCountryExceptionRule_Fragment
    ) | (
      { __typename: 'ExternalIdTypeRole' }
      & EntityMergeFragment_ExternalIdTypeRole_Fragment
    ) | (
      { __typename: 'FilterCode' }
      & EntityMergeFragment_FilterCode_Fragment
    ) | (
      { __typename: 'FilterCodeType' }
      & EntityMergeFragment_FilterCodeType_Fragment
    ) | (
      { __typename: 'ImportFile' }
      & EntityMergeFragment_ImportFile_Fragment
    ) | (
      { __typename: 'ImportLine' }
      & EntityMergeFragment_ImportLine_Fragment
    ) | (
      { __typename: 'ImportProcessField' }
      & EntityMergeFragment_ImportProcessField_Fragment
    ) | (
      { __typename: 'ImportProcessLine' }
      & EntityMergeFragment_ImportProcessLine_Fragment
    ) | (
      { __typename: 'ImportProcessLineEffect' }
      & EntityMergeFragment_ImportProcessLineEffect_Fragment
    ) | (
      { __typename: 'ImportProcessorData' }
      & EntityMergeFragment_ImportProcessorData_Fragment
    ) | (
      { __typename: 'ImportProject' }
      & EntityMergeFragment_ImportProject_Fragment
    ) | (
      { __typename: 'ImportTemplate' }
      & EntityMergeFragment_ImportTemplate_Fragment
    ) | (
      { __typename: 'ImportTemplateProcess' }
      & EntityMergeFragment_ImportTemplateProcess_Fragment
    ) | (
      { __typename: 'ImportTemplateProcessField' }
      & EntityMergeFragment_ImportTemplateProcessField_Fragment
    ) | (
      { __typename: 'List' }
      & EntityMergeFragment_List_Fragment
    ) | (
      { __typename: 'ListCountry' }
      & EntityMergeFragment_ListCountry_Fragment
    ) | (
      { __typename: 'ListFormat' }
      & EntityMergeFragment_ListFormat_Fragment
    ) | (
      { __typename: 'ListFormatField' }
      & EntityMergeFragment_ListFormatField_Fragment
    ) | (
      { __typename: 'ListPin' }
      & EntityMergeFragment_ListPin_Fragment
    ) | (
      { __typename: 'ListType' }
      & EntityMergeFragment_ListType_Fragment
    ) | (
      { __typename: 'ListUserFav' }
      & EntityMergeFragment_ListUserFav_Fragment
    ) | (
      { __typename: 'MarketAccessSite' }
      & EntityMergeFragment_MarketAccessSite_Fragment
    ) | (
      { __typename: 'MarketAccessSitePerson' }
      & EntityMergeFragment_MarketAccessSitePerson_Fragment
    ) | (
      { __typename: 'Note' }
      & EntityMergeFragment_Note_Fragment
    ) | (
      { __typename: 'OperatorType' }
      & EntityMergeFragment_OperatorType_Fragment
    ) | (
      { __typename: 'PersProjPreference' }
      & EntityMergeFragment_PersProjPreference_Fragment
    ) | (
      { __typename: 'Person' }
      & EntityMergeFragment_Person_Fragment
    ) | (
      { __typename: 'PersonActivityProduct' }
      & EntityMergeFragment_PersonActivityProduct_Fragment
    ) | (
      { __typename: 'PersonEducation' }
      & EntityMergeFragment_PersonEducation_Fragment
    ) | (
      { __typename: 'PersonFilterCode' }
      & EntityMergeFragment_PersonFilterCode_Fragment
    ) | (
      { __typename: 'PersonLanguage' }
      & EntityMergeFragment_PersonLanguage_Fragment
    ) | (
      { __typename: 'PersonProductSegmentation' }
      & EntityMergeFragment_PersonProductSegmentation_Fragment
    ) | (
      { __typename: 'PersonProject' }
      & EntityMergeFragment_PersonProject_Fragment
    ) | (
      { __typename: 'PersonSegmentationCode' }
      & EntityMergeFragment_PersonSegmentationCode_Fragment
    ) | (
      { __typename: 'PersonTherapeuticFocus' }
      & EntityMergeFragment_PersonTherapeuticFocus_Fragment
    ) | (
      { __typename: 'PersonUser' }
      & EntityMergeFragment_PersonUser_Fragment
    ) | (
      { __typename: 'Preference' }
      & EntityMergeFragment_Preference_Fragment
    ) | (
      { __typename: 'Product' }
      & EntityMergeFragment_Product_Fragment
    ) | (
      { __typename: 'Project' }
      & EntityMergeFragment_Project_Fragment
    ) | (
      { __typename: 'ProjectActivity' }
      & EntityMergeFragment_ProjectActivity_Fragment
    ) | (
      { __typename: 'ProjectProduct' }
      & EntityMergeFragment_ProjectProduct_Fragment
    ) | (
      { __typename: 'ProjectStatus' }
      & EntityMergeFragment_ProjectStatus_Fragment
    ) | (
      { __typename: 'ProjectType' }
      & EntityMergeFragment_ProjectType_Fragment
    ) | (
      { __typename: 'ProjectUser' }
      & EntityMergeFragment_ProjectUser_Fragment
    ) | (
      { __typename: 'PureAdvanceCustomerSandbox' }
      & EntityMergeFragment_PureAdvanceCustomerSandbox_Fragment
    ) | (
      { __typename: 'PureAdvanceCustomerSelection' }
      & EntityMergeFragment_PureAdvanceCustomerSelection_Fragment
    ) | (
      { __typename: 'PureAdvanceModule' }
      & EntityMergeFragment_PureAdvanceModule_Fragment
    ) | (
      { __typename: 'ReportSettingDailyCallTarget' }
      & EntityMergeFragment_ReportSettingDailyCallTarget_Fragment
    ) | (
      { __typename: 'ReportSettingFieldDay' }
      & EntityMergeFragment_ReportSettingFieldDay_Fragment
    ) | (
      { __typename: 'ReportSettingsActivityType' }
      & EntityMergeFragment_ReportSettingsActivityType_Fragment
    ) | (
      { __typename: 'ResponsibleArea' }
      & EntityMergeFragment_ResponsibleArea_Fragment
    ) | (
      { __typename: 'Role' }
      & EntityMergeFragment_Role_Fragment
    ) | (
      { __typename: 'RolePermission' }
      & EntityMergeFragment_RolePermission_Fragment
    ) | (
      { __typename: 'SalesCycle' }
      & EntityMergeFragment_SalesCycle_Fragment
    ) | (
      { __typename: 'SalesCycleSegmentationTarget' }
      & EntityMergeFragment_SalesCycleSegmentationTarget_Fragment
    ) | (
      { __typename: 'SalesCycleSetup' }
      & EntityMergeFragment_SalesCycleSetup_Fragment
    ) | (
      { __typename: 'Search' }
      & EntityMergeFragment_Search_Fragment
    ) | (
      { __typename: 'SegmentationCode' }
      & EntityMergeFragment_SegmentationCode_Fragment
    ) | (
      { __typename: 'Selection' }
      & EntityMergeFragment_Selection_Fragment
    ) | (
      { __typename: 'SelectionGroup' }
      & EntityMergeFragment_SelectionGroup_Fragment
    ) | (
      { __typename: 'SelectionRow' }
      & EntityMergeFragment_SelectionRow_Fragment
    ) | (
      { __typename: 'SelectionRowResult' }
      & EntityMergeFragment_SelectionRowResult_Fragment
    ) | (
      { __typename: 'Site' }
      & EntityMergeFragment_Site_Fragment
    ) | (
      { __typename: 'SiteFilterCode' }
      & EntityMergeFragment_SiteFilterCode_Fragment
    ) | (
      { __typename: 'SitePerson' }
      & EntityMergeFragment_SitePerson_Fragment
    ) | (
      { __typename: 'SitePersonTherapeuticFocus' }
      & EntityMergeFragment_SitePersonTherapeuticFocus_Fragment
    ) | (
      { __typename: 'SitePersonWorkingSpecialty' }
      & EntityMergeFragment_SitePersonWorkingSpecialty_Fragment
    ) | (
      { __typename: 'SiteResponsible' }
      & EntityMergeFragment_SiteResponsible_Fragment
    ) | (
      { __typename: 'SiteSegmentationCode' }
      & EntityMergeFragment_SiteSegmentationCode_Fragment
    ) | (
      { __typename: 'StandardTitle' }
      & EntityMergeFragment_StandardTitle_Fragment
    ) | (
      { __typename: 'Team' }
      & EntityMergeFragment_Team_Fragment
    ) | (
      { __typename: 'UnitType' }
      & EntityMergeFragment_UnitType_Fragment
    ) | (
      { __typename: 'User' }
      & EntityMergeFragment_User_Fragment
    ) | (
      { __typename: 'UserCountry' }
      & EntityMergeFragment_UserCountry_Fragment
    ) | (
      { __typename: 'UserPreferEnglishLov' }
      & EntityMergeFragment_UserPreferEnglishLov_Fragment
    ) | (
      { __typename: 'UserTableColumn' }
      & EntityMergeFragment_UserTableColumn_Fragment
    ) | (
      { __typename: 'UserTeam' }
      & EntityMergeFragment_UserTeam_Fragment
    ) | (
      { __typename: 'ValueModel' }
      & EntityMergeFragment_ValueModel_Fragment
    ) | null, overview: Array<(
      { __typename: 'VirtualEntityMergeFieldInfo' }
      & AdminEntityMergeItemFragmentFragment
    )> } };

export type EntityMergeFragment_Activity_Fragment = { __typename: 'Activity', id: number };

export type EntityMergeFragment_ActivityBrand_Fragment = { __typename: 'ActivityBrand', id: number };

export type EntityMergeFragment_ActivityFieldDays_Fragment = { __typename: 'ActivityFieldDays', id: number };

export type EntityMergeFragment_ActivityLocation_Fragment = { __typename: 'ActivityLocation', id: number };

export type EntityMergeFragment_ActivityPerson_Fragment = { __typename: 'ActivityPerson', id: number };

export type EntityMergeFragment_ActivityProduct_Fragment = { __typename: 'ActivityProduct', id: number };

export type EntityMergeFragment_ActivityTypeCustomField_Fragment = { __typename: 'ActivityTypeCustomField', id: number };

export type EntityMergeFragment_Address_Fragment = { __typename: 'Address', id: number };

export type EntityMergeFragment_AddressAffiliation_Fragment = { __typename: 'AddressAffiliation', id: number };

export type EntityMergeFragment_Brand_Fragment = { __typename: 'Brand', id: number };

export type EntityMergeFragment_ConsentContactValue_Fragment = { __typename: 'ConsentContactValue', id: number };

export type EntityMergeFragment_ConsentValue_Fragment = { __typename: 'ConsentValue', id: number };

export type EntityMergeFragment_ContactCategoryMapping_Fragment = { __typename: 'ContactCategoryMapping', id: number };

export type EntityMergeFragment_ContactValue_Fragment = { __typename: 'ContactValue', id: number };

export type EntityMergeFragment_CreateEntityField_Fragment = { __typename: 'CreateEntityField', id: number };

export type EntityMergeFragment_Criteria_Fragment = { __typename: 'Criteria', id: number };

export type EntityMergeFragment_CriteriaPath_Fragment = { __typename: 'CriteriaPath', id: number };

export type EntityMergeFragment_CriteriaSimpleSaved_Fragment = { __typename: 'CriteriaSimpleSaved', id: number };

export type EntityMergeFragment_CriteriaSimpleSavedCriteria_Fragment = { __typename: 'CriteriaSimpleSavedCriteria', id: number };

export type EntityMergeFragment_CriteriaSimpleSavedPath_Fragment = { __typename: 'CriteriaSimpleSavedPath', id: number };

export type EntityMergeFragment_CriteriaType_Fragment = { __typename: 'CriteriaType', id: number };

export type EntityMergeFragment_CustomFieldControlSetting_Fragment = { __typename: 'CustomFieldControlSetting', id: number };

export type EntityMergeFragment_CustomFieldGridConfiguration_Fragment = { __typename: 'CustomFieldGridConfiguration', id: number };

export type EntityMergeFragment_CustomFieldOption_Fragment = { __typename: 'CustomFieldOption', id: number };

export type EntityMergeFragment_CustomFieldOptionCountry_Fragment = { __typename: 'CustomFieldOptionCountry', id: number };

export type EntityMergeFragment_CustomFieldRole_Fragment = { __typename: 'CustomFieldRole', id: number };

export type EntityMergeFragment_CustomLinkValue_Fragment = { __typename: 'CustomLinkValue', id: number };

export type EntityMergeFragment_CustomValue_Fragment = { __typename: 'CustomValue', id: number };

export type EntityMergeFragment_Dashboard_Fragment = { __typename: 'Dashboard', id: number };

export type EntityMergeFragment_DashboardEntityPieSetting_Fragment = { __typename: 'DashboardEntityPieSetting', id: number };

export type EntityMergeFragment_DashboardItemConfiguration_Fragment = { __typename: 'DashboardItemConfiguration', id: number };

export type EntityMergeFragment_DashboardUser_Fragment = { __typename: 'DashboardUser', id: number };

export type EntityMergeFragment_Dcr_Fragment = { __typename: 'Dcr', id: number };

export type EntityMergeFragment_DcrComment_Fragment = { __typename: 'DcrComment', id: number };

export type EntityMergeFragment_DcrGroup_Fragment = { __typename: 'DcrGroup', id: number };

export type EntityMergeFragment_DcrGroupResponse_Fragment = { __typename: 'DcrGroupResponse', id: number };

export type EntityMergeFragment_DcrLine_Fragment = { __typename: 'DcrLine', id: number };

export type EntityMergeFragment_DcrNoteTemplate_Fragment = { __typename: 'DcrNoteTemplate', id: number };

export type EntityMergeFragment_DcrSnapshotInfo_Fragment = { __typename: 'DcrSnapshotInfo', id: number };

export type EntityMergeFragment_DefaultCriteria_Fragment = { __typename: 'DefaultCriteria', id: number };

export type EntityMergeFragment_DefaultDashboard_Fragment = { __typename: 'DefaultDashboard', id: number };

export type EntityMergeFragment_DefaultTableColumn_Fragment = { __typename: 'DefaultTableColumn', id: number };

export type EntityMergeFragment_DisabledDefaultDashboard_Fragment = { __typename: 'DisabledDefaultDashboard', id: number };

export type EntityMergeFragment_DynamicCriteriaList_Fragment = { __typename: 'DynamicCriteriaList', id: number };

export type EntityMergeFragment_DynamicCriteriaListValue_Fragment = { __typename: 'DynamicCriteriaListValue', id: number };

export type EntityMergeFragment_Entity_Fragment = { __typename: 'Entity', id: number };

export type EntityMergeFragment_EntityControlSetting_Fragment = { __typename: 'EntityControlSetting', id: number };

export type EntityMergeFragment_EntityGridItemCardField_Fragment = { __typename: 'EntityGridItemCardField', id: number };

export type EntityMergeFragment_EntityGridItemConfiguration_Fragment = { __typename: 'EntityGridItemConfiguration', id: number };

export type EntityMergeFragment_EntityGridItemField_Fragment = { __typename: 'EntityGridItemField', id: number };

export type EntityMergeFragment_EntityGridItemRelationField_Fragment = { __typename: 'EntityGridItemRelationField', id: number };

export type EntityMergeFragment_EntityMerge_Fragment = { __typename: 'EntityMerge', id: number };

export type EntityMergeFragment_EntityValidationLog_Fragment = { __typename: 'EntityValidationLog', id: number };

export type EntityMergeFragment_ExternalId_Fragment = { __typename: 'ExternalId', id: number };

export type EntityMergeFragment_ExternalIdSystem_Fragment = { __typename: 'ExternalIdSystem', id: number };

export type EntityMergeFragment_ExternalIdType_Fragment = { __typename: 'ExternalIdType', id: number };

export type EntityMergeFragment_ExternalIdTypeCountryExceptionRule_Fragment = { __typename: 'ExternalIdTypeCountryExceptionRule', id: number };

export type EntityMergeFragment_ExternalIdTypeRole_Fragment = { __typename: 'ExternalIdTypeRole', id: number };

export type EntityMergeFragment_FilterCode_Fragment = { __typename: 'FilterCode', id: number };

export type EntityMergeFragment_FilterCodeType_Fragment = { __typename: 'FilterCodeType', id: number };

export type EntityMergeFragment_ImportFile_Fragment = { __typename: 'ImportFile', id: number };

export type EntityMergeFragment_ImportLine_Fragment = { __typename: 'ImportLine', id: number };

export type EntityMergeFragment_ImportProcessField_Fragment = { __typename: 'ImportProcessField', id: number };

export type EntityMergeFragment_ImportProcessLine_Fragment = { __typename: 'ImportProcessLine', id: number };

export type EntityMergeFragment_ImportProcessLineEffect_Fragment = { __typename: 'ImportProcessLineEffect', id: number };

export type EntityMergeFragment_ImportProcessorData_Fragment = { __typename: 'ImportProcessorData', id: number };

export type EntityMergeFragment_ImportProject_Fragment = { __typename: 'ImportProject', id: number };

export type EntityMergeFragment_ImportTemplate_Fragment = { __typename: 'ImportTemplate', id: number };

export type EntityMergeFragment_ImportTemplateProcess_Fragment = { __typename: 'ImportTemplateProcess', id: number };

export type EntityMergeFragment_ImportTemplateProcessField_Fragment = { __typename: 'ImportTemplateProcessField', id: number };

export type EntityMergeFragment_List_Fragment = { __typename: 'List', id: number };

export type EntityMergeFragment_ListCountry_Fragment = { __typename: 'ListCountry', id: number };

export type EntityMergeFragment_ListFormat_Fragment = { __typename: 'ListFormat', id: number };

export type EntityMergeFragment_ListFormatField_Fragment = { __typename: 'ListFormatField', id: number };

export type EntityMergeFragment_ListPin_Fragment = { __typename: 'ListPin', id: number };

export type EntityMergeFragment_ListType_Fragment = { __typename: 'ListType', id: number };

export type EntityMergeFragment_ListUserFav_Fragment = { __typename: 'ListUserFav', id: number };

export type EntityMergeFragment_MarketAccessSite_Fragment = { __typename: 'MarketAccessSite', id: number };

export type EntityMergeFragment_MarketAccessSitePerson_Fragment = { __typename: 'MarketAccessSitePerson', id: number };

export type EntityMergeFragment_Note_Fragment = { __typename: 'Note', id: number };

export type EntityMergeFragment_OperatorType_Fragment = { __typename: 'OperatorType', id: number };

export type EntityMergeFragment_PersProjPreference_Fragment = { __typename: 'PersProjPreference', id: number };

export type EntityMergeFragment_Person_Fragment = { __typename: 'Person', id: number, countryCode: string, fullName: string };

export type EntityMergeFragment_PersonActivityProduct_Fragment = { __typename: 'PersonActivityProduct', id: number };

export type EntityMergeFragment_PersonEducation_Fragment = { __typename: 'PersonEducation', id: number };

export type EntityMergeFragment_PersonFilterCode_Fragment = { __typename: 'PersonFilterCode', id: number };

export type EntityMergeFragment_PersonLanguage_Fragment = { __typename: 'PersonLanguage', id: number };

export type EntityMergeFragment_PersonProductSegmentation_Fragment = { __typename: 'PersonProductSegmentation', id: number };

export type EntityMergeFragment_PersonProject_Fragment = { __typename: 'PersonProject', id: number };

export type EntityMergeFragment_PersonSegmentationCode_Fragment = { __typename: 'PersonSegmentationCode', id: number };

export type EntityMergeFragment_PersonTherapeuticFocus_Fragment = { __typename: 'PersonTherapeuticFocus', id: number };

export type EntityMergeFragment_PersonUser_Fragment = { __typename: 'PersonUser', id: number };

export type EntityMergeFragment_Preference_Fragment = { __typename: 'Preference', id: number };

export type EntityMergeFragment_Product_Fragment = { __typename: 'Product', id: number };

export type EntityMergeFragment_Project_Fragment = { __typename: 'Project', id: number };

export type EntityMergeFragment_ProjectActivity_Fragment = { __typename: 'ProjectActivity', id: number };

export type EntityMergeFragment_ProjectProduct_Fragment = { __typename: 'ProjectProduct', id: number };

export type EntityMergeFragment_ProjectStatus_Fragment = { __typename: 'ProjectStatus', id: number };

export type EntityMergeFragment_ProjectType_Fragment = { __typename: 'ProjectType', id: number };

export type EntityMergeFragment_ProjectUser_Fragment = { __typename: 'ProjectUser', id: number };

export type EntityMergeFragment_PureAdvanceCustomerSandbox_Fragment = { __typename: 'PureAdvanceCustomerSandbox', id: number };

export type EntityMergeFragment_PureAdvanceCustomerSelection_Fragment = { __typename: 'PureAdvanceCustomerSelection', id: number };

export type EntityMergeFragment_PureAdvanceModule_Fragment = { __typename: 'PureAdvanceModule', id: number };

export type EntityMergeFragment_ReportSettingDailyCallTarget_Fragment = { __typename: 'ReportSettingDailyCallTarget', id: number };

export type EntityMergeFragment_ReportSettingFieldDay_Fragment = { __typename: 'ReportSettingFieldDay', id: number };

export type EntityMergeFragment_ReportSettingsActivityType_Fragment = { __typename: 'ReportSettingsActivityType', id: number };

export type EntityMergeFragment_ResponsibleArea_Fragment = { __typename: 'ResponsibleArea', id: number };

export type EntityMergeFragment_Role_Fragment = { __typename: 'Role', id: number };

export type EntityMergeFragment_RolePermission_Fragment = { __typename: 'RolePermission', id: number };

export type EntityMergeFragment_SalesCycle_Fragment = { __typename: 'SalesCycle', id: number };

export type EntityMergeFragment_SalesCycleSegmentationTarget_Fragment = { __typename: 'SalesCycleSegmentationTarget', id: number };

export type EntityMergeFragment_SalesCycleSetup_Fragment = { __typename: 'SalesCycleSetup', id: number };

export type EntityMergeFragment_Search_Fragment = { __typename: 'Search', id: number };

export type EntityMergeFragment_SegmentationCode_Fragment = { __typename: 'SegmentationCode', id: number };

export type EntityMergeFragment_Selection_Fragment = { __typename: 'Selection', id: number };

export type EntityMergeFragment_SelectionGroup_Fragment = { __typename: 'SelectionGroup', id: number };

export type EntityMergeFragment_SelectionRow_Fragment = { __typename: 'SelectionRow', id: number };

export type EntityMergeFragment_SelectionRowResult_Fragment = { __typename: 'SelectionRowResult', id: number };

export type EntityMergeFragment_Site_Fragment = { __typename: 'Site', id: number, countryCode: string, name: string };

export type EntityMergeFragment_SiteFilterCode_Fragment = { __typename: 'SiteFilterCode', id: number };

export type EntityMergeFragment_SitePerson_Fragment = { __typename: 'SitePerson', id: number, countryCode: string, person: { __typename: 'Person', id: number, fullName: string }, site: { __typename: 'Site', id: number, name: string }, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type EntityMergeFragment_SitePersonTherapeuticFocus_Fragment = { __typename: 'SitePersonTherapeuticFocus', id: number };

export type EntityMergeFragment_SitePersonWorkingSpecialty_Fragment = { __typename: 'SitePersonWorkingSpecialty', id: number };

export type EntityMergeFragment_SiteResponsible_Fragment = { __typename: 'SiteResponsible', id: number };

export type EntityMergeFragment_SiteSegmentationCode_Fragment = { __typename: 'SiteSegmentationCode', id: number };

export type EntityMergeFragment_StandardTitle_Fragment = { __typename: 'StandardTitle', id: number };

export type EntityMergeFragment_Team_Fragment = { __typename: 'Team', id: number };

export type EntityMergeFragment_UnitType_Fragment = { __typename: 'UnitType', id: number };

export type EntityMergeFragment_User_Fragment = { __typename: 'User', id: number };

export type EntityMergeFragment_UserCountry_Fragment = { __typename: 'UserCountry', id: number };

export type EntityMergeFragment_UserPreferEnglishLov_Fragment = { __typename: 'UserPreferEnglishLov', id: number };

export type EntityMergeFragment_UserTableColumn_Fragment = { __typename: 'UserTableColumn', id: number };

export type EntityMergeFragment_UserTeam_Fragment = { __typename: 'UserTeam', id: number };

export type EntityMergeFragment_ValueModel_Fragment = { __typename: 'ValueModel', id: number };

export type EntityMergeFragmentFragment = EntityMergeFragment_Activity_Fragment | EntityMergeFragment_ActivityBrand_Fragment | EntityMergeFragment_ActivityFieldDays_Fragment | EntityMergeFragment_ActivityLocation_Fragment | EntityMergeFragment_ActivityPerson_Fragment | EntityMergeFragment_ActivityProduct_Fragment | EntityMergeFragment_ActivityTypeCustomField_Fragment | EntityMergeFragment_Address_Fragment | EntityMergeFragment_AddressAffiliation_Fragment | EntityMergeFragment_Brand_Fragment | EntityMergeFragment_ConsentContactValue_Fragment | EntityMergeFragment_ConsentValue_Fragment | EntityMergeFragment_ContactCategoryMapping_Fragment | EntityMergeFragment_ContactValue_Fragment | EntityMergeFragment_CreateEntityField_Fragment | EntityMergeFragment_Criteria_Fragment | EntityMergeFragment_CriteriaPath_Fragment | EntityMergeFragment_CriteriaSimpleSaved_Fragment | EntityMergeFragment_CriteriaSimpleSavedCriteria_Fragment | EntityMergeFragment_CriteriaSimpleSavedPath_Fragment | EntityMergeFragment_CriteriaType_Fragment | EntityMergeFragment_CustomFieldControlSetting_Fragment | EntityMergeFragment_CustomFieldGridConfiguration_Fragment | EntityMergeFragment_CustomFieldOption_Fragment | EntityMergeFragment_CustomFieldOptionCountry_Fragment | EntityMergeFragment_CustomFieldRole_Fragment | EntityMergeFragment_CustomLinkValue_Fragment | EntityMergeFragment_CustomValue_Fragment | EntityMergeFragment_Dashboard_Fragment | EntityMergeFragment_DashboardEntityPieSetting_Fragment | EntityMergeFragment_DashboardItemConfiguration_Fragment | EntityMergeFragment_DashboardUser_Fragment | EntityMergeFragment_Dcr_Fragment | EntityMergeFragment_DcrComment_Fragment | EntityMergeFragment_DcrGroup_Fragment | EntityMergeFragment_DcrGroupResponse_Fragment | EntityMergeFragment_DcrLine_Fragment | EntityMergeFragment_DcrNoteTemplate_Fragment | EntityMergeFragment_DcrSnapshotInfo_Fragment | EntityMergeFragment_DefaultCriteria_Fragment | EntityMergeFragment_DefaultDashboard_Fragment | EntityMergeFragment_DefaultTableColumn_Fragment | EntityMergeFragment_DisabledDefaultDashboard_Fragment | EntityMergeFragment_DynamicCriteriaList_Fragment | EntityMergeFragment_DynamicCriteriaListValue_Fragment | EntityMergeFragment_Entity_Fragment | EntityMergeFragment_EntityControlSetting_Fragment | EntityMergeFragment_EntityGridItemCardField_Fragment | EntityMergeFragment_EntityGridItemConfiguration_Fragment | EntityMergeFragment_EntityGridItemField_Fragment | EntityMergeFragment_EntityGridItemRelationField_Fragment | EntityMergeFragment_EntityMerge_Fragment | EntityMergeFragment_EntityValidationLog_Fragment | EntityMergeFragment_ExternalId_Fragment | EntityMergeFragment_ExternalIdSystem_Fragment | EntityMergeFragment_ExternalIdType_Fragment | EntityMergeFragment_ExternalIdTypeCountryExceptionRule_Fragment | EntityMergeFragment_ExternalIdTypeRole_Fragment | EntityMergeFragment_FilterCode_Fragment | EntityMergeFragment_FilterCodeType_Fragment | EntityMergeFragment_ImportFile_Fragment | EntityMergeFragment_ImportLine_Fragment | EntityMergeFragment_ImportProcessField_Fragment | EntityMergeFragment_ImportProcessLine_Fragment | EntityMergeFragment_ImportProcessLineEffect_Fragment | EntityMergeFragment_ImportProcessorData_Fragment | EntityMergeFragment_ImportProject_Fragment | EntityMergeFragment_ImportTemplate_Fragment | EntityMergeFragment_ImportTemplateProcess_Fragment | EntityMergeFragment_ImportTemplateProcessField_Fragment | EntityMergeFragment_List_Fragment | EntityMergeFragment_ListCountry_Fragment | EntityMergeFragment_ListFormat_Fragment | EntityMergeFragment_ListFormatField_Fragment | EntityMergeFragment_ListPin_Fragment | EntityMergeFragment_ListType_Fragment | EntityMergeFragment_ListUserFav_Fragment | EntityMergeFragment_MarketAccessSite_Fragment | EntityMergeFragment_MarketAccessSitePerson_Fragment | EntityMergeFragment_Note_Fragment | EntityMergeFragment_OperatorType_Fragment | EntityMergeFragment_PersProjPreference_Fragment | EntityMergeFragment_Person_Fragment | EntityMergeFragment_PersonActivityProduct_Fragment | EntityMergeFragment_PersonEducation_Fragment | EntityMergeFragment_PersonFilterCode_Fragment | EntityMergeFragment_PersonLanguage_Fragment | EntityMergeFragment_PersonProductSegmentation_Fragment | EntityMergeFragment_PersonProject_Fragment | EntityMergeFragment_PersonSegmentationCode_Fragment | EntityMergeFragment_PersonTherapeuticFocus_Fragment | EntityMergeFragment_PersonUser_Fragment | EntityMergeFragment_Preference_Fragment | EntityMergeFragment_Product_Fragment | EntityMergeFragment_Project_Fragment | EntityMergeFragment_ProjectActivity_Fragment | EntityMergeFragment_ProjectProduct_Fragment | EntityMergeFragment_ProjectStatus_Fragment | EntityMergeFragment_ProjectType_Fragment | EntityMergeFragment_ProjectUser_Fragment | EntityMergeFragment_PureAdvanceCustomerSandbox_Fragment | EntityMergeFragment_PureAdvanceCustomerSelection_Fragment | EntityMergeFragment_PureAdvanceModule_Fragment | EntityMergeFragment_ReportSettingDailyCallTarget_Fragment | EntityMergeFragment_ReportSettingFieldDay_Fragment | EntityMergeFragment_ReportSettingsActivityType_Fragment | EntityMergeFragment_ResponsibleArea_Fragment | EntityMergeFragment_Role_Fragment | EntityMergeFragment_RolePermission_Fragment | EntityMergeFragment_SalesCycle_Fragment | EntityMergeFragment_SalesCycleSegmentationTarget_Fragment | EntityMergeFragment_SalesCycleSetup_Fragment | EntityMergeFragment_Search_Fragment | EntityMergeFragment_SegmentationCode_Fragment | EntityMergeFragment_Selection_Fragment | EntityMergeFragment_SelectionGroup_Fragment | EntityMergeFragment_SelectionRow_Fragment | EntityMergeFragment_SelectionRowResult_Fragment | EntityMergeFragment_Site_Fragment | EntityMergeFragment_SiteFilterCode_Fragment | EntityMergeFragment_SitePerson_Fragment | EntityMergeFragment_SitePersonTherapeuticFocus_Fragment | EntityMergeFragment_SitePersonWorkingSpecialty_Fragment | EntityMergeFragment_SiteResponsible_Fragment | EntityMergeFragment_SiteSegmentationCode_Fragment | EntityMergeFragment_StandardTitle_Fragment | EntityMergeFragment_Team_Fragment | EntityMergeFragment_UnitType_Fragment | EntityMergeFragment_User_Fragment | EntityMergeFragment_UserCountry_Fragment | EntityMergeFragment_UserPreferEnglishLov_Fragment | EntityMergeFragment_UserTableColumn_Fragment | EntityMergeFragment_UserTeam_Fragment | EntityMergeFragment_ValueModel_Fragment;

export type PerformAutomaticMergesMutationVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type PerformAutomaticMergesMutation = { __typename: 'Mutation', performAutomaticMerges: Array<{ __typename: 'VirtualEntityMergeInfo', entityMergeId: number }> };

export type EntityMergeAdminOverviewQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type EntityMergeAdminOverviewQueryQuery = { __typename: 'Query', handled: { __typename: 'EntityMergeConnection', hash: string, totalCount: number }, unhandled: { __typename: 'EntityMergeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'EntityMerge', id: number, overview: { __typename: 'VirtualEntityMergeInfo', entityMergeId: number, hasConflict: boolean }, from?: (
        { __typename: 'Activity' }
        & EntityFragment_Activity_Fragment
      ) | (
        { __typename: 'ActivityBrand' }
        & EntityFragment_ActivityBrand_Fragment
      ) | (
        { __typename: 'ActivityFieldDays' }
        & EntityFragment_ActivityFieldDays_Fragment
      ) | (
        { __typename: 'ActivityLocation' }
        & EntityFragment_ActivityLocation_Fragment
      ) | (
        { __typename: 'ActivityPerson' }
        & EntityFragment_ActivityPerson_Fragment
      ) | (
        { __typename: 'ActivityProduct' }
        & EntityFragment_ActivityProduct_Fragment
      ) | (
        { __typename: 'ActivityTypeCustomField' }
        & EntityFragment_ActivityTypeCustomField_Fragment
      ) | (
        { __typename: 'Address' }
        & EntityFragment_Address_Fragment
      ) | (
        { __typename: 'AddressAffiliation' }
        & EntityFragment_AddressAffiliation_Fragment
      ) | (
        { __typename: 'Brand' }
        & EntityFragment_Brand_Fragment
      ) | (
        { __typename: 'ConsentContactValue' }
        & EntityFragment_ConsentContactValue_Fragment
      ) | (
        { __typename: 'ConsentValue' }
        & EntityFragment_ConsentValue_Fragment
      ) | (
        { __typename: 'ContactCategoryMapping' }
        & EntityFragment_ContactCategoryMapping_Fragment
      ) | (
        { __typename: 'ContactValue' }
        & EntityFragment_ContactValue_Fragment
      ) | (
        { __typename: 'CreateEntityField' }
        & EntityFragment_CreateEntityField_Fragment
      ) | (
        { __typename: 'Criteria' }
        & EntityFragment_Criteria_Fragment
      ) | (
        { __typename: 'CriteriaPath' }
        & EntityFragment_CriteriaPath_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSaved' }
        & EntityFragment_CriteriaSimpleSaved_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSavedCriteria' }
        & EntityFragment_CriteriaSimpleSavedCriteria_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSavedPath' }
        & EntityFragment_CriteriaSimpleSavedPath_Fragment
      ) | (
        { __typename: 'CriteriaType' }
        & EntityFragment_CriteriaType_Fragment
      ) | (
        { __typename: 'CustomFieldControlSetting' }
        & EntityFragment_CustomFieldControlSetting_Fragment
      ) | (
        { __typename: 'CustomFieldGridConfiguration' }
        & EntityFragment_CustomFieldGridConfiguration_Fragment
      ) | (
        { __typename: 'CustomFieldOption' }
        & EntityFragment_CustomFieldOption_Fragment
      ) | (
        { __typename: 'CustomFieldOptionCountry' }
        & EntityFragment_CustomFieldOptionCountry_Fragment
      ) | (
        { __typename: 'CustomFieldRole' }
        & EntityFragment_CustomFieldRole_Fragment
      ) | (
        { __typename: 'CustomLinkValue' }
        & EntityFragment_CustomLinkValue_Fragment
      ) | (
        { __typename: 'CustomValue' }
        & EntityFragment_CustomValue_Fragment
      ) | (
        { __typename: 'Dashboard' }
        & EntityFragment_Dashboard_Fragment
      ) | (
        { __typename: 'DashboardEntityPieSetting' }
        & EntityFragment_DashboardEntityPieSetting_Fragment
      ) | (
        { __typename: 'DashboardItemConfiguration' }
        & EntityFragment_DashboardItemConfiguration_Fragment
      ) | (
        { __typename: 'DashboardUser' }
        & EntityFragment_DashboardUser_Fragment
      ) | (
        { __typename: 'Dcr' }
        & EntityFragment_Dcr_Fragment
      ) | (
        { __typename: 'DcrComment' }
        & EntityFragment_DcrComment_Fragment
      ) | (
        { __typename: 'DcrGroup' }
        & EntityFragment_DcrGroup_Fragment
      ) | (
        { __typename: 'DcrGroupResponse' }
        & EntityFragment_DcrGroupResponse_Fragment
      ) | (
        { __typename: 'DcrLine' }
        & EntityFragment_DcrLine_Fragment
      ) | (
        { __typename: 'DcrNoteTemplate' }
        & EntityFragment_DcrNoteTemplate_Fragment
      ) | (
        { __typename: 'DcrSnapshotInfo' }
        & EntityFragment_DcrSnapshotInfo_Fragment
      ) | (
        { __typename: 'DefaultCriteria' }
        & EntityFragment_DefaultCriteria_Fragment
      ) | (
        { __typename: 'DefaultDashboard' }
        & EntityFragment_DefaultDashboard_Fragment
      ) | (
        { __typename: 'DefaultTableColumn' }
        & EntityFragment_DefaultTableColumn_Fragment
      ) | (
        { __typename: 'DisabledDefaultDashboard' }
        & EntityFragment_DisabledDefaultDashboard_Fragment
      ) | (
        { __typename: 'DynamicCriteriaList' }
        & EntityFragment_DynamicCriteriaList_Fragment
      ) | (
        { __typename: 'DynamicCriteriaListValue' }
        & EntityFragment_DynamicCriteriaListValue_Fragment
      ) | (
        { __typename: 'Entity' }
        & EntityFragment_Entity_Fragment
      ) | (
        { __typename: 'EntityControlSetting' }
        & EntityFragment_EntityControlSetting_Fragment
      ) | (
        { __typename: 'EntityGridItemCardField' }
        & EntityFragment_EntityGridItemCardField_Fragment
      ) | (
        { __typename: 'EntityGridItemConfiguration' }
        & EntityFragment_EntityGridItemConfiguration_Fragment
      ) | (
        { __typename: 'EntityGridItemField' }
        & EntityFragment_EntityGridItemField_Fragment
      ) | (
        { __typename: 'EntityGridItemRelationField' }
        & EntityFragment_EntityGridItemRelationField_Fragment
      ) | (
        { __typename: 'EntityMerge' }
        & EntityFragment_EntityMerge_Fragment
      ) | (
        { __typename: 'EntityValidationLog' }
        & EntityFragment_EntityValidationLog_Fragment
      ) | (
        { __typename: 'ExternalId' }
        & EntityFragment_ExternalId_Fragment
      ) | (
        { __typename: 'ExternalIdSystem' }
        & EntityFragment_ExternalIdSystem_Fragment
      ) | (
        { __typename: 'ExternalIdType' }
        & EntityFragment_ExternalIdType_Fragment
      ) | (
        { __typename: 'ExternalIdTypeCountryExceptionRule' }
        & EntityFragment_ExternalIdTypeCountryExceptionRule_Fragment
      ) | (
        { __typename: 'ExternalIdTypeRole' }
        & EntityFragment_ExternalIdTypeRole_Fragment
      ) | (
        { __typename: 'FilterCode' }
        & EntityFragment_FilterCode_Fragment
      ) | (
        { __typename: 'FilterCodeType' }
        & EntityFragment_FilterCodeType_Fragment
      ) | (
        { __typename: 'ImportFile' }
        & EntityFragment_ImportFile_Fragment
      ) | (
        { __typename: 'ImportLine' }
        & EntityFragment_ImportLine_Fragment
      ) | (
        { __typename: 'ImportProcessField' }
        & EntityFragment_ImportProcessField_Fragment
      ) | (
        { __typename: 'ImportProcessLine' }
        & EntityFragment_ImportProcessLine_Fragment
      ) | (
        { __typename: 'ImportProcessLineEffect' }
        & EntityFragment_ImportProcessLineEffect_Fragment
      ) | (
        { __typename: 'ImportProcessorData' }
        & EntityFragment_ImportProcessorData_Fragment
      ) | (
        { __typename: 'ImportProject' }
        & EntityFragment_ImportProject_Fragment
      ) | (
        { __typename: 'ImportTemplate' }
        & EntityFragment_ImportTemplate_Fragment
      ) | (
        { __typename: 'ImportTemplateProcess' }
        & EntityFragment_ImportTemplateProcess_Fragment
      ) | (
        { __typename: 'ImportTemplateProcessField' }
        & EntityFragment_ImportTemplateProcessField_Fragment
      ) | (
        { __typename: 'List' }
        & EntityFragment_List_Fragment
      ) | (
        { __typename: 'ListCountry' }
        & EntityFragment_ListCountry_Fragment
      ) | (
        { __typename: 'ListFormat' }
        & EntityFragment_ListFormat_Fragment
      ) | (
        { __typename: 'ListFormatField' }
        & EntityFragment_ListFormatField_Fragment
      ) | (
        { __typename: 'ListPin' }
        & EntityFragment_ListPin_Fragment
      ) | (
        { __typename: 'ListType' }
        & EntityFragment_ListType_Fragment
      ) | (
        { __typename: 'ListUserFav' }
        & EntityFragment_ListUserFav_Fragment
      ) | (
        { __typename: 'MarketAccessSite' }
        & EntityFragment_MarketAccessSite_Fragment
      ) | (
        { __typename: 'MarketAccessSitePerson' }
        & EntityFragment_MarketAccessSitePerson_Fragment
      ) | (
        { __typename: 'Note' }
        & EntityFragment_Note_Fragment
      ) | (
        { __typename: 'OperatorType' }
        & EntityFragment_OperatorType_Fragment
      ) | (
        { __typename: 'PersProjPreference' }
        & EntityFragment_PersProjPreference_Fragment
      ) | (
        { __typename: 'Person' }
        & EntityFragment_Person_Fragment
      ) | (
        { __typename: 'PersonActivityProduct' }
        & EntityFragment_PersonActivityProduct_Fragment
      ) | (
        { __typename: 'PersonEducation' }
        & EntityFragment_PersonEducation_Fragment
      ) | (
        { __typename: 'PersonFilterCode' }
        & EntityFragment_PersonFilterCode_Fragment
      ) | (
        { __typename: 'PersonLanguage' }
        & EntityFragment_PersonLanguage_Fragment
      ) | (
        { __typename: 'PersonProductSegmentation' }
        & EntityFragment_PersonProductSegmentation_Fragment
      ) | (
        { __typename: 'PersonProject' }
        & EntityFragment_PersonProject_Fragment
      ) | (
        { __typename: 'PersonSegmentationCode' }
        & EntityFragment_PersonSegmentationCode_Fragment
      ) | (
        { __typename: 'PersonTherapeuticFocus' }
        & EntityFragment_PersonTherapeuticFocus_Fragment
      ) | (
        { __typename: 'PersonUser' }
        & EntityFragment_PersonUser_Fragment
      ) | (
        { __typename: 'Preference' }
        & EntityFragment_Preference_Fragment
      ) | (
        { __typename: 'Product' }
        & EntityFragment_Product_Fragment
      ) | (
        { __typename: 'Project' }
        & EntityFragment_Project_Fragment
      ) | (
        { __typename: 'ProjectActivity' }
        & EntityFragment_ProjectActivity_Fragment
      ) | (
        { __typename: 'ProjectProduct' }
        & EntityFragment_ProjectProduct_Fragment
      ) | (
        { __typename: 'ProjectStatus' }
        & EntityFragment_ProjectStatus_Fragment
      ) | (
        { __typename: 'ProjectType' }
        & EntityFragment_ProjectType_Fragment
      ) | (
        { __typename: 'ProjectUser' }
        & EntityFragment_ProjectUser_Fragment
      ) | (
        { __typename: 'PureAdvanceCustomerSandbox' }
        & EntityFragment_PureAdvanceCustomerSandbox_Fragment
      ) | (
        { __typename: 'PureAdvanceCustomerSelection' }
        & EntityFragment_PureAdvanceCustomerSelection_Fragment
      ) | (
        { __typename: 'PureAdvanceModule' }
        & EntityFragment_PureAdvanceModule_Fragment
      ) | (
        { __typename: 'ReportSettingDailyCallTarget' }
        & EntityFragment_ReportSettingDailyCallTarget_Fragment
      ) | (
        { __typename: 'ReportSettingFieldDay' }
        & EntityFragment_ReportSettingFieldDay_Fragment
      ) | (
        { __typename: 'ReportSettingsActivityType' }
        & EntityFragment_ReportSettingsActivityType_Fragment
      ) | (
        { __typename: 'ResponsibleArea' }
        & EntityFragment_ResponsibleArea_Fragment
      ) | (
        { __typename: 'Role' }
        & EntityFragment_Role_Fragment
      ) | (
        { __typename: 'RolePermission' }
        & EntityFragment_RolePermission_Fragment
      ) | (
        { __typename: 'SalesCycle' }
        & EntityFragment_SalesCycle_Fragment
      ) | (
        { __typename: 'SalesCycleSegmentationTarget' }
        & EntityFragment_SalesCycleSegmentationTarget_Fragment
      ) | (
        { __typename: 'SalesCycleSetup' }
        & EntityFragment_SalesCycleSetup_Fragment
      ) | (
        { __typename: 'Search' }
        & EntityFragment_Search_Fragment
      ) | (
        { __typename: 'SegmentationCode' }
        & EntityFragment_SegmentationCode_Fragment
      ) | (
        { __typename: 'Selection' }
        & EntityFragment_Selection_Fragment
      ) | (
        { __typename: 'SelectionGroup' }
        & EntityFragment_SelectionGroup_Fragment
      ) | (
        { __typename: 'SelectionRow' }
        & EntityFragment_SelectionRow_Fragment
      ) | (
        { __typename: 'SelectionRowResult' }
        & EntityFragment_SelectionRowResult_Fragment
      ) | (
        { __typename: 'Site' }
        & EntityFragment_Site_Fragment
      ) | (
        { __typename: 'SiteFilterCode' }
        & EntityFragment_SiteFilterCode_Fragment
      ) | (
        { __typename: 'SitePerson' }
        & EntityFragment_SitePerson_Fragment
      ) | (
        { __typename: 'SitePersonTherapeuticFocus' }
        & EntityFragment_SitePersonTherapeuticFocus_Fragment
      ) | (
        { __typename: 'SitePersonWorkingSpecialty' }
        & EntityFragment_SitePersonWorkingSpecialty_Fragment
      ) | (
        { __typename: 'SiteResponsible' }
        & EntityFragment_SiteResponsible_Fragment
      ) | (
        { __typename: 'SiteSegmentationCode' }
        & EntityFragment_SiteSegmentationCode_Fragment
      ) | (
        { __typename: 'StandardTitle' }
        & EntityFragment_StandardTitle_Fragment
      ) | (
        { __typename: 'Team' }
        & EntityFragment_Team_Fragment
      ) | (
        { __typename: 'UnitType' }
        & EntityFragment_UnitType_Fragment
      ) | (
        { __typename: 'User' }
        & EntityFragment_User_Fragment
      ) | (
        { __typename: 'UserCountry' }
        & EntityFragment_UserCountry_Fragment
      ) | (
        { __typename: 'UserPreferEnglishLov' }
        & EntityFragment_UserPreferEnglishLov_Fragment
      ) | (
        { __typename: 'UserTableColumn' }
        & EntityFragment_UserTableColumn_Fragment
      ) | (
        { __typename: 'UserTeam' }
        & EntityFragment_UserTeam_Fragment
      ) | (
        { __typename: 'ValueModel' }
        & EntityFragment_ValueModel_Fragment
      ) | null, into?: (
        { __typename: 'Activity' }
        & EntityFragment_Activity_Fragment
      ) | (
        { __typename: 'ActivityBrand' }
        & EntityFragment_ActivityBrand_Fragment
      ) | (
        { __typename: 'ActivityFieldDays' }
        & EntityFragment_ActivityFieldDays_Fragment
      ) | (
        { __typename: 'ActivityLocation' }
        & EntityFragment_ActivityLocation_Fragment
      ) | (
        { __typename: 'ActivityPerson' }
        & EntityFragment_ActivityPerson_Fragment
      ) | (
        { __typename: 'ActivityProduct' }
        & EntityFragment_ActivityProduct_Fragment
      ) | (
        { __typename: 'ActivityTypeCustomField' }
        & EntityFragment_ActivityTypeCustomField_Fragment
      ) | (
        { __typename: 'Address' }
        & EntityFragment_Address_Fragment
      ) | (
        { __typename: 'AddressAffiliation' }
        & EntityFragment_AddressAffiliation_Fragment
      ) | (
        { __typename: 'Brand' }
        & EntityFragment_Brand_Fragment
      ) | (
        { __typename: 'ConsentContactValue' }
        & EntityFragment_ConsentContactValue_Fragment
      ) | (
        { __typename: 'ConsentValue' }
        & EntityFragment_ConsentValue_Fragment
      ) | (
        { __typename: 'ContactCategoryMapping' }
        & EntityFragment_ContactCategoryMapping_Fragment
      ) | (
        { __typename: 'ContactValue' }
        & EntityFragment_ContactValue_Fragment
      ) | (
        { __typename: 'CreateEntityField' }
        & EntityFragment_CreateEntityField_Fragment
      ) | (
        { __typename: 'Criteria' }
        & EntityFragment_Criteria_Fragment
      ) | (
        { __typename: 'CriteriaPath' }
        & EntityFragment_CriteriaPath_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSaved' }
        & EntityFragment_CriteriaSimpleSaved_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSavedCriteria' }
        & EntityFragment_CriteriaSimpleSavedCriteria_Fragment
      ) | (
        { __typename: 'CriteriaSimpleSavedPath' }
        & EntityFragment_CriteriaSimpleSavedPath_Fragment
      ) | (
        { __typename: 'CriteriaType' }
        & EntityFragment_CriteriaType_Fragment
      ) | (
        { __typename: 'CustomFieldControlSetting' }
        & EntityFragment_CustomFieldControlSetting_Fragment
      ) | (
        { __typename: 'CustomFieldGridConfiguration' }
        & EntityFragment_CustomFieldGridConfiguration_Fragment
      ) | (
        { __typename: 'CustomFieldOption' }
        & EntityFragment_CustomFieldOption_Fragment
      ) | (
        { __typename: 'CustomFieldOptionCountry' }
        & EntityFragment_CustomFieldOptionCountry_Fragment
      ) | (
        { __typename: 'CustomFieldRole' }
        & EntityFragment_CustomFieldRole_Fragment
      ) | (
        { __typename: 'CustomLinkValue' }
        & EntityFragment_CustomLinkValue_Fragment
      ) | (
        { __typename: 'CustomValue' }
        & EntityFragment_CustomValue_Fragment
      ) | (
        { __typename: 'Dashboard' }
        & EntityFragment_Dashboard_Fragment
      ) | (
        { __typename: 'DashboardEntityPieSetting' }
        & EntityFragment_DashboardEntityPieSetting_Fragment
      ) | (
        { __typename: 'DashboardItemConfiguration' }
        & EntityFragment_DashboardItemConfiguration_Fragment
      ) | (
        { __typename: 'DashboardUser' }
        & EntityFragment_DashboardUser_Fragment
      ) | (
        { __typename: 'Dcr' }
        & EntityFragment_Dcr_Fragment
      ) | (
        { __typename: 'DcrComment' }
        & EntityFragment_DcrComment_Fragment
      ) | (
        { __typename: 'DcrGroup' }
        & EntityFragment_DcrGroup_Fragment
      ) | (
        { __typename: 'DcrGroupResponse' }
        & EntityFragment_DcrGroupResponse_Fragment
      ) | (
        { __typename: 'DcrLine' }
        & EntityFragment_DcrLine_Fragment
      ) | (
        { __typename: 'DcrNoteTemplate' }
        & EntityFragment_DcrNoteTemplate_Fragment
      ) | (
        { __typename: 'DcrSnapshotInfo' }
        & EntityFragment_DcrSnapshotInfo_Fragment
      ) | (
        { __typename: 'DefaultCriteria' }
        & EntityFragment_DefaultCriteria_Fragment
      ) | (
        { __typename: 'DefaultDashboard' }
        & EntityFragment_DefaultDashboard_Fragment
      ) | (
        { __typename: 'DefaultTableColumn' }
        & EntityFragment_DefaultTableColumn_Fragment
      ) | (
        { __typename: 'DisabledDefaultDashboard' }
        & EntityFragment_DisabledDefaultDashboard_Fragment
      ) | (
        { __typename: 'DynamicCriteriaList' }
        & EntityFragment_DynamicCriteriaList_Fragment
      ) | (
        { __typename: 'DynamicCriteriaListValue' }
        & EntityFragment_DynamicCriteriaListValue_Fragment
      ) | (
        { __typename: 'Entity' }
        & EntityFragment_Entity_Fragment
      ) | (
        { __typename: 'EntityControlSetting' }
        & EntityFragment_EntityControlSetting_Fragment
      ) | (
        { __typename: 'EntityGridItemCardField' }
        & EntityFragment_EntityGridItemCardField_Fragment
      ) | (
        { __typename: 'EntityGridItemConfiguration' }
        & EntityFragment_EntityGridItemConfiguration_Fragment
      ) | (
        { __typename: 'EntityGridItemField' }
        & EntityFragment_EntityGridItemField_Fragment
      ) | (
        { __typename: 'EntityGridItemRelationField' }
        & EntityFragment_EntityGridItemRelationField_Fragment
      ) | (
        { __typename: 'EntityMerge' }
        & EntityFragment_EntityMerge_Fragment
      ) | (
        { __typename: 'EntityValidationLog' }
        & EntityFragment_EntityValidationLog_Fragment
      ) | (
        { __typename: 'ExternalId' }
        & EntityFragment_ExternalId_Fragment
      ) | (
        { __typename: 'ExternalIdSystem' }
        & EntityFragment_ExternalIdSystem_Fragment
      ) | (
        { __typename: 'ExternalIdType' }
        & EntityFragment_ExternalIdType_Fragment
      ) | (
        { __typename: 'ExternalIdTypeCountryExceptionRule' }
        & EntityFragment_ExternalIdTypeCountryExceptionRule_Fragment
      ) | (
        { __typename: 'ExternalIdTypeRole' }
        & EntityFragment_ExternalIdTypeRole_Fragment
      ) | (
        { __typename: 'FilterCode' }
        & EntityFragment_FilterCode_Fragment
      ) | (
        { __typename: 'FilterCodeType' }
        & EntityFragment_FilterCodeType_Fragment
      ) | (
        { __typename: 'ImportFile' }
        & EntityFragment_ImportFile_Fragment
      ) | (
        { __typename: 'ImportLine' }
        & EntityFragment_ImportLine_Fragment
      ) | (
        { __typename: 'ImportProcessField' }
        & EntityFragment_ImportProcessField_Fragment
      ) | (
        { __typename: 'ImportProcessLine' }
        & EntityFragment_ImportProcessLine_Fragment
      ) | (
        { __typename: 'ImportProcessLineEffect' }
        & EntityFragment_ImportProcessLineEffect_Fragment
      ) | (
        { __typename: 'ImportProcessorData' }
        & EntityFragment_ImportProcessorData_Fragment
      ) | (
        { __typename: 'ImportProject' }
        & EntityFragment_ImportProject_Fragment
      ) | (
        { __typename: 'ImportTemplate' }
        & EntityFragment_ImportTemplate_Fragment
      ) | (
        { __typename: 'ImportTemplateProcess' }
        & EntityFragment_ImportTemplateProcess_Fragment
      ) | (
        { __typename: 'ImportTemplateProcessField' }
        & EntityFragment_ImportTemplateProcessField_Fragment
      ) | (
        { __typename: 'List' }
        & EntityFragment_List_Fragment
      ) | (
        { __typename: 'ListCountry' }
        & EntityFragment_ListCountry_Fragment
      ) | (
        { __typename: 'ListFormat' }
        & EntityFragment_ListFormat_Fragment
      ) | (
        { __typename: 'ListFormatField' }
        & EntityFragment_ListFormatField_Fragment
      ) | (
        { __typename: 'ListPin' }
        & EntityFragment_ListPin_Fragment
      ) | (
        { __typename: 'ListType' }
        & EntityFragment_ListType_Fragment
      ) | (
        { __typename: 'ListUserFav' }
        & EntityFragment_ListUserFav_Fragment
      ) | (
        { __typename: 'MarketAccessSite' }
        & EntityFragment_MarketAccessSite_Fragment
      ) | (
        { __typename: 'MarketAccessSitePerson' }
        & EntityFragment_MarketAccessSitePerson_Fragment
      ) | (
        { __typename: 'Note' }
        & EntityFragment_Note_Fragment
      ) | (
        { __typename: 'OperatorType' }
        & EntityFragment_OperatorType_Fragment
      ) | (
        { __typename: 'PersProjPreference' }
        & EntityFragment_PersProjPreference_Fragment
      ) | (
        { __typename: 'Person' }
        & EntityFragment_Person_Fragment
      ) | (
        { __typename: 'PersonActivityProduct' }
        & EntityFragment_PersonActivityProduct_Fragment
      ) | (
        { __typename: 'PersonEducation' }
        & EntityFragment_PersonEducation_Fragment
      ) | (
        { __typename: 'PersonFilterCode' }
        & EntityFragment_PersonFilterCode_Fragment
      ) | (
        { __typename: 'PersonLanguage' }
        & EntityFragment_PersonLanguage_Fragment
      ) | (
        { __typename: 'PersonProductSegmentation' }
        & EntityFragment_PersonProductSegmentation_Fragment
      ) | (
        { __typename: 'PersonProject' }
        & EntityFragment_PersonProject_Fragment
      ) | (
        { __typename: 'PersonSegmentationCode' }
        & EntityFragment_PersonSegmentationCode_Fragment
      ) | (
        { __typename: 'PersonTherapeuticFocus' }
        & EntityFragment_PersonTherapeuticFocus_Fragment
      ) | (
        { __typename: 'PersonUser' }
        & EntityFragment_PersonUser_Fragment
      ) | (
        { __typename: 'Preference' }
        & EntityFragment_Preference_Fragment
      ) | (
        { __typename: 'Product' }
        & EntityFragment_Product_Fragment
      ) | (
        { __typename: 'Project' }
        & EntityFragment_Project_Fragment
      ) | (
        { __typename: 'ProjectActivity' }
        & EntityFragment_ProjectActivity_Fragment
      ) | (
        { __typename: 'ProjectProduct' }
        & EntityFragment_ProjectProduct_Fragment
      ) | (
        { __typename: 'ProjectStatus' }
        & EntityFragment_ProjectStatus_Fragment
      ) | (
        { __typename: 'ProjectType' }
        & EntityFragment_ProjectType_Fragment
      ) | (
        { __typename: 'ProjectUser' }
        & EntityFragment_ProjectUser_Fragment
      ) | (
        { __typename: 'PureAdvanceCustomerSandbox' }
        & EntityFragment_PureAdvanceCustomerSandbox_Fragment
      ) | (
        { __typename: 'PureAdvanceCustomerSelection' }
        & EntityFragment_PureAdvanceCustomerSelection_Fragment
      ) | (
        { __typename: 'PureAdvanceModule' }
        & EntityFragment_PureAdvanceModule_Fragment
      ) | (
        { __typename: 'ReportSettingDailyCallTarget' }
        & EntityFragment_ReportSettingDailyCallTarget_Fragment
      ) | (
        { __typename: 'ReportSettingFieldDay' }
        & EntityFragment_ReportSettingFieldDay_Fragment
      ) | (
        { __typename: 'ReportSettingsActivityType' }
        & EntityFragment_ReportSettingsActivityType_Fragment
      ) | (
        { __typename: 'ResponsibleArea' }
        & EntityFragment_ResponsibleArea_Fragment
      ) | (
        { __typename: 'Role' }
        & EntityFragment_Role_Fragment
      ) | (
        { __typename: 'RolePermission' }
        & EntityFragment_RolePermission_Fragment
      ) | (
        { __typename: 'SalesCycle' }
        & EntityFragment_SalesCycle_Fragment
      ) | (
        { __typename: 'SalesCycleSegmentationTarget' }
        & EntityFragment_SalesCycleSegmentationTarget_Fragment
      ) | (
        { __typename: 'SalesCycleSetup' }
        & EntityFragment_SalesCycleSetup_Fragment
      ) | (
        { __typename: 'Search' }
        & EntityFragment_Search_Fragment
      ) | (
        { __typename: 'SegmentationCode' }
        & EntityFragment_SegmentationCode_Fragment
      ) | (
        { __typename: 'Selection' }
        & EntityFragment_Selection_Fragment
      ) | (
        { __typename: 'SelectionGroup' }
        & EntityFragment_SelectionGroup_Fragment
      ) | (
        { __typename: 'SelectionRow' }
        & EntityFragment_SelectionRow_Fragment
      ) | (
        { __typename: 'SelectionRowResult' }
        & EntityFragment_SelectionRowResult_Fragment
      ) | (
        { __typename: 'Site' }
        & EntityFragment_Site_Fragment
      ) | (
        { __typename: 'SiteFilterCode' }
        & EntityFragment_SiteFilterCode_Fragment
      ) | (
        { __typename: 'SitePerson' }
        & EntityFragment_SitePerson_Fragment
      ) | (
        { __typename: 'SitePersonTherapeuticFocus' }
        & EntityFragment_SitePersonTherapeuticFocus_Fragment
      ) | (
        { __typename: 'SitePersonWorkingSpecialty' }
        & EntityFragment_SitePersonWorkingSpecialty_Fragment
      ) | (
        { __typename: 'SiteResponsible' }
        & EntityFragment_SiteResponsible_Fragment
      ) | (
        { __typename: 'SiteSegmentationCode' }
        & EntityFragment_SiteSegmentationCode_Fragment
      ) | (
        { __typename: 'StandardTitle' }
        & EntityFragment_StandardTitle_Fragment
      ) | (
        { __typename: 'Team' }
        & EntityFragment_Team_Fragment
      ) | (
        { __typename: 'UnitType' }
        & EntityFragment_UnitType_Fragment
      ) | (
        { __typename: 'User' }
        & EntityFragment_User_Fragment
      ) | (
        { __typename: 'UserCountry' }
        & EntityFragment_UserCountry_Fragment
      ) | (
        { __typename: 'UserPreferEnglishLov' }
        & EntityFragment_UserPreferEnglishLov_Fragment
      ) | (
        { __typename: 'UserTableColumn' }
        & EntityFragment_UserTableColumn_Fragment
      ) | (
        { __typename: 'UserTeam' }
        & EntityFragment_UserTeam_Fragment
      ) | (
        { __typename: 'ValueModel' }
        & EntityFragment_ValueModel_Fragment
      ) | null }> } };

export type EntityFragment_Activity_Fragment = { __typename: 'Activity' };

export type EntityFragment_ActivityBrand_Fragment = { __typename: 'ActivityBrand' };

export type EntityFragment_ActivityFieldDays_Fragment = { __typename: 'ActivityFieldDays' };

export type EntityFragment_ActivityLocation_Fragment = { __typename: 'ActivityLocation' };

export type EntityFragment_ActivityPerson_Fragment = { __typename: 'ActivityPerson' };

export type EntityFragment_ActivityProduct_Fragment = { __typename: 'ActivityProduct' };

export type EntityFragment_ActivityTypeCustomField_Fragment = { __typename: 'ActivityTypeCustomField' };

export type EntityFragment_Address_Fragment = { __typename: 'Address' };

export type EntityFragment_AddressAffiliation_Fragment = { __typename: 'AddressAffiliation' };

export type EntityFragment_Brand_Fragment = { __typename: 'Brand' };

export type EntityFragment_ConsentContactValue_Fragment = { __typename: 'ConsentContactValue' };

export type EntityFragment_ConsentValue_Fragment = { __typename: 'ConsentValue' };

export type EntityFragment_ContactCategoryMapping_Fragment = { __typename: 'ContactCategoryMapping' };

export type EntityFragment_ContactValue_Fragment = { __typename: 'ContactValue' };

export type EntityFragment_CreateEntityField_Fragment = { __typename: 'CreateEntityField' };

export type EntityFragment_Criteria_Fragment = { __typename: 'Criteria' };

export type EntityFragment_CriteriaPath_Fragment = { __typename: 'CriteriaPath' };

export type EntityFragment_CriteriaSimpleSaved_Fragment = { __typename: 'CriteriaSimpleSaved' };

export type EntityFragment_CriteriaSimpleSavedCriteria_Fragment = { __typename: 'CriteriaSimpleSavedCriteria' };

export type EntityFragment_CriteriaSimpleSavedPath_Fragment = { __typename: 'CriteriaSimpleSavedPath' };

export type EntityFragment_CriteriaType_Fragment = { __typename: 'CriteriaType' };

export type EntityFragment_CustomFieldControlSetting_Fragment = { __typename: 'CustomFieldControlSetting' };

export type EntityFragment_CustomFieldGridConfiguration_Fragment = { __typename: 'CustomFieldGridConfiguration' };

export type EntityFragment_CustomFieldOption_Fragment = { __typename: 'CustomFieldOption' };

export type EntityFragment_CustomFieldOptionCountry_Fragment = { __typename: 'CustomFieldOptionCountry' };

export type EntityFragment_CustomFieldRole_Fragment = { __typename: 'CustomFieldRole' };

export type EntityFragment_CustomLinkValue_Fragment = { __typename: 'CustomLinkValue' };

export type EntityFragment_CustomValue_Fragment = { __typename: 'CustomValue' };

export type EntityFragment_Dashboard_Fragment = { __typename: 'Dashboard' };

export type EntityFragment_DashboardEntityPieSetting_Fragment = { __typename: 'DashboardEntityPieSetting' };

export type EntityFragment_DashboardItemConfiguration_Fragment = { __typename: 'DashboardItemConfiguration' };

export type EntityFragment_DashboardUser_Fragment = { __typename: 'DashboardUser' };

export type EntityFragment_Dcr_Fragment = { __typename: 'Dcr' };

export type EntityFragment_DcrComment_Fragment = { __typename: 'DcrComment' };

export type EntityFragment_DcrGroup_Fragment = { __typename: 'DcrGroup' };

export type EntityFragment_DcrGroupResponse_Fragment = { __typename: 'DcrGroupResponse' };

export type EntityFragment_DcrLine_Fragment = { __typename: 'DcrLine' };

export type EntityFragment_DcrNoteTemplate_Fragment = { __typename: 'DcrNoteTemplate' };

export type EntityFragment_DcrSnapshotInfo_Fragment = { __typename: 'DcrSnapshotInfo' };

export type EntityFragment_DefaultCriteria_Fragment = { __typename: 'DefaultCriteria' };

export type EntityFragment_DefaultDashboard_Fragment = { __typename: 'DefaultDashboard' };

export type EntityFragment_DefaultTableColumn_Fragment = { __typename: 'DefaultTableColumn' };

export type EntityFragment_DisabledDefaultDashboard_Fragment = { __typename: 'DisabledDefaultDashboard' };

export type EntityFragment_DynamicCriteriaList_Fragment = { __typename: 'DynamicCriteriaList' };

export type EntityFragment_DynamicCriteriaListValue_Fragment = { __typename: 'DynamicCriteriaListValue' };

export type EntityFragment_Entity_Fragment = { __typename: 'Entity' };

export type EntityFragment_EntityControlSetting_Fragment = { __typename: 'EntityControlSetting' };

export type EntityFragment_EntityGridItemCardField_Fragment = { __typename: 'EntityGridItemCardField' };

export type EntityFragment_EntityGridItemConfiguration_Fragment = { __typename: 'EntityGridItemConfiguration' };

export type EntityFragment_EntityGridItemField_Fragment = { __typename: 'EntityGridItemField' };

export type EntityFragment_EntityGridItemRelationField_Fragment = { __typename: 'EntityGridItemRelationField' };

export type EntityFragment_EntityMerge_Fragment = { __typename: 'EntityMerge' };

export type EntityFragment_EntityValidationLog_Fragment = { __typename: 'EntityValidationLog' };

export type EntityFragment_ExternalId_Fragment = { __typename: 'ExternalId' };

export type EntityFragment_ExternalIdSystem_Fragment = { __typename: 'ExternalIdSystem' };

export type EntityFragment_ExternalIdType_Fragment = { __typename: 'ExternalIdType' };

export type EntityFragment_ExternalIdTypeCountryExceptionRule_Fragment = { __typename: 'ExternalIdTypeCountryExceptionRule' };

export type EntityFragment_ExternalIdTypeRole_Fragment = { __typename: 'ExternalIdTypeRole' };

export type EntityFragment_FilterCode_Fragment = { __typename: 'FilterCode' };

export type EntityFragment_FilterCodeType_Fragment = { __typename: 'FilterCodeType' };

export type EntityFragment_ImportFile_Fragment = { __typename: 'ImportFile' };

export type EntityFragment_ImportLine_Fragment = { __typename: 'ImportLine' };

export type EntityFragment_ImportProcessField_Fragment = { __typename: 'ImportProcessField' };

export type EntityFragment_ImportProcessLine_Fragment = { __typename: 'ImportProcessLine' };

export type EntityFragment_ImportProcessLineEffect_Fragment = { __typename: 'ImportProcessLineEffect' };

export type EntityFragment_ImportProcessorData_Fragment = { __typename: 'ImportProcessorData' };

export type EntityFragment_ImportProject_Fragment = { __typename: 'ImportProject' };

export type EntityFragment_ImportTemplate_Fragment = { __typename: 'ImportTemplate' };

export type EntityFragment_ImportTemplateProcess_Fragment = { __typename: 'ImportTemplateProcess' };

export type EntityFragment_ImportTemplateProcessField_Fragment = { __typename: 'ImportTemplateProcessField' };

export type EntityFragment_List_Fragment = { __typename: 'List' };

export type EntityFragment_ListCountry_Fragment = { __typename: 'ListCountry' };

export type EntityFragment_ListFormat_Fragment = { __typename: 'ListFormat' };

export type EntityFragment_ListFormatField_Fragment = { __typename: 'ListFormatField' };

export type EntityFragment_ListPin_Fragment = { __typename: 'ListPin' };

export type EntityFragment_ListType_Fragment = { __typename: 'ListType' };

export type EntityFragment_ListUserFav_Fragment = { __typename: 'ListUserFav' };

export type EntityFragment_MarketAccessSite_Fragment = { __typename: 'MarketAccessSite' };

export type EntityFragment_MarketAccessSitePerson_Fragment = { __typename: 'MarketAccessSitePerson' };

export type EntityFragment_Note_Fragment = { __typename: 'Note' };

export type EntityFragment_OperatorType_Fragment = { __typename: 'OperatorType' };

export type EntityFragment_PersProjPreference_Fragment = { __typename: 'PersProjPreference' };

export type EntityFragment_Person_Fragment = { __typename: 'Person', id: number, fullName: string };

export type EntityFragment_PersonActivityProduct_Fragment = { __typename: 'PersonActivityProduct' };

export type EntityFragment_PersonEducation_Fragment = { __typename: 'PersonEducation' };

export type EntityFragment_PersonFilterCode_Fragment = { __typename: 'PersonFilterCode' };

export type EntityFragment_PersonLanguage_Fragment = { __typename: 'PersonLanguage' };

export type EntityFragment_PersonProductSegmentation_Fragment = { __typename: 'PersonProductSegmentation' };

export type EntityFragment_PersonProject_Fragment = { __typename: 'PersonProject' };

export type EntityFragment_PersonSegmentationCode_Fragment = { __typename: 'PersonSegmentationCode' };

export type EntityFragment_PersonTherapeuticFocus_Fragment = { __typename: 'PersonTherapeuticFocus' };

export type EntityFragment_PersonUser_Fragment = { __typename: 'PersonUser' };

export type EntityFragment_Preference_Fragment = { __typename: 'Preference' };

export type EntityFragment_Product_Fragment = { __typename: 'Product' };

export type EntityFragment_Project_Fragment = { __typename: 'Project' };

export type EntityFragment_ProjectActivity_Fragment = { __typename: 'ProjectActivity' };

export type EntityFragment_ProjectProduct_Fragment = { __typename: 'ProjectProduct' };

export type EntityFragment_ProjectStatus_Fragment = { __typename: 'ProjectStatus' };

export type EntityFragment_ProjectType_Fragment = { __typename: 'ProjectType' };

export type EntityFragment_ProjectUser_Fragment = { __typename: 'ProjectUser' };

export type EntityFragment_PureAdvanceCustomerSandbox_Fragment = { __typename: 'PureAdvanceCustomerSandbox' };

export type EntityFragment_PureAdvanceCustomerSelection_Fragment = { __typename: 'PureAdvanceCustomerSelection' };

export type EntityFragment_PureAdvanceModule_Fragment = { __typename: 'PureAdvanceModule' };

export type EntityFragment_ReportSettingDailyCallTarget_Fragment = { __typename: 'ReportSettingDailyCallTarget' };

export type EntityFragment_ReportSettingFieldDay_Fragment = { __typename: 'ReportSettingFieldDay' };

export type EntityFragment_ReportSettingsActivityType_Fragment = { __typename: 'ReportSettingsActivityType' };

export type EntityFragment_ResponsibleArea_Fragment = { __typename: 'ResponsibleArea' };

export type EntityFragment_Role_Fragment = { __typename: 'Role' };

export type EntityFragment_RolePermission_Fragment = { __typename: 'RolePermission' };

export type EntityFragment_SalesCycle_Fragment = { __typename: 'SalesCycle' };

export type EntityFragment_SalesCycleSegmentationTarget_Fragment = { __typename: 'SalesCycleSegmentationTarget' };

export type EntityFragment_SalesCycleSetup_Fragment = { __typename: 'SalesCycleSetup' };

export type EntityFragment_Search_Fragment = { __typename: 'Search' };

export type EntityFragment_SegmentationCode_Fragment = { __typename: 'SegmentationCode' };

export type EntityFragment_Selection_Fragment = { __typename: 'Selection' };

export type EntityFragment_SelectionGroup_Fragment = { __typename: 'SelectionGroup' };

export type EntityFragment_SelectionRow_Fragment = { __typename: 'SelectionRow' };

export type EntityFragment_SelectionRowResult_Fragment = { __typename: 'SelectionRowResult' };

export type EntityFragment_Site_Fragment = { __typename: 'Site', id: number, name: string };

export type EntityFragment_SiteFilterCode_Fragment = { __typename: 'SiteFilterCode' };

export type EntityFragment_SitePerson_Fragment = { __typename: 'SitePerson', id: number };

export type EntityFragment_SitePersonTherapeuticFocus_Fragment = { __typename: 'SitePersonTherapeuticFocus' };

export type EntityFragment_SitePersonWorkingSpecialty_Fragment = { __typename: 'SitePersonWorkingSpecialty' };

export type EntityFragment_SiteResponsible_Fragment = { __typename: 'SiteResponsible' };

export type EntityFragment_SiteSegmentationCode_Fragment = { __typename: 'SiteSegmentationCode' };

export type EntityFragment_StandardTitle_Fragment = { __typename: 'StandardTitle' };

export type EntityFragment_Team_Fragment = { __typename: 'Team' };

export type EntityFragment_UnitType_Fragment = { __typename: 'UnitType' };

export type EntityFragment_User_Fragment = { __typename: 'User' };

export type EntityFragment_UserCountry_Fragment = { __typename: 'UserCountry' };

export type EntityFragment_UserPreferEnglishLov_Fragment = { __typename: 'UserPreferEnglishLov' };

export type EntityFragment_UserTableColumn_Fragment = { __typename: 'UserTableColumn' };

export type EntityFragment_UserTeam_Fragment = { __typename: 'UserTeam' };

export type EntityFragment_ValueModel_Fragment = { __typename: 'ValueModel' };

export type EntityFragmentFragment = EntityFragment_Activity_Fragment | EntityFragment_ActivityBrand_Fragment | EntityFragment_ActivityFieldDays_Fragment | EntityFragment_ActivityLocation_Fragment | EntityFragment_ActivityPerson_Fragment | EntityFragment_ActivityProduct_Fragment | EntityFragment_ActivityTypeCustomField_Fragment | EntityFragment_Address_Fragment | EntityFragment_AddressAffiliation_Fragment | EntityFragment_Brand_Fragment | EntityFragment_ConsentContactValue_Fragment | EntityFragment_ConsentValue_Fragment | EntityFragment_ContactCategoryMapping_Fragment | EntityFragment_ContactValue_Fragment | EntityFragment_CreateEntityField_Fragment | EntityFragment_Criteria_Fragment | EntityFragment_CriteriaPath_Fragment | EntityFragment_CriteriaSimpleSaved_Fragment | EntityFragment_CriteriaSimpleSavedCriteria_Fragment | EntityFragment_CriteriaSimpleSavedPath_Fragment | EntityFragment_CriteriaType_Fragment | EntityFragment_CustomFieldControlSetting_Fragment | EntityFragment_CustomFieldGridConfiguration_Fragment | EntityFragment_CustomFieldOption_Fragment | EntityFragment_CustomFieldOptionCountry_Fragment | EntityFragment_CustomFieldRole_Fragment | EntityFragment_CustomLinkValue_Fragment | EntityFragment_CustomValue_Fragment | EntityFragment_Dashboard_Fragment | EntityFragment_DashboardEntityPieSetting_Fragment | EntityFragment_DashboardItemConfiguration_Fragment | EntityFragment_DashboardUser_Fragment | EntityFragment_Dcr_Fragment | EntityFragment_DcrComment_Fragment | EntityFragment_DcrGroup_Fragment | EntityFragment_DcrGroupResponse_Fragment | EntityFragment_DcrLine_Fragment | EntityFragment_DcrNoteTemplate_Fragment | EntityFragment_DcrSnapshotInfo_Fragment | EntityFragment_DefaultCriteria_Fragment | EntityFragment_DefaultDashboard_Fragment | EntityFragment_DefaultTableColumn_Fragment | EntityFragment_DisabledDefaultDashboard_Fragment | EntityFragment_DynamicCriteriaList_Fragment | EntityFragment_DynamicCriteriaListValue_Fragment | EntityFragment_Entity_Fragment | EntityFragment_EntityControlSetting_Fragment | EntityFragment_EntityGridItemCardField_Fragment | EntityFragment_EntityGridItemConfiguration_Fragment | EntityFragment_EntityGridItemField_Fragment | EntityFragment_EntityGridItemRelationField_Fragment | EntityFragment_EntityMerge_Fragment | EntityFragment_EntityValidationLog_Fragment | EntityFragment_ExternalId_Fragment | EntityFragment_ExternalIdSystem_Fragment | EntityFragment_ExternalIdType_Fragment | EntityFragment_ExternalIdTypeCountryExceptionRule_Fragment | EntityFragment_ExternalIdTypeRole_Fragment | EntityFragment_FilterCode_Fragment | EntityFragment_FilterCodeType_Fragment | EntityFragment_ImportFile_Fragment | EntityFragment_ImportLine_Fragment | EntityFragment_ImportProcessField_Fragment | EntityFragment_ImportProcessLine_Fragment | EntityFragment_ImportProcessLineEffect_Fragment | EntityFragment_ImportProcessorData_Fragment | EntityFragment_ImportProject_Fragment | EntityFragment_ImportTemplate_Fragment | EntityFragment_ImportTemplateProcess_Fragment | EntityFragment_ImportTemplateProcessField_Fragment | EntityFragment_List_Fragment | EntityFragment_ListCountry_Fragment | EntityFragment_ListFormat_Fragment | EntityFragment_ListFormatField_Fragment | EntityFragment_ListPin_Fragment | EntityFragment_ListType_Fragment | EntityFragment_ListUserFav_Fragment | EntityFragment_MarketAccessSite_Fragment | EntityFragment_MarketAccessSitePerson_Fragment | EntityFragment_Note_Fragment | EntityFragment_OperatorType_Fragment | EntityFragment_PersProjPreference_Fragment | EntityFragment_Person_Fragment | EntityFragment_PersonActivityProduct_Fragment | EntityFragment_PersonEducation_Fragment | EntityFragment_PersonFilterCode_Fragment | EntityFragment_PersonLanguage_Fragment | EntityFragment_PersonProductSegmentation_Fragment | EntityFragment_PersonProject_Fragment | EntityFragment_PersonSegmentationCode_Fragment | EntityFragment_PersonTherapeuticFocus_Fragment | EntityFragment_PersonUser_Fragment | EntityFragment_Preference_Fragment | EntityFragment_Product_Fragment | EntityFragment_Project_Fragment | EntityFragment_ProjectActivity_Fragment | EntityFragment_ProjectProduct_Fragment | EntityFragment_ProjectStatus_Fragment | EntityFragment_ProjectType_Fragment | EntityFragment_ProjectUser_Fragment | EntityFragment_PureAdvanceCustomerSandbox_Fragment | EntityFragment_PureAdvanceCustomerSelection_Fragment | EntityFragment_PureAdvanceModule_Fragment | EntityFragment_ReportSettingDailyCallTarget_Fragment | EntityFragment_ReportSettingFieldDay_Fragment | EntityFragment_ReportSettingsActivityType_Fragment | EntityFragment_ResponsibleArea_Fragment | EntityFragment_Role_Fragment | EntityFragment_RolePermission_Fragment | EntityFragment_SalesCycle_Fragment | EntityFragment_SalesCycleSegmentationTarget_Fragment | EntityFragment_SalesCycleSetup_Fragment | EntityFragment_Search_Fragment | EntityFragment_SegmentationCode_Fragment | EntityFragment_Selection_Fragment | EntityFragment_SelectionGroup_Fragment | EntityFragment_SelectionRow_Fragment | EntityFragment_SelectionRowResult_Fragment | EntityFragment_Site_Fragment | EntityFragment_SiteFilterCode_Fragment | EntityFragment_SitePerson_Fragment | EntityFragment_SitePersonTherapeuticFocus_Fragment | EntityFragment_SitePersonWorkingSpecialty_Fragment | EntityFragment_SiteResponsible_Fragment | EntityFragment_SiteSegmentationCode_Fragment | EntityFragment_StandardTitle_Fragment | EntityFragment_Team_Fragment | EntityFragment_UnitType_Fragment | EntityFragment_User_Fragment | EntityFragment_UserCountry_Fragment | EntityFragment_UserPreferEnglishLov_Fragment | EntityFragment_UserTableColumn_Fragment | EntityFragment_UserTeam_Fragment | EntityFragment_ValueModel_Fragment;

export type ExternalIdAdminQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type ExternalIdAdminQueryQuery = { __typename: 'Query', externalIdTypes: { __typename: 'ExternalIdTypeConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdType', code: string, heading: string, isHeadingKey: boolean, description?: string | null, externalIds: { __typename: 'ExternalIdConnection', hash: string, totalCount: number } }> } };

export type ExternalIdModalQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ExternalIdModalQueryQuery = { __typename: 'Query', roles: { __typename: 'RoleConnection', hash: string, nodes: Array<{ __typename: 'Role', id: number, heading: string }> }, externalIdType?: { __typename: 'ExternalIdType', code: string, heading: string, description?: string | null, allowDuplicateValues: boolean, isDuplicateRuleAcrossCountries: boolean, exceptionCountries?: { __typename: 'ExternalIdTypeCountryExceptionRuleConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdTypeCountryExceptionRule', id: number, country: any, countryCode: string }> } | null, roleRules: { __typename: 'ExternalIdTypeRoleConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdTypeRole', id: number, allowRead: boolean, allowMutation: boolean, role: { __typename: 'Role', id: number, heading: string, isAdminRole: boolean } }> } } | null };

export type AddExternalIdRoleMutationVariables = Exact<{
  externalIdTypeCode: Scalars['String'];
  roleId: Scalars['Int'];
}>;


export type AddExternalIdRoleMutation = { __typename: 'Mutation', addExternalIdTypeRole: { __typename: 'ExternalIdTypeRole', id: number } };

export type RemoveExternalIdRoleMutationVariables = Exact<{
  externalIdTypeRoleId: Scalars['Int'];
}>;


export type RemoveExternalIdRoleMutation = { __typename: 'Mutation', removeExternalIdTypeRole: boolean };

export type UpdateExternalIdRoleMutationVariables = Exact<{
  externalIdTypeRoleId: Scalars['Int'];
  allowRead: Scalars['Boolean'];
  allowMutation: Scalars['Boolean'];
}>;


export type UpdateExternalIdRoleMutation = { __typename: 'Mutation', setExternalIdTypeRoleRules: { __typename: 'ExternalIdTypeRole', id: number, allowRead: boolean, allowMutation: boolean } };

export type CustomerSelectionQueryQueryVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type CustomerSelectionQueryQuery = { __typename: 'Query', selectionImfCustomers: { __typename: 'SelectionImfCustomerConnection', hash: string, nodes: Array<{ __typename: 'SelectionImfCustomer', code: string, countryCode: string, isActive: boolean, selections: { __typename: 'SelectionConnection', hash: string, nodes: Array<{ __typename: 'Selection', id: number, description?: string | null, type: SlicerSelectionType, groups: { __typename: 'SelectionGroupConnection', hash: string, nodes: Array<{ __typename: 'SelectionGroup', id: number, description?: string | null, rows: { __typename: 'SelectionRowConnection', hash: string, nodes: Array<{ __typename: 'SelectionRow', id: number, persons: { __typename: 'PersonSelectionRowConnection', hash: string, totalCount: number }, sites: { __typename: 'SiteSelectionRowConnection', hash: string, totalCount: number } }> } }> } }> } }> } };

export type InstanceDeploymentDetailsQueryQueryVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type InstanceDeploymentDetailsQueryQuery = { __typename: 'Query', pureAdvanceCustomer?: { __typename: 'PureAdvanceCustomer', code: string, heading?: string | null } | null };

export type InstanceDeploymentTableFragmentFragment = { __typename: 'PureAdvanceCustomer', code: string };

export type InstanceDeploymentQueryQueryVariables = Exact<{
  criteria?: InputMaybe<PureAdvanceCustomerCriteria>;
}>;


export type InstanceDeploymentQueryQuery = { __typename: 'Query', connection: { __typename: 'PureAdvanceCustomerConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'PureAdvanceCustomer' }
      & InstanceDeploymentTableFragmentFragment
    )> } };

export type InstanceDeploymentRecordQueryQueryVariables = Exact<{
  recordId: Scalars['String'];
}>;


export type InstanceDeploymentRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'PureAdvanceCustomer', code: string }
    & InstanceDeploymentTableFragmentFragment
  ) | null };

export type PureAdvanceCustomerProfileQueryVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type PureAdvanceCustomerProfileQuery = { __typename: 'Query', pureAdvanceModules: { __typename: 'PureAdvanceModuleConnection', hash: string, nodes: Array<{ __typename: 'PureAdvanceModule', id: number, name: string, enum: ModuleEnumType, description?: string | null }> }, pureAdvanceCustomer?: { __typename: 'PureAdvanceCustomer', code: string, modules: { __typename: 'PureAdvanceCustomerModuleConnection', hash: string, nodes: Array<{ __typename: 'PureAdvanceCustomerModule', id: { __typename: 'PureAdvanceCustomerModuleId', customerCode: string, moduleId: number }, module: { __typename: 'PureAdvanceModule', id: number, name: string, enum: ModuleEnumType, description?: string | null } }> } } | null };

export type UpdateCustomerModuleMutationVariables = Exact<{
  customerCode: Scalars['String'];
  module: ModuleEnumType;
  enabled: Scalars['Boolean'];
}>;


export type UpdateCustomerModuleMutation = { __typename: 'Mutation', updatePureAdvanceCustomerModule: { __typename: 'PureAdvanceCustomer', code: string, modules: { __typename: 'PureAdvanceCustomerModuleConnection', hash: string, nodes: Array<{ __typename: 'PureAdvanceCustomerModule', id: { __typename: 'PureAdvanceCustomerModuleId', customerCode: string, moduleId: number }, module: { __typename: 'PureAdvanceModule', id: number, name: string, description?: string | null } }> } } };

export type InstanceDeploymentSchedulesQueryQueryVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type InstanceDeploymentSchedulesQueryQuery = { __typename: 'Query', pureAdvanceCustomer?: { __typename: 'PureAdvanceCustomer', code: string, heading?: string | null, dataSyncSchedule?: (
      { __typename: 'GitlabSchedule' }
      & ScheduleFragmentFragment
    ) | null, dcrSyncSchedule?: (
      { __typename: 'GitlabSchedule' }
      & ScheduleFragmentFragment
    ) | null } | null };

export type ScheduleFragmentFragment = { __typename: 'GitlabSchedule', id: any, active: boolean, cron: string, cron_timezone: string, description?: string | null, next_run_at: string, last_pipeline?: { __typename: 'GitlabPipeline', id: any, duration?: number | null, finished_at?: string | null, started_at?: string | null, status?: string | null, web_url?: string | null } | null };

export type ScheduleDcrSyncMutationMutationVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type ScheduleDcrSyncMutationMutation = { __typename: 'Mutation', runDcrSynchronization: boolean };

export type ScheduleDataLoaderMutationMutationVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type ScheduleDataLoaderMutationMutation = { __typename: 'Mutation', runDataLoader: boolean };

export type UpdateInstanceDeploymentBoxSettingMutationVariables = Exact<{
  customerCode: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdateInstanceDeploymentBoxSettingMutation = { __typename: 'Mutation', setPureAdvanceCustomerInstanceSetting: { __typename: 'PureAdvanceCustomer', code: string, downloadFilesViaBoxSetting?: string | null } };

export type InstanceDeploymentProfileQueryVariables = Exact<{
  customerCode: Scalars['String'];
}>;


export type InstanceDeploymentProfileQuery = { __typename: 'Query', pureAdvanceCustomer?: { __typename: 'PureAdvanceCustomer', code: string, heading?: string | null, downloadFilesViaBoxSetting?: string | null } | null };

export type JiraVersionReleaseNotesQueryQueryVariables = Exact<{
  version: Scalars['String'];
}>;


export type JiraVersionReleaseNotesQueryQuery = { __typename: 'Query', jiraIssues?: { __typename: 'JiraIssueConnection', total: number, issues: Array<{ __typename: 'JiraIssue', key: string, self: string, fields: { __typename: 'JiraIssueFields', summary?: string | null, issuetype?: { __typename: 'JiraIssueType', id: string, name: string, iconUrl: string } | null } }> } | null };

export type PureAdvanceReleasesQueryQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type PureAdvanceReleasesQueryQuery = { __typename: 'Query', releases: { __typename: 'JiraReleaseConnection', self: string, total: number, values: Array<{ __typename: 'JiraRelease', id: number, description?: string | null, releaseDate?: string | null, version: string }> } };

export type CreateCustomSelectFieldMutationMutationVariables = Exact<{
  input: CreateCustomFieldInput;
}>;


export type CreateCustomSelectFieldMutationMutation = { __typename: 'Mutation', createCustomField: { __typename: 'CustomField', code: string, heading: string } };

export type UpdateCustomSelectFieldMutationMutationVariables = Exact<{
  input: UpdateCustomFieldInput;
}>;


export type UpdateCustomSelectFieldMutationMutation = { __typename: 'Mutation', updateCustomField: { __typename: 'CustomField', code: string, heading: string } };

export type UpdateCustomFieldQueryQueryVariables = Exact<{
  customFieldCode: Scalars['String'];
}>;


export type UpdateCustomFieldQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', code: string, heading: string, color?: string | null, isActive: boolean, allowMultiple?: boolean | null, allowUserCreate?: boolean | null, isCheckableTag?: boolean | null, allowCountrySpecificValues?: boolean | null, entityTypeEnum: EntityTypeEnum, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum }, fieldGridConfigurations: { __typename: 'CustomFieldGridConfigurationConnection', hash: string, totalCount: number }, options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, selectedCountries: { __typename: 'CustomFieldOptionCountryConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOptionCountry', id: number, country: any }> }, relations: { __typename: 'CustomLinkValueConnection', hash: string, totalCount: number }, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null } | null };

export type CustomFieldPermissionQueryQueryVariables = Exact<{
  customFieldCode: Scalars['String'];
}>;


export type CustomFieldPermissionQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', code: string, accessRules: { __typename: 'CustomFieldRoleConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldRole', id: number, allowRead: boolean, allowMutation: boolean, roleId: number }> } } | null };

export type CustomFieldPermissionRolesQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type CustomFieldPermissionRolesQueryQuery = { __typename: 'Query', roles: { __typename: 'RoleConnection', hash: string, nodes: Array<{ __typename: 'Role', id: number, heading: string }> } };

export type CreateCustomFieldRoleMutationMutationVariables = Exact<{
  customFieldCode: Scalars['String'];
  roleId: Scalars['Int'];
}>;


export type CreateCustomFieldRoleMutationMutation = { __typename: 'Mutation', addRoleToCustomField: { __typename: 'CustomFieldRole', id: number } };

export type UpdateCustomFieldRoleMutationMutationVariables = Exact<{
  fieldRoleId: Scalars['Int'];
  read?: InputMaybe<Scalars['Boolean']>;
  mutation?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCustomFieldRoleMutationMutation = { __typename: 'Mutation', updateCustomFieldRoleRules: { __typename: 'CustomFieldRole', id: number, allowMutation: boolean, allowRead: boolean } };

export type RemoveCustomFieldRoleMutationMutationVariables = Exact<{
  fieldRoleId: Scalars['Int'];
}>;


export type RemoveCustomFieldRoleMutationMutation = { __typename: 'Mutation', removeRoleFromCustomField: boolean };

export type CustomFieldUsageOverviewQueryQueryVariables = Exact<{
  customFieldCode: Scalars['String'];
}>;


export type CustomFieldUsageOverviewQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', code: string, fieldGridConfigurations: { __typename: 'CustomFieldGridConfigurationConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldGridConfiguration', id: number, fieldConfig: { __typename: 'EntityGridItemField', id: number, itemConfiguration: { __typename: 'EntityGridItemConfiguration', id: number, heading?: string | null, tab: { __typename: 'EntityTab', code: string, headingKey: string } } } }> } } | null };

export type ActivityTypesForConfigurationQueryVariables = Exact<{
  includeActive: ActiveEnum;
}>;


export type ActivityTypesForConfigurationQuery = { __typename: 'Query', activitySuperTypes: { __typename: 'ActivitySuperTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivitySuperType', code: string, heading: string, types: { __typename: 'ActivityTypeConnection', hash: string, totalCount: number, nodes: Array<(
          { __typename: 'ActivityType' }
          & ActivityTypeMutationFragmentFragment
        )> } }> } };

export type UpdateActivityTypeMutationMutationVariables = Exact<{
  typeCode: Scalars['String'];
  input: UpdateActivityTypeInput;
}>;


export type UpdateActivityTypeMutationMutation = { __typename: 'Mutation', updateActivityType: (
    { __typename: 'ActivityType' }
    & ActivityTypeMutationFragmentFragment
  ) };

export type ActivityTypeMutationFragmentFragment = { __typename: 'ActivityType', code: string, heading: string, isActive: boolean, description: string, sort?: number | null, standardTimeLengthMinutes: number, superTypeCode: string, brandRule: AttachmentRuleEnum, locationRule: AttachmentRuleEnum, participationUserRule: AttachmentRuleEnum, personRule: AttachmentRuleEnum, productRule: AttachmentRuleEnum, projectRule: AttachmentRuleEnum, responsibleUserRule: AttachmentRuleEnum, color: { __typename: 'Color', code: string, headingKey: string, value: string }, customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string }> } };

export type ConfigureCustomFieldsActivityTypeQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type ConfigureCustomFieldsActivityTypeQuery = { __typename: 'Query', customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string }> } };

export type SetCustomFieldsToActivityTypeMutationVariables = Exact<{
  activityTypeCode: Scalars['String'];
  customFieldCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetCustomFieldsToActivityTypeMutation = { __typename: 'Mutation', setCustomFieldsToActivityType: (
    { __typename: 'ActivityType', code: string }
    & ActivityTypeMutationFragmentFragment
  ) };

export type ConfigureFieldDaysQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
  year: Scalars['Year'];
}>;


export type ConfigureFieldDaysQueryQuery = { __typename: 'Query', activityFieldDaysInYear: Array<{ __typename: 'ActivityFieldDays', id: number, country: any, month: number, year: number, count: number }> };

export type UpdateFieldDaysMutationMutationVariables = Exact<{
  country: Scalars['CountryCode'];
  year: Scalars['Year'];
  month: Scalars['Month'];
  count: Scalars['Int'];
}>;


export type UpdateFieldDaysMutationMutation = { __typename: 'Mutation', updateActivityFieldDaysInMonth: { __typename: 'ActivityFieldDays', id: number, count: number } };

export type MassAssignSettingsQueryQueryVariables = Exact<{
  type: InstanceSettingEnum;
}>;


export type MassAssignSettingsQueryQuery = { __typename: 'Query', instanceSetting?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null };

export type UpdateMassAssignSettingMutationVariables = Exact<{
  type: InstanceSettingEnum;
  newValue: Scalars['String'];
}>;


export type UpdateMassAssignSettingMutation = { __typename: 'Mutation', updateInstanceSetting: { __typename: 'InstanceSetting', code: string, value?: string | null } };

export type SegmentationSettingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentationSettingsQueryQuery = { __typename: 'Query', person?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null, product?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null, allowMultipleProducts?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null };

export type UpdateSegmentationSettingMutationVariables = Exact<{
  type: InstanceSettingEnum;
  newValue: Scalars['String'];
}>;


export type UpdateSegmentationSettingMutation = { __typename: 'Mutation', updateInstanceSetting: { __typename: 'InstanceSetting', code: string, value?: string | null } };

export type CreateTerritoryMutationMutationVariables = Exact<{
  code: Scalars['String'];
  country: Scalars['CountryCode'];
  heading: Scalars['String'];
}>;


export type CreateTerritoryMutationMutation = { __typename: 'Mutation', createTerritory: { __typename: 'Territory', code: string, heading: string, countryCode: string } };

export type SiteBrickTerritoryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteBrickTerritoryQueryQuery = { __typename: 'Query', bricks: { __typename: 'BrickConnection', hash: string, totalCount: number }, territories: { __typename: 'TerritoryConnection', hash: string, nodes: Array<{ __typename: 'Territory', code: string, heading: string, description?: string | null, countryCode: string, bricks: { __typename: 'BrickConnection', hash: string, totalCount: number, siteTotalCount: number, nodes: Array<{ __typename: 'Brick', code: string, heading: string }> }, responsibleUser?: { __typename: 'User', id: number, fullname: string } | null }> } };

export type BricksForTerritorySelectorQueryVariables = Exact<{
  territoryCode: Scalars['String'];
}>;


export type BricksForTerritorySelectorQuery = { __typename: 'Query', bricks: { __typename: 'BrickConnection', hash: string, nodes: Array<{ __typename: 'Brick', code: string, heading: string }> } };

export type SetTerritoryBricksMutationVariables = Exact<{
  territoryCode: Scalars['String'];
  brickCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type SetTerritoryBricksMutation = { __typename: 'Mutation', setBricksForTerritory: { __typename: 'Territory', code: string } };

export type TerritorySitesUserResponsibleQueryVariables = Exact<{
  territoryCode: Scalars['String'];
}>;


export type TerritorySitesUserResponsibleQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, sitesResponsibleFor: { __typename: 'SiteConnection', hash: string, totalCount: number } }> } };

export type UpdateTerritoryHeadingMutationMutationVariables = Exact<{
  territoryCode: Scalars['String'];
  newHeading: Scalars['String'];
}>;


export type UpdateTerritoryHeadingMutationMutation = { __typename: 'Mutation', updateTerritoryHeading: { __typename: 'Territory', code: string, heading: string } };

export type InactivateTerritoryMutationVariables = Exact<{
  territoryCode: Scalars['String'];
}>;


export type InactivateTerritoryMutation = { __typename: 'Mutation', inactivateTerritory: { __typename: 'Territory', code: string, isActive: boolean } };

export type UpdateTerritoryResponsibleMutationVariables = Exact<{
  territoryCode: Scalars['String'];
  responsibleUserId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateTerritoryResponsibleMutation = { __typename: 'Mutation', updateTerritoryResponsibleUser: { __typename: 'Territory', code: string, responsibleUserId?: number | null, responsibleUser?: { __typename: 'User', id: number } | null } };

export type UpdateGroupMenuItemMutationVariables = Exact<{
  menuItemCode: Scalars['String'];
  menuGroup: MenuGroupEnum;
}>;


export type UpdateGroupMenuItemMutation = { __typename: 'Mutation', updateMenuItemGroup: { __typename: 'MenuItem', code: string, menuGroup: { __typename: 'MenuGroup', code: string, enum: MenuGroupEnum } } };

export type UpdateMenuSortingMutationMutationVariables = Exact<{
  menuGroup: MenuGroupEnum;
  menuItemCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateMenuSortingMutationMutation = { __typename: 'Mutation', updateMenuItemsSorting: Array<{ __typename: 'MenuItem', code: string, sort: number }> };

export type AdminMenuDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMenuDataQueryQuery = { __typename: 'Query', menuItems: { __typename: 'MenuItemConnection', hash: string, nodes: Array<(
      { __typename: 'MenuItem' }
      & AdminMenuItemFragmentFragment
    )> }, functionMenuItems: { __typename: 'MenuItemConnection', hash: string, nodes: Array<(
      { __typename: 'MenuItem' }
      & AdminMenuItemFragmentFragment
    )> } };

export type AdminMenuItemFragmentFragment = { __typename: 'MenuItem', code: string, headingKey: string, tooltipKey?: string | null, iconKey?: string | null, url: string, isActive: boolean, menuGroup: { __typename: 'MenuGroup', code: string, enum: MenuGroupEnum } };

export type UpdateStatusMenuItemMutationVariables = Exact<{
  menuItemCode: Scalars['String'];
  isActive: Scalars['Boolean'];
}>;


export type UpdateStatusMenuItemMutation = { __typename: 'Mutation', updateMenuItemStatus: { __typename: 'MenuItem', code: string, isActive: boolean } };

export type AddActivityTypeToReportMutationVariables = Exact<{
  reportCode: Scalars['String'];
  country: Scalars['CountryCode'];
  activityTypeCode: Scalars['String'];
}>;


export type AddActivityTypeToReportMutation = { __typename: 'Mutation', addActivityTypeToReport: { __typename: 'ReportSettingsActivityType', id: number, includeInReport: boolean } };

export type RemoveActivityTypeToReportMutationVariables = Exact<{
  reportCode: Scalars['String'];
  country: Scalars['CountryCode'];
  activityTypeCode: Scalars['String'];
}>;


export type RemoveActivityTypeToReportMutation = { __typename: 'Mutation', removeActivityTypeFromReport: { __typename: 'ReportSettingsActivityType', id: number, includeInReport: boolean } };

export type ActivityTypesForInReportsQueryQueryVariables = Exact<{
  reportCode: Scalars['String'];
  country: Scalars['CountryCode'];
}>;


export type ActivityTypesForInReportsQueryQuery = { __typename: 'Query', activitySuperTypes: { __typename: 'ActivitySuperTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivitySuperType', code: string, heading: string, types: { __typename: 'ActivityTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivityType', code: string, heading: string, colorCode: string }> } }> }, reportSettingsActivityTypes: { __typename: 'ReportSettingsActivityTypeConnection', hash: string, nodes: Array<{ __typename: 'ReportSettingsActivityType', id: number, activityType: { __typename: 'ActivityType', code: string, heading: string, colorCode: string, color: { __typename: 'Color', code: string, value: string } } }> } };

export type updateSaleCycleMutationMutationVariables = Exact<{
  year: Scalars['Int'];
  cycleStartMonth: Scalars['Month'];
  countryCode: Scalars['CountryCode'];
  cycleAmount: Scalars['Int'];
  id: Scalars['Int'];
  segmentations: Array<SegmentationSaleCycleInput> | SegmentationSaleCycleInput;
}>;


export type updateSaleCycleMutationMutation = { __typename: 'Mutation', updateSaleCycle: { __typename: 'SalesCycleSetup', id: number, country: any, createdByUserId: number, cycleStartMonth: number, modifiedByUserId: number, numberOfCyclesInYear: number, startMonth: any, year: number } };

export type KPIQueryQueryVariables = Exact<{
  selectedCountry: Scalars['CountryCode'];
}>;


export type KPIQueryQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, heading: string }> }, salesCycleSetups: { __typename: 'SalesCycleSetupConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SalesCycleSetup', id: number, countryCode: string, year: number, numberOfCyclesInYear: number, cycleStartMonth: number, targets: { __typename: 'SalesCycleSegmentationTargetConnection', hash: string, nodes: Array<{ __typename: 'SalesCycleSegmentationTarget', id: number, goal: number, segmentationCodeId: number, segmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string, code: string } | null }> } }> } };

export type CreateNewSalesCycleMutationMutationVariables = Exact<{
  year: Scalars['Int'];
  countryCode: Scalars['CountryCode'];
  cycleAmount: Scalars['Int'];
  cycleStartMonth: Scalars['Month'];
  segmentations: Array<SegmentationSaleCycleInput> | SegmentationSaleCycleInput;
}>;


export type CreateNewSalesCycleMutationMutation = { __typename: 'Mutation', createNewSalesCycle: { __typename: 'SalesCycleSetup', id: number } };

export type ReportCallFreqDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportCallFreqDataQueryQuery = { __typename: 'Query', reportSettingIsHalfDay: boolean, reportSettingDailyCallTarget: Array<{ __typename: 'ReportSettingDailyCallTarget', id: number, country: any, amount: number }>, reportSettingFieldDays: { __typename: 'ReportSettingFieldDayConnection', hash: string, nodes: Array<{ __typename: 'ReportSettingFieldDay', id: number, activityTypeCode: string, amountForOne: number, activityType: { __typename: 'ActivityType', code: string, heading: string, colorCode: string } }> }, activitySuperTypes: { __typename: 'ActivitySuperTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivitySuperType', code: string, heading: string, types: { __typename: 'ActivityTypeConnection', hash: string, nodes: Array<{ __typename: 'ActivityType', code: string, heading: string }> } }> } };

export type SetHalfDayMutationMutationVariables = Exact<{
  isHalfDay: Scalars['Boolean'];
}>;


export type SetHalfDayMutationMutation = { __typename: 'Mutation', setReportSettingIsHalfDay: boolean };

export type SetDailyTargetMutationMutationVariables = Exact<{
  country: Scalars['CountryCode'];
  amount: Scalars['Int'];
}>;


export type SetDailyTargetMutationMutation = { __typename: 'Mutation', setReportSettingDailyCallTarget: { __typename: 'ReportSettingDailyCallTarget', id: number, country: any, amount: number } };

export type AddFieldDayMutationMutationVariables = Exact<{
  activityTypeCode: Scalars['String'];
  amountForOne: Scalars['Int'];
}>;


export type AddFieldDayMutationMutation = { __typename: 'Mutation', addReportSettingFieldDay: { __typename: 'ReportSettingFieldDay', id: number, activityTypeCode: string, amountForOne: number } };

export type RemoveFieldDayMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveFieldDayMutationMutation = { __typename: 'Mutation', removeReportSettingFieldDay: boolean };

export type CreateNewSandboxMutationMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateNewSandboxMutationMutation = { __typename: 'Mutation', deployNewSandbox: { __typename: 'PureAdvanceCustomerSandbox', id: number, heading: string } };

export type SandboxInformationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SandboxInformationQueryQuery = { __typename: 'Query', instance: { __typename: 'PureAdvanceCustomer', code: string, maxSandboxes: number, sandboxes: { __typename: 'PureAdvanceCustomerSandboxConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'PureAdvanceCustomerSandbox', id: number, heading: string, isActive: boolean, serverCode: string, ct: any, ut: any, deploymentStatus: { __typename: 'CurrentSandboxDeploymentStatus', code: string, currentPercentage: number, totalSteps: number, app: { __typename: 'DeploymentStatus', currentStatus: AntProgressStatusEnum, message?: string | null }, clone: { __typename: 'DeploymentStatus', currentStatus: AntProgressStatusEnum, message?: string | null }, db: { __typename: 'DeploymentStatus', currentStatus: AntProgressStatusEnum, message?: string | null }, activityJob: { __typename: 'DeploymentStatus', currentStatus: AntProgressStatusEnum, message?: string | null }, schedule: { __typename: 'SandboxScheduleStatus', code: string, cron: string, isActive: boolean, lastRun?: any | null, status: AntProgressStatusEnum } } }> } } };

export type DestroySandboxMutationMutationVariables = Exact<{
  sandboxId: Scalars['Int'];
}>;


export type DestroySandboxMutationMutation = { __typename: 'Mutation', destroySandbox: { __typename: 'PureAdvanceCustomerSandbox', id: number, isActive: boolean } };

export type ResetSandboxDbMutationMutationVariables = Exact<{
  sandboxId: Scalars['Int'];
}>;


export type ResetSandboxDbMutationMutation = { __typename: 'Mutation', resetSandboxDb: { __typename: 'PureAdvanceCustomerSandbox', id: number, isActive: boolean } };

export type UpdateInstanceSettingMutationMutationVariables = Exact<{
  type: InstanceSettingEnum;
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdateInstanceSettingMutationMutation = { __typename: 'Mutation', updateInstanceSetting: { __typename: 'InstanceSetting', code: string, value?: string | null } };

export type GeneralSystemSettingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralSystemSettingsQueryQuery = { __typename: 'Query', name?: (
    { __typename: 'InstanceSetting' }
    & InstanceSettingFragmentFragment
  ) | null, img?: (
    { __typename: 'InstanceSetting' }
    & InstanceSettingFragmentFragment
  ) | null, domain?: (
    { __typename: 'InstanceSetting' }
    & InstanceSettingFragmentFragment
  ) | null };

export type InstanceSettingFragmentFragment = { __typename: 'InstanceSetting', code: string, value?: string | null, enum: InstanceSettingEnum };

export type createUserMutationMutationVariables = Exact<{
  input: CreateUserInputdata;
}>;


export type createUserMutationMutation = { __typename: 'Mutation', createUser: { __typename: 'User', id: number } };

export type GetAllCountiresQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountiresQueryQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string, labelGb?: string | null }> } };

export type UserAdminTableFragmentFragment = { __typename: 'User', id: number };

export type UserAdminConnectionQueryQueryVariables = Exact<{
  criteria?: InputMaybe<UserCriteria>;
}>;


export type UserAdminConnectionQueryQuery = { __typename: 'Query', connection: { __typename: 'UserConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'User', id: number }
      & UserAdminTableFragmentFragment
    )> } };

export type UserAdminRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type UserAdminRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'User', id: number }
    & UserAdminTableFragmentFragment
  ) | null };

export type RoleAdminTableFragmentFragment = { __typename: 'Role', id: number };

export type RoleAdminTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<RoleCriteria>;
}>;


export type RoleAdminTableQueryQuery = { __typename: 'Query', connection: { __typename: 'RoleConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'Role', id: number }
      & RoleAdminTableFragmentFragment
    )> } };

export type RoleAdminRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type RoleAdminRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'Role', id: number }
    & RoleAdminTableFragmentFragment
  ) | null };

export type RoleOverviewQueryQueryVariables = Exact<{
  roleId: Scalars['Int'];
}>;


export type RoleOverviewQueryQuery = { __typename: 'Query', role?: { __typename: 'Role', id: number, heading: string, isAdminRole: boolean, description?: string | null, users: { __typename: 'UserConnection', hash: string, totalCount: number }, permissions: Array<{ __typename: 'VirtualRolePermission', permissionEnum: PermissionEnum, roleId: number, module?: ModuleEnumType | null, heading: string, description?: string | null, create?: boolean | null, read?: boolean | null, update?: boolean | null, delete?: boolean | null }> } | null };

export type UpdatePermissionMutationMutationVariables = Exact<{
  roleId: Scalars['Int'];
  permission: PermissionEnum;
  level: PermissionLevel;
  allow: Scalars['Boolean'];
}>;


export type UpdatePermissionMutationMutation = { __typename: 'Mutation', updateRolePermission: { __typename: 'VirtualRolePermission', permissionEnum: PermissionEnum, roleId: number, module?: ModuleEnumType | null, heading: string, description?: string | null, create?: boolean | null, read?: boolean | null, update?: boolean | null, delete?: boolean | null } };

export type UpdateUserMutationMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutationMutation = { __typename: 'Mutation', updateUser: { __typename: 'User', id: number, fullname: string, firstname?: string | null, lastname?: string | null, email: string, roleId: number, role: { __typename: 'Role', id: number }, countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string }> } } };

export type AdminUserQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type AdminUserQueryQuery = { __typename: 'Query', user?: { __typename: 'User', id: number, fullname: string, firstname?: string | null, lastname?: string | null, email: string } | null };

export type UserAdminGeneralQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserAdminGeneralQueryQuery = { __typename: 'Query', user?: { __typename: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string, countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string }> } } | null };

export type UserAdminRoleQueryQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserAdminRoleQueryQuery = { __typename: 'Query', user?: { __typename: 'User', id: number, role: { __typename: 'Role', id: number, heading: string }, teams: { __typename: 'TeamConnection', hash: string, nodes: Array<{ __typename: 'Team', id: number, heading: string }> } } | null, roles: { __typename: 'RoleConnection', hash: string, nodes: Array<{ __typename: 'Role', id: number, heading: string }> } };

export type GenerateImpersonateTokenMutationMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GenerateImpersonateTokenMutationMutation = { __typename: 'Mutation', impersonateUser: { __typename: 'JwtToken', token: string, expireDate: string } };

export type BrickDetailQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type BrickDetailQueryQuery = { __typename: 'Query', brick?: { __typename: 'Brick', code: string, territoryCode?: string | null, ct: any, ut: any, heading: string } | null };

export type BrickTableFragmentFragment = { __typename: 'Brick', code: string, ct: any, ut: any, heading: string };

export type BrickTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<BrickCriteria>;
}>;


export type BrickTableQueryQuery = { __typename: 'Query', connection: { __typename: 'BrickConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'Brick' }
      & BrickTableFragmentFragment
    )> } };

export type AllDashboardItemsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllDashboardItemsQueryQuery = { __typename: 'Query', dashboardItems: { __typename: 'DashboardItemConnection', hash: string, nodes: Array<{ __typename: 'DashboardItem', code: string, headingKey: string, descriptionKey?: string | null }> } };

export type AddDashboardItemMutationMutationVariables = Exact<{
  dashboardId: Scalars['Int'];
  dashboardItemCode: Scalars['String'];
}>;


export type AddDashboardItemMutationMutation = { __typename: 'Mutation', addDashboardItem: { __typename: 'DashboardItemConfiguration', id: number } };

export type DashboardItemsQueryQueryVariables = Exact<{
  dashboardId: Scalars['Int'];
}>;


export type DashboardItemsQueryQuery = { __typename: 'Query', dashboard?: { __typename: 'Dashboard', id: number, isDefaultDashboard: boolean, dashboardItemConfigurations: { __typename: 'DashboardItemConfigurationConnection', hash: string, nodes: Array<(
        { __typename: 'DashboardItemConfiguration', id: number, x?: number | null, y?: number | null, height?: number | null, width?: number | null }
        & DashboardItemFragmentFragment
      )> } } | null };

export type UpdateGridPositionsMutationMutationVariables = Exact<{
  input: DashboardItemConfigurationInput;
}>;


export type UpdateGridPositionsMutationMutation = { __typename: 'Mutation', updateDashboardItems: { __typename: 'Dashboard', id: number } };

export type CreateNewDashboardMutationMutationVariables = Exact<{
  title: Scalars['String'];
}>;


export type CreateNewDashboardMutationMutation = { __typename: 'Mutation', createNewDashboard: { __typename: 'Dashboard', id: number } };

export type DisableDashboardMutationMutationVariables = Exact<{
  dashboardId: Scalars['Int'];
}>;


export type DisableDashboardMutationMutation = { __typename: 'Mutation', RemoveDashboard: { __typename: 'Dashboard', id: number } };

export type DashboardViewQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardViewQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, dashboards: { __typename: 'DashboardConnection', hash: string, nodes: Array<{ __typename: 'Dashboard', id: number, headingKey: string, isDefaultDashboard: boolean, dashboardItemConfigurations: { __typename: 'DashboardItemConfigurationConnection', hash: string, totalCount: number } }> } } | null };

export type ManageGroupDcrMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  maintainRecord: Scalars['Boolean'];
  isMdmEnabled: Scalars['Boolean'];
}>;


export type ManageGroupDcrMutationMutation = { __typename: 'Mutation', manageGroupDcrMutation: { __typename: 'DcrGroup', id: number } };

export type DcrGroupDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DcrGroupDetailQuery = { __typename: 'Query', hasAccessToModule: boolean, dcrGroup?: { __typename: 'DcrGroup', id: number, ct: any, areYouDcrOwner: boolean, responsibleUserId: number, isDcrGroupKeptAsLocalRecord: boolean, GroupComment?: { __typename: 'DcrComment', id: number, byUserId?: number | null, comment?: string | null, ct: any, ut: any } | null, responses: { __typename: 'DcrGroupResponseConnection', hash: string, nodes: Array<{ __typename: 'DcrGroupResponse', id: number, ct: any, responseTypeEnum: DcrResponseTypeEnum, comment?: string | null, dcrNoteTemplate?: { __typename: 'DcrNoteTemplate', id: number, key: string, status: boolean, sort?: number | null, addedBy?: number | null, ct: any, ut: any } | null, user?: { __typename: 'User', id: number, fullname: string } | null }> }, responsibleUser: { __typename: 'User', id: number, fullname: string }, responseStatus: { __typename: 'DcrGroupResponse', id: number, responseTypeCode: string, responseTypeEnum: DcrResponseTypeEnum, responseComment?: string | null }, dcrs: { __typename: 'DcrConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Dcr', id: number, requestTypeEnum: DcrRequestTypeEnum, entityTypeEnum?: EntityTypeEnum | null, ct: any, entityAffiliationId?: number | null, ut: any, dcrSnapshotInfo: Array<{ __typename: 'DcrSnapshotInfo', id: number, dcrId: number, entityAffiliationId: number, entityTypeEnum: EntityTypeEnum, affiliationEntity?: { __typename: 'Activity', heading: string, id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', title: string, isShared: boolean, id: number, createdUser?: { __typename: 'User', id: number, fullname: string } | null, listType: { __typename: 'ListType', id: number, heading: string, code: string } } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null }>, requestType: { __typename: 'DcrRequestType', code: string, heading: string }, lines: { __typename: 'DcrLineConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'DcrLine', id: number, newValue?: string | null, dcrNewValue?: string | null, dcrOldValue?: string | null, newValueMapped?: string | null, oldValueMapped?: string | null, oldValue?: string | null, fieldCode: string, fieldLabel?: string | null, fieldLabelKey?: string | null }> }, affiliationEntity?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', fullName: string, id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', name: string, id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', siteId: number, persId: number, id: number, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null }> } } | null };

export type DcrGroupTableFragmentFragment = { __typename: 'DcrGroup', id: number };

export type DCRGroupTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<DcrGroupCriteria>;
}>;


export type DCRGroupTableQueryQuery = { __typename: 'Query', connection: { __typename: 'DcrGroupConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'DcrGroup' }
      & DcrGroupTableFragmentFragment
    )> } };

export type DCRGroupRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type DCRGroupRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'DcrGroup', id: number }
    & DcrGroupTableFragmentFragment
  ) | null };

export type ClearLinkMutationMutationVariables = Exact<{
  hcoId: Scalars['Int'];
}>;


export type ClearLinkMutationMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean } };

export type ClearHcpMutationMutationVariables = Exact<{
  hcpId: Scalars['Int'];
  isChecked: Scalars['Boolean'];
}>;


export type ClearHcpMutationMutation = { __typename: 'Mutation', inactivateHcpAndActivityAffiliations: { __typename: 'Person', id: number, isActive: boolean } };

export type ClearHopMutationMutationVariables = Exact<{
  hcoId: Scalars['Int'];
}>;


export type ClearHopMutationMutation = { __typename: 'Mutation', setSiteActiveStatus: { __typename: 'Site', id: number, isActive: boolean } };

export type DcrGroupHeadingFragmentFragment = { __typename: 'DcrGroup', heading?: { __typename: 'DcrGroupHeadingCreatePerson', code: string, headingKey: string, rPerson: { __typename: 'Person', id: number, fullName: string } } | { __typename: 'DcrGroupHeadingCreateSite', code: string, headingKey: string, rSite: { __typename: 'Site', id: number, name: string } } | { __typename: 'DcrGroupHeadingDeletePerson', code: string, headingKey: string, rPerson: { __typename: 'Person', id: number, fullName: string } } | { __typename: 'DcrGroupHeadingDeleteSite', code: string, headingKey: string, rSite: { __typename: 'Site', id: number, name: string } } | { __typename: 'DcrGroupHeadingDeleteWorkplace', code: string, headingKey: string, oPerson?: { __typename: 'Person', id: number, fullName: string } | null, oSite?: { __typename: 'Site', id: number, name: string } | null } | { __typename: 'DcrGroupHeadingNewPersonWithWorkplace', code: string, headingKey: string, rPerson: { __typename: 'Person', id: number, fullName: string }, oSite?: { __typename: 'Site', id: number, name: string } | null } | { __typename: 'DcrGroupHeadingNewWorkplace', code: string, headingKey: string, rPerson: { __typename: 'Person', id: number, fullName: string }, oSite?: { __typename: 'Site', id: number, name: string } | null } | { __typename: 'DcrGroupHeadingUnknownDcrType', code: string, headingKey: string } | { __typename: 'DcrGroupHeadingUpdatePerson', code: string, headingKey: string, rPerson: { __typename: 'Person', id: number, fullName: string } } | { __typename: 'DcrGroupHeadingUpdateSite', code: string, headingKey: string, rSite: { __typename: 'Site', id: number, name: string } } | { __typename: 'DcrGroupHeadingUpdateWorkplace', code: string, headingKey: string, oPerson?: { __typename: 'Person', id: number, fullName: string } | null, oSite?: { __typename: 'Site', id: number, name: string } | null } | null };

export type DcrGroupHeadingQueryQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type DcrGroupHeadingQueryQuery = { __typename: 'Query', dcrGroup?: (
    { __typename: 'DcrGroup', id: number }
    & DcrGroupHeadingFragmentFragment
  ) | null };

export type FinishedImportProjectDetailsQueryQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type FinishedImportProjectDetailsQueryQuery = { __typename: 'Query', importProject?: { __typename: 'ImportProject', id: number, effects: { __typename: 'ImportProcessLineEffectConnection', hash: string, nodes: Array<{ __typename: 'ImportProcessLineEffect', id: number, actionType: ProcessLineEffectActionEnum, entityType?: EntityTypeEnum | null, note?: string | null, affiliationEntity?: { __typename: 'Activity', id: number, title: string } | { __typename: 'ActivityBrand', id: number, activity: { __typename: 'Activity', id: number, title: string }, productBrand: { __typename: 'Brand', id: number, name: string } } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number, activity: { __typename: 'Activity', id: number, title: string }, product: { __typename: 'Product', id: number, heading: string } } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number, name: string } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number, value?: string | null } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', id: number, fullname: string } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number, title: string } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number, name: string } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number, fullname: string } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null }> } } | null };

export type ImportProjectDetailsQueryQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ImportProjectDetailsQueryQuery = { __typename: 'Query', project?: { __typename: 'ImportProject', id: number, heading: string, currentPhase?: { __typename: 'ImportTemplateProcess', id: number, heading: string } | null } | null };

export type BasicImportProjectStatusQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type BasicImportProjectStatusQuery = { __typename: 'Query', importProject?: { __typename: 'ImportProject', id: number, statusCode?: ImportProcessStatusEnum | null } | null };

export type CurrentImportProjectStateQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type CurrentImportProjectStateQuery = { __typename: 'Query', importProject?: (
    { __typename: 'ImportProject' }
    & currentImportStateFragment
  ) | null };

export type StartImportProjectMutationVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type StartImportProjectMutation = { __typename: 'Mutation', startImportProject: (
    { __typename: 'ImportProject' }
    & currentImportStateFragment
  ) };

export type ManualPersonMatchingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ManualPersonMatchingDataQuery = { __typename: 'Query', contactCategories: { __typename: 'ContactCategoryConnection', hash: string, nodes: Array<{ __typename: 'ContactCategory', code: string, heading: string, entityType: EntityTypeEnum, type: ContactTypeEnum }> }, addressTypes: { __typename: 'AddressTypeConnection', hash: string, nodes: Array<{ __typename: 'AddressType', code: string, headingKey: string, entityType: EntityTypeEnum }> } };

export type SelectExternalSystemForImportQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectExternalSystemForImportQuery = { __typename: 'Query', externalIdSystems: { __typename: 'ExternalIdSystemConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdSystem', id: number, heading: string }> } };

export type SaveSelectedExternalSystemMutationVariables = Exact<{
  processorId: Scalars['Int'];
  projectId: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type SaveSelectedExternalSystemMutation = { __typename: 'Mutation', saveImportProcessorData: { __typename: 'ImportProcessorData', id: number, value?: string | null } };

export type SelectExternalSystemManualFragment = { __typename: 'SelectExternalSystemManualState', processorId: number };

export type SaveImportLineProcessMutationVariables = Exact<{
  input: ImportSaveProcessInput;
}>;


export type SaveImportLineProcessMutation = { __typename: 'Mutation', saveImportLineProcess: { __typename: 'ImportProcessLine', id: number } };

export type SkipImportLineProcessMutationVariables = Exact<{
  input: ImportSkipProcessInput;
}>;


export type SkipImportLineProcessMutation = { __typename: 'Mutation', skipImportLineProcess: { __typename: 'ImportProcessLine', id: number } };

export type PersonCustomFieldsForImportQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonCustomFieldsForImportQuery = { __typename: 'Query', customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', code: string, heading: string, fieldTypeEnum: CustomFieldTypeEnum, allowMultiple?: boolean | null, allowUserCreate?: boolean | null }> } };

export type ImportTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ImportTemplatesQuery = { __typename: 'Query', importTemplates: { __typename: 'ImportTemplateConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'ImportTemplate', id: number, name: string, note?: string | null, processes: { __typename: 'ImportTemplateProcessConnection', hash: string, nodes: Array<{ __typename: 'ImportTemplateProcess', id: number, processorId: number, processorDataKey?: string | null, requiresCustomFieldsImportMapping: boolean, heading: string, note?: string | null, sort: number, fields: { __typename: 'ImportTemplateProcessFieldConnection', hash: string, nodes: Array<{ __typename: 'ImportTemplateProcessField', id: number, lineDataIndex: number, field: { __typename: 'Field', code: string, heading: string, note?: string | null } }> } }> } }> } };

export type SaveCustomFieldsImportMappingMutationVariables = Exact<{
  key: Scalars['String'];
  processorId: Scalars['Int'];
  projectId: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type SaveCustomFieldsImportMappingMutation = { __typename: 'Mutation', saveImportProcessorData: { __typename: 'ImportProcessorData', id: number, value?: string | null } };

export type FileValidationQueryQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type FileValidationQueryQuery = { __typename: 'Query', delimiters: Array<DelimiterEnum>, charsets: Array<CharsetEnum>, importProject?: { __typename: 'ImportProject', id: number, linePreview: { __typename: 'ImportProjectLinesPreview', projectId: number, charset: CharsetEnum, delimiter: DelimiterEnum, firstLineHeader: boolean, columns: Array<{ __typename: 'ImportProjectColumnPreview', code: string, label: string, note?: string | null } | null>, values: Array<{ __typename: 'ImportProjectLinePreview', key: number, values: Array<{ __typename: 'ImportProjectValuePreview', index: number, code?: string | null, value: string }> }> } } | null };

export type UpdateDelimiterOfFileMutationVariables = Exact<{
  importProjectId: Scalars['ID'];
  delimiter: DelimiterEnum;
}>;


export type UpdateDelimiterOfFileMutation = { __typename: 'Mutation', updateImportedFileSettings: { __typename: 'ImportFile', id: number } };

export type currentImportStateFragment = { __typename: 'ImportProject', id: number, heading: string, statusCode?: ImportProcessStatusEnum | null, statusNote?: string | null, ut: any, manual?: (
    { __typename: 'ImportManualEventMatchStage', projectId: number, lineId: number, templateProcessId: number }
    & ManualEventActionFragmentFragment
  ) | (
    { __typename: 'ImportManualPersonStage', projectId: number, lineId: number, templateProcessId: number }
    & ManualPersonActionFragmentFragment
  ) | (
    { __typename: 'ManualExternalUserIdMapping', projectId: number, lineId: number, templateProcessId: number }
    & ManualExternalUserMappingFragmentFragment
  ) | (
    { __typename: 'SelectExternalSystemManualState', projectId: number, lineId: number, templateProcessId: number }
    & SelectExternalSystemManualFragment
  ) | null, meta: { __typename: 'ImportProjectMeta', projectId: number, missingLineCount: number, steps: Array<string>, currentStepIndex: number, percentage: number } };

export type ManualEventActionFragmentFragment = { __typename: 'ImportManualEventMatchStage', projectId: number };

export type ManualExternalUserMappingFragmentFragment = { __typename: 'ManualExternalUserIdMapping', projectId: number, externalIds: Array<string>, externalIdTypeCode: string };

export type UsersForUserMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersForUserMappingQuery = { __typename: 'Query', usersConnection: { __typename: 'UserConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'User', id: number, firstname?: string | null, lastname?: string | null, email: string }> } };

export type LinkUserWithExternalIdMutationVariables = Exact<{
  input: ExternalIdMutationInput;
}>;


export type LinkUserWithExternalIdMutation = { __typename: 'Mutation', setExternalId?: { __typename: 'ExternalId', id: number } | null };

export type ManualPersonActionFragmentFragment = { __typename: 'ImportManualPersonStage', projectId: number, externalIdTypeCode: string, externalIdValue: string, fuzzySearchAvailable: boolean, candidatesFor: Array<{ __typename: 'MatchCandidateValue', fieldName: string, fieldNameKey: string, value: string }>, candidates: Array<{ __typename: 'MatchCandidate', apurebaseId: string, inLocalDb: boolean, score: number, fields: Array<{ __typename: 'MatchCandidateValue', fieldName: string, fieldNameKey: string, value: string }> }> };

export type DownloadPersonByApbIdMutationVariables = Exact<{
  apbId: Scalars['Int'];
}>;


export type DownloadPersonByApbIdMutation = { __typename: 'Mutation', person: Array<{ __typename: 'Person', id: number } | { __typename: 'Site', id: number } | { __typename: 'SitePerson', id: number }> };

export type LinkHeaderQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type LinkHeaderQuery = { __typename: 'Query', sitePersonAffiliation?: { __typename: 'SitePerson', id: number, apurebaseId?: number | null, countryCode: string, yesIfIsPrimary: string, isActive: boolean, maintainerSourceCode: string, person: { __typename: 'Person', id: number, countryCode: string, fullName: string }, specialties: { __typename: 'SitePersonWorkSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'SitePersonWorkingSpecialty', id: number, specialty: { __typename: 'ImfDataValue', code: string, label: string, type: DataValueMappingName, displayLabel: string } }> }, site: { __typename: 'Site', id: number, name: string }, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string, displayLabel: string } | null } | null };

export type SitePersonAffiliationNoteDetailQueryQueryVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type SitePersonAffiliationNoteDetailQueryQuery = { __typename: 'Query', sitePersonAffiliation?: { __typename: 'SitePerson', id: number, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Note', id: number }
        & NoteDrawerFragmentFragment
      )> } } | null };

export type LinkSelectionRowResultContainerQueryVariables = Exact<{
  linkApureBaseID: Scalars['Int'];
  selectionType?: InputMaybe<SlicerSelectionType>;
}>;


export type LinkSelectionRowResultContainerQuery = { __typename: 'Query', selectionImfCustomers: { __typename: 'SelectionImfCustomerConnection', hash: string, nodes: Array<{ __typename: 'SelectionImfCustomer', code: string, callName?: string | null, name: string }> } };

export type SetActiveLinkSiteMutationVariables = Exact<{
  linkId: Scalars['Int'];
  isActive: Scalars['Boolean'];
}>;


export type SetActiveLinkSiteMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean } };

export type InactivateLinkActionQueryVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type InactivateLinkActionQuery = { __typename: 'Query', sitePersonAffiliation?: { __typename: 'SitePerson', id: number, isActive: boolean, maintainerSourceCode: string } | null };

export type LinkTabDetailQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type LinkTabDetailQuery = { __typename: 'Query', sitePersonAffiliation?: { __typename: 'SitePerson', id: number, siteId: number, apurebaseId?: number | null, selectionRowsCustomerCount?: number | null, notes: { __typename: 'NoteConnection', hash: string, totalCount: number }, site: { __typename: 'Site', id: number, name: string, persons: { __typename: 'PersonConnection', totalCount: number, hash: string } }, person: { __typename: 'Person', id: number, fullName: string, title?: string | null, ct: any, activities: { __typename: 'ActivityConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Activity', id: number, heading: string, type: { __typename: 'ActivityType', code: string, heading: string } }> }, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Note', id: number, title?: string | null }> }, lists: { __typename: 'ListConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'List', id: number, title: string }> }, projects: { __typename: 'ProjectConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Project', id: number, title: string }> }, segmentation?: { __typename: 'SegmentationCode', code: string, heading: string } | null, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number, site: { __typename: 'Site', id: number, name: string } }> }, persType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null } } | null };

export type LinkCardsContainerQueryQueryVariables = Exact<{
  linkId: Scalars['Int'];
  entityGridItemConfigurationId: Scalars['Int'];
}>;


export type LinkCardsContainerQueryQuery = { __typename: 'Query', cardFieldKeys: { __typename: 'EntityCardFields', entityGridItemConfigurationId: number, person: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, link: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, site: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> } }, sitePersonAffiliation?: { __typename: 'SitePerson', id: number, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null, person: { __typename: 'Person', id: number, fullName: string }, site: { __typename: 'Site', id: number, name: string } } | null };

export type LinkDetailQueryVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type LinkDetailQuery = { __typename: 'Query', sitePersonAffiliation?: { __typename: 'SitePerson', id: number, apurebaseId?: number | null, isActive: boolean, countryCode: string, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null, site: { __typename: 'Site', id: number, name: string }, person: { __typename: 'Person', id: number, fullName: string } } | null };

export type LinkTableFragmentFragment = { __typename: 'SitePerson', id: number, apurebaseId?: number | null, isActive: boolean, isLocal: boolean };

export type LinkConnectionQueryQueryVariables = Exact<{
  criteria?: InputMaybe<SitePersonCriteria>;
}>;


export type LinkConnectionQueryQuery = { __typename: 'Query', connection: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'SitePerson' }
      & LinkTableFragmentFragment
    )> } };

export type LinkRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type LinkRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'SitePerson', id: number }
    & LinkTableFragmentFragment
  ) | null };

export type UpdateLinkIsPrimaryMutationMutationVariables = Exact<{
  linkId: Scalars['ID'];
  personId: Scalars['ID'];
}>;


export type UpdateLinkIsPrimaryMutationMutation = { __typename: 'Mutation', setPrimaryLink: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> };

export type UpdateNumberOfPatientsMutationMutationVariables = Exact<{
  linkId: Scalars['Int'];
  numberOfPatients?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateNumberOfPatientsMutationMutation = { __typename: 'Mutation', updateNumberOfPatients: { __typename: 'SitePerson', id: number, numberOfPatients?: number | null } };

export type UpdateLinkPersonTitleMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdateLinkPersonTitleMutationMutation = { __typename: 'Mutation', updatePersonTitle: { __typename: 'Person', id: number, title?: string | null } };

export type SuggestedLinkPersonStandardTitleQueryQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type SuggestedLinkPersonStandardTitleQueryQuery = { __typename: 'Query', standardTitles: { __typename: 'StandardTitleConnection', hash: string, nodes: Array<{ __typename: 'StandardTitle', id: number, label: string }> } };

export type UpdatePersonPositionMutationMutationVariables = Exact<{
  linkId: Scalars['Int'];
  positionCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePersonPositionMutationMutation = { __typename: 'Mutation', updatePosition: { __typename: 'SitePerson', id: number, positionCode?: string | null, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName } | null } };

export type SelectPersonPosSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  country: Scalars['CountryCode'];
}>;


export type SelectPersonPosSuggestionQueryQuery = { __typename: 'Query', positions: { __typename: 'ValuePositionConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type NewLinkFromExistingMutationMutationVariables = Exact<{
  linkId: Scalars['ID'];
  siteId: Scalars['ID'];
}>;


export type NewLinkFromExistingMutationMutation = { __typename: 'Mutation', newLinkFromExisting?: { __typename: 'SitePerson', id: number, person: { __typename: 'Person', id: number, sites: { __typename: 'SiteConnection', hash: string, nodes: Array<{ __typename: 'Site', id: number }> }, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<{ __typename: 'SitePerson', id: number }> } } } | null };

export type UpdateTherapeuticFocusesMutationMutationVariables = Exact<{
  linkId: Scalars['Int'];
  therapeuticFocusCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateTherapeuticFocusesMutationMutation = { __typename: 'Mutation', updateSitePersonTherapeuticFocuses: Array<{ __typename: 'SitePersonTherapeuticFocus', id: number, therapeuticFocusCode: string, sitePerson: { __typename: 'SitePerson', id: number, therapeuticFocuses: { __typename: 'ValueTherapeuticFocusConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, label: string, type: DataValueMappingName }> } } }> };

export type TherapeuticFocusSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['CountryCode'];
}>;


export type TherapeuticFocusSuggestionQueryQuery = { __typename: 'Query', therapeuticFocuses: { __typename: 'ValueTherapeuticFocusConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, label: string, type: DataValueMappingName }> } };

export type FieldWorkingSpecialtiesQueryQueryVariables = Exact<{
  countries: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
}>;


export type FieldWorkingSpecialtiesQueryQuery = { __typename: 'Query', availableSpecialties: { __typename: 'ValueWorkingSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type UpdateSitePersonWorkingSpecialtiesMutationMutationVariables = Exact<{
  linkId: Scalars['Int'];
  specialties: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateSitePersonWorkingSpecialtiesMutationMutation = { __typename: 'Mutation', updateSitePersonWorkingSpecialties: Array<{ __typename: 'SitePersonWorkingSpecialty', id: number, specialty: { __typename: 'ImfDataValue', type: DataValueMappingName, code: string, label: string } }> };

export type AddToStaticListMutationMutationVariables = Exact<{
  listId: Scalars['Int'];
  selection: SelectionCriteriaInput;
}>;


export type AddToStaticListMutationMutation = { __typename: 'Mutation', addToStaticList: { __typename: 'List', id: number } };

export type CreateListInModalMutationVariables = Exact<{
  input: ListInput;
}>;


export type CreateListInModalMutation = { __typename: 'Mutation', createList: { __typename: 'List', id: number } };

export type CreateListMutationMutationVariables = Exact<{
  input: ListInput;
}>;


export type CreateListMutationMutation = { __typename: 'Mutation', createList: { __typename: 'List', id: number } };

export type CreateStaticListMutationMutationVariables = Exact<{
  title: Scalars['String'];
  selection: SelectionCriteriaInput;
  description: Scalars['String'];
  shared: Scalars['Boolean'];
  entityType: EntityTypeEnum;
}>;


export type CreateStaticListMutationMutation = { __typename: 'Mutation', createStaticList: { __typename: 'List', id: number } };

export type GetStaticListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaticListsQuery = { __typename: 'Query', connection: { __typename: 'ListConnection', hash: string, nodes: Array<{ __typename: 'List', id: number, title: string, description?: string | null }> } };

export type AddDynamicRulesToListMutationVariables = Exact<{
  input: DynamicRulesInput;
}>;


export type AddDynamicRulesToListMutation = { __typename: 'Mutation', addDynamicRulesToList: Array<{ __typename: 'DynamicCriteriaList', id: number }> };

export type SetListCountriesMutationVariables = Exact<{
  listId: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type SetListCountriesMutation = { __typename: 'Mutation', updateListCountries?: { __typename: 'List', id: number } | null };

export type ListDetailsQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type ListDetailsQueryQuery = { __typename: 'Query', list?: { __typename: 'List', id: number, isFavoriteList: boolean, isShared: boolean, description?: string | null, title: string, sort?: number | null, ct: any, ut: any, editAccess: boolean, entityTypeEnum: EntityTypeEnum, typeEnum: ListTypeEnum, countries: { __typename: 'ListCountryConnection', hash: string, nodes: Array<{ __typename: 'ListCountry', id: number, countryCode: string }> }, entityType?: { __typename: 'Entity', code: string, heading: string } | null, criterias?: { __typename: 'DynamicCriteriaListConnection', hash: string, totalCount: number } | null, listType: { __typename: 'ListType', code: string, heading: string }, createdUser?: { __typename: 'User', id: number, fullname: string } | null } | null };

export type UpdateListTitleMutationVariables = Exact<{
  id: Scalars['Int'];
  value: Scalars['String'];
}>;


export type UpdateListTitleMutation = { __typename: 'Mutation', updateList: { __typename: 'List', id: number, title: string } };

export type UpdateListDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type UpdateListDescriptionMutation = { __typename: 'Mutation', updateList: { __typename: 'List', id: number, description?: string | null } };

export type DeactivateListMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeactivateListMutationMutation = { __typename: 'Mutation', deactivateList: { __typename: 'List', id: number, isActive: boolean } };

export type ListDynamicRulesFragmentFragment = { __typename: 'List', criterias?: { __typename: 'DynamicCriteriaListConnection', hash: string, nodes: Array<{ __typename: 'DynamicCriteriaList', id: number, criteria: (
        { __typename: 'Criteria', id: number, heading: string }
        & CriteriaInputFragmentFragment
      ), values: { __typename: 'DynamicCriteriaListValueConnection', hash: string, nodes: Array<{ __typename: 'DynamicCriteriaListValue', id: number, value?: string | null, path: { __typename: 'CriteriaPath', id: number, type?: { __typename: 'CriteriaType', id: number, type: string } | null } }> } }> } | null };

export type DynamicRulesQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
  entityTypeEnum?: InputMaybe<EntityTypeEnum>;
}>;


export type DynamicRulesQueryQuery = { __typename: 'Query', list?: (
    { __typename: 'List', id: number }
    & ListDynamicRulesFragmentFragment
  ) | null, criteriaGroups: { __typename: 'CriteriaGroupConnection', hash: string, nodes: Array<(
      { __typename: 'CriteriaGroup' }
      & CriteriasGroupsFragmentFragment
    )> } };

export type ListDetailsTableQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
  fetchSize?: InputMaybe<FetchSize>;
  ordering?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ListDetailsTableQueryQuery = { __typename: 'Query', list?: { __typename: 'List', id: number, entityTypeEnum: EntityTypeEnum, listType: { __typename: 'ListType', code: string } } | null };

export type UpdateListSubTitleMutationVariables = Exact<{
  listId: Scalars['Int'];
  description: Scalars['String'];
}>;


export type UpdateListSubTitleMutation = { __typename: 'Mutation', updateList: { __typename: 'List', id: number, description?: string | null } };

export type UpdateListCountriesMutationVariables = Exact<{
  listId: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type UpdateListCountriesMutation = { __typename: 'Mutation', updateListCountries?: { __typename: 'List', id: number, countries: { __typename: 'ListCountryConnection', hash: string, nodes: Array<{ __typename: 'ListCountry', id: number, countryCode: string }> } } | null };

export type SetDynamicRulesForListMutationVariables = Exact<{
  input: DynamicRulesInput;
}>;


export type SetDynamicRulesForListMutation = { __typename: 'Mutation', setDynamicRulesToList: Array<{ __typename: 'DynamicCriteriaList', id: number, list: (
      { __typename: 'List', id: number, affiliations: { __typename: 'ActivityConnection', hash: string, totalCount: number } | { __typename: 'ActivityPersonConnection' } | { __typename: 'PersonConnection', hash: string, totalCount: number } | { __typename: 'SiteConnection', hash: string, totalCount: number } | { __typename: 'SitePersonConnection', hash: string, totalCount: number } }
      & ListDynamicRulesFragmentFragment
    ) }> };

export type ListDynamicRulesQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type ListDynamicRulesQueryQuery = { __typename: 'Query', list?: (
    { __typename: 'List', id: number, countries: { __typename: 'ListCountryConnection', hash: string, nodes: Array<{ __typename: 'ListCountry', id: number, countryCode: string }> } }
    & ListDynamicRulesFragmentFragment
  ) | null };

export type updateFavListMutationVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type updateFavListMutation = { __typename: 'Mutation', toggleFavoriteList?: { __typename: 'ListUserFav', id: number, list: { __typename: 'List', id: number, isPinned: boolean, isFavoriteList: boolean } } | null };

export type DownloadFileMutationVariables = Exact<{
  listId: Scalars['Int'];
  listFormatId: Scalars['Int'];
}>;


export type DownloadFileMutation = { __typename: 'Mutation', downloadList: { __typename: 'Resource', filename: string, url: string } };

export type AvailableListFormatsQueryVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type AvailableListFormatsQuery = { __typename: 'Query', downloadFilesViaBox?: string | null, list?: { __typename: 'List', id: number, affiliations: { __typename: 'ActivityConnection', hash: string, totalCount: number } | { __typename: 'ActivityPersonConnection' } | { __typename: 'PersonConnection', hash: string, totalCount: number } | { __typename: 'SiteConnection', hash: string, totalCount: number } | { __typename: 'SitePersonConnection' }, availableFormats: { __typename: 'ListFormatConnection', hash: string, nodes: Array<{ __typename: 'ListFormat', id: number, heading: string }> } } | null };

export type SetSharedStatusForListMutationVariables = Exact<{
  listId: Scalars['Int'];
  isShared: Scalars['Boolean'];
}>;


export type SetSharedStatusForListMutation = { __typename: 'Mutation', updateList: { __typename: 'List', id: number, isShared: boolean } };

export type ListSharedDataQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type ListSharedDataQueryQuery = { __typename: 'Query', list?: { __typename: 'List', id: number, isShared: boolean } | null };

export type SetPinStatusForListMutationVariables = Exact<{
  listId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type SetPinStatusForListMutation = { __typename: 'Mutation', updatePinList?: { __typename: 'ListPin', id: number } | null, updateFavoriteList?: { __typename: 'ListUserFav', id: number } | null };

export type updateFavListByStarMutationVariables = Exact<{
  listId: Scalars['Int'];
  enabled: Scalars['Boolean'];
}>;


export type updateFavListByStarMutation = { __typename: 'Mutation', updateFavoriteList?: { __typename: 'ListUserFav', id: number } | null };

export type ListStarQueryQueryVariables = Exact<{
  listId: Scalars['Int'];
}>;


export type ListStarQueryQuery = { __typename: 'Query', list?: { __typename: 'List', id: number, isPinned: boolean, isFavoriteList: boolean } | null };

export type ListTableFragmentFragment = { __typename: 'List', id: number };

export type ListTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<ListCriteria>;
}>;


export type ListTableQueryQuery = { __typename: 'Query', connection: { __typename: 'ListConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'List' }
      & ListTableFragmentFragment
    )> } };

export type ListRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type ListRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'List', id: number }
    & ListTableFragmentFragment
  ) | null };

export type RemoveFromStaticListMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  listId: Scalars['Int'];
}>;


export type RemoveFromStaticListMutationMutation = { __typename: 'Mutation', removeFromStaticList: { __typename: 'List', id: number } };

export type AvailableMassAssignFieldsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type AvailableMassAssignFieldsQueryQuery = { __typename: 'Query', availableMassAssignFields: Array<{ __typename: 'MassAssignFieldInfo', heading: string, isHeadingKey: boolean, fieldType: MassAssignFieldTypeEnum, entityTypes: Array<EntityTypeEnum>, actionName: string, accessRules?: { __typename: 'CustomFieldPermissionOption', customFieldCode: string, allowMutation: boolean, allowRead: boolean } | null }> };

export type MassAssignPreviewQueryQueryVariables = Exact<{
  actionName: Scalars['String'];
  selectionCriteria: SelectionCriteriaInput;
  input: MassAssignFieldInput;
}>;


export type MassAssignPreviewQueryQuery = { __typename: 'Query', previewMassAssign: { __typename: 'MassFieldAssignPreviewInfo', tbd: string, addCount?: number | null, addLabel?: string | null, skipCount?: number | null, skipLabel?: string | null, updatedCount?: number | null, updatedLabel?: string | null, blankOutLabel?: string | null, blankOutSize?: number | null } };

export type SubmitMassAssignSingleSelectMutationMutationVariables = Exact<{
  actionName: Scalars['String'];
  selectionCriteria: SelectionCriteriaInput;
  input: MassAssignFieldInput;
}>;


export type SubmitMassAssignSingleSelectMutationMutation = { __typename: 'Mutation', executeMassAssign: boolean };

export type MassAssignMultiOptionsQueryQueryVariables = Exact<{
  actionName: Scalars['String'];
  search: Scalars['String'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type MassAssignMultiOptionsQueryQuery = { __typename: 'Query', massAssignFieldOptions: Array<{ __typename: 'MassAssignFieldOption', key: string, heading: string, isHeadingKey: boolean }> };

export type MassAssignOptionsQueryQueryVariables = Exact<{
  actionName: Scalars['String'];
  search: Scalars['String'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type MassAssignOptionsQueryQuery = { __typename: 'Query', massAssignFieldOptions: Array<{ __typename: 'MassAssignFieldOption', key: string, heading: string, isHeadingKey: boolean }> };

export type MassAssignMultiTagOptionsQueryQueryVariables = Exact<{
  actionName: Scalars['String'];
  search: Scalars['String'];
}>;


export type MassAssignMultiTagOptionsQueryQuery = { __typename: 'Query', massAssignFieldOptions: Array<{ __typename: 'MassAssignFieldOption', key: string, heading: string, isHeadingKey: boolean }> };

export type ActivityScrollListQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type ActivityScrollListQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, activities: { __typename: 'ActivityConnection', totalCount: number, nodes: Array<{ __typename: 'Activity', id: number, startDate: any, endDate: any, ct: any, title: string, notes: { __typename: 'NoteConnection', hash: string, nodes: Array<{ __typename: 'Note', id: number, text?: string | null }> }, status: { __typename: 'ActivityStatus', code: string, headingKey: string }, type: { __typename: 'ActivityType', code: string, heading: string, color: { __typename: 'Color', code: string, colorName: string } }, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } }> } } | null };

export type BulkPersToActivityMutationVariables = Exact<{
  activityId: Scalars['Int'];
  selection?: InputMaybe<SelectionCriteriaInput>;
  personId?: InputMaybe<Scalars['Int']>;
}>;


export type BulkPersToActivityMutation = { __typename: 'Mutation', addPersonsToActivity: { __typename: 'Activity', id: number, heading: string, persons: { __typename: 'PersonConnection', hash: string, totalCount: number } } };

export type ContactFormQueryQueryVariables = Exact<{
  entityType?: InputMaybe<EntityTypeEnum>;
  contactType?: InputMaybe<ContactTypeEnum>;
}>;


export type ContactFormQueryQuery = { __typename: 'Query', contactCategories: { __typename: 'ContactCategoryConnection', hash: string, nodes: Array<{ __typename: 'ContactCategory', code: string, heading: string }> } };

export type CherryPickDataQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
}>;


export type CherryPickDataQueryQuery = { __typename: 'Query', cherryPickOverview: { __typename: 'ExternalCherryPickCustomerOverview', customerCode: string, country: any, amount: number, amountAvailable: number, amountUsed: number } };

export type EducationDataQueryQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type EducationDataQueryQuery = { __typename: 'Query', educations: { __typename: 'ValueEducationConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type ExternalIdFormQueryVariables = Exact<{
  entityType?: InputMaybe<EntityTypeEnum>;
}>;


export type ExternalIdFormQuery = { __typename: 'Query', externalIdTypes: { __typename: 'ExternalIdTypeConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdType', code: string, isHeadingKey: boolean, heading: string }> } };

export type UpdatePersonFilterCodeMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  filterCodeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdatePersonFilterCodeMutationMutation = { __typename: 'Mutation', updatePersonFilterCode: Array<{ __typename: 'PersonFilterCode', id: number, person: { __typename: 'Person', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, hasKOL: boolean, nodes: Array<{ __typename: 'FilterCode', id: number }> } } }> };

export type FilterCodesSearchQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type FilterCodesSearchQueryQuery = { __typename: 'Query', filterCodeTypes: { __typename: 'FilterCodeTypeConnection', hash: string, nodes: Array<{ __typename: 'FilterCodeType', id: number, code: string, heading: string, getFilterCodesByTypeId: { __typename: 'FilterCodeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'FilterCode', id: number, header: string }> } }> } };

export type PersonFilterCodesQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonFilterCodesQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, hasKOL: boolean, nodes: Array<{ __typename: 'FilterCode', id: number, filterCodeTypeId: number, header: string }> } } | null };

export type GenerateGdprReportMutationVariables = Exact<{
  hcpId: Scalars['Int'];
}>;


export type GenerateGdprReportMutation = { __typename: 'Mutation', report: { __typename: 'Resource', url: string } };

export type PersonAffiliationsContainerQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type PersonAffiliationsContainerQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, apurebaseId?: number | null, countryCode: string, selectionRowsCustomerCount?: number | null, activities: { __typename: 'ActivityConnection', hash: string, totalCount: number }, notes: { __typename: 'NoteConnection', hash: string, totalCount: number }, projects: { __typename: 'ProjectConnection', hash: string, totalCount: number }, lists: { __typename: 'ListConnection', hash: string, totalCount: number }, dcrGroups: { __typename: 'DcrGroupConnection', hash: string, totalCount: number }, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number } } | null };

export type PersonCardContainerQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
  entityGridItemConfigurationId: Scalars['Int'];
}>;


export type PersonCardContainerQueryQuery = { __typename: 'Query', cardFieldKeys: { __typename: 'EntityCardFields', entityGridItemConfigurationId: number, person: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, link: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, site: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> } }, person?: { __typename: 'Person', id: number, segmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean, siteId: number }> } } | null };

export type RecordTabDcrGroupsQueryQueryVariables = Exact<{
  record: DcrGroupContainsRecordDcr;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type RecordTabDcrGroupsQueryQuery = { __typename: 'Query', dcrGroups: { __typename: 'DcrGroupConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'DcrGroup' }
      & DcrGroupTableFragmentFragment
    )> } };

export type HcpHeaderQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type HcpHeaderQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, fullName: string, title?: string | null, countryCode: string, maintainerSourceCode: string, isCherryPicked?: boolean | null, isGdprInformed: boolean, apurebaseId?: number | null, isActive: boolean, primarySite?: { __typename: 'Site', id: number, name: string, countryCode: string, visitAddress?: { __typename: 'Address', id: number, street?: string | null, city?: string | null, postalCode?: string | null } | null, phone?: { __typename: 'ContactValue', id: number, value?: string | null } | null, email?: { __typename: 'ContactValue', id: number, value?: string | null } | null } | null, segmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null };

export type CheckPersonMergeRequestQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type CheckPersonMergeRequestQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, mergeRequests: { __typename: 'EntityMergeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'EntityMerge', id: number, status: EntityMergeStatusEnum, entityAffiliationId: number, intoEntityAffiliationId: number, into?: { __typename: 'Activity' } | { __typename: 'ActivityBrand' } | { __typename: 'ActivityFieldDays' } | { __typename: 'ActivityLocation' } | { __typename: 'ActivityPerson' } | { __typename: 'ActivityProduct' } | { __typename: 'ActivityTypeCustomField' } | { __typename: 'Address' } | { __typename: 'AddressAffiliation' } | { __typename: 'Brand' } | { __typename: 'ConsentContactValue' } | { __typename: 'ConsentValue' } | { __typename: 'ContactCategoryMapping' } | { __typename: 'ContactValue' } | { __typename: 'CreateEntityField' } | { __typename: 'Criteria' } | { __typename: 'CriteriaPath' } | { __typename: 'CriteriaSimpleSaved' } | { __typename: 'CriteriaSimpleSavedCriteria' } | { __typename: 'CriteriaSimpleSavedPath' } | { __typename: 'CriteriaType' } | { __typename: 'CustomFieldControlSetting' } | { __typename: 'CustomFieldGridConfiguration' } | { __typename: 'CustomFieldOption' } | { __typename: 'CustomFieldOptionCountry' } | { __typename: 'CustomFieldRole' } | { __typename: 'CustomLinkValue' } | { __typename: 'CustomValue' } | { __typename: 'Dashboard' } | { __typename: 'DashboardEntityPieSetting' } | { __typename: 'DashboardItemConfiguration' } | { __typename: 'DashboardUser' } | { __typename: 'Dcr' } | { __typename: 'DcrComment' } | { __typename: 'DcrGroup' } | { __typename: 'DcrGroupResponse' } | { __typename: 'DcrLine' } | { __typename: 'DcrNoteTemplate' } | { __typename: 'DcrSnapshotInfo' } | { __typename: 'DefaultCriteria' } | { __typename: 'DefaultDashboard' } | { __typename: 'DefaultTableColumn' } | { __typename: 'DisabledDefaultDashboard' } | { __typename: 'DynamicCriteriaList' } | { __typename: 'DynamicCriteriaListValue' } | { __typename: 'Entity' } | { __typename: 'EntityControlSetting' } | { __typename: 'EntityGridItemCardField' } | { __typename: 'EntityGridItemConfiguration' } | { __typename: 'EntityGridItemField' } | { __typename: 'EntityGridItemRelationField' } | { __typename: 'EntityMerge' } | { __typename: 'EntityValidationLog' } | { __typename: 'ExternalId' } | { __typename: 'ExternalIdSystem' } | { __typename: 'ExternalIdType' } | { __typename: 'ExternalIdTypeCountryExceptionRule' } | { __typename: 'ExternalIdTypeRole' } | { __typename: 'FilterCode' } | { __typename: 'FilterCodeType' } | { __typename: 'ImportFile' } | { __typename: 'ImportLine' } | { __typename: 'ImportProcessField' } | { __typename: 'ImportProcessLine' } | { __typename: 'ImportProcessLineEffect' } | { __typename: 'ImportProcessorData' } | { __typename: 'ImportProject' } | { __typename: 'ImportTemplate' } | { __typename: 'ImportTemplateProcess' } | { __typename: 'ImportTemplateProcessField' } | { __typename: 'List' } | { __typename: 'ListCountry' } | { __typename: 'ListFormat' } | { __typename: 'ListFormatField' } | { __typename: 'ListPin' } | { __typename: 'ListType' } | { __typename: 'ListUserFav' } | { __typename: 'MarketAccessSite' } | { __typename: 'MarketAccessSitePerson' } | { __typename: 'Note' } | { __typename: 'OperatorType' } | { __typename: 'PersProjPreference' } | { __typename: 'Person', id: number, fullName: string } | { __typename: 'PersonActivityProduct' } | { __typename: 'PersonEducation' } | { __typename: 'PersonFilterCode' } | { __typename: 'PersonLanguage' } | { __typename: 'PersonProductSegmentation' } | { __typename: 'PersonProject' } | { __typename: 'PersonSegmentationCode' } | { __typename: 'PersonTherapeuticFocus' } | { __typename: 'PersonUser' } | { __typename: 'Preference' } | { __typename: 'Product' } | { __typename: 'Project' } | { __typename: 'ProjectActivity' } | { __typename: 'ProjectProduct' } | { __typename: 'ProjectStatus' } | { __typename: 'ProjectType' } | { __typename: 'ProjectUser' } | { __typename: 'PureAdvanceCustomerSandbox' } | { __typename: 'PureAdvanceCustomerSelection' } | { __typename: 'PureAdvanceModule' } | { __typename: 'ReportSettingDailyCallTarget' } | { __typename: 'ReportSettingFieldDay' } | { __typename: 'ReportSettingsActivityType' } | { __typename: 'ResponsibleArea' } | { __typename: 'Role' } | { __typename: 'RolePermission' } | { __typename: 'SalesCycle' } | { __typename: 'SalesCycleSegmentationTarget' } | { __typename: 'SalesCycleSetup' } | { __typename: 'Search' } | { __typename: 'SegmentationCode' } | { __typename: 'Selection' } | { __typename: 'SelectionGroup' } | { __typename: 'SelectionRow' } | { __typename: 'SelectionRowResult' } | { __typename: 'Site' } | { __typename: 'SiteFilterCode' } | { __typename: 'SitePerson' } | { __typename: 'SitePersonTherapeuticFocus' } | { __typename: 'SitePersonWorkingSpecialty' } | { __typename: 'SiteResponsible' } | { __typename: 'SiteSegmentationCode' } | { __typename: 'StandardTitle' } | { __typename: 'Team' } | { __typename: 'UnitType' } | { __typename: 'User' } | { __typename: 'UserCountry' } | { __typename: 'UserPreferEnglishLov' } | { __typename: 'UserTableColumn' } | { __typename: 'UserTeam' } | { __typename: 'ValueModel' } | null }> } } | null };

export type PersonDetailListsQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonDetailListsQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, lists: { __typename: 'ListConnection', hash: string, nodes: Array<{ __typename: 'List', id: number, title: string, description?: string | null, ct: any, entityType?: { __typename: 'Entity', id: number, heading: string } | null, listType: { __typename: 'ListType', id: number, heading: string }, createdUser?: { __typename: 'User', fullname: string, id: number } | null }> } } | null };

export type PersonNoteDetailQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonNoteDetailQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'Note', id: number }
        & NoteDrawerFragmentFragment
      )> } } | null };

export type PersonDetailSegmentationQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonDetailSegmentationQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, productSegmentations: { __typename: 'PersonProductSegmentationConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'PersonProductSegmentation', id: number, person: { __typename: 'Person', id: number, fullName: string }, segmentationCode: { __typename: 'SegmentationCode', id: number, heading: string }, product: { __typename: 'Product', id: number, heading: string, strengthUnitType?: { __typename: 'UnitType', id: number, abbreviation: string, description?: string | null, name: string } | null } }> } } | null };

export type PersonDetailProjectsQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonDetailProjectsQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, projects: { __typename: 'ProjectConnection', hash: string, nodes: Array<{ __typename: 'Project', id: number, title: string, location?: string | null, startDate: any, endDate: any, ct: any, notes: { __typename: 'NoteConnection', hash: string, nodes: Array<{ __typename: 'Note', id: number, text?: string | null }> }, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> }, projectStatus: { __typename: 'ProjectStatus', id: number, heading: string, code: string }, projectType: { __typename: 'ProjectType', id: number, heading: string, color?: { __typename: 'Color', code: string, colorName: string } | null } }> } } | null };

export type PersonSelectionRowContainerQueryVariables = Exact<{
  personApureBaseID: Scalars['Int'];
  selectionType?: InputMaybe<SlicerSelectionType>;
}>;


export type PersonSelectionRowContainerQuery = { __typename: 'Query', selectionImfCustomers: { __typename: 'SelectionImfCustomerConnection', hash: string, nodes: Array<{ __typename: 'SelectionImfCustomer', code: string, callName?: string | null, name: string }> } };

export type SegmentationCodesQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type SegmentationCodesQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, segmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null, segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', code: string, id: number, description: string, heading: string }> } };

export type RemoveSegmentationCodeMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveSegmentationCodeMutationMutation = { __typename: 'Mutation', removeSegmentationCode: boolean };

export type UpsertSegmentationCodeMutationVariables = Exact<{
  id: Scalars['Int'];
  segmentationId: Scalars['Int'];
}>;


export type UpsertSegmentationCodeMutation = { __typename: 'Mutation', upsertPersonSegmentationCode: { __typename: 'PersonSegmentationCode', id: number, segmentationCode: { __typename: 'SegmentationCode', id: number, code: string, heading: string } } };

export type PersonDetailAttributesSecondaryPositionFragmentFragment = { __typename: 'SitePerson', id: number, imfCt?: any | null, imfUt?: any | null, imfVt?: any | null, ct: any, apurebaseId?: number | null, maintainerSource: { __typename: 'DbSource', code: string, heading: string }, originSource: { __typename: 'DbSource', code: string, heading: string } };

export type PersonDetailAttributesSharedCustomFieldsFragmentFragment = { __typename: 'Person', id: number, sharedCustomFields?: Array<{ __typename: 'CustomLinkValue', id: number, heading: string, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> | null };

export type InsertEntityValidationLogMutationVariables = Exact<{
  id: Scalars['Int'];
  entity: EntityTypeEnum;
  valDate: Scalars['DateTime'];
}>;


export type InsertEntityValidationLogMutation = { __typename: 'Mutation', insertEntityValidationLog: { __typename: 'EntityValidationLog', id: number, entityAffiliationId: number, entityTypeId: number, validatedTime: any, ct: any, ut: any, validatedByUser?: number | null, affiliationEntity?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', imfVt?: any | null, id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', imfVt?: any | null, id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', imfVt?: any | null, id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null } };

export type hasMdmAccessQueryVariables = Exact<{
  id: Scalars['Int'];
  entityType: EntityTypeEnum;
}>;


export type hasMdmAccessQuery = { __typename: 'Query', getAffiliationByEntity?: { __typename: 'Person', id: number, imfVt?: any | null, ct: any, maintainerSourceCode: string } | { __typename: 'Site', id: number, imfVt?: any | null, ct: any, maintainerSourceCode: string } | { __typename: 'SitePerson', id: number, imfVt?: any | null, ct: any, maintainerSourceCode: string } | null };

export type globalHasMdmAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type globalHasMdmAccessQuery = { __typename: 'Query', hasAccessToModule: boolean };

export type InsertMassEntityValidationLogMutationVariables = Exact<{
  id: Array<Scalars['Int']> | Scalars['Int'];
  entity: EntityTypeEnum;
  valDate: Scalars['DateTime'];
}>;


export type InsertMassEntityValidationLogMutation = { __typename: 'Mutation', insertMassEntityValidationLog: boolean };

export type CherryPickMutationVariables = Exact<{
  type: EntityTypeEnum;
  apurebaseIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CherryPickMutation = { __typename: 'Mutation', cherryPick: Array<{ __typename: 'Person', fullName: string, id: number } | { __typename: 'Site', id: number } | { __typename: 'SitePerson', id: number }> };

export type SetActiveStatusPersonMutationVariables = Exact<{
  personId: Scalars['Int'];
  isActive: Scalars['Boolean'];
}>;


export type SetActiveStatusPersonMutation = { __typename: 'Mutation', setPersonActiveStatus: { __typename: 'Person', id: number, isActive: boolean } };

export type InactivatePersonLinkMutationVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type InactivatePersonLinkMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean, person: { __typename: 'Person', id: number, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } } };

export type InactivatePersonActionQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type InactivatePersonActionQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, isActive: boolean, maintainerSourceCode: string, mergeRequests: { __typename: 'EntityMergeConnection', hash: string, totalCount: number }, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } | null };

export type MultiCherryPickDataQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
}>;


export type MultiCherryPickDataQueryQuery = { __typename: 'Query', cherryPickOverview: { __typename: 'ExternalCherryPickCustomerOverview', customerCode: string, country: any, amount: number, amountAvailable: number, amountUsed: number } };

export type PersonDetailQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonDetailQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, fullName: string, isActive: boolean, countryCode: string, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> }, consentInstructions?: { __typename: 'ConsentInstructionConnection', hash: string, optedOutFromAPB?: boolean | null } | null } | null };

export type PersonSitesFragmentFragment = { __typename: 'SitePerson', id: number, person: { __typename: 'Person', id: number, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } };

export type PersonSiteAffiliationsQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonSiteAffiliationsQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, countryCode: string, maintainerSourceCode: string, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<{ __typename: 'SitePerson', id: number, persId: number, siteId: number, isPrimary: boolean }> } } | null };

export type PersonTableBuiltFragmentFragment = { __typename: 'Person', id: number, countryCode: string, isActive: boolean, isLocal: boolean, consentInstructions?: { __typename: 'ConsentInstructionConnection', hash: string, optedOutFromAPB?: boolean | null } | null };

export type PersonsBuiltQueryQueryVariables = Exact<{
  criteria?: InputMaybe<PersonCriteria>;
}>;


export type PersonsBuiltQueryQuery = { __typename: 'Query', connection: { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'Person', id: number, countryCode: string, fullName: string, isLocal: boolean }
      & PersonTableBuiltFragmentFragment
    )> } };

export type PersonsRecordBuiltQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type PersonsRecordBuiltQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'Person', id: number, countryCode: string, fullName: string, isLocal: boolean }
    & PersonTableBuiltFragmentFragment
  ) | null };

export type searchHasMdmAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type searchHasMdmAccessQuery = { __typename: 'Query', hasAccessToModule: boolean };

export type PersonPopoverCardQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonPopoverCardQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, firstName: string, lastName: string, countryCode: string, title?: string | null, gender?: string | null, externalIds: { __typename: 'ExternalIdConnection', hash: string, nodes: Array<{ __typename: 'ExternalId', id: number, externalId: string }> }, persType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string } | null } | null };

export type PersonConsentQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonConsentQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, hasConsentedEmail: boolean, consents: Array<{ __typename: 'VirtualConsentValue', entityType: EntityTypeEnum, entityAffiliationId: number, consentTypeCode: string, isEnabled: boolean, type: { __typename: 'ConsentType', code: string, headingKey: string, isManaged: boolean } }> } | null };

export type updatePersonConsentMutationMutationVariables = Exact<{
  personId: Scalars['Int'];
  consentTypeCode: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type updatePersonConsentMutationMutation = { __typename: 'Mutation', setConsentValue: { __typename: 'VirtualConsentValue', entityType: EntityTypeEnum, entityAffiliationId: number, consentTypeCode: string, isEnabled: boolean, type: { __typename: 'ConsentType', code: string, headingKey: string } } };

export type CreateAddAddressQueryQueryVariables = Exact<{
  entityType?: InputMaybe<EntityTypeEnum>;
}>;


export type CreateAddAddressQueryQuery = { __typename: 'Query', addressTypes: { __typename: 'AddressTypeConnection', hash: string, nodes: Array<{ __typename: 'AddressType', code: string, headingKey: string }> } };

export type SuggestedStandardTitleQueryQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type SuggestedStandardTitleQueryQuery = { __typename: 'Query', standardTitles: { __typename: 'StandardTitleConnection', hash: string, nodes: Array<{ __typename: 'StandardTitle', id: number, label: string }> } };

export type CreatePersonMutationMutationVariables = Exact<{
  input: PersonInput;
}>;


export type CreatePersonMutationMutation = { __typename: 'Mutation', createPerson: { __typename: 'PersonCreated', person?: { __typename: 'Person', id: number, fullName: string } | null, dcr?: { __typename: 'DcrGroup', id: number, currentResponseCode?: string | null } | null } };

export type EntityContactTypesQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type EntityContactTypesQueryQuery = { __typename: 'Query', contactTypes: { __typename: 'ContactTypeConnection', hash: string, nodes: Array<{ __typename: 'ContactType', code: string, label: string }> } };

export type ContactFieldCategoriesQueryVariables = Exact<{
  type: ContactTypeEnum;
  entityType: EntityTypeEnum;
}>;


export type ContactFieldCategoriesQuery = { __typename: 'Query', contactCategories: { __typename: 'ContactCategoryConnection', hash: string, nodes: Array<{ __typename: 'ContactCategory', code: string, heading: string, isHeadingKey: boolean, allowMultipleValues: boolean, isMapped: boolean, typeEnum: ContactTypeEnum }> } };

export type UpsertContactValuesMutationMutationVariables = Exact<{
  type: ContactTypeEnum;
  entityType: EntityTypeEnum;
  entityAffiliationId: Scalars['Int'];
  values: Array<ContactValueInput> | ContactValueInput;
}>;


export type UpsertContactValuesMutationMutation = { __typename: 'Mutation', upsertContactValues: Array<{ __typename: 'ContactValue', id: number, value?: string | null }> };

export type SetContactPrimaryStateMutationMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  contactValueId: Scalars['Int'];
  isPrimary: Scalars['Boolean'];
}>;


export type SetContactPrimaryStateMutationMutation = { __typename: 'Mutation', setContactPrimaryState: boolean };

export type UpdatePersonMailToPrivateMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  mailToPrivate: Scalars['Boolean'];
}>;


export type UpdatePersonMailToPrivateMutationMutation = { __typename: 'Mutation', updateMailToPrivate: { __typename: 'Person', id: number, mailToPrivate: boolean } };

export type GenerateApureBaseIdMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  id: Scalars['ID'];
}>;


export type GenerateApureBaseIdMutation = { __typename: 'Mutation', synchronizeApureBaseId: { __typename: 'Person', id: number, apurebaseId?: number | null } | { __typename: 'Site', id: number, apurebaseId?: number | null } | { __typename: 'SitePerson', id: number, apurebaseId?: number | null } };

export type CanIGenerateApureBaseIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CanIGenerateApureBaseIdQuery = { __typename: 'Query', canIGenerateApureBaseId: boolean };

export type UpdatePersonDateOfBirthMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  date: Scalars['DateTime'];
}>;


export type UpdatePersonDateOfBirthMutationMutation = { __typename: 'Mutation', updatePersonDateOfBirth: { __typename: 'Person', id: number, birth?: any | null } };

export type UpdatePersonEducationMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  educations: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdatePersonEducationMutationMutation = { __typename: 'Mutation', updatePersonEducations: Array<{ __typename: 'PersonEducation', id: number, person: { __typename: 'Person', id: number, educations: { __typename: 'ValueEducationConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName }> } } }> };

export type SelectPersonEduSuggestionQueryQueryVariables = Exact<{
  countries: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
}>;


export type SelectPersonEduSuggestionQueryQuery = { __typename: 'Query', availableSpecialties: { __typename: 'ValueEducationConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type UpdatePersonExamYearMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  year?: InputMaybe<Scalars['Year']>;
}>;


export type UpdatePersonExamYearMutationMutation = { __typename: 'Mutation', updatePersonExamYear: { __typename: 'Person', id: number, examYear?: number | null, examYearAsDate?: any | null } };

export type UpdateHcpFirstNameMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  firstName: Scalars['String'];
}>;


export type UpdateHcpFirstNameMutationMutation = { __typename: 'Mutation', updatePersonFirstName: { __typename: 'Person', id: number, firstName: string, lastName: string, fullName: string, title?: string | null } };

export type UpdatePersonGenderMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  gender: GenderEnum;
}>;


export type UpdatePersonGenderMutationMutation = { __typename: 'Mutation', updatePersonSex: { __typename: 'Person', id: number, sex?: string | null, genderEnum?: GenderEnum | null } };

export type UpdatePersonLanguageMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  languageCodes: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdatePersonLanguageMutationMutation = { __typename: 'Mutation', updatePersonLanguage: Array<{ __typename: 'PersonLanguage', id: number }> };

export type SelectPersonLanguageSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SelectPersonLanguageSuggestionQueryQuery = { __typename: 'Query', languages: { __typename: 'LanguageConnection', hash: string, nodes: Array<{ __typename: 'ValueLanguage', code: string, heading: string, id: string }> } };

export type UpdatePersonLastNameMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  lastName: Scalars['String'];
}>;


export type UpdatePersonLastNameMutationMutation = { __typename: 'Mutation', updatePersonLastName: { __typename: 'Person', id: number, firstName: string, lastName: string, fullName: string, title?: string | null } };

export type UpdateHcpMiddleNameMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  middleName: Scalars['String'];
}>;


export type UpdateHcpMiddleNameMutationMutation = { __typename: 'Mutation', updatePersonMiddleName: { __typename: 'Person', id: number, firstName: string, middleName?: string | null, lastName: string, fullName: string, title?: string | null } };

export type SetConsentInstructionsMutationVariables = Exact<{
  imfCustomerCodes: Array<Scalars['String']> | Scalars['String'];
  personId: Scalars['Int'];
  optedOut: Scalars['Boolean'];
}>;


export type SetConsentInstructionsMutation = { __typename: 'Mutation', setConsentInstructions: Array<{ __typename: 'ConsentInstruction', isOptedOutForAll: boolean, optedOut: boolean }> };

export type ConsentInstructionCustomersQueryVariables = Exact<{
  countryCode: Scalars['CountryCode'];
}>;


export type ConsentInstructionCustomersQuery = { __typename: 'Query', internationalCustomers: { __typename: 'InternationalCustomerConnection', hash: string, nodes: Array<{ __typename: 'InternationalCustomer', code: string, isActive: boolean, label: string }> } };

export type UpdateHcpAddressMutationMutationVariables = Exact<{
  hcpId: Scalars['Int'];
  input: AddressInput;
}>;


export type UpdateHcpAddressMutationMutation = { __typename: 'Mutation', setPersonSingleAddress: { __typename: 'AddressAffiliation', id: number, affiliationEntity?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', id: number, privateAddresses?: { __typename: 'Address', id: number, city?: string | null, countryCode?: string | null, street?: string | null, postalCode?: string | null } | null } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null } };

export type UpdatePersonTherapeuticFocusesMutationMutationVariables = Exact<{
  persId: Scalars['ID'];
  therapeuticFocuses: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdatePersonTherapeuticFocusesMutationMutation = { __typename: 'Mutation', updatePersonTherapeuticFocuses: Array<{ __typename: 'PersonTherapeuticFocus', id: number, person: { __typename: 'Person', id: number, therapeuticFocuses: { __typename: 'ValueTherapeuticFocusConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName }> } } }> };

export type SelectPersonTherapeuticFocusesSuggestionQueryQueryVariables = Exact<{
  countries: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
}>;


export type SelectPersonTherapeuticFocusesSuggestionQueryQuery = { __typename: 'Query', therapeuticFocuses: { __typename: 'ValueTherapeuticFocusConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, label: string, type: DataValueMappingName }> } };

export type UpdatePersonTitleMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdatePersonTitleMutationMutation = { __typename: 'Mutation', updatePersonTitle: { __typename: 'Person', id: number, title?: string | null } };

export type SuggestedStandardTitleDetailPageQueryQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type SuggestedStandardTitleDetailPageQueryQuery = { __typename: 'Query', standardTitles: { __typename: 'StandardTitleConnection', hash: string, nodes: Array<{ __typename: 'StandardTitle', id: number, label: string }> } };

export type UpdatePersonTypeMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  typeCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePersonTypeMutationMutation = { __typename: 'Mutation', updatePersonType: { __typename: 'Person', id: number, persTypeCode?: string | null, persType?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName } | null } };

export type SelectPersonTypeSuggestionQuery2QueryVariables = Exact<{
  country: Scalars['CountryCode'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type SelectPersonTypeSuggestionQuery2Query = { __typename: 'Query', personTypes: { __typename: 'ValuePersonTypeConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type AddWorkplaceMutationMutationVariables = Exact<{
  input: AddWorkplaceInput;
}>;


export type AddWorkplaceMutationMutation = { __typename: 'Mutation', createSitePerson: { __typename: 'SitePersonCreated', dcr?: { __typename: 'Dcr', id: number } | null, sitePerson?: (
      { __typename: 'SitePerson', id: number }
      & PersonSitesFragmentFragment
    ) | null } };

export type ActivateHcpSiteRelationMutationVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type ActivateHcpSiteRelationMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean } };

export type RemoveHcpSiteRelationMutationVariables = Exact<{
  linkIds: Array<Scalars['Int']> | Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  reason: DeleteReasonDcrEnum;
}>;


export type RemoveHcpSiteRelationMutation = { __typename: 'Mutation', removeHcpSiteRelation: boolean };

export type SetPrimaryLinkMutationMutationVariables = Exact<{
  linkId: Scalars['ID'];
  personId: Scalars['ID'];
}>;


export type SetPrimaryLinkMutationMutation = { __typename: 'Mutation', setPrimaryLink: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> };

export type SetNonPrimaryLinkMutationMutationVariables = Exact<{
  linkId: Scalars['ID'];
  personId: Scalars['ID'];
}>;


export type SetNonPrimaryLinkMutationMutation = { __typename: 'Mutation', setNonPrimaryLink: Array<{ __typename: 'SitePerson', id: number, isPrimary: boolean }> };

export type PersonSelectionRowTableBuiltFragmentFragment = { __typename: 'PersonSelectionRow', id: any };

export type PersonSelectionRowTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<PersonSelectionRowCriteria>;
}>;


export type PersonSelectionRowTableQueryQuery = { __typename: 'Query', connection: { __typename: 'PersonSelectionRowConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'PersonSelectionRow' }
      & PersonSelectionRowTableBuiltFragmentFragment
    )> } };

export type PersonSelectionRowRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Long'];
}>;


export type PersonSelectionRowRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'PersonSelectionRow', id: any }
    & PersonSelectionRowTableBuiltFragmentFragment
  ) | null };

export type ProductDetailQueryQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type ProductDetailQueryQuery = { __typename: 'Query', product?: { __typename: 'Product', id: number, code: string, ct: any, ut: any, strength?: number | null, name: string, strengthUnitType?: { __typename: 'UnitType', id: number, abbreviation: string, description?: string | null, name: string } | null, productDeliveries: { __typename: 'PersonActivityProductConnection', totalCount: number, nodes: Array<{ __typename: 'PersonActivityProduct', person: { __typename: 'Person', id: number, fullname: string } }> } } | null };

export type CreateNewProjectMutationVariables = Exact<{
  title: Scalars['String'];
  typeId: Scalars['Int'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type CreateNewProjectMutation = { __typename: 'Mutation', createNewProject: { __typename: 'Project', id: number } };

export type ProjectTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectTypesQuery = { __typename: 'Query', projectTypes: { __typename: 'ProjectTypeConnection', hash: string, nodes: Array<{ __typename: 'ProjectType', id: number, code: string, heading: string, note?: string | null, ct: any, ut: any }> } };

export type AssignValuesStepQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignValuesStepQueryQuery = { __typename: 'Query', roles: { __typename: 'PersProjectRoleConnection', hash: string, nodes: Array<{ __typename: 'ValueModel', id: number, heading: string, description?: string | null }> }, responses: { __typename: 'ProjectResponseValueConnection', hash: string, nodes: Array<{ __typename: 'ValueModel', id: number, heading: string, description?: string | null }> }, preferences: { __typename: 'PreferenceConnection', hash: string, nodes: Array<{ __typename: 'Preference', id: number, heading: string }> } };

export type BulkProjectConfirmStepQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BulkProjectConfirmStepQueryQuery = { __typename: 'Query', projectTypes: { __typename: 'ProjectTypeConnection', hash: string, nodes: Array<{ __typename: 'ProjectType', id: number, heading: string }> } };

export type NewProjectStepDefaultValuesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewProjectStepDefaultValuesQueryQuery = { __typename: 'Query', projectTypes: { __typename: 'ProjectTypeConnection', hash: string, defaultOption: { __typename: 'ProjectType', id: number }, nodes: Array<{ __typename: 'ProjectType', id: number, heading: string }> } };

export type BulkPersProjMutationVariables = Exact<{
  input: BulkProjectInput;
}>;


export type BulkPersProjMutation = { __typename: 'Mutation', bulkPersProject: { __typename: 'Project', id: number } };

export type CreateProjectMutationMutationVariables = Exact<{
  title: Scalars['String'];
  typeId: Scalars['Int'];
  location?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
}>;


export type CreateProjectMutationMutation = { __typename: 'Mutation', project: { __typename: 'Project', id: number, title: string } };

export type PeopleInProjectQueryQueryVariables = Exact<{
  id: Scalars['Int'];
  isNewProject: Scalars['Boolean'];
}>;


export type PeopleInProjectQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: number, title: string, affiliations: { __typename: 'PersProjectConnection', hash: string, nodes: Array<{ __typename: 'PersonProject', id: number, persId: number, roleId: number, responseId: number, personPreferences: { __typename: 'PersProjPreferenceConnection', hash: string, nodes: Array<{ __typename: 'PersProjPreference', id: number, preferenceId: number }> } }> } } | null, roles: { __typename: 'PersProjectRoleConnection', hash: string, defaultOption: { __typename: 'ValueModel', id: number, heading: string } }, responses: { __typename: 'ProjectResponseValueConnection', hash: string, defaultOption: { __typename: 'ValueModel', id: number, heading: string } }, preferences: { __typename: 'PreferenceConnection', hash: string, defaultOption: { __typename: 'Preference', id: number } } };

export type updateProjectLocationMutationVariables = Exact<{
  projectId: Scalars['Int'];
  location: Scalars['String'];
}>;


export type updateProjectLocationMutation = { __typename: 'Mutation', updateProjectLocation: { __typename: 'Project', id: number } };

export type ProjectNotesQueryQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ProjectNotesQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: number } | null };

export type UpdateProjectNotesMutationVariables = Exact<{
  projectId: Scalars['Int'];
  notes: Scalars['String'];
}>;


export type UpdateProjectNotesMutation = { __typename: 'Mutation', updateProjectNotes?: { __typename: 'Project', id: number } | null };

export type ProjectNoteQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ProjectNoteQuery = { __typename: 'Query', project?: { __typename: 'Project', id: number, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Note', id: number, text?: string | null, ct: any, ut: any, status: boolean, private: boolean, title?: string | null, user?: { __typename: 'User', id: number, fullname: string } | null }> } } | null };

export type AddProductToProjectMutationVariables = Exact<{
  projectId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type AddProductToProjectMutation = { __typename: 'Mutation', addProductToProject: { __typename: 'ProjectProduct', id: number, project: { __typename: 'Project', id: number, productsAffiliations: { __typename: 'ProjectProductConnection', hash: string, nodes: Array<{ __typename: 'ProjectProduct', id: number, product: { __typename: 'Product', id: number, heading: string } }> } } } };

export type RemoveProductFromProjectMutationVariables = Exact<{
  projectId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type RemoveProductFromProjectMutation = { __typename: 'Mutation', removeProductFromProject: { __typename: 'ProjectProduct', id: number, project: { __typename: 'Project', id: number, productsAffiliations: { __typename: 'ProjectProductConnection', hash: string, nodes: Array<{ __typename: 'ProjectProduct', id: number, product: { __typename: 'Product', id: number, heading: string } }> } } } };

export type GetAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, code: string, label: string }> } };

export type ProjectProductBrandsQueryQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ProjectProductBrandsQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: number, productsAffiliations: { __typename: 'ProjectProductConnection', hash: string, nodes: Array<{ __typename: 'ProjectProduct', id: number, product: { __typename: 'Product', id: number, code: string, heading: string } }> } } | null };

export type UpdateProjectResUsersMutationVariables = Exact<{
  projectId: Scalars['Int'];
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateProjectResUsersMutation = { __typename: 'Mutation', updateProjectResUsers: { __typename: 'Project', id: number, editAccess: boolean, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } } };

export type ProjectRightActionsQueryVariables = Exact<{
  projectId: Scalars['Int'];
}>;


export type ProjectRightActionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: number, editAccess: boolean, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } } | null, users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string, email: string }> } };

export type UpdateProjectStatusMutationVariables = Exact<{
  projectId: Scalars['Int'];
  status: Scalars['Int'];
}>;


export type UpdateProjectStatusMutation = { __typename: 'Mutation', updateProjectStatus: { __typename: 'Project', id: number } };

export type UpdateProjectTitleMutationVariables = Exact<{
  projectId: Scalars['Int'];
  title: Scalars['String'];
}>;


export type UpdateProjectTitleMutation = { __typename: 'Mutation', updateProjectTitle: { __typename: 'Project', id: number } };

export type UpdateProjectTypeMutationVariables = Exact<{
  projectId: Scalars['Int'];
  type: Scalars['Int'];
}>;


export type UpdateProjectTypeMutation = { __typename: 'Mutation', updateProjectType: { __typename: 'Project', id: number } };

export type UsersForReportOverviewQueryVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UsersForReportOverviewQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } };

export type ProductsForReportOverviewQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ProductsForReportOverviewQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, heading: string }> } };

export type CountriesQueryForReportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type CountriesQueryForReportsQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string }> } };

export type ReportProductInputQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type ReportProductInputQueryQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, heading: string }> } };

export type ReportUsersInputQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type ReportUsersInputQueryQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } };

export type KPIReportInputQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
}>;


export type KPIReportInputQueryQuery = { __typename: 'Query', salesCycleSetups: { __typename: 'SalesCycleSetupConnection', hash: string, nodes: Array<{ __typename: 'SalesCycleSetup', id: number, year: number }> } };

export type GenerateReportMutationMutationVariables = Exact<{
  input: ReportInput;
}>;


export type GenerateReportMutationMutation = { __typename: 'Mutation', generateReport: { __typename: 'Resource', url: string } };

export type reportsQueryVariables = Exact<{ [key: string]: never; }>;


export type reportsQuery = { __typename: 'Query', reports: { __typename: 'ReportConnection', totalCount: number, hash: string, nodes: Array<{ __typename: 'Report', code: string, sort?: number | null, heading: string, description?: string | null, ut: any, ct: any }> } };

export type ReportInputsQueryQueryVariables = Exact<{
  reportCode: Scalars['String'];
}>;


export type ReportInputsQueryQuery = { __typename: 'Query', report?: { __typename: 'Report', code: string, inputDefs: Array<{ __typename: 'ReportInputDef', key: ReportInputEnum, labelKey?: string | null, placeholderKey?: string | null, rules: Array<{ __typename: 'FormInputRule', type?: AsyncValidatorTypeEnum | null, messageKey?: string | null, required: boolean }> }> } | null };

export type CriteriasGroupsFragmentFragment = { __typename: 'CriteriaGroup', code: string, heading: string, entityId: number, id: string, options: { __typename: 'CriteriaConnection', hash: string, nodes: Array<(
      { __typename: 'Criteria' }
      & DynamicCriteriaInputFragment
    )> } };

export type SelectionRowResultTableBuiltFragmentFragment = { __typename: 'SelectionRowResult', id: number };

export type SelectionRowResultTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<SelectionRowResultCriteria>;
}>;


export type SelectionRowResultTableQueryQuery = { __typename: 'Query', connection: { __typename: 'SelectionRowResultConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'SelectionRowResult' }
      & SelectionRowResultTableBuiltFragmentFragment
    )> } };

export type SelectionRowResultRecordQueryQueryVariables = Exact<{
  recordId: Scalars['ID'];
}>;


export type SelectionRowResultRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'SelectionRowResult', id: number }
    & SelectionRowResultTableBuiltFragmentFragment
  ) | null };

export type FetchSitePositionsGroupsQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type FetchSitePositionsGroupsQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, positionGroups: Array<{ __typename: 'PositionGroup', code?: string | null, heading?: string | null, count: number }>, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number, person: { __typename: 'Person', id: number, fullName: string }, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName } | null }> } } | null };

export type FindNewSiteQueryByApbIdQueryVariables = Exact<{
  apbId: Scalars['Int'];
}>;


export type FindNewSiteQueryByApbIdQuery = { __typename: 'Query', sites: { __typename: 'SiteConnection', hash: string, nodes: Array<{ __typename: 'Site', id: number }> } };

export type SiteDetailQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteDetailQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, isUnplaced: boolean, countryCode: string, maintainerSourceCode: string, isHcoCherryPicked?: boolean | null, isActive: boolean } | null };

export type SitePersonForCacheFragment = { __typename: 'SitePerson', id: number, site: { __typename: 'Site', id: number, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } };

export type AddNewPersonToSiteMutationMutationVariables = Exact<{
  personInput: PersonInput;
}>;


export type AddNewPersonToSiteMutationMutation = { __typename: 'Mutation', createPerson: { __typename: 'PersonCreated', dcr?: { __typename: 'DcrGroup', id: number } | null, person?: { __typename: 'Person', id: number, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<(
          { __typename: 'SitePerson' }
          & SitePersonForCacheFragment
        )> } } | null } };

export type AddExistingPersonToSiteMutationMutationVariables = Exact<{
  workplaceInput: AddWorkplaceInput;
}>;


export type AddExistingPersonToSiteMutationMutation = { __typename: 'Mutation', createSitePerson: { __typename: 'SitePersonCreated', dcr?: { __typename: 'Dcr', id: number } | null, sitePerson?: (
      { __typename: 'SitePerson' }
      & SitePersonForCacheFragment
    ) | null } };

export type AddPersonsToSiteModalQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AddPersonsToSiteModalQueryQuery = { __typename: 'Query', affiliationSetting?: { __typename: 'EntityControlSetting', id: number, createDcr: boolean } | null, personSetting?: { __typename: 'EntityControlSetting', id: number, createDcr: boolean } | null };

export type HcoSectionRightQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type HcoSectionRightQueryQuery = { __typename: 'Query', canICreate: boolean };

export type ValueChainQueryQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type ValueChainQueryQuery = { __typename: 'Query', valueChains: { __typename: 'ValueChainConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SiteActivityContainerQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteActivityContainerQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, activities: { __typename: 'ActivityConnection', hash: string, nodes: Array<{ __typename: 'Activity', id: number, startDate: any, endDate: any, ct: any, title: string, activityStatus: { __typename: 'ActivityStatus', code: string }, responsibleUsers: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> }, type: { __typename: 'ActivityType', code: string, color: { __typename: 'Color', code: string } }, notes: { __typename: 'NoteConnection', hash: string, nodes: Array<{ __typename: 'Note', id: number, text?: string | null }> } }> } } | null };

export type SiteAffiliationContainerQueryQueryVariables = Exact<{
  recordId: Scalars['Int'];
}>;


export type SiteAffiliationContainerQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, apurebaseId?: number | null, countryCode: string, selectionRowsCustomerCount?: number | null, persons: { __typename: 'PersonConnection', hash: string, totalCount: number }, childrenHierarchy: { __typename: 'SiteClosureConnection', hash: string, totalCount: number }, activities: { __typename: 'ActivityConnection', hash: string, totalCount: number }, notes: { __typename: 'NoteConnection', hash: string, totalCount: number }, dcrGroups: { __typename: 'DcrGroupConnection', hash: string, totalCount: number } } | null };

export type SiteNameQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteNameQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', name: string } | null };

export type SiteCardContainerQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
  entityGridItemConfigurationId: Scalars['Int'];
}>;


export type SiteCardContainerQueryQuery = { __typename: 'Query', cardFieldKeys: { __typename: 'EntityCardFields', entityGridItemConfigurationId: number, person: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> }, site: { __typename: 'CardFieldKeys', entityGridItemConfigurationId: number, entityType: EntityTypeEnum, fields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )>, drawerFields: Array<(
        { __typename: 'EntityGridItemCardField' }
        & GridCardFieldFragment
      )> } }, site?: { __typename: 'Site', id: number, name: string, siteSegmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null };

export type UpdateSiteFilterCodeMutationVariables = Exact<{
  siteId: Scalars['Int'];
  filterCodeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateSiteFilterCodeMutation = { __typename: 'Mutation', updateSiteFilterCode: Array<{ __typename: 'SiteFilterCode', id: number }> };

export type SiteFilterCodesSearchQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SiteFilterCodesSearchQueryQuery = { __typename: 'Query', filterCodeTypes: { __typename: 'FilterCodeTypeConnection', hash: string, nodes: Array<{ __typename: 'FilterCodeType', id: number, code: string, heading: string, getFilterCodesByTypeId: { __typename: 'FilterCodeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'FilterCode', id: number, header: string }> } }> } };

export type SiteFilterCodesQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteFilterCodesQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number, filterCodeTypeId: number, header: string }> } } | null };

export type CheckSiteMergeRequestQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type CheckSiteMergeRequestQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, mergeRequests: { __typename: 'EntityMergeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'EntityMerge', id: number, status: EntityMergeStatusEnum, entityAffiliationId: number, intoEntityAffiliationId: number, into?: { __typename: 'Activity' } | { __typename: 'ActivityBrand' } | { __typename: 'ActivityFieldDays' } | { __typename: 'ActivityLocation' } | { __typename: 'ActivityPerson' } | { __typename: 'ActivityProduct' } | { __typename: 'ActivityTypeCustomField' } | { __typename: 'Address' } | { __typename: 'AddressAffiliation' } | { __typename: 'Brand' } | { __typename: 'ConsentContactValue' } | { __typename: 'ConsentValue' } | { __typename: 'ContactCategoryMapping' } | { __typename: 'ContactValue' } | { __typename: 'CreateEntityField' } | { __typename: 'Criteria' } | { __typename: 'CriteriaPath' } | { __typename: 'CriteriaSimpleSaved' } | { __typename: 'CriteriaSimpleSavedCriteria' } | { __typename: 'CriteriaSimpleSavedPath' } | { __typename: 'CriteriaType' } | { __typename: 'CustomFieldControlSetting' } | { __typename: 'CustomFieldGridConfiguration' } | { __typename: 'CustomFieldOption' } | { __typename: 'CustomFieldOptionCountry' } | { __typename: 'CustomFieldRole' } | { __typename: 'CustomLinkValue' } | { __typename: 'CustomValue' } | { __typename: 'Dashboard' } | { __typename: 'DashboardEntityPieSetting' } | { __typename: 'DashboardItemConfiguration' } | { __typename: 'DashboardUser' } | { __typename: 'Dcr' } | { __typename: 'DcrComment' } | { __typename: 'DcrGroup' } | { __typename: 'DcrGroupResponse' } | { __typename: 'DcrLine' } | { __typename: 'DcrNoteTemplate' } | { __typename: 'DcrSnapshotInfo' } | { __typename: 'DefaultCriteria' } | { __typename: 'DefaultDashboard' } | { __typename: 'DefaultTableColumn' } | { __typename: 'DisabledDefaultDashboard' } | { __typename: 'DynamicCriteriaList' } | { __typename: 'DynamicCriteriaListValue' } | { __typename: 'Entity' } | { __typename: 'EntityControlSetting' } | { __typename: 'EntityGridItemCardField' } | { __typename: 'EntityGridItemConfiguration' } | { __typename: 'EntityGridItemField' } | { __typename: 'EntityGridItemRelationField' } | { __typename: 'EntityMerge' } | { __typename: 'EntityValidationLog' } | { __typename: 'ExternalId' } | { __typename: 'ExternalIdSystem' } | { __typename: 'ExternalIdType' } | { __typename: 'ExternalIdTypeCountryExceptionRule' } | { __typename: 'ExternalIdTypeRole' } | { __typename: 'FilterCode' } | { __typename: 'FilterCodeType' } | { __typename: 'ImportFile' } | { __typename: 'ImportLine' } | { __typename: 'ImportProcessField' } | { __typename: 'ImportProcessLine' } | { __typename: 'ImportProcessLineEffect' } | { __typename: 'ImportProcessorData' } | { __typename: 'ImportProject' } | { __typename: 'ImportTemplate' } | { __typename: 'ImportTemplateProcess' } | { __typename: 'ImportTemplateProcessField' } | { __typename: 'List' } | { __typename: 'ListCountry' } | { __typename: 'ListFormat' } | { __typename: 'ListFormatField' } | { __typename: 'ListPin' } | { __typename: 'ListType' } | { __typename: 'ListUserFav' } | { __typename: 'MarketAccessSite' } | { __typename: 'MarketAccessSitePerson' } | { __typename: 'Note' } | { __typename: 'OperatorType' } | { __typename: 'PersProjPreference' } | { __typename: 'Person' } | { __typename: 'PersonActivityProduct' } | { __typename: 'PersonEducation' } | { __typename: 'PersonFilterCode' } | { __typename: 'PersonLanguage' } | { __typename: 'PersonProductSegmentation' } | { __typename: 'PersonProject' } | { __typename: 'PersonSegmentationCode' } | { __typename: 'PersonTherapeuticFocus' } | { __typename: 'PersonUser' } | { __typename: 'Preference' } | { __typename: 'Product' } | { __typename: 'Project' } | { __typename: 'ProjectActivity' } | { __typename: 'ProjectProduct' } | { __typename: 'ProjectStatus' } | { __typename: 'ProjectType' } | { __typename: 'ProjectUser' } | { __typename: 'PureAdvanceCustomerSandbox' } | { __typename: 'PureAdvanceCustomerSelection' } | { __typename: 'PureAdvanceModule' } | { __typename: 'ReportSettingDailyCallTarget' } | { __typename: 'ReportSettingFieldDay' } | { __typename: 'ReportSettingsActivityType' } | { __typename: 'ResponsibleArea' } | { __typename: 'Role' } | { __typename: 'RolePermission' } | { __typename: 'SalesCycle' } | { __typename: 'SalesCycleSegmentationTarget' } | { __typename: 'SalesCycleSetup' } | { __typename: 'Search' } | { __typename: 'SegmentationCode' } | { __typename: 'Selection' } | { __typename: 'SelectionGroup' } | { __typename: 'SelectionRow' } | { __typename: 'SelectionRowResult' } | { __typename: 'Site', id: number, name: string } | { __typename: 'SiteFilterCode' } | { __typename: 'SitePerson' } | { __typename: 'SitePersonTherapeuticFocus' } | { __typename: 'SitePersonWorkingSpecialty' } | { __typename: 'SiteResponsible' } | { __typename: 'SiteSegmentationCode' } | { __typename: 'StandardTitle' } | { __typename: 'Team' } | { __typename: 'UnitType' } | { __typename: 'User' } | { __typename: 'UserCountry' } | { __typename: 'UserPreferEnglishLov' } | { __typename: 'UserTableColumn' } | { __typename: 'UserTeam' } | { __typename: 'ValueModel' } | null }> } } | null };

export type SiteNoteDetailQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteNoteDetailQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, notes: { __typename: 'NoteConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Note', id: number, text?: string | null, ct: any, ut: any, status: boolean, private: boolean, title?: string | null, user?: { __typename: 'User', id: number, fullname: string } | null }> } } | null };

export type SiteSpecialityTypeQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SiteSpecialityTypeQueryQuery = { __typename: 'Query', siteSectorTypes: { __typename: 'ValueSiteSectorTypeConnection', hash: string, nodes: Array<{ __typename: 'ValueSiteSectorType', code: string, label: string }> } };

export type UpsertSiteSegmentationCodeMutationVariables = Exact<{
  id: Scalars['Int'];
  segmentationId: Scalars['Int'];
}>;


export type UpsertSiteSegmentationCodeMutation = { __typename: 'Mutation', upsertSiteSegmentationCode: { __typename: 'SiteSegmentationCode', id: number, segmentationCode: { __typename: 'SegmentationCode', id: number, heading: string } } };

export type HcoSegmentationCodesTabQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type HcoSegmentationCodesTabQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, siteSegmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null, segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', code: string, id: number, description: string, heading: string }> } };

export type RemoveHcoSegmentationCodeMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveHcoSegmentationCodeMutationMutation = { __typename: 'Mutation', removeSiteSegmentation: { __typename: 'Site', id: number } };

export type SiteSelectionRowContainerQueryVariables = Exact<{
  siteApureBaseID: Scalars['Int'];
  selectionType?: InputMaybe<SlicerSelectionType>;
}>;


export type SiteSelectionRowContainerQuery = { __typename: 'Query', selectionImfCustomers: { __typename: 'SelectionImfCustomerConnection', hash: string, nodes: Array<{ __typename: 'SelectionImfCustomer', code: string, callName?: string | null, name: string }> } };

export type SiteSpecialityQueryQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type SiteSpecialityQueryQuery = { __typename: 'Query', siteSpecialties: { __typename: 'ValueSiteSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SetActiveStatusSiteMutationVariables = Exact<{
  siteId: Scalars['Int'];
  isActive: Scalars['Boolean'];
}>;


export type SetActiveStatusSiteMutation = { __typename: 'Mutation', setSiteActiveStatus: { __typename: 'Site', id: number, isActive: boolean } };

export type InactivateSiteLinkMutationVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type InactivateSiteLinkMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean, site: { __typename: 'Site', id: number, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } } };

export type InactivateSiteActionQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type InactivateSiteActionQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, isActive: boolean, maintainerSourceCode: string, mergeRequests: { __typename: 'EntityMergeConnection', hash: string, totalCount: number }, affiliations: { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } | null };

export type CreateSiteDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateSiteDataQueryQuery = { __typename: 'Query', canICreate: boolean };

export type TotalAddressTypeQueryQueryVariables = Exact<{
  entityType?: InputMaybe<EntityTypeEnum>;
}>;


export type TotalAddressTypeQueryQuery = { __typename: 'Query', addressTypes: { __typename: 'AddressTypeConnection', hash: string, totalCount: number } };

export type CreateSiteMutationMutationVariables = Exact<{
  input: SiteInput;
}>;


export type CreateSiteMutationMutation = { __typename: 'Mutation', createSite: { __typename: 'SiteCreated', site?: { __typename: 'Site', id: number, name: string } | null, dcrGroup?: { __typename: 'DcrGroup', id: number, currentResponseCode?: string | null } | null } };

export type EntityCustomFieldConfigQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type EntityCustomFieldConfigQueryQuery = { __typename: 'Query', customFields: { __typename: 'CustomFieldConnection', hash: string, nodes: Array<{ __typename: 'CustomField', allowMultiple?: boolean | null, code: string, label: string }> } };

export type GetFieldTypeQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetFieldTypeQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', code: string, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum } } | null };

export type CustomFieldRuleQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type CustomFieldRuleQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', myAccessRules?: { __typename: 'CustomFieldRole', id: number, allowMutation: boolean, allowRead: boolean } | null } | null };

export type ExternalIdTypesForFieldQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type ExternalIdTypesForFieldQueryQuery = { __typename: 'Query', externalIdTypes: { __typename: 'ExternalIdTypeConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdType', code: string, heading: string, isHeadingKey: boolean, id: number }> } };

export type ExternalIdRuleQueryQueryVariables = Exact<{
  typeCode: Scalars['String'];
  roleId: Scalars['ID'];
}>;


export type ExternalIdRuleQueryQuery = { __typename: 'Query', externalIdTypeRoles: { __typename: 'ExternalIdTypeRoleConnection', hash: string, nodes: Array<{ __typename: 'ExternalIdTypeRole', id: number, type: { __typename: 'ExternalIdType', code: string, controlSetting?: { __typename: 'EntityControlSetting', id: number, createDcr: boolean } | null, rules: { __typename: 'ExternalIdTypeRules', key: number, allowRead: boolean, allowMutation: boolean } } }> } };

export type UpdateExternalIdValueMutationVariables = Exact<{
  input: ExternalIdMutationInput;
}>;


export type UpdateExternalIdValueMutation = { __typename: 'Mutation', setExternalId?: { __typename: 'ExternalId', id: number } | null };

export type RemoveExternalIdValueMutationVariables = Exact<{
  input: Scalars['Int'];
}>;


export type RemoveExternalIdValueMutation = { __typename: 'Mutation', removeExternalId: { __typename: 'ExternalId', id: number } };

export type ExternalIdControlQueryVariables = Exact<{
  externalIdTypeCode: Scalars['String'];
}>;


export type ExternalIdControlQuery = { __typename: 'Query', externalIdType?: { __typename: 'ExternalIdType', id: number, code: string, controlSetting?: { __typename: 'EntityControlSetting', id: number, createDcr: boolean } | null } | null };

export type DuplicateExternalIDQueryQueryVariables = Exact<{
  typeId: Scalars['ID'];
  entityAffiliationId: Scalars['ID'];
  externalId: Scalars['String'];
}>;


export type DuplicateExternalIDQueryQuery = { __typename: 'Query', validateExternalId: { __typename: 'FormValidationErrorResponse', errorMessage?: string | null, isOk: boolean } };

export type EntityCustomFieldCheckableOptionsQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type EntityCustomFieldCheckableOptionsQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', isCheckableTag?: boolean | null, options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null } | null };

export type EntityRadioCustomFieldCheckableOptionsQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type EntityRadioCustomFieldCheckableOptionsQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', isCheckableTag?: boolean | null, options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null } | null };

export type EntityCustomFieldTagOptionsQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type EntityCustomFieldTagOptionsQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', color?: string | null, options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null } | null };

export type UpsertCustomFieldInputValueMutationVariables = Exact<{
  customFieldCode: Scalars['String'];
  customValues: Array<UpdateSelectCustomFieldValueForRecord> | UpdateSelectCustomFieldValueForRecord;
  recordId: Scalars['Int'];
}>;


export type UpsertCustomFieldInputValueMutation = { __typename: 'Mutation', setCustomLinkValues: Array<{ __typename: 'CustomLinkValue', customFieldCode: string }> };

export type RemoveCustomFieldInputValueMutationVariables = Exact<{
  customValues: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveCustomFieldInputValueMutation = { __typename: 'Mutation', removeCustomLinkValues: boolean };

export type EntityCustomFieldOptionsQueryQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type EntityCustomFieldOptionsQueryQuery = { __typename: 'Query', customField?: { __typename: 'CustomField', options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null } | null };

export type UpdateSiteAddressMutationMutationVariables = Exact<{
  existingAffiliationId?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  addressInput: AddressInput;
}>;


export type UpdateSiteAddressMutationMutation = { __typename: 'Mutation', updateOrCreateAddress: { __typename: 'AddressAffiliation', id: number } };

export type SiteAddressTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteAddressTypesQueryQuery = { __typename: 'Query', addressTypes: { __typename: 'AddressTypeConnection', hash: string, nodes: Array<{ __typename: 'AddressType', code: string, headingKey: string }> } };

export type UpdateSiteChainMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  chainCode: Scalars['String'];
}>;


export type UpdateSiteChainMutationMutation = { __typename: 'Mutation', updateSiteChain: Array<{ __typename: 'SiteChain', id: { __typename: 'SiteChainId', siteId: number, chainCode: string } } | null> };

export type SelectValueChainSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['CountryCode'];
}>;


export type SelectValueChainSuggestionQueryQuery = { __typename: 'Query', valueChains: { __typename: 'ValueChainConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SelectSiteCountyQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  country: Scalars['CountryCode'];
}>;


export type SelectSiteCountyQueryQuery = { __typename: 'Query', counties: { __typename: 'ValueCountyConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName, label: string }> } };

export type UpdateAddressMutationMutationVariables = Exact<{
  addressAffiliationId: Scalars['Int'];
  input: AddressInput;
}>;


export type UpdateAddressMutationMutation = { __typename: 'Mutation', updateAddress: { __typename: 'Address', id: number, city?: string | null, countryCode?: string | null, countryEnum?: any | null, countyCode?: string | null, street?: string | null, postalCode?: string | null, county?: { __typename: 'DataValue', code: string } | null } };

export type UpdateSiteName2MutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  siteName2: Scalars['String'];
}>;


export type UpdateSiteName2MutationMutation = { __typename: 'Mutation', updateSiteName2: { __typename: 'Site', id: number, name2?: string | null } };

export type UpdateSiteNameMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  siteName: Scalars['String'];
}>;


export type UpdateSiteNameMutationMutation = { __typename: 'Mutation', updateSiteName: { __typename: 'Site', id: number, name: string } };

export type UpdateSiteNumberOfBedsMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  beds?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateSiteNumberOfBedsMutationMutation = { __typename: 'Mutation', updateSiteNumberOfBeds: { __typename: 'Site', id: number, numberOfBeds?: number | null } };

export type UpdateSiteNumberOfChairsMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  chairs?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateSiteNumberOfChairsMutationMutation = { __typename: 'Mutation', updateSiteNumberOfChairs: { __typename: 'Site', id: number, numberOfChairs?: number | null } };

export type SelectSiteParentSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['CountryCode'];
}>;


export type SelectSiteParentSuggestionQueryQuery = { __typename: 'Query', sites: { __typename: 'SiteConnection', hash: string, nodes: Array<{ __typename: 'Site', id: number, name: string }> } };

export type UpdateSiteParentMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateSiteParentMutationMutation = { __typename: 'Mutation', updateSiteParentId: { __typename: 'Site', id: number, parentId?: number | null, parentSite?: { __typename: 'Site', id: number, name: string } | null } };

export type SetSiteResponsibleUserMutationVariables = Exact<{
  siteId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type SetSiteResponsibleUserMutation = { __typename: 'Mutation', setSiteResponsibleUser?: { __typename: 'SiteResponsible', id: number, siteId: number, site: { __typename: 'Site', id: number, responsibleUser: { __typename: 'SiteResponsibleUserViewModel', id: number, user?: { __typename: 'User', id: number, fullname: string } | null } } } | null };

export type SelectSiteResSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SelectSiteResSuggestionQueryQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } };

export type UpdateSiteSectorTypeMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  sectorType?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSiteSectorTypeMutationMutation = { __typename: 'Mutation', updateSiteSectorType: { __typename: 'Site', id: number } };

export type SelectSiteSegmentTypeSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SelectSiteSegmentTypeSuggestionQueryQuery = { __typename: 'Query', siteSectorTypes: { __typename: 'ValueSiteSectorTypeConnection', hash: string, nodes: Array<{ __typename: 'ValueSiteSectorType', code: string, label: string }> } };

export type UpdateSiteSegmentationCodeMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  segmentCodeId: Scalars['Int'];
}>;


export type UpdateSiteSegmentationCodeMutationMutation = { __typename: 'Mutation', upsertSiteSegmentationCode: { __typename: 'SiteSegmentationCode', id: number } };

export type SelectSiteSegmentationCodeSuggestionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectSiteSegmentationCodeSuggestionQueryQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, code: string, heading: string }> } };

export type UpdateSiteSpecialtiesMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  specialties: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateSiteSpecialtiesMutationMutation = { __typename: 'Mutation', updateSiteSpecialties: Array<{ __typename: 'SiteSpecialty', id: { __typename: 'SiteSpecialtyId', siteId: number, siteSpecialtyCode: string } }> };

export type SelectSiteSpecialtiesSuggestionQueryQueryVariables = Exact<{
  countries: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
}>;


export type SelectSiteSpecialtiesSuggestionQueryQuery = { __typename: 'Query', availableSpecialties: { __typename: 'ValueSiteSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type UpdateSiteTypeMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  typeCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSiteTypeMutationMutation = { __typename: 'Mutation', updateSiteTypeCode: { __typename: 'Site', id: number } };

export type SelectSiteTypeSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  country: Scalars['CountryCode'];
}>;


export type SelectSiteTypeSuggestionQueryQuery = { __typename: 'Query', siteTypes: { __typename: 'ValueSiteTypeConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type UpdateSiteWebsiteMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  webpage: Scalars['String'];
}>;


export type UpdateSiteWebsiteMutationMutation = { __typename: 'Mutation', updateSiteWebpage: { __typename: 'Site', id: number, siteWebpage?: string | null } };

export type FindHcpAffiliationsQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type FindHcpAffiliationsQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, affiliations: { __typename: 'SitePersonConnection', totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number, person: { __typename: 'Person', id: number, fullName: string, title?: string | null, persType?: { __typename: 'ImfDataValue', type: DataValueMappingName, code: string, label: string } | null } }> } } | null };

export type RemoveSiteModalQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type RemoveSiteModalQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, maintainerSource: { __typename: 'DbSource', code: string, heading: string }, affiliations: { __typename: 'SitePersonConnection', totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number, person: { __typename: 'Person', id: number, fullName: string, title?: string | null } }> } } | null };

export type removeSiteMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  comment: Scalars['String'];
  reason: DeleteReasonDcrEnum;
}>;


export type removeSiteMutationMutation = { __typename: 'Mutation', removeSite: boolean };

export type SitePersonAffiliationsQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SitePersonAffiliationsQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, countryCode: string, maintainerSourceCode: string, affiliations: { __typename: 'SitePersonConnection', hash: string, nodes: Array<{ __typename: 'SitePerson', id: number, persId: number, siteId: number }> } } | null };

export type SelectWorkingSpecialtiesQueryQueryVariables = Exact<{
  countries: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type SelectWorkingSpecialtiesQueryQuery = { __typename: 'Query', availableSpecialties: { __typename: 'ValueWorkingSpecialtyConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SiteInformationForWorkplaceQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
  positionCode: Scalars['String'];
}>;


export type SiteInformationForWorkplaceQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, countryCode: string } | null, position?: { __typename: 'ImfDataValue', code: string, type: DataValueMappingName, displayLabel: string } | null };

export type ActivateHcpAffiliationMutationVariables = Exact<{
  linkId: Scalars['Int'];
}>;


export type ActivateHcpAffiliationMutation = { __typename: 'Mutation', setSitePersonActiveStatus: { __typename: 'SitePerson', id: number, isActive: boolean } };

export type removeHcpHcoRelationMutationMutationVariables = Exact<{
  linkIds: Array<Scalars['Int']> | Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
  reason: DeleteReasonDcrEnum;
}>;


export type removeHcpHcoRelationMutationMutation = { __typename: 'Mutation', removeHcpSiteRelation: boolean };

export type SiteSelectionRowTableBuiltFragmentFragment = { __typename: 'SiteSelectionRow', id: any };

export type SiteSelectionRowTableQueryQueryVariables = Exact<{
  criteria?: InputMaybe<SiteSelectionRowCriteria>;
}>;


export type SiteSelectionRowTableQueryQuery = { __typename: 'Query', connection: { __typename: 'SiteSelectionRowConnection', hash: string, totalCount: number, nodes: Array<(
      { __typename: 'SiteSelectionRow' }
      & SiteSelectionRowTableBuiltFragmentFragment
    )> } };

export type SiteSelectionRowRecordQueryQueryVariables = Exact<{
  recordId: Scalars['Long'];
}>;


export type SiteSelectionRowRecordQueryQuery = { __typename: 'Query', record?: (
    { __typename: 'SiteSelectionRow' }
    & SiteSelectionRowTableBuiltFragmentFragment
  ) | null };

export type GetAvailableListsQueryVariables = Exact<{
  criteria?: InputMaybe<ListCriteria>;
}>;


export type GetAvailableListsQuery = { __typename: 'Query', lists: { __typename: 'ListConnection', hash: string, nodes: Array<{ __typename: 'List', id: number, title: string, description?: string | null }> } };

export type AddSingleToStaticListMutationMutationVariables = Exact<{
  listId: Scalars['Int'];
  selection: SelectionCriteriaInput;
}>;


export type AddSingleToStaticListMutationMutation = { __typename: 'Mutation', addToStaticList: { __typename: 'List', id: number, affiliations: { __typename: 'ActivityConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Activity', id: number }> } | { __typename: 'ActivityPersonConnection' } | { __typename: 'PersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Person', id: number }> } | { __typename: 'SiteConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'Site', id: number }> } | { __typename: 'SitePersonConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SitePerson', id: number }> } } };

export type AddressFormDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AddressFormDataQueryQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string }> } };

export type PostcodeQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
  postcode: Scalars['String'];
}>;


export type PostcodeQueryQuery = { __typename: 'Query', postcode?: { __typename: 'ExternalPostcodeResponse', postcode?: string | null, city?: string | null, region?: string | null, regionCode?: string | null, county?: string | null, countyCode?: string | null } | null };

export type CountycodeQueryQueryVariables = Exact<{
  country: Array<Scalars['CountryCode']> | Scalars['CountryCode'];
}>;


export type CountycodeQueryQuery = { __typename: 'Query', counties: { __typename: 'ValueCountyConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName, label: string }> } };

export type CommuneCodeQueryQueryVariables = Exact<{
  country?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type CommuneCodeQueryQuery = { __typename: 'Query', communes: { __typename: 'ValueCommuneConnection', hash: string, nodes: Array<{ __typename: 'DataValue', code: string, type: DataValueMappingName, label: string }> } };

export type CriteriaSuggestionDropdownValuesAdvanceQueryVariables = Exact<{
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
  service: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  fromEntityType: EntityTypeEnum;
}>;


export type CriteriaSuggestionDropdownValuesAdvanceQuery = { __typename: 'Query', dropdownSuggestions: { __typename: 'AdvancedSearchableGqlValueConnection', hash: string, totalCount: number, search?: string | null, service?: string | null, countryCodes: Array<string>, nodes: Array<{ __typename: 'AdvancedSearchableGqlValueWithKey', key: string, isGlobalOnly: boolean, cacheKey: string, isHeadingKey: boolean, englishHeading?: string | null, heading: string }> } };

export type personsCalendarQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type personsCalendarQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, fullName: string, daysSinceLastActivity?: number | null, primarySite?: { __typename: 'Site', id: number, name: string } | null } | null };

export type InternationalCustomersForCherryPickQueryVariables = Exact<{
  criteria: InternationalCustomerCriteria;
}>;


export type InternationalCustomersForCherryPickQuery = { __typename: 'Query', internationalCustomers: { __typename: 'InternationalCustomerConnection', hash: string, nodes: Array<{ __typename: 'InternationalCustomer', code: string, heading: string, countryCode: string, cherryPickOverview?: { __typename: 'ExternalCherryPickCustomerOverview', customerCode: string, country: any, amount: number, amountAvailable: number, amountUsed: number } | null }> } };

export type CherryPickOnBeHalfOfCustomerMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  customerCode: Scalars['String'];
  entityApbId: Scalars['Int'];
}>;


export type CherryPickOnBeHalfOfCustomerMutation = { __typename: 'Mutation', cherryPick: Array<{ __typename: 'Person', id: number } | { __typename: 'Site', id: number } | { __typename: 'SitePerson', id: number }> };

export type EntityCherryPickOverviewQueryVariables = Exact<{
  entityApbId: Scalars['Int'];
  entityType: EntityTypeEnum;
}>;


export type EntityCherryPickOverviewQuery = { __typename: 'Query', instancesRecordCherryPickOverview: Array<{ __typename: 'ExternalCherryPickHcpOverview', apurebaseId: number, internationalId: string, cherryPickedForCustomerCodes: Array<{ __typename: 'ExternalCherryPickHcpOverviewCustomer', customerCode: string, bySystem?: string | null, bySystemUserId?: string | null, timestamp: any, customer?: { __typename: 'PureAdvanceCustomer', code: string, heading?: string | null } | null, byUser?: { __typename: 'User', id: number, fullname: string } | null }> }> };

export type AdminTableColumnSettingsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type AdminTableColumnSettingsQueryQuery = { __typename: 'Query', defaultTableColumns: { __typename: 'DefaultTableColumnConnection', hash: string, nodes: Array<{ __typename: 'DefaultTableColumn', id: number, sort: number, columnKey: string }> } };

export type UserTableColumnsQueryQueryVariables = Exact<{
  userId: Scalars['ID'];
  entityType: EntityTypeEnum;
}>;


export type UserTableColumnsQueryQuery = { __typename: 'Query', userTableColumns: { __typename: 'UserTableColumnConnection', hash: string, nodes: Array<{ __typename: 'UserTableColumn', id: number, columnKey: string, sort: number }> }, defaultTableColumns: { __typename: 'DefaultTableColumnConnection', hash: string, nodes: Array<{ __typename: 'DefaultTableColumn', id: number, columnKey: string, sort: number }> } };

export type UpdateUserTableColumnsMutationMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  columnKeys: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateUserTableColumnsMutationMutation = { __typename: 'Mutation', updateUserTableColumns: Array<{ __typename: 'UserTableColumn', id: number }> };

export type UpdateDefaultTableColumnsMutationMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  columnKeys: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateDefaultTableColumnsMutationMutation = { __typename: 'Mutation', updateDefaultTableColumns: { __typename: 'DefaultTableColumnConnection', hash: string, nodes: Array<{ __typename: 'DefaultTableColumn', id: number, sort: number, columnKey: string }> } };

export type RemoveProductSegmentationMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type RemoveProductSegmentationMutation = { __typename: 'Mutation', removeProductSegmentation: boolean };

export type AddProductSegmentationMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
  segmentationCode: Scalars['Int'];
}>;


export type AddProductSegmentationMutation = { __typename: 'Mutation', addProductSegmentation: { __typename: 'PersonProductSegmentation', id: number } };

export type ProductForSegmentationQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductForSegmentationQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, heading: string, strength?: number | null }> } };

export type SegmentationForProductQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentationForProductQuery = { __typename: 'Query', segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, code: string, description: string, heading: string }> } };

export type CriteriaInputFragmentFragment = { __typename: 'Criteria', id: number, heading: string, entityType: EntityTypeEnum, code?: string | null, criteriaGroupCode: string, hasGlobalSupport: boolean, inputPaths: { __typename: 'CriteriaPathConnection', hash: string, nodes: Array<{ __typename: 'CriteriaPath', id: number, service?: string | null, icon?: string | null, placeholderHeading?: string | null, defaultOperatorType?: { __typename: 'OperatorType', id: number, heading: string, type: string } | null, type?: { __typename: 'CriteriaType', id: number, type: string } | null }> } };

export type UserPreferEnglishQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPreferEnglishQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, user: { __typename: 'User', id: number, hasEnglishAsDefault: boolean } } | null };

export type preferEnglishLovMutationVariables = Exact<{ [key: string]: never; }>;


export type preferEnglishLovMutation = { __typename: 'Mutation', preferEnglishLov: { __typename: 'UserPreferEnglishLov', id: number, user: { __typename: 'User', id: number, hasEnglishAsDefault: boolean } } };

export type CriteriaSuggestionDropdownValuesQueryVariables = Exact<{
  countryCodes?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
  service: Scalars['String'];
  criteriaPathId: Scalars['Int'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type CriteriaSuggestionDropdownValuesQuery = { __typename: 'Query', suggestions: { __typename: 'SearchableGqlValueConnection', hash: string, totalCount: number, search?: string | null, service?: string | null, countryCodes: Array<string>, nodes: Array<{ __typename: 'SearchableGqlValueWithKey', key: string, parentKey?: string | null, isValueHeadingKey: boolean, isGlobalOnly: boolean, value: string, valueGb?: string | null, cacheKey: string }> } };

export type UpsertCustomFieldValueMutationVariables = Exact<{
  customFieldCode: Scalars['String'];
  customValues: Array<UpdateSelectCustomFieldValueForRecord> | UpdateSelectCustomFieldValueForRecord;
  recordId: Scalars['Int'];
}>;


export type UpsertCustomFieldValueMutation = { __typename: 'Mutation', setCustomLinkValues: Array<{ __typename: 'CustomLinkValue', customFieldCode: string }> };

export type RemoveCustomFieldValueMutationVariables = Exact<{
  customValues: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveCustomFieldValueMutation = { __typename: 'Mutation', removeCustomLinkValues: boolean };

export type CustomFieldFragmentFragment = { __typename: 'CustomField', code: string, isActive: boolean, allowMultiple?: boolean | null, color?: string | null, allowUserCreate?: boolean | null, isCheckableTag?: boolean | null, customFieldControlSetting?: { __typename: 'CustomFieldControlSetting', id: number, createDcr: boolean, maintainerSourceCode: string, isSynced?: boolean | null } | null, fieldType: { __typename: 'CustomFieldType', code: string, enum: CustomFieldTypeEnum }, options?: { __typename: 'CustomFieldOptionConnection', hash: string, nodes: Array<{ __typename: 'CustomFieldOption', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> } | null, accessRules?: { __typename: 'CustomFieldRole', id: number, allowRead: boolean, allowMutation: boolean } | null };

export type CustomFieldValueFragmentFragment = { __typename: 'CustomLinkValueConnection', hash: string, nodes: Array<{ __typename: 'CustomLinkValue', id: number, value?: { __typename: 'CustomValue', id: number, value?: string | null } | null }> };

export type RemoveDashboardItemMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveDashboardItemMutationMutation = { __typename: 'Mutation', removeDashboardItem: { __typename: 'DashboardItemConfiguration', id: number } };

export type DashboardItemFragmentFragment = { __typename: 'DashboardItemConfiguration', id: number, dashboardItemCode: string, headingKey?: string | null, dashboardItem: { __typename: 'DashboardItem', code: string, headingKey: string, minHeight?: number | null, minWidth?: number | null } };

export type DashboardCherryPickOverviewQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardCherryPickOverviewQueryQuery = { __typename: 'Query', cherryPickOverviews: Array<{ __typename: 'ExternalCherryPickCustomerOverview', customerCode: string, country: any, amount: number, amountAvailable: number, amountUsed: number }> };

export type DashboardDCRStatusesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardDCRStatusesQueryQuery = { __typename: 'Query', getDcrCounts: Array<{ __typename: 'ChartColumnItemValue', seriesLabel: string, label: string, value: number, color: string }> };

export type DashboardMasterDataOverviewQueryQueryVariables = Exact<{
  from: Scalars['DateTime'];
}>;


export type DashboardMasterDataOverviewQueryQuery = { __typename: 'Query', dashboardMasterDataOverview: Array<{ __typename: 'ChartColumnSeriesValue', entity: EntityTypeEnum, state: EntityUpdateStateEnum, value: number }> };

export type DashboardRecordsImportedItemQueryQueryVariables = Exact<{
  grouping: GroupByDateRanges;
}>;


export type DashboardRecordsImportedItemQueryQuery = { __typename: 'Query', dashboardRecordsImportedDataPoints: Array<{ __typename: 'ChartTimestampValue', time: any, value: number }> };

export type EntityPieSettingsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type EntityPieSettingsQueryQuery = { __typename: 'Query', dashboardEntityPieSupportedFields: Array<{ __typename: 'DashboardPieFieldOption', code: string, entityType?: EntityTypeEnum | null, heading: string, headingKey?: string | null }> };

export type UpdateEntityPieSettingsMutationMutationVariables = Exact<{
  input: DashboardEntityPieUpdateInput;
}>;


export type UpdateEntityPieSettingsMutationMutation = { __typename: 'Mutation', updateDashboardEntityPieSettings: boolean };

export type DashboardPieFullscreenQueryQueryVariables = Exact<{
  itemConfigurationId: Scalars['Int'];
}>;


export type DashboardPieFullscreenQueryQuery = { __typename: 'Query', dashboardEntityPieSettings: Array<{ __typename: 'DashboardEntityPieSetting', id: number, entityType: EntityTypeEnum }> };

export type PieDataQueryQueryVariables = Exact<{
  configurationId: Scalars['Int'];
}>;


export type PieDataQueryQuery = { __typename: 'Query', dashboardEntityPieSettings: Array<{ __typename: 'DashboardEntityPieSetting', id: number, entityType: EntityTypeEnum, fieldCode?: string | null, customFieldCode?: string | null, fieldHeading: string, fieldHeadingKey?: string | null }> };

export type PieLevelDataQueryQueryVariables = Exact<{
  configurationId: Scalars['Int'];
  selection?: InputMaybe<Array<DashboardPieSelectionInput> | DashboardPieSelectionInput>;
}>;


export type PieLevelDataQueryQuery = { __typename: 'Query', dashboardEntityPieData?: { __typename: 'ChartResults', values: Array<{ __typename: 'ChartItemValue', code?: string | null, label: string, value: number }>, criterias: Array<{ __typename: 'ChartResultCriteria', name: string, value?: any | null, values?: Array<any | null> | null }> } | null };

export type validationLogHistoryQueryVariables = Exact<{
  id: Scalars['Int'];
  entityType: EntityTypeEnum;
}>;


export type validationLogHistoryQuery = { __typename: 'Query', entityValidationLogsByValues: Array<{ __typename: 'EntityValidationLog', id: number, entityAffiliationId: number, entityTypeId: number, ct: any, ut: any, validatedTime: any, user?: { __typename: 'User', id: number, email: string, fullname: string } | null }> };

export type AttributeLabelDcrInfoQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  entityAffiliationId: Scalars['Int'];
  fields: Array<DcrLineCriteriaField> | DcrLineCriteriaField;
}>;


export type AttributeLabelDcrInfoQuery = { __typename: 'Query', line: { __typename: 'DcrLineConnection', hash: string, hasActiveLines: boolean, newValue?: string | null, oldValue?: string | null, nodes: Array<{ __typename: 'DcrLine', id: number, dcr: { __typename: 'Dcr', id: number, dcrGroupId: number } }> } };

export type TableMapperFragmentFragment = { __typename: 'TableMapper', joinSupport: Array<{ __typename: 'MappingJoinSupport', entityType: EntityTypeEnum, headingKey: string, code: string, mode: IsMappingJoinBasicEnum, service?: string | null, dataValue: boolean, supportedCriteriaTypes: Array<string>, id: string, paths: Array<{ __typename: 'VirtualColumnPath', id?: string | null, mapper: string, mapperFrom: string, mapperTo?: string | null, operatorOnMapperTo?: OperatorTypeEnum | null }> }> };

export type EntityPropertyDataQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type EntityPropertyDataQueryQuery = { __typename: 'Query', tableMapper: (
    { __typename: 'TableMapper', mappingName: string, tableName: string, id: EntityTypeEnum, tableColumns: Array<{ __typename: 'CustomMapping', dataType: string, isHeadingKey: boolean, heading?: string | null, columnName: string, supportedCriteriaTypes: Array<CriteriaTypeEnum>, service: string, id: string }> }
    & TableMapperFragmentFragment
  ) };

export type CreateMergeRequestFlowMutationVariables = Exact<{
  entityType: EntityTypeEnum;
  loserId: Scalars['ID'];
  winnerId: Scalars['ID'];
}>;


export type CreateMergeRequestFlowMutation = { __typename: 'Mutation', createMergeRequest: { __typename: 'EntityMerge', id: number } };

export type PerformMergeRequestFlowMutationVariables = Exact<{
  mergeRequestId: Scalars['ID'];
}>;


export type PerformMergeRequestFlowMutation = { __typename: 'Mutation', performMerge: { __typename: 'VirtualEntityMergeInfo', hasConflict: boolean, entityMerge: { __typename: 'EntityMerge', id: number, from?: { __typename: 'Activity' } | { __typename: 'ActivityBrand' } | { __typename: 'ActivityFieldDays' } | { __typename: 'ActivityLocation' } | { __typename: 'ActivityPerson' } | { __typename: 'ActivityProduct' } | { __typename: 'ActivityTypeCustomField' } | { __typename: 'Address' } | { __typename: 'AddressAffiliation' } | { __typename: 'Brand' } | { __typename: 'ConsentContactValue' } | { __typename: 'ConsentValue' } | { __typename: 'ContactCategoryMapping' } | { __typename: 'ContactValue' } | { __typename: 'CreateEntityField' } | { __typename: 'Criteria' } | { __typename: 'CriteriaPath' } | { __typename: 'CriteriaSimpleSaved' } | { __typename: 'CriteriaSimpleSavedCriteria' } | { __typename: 'CriteriaSimpleSavedPath' } | { __typename: 'CriteriaType' } | { __typename: 'CustomFieldControlSetting' } | { __typename: 'CustomFieldGridConfiguration' } | { __typename: 'CustomFieldOption' } | { __typename: 'CustomFieldOptionCountry' } | { __typename: 'CustomFieldRole' } | { __typename: 'CustomLinkValue' } | { __typename: 'CustomValue' } | { __typename: 'Dashboard' } | { __typename: 'DashboardEntityPieSetting' } | { __typename: 'DashboardItemConfiguration' } | { __typename: 'DashboardUser' } | { __typename: 'Dcr' } | { __typename: 'DcrComment' } | { __typename: 'DcrGroup' } | { __typename: 'DcrGroupResponse' } | { __typename: 'DcrLine' } | { __typename: 'DcrNoteTemplate' } | { __typename: 'DcrSnapshotInfo' } | { __typename: 'DefaultCriteria' } | { __typename: 'DefaultDashboard' } | { __typename: 'DefaultTableColumn' } | { __typename: 'DisabledDefaultDashboard' } | { __typename: 'DynamicCriteriaList' } | { __typename: 'DynamicCriteriaListValue' } | { __typename: 'Entity' } | { __typename: 'EntityControlSetting' } | { __typename: 'EntityGridItemCardField' } | { __typename: 'EntityGridItemConfiguration' } | { __typename: 'EntityGridItemField' } | { __typename: 'EntityGridItemRelationField' } | { __typename: 'EntityMerge' } | { __typename: 'EntityValidationLog' } | { __typename: 'ExternalId' } | { __typename: 'ExternalIdSystem' } | { __typename: 'ExternalIdType' } | { __typename: 'ExternalIdTypeCountryExceptionRule' } | { __typename: 'ExternalIdTypeRole' } | { __typename: 'FilterCode' } | { __typename: 'FilterCodeType' } | { __typename: 'ImportFile' } | { __typename: 'ImportLine' } | { __typename: 'ImportProcessField' } | { __typename: 'ImportProcessLine' } | { __typename: 'ImportProcessLineEffect' } | { __typename: 'ImportProcessorData' } | { __typename: 'ImportProject' } | { __typename: 'ImportTemplate' } | { __typename: 'ImportTemplateProcess' } | { __typename: 'ImportTemplateProcessField' } | { __typename: 'List' } | { __typename: 'ListCountry' } | { __typename: 'ListFormat' } | { __typename: 'ListFormatField' } | { __typename: 'ListPin' } | { __typename: 'ListType' } | { __typename: 'ListUserFav' } | { __typename: 'MarketAccessSite' } | { __typename: 'MarketAccessSitePerson' } | { __typename: 'Note' } | { __typename: 'OperatorType' } | { __typename: 'PersProjPreference' } | { __typename: 'Person', id: number, isActive: boolean } | { __typename: 'PersonActivityProduct' } | { __typename: 'PersonEducation' } | { __typename: 'PersonFilterCode' } | { __typename: 'PersonLanguage' } | { __typename: 'PersonProductSegmentation' } | { __typename: 'PersonProject' } | { __typename: 'PersonSegmentationCode' } | { __typename: 'PersonTherapeuticFocus' } | { __typename: 'PersonUser' } | { __typename: 'Preference' } | { __typename: 'Product' } | { __typename: 'Project' } | { __typename: 'ProjectActivity' } | { __typename: 'ProjectProduct' } | { __typename: 'ProjectStatus' } | { __typename: 'ProjectType' } | { __typename: 'ProjectUser' } | { __typename: 'PureAdvanceCustomerSandbox' } | { __typename: 'PureAdvanceCustomerSelection' } | { __typename: 'PureAdvanceModule' } | { __typename: 'ReportSettingDailyCallTarget' } | { __typename: 'ReportSettingFieldDay' } | { __typename: 'ReportSettingsActivityType' } | { __typename: 'ResponsibleArea' } | { __typename: 'Role' } | { __typename: 'RolePermission' } | { __typename: 'SalesCycle' } | { __typename: 'SalesCycleSegmentationTarget' } | { __typename: 'SalesCycleSetup' } | { __typename: 'Search' } | { __typename: 'SegmentationCode' } | { __typename: 'Selection' } | { __typename: 'SelectionGroup' } | { __typename: 'SelectionRow' } | { __typename: 'SelectionRowResult' } | { __typename: 'Site', id: number, isActive: boolean } | { __typename: 'SiteFilterCode' } | { __typename: 'SitePerson' } | { __typename: 'SitePersonTherapeuticFocus' } | { __typename: 'SitePersonWorkingSpecialty' } | { __typename: 'SiteResponsible' } | { __typename: 'SiteSegmentationCode' } | { __typename: 'StandardTitle' } | { __typename: 'Team' } | { __typename: 'UnitType' } | { __typename: 'User' } | { __typename: 'UserCountry' } | { __typename: 'UserPreferEnglishLov' } | { __typename: 'UserTableColumn' } | { __typename: 'UserTeam' } | { __typename: 'ValueModel' } | null } } };

export type DynamicTabGridFragmentFragment = (
  { __typename: 'EntityGridItemConfiguration', id: number, typeEnum: EntityGridItemTypeEnum, heading?: string | null, description?: string | null, x: number, y: number, width?: number | null, height: number }
  & TabCardConfigurationFragmentFragment
);

export type DynamicEntityTabsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type DynamicEntityTabsQueryQuery = { __typename: 'Query', entityTabs: { __typename: 'EntityTabConnection', hash: string, nodes: Array<{ __typename: 'EntityTab', code: string, headingKey: string, gridItems: { __typename: 'EntityGridItemConfigurationConnection', hash: string, nodes: Array<(
          { __typename: 'EntityGridItemConfiguration', id: number }
          & DynamicTabGridFragmentFragment
        )> } }> } };

export type EntityCardFieldsQueryQueryVariables = Exact<{
  configurationId: Scalars['ID'];
}>;


export type EntityCardFieldsQueryQuery = { __typename: 'Query', entityTabGridConfigurationFields: { __typename: 'EntityGridItemFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemField', id: number, typeCode: string }> } };

export type EntityTabCustomFieldDataQueryQueryVariables = Exact<{
  fieldId: Scalars['Int'];
  recordId: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type EntityTabCustomFieldDataQueryQuery = { __typename: 'Query', info?: { __typename: 'EntityGridItemField', id: number, fieldConfig?: { __typename: 'CustomFieldGridConfiguration', id: number, customField: (
        { __typename: 'CustomField', code: string, heading: string, myAccessRules?: { __typename: 'CustomFieldRole', id: number, allowMutation: boolean, allowRead: boolean } | null, customLinkValues?: (
          { __typename: 'CustomLinkValueConnection', hash: string }
          & CustomFieldValueFragmentFragment
        ) | null }
        & CustomFieldFragmentFragment
      ) } | null } | null };

export type PersonConsentTabQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonConsentTabQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, consents: Array<{ __typename: 'VirtualConsentValue', entityType: EntityTypeEnum, entityAffiliationId: number, consentTypeCode: string, isEnabled: boolean, type: { __typename: 'ConsentType', code: string, headingKey: string, isManaged: boolean } }> } | null };

export type UpdatePersonConsentTabMutationMutationVariables = Exact<{
  personId: Scalars['Int'];
  consentTypeCode: Scalars['String'];
  enabled: Scalars['Boolean'];
}>;


export type UpdatePersonConsentTabMutationMutation = { __typename: 'Mutation', setConsentValue: { __typename: 'VirtualConsentValue', entityType: EntityTypeEnum, entityAffiliationId: number, consentTypeCode: string, isEnabled: boolean, type: { __typename: 'ConsentType', code: string, headingKey: string } } };

export type PersonExternalIdsQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonExternalIdsQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, externalIds: { __typename: 'ExternalIdConnection', hash: string, nodes: Array<{ __typename: 'ExternalId', id: number, externalId: string, type: { __typename: 'ExternalIdType', id: number, heading: string, isHeadingKey: boolean, description?: string | null } }> } } | null };

export type UpsertResponsibleAreaTabMutationVariables = Exact<{
  persId: Scalars['Int'];
  areaId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type UpsertResponsibleAreaTabMutation = { __typename: 'Mutation', upsertResponsibleArea: { __typename: 'ResponsibleArea', id: number } };

export type PersonResponsibleUserTabQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonResponsibleUserTabQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, fullName: string, userResponsibilites: { __typename: 'PersonUserConnection', hash: string, nodes: Array<{ __typename: 'PersonUser', ct: any, id: number, user: { __typename: 'User', id: number }, person: { __typename: 'Person', id: number, fullName: string }, responsibleArea: { __typename: 'ResponsibleArea', id: number, code: string, ct: any, heading: string } }> } } | null };

export type GetResponsibleUsersTabQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResponsibleUsersTabQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, nodes: Array<{ __typename: 'User', id: number, fullname: string }> }, responsibleAreas: { __typename: 'ResponsibleAreaConnection', hash: string, nodes: Array<{ __typename: 'ResponsibleArea', id: number, code: string, heading: string }> } };

export type RemoveResponsibleAreaMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  areaId: Scalars['Int'];
}>;


export type RemoveResponsibleAreaMutationMutation = { __typename: 'Mutation', removeResponsibleArea: boolean };

export type PersonDetailSegmentationFragmentFragment = { __typename: 'PersonProductSegmentation', id: number, segmentation: { __typename: 'SegmentationCode', id: number, heading: string }, product: { __typename: 'Product', id: number, heading: string, strengthUnitType?: { __typename: 'UnitType', id: number, abbreviation: string, description?: string | null, name: string } | null } };

export type PersonDetailSegmentationTabQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonDetailSegmentationTabQueryQuery = { __typename: 'Query', allowMultiple?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null, person?: { __typename: 'Person', id: number, fullName: string, productSegmentations: { __typename: 'PersonProductSegmentationConnection', hash: string, totalCount: number, nodes: Array<(
        { __typename: 'PersonProductSegmentation' }
        & PersonDetailSegmentationFragmentFragment
      )> } } | null };

export type RemoveProductSegmentationTabMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type RemoveProductSegmentationTabMutation = { __typename: 'Mutation', removeProductSegmentation: boolean };

export type AddProductSegmentationTabMutationVariables = Exact<{
  personId: Scalars['Int'];
  productId: Scalars['Int'];
  segmentationCode: Scalars['Int'];
}>;


export type AddProductSegmentationTabMutation = { __typename: 'Mutation', addProductSegmentation: { __typename: 'PersonProductSegmentation', id: number, person: { __typename: 'Person', id: number, productSegmentations: { __typename: 'PersonProductSegmentationConnection', hash: string, nodes: Array<(
          { __typename: 'PersonProductSegmentation' }
          & PersonDetailSegmentationFragmentFragment
        )> } } } };

export type PersonProductSegmentationModalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonProductSegmentationModalDataQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', hash: string, nodes: Array<{ __typename: 'Product', id: number, heading: string, strength?: number | null }> }, segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', id: number, code: string, description: string, heading: string }> } };

export type SegmentationCodesTabQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type SegmentationCodesTabQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, segmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null, segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', code: string, id: number, description: string, heading: string }> } };

export type removeHcpSegmentationCodeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type removeHcpSegmentationCodeMutation = { __typename: 'Mutation', removeSegmentationCode: boolean };

export type UpsertSegmentationCodeTabMutationVariables = Exact<{
  id: Scalars['Int'];
  segmentationId: Scalars['Int'];
}>;


export type UpsertSegmentationCodeTabMutation = { __typename: 'Mutation', upsertPersonSegmentationCode: { __typename: 'PersonSegmentationCode', id: number, segmentationCode: { __typename: 'SegmentationCode', id: number, code: string, heading: string } } };

export type SegmentationsettingsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentationsettingsQueryQuery = { __typename: 'Query', product?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null, person?: { __typename: 'InstanceSetting', code: string, value?: string | null } | null };

export type UpdatePersonFilterCodeTabMutationMutationVariables = Exact<{
  persId: Scalars['Int'];
  filterCodeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdatePersonFilterCodeTabMutationMutation = { __typename: 'Mutation', updatePersonFilterCode: Array<{ __typename: 'PersonFilterCode', id: number, person: { __typename: 'Person', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number }> } } }> };

export type FilterCodesSearchTabQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type FilterCodesSearchTabQueryQuery = { __typename: 'Query', filterCodeTypes: { __typename: 'FilterCodeTypeConnection', hash: string, nodes: Array<{ __typename: 'FilterCodeType', id: number, code: string, heading: string, getFilterCodesByTypeId: { __typename: 'FilterCodeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'FilterCode', id: number, header: string }> } }> } };

export type PersonFilterCodesTabQueryQueryVariables = Exact<{
  personId: Scalars['Int'];
}>;


export type PersonFilterCodesTabQueryQuery = { __typename: 'Query', person?: { __typename: 'Person', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number, filterCodeTypeId: number, header: string }> } } | null };

export type SiteExternalIdsQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteExternalIdsQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, externalIds: { __typename: 'ExternalIdConnection', hash: string, nodes: Array<{ __typename: 'ExternalId', id: number, externalId: string, type: { __typename: 'ExternalIdType', id: number, heading: string, isHeadingKey: boolean, description?: string | null } }> } } | null };

export type SiteSegmentationCodesTabQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteSegmentationCodesTabQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, siteSegmentationCode?: { __typename: 'SegmentationCode', id: number, heading: string } | null } | null, segmentationCodes: { __typename: 'SegmentationCodeConnection', hash: string, nodes: Array<{ __typename: 'SegmentationCode', code: string, id: number, description: string, heading: string }> } };

export type UpsertSiteSegmentationCodeTabMutationVariables = Exact<{
  id: Scalars['Int'];
  segmentationId: Scalars['Int'];
}>;


export type UpsertSiteSegmentationCodeTabMutation = { __typename: 'Mutation', upsertSiteSegmentationCode: { __typename: 'SiteSegmentationCode', id: number, segmentationCode: { __typename: 'SegmentationCode', id: number, code: string, heading: string } } };

export type RemoveHcoTabSegmentationCodeMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveHcoTabSegmentationCodeMutationMutation = { __typename: 'Mutation', removeSiteSegmentation: { __typename: 'Site', id: number } };

export type UpdateSiteFilterCodeTabMutationMutationVariables = Exact<{
  siteId: Scalars['Int'];
  filterCodeIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateSiteFilterCodeTabMutationMutation = { __typename: 'Mutation', updateSiteFilterCode: Array<{ __typename: 'SiteFilterCode', id: number, site: { __typename: 'Site', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number }> } } }> };

export type SiteFilterCodesSearchTabQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SiteFilterCodesSearchTabQueryQuery = { __typename: 'Query', filterCodeTypes: { __typename: 'FilterCodeTypeConnection', hash: string, nodes: Array<{ __typename: 'FilterCodeType', id: number, code: string, heading: string, getFilterCodesByTypeId: { __typename: 'FilterCodeConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'FilterCode', id: number, header: string }> } }> } };

export type SiteFilterCodesTabQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteFilterCodesTabQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, filterCodes: { __typename: 'FilterCodeConnection', hash: string, nodes: Array<{ __typename: 'FilterCode', id: number, filterCodeTypeId: number, header: string }> } } | null };

export type EntityRelationTabsQueryQueryVariables = Exact<{
  configurationId: Scalars['ID'];
}>;


export type EntityRelationTabsQueryQuery = { __typename: 'Query', entityGridItemRelationFields: { __typename: 'EntityGridItemRelationFieldConnection', hash: string, nodes: Array<{ __typename: 'EntityGridItemRelationField', id: number, relationTabKey: string }> } };

export type TabCardConfigurationFragmentFragment = { __typename: 'EntityGridItemConfiguration', id: number, heading?: string | null, typeEnum: EntityGridItemTypeEnum, height: number, width?: number | null, type: { __typename: 'EntityGridItemType', code: string, headingKey: string, minHeight: number, minWidth?: number | null } };

export type AvailableFlagsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableFlagsQueryQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string }> } };

export type DynamicCriteriaInputFragment = { __typename: 'Criteria', id: number, heading: string, entityType: EntityTypeEnum, inputPaths: { __typename: 'CriteriaPathConnection', hash: string, nodes: Array<{ __typename: 'CriteriaPath', id: number, service?: string | null, defaultOperatorType?: { __typename: 'OperatorType', id: number, heading: string, type: string } | null, type?: { __typename: 'CriteriaType', id: number, type: string } | null }> } };

export type CountriesQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type CountriesQueryQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string, id: string }> } };

export type SelectPersonTypeSuggestionQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['CountryCode']> | Scalars['CountryCode']>;
}>;


export type SelectPersonTypeSuggestionQueryQuery = { __typename: 'Query', personTypes: { __typename: 'ValuePersonTypeConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SelectPositionSuggestionsQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type SelectPositionSuggestionsQueryQuery = { __typename: 'Query', positions: { __typename: 'ValuePositionConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type SelectSiteTypeQueryQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type SelectSiteTypeQueryQuery = { __typename: 'Query', siteTypes: { __typename: 'ValueSiteTypeConnection', hash: string, nodes: Array<{ __typename: 'ImfDataValue', code: string, type: DataValueMappingName, label: string }> } };

export type GetAllFavListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllFavListsQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, getAllFavoriteLists: { __typename: 'ListConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'List', id: number, title: string, sort?: number | null, listType: { __typename: 'ListType', id: number, code: string, color?: string | null, ct: any, heading: string, note?: string | null, status: number, ut: any }, entityType?: { __typename: 'Entity', id: number, code: string, heading: string } | null }> } } | null };

export type UpdateFavSortMutationMutationVariables = Exact<{
  input: Array<UserFavInput> | UserFavInput;
}>;


export type UpdateFavSortMutationMutation = { __typename: 'Mutation', updateFavSort?: boolean | null };

export type PersonElasticMatchQueryVariables = Exact<{
  minScore?: InputMaybe<Scalars['Int']>;
  person?: InputMaybe<PersonMatchInput>;
  site?: InputMaybe<SiteMatchInput>;
  link?: InputMaybe<SitePersonMatchInput>;
}>;


export type PersonElasticMatchQuery = { __typename: 'Query', elasticMatch: Array<{ __typename: 'MatchCandidate', apurebaseId: string, inLocal: boolean, score: number, person: { __typename: 'PersonMatchCandidateData', apurebaseId: number, firstName: string, lastName: string, countryCode: string, title: string, gender: string, personType: string }, site: { __typename: 'SiteMatchCandidateData', apurebaseId: number, name: string }, link: { __typename: 'LinkMatchCandidateData', apurebaseId: number, role: string, specialty: string } }> };

export type LiveMatchFetchHCPIdQueryVariables = Exact<{
  apbId: Scalars['Int'];
}>;


export type LiveMatchFetchHCPIdQuery = { __typename: 'Query', persons: { __typename: 'PersonConnection', hash: string, nodes: Array<{ __typename: 'Person', id: number, apurebaseId?: number | null }> } };

export type LiveMatchOfficialIdQueryVariables = Exact<{
  officialId: Scalars['String'];
}>;


export type LiveMatchOfficialIdQuery = { __typename: 'Query', externalIds: { __typename: 'ExternalIdConnection', hash: string, nodes: Array<{ __typename: 'ExternalId', id: number, externalId: string, entityAffiliation?: { __typename: 'Activity', id: number } | { __typename: 'ActivityBrand', id: number } | { __typename: 'ActivityFieldDays', id: number } | { __typename: 'ActivityLocation', id: number } | { __typename: 'ActivityPerson', id: number } | { __typename: 'ActivityProduct', id: number } | { __typename: 'ActivityTypeCustomField', id: number } | { __typename: 'Address', id: number } | { __typename: 'AddressAffiliation', id: number } | { __typename: 'Brand', id: number } | { __typename: 'ConsentContactValue', id: number } | { __typename: 'ConsentValue', id: number } | { __typename: 'ContactCategoryMapping', id: number } | { __typename: 'ContactValue', id: number } | { __typename: 'CreateEntityField', id: number } | { __typename: 'Criteria', id: number } | { __typename: 'CriteriaPath', id: number } | { __typename: 'CriteriaSimpleSaved', id: number } | { __typename: 'CriteriaSimpleSavedCriteria', id: number } | { __typename: 'CriteriaSimpleSavedPath', id: number } | { __typename: 'CriteriaType', id: number } | { __typename: 'CustomFieldControlSetting', id: number } | { __typename: 'CustomFieldGridConfiguration', id: number } | { __typename: 'CustomFieldOption', id: number } | { __typename: 'CustomFieldOptionCountry', id: number } | { __typename: 'CustomFieldRole', id: number } | { __typename: 'CustomLinkValue', id: number } | { __typename: 'CustomValue', id: number } | { __typename: 'Dashboard', id: number } | { __typename: 'DashboardEntityPieSetting', id: number } | { __typename: 'DashboardItemConfiguration', id: number } | { __typename: 'DashboardUser', id: number } | { __typename: 'Dcr', id: number } | { __typename: 'DcrComment', id: number } | { __typename: 'DcrGroup', id: number } | { __typename: 'DcrGroupResponse', id: number } | { __typename: 'DcrLine', id: number } | { __typename: 'DcrNoteTemplate', id: number } | { __typename: 'DcrSnapshotInfo', id: number } | { __typename: 'DefaultCriteria', id: number } | { __typename: 'DefaultDashboard', id: number } | { __typename: 'DefaultTableColumn', id: number } | { __typename: 'DisabledDefaultDashboard', id: number } | { __typename: 'DynamicCriteriaList', id: number } | { __typename: 'DynamicCriteriaListValue', id: number } | { __typename: 'Entity', id: number } | { __typename: 'EntityControlSetting', id: number } | { __typename: 'EntityGridItemCardField', id: number } | { __typename: 'EntityGridItemConfiguration', id: number } | { __typename: 'EntityGridItemField', id: number } | { __typename: 'EntityGridItemRelationField', id: number } | { __typename: 'EntityMerge', id: number } | { __typename: 'EntityValidationLog', id: number } | { __typename: 'ExternalId', id: number } | { __typename: 'ExternalIdSystem', id: number } | { __typename: 'ExternalIdType', id: number } | { __typename: 'ExternalIdTypeCountryExceptionRule', id: number } | { __typename: 'ExternalIdTypeRole', id: number } | { __typename: 'FilterCode', id: number } | { __typename: 'FilterCodeType', id: number } | { __typename: 'ImportFile', id: number } | { __typename: 'ImportLine', id: number } | { __typename: 'ImportProcessField', id: number } | { __typename: 'ImportProcessLine', id: number } | { __typename: 'ImportProcessLineEffect', id: number } | { __typename: 'ImportProcessorData', id: number } | { __typename: 'ImportProject', id: number } | { __typename: 'ImportTemplate', id: number } | { __typename: 'ImportTemplateProcess', id: number } | { __typename: 'ImportTemplateProcessField', id: number } | { __typename: 'List', id: number } | { __typename: 'ListCountry', id: number } | { __typename: 'ListFormat', id: number } | { __typename: 'ListFormatField', id: number } | { __typename: 'ListPin', id: number } | { __typename: 'ListType', id: number } | { __typename: 'ListUserFav', id: number } | { __typename: 'MarketAccessSite', id: number } | { __typename: 'MarketAccessSitePerson', id: number } | { __typename: 'Note', id: number } | { __typename: 'OperatorType', id: number } | { __typename: 'PersProjPreference', id: number } | { __typename: 'Person', fullName: string, id: number } | { __typename: 'PersonActivityProduct', id: number } | { __typename: 'PersonEducation', id: number } | { __typename: 'PersonFilterCode', id: number } | { __typename: 'PersonLanguage', id: number } | { __typename: 'PersonProductSegmentation', id: number } | { __typename: 'PersonProject', id: number } | { __typename: 'PersonSegmentationCode', id: number } | { __typename: 'PersonTherapeuticFocus', id: number } | { __typename: 'PersonUser', id: number } | { __typename: 'Preference', id: number } | { __typename: 'Product', id: number } | { __typename: 'Project', id: number } | { __typename: 'ProjectActivity', id: number } | { __typename: 'ProjectProduct', id: number } | { __typename: 'ProjectStatus', id: number } | { __typename: 'ProjectType', id: number } | { __typename: 'ProjectUser', id: number } | { __typename: 'PureAdvanceCustomerSandbox', id: number } | { __typename: 'PureAdvanceCustomerSelection', id: number } | { __typename: 'PureAdvanceModule', id: number } | { __typename: 'ReportSettingDailyCallTarget', id: number } | { __typename: 'ReportSettingFieldDay', id: number } | { __typename: 'ReportSettingsActivityType', id: number } | { __typename: 'ResponsibleArea', id: number } | { __typename: 'Role', id: number } | { __typename: 'RolePermission', id: number } | { __typename: 'SalesCycle', id: number } | { __typename: 'SalesCycleSegmentationTarget', id: number } | { __typename: 'SalesCycleSetup', id: number } | { __typename: 'Search', id: number } | { __typename: 'SegmentationCode', id: number } | { __typename: 'Selection', id: number } | { __typename: 'SelectionGroup', id: number } | { __typename: 'SelectionRow', id: number } | { __typename: 'SelectionRowResult', id: number } | { __typename: 'Site', id: number } | { __typename: 'SiteFilterCode', id: number } | { __typename: 'SitePerson', id: number } | { __typename: 'SitePersonTherapeuticFocus', id: number } | { __typename: 'SitePersonWorkingSpecialty', id: number } | { __typename: 'SiteResponsible', id: number } | { __typename: 'SiteSegmentationCode', id: number } | { __typename: 'StandardTitle', id: number } | { __typename: 'Team', id: number } | { __typename: 'UnitType', id: number } | { __typename: 'User', id: number } | { __typename: 'UserCountry', id: number } | { __typename: 'UserPreferEnglishLov', id: number } | { __typename: 'UserTableColumn', id: number } | { __typename: 'UserTeam', id: number } | { __typename: 'ValueModel', id: number } | null }> } };

export type LiveSearchElasticSiteQueryVariables = Exact<{
  search: ApiSiteMatchInputSearch;
}>;


export type LiveSearchElasticSiteQuery = { __typename: 'Query', elasticSiteMatch: Array<{ __typename: 'SiteMatchCandidate', apurebaseId: string, score: number, inLocalDb: boolean, result: { __typename: 'ApiSiteMatch', id: string, address?: string | null, city?: string | null, country: string, ct: string, name: string, site_type?: string | null, spc: Array<string>, status: boolean, ut: string, zip?: string | null, people: Array<{ __typename: 'ApiSiteMatchPerson', id: string, firstname: string }> } }> };

export type PersonUpdateNoteMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  title: Scalars['String'];
  text: Scalars['String'];
  private: Scalars['Boolean'];
}>;


export type PersonUpdateNoteMutationMutation = { __typename: 'Mutation', updateNote: { __typename: 'Note', id: number, text?: string | null, title?: string | null } };

export type PersonCreateNoteMutationMutationVariables = Exact<{
  id: Scalars['Int'];
  title: Scalars['String'];
  text: Scalars['String'];
  private: Scalars['Boolean'];
  entity: EntityTypeEnum;
}>;


export type PersonCreateNoteMutationMutation = { __typename: 'Mutation', createNote: { __typename: 'Note', id: number, text?: string | null } };

export type DeletePersonNoteMutationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeletePersonNoteMutationMutation = { __typename: 'Mutation', deleteNote: boolean };

export type NoteDrawerFragmentFragment = { __typename: 'Note', id: number, text?: string | null, ct: any, ut: any, status: boolean, private: boolean, title?: string | null, user?: { __typename: 'User', id: number, fullname: string } | null };

export type GetCriteriaDefinitionQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  code: Scalars['String'];
}>;


export type GetCriteriaDefinitionQuery = { __typename: 'Query', criteriaByCode?: { __typename: 'Criteria', id: number, inputPaths: { __typename: 'CriteriaPathConnection', hash: string, nodes: Array<{ __typename: 'CriteriaPath', id: number }> } } | null };

export type SiteHierarchyQueryQueryVariables = Exact<{
  siteId: Scalars['Int'];
}>;


export type SiteHierarchyQueryQuery = { __typename: 'Query', site?: { __typename: 'Site', id: number, name: string, name2?: string | null, parentHierarchy: (
      { __typename: 'SiteClosureConnection' }
      & HierarchyConnectionFragmentFragment
    ), childrenHierarchy: (
      { __typename: 'SiteClosureConnection' }
      & HierarchyConnectionFragmentFragment
    ) } | null };

export type HierarchyConnectionFragmentFragment = { __typename: 'SiteClosureConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'SiteClosure', ancestorId: number, descendantId: number, depth: number, descendant: { __typename: 'Site', id: number, name: string, childrenHierarchy: { __typename: 'SiteClosureConnection', hash: string, totalCount: number } }, ancestor: { __typename: 'Site', id: number, name: string, childrenHierarchy: { __typename: 'SiteClosureConnection', hash: string, totalCount: number } } }> };

export type UsersForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersForSelectQuery = { __typename: 'Query', users: { __typename: 'UserConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'User', id: number, fullname: string }> } };

export type LoadDefaultUserCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadDefaultUserCountriesQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, user: { __typename: 'User', id: number, countries: { __typename: 'ValueCountryConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'ValueCountry', code: string }> } } } | null, countries: { __typename: 'ValueCountryConnection', hash: string, nodes: Array<{ __typename: 'ValueCountry', code: string }> } };

export type LoadCriteriasByCodesQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  codes: Array<Scalars['String']> | Scalars['String'];
}>;


export type LoadCriteriasByCodesQueryQuery = { __typename: 'Query', criterias: { __typename: 'CriteriaConnection', hash: string, nodes: Array<(
      { __typename: 'Criteria', id: number, code?: string | null }
      & CriteriaInputFragmentFragment
    )> } };

export type saveAdvanceSearchMutationVariables = Exact<{
  type: EntityTypeEnum;
  heading: Scalars['String'];
  searchInput: SaveSearchInput;
  isShared: Scalars['Boolean'];
}>;


export type saveAdvanceSearchMutation = { __typename: 'Mutation', saveSearch: { __typename: 'Search', id: number, code?: string | null, heading?: string | null, isHeadingKey: boolean } };

export type GetAdvanceSearchDataQueryQueryVariables = Exact<{
  searchId: Scalars['ID'];
}>;


export type GetAdvanceSearchDataQueryQuery = { __typename: 'Query', singleSearch: (
    { __typename: 'SearchNode' }
    & SearchNodesFragmentFragment
  ) };

export type SearchNodesFragmentFragment = { __typename: 'SearchNode', searchId?: number | null, heading?: string | null, code?: string | null, id?: number | null, groups: Array<{ __typename: 'SearchGroupNode', nextOperation?: SearchGroupOperationEnum | null, conditions: Array<{ __typename: 'SearchConditionNode', dataType?: string | null, code: string, criteriaId?: number | null, type: SearchConditionEnum, operation?: SearchConditionOperationEnum | null, value?: Array<string> | null, id: string, nest?: { __typename: 'SearchNode', entityType: EntityTypeEnum, id: EntityTypeEnum, groups: Array<{ __typename: 'SearchGroupNode', nextOperation?: SearchGroupOperationEnum | null, conditions: Array<{ __typename: 'SearchConditionNode', dataType?: string | null, code: string, criteriaId?: number | null, type: SearchConditionEnum, operation?: SearchConditionOperationEnum | null, value?: Array<string> | null, id: string, paths?: Array<{ __typename: 'SearchPathNode', mapper: string, mapperTo?: string | null, mapperFrom: string, operator?: OperatorTypeEnum | null }> | null, inputConfiguration?: { __typename: 'SearchConditionInputConfigurationNode', valueService?: string | null, inputHeading?: string | null, inputPlaceholder?: string | null, inputHeadingMeta?: string | null, parentEntityType?: EntityTypeEnum | null, isInputPlaceholderKey?: boolean | null, isInputHeadingKey?: boolean | null, allowMultiple?: boolean | null, allowNoValue?: boolean | null, inputType?: CriteriaTypeEnum | null, id?: string | null } | null }> }> } | null, paths?: Array<{ __typename: 'SearchPathNode', mapper: string, mapperTo?: string | null, mapperFrom: string, operator?: OperatorTypeEnum | null }> | null, inputConfiguration?: { __typename: 'SearchConditionInputConfigurationNode', valueService?: string | null, inputHeading?: string | null, inputPlaceholder?: string | null, inputHeadingMeta?: string | null, parentEntityType?: EntityTypeEnum | null, isInputPlaceholderKey?: boolean | null, isInputHeadingKey?: boolean | null, allowMultiple?: boolean | null, allowNoValue?: boolean | null, inputType?: CriteriaTypeEnum | null, id?: string | null } | null }> }> };

export type DefaultAdvanceSearchQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultAdvanceSearchQueryQuery = { __typename: 'Query', defaultSearch: (
    { __typename: 'SearchNode' }
    & SearchNodesFragmentFragment
  ) };

export type SingleAdvanceSearchQueryVariables = Exact<{
  searchId: Scalars['ID'];
}>;


export type SingleAdvanceSearchQuery = { __typename: 'Query', singleSearch: (
    { __typename: 'SearchNode' }
    & SearchNodesFragmentFragment
  ) };

export type DefaultCriteriasQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type DefaultCriteriasQueryQuery = { __typename: 'Query', defaultCriterias: { __typename: 'DefaultCriteriaConnection', hash: string, nodes: Array<{ __typename: 'DefaultCriteria', id: number, criteria: (
        { __typename: 'Criteria', id: number }
        & CriteriaInputFragmentFragment
      ) }> } };

export type TableColumnsQueryQueryVariables = Exact<{
  entityType: EntityTypeEnum;
}>;


export type TableColumnsQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, tableColumns: Array<{ __typename: 'AntTableColumn', columnKey: string, sort: number }> } | null };

export type CheckMdmModuleEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckMdmModuleEnabledQuery = { __typename: 'Query', hasAccessToModule: boolean };

export type EntitiesSearchTopCountriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type EntitiesSearchTopCountriesQuery = { __typename: 'Query', countries: { __typename: 'ValueCountryConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'ValueCountry', code: string, label: string }> } };

export type MyAdvanceSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAdvanceSavedSearchesQuery = { __typename: 'Query', allSearches: { __typename: 'SearchConnection', totalCount: number, nodes: Array<{ __typename: 'Search', heading?: string | null, id: number, groupingCode?: string | null, isDefault: boolean }> } };

export type SaveAsDefaultMutationVariables = Exact<{
  searchID: Scalars['ID'];
}>;


export type SaveAsDefaultMutation = { __typename: 'Mutation', defaultSearch: { __typename: 'SearchNode', searchId?: number | null } };

export type DeleteSearchMutationVariables = Exact<{
  searchID: Scalars['ID'];
}>;


export type DeleteSearchMutation = { __typename: 'Mutation', deleteSearch: boolean };

export type EntitySimpleSearchCriteriasQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  search?: InputMaybe<Scalars['String']>;
}>;


export type EntitySimpleSearchCriteriasQuery = { __typename: 'Query', criteriaGroups: { __typename: 'CriteriaGroupConnection', hash: string, nodes: Array<{ __typename: 'CriteriaGroup', code: string, entityId: number, heading: string, criterias: { __typename: 'CriteriaConnection', hash: string, nodes: Array<(
          { __typename: 'Criteria' }
          & CriteriaInputFragmentFragment
        )> } }> } };

export type SimpleSavedSearchFragmentFragment = { __typename: 'CriteriaSimpleSaved', id: number, heading: string, totalCount: number, criteriaAffiliations: { __typename: 'CriteriaSimpleSavedCriteriaConnection', hash: string, nodes: Array<{ __typename: 'CriteriaSimpleSavedCriteria', id: number, criteria: (
        { __typename: 'Criteria' }
        & CriteriaInputFragmentFragment
      ), paths: { __typename: 'CriteriaSimpleSavedPathConnection', hash: string, nodes: Array<{ __typename: 'CriteriaSimpleSavedPath', id: number, pathId: number, value?: string | null }> } }> } };

export type MySimpleSavedSearchesQueryVariables = Exact<{
  entityType: EntityTypeEnum;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MySimpleSavedSearchesQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, savedCriterias: { __typename: 'CriteriaSimpleSavedConnection', hash: string, nodes: Array<(
        { __typename: 'CriteriaSimpleSaved' }
        & SimpleSavedSearchFragmentFragment
      )> } } | null };

export type DeleteSavedSearchMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSavedSearchMutation = { __typename: 'Mutation', deleteSavedSearchCriteria: boolean };

export type UpdateExistingSearchMutationVariables = Exact<{
  id: Scalars['Int'];
  name: Scalars['String'];
  criterias: Array<DynamicCriteriaInput> | DynamicCriteriaInput;
}>;


export type UpdateExistingSearchMutation = { __typename: 'Mutation', updateSimpleCriteria: { __typename: 'CriteriaSimpleSaved', id: number, heading: string, totalCount: number } };

export type SaveNewSimpleSearchMutationVariables = Exact<{
  name: Scalars['String'];
  entityType: EntityTypeEnum;
  criterias: Array<DynamicCriteriaInput> | DynamicCriteriaInput;
}>;


export type SaveNewSimpleSearchMutation = { __typename: 'Mutation', saveNewSimpleCriteria: (
    { __typename: 'CriteriaSimpleSaved' }
    & SimpleSavedSearchFragmentFragment
  ) };

export type PersonEntityRecordsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PersonEntityRecordsQuery = { __typename: 'Query', personsById: Array<{ __typename: 'Person', id: number, fullName: string, ct: any, ut: any }> };

export type SiteEntityRecordsQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SiteEntityRecordsQuery = { __typename: 'Query', sitesById: Array<{ __typename: 'Site', id: number, name: string, ct: any, ut: any }> };

export type MyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInfoQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, fullname: string, username: string, role: { __typename: 'Role', id: number, name: string } } | null };

export type NavigationDataQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationDataQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, menuItems: { __typename: 'MenuItemConnection', hash: string, nodes: Array<(
        { __typename: 'MenuItem' }
        & MenuItemFragmentFragment
      )> }, functionMenuItems: { __typename: 'MenuItemConnection', hash: string, nodes: Array<(
        { __typename: 'MenuItem' }
        & MenuItemFragmentFragment
      )> } } | null, person?: { __typename: 'Person', id: number, sites: { __typename: 'SiteConnection', totalCount: number } } | null };

export type MenuItemFragmentFragment = { __typename: 'MenuItem', code: string, headingKey: string, tooltipKey?: string | null, iconKey?: string | null, url: string };

export type FavoriteListsNavigationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteListsNavigationQueryQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, lists: { __typename: 'ListConnection', hash: string, totalCount: number, nodes: Array<{ __typename: 'List', id: number, title: string, description?: string | null, affiliations: { __typename: 'ActivityConnection', hash: string, totalCount: number } | { __typename: 'ActivityPersonConnection', hash: string, totalCount: number } | { __typename: 'PersonConnection', hash: string, totalCount: number } | { __typename: 'SiteConnection', hash: string, totalCount: number } | { __typename: 'SitePersonConnection', hash: string, totalCount: number } }> } } | null };

export type InstanceQueryVariables = Exact<{ [key: string]: never; }>;


export type InstanceQuery = { __typename: 'Query', instanceName?: string | null, imgPath?: string | null };

export type HasPermissionQueryQueryVariables = Exact<{
  permissions: Array<PermissionEnum> | PermissionEnum;
}>;


export type HasPermissionQueryQuery = { __typename: 'Query', hasPermissions: Array<{ __typename: 'VirtualPermissionInfo', code: string, create: boolean, read: boolean, update: boolean, delete: boolean }> };

export type CreateEntityFieldQueryQueryVariables = Exact<{
  country: Scalars['CountryCode'];
  entityType: EntityTypeEnum;
}>;


export type CreateEntityFieldQueryQuery = { __typename: 'Query', getCreateEntityFields: Array<{ __typename: 'CreateEntityField', id: number, fieldKey: string }> };

export type GridCardFieldFragment = { __typename: 'EntityGridItemCardField', id: number, fieldKey: string, heading?: string | null, isHeadingKey: boolean };

export type UsePreferredLOVLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type UsePreferredLOVLanguageQuery = { __typename: 'Query', viewer?: { __typename: 'Viewer', id: number, user: { __typename: 'User', id: number, hasEnglishAsDefault: boolean } } | null };
